/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 598);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(605);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(611)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMMENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_IPR_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return STATE_TRANSITION_LOG_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return TECHNICAL_LOG_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SALES_ORDER_OVERVIEW_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SALES_ORDER_CUSTOMER_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SENT_EMAIL_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return WHATSAPP_MESSAGES_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CUSTOMS_INVOICE_LIST_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return INVOICE_LIST_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PAYMENT_LIST_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return TRAY_SIZE_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return IMPRINT_SCAN_STATUS_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PHYSICIAN_AND_SUPPLIER_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return TREATMENT_EXECUTION_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return TREATMENT_FEEDBACK_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CUSTOMER_IMAGE_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CUSTOMER_IMAGE_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CUSTOMER_IMAGE_REUPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CUSTOMER_CONTACT_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return TREATMENT_PLAN_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SCAN_FILE_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return TREATMENT_PLAN_FILE_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return IPR_INSTRUCTIONS_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PATIENT_IPR_WISHES_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PRODUCTION_FILE_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return TREATMENT_QUOTATION_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IMPLANT_TREATMENT_QUOTATION_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return REFUND_SEPA_TRANSFER_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALIGNER_LABEL_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PRE_TREATMENT_REASON_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return WHATS_APP_TEXT_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return TREATMENT_DURATION_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SALES_NOTE_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return TREATMENT_CLASSIFICATION_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return TREATMENT_VISUALIZATION_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MOVEMENT_CERTIFICATE_NUMBER_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SHIPMENT_LIST_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return INITIAL_HESITATION_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return TRANSITION_LIST_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return TREATMENT_PAYMENT_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DELIVERY_TRACKING_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SUPPLIER_TRACKING_NUMBER_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PHOTO_CHECKIN_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return MEDICAL_PHOTO_CHECK_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return INVOICE_CORRECTION_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PRODUCTION_CASE_CARD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return MODEL_SELECTION_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALIGNER_CUSTOMER_COMMUNICATION_COMMENT_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALIGNER_SEND_RECOMMENDATION_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PATIENT_SCANNED_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMPLEXITY_TREATMENT_WIDGET; });
/* unused harmony export PROSPECT_DETAIL_WIDGET_CONTAINER */
/* unused harmony export PROSPECT_MEDICAL_CONDITION_WIDGET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return VOUCHER_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ANAMNESIS_EDIT_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ANAMNESIS_LIST_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return APPOINTMENT_LIST_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PROCESS_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PROCESS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PROCESS_TASK_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CONFORMITY_DECLARATION_LIST_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CBCT_FILE_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATE_3DSCAN_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return REFINEMENT_REASON_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return LOW_NPS_REASON_WIDGET_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PARTIAL_INVOICE_CORRECTION_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CUSTOMER_XRAY_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return REQUEST_MEDICAL_EVALUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ATTACHMENT_NEEDED_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ATTACHMENT_AGREEMENT_WIDGET; });
// Please don't change values of constants since they are used in database
var OVERVIEW='overview';var COMMENT_LIST='CommentListWidgetContainer';var CREATE_IPR_APPOINTMENT='CreateIprAppoinmentContainer';var STATE_TRANSITION_LOG_CONTAINER='StateTransitionLogContainer';var TECHNICAL_LOG_CONTAINER='TechnicalLogContainer';var SALES_ORDER_OVERVIEW_WIDGET='SalesOrderOverviewWidgetContainer';var SALES_ORDER_CUSTOMER_WIDGET='SalesOrderCustomerWidgetContainer';var SENT_EMAIL_WIDGET='SentEmailWidgetContainer';var WHATSAPP_MESSAGES_WIDGET='WhatsappMessagesWidgetContainer';var CUSTOMS_INVOICE_LIST_WIDGET='CustomsInvoiceListWidgetContainer';var INVOICE_LIST_WIDGET='InvoiceListWidgetContainer';var PAYMENT_LIST_WIDGET='PaymentListWidgetContainer';var TRAY_SIZE_WIDGET='TraySizeWidgetContainer';var IMPRINT_SCAN_STATUS_WIDGET='ImprintScanStatusWidgetContainer';var PHYSICIAN_AND_SUPPLIER_WIDGET='PhysicianAndSupplierWidgetContainer';var TREATMENT_EXECUTION_WIDGET_CONTAINER='TreatmentExecutionWidgetContainer';var TREATMENT_FEEDBACK_WIDGET='TreatmentFeedbackWidgetContainer';var CUSTOMER_IMAGE_WIDGET='CustomerImageWidgetContainer';var CUSTOMER_IMAGE_UPLOAD_WIDGET='CustomerImageUploadWidgetContainer';var CUSTOMER_IMAGE_REUPLOAD_WIDGET='CustomerImageReuploadWidgetContainer';var CUSTOMER_CONTACT_WIDGET='CustomerContactWidgetContainer';var TREATMENT_PLAN_WIDGET='TreatmentPlanWidgetContainer';var SCAN_FILE_UPLOAD_WIDGET='ScanFileUploadWidgetContainer';var TREATMENT_PLAN_FILE_UPLOAD_WIDGET='TreatmentPlanFileUploadWidgetContainer';var IPR_INSTRUCTIONS_WIDGET='IPRInstructionsWidgetContainer';var PATIENT_IPR_WISHES_WIDGET='PatientIPRWishesWidgetContainer';var TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET='TreatmentPlanExternalFileUploadWidgetContainer';var PRODUCTION_FILE_UPLOAD_WIDGET='ProductionFileUploadWidgetContainer';var TREATMENT_QUOTATION_WIDGET='TreatmentQuotationWidgetContainer';var IMPLANT_TREATMENT_QUOTATION_WIDGET='ImplantTreatmentQuotationWidgetContainer';var REFUND_SEPA_TRANSFER_WIDGET='RefundSepaTransferWidgetContainer';var ALIGNER_LABEL_WIDGET_CONTAINER='AlignerLabelWidgetContainer';var CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER='CannotBeTreatedReasonWidgetContainer';var PRE_TREATMENT_REASON_WIDGET_CONTAINER='PreTreatmentReasonWidgetContainer';var WHATS_APP_TEXT_WIDGET_CONTAINER='WhatsAppTextWidgetContainer';var TREATMENT_DURATION_WIDGET_CONTAINER='TreatmentDurationWidgetContainer';var SALES_NOTE_WIDGET_CONTAINER='SalesNoteWidgetContainer';var TREATMENT_CLASSIFICATION_WIDGET_CONTAINER='TreatmentClassificationWidgetContainer';var TREATMENT_VISUALIZATION_WIDGET_CONTAINER='TreatmentVisualizationWidgetContainer';var MOVEMENT_CERTIFICATE_NUMBER_WIDGET='MovementCertificateNumberWidgetContainer';var SHIPMENT_LIST_WIDGET_CONTAINER='ShipmentListWidgetContainer';var INITIAL_HESITATION_WIDGET_CONTAINER='InitialHesitationWidgetContainer';var TRANSITION_LIST_WIDGET_CONTAINER='TransitionListWidgetContainer';/* Treatment */var TREATMENT_PAYMENT_WIDGET='TreatmentPaymentWidgetContainer';var DELIVERY_TRACKING_WIDGET='DeliveryTrackingNumberWidgetContainer';var SUPPLIER_TRACKING_NUMBER_WIDGET='SupplierTrackingNumberWidgetContainer';var PHOTO_CHECKIN_WIDGET='PhotoCheckinWidgetContainer';var MEDICAL_PHOTO_CHECK_WIDGET='MedicalPhotoCheckWidgetContainer';var INVOICE_CORRECTION_WIDGET='InvoiceCorrectionWidget';var PRODUCTION_CASE_CARD_WIDGET='ProductionCaseCardWidgetContainer';var MODEL_SELECTION_WIDGET='ModelSelectionWidgetContainer';var ALIGNER_CUSTOMER_COMMUNICATION_COMMENT_WIDGET='AlignerCustomerCommunicationCommentWidgetContainer';var ALIGNER_SEND_RECOMMENDATION_WIDGET='AlignerSendRecommendationWidgetContainer';/* In Shop Scan */var CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET='TransferDriveFilesContainer';var MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER='Match3ShapeCustomerWidgetContainer';var PATIENT_SCANNED_WIDGET='PatientScannedWidgetContainer';var COMPLEXITY_TREATMENT_WIDGET='ComplexityTreatmentWidgetContainer';/* prospect */var PROSPECT_DETAIL_WIDGET_CONTAINER='ProspectDetailContainer';var PROSPECT_MEDICAL_CONDITION_WIDGET='ProspectMedicalConditionContainer';/* general */var VOUCHER_WIDGET_CONTAINER='VoucherContainer';/* other */var ANAMNESIS_EDIT_WIDGET_CONTAINER='AnamnesisEditWidgetContainer';var ANAMNESIS_LIST_WIDGET_CONTAINER='AnamnesisListWidgetContainer';var APPOINTMENT_LIST_WIDGET_CONTAINER='AppointmentListWidgetContainer';var PROCESS_OVERVIEW='ProcessOverview';var PROCESS_LIST='Process';var PROCESS_TASK_LIST='TaskList';var CONFORMITY_DECLARATION_LIST_WIDGET='ConformityDeclarationListWidgetContainer';var CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET='CustomerPreCheckinImageWidgetContainer';var CBCT_FILE_UPLOAD_WIDGET='CbctFileUploadContainer';var IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET='ImplantTreatmentPlanUploadWidgetContainer';var CREATE_3DSCAN_APPOINTMENT='Create3DScanAppointmentContainer';var REFINEMENT_REASON_WIDGET='RefinementReasonWidgetContainer';var LOW_NPS_REASON_WIDGET_CONTAINER='LowNpsReasonWidgetContainer';var PARTIAL_INVOICE_CORRECTION_CONTAINER='PartialInvoiceCorrectionWidgetContainer';var CUSTOMER_XRAY_FILE_UPLOAD='XRayFileUploadContainer';var REQUEST_MEDICAL_EVALUATION='RequestMedicalEvalWidgetContainer';var ATTACHMENT_NEEDED_WIDGET='AttachmentNeededWidgetContainer';var ATTACHMENT_AGREEMENT_WIDGET='AttachmentAgreementWidgetContainer';

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport batch */
/* unused harmony reexport useDispatch */
/* unused harmony reexport createDispatchHook */
/* unused harmony reexport useSelector */
/* unused harmony reexport createSelectorHook */
/* unused harmony reexport useStore */
/* unused harmony reexport createStoreHook */
/* unused harmony reexport shallowEqual */










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curry2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPlaceholder__ = __webpack_require__(166);



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(a) ? f2 : Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_b) {
          return fn(a, _b);
        });
      default:
        return Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(b) ? f2 : Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(a) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_a) {
          return fn(_a, b);
        }) : Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var MARGIN_OPTIONS={'no-margin':'0px',S:'10px',M:'25px'};var Row=function Row(props){var _props$className=props.className,className=_props$className===undefined?'':_props$className,_props$top=props.top,top=_props$top===undefined?'no-margin':_props$top,_props$bottom=props.bottom,bottom=_props$bottom===undefined?'no-margin':_props$bottom;var style={marginTop:MARGIN_OPTIONS[top],marginBottom:MARGIN_OPTIONS[bottom]};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row '+className,style:style},props.children);};Row.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Column=function Column(props){var _props$layer=props.layer,layer=_props$layer===undefined?'md':_props$layer,_props$size=props.size,size=_props$size===undefined?12:_props$size,_props$className=props.className,className=_props$className===undefined?'':_props$className;var _className='col-'+layer+'-'+size+' '+className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:_className},props.children);};Column.propTypes={layer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentBoxBody__ = __webpack_require__(84);
var ContentBox=function ContentBox(_ref){var children=_ref.children,title=_ref.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{layer:'lg',size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ContentBoxBody__["a" /* default */],null,children))));};ContentBox.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ContentBox);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUIDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultUI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_action__ = __webpack_require__(11);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var createUIDefinition=function createUIDefinition(_ref){var taskName=_ref.taskName,_ref$stateNameList=_ref.stateNameList,stateNameList=_ref$stateNameList===undefined?[]:_ref$stateNameList,_ref$external=_ref.external,external=_ref$external===undefined?false:_ref$external,_ref$widgetList=_ref.widgetList,widgetList=_ref$widgetList===undefined?[]:_ref$widgetList,_ref$overwriteWidget=_ref.overwriteWidget,overwriteWidget=_ref$overwriteWidget===undefined?false:_ref$overwriteWidget,_ref$actionList=_ref.actionList,actionList=_ref$actionList===undefined?[]:_ref$actionList,_ref$taskValidatorSel=_ref.taskValidatorSelector,taskValidatorSelector=_ref$taskValidatorSel===undefined?[]:_ref$taskValidatorSel,_ref$taskValidator=_ref.taskValidator,taskValidator=_ref$taskValidator===undefined?null:_ref$taskValidator;return{external:external,taskName:taskName,stateNameList:stateNameList,widgetList:!overwriteWidget?[{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]}].concat(_toConsumableArray(widgetList),[{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_22" /* WHATSAPP_MESSAGES_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}]):widgetList,actionList:[].concat(_toConsumableArray(actionList),[{action:__WEBPACK_IMPORTED_MODULE_1__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_1__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_1__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]),taskValidatorSelector:taskValidatorSelector,taskValidator:taskValidator};};var defaultUI=createUIDefinition({});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return selectValidationMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectCommentText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectProcessFlowVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectBeamProcessState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectProcessInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectProcessInstanceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectCurrentTaskName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectProcessContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return selectProcessStateHistoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectProcessLogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCommentList; });
/* unused harmony export selectProcessTaskList */
/* unused harmony export selectProcessObjectDetail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return selectProcessVoucherList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectOpenTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectVIPStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return selectRushStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAvailableStateList; });
/* unused harmony export selectCurrentState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectAvailableTransitionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectFreshSalesDealOwner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectFreshSalesCalendlyLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectValidationMessageList=function selectValidationMessageList(state){return selectOwnState(state).validationMessageList;};var selectCommentText=function selectCommentText(state){return selectOwnState(state).commentText;};var selectProcessFlowVisible=function selectProcessFlowVisible(state){return selectOwnState(state).processFlowVisible;};var selectBeamProcessState=function selectBeamProcessState(state){return selectOwnState(state).beamProcessState;};var selectProcessInstance=function selectProcessInstance(state){return selectOwnState(state).processInstance;};var selectProcessInstanceId=function selectProcessInstanceId(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.id:null;};var selectCurrentTaskName=function selectCurrentTaskName(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.currentTaskName:null;};var selectProcessContext=function selectProcessContext(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.context:null;};var selectProcessStateHistoryList=function selectProcessStateHistoryList(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.processStateHistoryList:null;};var selectProcessLogList=function selectProcessLogList(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.processLogList:null;};var selectCommentList=function selectCommentList(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.processCommentList:null;};var selectProcessTaskList=function selectProcessTaskList(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.processTaskList:[];};var selectProcessObjectDetail=function selectProcessObjectDetail(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.objectDetail:null;};var selectProcessVoucherList=function selectProcessVoucherList(state){var processObjectDetail=selectProcessObjectDetail(state);var customer=processObjectDetail?processObjectDetail.customer:null;var voucherList=customer?customer.voucherList:[];return voucherList||[];};var selectOpenTask=function selectOpenTask(state){var taskList=selectProcessTaskList(state);for(var index=0;index<taskList.length;index++){var task=taskList[index];if(task.status==='open'||task.status==='pending'){return task;}}return null;};var selectVIPStatus=function selectVIPStatus(state){var processInstance=selectProcessInstance(state);return processInstance?!!processInstance.vip:false;};var selectRushStatus=function selectRushStatus(state){var processInstance=selectProcessInstance(state);return processInstance?!!processInstance.rush:false;};var selectAvailableStateList=function selectAvailableStateList(state){var processInstance=selectProcessInstance(state);if(!processInstance||!processInstance.processVersion||!processInstance.processVersion.stateList){return[];}var stateList=processInstance.processVersion.stateList;stateList.sort(function(a,b){if(a.name<b.name){return-1;}if(a.name>b.name){return 1;}return 0;});return stateList;};var selectCurrentState=function selectCurrentState(state){var processInstance=selectProcessInstance(state);return processInstance?processInstance.currentState:null;};var selectAvailableTransitionList=function selectAvailableTransitionList(state){var currentState=selectCurrentState(state);if(!currentState){return null;}return currentState.transitionList.filter(function(transition){return!!transition.eventName;});};var selectFreshSalesDealOwner=function selectFreshSalesDealOwner(state){var processInstance=selectProcessInstance(state);if(!processInstance.objectDetail){return null;}var freshSalesDealOwner=processInstance.objectDetail.freshSalesDealOwner;return freshSalesDealOwner?freshSalesDealOwner:null;};var selectFreshSalesCalendlyLink=function selectFreshSalesCalendlyLink(state){var processInstance=selectProcessInstance(state);if(!processInstance.objectDetail){return null;}var freshSalesCalendlyLink=processInstance.objectDetail.freshSalesCalendlyLink;return freshSalesCalendlyLink?freshSalesCalendlyLink:null;};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_security_state_auth_selector__ = __webpack_require__(23);
var currentUserHasAccess=function currentUserHasAccess(widgetId){var state=__WEBPACK_IMPORTED_MODULE_0__modules_store__["a" /* default */].getState();var visibleWidgetList=Object(__WEBPACK_IMPORTED_MODULE_1__modules_security_state_auth_selector__["t" /* selectUserVisibleWidgetList */])(state);var visibleManuallyAddedWidgetList=Object(__WEBPACK_IMPORTED_MODULE_1__modules_security_state_auth_selector__["r" /* selectUserManuallyVisibleWidgetList */])(state);return visibleWidgetList.includes(widgetId)||visibleManuallyAddedWidgetList.includes(widgetId);};/* harmony default export */ __webpack_exports__["a"] = (currentUserHasAccess);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROCESS_INSTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SALES_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TREATMENT_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return QUOTATION_CUSTOMER_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INVOICE_CORRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROSPECT_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESCAN_APPOINTMENT_TOGGLE_IMAGE_VIEW; });
var PROCESS_INSTANCE='processInstanceLoaded';var SALES_ORDER='findSalesOrderSuccess';var CUSTOMER='findCustomerSuccess';var TREATMENT_PLAN='treatmentPlanLoaded';var TREATMENT_QUOTATION='treatmentQuotation';var QUOTATION_CUSTOMER_LOADED='quoatationCustomerLoaded';var INVOICE_CORRECTION='findInvoiceById';// prospect process
var PROSPECT_LOADED='findProspectSuccess';// rescan appointment
var RESCAN_APPOINTMENT_TOGGLE_IMAGE_VIEW='toggleImageView';

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACKEND_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
var BACKEND_URL= false?process.env.REACT_APP_API_URL:'';var post=function post(url,body,signal){return fetch(BACKEND_URL+url,{method:'POST',signal:signal,headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(body),credentials:'include'}).then(function(response){var status=response.status;if(status<200||status>300){return response.json().then(function(body){if(body&&body.exception==='NotAuthenticatedException'){window.location.reload();}return Promise.reject(body);});}return response.json();});};var get=function get(url){return fetch(BACKEND_URL+url,{method:'GET',headers:{Accept:'application/json','Content-Type':'application/json'},credentials:'include'}).then(function(response){var status=response.status;if(status<200||status>300){return response.json().then(function(body){if(body&&body.exception==='NotAuthenticatedException'){window.location.reload();}return Promise.reject(body);});}return response.json();});};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectCustomerDetailState; });
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return selectTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectImageFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectChangeEmailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return selectStartProcessFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectHasChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return selectTreatmentAlignerSystemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectIsExternalTreatmentPlanerPossible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAccountFix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectCustomerId; });
/* unused harmony export selectTreatmentExpectation */
/* unused harmony export selectMedicalCondition */
/* unused harmony export selectImageList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectShowImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectProcessList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectResponseFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectDeleteConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCustomerContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectCustomerError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treatment_state_quotation_const__ = __webpack_require__(59);
var selectCustomerDetailState=function selectCustomerDetailState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["f" /* REDUCER_NAME */]];};var selectOwnState=function selectOwnState(state){return selectCustomerDetailState(state)[__WEBPACK_IMPORTED_MODULE_0__const__["f" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectTab=function selectTab(state){return selectOwnState(state).tab;};var selectImageFetching=function selectImageFetching(state){return selectOwnState(state).imageFetching;};var selectChangeEmailData=function selectChangeEmailData(state){return selectOwnState(state).changeEmailData;};var selectStartProcessFetching=function selectStartProcessFetching(state){return selectOwnState(state).startProcessFetching;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectCustomer=function selectCustomer(state){return selectOwnState(state).customer;};var selectTreatmentAlignerSystemList=function selectTreatmentAlignerSystemList(state){var customer=selectCustomer(state);var supplierTechnicalName=Object(__WEBPACK_IMPORTED_MODULE_2__globals_state_selector__["selectPartnerTechnicalNameById"])(state,customer.partnerSupplierId);return supplierTechnicalName===__WEBPACK_IMPORTED_MODULE_3__treatment_state_quotation_const__["l" /* SUPPLIER_TECHNICAL_NAME_HAT_GROUP */]?__WEBPACK_IMPORTED_MODULE_3__treatment_state_quotation_const__["d" /* ALIGNER_SYSTEM_LIST_HAT_GROUP */]:__WEBPACK_IMPORTED_MODULE_3__treatment_state_quotation_const__["c" /* ALIGNER_SYSTEM_LIST_FULL */];};var selectIsExternalTreatmentPlanerPossible=function selectIsExternalTreatmentPlanerPossible(state){var customer=selectCustomer(state);if(!customer||!customer.partnerSupplierId){return false;}var technicalName=Object(__WEBPACK_IMPORTED_MODULE_2__globals_state_selector__["selectPartnerTechnicalNameById"])(state,customer.partnerSupplierId);return technicalName==='sunshine_smile';};var selectAccountFix=function selectAccountFix(state){return selectOwnState(state).accountFix;};var selectCustomerId=function selectCustomerId(state){var customer=selectCustomer(state);return customer?customer.id:null;};var selectTreatmentExpectation=function selectTreatmentExpectation(state){var customer=selectCustomer(state);return customer?customer.treatmentExpectation:null;};var selectMedicalCondition=function selectMedicalCondition(state){var customer=selectCustomer(state);return customer?customer.medicalCondition:null;};var selectImageList=function selectImageList(state){var customer=selectCustomer(state);return customer?customer.imageList:[];};var selectShowImages=function selectShowImages(state){return selectOwnState(state).showImages;};var selectProcessList=function selectProcessList(state){var customer=selectCustomer(state);return customer?customer.processList:null;};var selectResponseFeedback=function selectResponseFeedback(state){return selectOwnState(state).responseFeedback;};var selectDeleteConfirmationModal=function selectDeleteConfirmationModal(state){return selectOwnState(state).deleteConfirmationModal;};var selectCustomerContact=function selectCustomerContact(state){return selectOwnState(state).contact;};var selectCustomerError=function selectCustomerError(state){return selectOwnState(state).error;};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__combineActions__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAction__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createActions__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createCurriedAction__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handleAction__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handleActions__ = __webpack_require__(655);
/* unused harmony reexport combineActions */
/* unused harmony reexport createAction */
/* unused harmony reexport createActions */
/* unused harmony reexport createCurriedAction */
/* unused harmony reexport handleAction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__handleActions__["a"]; });








/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curry1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlaceholder__ = __webpack_require__(166);


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || Object(__WEBPACK_IMPORTED_MODULE_0__isPlaceholder__["a" /* default */])(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Select=function Select(_ref){var object=_ref.object,name=_ref.name,_onChange=_ref.onChange,_ref$valueList=_ref.valueList,valueList=_ref$valueList===undefined?[]:_ref$valueList,renderer=_ref.renderer,_ref$style=_ref.style,style=_ref$style===undefined?{}:_ref$style,_ref$addEmpty=_ref.addEmpty,addEmpty=_ref$addEmpty===undefined?false:_ref$addEmpty,type=_ref.type,_ref$readOnly=_ref.readOnly,readOnly=_ref$readOnly===undefined?false:_ref$readOnly,_ref$defaultValue=_ref.defaultValue,defaultValue=_ref$defaultValue===undefined?'':_ref$defaultValue,_ref$id=_ref.id,id=_ref$id===undefined?'':_ref$id;var selectedValue=object[name];if(typeof selectedValue==='boolean'){selectedValue=String(object[name]);}selectedValue=String(selectedValue||defaultValue);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:id,className:'form-control',style:style,disabled:readOnly,value:selectedValue,onChange:function onChange(event){if(readOnly){return;}var value=event.target.value;if(type==='int'){value=parseInt(value,10);}_onChange(name,value);}},addEmpty&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'empty',value:''}),valueList.map(function(object){var displayText=renderer?renderer(object):object.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:object.id,value:object.id,disabled:object.disabled},displayText);}));};Select.propTypes={object:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,validation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valueList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,addEmpty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,defaultValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createValidationMessage; });
var createValidationMessage=function createValidationMessage(message,messageId){return{message:message,messageId:messageId};};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSIGN_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECK_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHECK_IMAGES_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHECK_IMAGES_AND_SCANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHECK_IMAGES_AND_SCANS_REFINEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLARIFY_PRE_TREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PRE_TREATMENT_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHECK_SCANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHECK_CUSTOMER_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CREATE_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CREATE_REFINEMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CREATE_TREATMENT_PLAN_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CREATE_REFINEMENT_PLAN_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CREATE_TREATMENT_PLAN_EXTERNAL_PLANER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_EXTERNAL_TREATMENT_PLAN_VISUALIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CREATE_TREATMENT_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CREATE_REFINEMENT_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHECK_IMPRINTS_VISUALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CONFIRM_TREATMENT_PLAN_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLARIFY_REMARKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DO_SEPA_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ENTER_PHYSICIAN_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return REFUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MANUALLY_CHECK_IMAGE_AVAILABILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PROVIDE_TREATMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PROVIDE_REFINEMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return REVIEW_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return REVIEW_REFINEMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return REVIEW_TREATMENT_PLAN_INTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SCAN_IMPRINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SHIP_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UPLOAD_CASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UPLOAD_TREATMENT_PLAN_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ORDER_ALIGNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return VALIDATE_CANNOT_BE_TREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TREATMENT_QUOTATION_CREATED_WHATS_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TREATMENT_QUOTATION_FOLLOW_UP_CALL_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return TREATMENT_QUOTATION_FOLLOW_UP_CALL_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BAD_IMPRINT_PATIENT_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COMPLEXITY_TREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MAKE_CUSTOMER_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MAKE_NEW_CUSTOMER_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PREPARE_TREATMENT_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return VISUALIZATION_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHECK_TREATABILITY_AFTER_CLINIC; });
var ASSIGN_PHYSICIAN='assign_physician';var CHECK_IMAGES='check_images';var CHECK_IMAGES_POST='check_images_post';var CHECK_IMAGES_AND_SCANS='check_images_and_scans';var CHECK_IMAGES_AND_SCANS_REFINEMENT='check_images_and_scans_refinement';var CLARIFY_PRE_TREATMENT='clarify_pre_treatment';var PRE_TREATMENT_CHECK='pretreatment_check';var CHECK_SCANS='check_scans';var CHECK_CUSTOMER_IMAGES='check_customer_images';var CREATE_TREATMENT_PLAN='create_treatment_plan';var CREATE_REFINEMENT_PLAN='create_refinement_plan';var CREATE_TREATMENT_PLAN_EXTERNAL='create_treatment_plan_external';var CREATE_REFINEMENT_PLAN_EXTERNAL='create_refinement_plan_external';var CREATE_TREATMENT_PLAN_EXTERNAL_PLANER='create_treatment_plan_external_planer';var CREATE_EXTERNAL_TREATMENT_PLAN_VISUALIZATION='create_external_treatment_plan_visualization';var CREATE_TREATMENT_QUOTATION='create_treatment_quotation';var CREATE_REFINEMENT_QUOTATION='create_refinement_quotation';var CHECK_IMPRINTS_VISUALLY='check_imprints_visually';var CONFIRM_TREATMENT_PLAN_DONE='confirm_treatment_plan_done';var CLARIFY_REMARKS='clarify_remarks';var DO_SEPA_PAYMENT='do_sepa_payment';var ENTER_PHYSICIAN_FEEDBACK='enter_physician_feedback';var REFUND='refund';var MANUALLY_CHECK_IMAGE_AVAILABILITY='manually_check_image_availability';var PROVIDE_TREATMENT_SETUP='provide_treatment_setup';var PROVIDE_REFINEMENT_SETUP='provide_refinement_setup';var REVIEW_TREATMENT_PLAN='review_treatment_plan';var REVIEW_REFINEMENT_PLAN='review_refinement_plan';var REVIEW_TREATMENT_PLAN_INTERNAL='review_treatment_plan_internal';var SCAN_IMPRINTS='scan_imprints';var SHIP_SET='ship_set';var UPLOAD_CASE='upload_case';var UPLOAD_TREATMENT_PLAN_FILES='upload_treatment_plan_files';var ORDER_ALIGNER='order_aligner';var VALIDATE_CANNOT_BE_TREATED='validate_cannot_be_treated';var TREATMENT_QUOTATION_CREATED_WHATS_APP='treatment_quotation_created_whatsapp';var TREATMENT_QUOTATION_FOLLOW_UP_CALL_1='treatment_quotation_follow_up_call_1';var TREATMENT_QUOTATION_FOLLOW_UP_CALL_2='treatment_quotation_follow_up_call_2';var SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_1='send_treatment_quotation_reminder_whatsapp_1';var SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_2='send_treatment_quotation_reminder_whatsapp_2';var BAD_IMPRINT_PATIENT_CALL='bad_imprint_patient_call';var COMPLEXITY_TREATMENT='treatment_plan_complexity_assignment';var MAKE_CUSTOMER_APPOINTMENT='make_customer_appointment';var MAKE_NEW_CUSTOMER_APPOINTMENT='make_new_customer_appointment';var PREPARE_TREATMENT_FILES='prepare_treatment_files';var VISUALIZATION_CHECK='visualization_check';var CHECK_TREATABILITY_AFTER_CLINIC='check_treatability_after_clinic';

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapProps */
/* unused harmony export withProps */
/* unused harmony export withPropsOnChange */
/* unused harmony export withHandlers */
/* unused harmony export defaultProps */
/* unused harmony export renameProp */
/* unused harmony export renameProps */
/* unused harmony export flattenProp */
/* unused harmony export withState */
/* unused harmony export withStateHandlers */
/* unused harmony export withReducer */
/* unused harmony export branch */
/* unused harmony export renderComponent */
/* unused harmony export renderNothing */
/* unused harmony export shouldUpdate */
/* unused harmony export pure */
/* unused harmony export onlyUpdateForKeys */
/* unused harmony export onlyUpdateForPropTypes */
/* unused harmony export withContext */
/* unused harmony export getContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lifecycle; });
/* unused harmony export toClass */
/* unused harmony export setStatic */
/* unused harmony export setPropTypes */
/* unused harmony export setDisplayName */
/* unused harmony export compose */
/* unused harmony export getDisplayName */
/* unused harmony export wrapDisplayName */
/* unused harmony export isClassComponent */
/* unused harmony export createSink */
/* unused harmony export componentFromProp */
/* unused harmony export nest */
/* unused harmony export hoistStatics */
/* unused harmony export componentFromStream */
/* unused harmony export componentFromStreamWithConfig */
/* unused harmony export mapPropsStream */
/* unused harmony export mapPropsStreamWithConfig */
/* unused harmony export createEventHandler */
/* unused harmony export createEventHandlerWithConfig */
/* unused harmony export setObservableConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(329);
/* unused harmony reexport shallowEqual */






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curry3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPlaceholder__ = __webpack_require__(166);




/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) ? f3 : Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(b) ? f3 : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (_a, _c) {
          return fn(_a, b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (_b, _c) {
          return fn(a, _b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(b) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(c) ? f3 : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (_a, _b) {
          return fn(_a, _b, c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(c) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (_a, _c) {
          return fn(_a, b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(b) && Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(c) ? Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (_b, _c) {
          return fn(a, _b, _c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(a) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_a) {
          return fn(_a, b, c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(b) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_b) {
          return fn(a, _b, c);
        }) : Object(__WEBPACK_IMPORTED_MODULE_2__isPlaceholder__["a" /* default */])(c) ? Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Label=function Label(_ref){var label=_ref.label,_ref$labelClassName=_ref.labelClassName,labelClassName=_ref$labelClassName===undefined?'':_ref$labelClassName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label '+labelClassName},label);};var GroupAddOn=function GroupAddOn(_ref2){var groupAddOnIcon=_ref2.groupAddOnIcon;if(!groupAddOnIcon){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-addon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:groupAddOnIcon}));};var ActionAddOn=function ActionAddOn(_ref3){var actionAddOnIcon=_ref3.actionAddOnIcon,onActionAddOnClick=_ref3.onActionAddOnClick;if(!actionAddOnIcon){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:onActionAddOnClick,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:actionAddOnIcon})));};var LabelInput=function LabelInput(props){var isGroup=props.groupAddOnIcon||props.actionAddOnIcon;if(!isGroup){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,props),props.children);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupAddOn,props),props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionAddOn,props)));};LabelInput.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,labelClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,groupAddOnIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,actionAddOnIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onActionAddOnClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (LabelInput);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectRouter; });
/* unused harmony export getLocation */
/* unused harmony export getAction */
/* unused harmony export getHash */
/* unused harmony export getSearch */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__structure_plain__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["b"]; });
/* unused harmony reexport CALL_HISTORY_METHOD */
/* unused harmony reexport onLocationChanged */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["d"]; });
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middleware__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__middleware__["a"]; });






var ConnectedRouter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]);
var connectRouter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]);

var _createSelectors = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__structure_plain__["a" /* default */]),
    getLocation = _createSelectors.getLocation,
    getAction = _createSelectors.getAction,
    getHash = _createSelectors.getHash,
    getSearch = _createSelectors.getSearch,
    createMatchSelector = _createSelectors.createMatchSelector;



/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectLoginData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectLoginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return selectUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return selectUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canSeeCustomerNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectHasRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectIsTQAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectIsPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectIsCustomerServiceTeamLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectHasReportingRole; });
/* unused harmony export selectHasProcessAdminRole */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCanReassignPhysician; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCanReassignStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectHasAccountingRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectIsPasswordResetRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCanSeeImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectEmployeeRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectEmployeeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectUserStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return selectUserVisibleWidgetList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return selectUserManuallyVisibleWidgetList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return userHasWidgetInVisibleList; });
/* unused harmony export selectUserRoleList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return userHasAnyOfRoles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(399);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]];};var selectLoginData=function selectLoginData(state){return selectOwnState(state).loginData;};var selectLoginError=function selectLoginError(state){return selectOwnState(state).error;};var selectUser=function selectUser(state){return selectOwnState(state).user;};var selectUserId=function selectUserId(state){var user=selectUser(state);return user?user.id:null;};var canSeeCustomerNames=function canSeeCustomerNames(state){return selectHasRole(state,[__WEBPACK_IMPORTED_MODULE_0__const__["l" /* ROLE_EMPLOYEE */],__WEBPACK_IMPORTED_MODULE_0__const__["B" /* ROLE_PARTNER_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["D" /* ROLE_PARTNER_SCAN_PHYSICIAN */]]);};var selectHasRole=function selectHasRole(state,role){var user=selectUser(state);if(!user||!role){return false;}if(!Array.isArray(role)){return user.roleList.indexOf(role)!==-1;}for(var index=0;index<role.length;index++){if(user.roleList.indexOf(role[index])!==-1){return true;}}return false;};var selectIsTQAdmin=function selectIsTQAdmin(state){return selectHasRole(state,__WEBPACK_IMPORTED_MODULE_0__const__["P" /* ROLE_TREATMENT_QUOTATION_ADMIN */]);};var selectIsPartner=function selectIsPartner(state){return selectHasRole(state,__WEBPACK_IMPORTED_MODULE_0__const__["A" /* ROLE_PARTNER */]);};var selectIsCustomerServiceTeamLead=function selectIsCustomerServiceTeamLead(state){return selectHasRole(state,__WEBPACK_IMPORTED_MODULE_0__const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */]);};var selectHasReportingRole=function selectHasReportingRole(state){return selectHasRole(state,__WEBPACK_IMPORTED_MODULE_0__const__["J" /* ROLE_REPORTING */]);};var selectHasProcessAdminRole=function selectHasProcessAdminRole(state){return selectHasRole(state,__WEBPACK_IMPORTED_MODULE_0__const__["F" /* ROLE_PROCESS_ADMIN */]);};var selectCanReassignPhysician=function selectCanReassignPhysician(state){return selectHasRole(state,[__WEBPACK_IMPORTED_MODULE_0__const__["h" /* ROLE_CLINIC_MANAGEMENT */],__WEBPACK_IMPORTED_MODULE_0__const__["K" /* ROLE_RETAIL_QA */]]);};var selectCanReassignStore=function selectCanReassignStore(state){return selectHasRole(state,[__WEBPACK_IMPORTED_MODULE_0__const__["h" /* ROLE_CLINIC_MANAGEMENT */],__WEBPACK_IMPORTED_MODULE_0__const__["K" /* ROLE_RETAIL_QA */]]);};var selectHasAccountingRole=function selectHasAccountingRole(state){return selectHasRole(state,__WEBPACK_IMPORTED_MODULE_0__const__["f" /* ROLE_ACCOUNTING */]);};var selectIsPasswordResetRequired=function selectIsPasswordResetRequired(state){return selectOwnState(state).passwordResetRequired;};var selectCanSeeImages=function selectCanSeeImages(state){return selectHasRole(state,[__WEBPACK_IMPORTED_MODULE_0__const__["n" /* ROLE_EMPLOYEE_DENTAL_TECHNICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["o" /* ROLE_EMPLOYEE_IMPRINT_QA */],__WEBPACK_IMPORTED_MODULE_0__const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_0__const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_0__const__["B" /* ROLE_PARTNER_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["B" /* ROLE_PARTNER_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["E" /* ROLE_PARTNER_TREATMENT_PLANER */],__WEBPACK_IMPORTED_MODULE_0__const__["D" /* ROLE_PARTNER_SCAN_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["q" /* ROLE_EMPLOYEE_SHOP_ASSISTANT */],__WEBPACK_IMPORTED_MODULE_0__const__["r" /* ROLE_EMPLOYEE_SHOP_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["s" /* ROLE_EMPLOYEE_SHOP_ZFA */],__WEBPACK_IMPORTED_MODULE_0__const__["g" /* ROLE_ADVISING_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["M" /* ROLE_TREATING_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_0__const__["N" /* ROLE_TREATING_PHYSICIAN_REMOTE */]]);};var selectEmployeeRoleList=function selectEmployeeRoleList(state){var user=selectUser(state);return user.roleList;};var selectEmployeeId=function selectEmployeeId(state){var user=selectUser(state);return user.employeeId;};var selectUserStore=function selectUserStore(state){var _selectUser=selectUser(state),store=_selectUser.store;return store;};var selectUserVisibleWidgetList=function selectUserVisibleWidgetList(state){var user=selectUser(state);return user.visibleWidgetList||[];};var selectUserManuallyVisibleWidgetList=function selectUserManuallyVisibleWidgetList(state){var user=selectUser(state);return user.visibleWidgetListManuallyAdded||[];};var userHasWidgetInVisibleList=function userHasWidgetInVisibleList(state,widgetName){var visibleList=selectUserVisibleWidgetList(state);return visibleList.includes(widgetName);};var selectUserRoleList=function selectUserRoleList(state){var user=selectUser(state);return user.roleList;};var userHasAnyOfRoles=function userHasAnyOfRoles(state,roleList){var userRoleList=selectUserRoleList(state);return userRoleList.some(function(role){return roleList.includes(role);});};

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_LayoutContainer__ = __webpack_require__(805);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_LayoutContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props));};});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROCESS_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROCESS_NAME_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return renderProcessName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return renderTaskName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderEventName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return renderStateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return renderRoleName; });
var PROCESS_NAMES={'salesorder-in-shop-scan':'Clinic 3D-Scan','salesorder-in-shop-scan-new':'Clinic 3D-Scan New','salesorder-check-in':'Clinic Check-In','salesorder-escalation':'Escalation','salesorder-refinement-set':'Refinement (Set)','salesorder-refinement-booking':'Refinement (Booking)','salesorder-refinement-shop':'Refinement (Shop Scan)','salesorder-refinement-shop-new':'Refinement (Shop Scan New)','salesorder-refinement-production':'Refinement Treatment','salesorder-retainer':'Retainer','salesorder-retainer-new':'Retainer New','salesorder-set':'Set','salesorder-shop-scan':'Shop Scan','salesorder-shop-scan-new':'Shop Scan New','salesorder-treatment':'Treatment','salesorder-treatment-new':'Treatment New','salesorder-end-of-treatment':'End Of Treatment','salesorder-aligner-reproduction':'Aligner Reproduction','process-implant-3dscan':'Implant 3D-Scan','process-implant-plan':'Implant Plan','process-implant-treatment':'Implant Treatment','process-retainer-refinement':'Retainer Refinement','process-retainer-refinement-new':'Retainer Refinement New','process-partial-refund':'Partial Refund'};var PROCESS_NAME_SELECT=Object.keys(PROCESS_NAMES).map(function(processName){return{id:processName,value:PROCESS_NAMES[processName]};});var DEBUG_MODE=false;var renderProcessName=function renderProcessName(processName){return PROCESS_NAMES[processName];};var renderTaskName=function renderTaskName(taskName){if(!taskName){return'';}return DEBUG_MODE?taskName:taskName.replace(/_/g,' ');};var renderEventName=function renderEventName(eventName){if(!eventName){return'';}return DEBUG_MODE?eventName:eventName.replace(/_/g,' ');};var renderStateName=function renderStateName(stateName){if(!stateName){return'';}return DEBUG_MODE?stateName:stateName.replace(/_/g,' ');};var renderRoleName=function renderRoleName(roleName){if(!roleName){return'';}roleName=roleName.join(',');return DEBUG_MODE?roleName:roleName.replace(/_/g,' ');};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDaysDifferenceToToday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDate; });
/* unused harmony export formatJSONDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateComparator; });
var moment=__webpack_require__(38);var getDaysDifferenceToToday=function getDaysDifferenceToToday(dateTime){if(!dateTime){return'';}return moment().diff(moment(dateTime),'days');};var formatDateTime=function formatDateTime(dateTime){if(!dateTime){return'';}return moment(dateTime).format('DD.MM.YYYY HH:mm');};var formatDate=function formatDate(dateTime){if(!dateTime){return'';}return moment(dateTime).format('DD.MM.YYYY');};// 2018-02-19T12:27:00
var formatJSONDate=function formatJSONDate(momentDate){return momentDate.format('YYYY-MM-DDTHH:mm:ss');};var dateComparator=function dateComparator(property){var sortOrder=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(a,b){a=a[property];b=b[property];if(!a&&!b){return 0;}if(!a&&b){return-1*sortOrder;}if(a&&!b){return sortOrder;}return sortOrder*(moment(a).unix()-moment(b).unix());};};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALIGNER_TREATMENT_MEDICAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALIGNER_TREATMENT_EXPECTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALIGNER_TREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IMPLANT_TREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IMPLANT_CONSULTATION_AND_FINDINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IMPLANT_SURGERY_DOCUMENTATION; });
var REDUCER_NAME='anamnesis';/* old type form */var ALIGNER_TREATMENT_MEDICAL_INFORMATION='alignerTreatmentTypeForm.medical';var ALIGNER_TREATMENT_EXPECTATION='alignerTreatmentTypeForm.expectation';/* external forms on fire */var ALIGNER_TREATMENT='alignerTreatment';var IMPLANT_TREATMENT='implantTreatment';/* physician assessment */var ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT='alignerTreatmentPhysicianAssessment';var IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT='implantTreatmentPhysicianAssessment';var IMPLANT_CONSULTATION_AND_FINDINGS='implantConsultationAndFindings';var IMPLANT_SURGERY_DOCUMENTATION='implantSurgeryDocumentation';

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERROR_PASSWORD_NOT_IDENTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ERROR_PASSWORD_NOT_SECURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_PASSWORD_MUST_BE_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ROLE_PARTNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ROLE_PARTNER_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ROLE_PARTNER_TREATMENT_PLANER; });
/* unused harmony export ROLE_PARTNER_ALIGNER_PRODUCER */
/* unused harmony export ROLE_PARTNER_LOGISTICS */
/* unused harmony export ROLE_PARTNER_RETAINER_PRODUCER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ROLE_PARTNER_SCAN_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ROLE_PARTNER_PHYSICIAN_REMOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ROLE_EMPLOYEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ROLE_EMPLOYEE_OFFICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ROLE_EMPLOYEE_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ROLE_ACCOUNTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ROLE_EMPLOYEE_CUSTOMER_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ROLE_CUSTOMER_SERVICE_TEAM_LEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROLE_2ND_LEVEL_LEGAL; });
/* unused harmony export ROLE_EMPLOYEE_CALL_CENTER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ROLE_EMPLOYEE_DENTAL_TECHNICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ROLE_EMPLOYEE_IMPRINT_QA; });
/* unused harmony export ROLE_EMPLOYEE_LOGISTICS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ROLE_PROCESS_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ROLE_EMAIL_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return ROLE_WIDGET_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ROLE_REPORTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ROLE_PROCESS_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ROLE_TREATMENT_PLANER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ROLE_QM_TREATMENT_PLANNER; });
/* unused harmony export ROLE_EMPLOYEE_TREATMENT_PRODUCER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ROLE_TREATMENT_QUOTATION_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ROLE_USER_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ROLE_TASK_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ROLE_MEDICAL_ADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ROLE_EMPLOYEE_SHOP_ASSISTANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ROLE_EMPLOYEE_SHOP_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ROLE_EMPLOYEE_SHOP_ZFA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ROLE_ADVISING_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ROLE_TREATING_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return ROLE_TREATING_PHYSICIAN_REMOTE; });
/* unused harmony export ROLE_PRODUCTION_ASSISTANCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ROLE_PRODUCTION_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return ROLE_RETAIL_QA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ROLE_CLINIC_MANAGEMENT; });
/* unused harmony export ROLE_PRODUCTION_MARKER */
/* unused harmony export ROLE_PRODUCTION_NESTER */
/* unused harmony export ROLE_PRODUCTION_SORTER */
/* unused harmony export ROLE_PRODUCTION_THERMO_FORMER */
/* unused harmony export ROLE_PRODUCTION_LASER_MARKER */
/* unused harmony export ROLE_PRODUCTION_TRIMMER */
/* unused harmony export ROLE_PRODUCTION_QM */
/* unused harmony export ROLE_PRODUCTION_PACKER */
/* unused harmony export ROLE_PRODUCTION_PRINTER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ROLE_FOIL_METADATA_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ROLE_CLINIC_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ROLE_LIST_PARTNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ROLE_LIST_EMPLOYEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ROLE_LIST_EMPLOYEE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ROLE_LIST_PARTNER_SELECT; });
/* unused harmony export ROLE_LIST */
/* unused harmony export ROLE_LIST_SELECT */
/* unused harmony export STORE_BERLIN */
/* unused harmony export STORE_DORTMUND */
/* unused harmony export STORE_DUESSELDORF */
/* unused harmony export STORE_FRANKFURT */
/* unused harmony export STORE_HEIDELBERG */
/* unused harmony export STORE_HAMBURG */
/* unused harmony export STORE_LEIPZIG */
/* unused harmony export STORE_MUNICH */
/* unused harmony export STORE_STUTTGART */
/* unused harmony export STORE_VIENNA */
/* unused harmony export STORE_LIST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_sort__ = __webpack_require__(221);
var REDUCER_NAME='auth';var ERROR_PASSWORD_NOT_IDENTICAL='password_not_identical';var ERROR_PASSWORD_NOT_SECURE='password_not_secure';var ERROR_PASSWORD_MUST_BE_NEW='password_must_be_new';var ROLE_PARTNER='partner';var ROLE_PARTNER_PHYSICIAN='partner.physician';var ROLE_PARTNER_TREATMENT_PLANER='partner.treatment_planer';var ROLE_PARTNER_ALIGNER_PRODUCER='partner.aligner_producer';var ROLE_PARTNER_LOGISTICS='partner.logistic';var ROLE_PARTNER_RETAINER_PRODUCER='partner.retainer_producer';var ROLE_PARTNER_SCAN_PHYSICIAN='partner.scan_physician';var ROLE_PARTNER_PHYSICIAN_REMOTE='partner.physician_remote';var ROLE_EMPLOYEE='employee';var ROLE_EMPLOYEE_OFFICE='employee.office';var ROLE_EMPLOYEE_STORE='employee.store';var ROLE_ACCOUNTING='accounting';var ROLE_EMPLOYEE_CUSTOMER_SERVICE='customer_service';var ROLE_CUSTOMER_SERVICE_TEAM_LEAD='customer_service_team_lead';var ROLE_2ND_LEVEL_LEGAL='2nd_level_legal';var ROLE_EMPLOYEE_CALL_CENTER='call_center';var ROLE_EMPLOYEE_DENTAL_TECHNICIAN='dental_technician';var ROLE_EMPLOYEE_IMPRINT_QA='imprint_qa';var ROLE_EMPLOYEE_LOGISTICS='logistic';var ROLE_PROCESS_ADMIN='processAdmin';var ROLE_EMAIL_ADMIN='email_admin';var ROLE_WIDGET_ADMIN='widget_admin';var ROLE_REPORTING='reporting';var ROLE_PROCESS_MANAGER='process_manager';var ROLE_TREATMENT_PLANER='treatment_planer';var ROLE_QM_TREATMENT_PLANNER='qm_treatment_planner';var ROLE_EMPLOYEE_TREATMENT_PRODUCER='treatment_producer';var ROLE_TREATMENT_QUOTATION_ADMIN='tq_admin';var ROLE_USER_ADMIN='user_admin';var ROLE_TASK_ADMIN='task_admin';var ROLE_MEDICAL_ADVISOR='medical_advisor';var ROLE_EMPLOYEE_SHOP_ASSISTANT='shop_assistant';var ROLE_EMPLOYEE_SHOP_PHYSICIAN='shop_physician';var ROLE_EMPLOYEE_SHOP_ZFA='shop_zfa';var ROLE_ADVISING_PHYSICIAN='advising_physician';var ROLE_TREATING_PHYSICIAN='treating_physician';var ROLE_TREATING_PHYSICIAN_REMOTE='treating_physician_remote';var ROLE_PRODUCTION_ASSISTANCE='production_assistance';var ROLE_PRODUCTION_ADMIN='production_admin';var ROLE_RETAIL_QA='retail_qa';var ROLE_CLINIC_MANAGEMENT='clinic_management';var ROLE_PRODUCTION_MARKER='production_marker';var ROLE_PRODUCTION_NESTER='production_nester';var ROLE_PRODUCTION_SORTER='production_sorter';var ROLE_PRODUCTION_THERMO_FORMER='production_thermo_former';var ROLE_PRODUCTION_LASER_MARKER='production_laser_marker';var ROLE_PRODUCTION_TRIMMER='production_trimmer';var ROLE_PRODUCTION_QM='production_qm';var ROLE_PRODUCTION_PACKER='production_packer';var ROLE_PRODUCTION_PRINTER='production_printer';var ROLE_FOIL_METADATA_ADMIN='foil_metadata_admin';var ROLE_CLINIC_SALES='clinic_sales';var ROLE_LIST_PARTNER=[ROLE_PARTNER,ROLE_PARTNER_PHYSICIAN,ROLE_PARTNER_TREATMENT_PLANER,ROLE_PARTNER_ALIGNER_PRODUCER,ROLE_PARTNER_RETAINER_PRODUCER,ROLE_PARTNER_LOGISTICS,ROLE_PARTNER_SCAN_PHYSICIAN,ROLE_PARTNER_PHYSICIAN_REMOTE,ROLE_CLINIC_SALES];var ROLE_LIST_EMPLOYEE=[ROLE_EMPLOYEE,ROLE_EMPLOYEE_OFFICE,ROLE_EMPLOYEE_STORE,ROLE_ACCOUNTING,ROLE_CUSTOMER_SERVICE_TEAM_LEAD,ROLE_2ND_LEVEL_LEGAL,ROLE_EMPLOYEE_CUSTOMER_SERVICE,ROLE_EMPLOYEE_CALL_CENTER,ROLE_EMPLOYEE_DENTAL_TECHNICIAN,ROLE_EMPLOYEE_IMPRINT_QA,ROLE_EMPLOYEE_LOGISTICS,ROLE_REPORTING,ROLE_EMAIL_ADMIN,ROLE_WIDGET_ADMIN,ROLE_TREATMENT_PLANER,ROLE_QM_TREATMENT_PLANNER,ROLE_TREATMENT_QUOTATION_ADMIN,ROLE_EMPLOYEE_TREATMENT_PRODUCER,ROLE_USER_ADMIN,ROLE_TASK_ADMIN,ROLE_EMPLOYEE_SHOP_ASSISTANT,ROLE_EMPLOYEE_SHOP_PHYSICIAN,ROLE_EMPLOYEE_SHOP_ZFA,ROLE_ADVISING_PHYSICIAN,ROLE_TREATING_PHYSICIAN,ROLE_TREATING_PHYSICIAN_REMOTE,ROLE_PRODUCTION_ASSISTANCE,ROLE_RETAIL_QA,ROLE_CLINIC_MANAGEMENT,ROLE_PRODUCTION_ADMIN,ROLE_PRODUCTION_MARKER,ROLE_PRODUCTION_NESTER,ROLE_PRODUCTION_SORTER,ROLE_PRODUCTION_THERMO_FORMER,ROLE_PRODUCTION_LASER_MARKER,ROLE_PRODUCTION_TRIMMER,ROLE_PRODUCTION_QM,ROLE_PRODUCTION_PACKER,ROLE_PRODUCTION_PRINTER,ROLE_MEDICAL_ADVISOR,ROLE_FOIL_METADATA_ADMIN,ROLE_CLINIC_SALES];var ROLE_LIST_EMPLOYEE_SELECT=ROLE_LIST_EMPLOYEE.map(function(role){return{id:role,value:role};});Object(__WEBPACK_IMPORTED_MODULE_0__util_sort__["a" /* sortByProperty */])(ROLE_LIST_EMPLOYEE_SELECT,'value');var ROLE_LIST_PARTNER_SELECT=ROLE_LIST_PARTNER.map(function(role){return{id:role,value:'Partner '+role};});Object(__WEBPACK_IMPORTED_MODULE_0__util_sort__["a" /* sortByProperty */])(ROLE_LIST_PARTNER_SELECT,'value');var ROLE_LIST=[].concat(ROLE_LIST_EMPLOYEE,ROLE_LIST_PARTNER);var ROLE_LIST_SELECT=ROLE_LIST.map(function(role){return{id:role,value:role};});Object(__WEBPACK_IMPORTED_MODULE_0__util_sort__["a" /* sortByProperty */])(ROLE_LIST_SELECT,'value');var STORE_BERLIN='berlin';var STORE_DORTMUND='dortmund';var STORE_DUESSELDORF='duesseldorf';var STORE_FRANKFURT='frankfurt';var STORE_HEIDELBERG='heidelberg';var STORE_HAMBURG='hamburg';var STORE_LEIPZIG='leipzig';var STORE_MUNICH='munich';var STORE_STUTTGART='stuttgart';var STORE_VIENNA='vienna';var STORE_LIST=[STORE_BERLIN,STORE_DORTMUND,STORE_DUESSELDORF,STORE_FRANKFURT,STORE_HAMBURG,STORE_HEIDELBERG,STORE_LEIPZIG,STORE_MUNICH,STORE_STUTTGART,STORE_VIENNA].map(function(store){return{id:store,value:store};});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FILE_TYPE_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FILE_TYPE_X_RAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FILE_TYPE_SCAN_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE_TYPE_IMPLANT_SCAN_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FILE_TYPE_IMPLANT_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FILE_TYPE_OTHER_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_TYPE_CBCT_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FILE_TYPE_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FILE_TYPE_TREATMENT_PLAN_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FILE_TYPE_PRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE_TYPE_CONFORMITY_DECLARATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILE_TYPE_CUSTOMS_INVOICE; });
var REDUCER_NAME='customer';var FILE_TYPE_IMAGE='imageList';var FILE_TYPE_X_RAY='xRayFileList';var FILE_TYPE_SCAN_FILE='scanFileList';var FILE_TYPE_IMPLANT_SCAN_FILE='implantScanFileList';var FILE_TYPE_IMPLANT_TREATMENT_PLAN='implantTreatmentPlanFileList';var FILE_TYPE_OTHER_FILES='otherFileList';var FILE_TYPE_CBCT_FILE='cbctFileList';var FILE_TYPE_TREATMENT_PLAN='treatmentPlanFileList';var FILE_TYPE_TREATMENT_PLAN_EXTERNAL='treatmentPlanExternalFileList';var FILE_TYPE_PRODUCTION='productionFileList';var FILE_TYPE_CONFORMITY_DECLARATION='conformityDeclarationList';var FILE_TYPE_CUSTOMS_INVOICE='customsInvoiceList';

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FORWARD_IMAGES_TO_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FOLLOW_UP_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REFINEMENT_CLARIFICATION_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PRINT_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PRINT_MISSING_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PRODUCE_ALIGNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PRODUCE_ALIGNER_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PROVIDE_MOVEMENT_CERTIFICATE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SHIP_ALIGNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PRE_CHECK_PHOTO_CHECKIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_PHOTO_CHECKIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FINAL_CHECK_PHOTO_CHECKIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLARIFY_REFINEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLARIFY_ALIGNER_CHECKIN_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PROVIDE_CUSTOMER_COMMUNICATION_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PROVIDE_PHYSICIAN_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SHIP_ALIGNER_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return THERMO_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MARKING_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPLOAD_PRODUCT_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_INVOICE_CORRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PRINT_CASE_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REDUCER_ENAMEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NESTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NEST_MISSING_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return START_SORTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SORTING_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MAKE_CUSTOMER_IPR_APPOINTMENT; });
var FORWARD_IMAGES_TO_PHYSICIAN='forward_images_to_physician';var FOLLOW_UP_CALL='follow_up_call';var REFINEMENT_CLARIFICATION_CALL='refinement_clarification_call';var PRINT_MODELS='print_models';var PRINT_MISSING_MODELS='print_missing_models';var PRODUCE_ALIGNER='produce_aligner';var PRODUCE_ALIGNER_EXTERNAL='produce_aligner_external';var PROVIDE_MOVEMENT_CERTIFICATE_NUMBER='provide_movement_certificate_number';var SHIP_ALIGNER='ship_aligner';var PRE_CHECK_PHOTO_CHECKIN='precheck_photo_checkin';var CHECK_PHOTO_CHECKIN='check_photo_checkin';var FINAL_CHECK_PHOTO_CHECKIN='final_check_photo_checkin';var CLARIFY_REFINEMENT='clarify_refinement';var CLARIFY_ALIGNER_CHECKIN_COMMENT='clarify_aligner_checkin_comment';var PROVIDE_CUSTOMER_COMMUNICATION_REASON='provide_customer_communication_reason';var PROVIDE_PHYSICIAN_RECOMMENDATION='provide_physician_recommendation';var SHIP_ALIGNER_EXTERNAL='ship_aligner_external';var THERMO_FORM='thermo_form';var MARKING_MODELS='marking_models';var UPLOAD_PRODUCT_FILES='upload_production_files';var CREATE_INVOICE_CORRECTION='create_invoice_correction';var PRINT_CASE_CARD='print_case_card';var REDUCER_ENAMEL='reduce_enamel';var NESTING='nesting';var NEST_MISSING_MODELS='nest_missing_models';var START_SORTING='start_sorting';var SORTING_MODELS='sorting_models';var MAKE_CUSTOMER_IPR_APPOINTMENT='make_customer_ipr_appointment';

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPANY_CODE_SUNSHINE_SMILE_GERMANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPANY_CODE_SUNSHINE_SMILE_UK; });
/* unused harmony export COMPANY_CODE_DISPLAY_NAMES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY_CODE_SELECT_VALUE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LANGUAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COUNTRY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUNTRY_CODE_LIST; });
/* unused harmony export WEBSITE_URL_LIST */
var _COMPANY_CODE_DISPLAY;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var COMPANY_CODE_SUNSHINE_SMILE_GERMANY='0200';var COMPANY_CODE_SUNSHINE_SMILE_UK='1066';var COMPANY_CODE_DISPLAY_NAMES=(_COMPANY_CODE_DISPLAY={},_defineProperty(_COMPANY_CODE_DISPLAY,COMPANY_CODE_SUNSHINE_SMILE_GERMANY,'Sunshine Smile GmbH'),_defineProperty(_COMPANY_CODE_DISPLAY,COMPANY_CODE_SUNSHINE_SMILE_UK,'SSS UK Services Limited'),_COMPANY_CODE_DISPLAY);var COMPANY_CODE_SELECT_VALUE_LIST=Object.keys(COMPANY_CODE_DISPLAY_NAMES).map(function(key){return{id:key,value:COMPANY_CODE_DISPLAY_NAMES[key]};});var LANGUAGE_LIST=[{id:'',value:''},{id:'de_DE',value:'German (Germany)'},{id:'de_AT',value:'German (Austria)'},{id:'de_CH',value:'German (Switzerland)'},{id:'en_GB',value:'English (Great Britain)'},{id:'es_ES',value:'Spanish'},{id:'fr_FR',value:'French (France)'},{id:'fr_BE',value:'French (Belgium)'},{id:'nl_NL',value:'Dutch (Netherlands)'},{id:'nl_BE',value:'Dutch (Belgium)'},{id:'sv_SE',value:'Swedish'},{id:'it_IT',value:'Italian'},{id:'da_DK',value:'Danish'}];var COUNTRY_CODE={AT:'AT',CH:'CH',DE:'DE',ES:'ES',GB:'GB',FR:'FR',NL:'NL',SE:'SE',BE:'BE',IT:'IT',DK:'DK'};var COUNTRY_CODE_LIST=[{id:COUNTRY_CODE.DE,value:'Germany'},{id:COUNTRY_CODE.AT,value:'Austria'},{id:COUNTRY_CODE.CH,value:'Switzerland'},{id:COUNTRY_CODE.GB,value:'United Kingdom'},{id:COUNTRY_CODE.ES,value:'Spain'},{id:COUNTRY_CODE.FR,value:'France'},{id:COUNTRY_CODE.NL,value:'Netherlands'},{id:COUNTRY_CODE.SE,value:'Sweden'},{id:COUNTRY_CODE.BE,value:'Belgium'},{id:COUNTRY_CODE.IT,value:'Italy'},{id:COUNTRY_CODE.DK,value:'Denmark'}];var WEBSITE_URL_LIST=[{id:COUNTRY_CODE.DE,value:'https://plusdental.de'},{id:COUNTRY_CODE.AT,value:'https://plusdental.at'},{id:COUNTRY_CODE.CH,value:'https://plusdental.ch'},{id:COUNTRY_CODE.GB,value:'https://plusdent.co.uk'},{id:COUNTRY_CODE.ES,value:'https://plus-dental.es'},{id:COUNTRY_CODE.FR,value:'https://plusdental.fr'},{id:COUNTRY_CODE.NL,value:'https://plus-dental.nl'},{id:COUNTRY_CODE.SE,value:'https://plusdental.se'}];

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findCustomerRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return findCustomerSuccess; });
/* unused harmony export findCustomerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hydrateCustomerContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return findCustomer; });
/* unused harmony export _changeActiveTab */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeActiveTab; });
/* unused harmony export uploadCustomerImageRequest */
/* unused harmony export uploadCustomerImageError */
/* unused harmony export uploadCustomerImageSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return uploadCustomerImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return toggleImageView; });
/* unused harmony export fixAccountProblemRequest */
/* unused harmony export fixAccountProblemSuccess */
/* unused harmony export fixAccountProblemError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fixAccountProblem; });
/* unused harmony export startAlignerReproductionRequest */
/* unused harmony export startAlignerReproductionProcessError */
/* unused harmony export startAlignerReproductionSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return startAlignerReproductionProcess; });
/* unused harmony export startPartialRefundRequest */
/* unused harmony export startPartialRefundProcessError */
/* unused harmony export startPartialRefundSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return startPartialRefundProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return closeResponseFeedbackModal; });
/* unused harmony export startDownloadCustomerDataError */
/* unused harmony export startDownloadCustomerDataSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return startDownloadCustomerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return openDeleteConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return closeDeleteConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return showError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleDeleteConfirmationModal; });
/* unused harmony export deleteCustomerSuccess */
/* unused harmony export deleteCustomerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteCustomer; });
/* unused harmony export startEscalationProcessRequest */
/* unused harmony export startEscalationProcessError */
/* unused harmony export startEscalationProcessSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return startEscalationProcess; });
/* unused harmony export startRefinementSetProcessRequest */
/* unused harmony export startRefinementSetProcessError */
/* unused harmony export startRefinementSetProcessSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return startRefinementSetProcess; });
/* unused harmony export startRefinementShopProcessRequest */
/* unused harmony export startRefinementShopProcessError */
/* unused harmony export startRefinementShopProcessSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return startRefinementShopProcess; });
/* unused harmony export startRetainerRefinementProcessRequest */
/* unused harmony export startRetainerRefinementProcessError */
/* unused harmony export startRetainerRefinementProcessSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return startRetainerRefinementProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeCustomerContact; });
/* unused harmony export saveCustomerRequest */
/* unused harmony export saveCustomerSuccess */
/* unused harmony export saveCustomerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reassignPhysician; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reassignStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return saveCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return saveCustomerContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addCustomerFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return onFileDeleteFlagSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return openChangeEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return closeChangeEmailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return changeNewEmail; });
/* unused harmony export changeEmailRequest */
/* unused harmony export changeEmailSuccess */
/* unused harmony export changeEmailError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeEmail; });
/* unused harmony export findProcessCommentRequest */
/* unused harmony export findProcessCommentSuccess */
/* unused harmony export findProcessCommentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return findProcessComment; });
/* unused harmony export saveTreatmentExecutionClarificationCommentRequest */
/* unused harmony export saveTreatmentExecutionClarificationCommentSuccess */
/* unused harmony export saveTreatmentExecutionClarificationCommentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return saveTreatmentExecutionClarificationComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeIsTransferredToDrSmile; });
/* unused harmony export updateIsTransferredToDrSmileRequest */
/* unused harmony export updateIsTransferredToDrSmileSuccess */
/* unused harmony export updateIsTransferredToDrSmileError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return updateWhatsappOtpIn; });
/* unused harmony export updateWhatsappOtpInRequest */
/* unused harmony export updateWhatsappOtpInSuccess */
/* unused harmony export updateWhatsappOtpInError */
/* unused harmony export updateWhatsappOtpInNonValidValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_state_instance_detail_enrich_process_instance__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__const__ = __webpack_require__(40);
var _TAB_PATH_MAPPING,_TAB_TRANSFORMER_MAPP;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var findCustomerRequest=function findCustomerRequest(customerId){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["p" /* FIND_CUSTOMER_REQUEST */],payload:{customerId:customerId}};};var findCustomerSuccess=function findCustomerSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["q" /* FIND_CUSTOMER_SUCCESS */],payload:{customer:customer}};};var findCustomerError=function findCustomerError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["n" /* FIND_CUSTOMER_ERROR */],payload:{error:error}};};var hydrateCustomerContact=function hydrateCustomerContact(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["y" /* HYDRATE_CUSTOMER_CONTACT */]};};var enrichFile=function enrichFile(state,file){file.createdByUser=__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId);};var enrichCustomer=function enrichCustomer(state,customer){__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(file){enrichFile(state,file);},customer.scanFileList);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(file){enrichFile(state,file);},customer.implantScanFileList);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(file){enrichFile(state,file);},customer.treatmentPlanFileList);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(file){enrichFile(state,file);},customer.productionFileList);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(file){enrichFile(state,file);},customer.imageList);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(file){enrichFile(state,file);},customer.treatmentPlanPDFList);};var findCustomer=function findCustomer(customerId){return function(dispatch,getState){dispatch(findCustomerRequest(customerId));Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/customer/find-customer-basic-data?customerId='+customerId).then(function(customer){enrichCustomer(getState(),customer);dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__treatment_state_quotation_action__["c" /* customerLoaded */])(customer));dispatch(findCustomerSuccess(customer));}).catch(function(error){dispatch(findCustomerError(error));});};};var _changeActiveTab=function _changeActiveTab(tab){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["b" /* CHANGE_ACTIVE_TAB */],payload:{tab:tab}};};var TAB_PATH_MAPPING=(_TAB_PATH_MAPPING={},_defineProperty(_TAB_PATH_MAPPING,__WEBPACK_IMPORTED_MODULE_8__const__["h" /* TAB_ACCOUNTING */],'/api/customer/find-customer-accounting-data?customerId='),_defineProperty(_TAB_PATH_MAPPING,__WEBPACK_IMPORTED_MODULE_8__const__["k" /* TAB_FILES */],'/api/customer/find-customer-file-data?customerId='),_defineProperty(_TAB_PATH_MAPPING,__WEBPACK_IMPORTED_MODULE_8__const__["l" /* TAB_MEDICAL */],'/api/customer/find-customer-medical-data?customerId='),_TAB_PATH_MAPPING);var TAB_TRANSFORMER_MAPPING=(_TAB_TRANSFORMER_MAPP={},_defineProperty(_TAB_TRANSFORMER_MAPP,__WEBPACK_IMPORTED_MODULE_8__const__["h" /* TAB_ACCOUNTING */],function(customer,state){return{invoiceList:customer.invoiceList,paymentList:customer.paymentList};}),_defineProperty(_TAB_TRANSFORMER_MAPP,__WEBPACK_IMPORTED_MODULE_8__const__["l" /* TAB_MEDICAL */],function(customer,state){return{treatmentPlanList:customer.treatmentPlanList,treatmentExecutionList:customer.treatmentExecutionList};}),_defineProperty(_TAB_TRANSFORMER_MAPP,__WEBPACK_IMPORTED_MODULE_8__const__["k" /* TAB_FILES */],function(customer,state){return{scanFileList:customer.scanFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),implantScanFileList:customer.implantScanFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),xRayFileList:customer.xRayFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),cbctFileList:customer.cbctFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),treatmentPlanFileList:customer.treatmentPlanFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),treatmentPlanExternalFileList:customer.treatmentPlanExternalFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),productionFileList:customer.productionFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),conformityDeclarationList:customer.conformityDeclarationList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),customsInvoiceList:customer.customsInvoiceList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),otherFileList:customer.otherFileList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});}),treatmentPlanPDFList:customer.treatmentPlanPDFList.map(function(file){return Object.assign({},file,{createdByUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId)});})};}),_TAB_TRANSFORMER_MAPP);var findCustomerPartialRequest=function findCustomerPartialRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["o" /* FIND_CUSTOMER_PARTIAL_REQUEST */]};};var changeActiveTab=function changeActiveTab(tab){return function(dispatch,getState){dispatch(_changeActiveTab(tab));var path=TAB_PATH_MAPPING[tab];var transformer=TAB_TRANSFORMER_MAPPING[tab];if(!path||!transformer){return;}dispatch(findCustomerPartialRequest());var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])(path+customerId).then(function(customer){var _customer=transformer(customer,getState());dispatch(findCustomerSuccess(_customer));}).catch(function(error){dispatch(findCustomerError(error));});};};var uploadCustomerImageRequest=function uploadCustomerImageRequest(fileName){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_12" /* UPLOAD_CUSTOMER_IMAGE_REQUEST */],payload:{fileName:fileName}};};var uploadCustomerImageError=function uploadCustomerImageError(error,fileName){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_11" /* UPLOAD_CUSTOMER_IMAGE_ERROR */],payload:{error:error,fileName:fileName}};};var uploadCustomerImageSuccess=function uploadCustomerImageSuccess(file){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_13" /* UPLOAD_CUSTOMER_IMAGE_SUCCESS */],payload:{file:file}};};var uploadCustomerImage=function uploadCustomerImage(fileList,fileName){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);if(!customerId){return;}dispatch(uploadCustomerImageRequest(fileName));var data=new FormData();data.append('file',fileList[0]);fetch(__WEBPACK_IMPORTED_MODULE_1__util_api__["a" /* BACKEND_URL */]+'/api/customer/image-upload-for-customer?customerId='+customerId+'&fileName='+fileName,{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(file){dispatch(uploadCustomerImageSuccess(file));}).catch(function(error){dispatch(uploadCustomerImageError(error,fileName));});};};var toggleImageView=function toggleImageView(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_3" /* TOGGLE_IMAGE_VIEW */]};};var fixAccountProblemRequest=function fixAccountProblemRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["v" /* FIX_ACCOUNT_PROBLEM_REQUEST */]};};var fixAccountProblemSuccess=function fixAccountProblemSuccess(accountFix){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["w" /* FIX_ACCOUNT_PROBLEM_SUCCESS */],payload:{accountFix:accountFix}};};var fixAccountProblemError=function fixAccountProblemError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["u" /* FIX_ACCOUNT_PROBLEM_ERROR */],payload:{error:error}};};var fixAccountProblem=function fixAccountProblem(){return function(dispatch,getState){var state=getState();var customer=__WEBPACK_IMPORTED_MODULE_3__selector__["c" /* selectCustomer */](state);dispatch(fixAccountProblemRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/customer/fix-account-problem?email='+encodeURIComponent(customer.email)).then(function(_ref){var fix=_ref.fix;dispatch(fixAccountProblemSuccess(fix));}).catch(function(error){dispatch(fixAccountProblemError(error));});};};var startAlignerReproductionRequest=function startAlignerReproductionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["K" /* START_ALIGNER_REPRODUCTION_PROCESS_REQUEST */]};};var startAlignerReproductionProcessError=function startAlignerReproductionProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["J" /* START_ALIGNER_REPRODUCTION_PROCESS_ERROR */],payload:{error:error}};};var startAlignerReproductionSuccess=function startAlignerReproductionSuccess(processInstance){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["L" /* START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS */],payload:{processInstance:processInstance}};};var startAlignerReproductionProcess=function startAlignerReproductionProcess(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);dispatch(startAlignerReproductionRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/sales-order/start-aligner-reproduction?customerId='+customerId).then(function(processInstance){var taskList=processInstance.processTaskList;if(taskList.length===1){var taskId=taskList[0].id;dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_connected_react_router__["d" /* push */])('/task/detail/'+taskId));}dispatch(startAlignerReproductionSuccess(processInstance));}).catch(function(error){dispatch(startAlignerReproductionProcessError(error));});};};var startPartialRefundRequest=function startPartialRefundRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["S" /* START_PARTIAL_REFUND_PROCESS_REQUEST */]};};var startPartialRefundProcessError=function startPartialRefundProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["R" /* START_PARTIAL_REFUND_PROCESS_ERROR */],payload:{error:error}};};var startPartialRefundSuccess=function startPartialRefundSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["T" /* START_PARTIAL_REFUND_PROCESS_SUCCESS */],payload:{customer:customer}};};var startPartialRefundProcess=function startPartialRefundProcess(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);dispatch(startPartialRefundRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/sales-order/start-partial-refund-process?customerId='+customerId).then(function(customer){dispatch(startPartialRefundSuccess(customer));}).catch(function(error){dispatch(startPartialRefundProcessError(error));});};};var closeResponseFeedbackModal=function closeResponseFeedbackModal(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["k" /* CLOSE_RESPONSE_FEEDBACK_MODAL */]};};var startDownloadCustomerDataError=function startDownloadCustomerDataError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["M" /* START_DOWNLOAD_CUSTOMER_DATA_ERROR */],payload:{error:error}};};var startDownloadCustomerDataSuccess=function startDownloadCustomerDataSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["N" /* START_DOWNLOAD_CUSTOMER_DATA_SUCCESS */]};};var startDownloadCustomerData=function startDownloadCustomerData(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/security/customer-data-export?customerId='+customerId).then(function(){dispatch(startDownloadCustomerDataSuccess());}).catch(function(error){dispatch(startDownloadCustomerDataError(error));});};};var openDeleteConfirmationModal=function openDeleteConfirmationModal(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["A" /* OPEN_DELETE_CONFIRMATION_MODAL */]};};var closeDeleteConfirmationModal=function closeDeleteConfirmationModal(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["j" /* CLOSE_DELETE_CONFIRMATION_MODAL */]};};var showError=function showError(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["I" /* SHOW_ERROR_CONFIRMATION_MODAL */]};};var handleDeleteConfirmationModal=function handleDeleteConfirmationModal(value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["x" /* HANDLE_DELETE_CONFIRMATION_MODAL */],payload:{value:value}};};var deleteCustomerSuccess=function deleteCustomerSuccess(response){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["m" /* DELETE_CUSTOMER_SUCCESS */],payload:{response:response}};};var deleteCustomerError=function deleteCustomerError(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["l" /* DELETE_CUSTOMER_ERROR */]};};var deleteCustomer=function deleteCustomer(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);dispatch(closeDeleteConfirmationModal());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/customer/delete-customer-data?customerId='+customerId).then(function(response){dispatch(deleteCustomerSuccess(response));}).catch(function(){dispatch(deleteCustomerError());});};};var startEscalationProcessRequest=function startEscalationProcessRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["P" /* START_ESCALATION_PROCESS_REQUEST */]};};var startEscalationProcessError=function startEscalationProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["O" /* START_ESCALATION_PROCESS_ERROR */],payload:{error:error}};};var startEscalationProcessSuccess=function startEscalationProcessSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["Q" /* START_ESCALATION_PROCESS_SUCCESS */],payload:{customer:customer}};};var startEscalationProcess=function startEscalationProcess(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);if(!customerId){return;}dispatch(startEscalationProcessRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/sales-order/start-escalation-process?customerId='+customerId).then(function(customer){dispatch(startEscalationProcessSuccess(customer));}).catch(function(error){dispatch(startEscalationProcessError(error));});};};var startRefinementSetProcessRequest=function startRefinementSetProcessRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["V" /* START_REFINEMENT_SET_PROCESS_REQUEST */]};};var startRefinementSetProcessError=function startRefinementSetProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["U" /* START_REFINEMENT_SET_PROCESS_ERROR */],payload:{error:error}};};var startRefinementSetProcessSuccess=function startRefinementSetProcessSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["W" /* START_REFINEMENT_SET_PROCESS_SUCCESS */],payload:{customer:customer}};};var startRefinementSetProcess=function startRefinementSetProcess(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);dispatch(startRefinementSetProcessRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/sales-order/start-refinement-set-process?customerId='+customerId).then(function(customer){dispatch(startRefinementSetProcessSuccess(customer));}).catch(function(error){dispatch(startRefinementSetProcessError(error));});};};var startRefinementShopProcessRequest=function startRefinementShopProcessRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["Y" /* START_REFINEMENT_SHOP_PROCESS_REQUEST */]};};var startRefinementShopProcessError=function startRefinementShopProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["X" /* START_REFINEMENT_SHOP_PROCESS_ERROR */],payload:{error:error}};};var startRefinementShopProcessSuccess=function startRefinementShopProcessSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["Z" /* START_REFINEMENT_SHOP_PROCESS_SUCCESS */],payload:{customer:customer}};};var startRefinementShopProcess=function startRefinementShopProcess(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);dispatch(startRefinementShopProcessRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/sales-order/start-refinement-shop-process?customerId='+customerId).then(function(customer){dispatch(startRefinementShopProcessSuccess(customer));}).catch(function(error){dispatch(startRefinementShopProcessError(error));});};};var startRetainerRefinementProcessRequest=function startRetainerRefinementProcessRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_1" /* START_RETAINER_REFINEMENT_PROCESS_REQUEST */]};};var startRetainerRefinementProcessError=function startRetainerRefinementProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_0" /* START_RETAINER_REFINEMENT_PROCESS_ERROR */],payload:{error:error}};};var startRetainerRefinementProcessSuccess=function startRetainerRefinementProcessSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_2" /* START_RETAINER_REFINEMENT_PROCESS_SUCCESS */],payload:{customer:customer}};};var startRetainerRefinementProcess=function startRetainerRefinementProcess(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);dispatch(startRetainerRefinementProcessRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/sales-order/start-retainer-refinement-process?customerId='+customerId).then(function(customer){dispatch(startRetainerRefinementProcessSuccess(customer));}).catch(function(error){dispatch(startRetainerRefinementProcessError(error));});};};var changeCustomer=function changeCustomer(name,value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* CHANGE_CUSTOMER */],payload:{name:name,value:value}};};var changeCustomerContact=function changeCustomerContact(name,value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["d" /* CHANGE_CUSTOMER_CONTACT */],payload:{name:name,value:value}};};var saveCustomerRequest=function saveCustomerRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["C" /* SAVE_CUSTOMER_REQUEST */]};};var saveCustomerSuccess=function saveCustomerSuccess(customer){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["D" /* SAVE_CUSTOMER_SUCCESS */],payload:{customer:customer}};};var saveCustomerError=function saveCustomerError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["B" /* SAVE_CUSTOMER_ERROR */],payload:{error:error}};};var reassignPhysician=function reassignPhysician(physicianId,physicianType){return function(dispatch,getState){var state=getState();var _selector$selectCusto=__WEBPACK_IMPORTED_MODULE_3__selector__["c" /* selectCustomer */](state),referenceNumber=_selector$selectCusto.referenceNumber,id=_selector$selectCusto.id;var payload={physicianId:physicianId,physicianType:physicianType,customerReference:referenceNumber};Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/reassign-physician',payload).then(function(){dispatch(findCustomer(id));}).catch(function(error){dispatch(findCustomer(id));});};};var reassignStore=function reassignStore(storeId,customerId){return function(dispatch){var payload={customerId:customerId,storeId:storeId};Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/reassign-store',payload).then(function(){dispatch(findCustomer(customerId));}).catch(function(error){dispatch(findCustomer(customerId));});};};var saveCustomer=function saveCustomer(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_3__selector__["i" /* selectHasChanged */](state);if(!hasChanged){return;}dispatch(saveCustomerRequest());var customer=__WEBPACK_IMPORTED_MODULE_3__selector__["c" /* selectCustomer */](state);Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/save',customer).then(function(customer){dispatch(saveCustomerSuccess(customer));}).catch(function(error){dispatch(saveCustomerError(error));});};};var saveCustomerContact=function saveCustomerContact(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_3__selector__["i" /* selectHasChanged */](state);if(!hasChanged){return;}dispatch(saveCustomerRequest());var contact=__WEBPACK_IMPORTED_MODULE_3__selector__["d" /* selectCustomerContact */](state);Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/save-contact',contact).then(function(customer){dispatch(saveCustomerSuccess(customer));}).catch(function(error){dispatch(saveCustomerError(error));}).finally(function(){dispatch(hydrateCustomerContact());});};};var addCustomerFile=function addCustomerFile(fileType,file){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["a" /* ADD_CUSTOMER_FILE */],payload:{fileType:fileType,file:file}};};var onFileDeleteFlagSuccess=function onFileDeleteFlagSuccess(fileType,fileId){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["H" /* SET_FILE_DELETE_FLAG */],payload:{fileType:fileType,fileId:fileId}};};var openChangeEmailModal=function openChangeEmailModal(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["z" /* OPEN_CHANGE_EMAIL_MODAL */]};};var closeChangeEmailModal=function closeChangeEmailModal(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* CLOSE_CHANGE_EMAIL_MODAL */]};};var changeNewEmail=function changeNewEmail(name,value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["h" /* CHANGE_NEW_EMAIL */],payload:{name:name,value:value}};};var changeEmailRequest=function changeEmailRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["f" /* CHANGE_EMAIL_REQUEST */]};};var changeEmailSuccess=function changeEmailSuccess(email){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["g" /* CHANGE_EMAIL_SUCCESS */],payload:{email:email}};};var changeEmailError=function changeEmailError(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["e" /* CHANGE_EMAIL_ERROR */]};};var changeEmail=function changeEmail(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);var _selector$selectChang=__WEBPACK_IMPORTED_MODULE_3__selector__["b" /* selectChangeEmailData */](state),newEmail=_selector$selectChang.newEmail;if(!customerId||!newEmail){return;}dispatch(changeEmailRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/change-email',{customerId:customerId,email:newEmail}).then(function(response){dispatch(changeEmailSuccess(newEmail));}).catch(function(error){dispatch(changeEmailError());});};};var findProcessCommentRequest=function findProcessCommentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["s" /* FIND_PROCESS_COMMENT_REQUEST */]};};var findProcessCommentSuccess=function findProcessCommentSuccess(processList){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["t" /* FIND_PROCESS_COMMENT_SUCCESS */],payload:{processList:processList}};};var findProcessCommentError=function findProcessCommentError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["r" /* FIND_PROCESS_COMMENT_ERROR */],payload:{error:error}};};var findProcessComment=function findProcessComment(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectCustomerId */](state);if(!customerId){return;}dispatch(findProcessCommentRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/customer/find-process-comment?customerId='+customerId).then(function(processList){var state=getState();for(var index=0;index<processList.length;index++){var process=processList[index];Object(__WEBPACK_IMPORTED_MODULE_6__process_state_instance_detail_enrich_process_instance__["b" /* enrichCommentList */])(state,process);}dispatch(findProcessCommentSuccess(processList));}).catch(function(error){dispatch(findProcessCommentError(error));});};};var saveTreatmentExecutionClarificationCommentRequest=function saveTreatmentExecutionClarificationCommentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["F" /* SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST */]};};var saveTreatmentExecutionClarificationCommentSuccess=function saveTreatmentExecutionClarificationCommentSuccess(treatmentExecutionList){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["G" /* SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS */],payload:{treatmentExecutionList:treatmentExecutionList}};};var saveTreatmentExecutionClarificationCommentError=function saveTreatmentExecutionClarificationCommentError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["E" /* SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR */],payload:{error:error}};};var saveTreatmentExecutionClarificationComment=function saveTreatmentExecutionClarificationComment(comment){return function(dispatch,getState){var state=getState();var customer=__WEBPACK_IMPORTED_MODULE_3__selector__["c" /* selectCustomer */](state);var body={customerId:customer.id,clarificationComment:comment};dispatch(saveTreatmentExecutionClarificationCommentRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/treatment/execution/add-clarification-comment',body).then(function(treatmentExecutionList){dispatch(saveTreatmentExecutionClarificationCommentSuccess(treatmentExecutionList));}).catch(function(error){dispatch(saveTreatmentExecutionClarificationCommentError(error));});};};var changeIsTransferredToDrSmile=function changeIsTransferredToDrSmile(val){return function(dispatch,getState){var state=getState();var customer=__WEBPACK_IMPORTED_MODULE_3__selector__["c" /* selectCustomer */](state);var body={customerId:customer.id,drSmileTransfer:val};dispatch(updateIsTransferredToDrSmileRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/transferred-to-dr-smile',body).then(function(){dispatch(updateIsTransferredToDrSmileSuccess(val));}).catch(function(error){dispatch(updateIsTransferredToDrSmileError());});};};var updateIsTransferredToDrSmileRequest=function updateIsTransferredToDrSmileRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_5" /* UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST */]};};var updateIsTransferredToDrSmileSuccess=function updateIsTransferredToDrSmileSuccess(value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_6" /* UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS */],payload:{value:value}};};var updateIsTransferredToDrSmileError=function updateIsTransferredToDrSmileError(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_4" /* UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR */]};};var updateWhatsappOtpIn=function updateWhatsappOtpIn(val){return function(dispatch,getState){if(val==='null'){dispatch(updateWhatsappOtpInNonValidValue());return;}var state=getState();var customer=__WEBPACK_IMPORTED_MODULE_3__selector__["c" /* selectCustomer */](state);var valueMap=function valueMap(val){return val==='true'?'1':'0';};var body={customerId:customer.id,whatsAppOptIn:valueMap(val)};dispatch(updateWhatsappOtpInRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/update-whatsapp-opt-in',body).then(function(response){dispatch(updateWhatsappOtpInSuccess(val));}).catch(function(error){dispatch(updateWhatsappOtpInError());});};};var updateWhatsappOtpInRequest=function updateWhatsappOtpInRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_9" /* UPDATE_WHATSAPP_OPT_IN_REQUEST */]};};var updateWhatsappOtpInSuccess=function updateWhatsappOtpInSuccess(value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_10" /* UPDATE_WHATSAPP_OPT_IN_SUCCESS */],payload:{value:value}};};var updateWhatsappOtpInError=function updateWhatsappOtpInError(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_7" /* UPDATE_WHATSAPP_OPT_IN_ERROR */]};};var updateWhatsappOtpInNonValidValue=function updateWhatsappOtpInNonValidValue(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["_8" /* UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE */]};};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectTreatmentPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectHasChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAlignerLabelList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAlignerLabelListReproduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectAlignerLabelListProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectAlignersPerStepList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quotation_const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__ = __webpack_require__(54);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]];};var selectTreatmentPlan=function selectTreatmentPlan(state){return selectOwnState(state).treatmentPlan;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectAlignerLabelList=function selectAlignerLabelList(state,salesOrder){if(!salesOrder){return[];}if(salesOrder.type==='retainer'||salesOrder.type==='retainer-new'){return[{upper:'-R-U',lower:'-R-L'}];}if(salesOrder.type==='retainer-refinement'){return[{upper:'-RR-U',lower:'-RR-L'}];}if(salesOrder.type==='retainer-refinement-new'){return[{upper:'-RR-U',lower:'-RR-L'}];}var treatmentPlan=selectTreatmentPlan(state);if(!treatmentPlan){return[];}var numberOfAlignerUpperJaw=treatmentPlan.numberOfAlignerUpperJaw,numberOfAlignerLowerJaw=treatmentPlan.numberOfAlignerLowerJaw;var maxNumber=numberOfAlignerUpperJaw>numberOfAlignerLowerJaw?numberOfAlignerUpperJaw:numberOfAlignerLowerJaw;var alignerLabelList=[];for(var index=1;index<=maxNumber;index++){// let week = ((index % 3) === 0) ? '2W' : '1W';
var step=index<10?'0'+index:index;alignerLabelList.push({upper:index<=numberOfAlignerUpperJaw?'-'+step+'-U':null,lower:index<=numberOfAlignerLowerJaw?'-'+step+'-L':null});}return alignerLabelList;};var selectAlignerLabelListReproduction=function selectAlignerLabelListReproduction(state){var salesOrder=Object(__WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__["f" /* selectSalesOrder */])(state);var customer=salesOrder.customer;var salesOrderList=customer.salesOrderList;var isProductionSalesOrder=function isProductionSalesOrder(type){return type==='retainer'||type==='retainer-new'||type==='treatment'||type==='refinement-production';};return salesOrderList.filter(function(salesOrder){return isProductionSalesOrder(salesOrder.type);}).map(function(currentSalesOrder){return{salesOrderType:currentSalesOrder.type,salesOrderReference:currentSalesOrder.referenceNumber,labelList:selectAlignerLabelList(state,currentSalesOrder)};});};var selectAlignerLabelListProduction=function selectAlignerLabelListProduction(state){var salesOrder=Object(__WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__["f" /* selectSalesOrder */])(state);var alignerLabeList=[];var alignerLabel={salesOrderType:salesOrder.type,salesOrderReference:salesOrder.referenceNumber,labelList:selectAlignerLabelList(state,salesOrder)};alignerLabeList.push(alignerLabel);return alignerLabeList;};var selectAlignersPerStepList=function selectAlignersPerStepList(){return __WEBPACK_IMPORTED_MODULE_1__quotation_const__["a" /* ALIGNER_SYSTEM_ALIGNERS_PER_STEP */];};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ValidationMessageList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var ValidationMessage=function ValidationMessage(_ref){var message=_ref.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-error'},message);};var ValidationMessageList=function ValidationMessageList(_ref2){var validationMessageList=_ref2.validationMessageList;if(!validationMessageList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,validationMessageList.map(function(message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValidationMessage,{key:message.messageId,message:message.message});}));};ValidationMessageList.propTypes={validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (ValidationMessageList);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENTER_DOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MEDICAL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RESCAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REFINEMENT_MEDICAL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MEDICAL_CHECK_WITH_PRETREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MEDICAL_ASSESSMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONFIRM_MEDICAL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONFIRM_REFINEMENT_MEDICAL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIRM_MEDICAL_ASSESSMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SELECT_REFINEMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return VALIDATE_PRETREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SCAN_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TAKE_PICTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPLOAD_SCANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPLOAD_SCAN_FILES_MANUALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONSULT_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MATCH_3SHAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IPR_CLEARING_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IPR_EXPLANATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MANUAL_ADDRESS_CHECK; });
/* unused harmony export LOW_NPS_REASON */
var ENTER_DOB='enter_dob';var MEDICAL_CHECK='medical_check';var RESCAN='rescan';var REFINEMENT_MEDICAL_CHECK='refinement_medical_check';var MEDICAL_CHECK_WITH_PRETREATMENT='medical_check_with_pretreatment';var MEDICAL_ASSESSMENT='medical_assessment';var CONFIRM_MEDICAL_CHECK='confirm_medical_check';var CONFIRM_REFINEMENT_MEDICAL_CHECK='confirm_refinement_medical_check';var CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT='confirm_medical_check_with_pretreatment';var CONFIRM_MEDICAL_ASSESSMENT='confirm_medical_assessment';var SELECT_REFINEMENT_TYPE='select_refinement_type';var VALIDATE_PRETREATMENT='validate_pretreatment';var SCAN_CUSTOMER='scan_customer';var TAKE_PICTURES='take_pictures';var UPLOAD_SCANS='upload_scans';var UPLOAD_SCAN_FILES_MANUALLY='upload_scan_files_manually';var CONSULT_CUSTOMER='consult_customer';var MATCH_3SHAPE='match_3shape';var IPR_CLEARING_UP='ipr_clearing_up';var IPR_EXPLANATION='ipr_explanation';var MANUAL_ADDRESS_CHECK='manual_address_check';var LOW_NPS_REASON='low_nps_reason';

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var NO_AUTOCORRECT={autoComplete:'off',autoCorrect:'off',spellCheck:'false'};var Input=function Input(_ref){var _onChange=_ref.onChange,name=_ref.name,object=_ref.object,validation=_ref.validation,placeholder=_ref.placeholder,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className,_ref$type=_ref.type,type=_ref$type===undefined?'text':_ref$type,_ref$onBlur=_ref.onBlur,onBlur=_ref$onBlur===undefined?function(){}:_ref$onBlur,onEnter=_ref.onEnter,_ref$autoCapitalize=_ref.autoCapitalize,autoCapitalize=_ref$autoCapitalize===undefined?'words':_ref$autoCapitalize,_ref$autoCorrect=_ref.autoCorrect,autoCorrect=_ref$autoCorrect===undefined?false:_ref$autoCorrect,_ref$readOnly=_ref.readOnly,readOnly=_ref$readOnly===undefined?false:_ref$readOnly,_ref$isMoney=_ref.isMoney,isMoney=_ref$isMoney===undefined?false:_ref$isMoney,_ref$max=_ref.max,max=_ref$max===undefined?null:_ref$max,_ref$min=_ref.min,min=_ref$min===undefined?null:_ref$min,_ref$step=_ref.step,step=_ref$step===undefined?null:_ref$step,_ref$pattern=_ref.pattern,pattern=_ref$pattern===undefined?'.*':_ref$pattern,_ref$filterValue=_ref.filterValue,filterValue=_ref$filterValue===undefined?function(value){return value;}:_ref$filterValue;className=validation&&validation[name]?'form-control error '+className:'form-control '+className;var autoCorrectAttributes=autoCorrect?{}:NO_AUTOCORRECT;var value=isMoney&&object[name]?(object[name]/100).toString().replace('.',','):object[name];if(value===0){value='0';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({className:className,type:type,placeholder:placeholder,value:value||'',name:name,onBlur:onBlur},autoCorrectAttributes,{autoCapitalize:autoCapitalize,onKeyPress:function onKeyPress(event){if(onEnter&&event.key==='Enter'){onEnter();}},max:max,min:min,step:step,pattern:pattern,readOnly:readOnly,onChange:function onChange(event){if(readOnly){return;}if(isMoney){var _value=event.target.value?parseFloat(event.target.value)*100:null;_onChange(name,_value);return;}if(filterValue){event.target.value=filterValue(event.target.value);}_onChange(name,event.target.value);}}));};Input.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,object:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,validation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,autoCapitalize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,autoCorrect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMoney:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,max:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pattern:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectOwnState", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalutationList", function() { return selectSalutationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectLeadStatusList", function() { return selectLeadStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectProcessStateNameList", function() { return selectProcessStateNameList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectProcessNameList", function() { return selectProcessNameList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectLeadStatusById", function() { return selectLeadStatusById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectLeadStatusValueById", function() { return selectLeadStatusValueById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalesOrderTreatmentStatusList", function() { return selectSalesOrderTreatmentStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalesOrderTreatmentStatusById", function() { return selectSalesOrderTreatmentStatusById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalesOrderTreatmentStatusValueById", function() { return selectSalesOrderTreatmentStatusValueById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalesOrderStatusList", function() { return selectSalesOrderStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalesOrderStatusById", function() { return selectSalesOrderStatusById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSalesOrderStatusValueById", function() { return selectSalesOrderStatusValueById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUser", function() { return selectUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserViewPreferences", function() { return selectUserViewPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserId", function() { return selectUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserList", function() { return selectUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectTreatingPhysicianList", function() { return selectTreatingPhysicianList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserWithRoleList", function() { return selectUserWithRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserById", function() { return selectUserById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserDisplayNameById", function() { return selectUserDisplayNameById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectEmployeeList", function() { return selectEmployeeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectEmployeeById", function() { return selectEmployeeById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectEmployeeNameById", function() { return selectEmployeeNameById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectTreatmentRateDefault", function() { return selectTreatmentRateDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectTreatmentPriceDefault", function() { return selectTreatmentPriceDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPartnerList", function() { return selectPartnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPartnerById", function() { return selectPartnerById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPartnerDisplayNameById", function() { return selectPartnerDisplayNameById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPartnerTechnicalNameById", function() { return selectPartnerTechnicalNameById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPhysicianList", function() { return selectPhysicianList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSupplierDisplayNameWhiteList", function() { return selectSupplierDisplayNameWhiteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSupplierDisplayNameDefault", function() { return selectSupplierDisplayNameDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSupplierDefaultId", function() { return selectSupplierDefaultId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectSupplierList", function() { return selectSupplierList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectTreatmentPlanerList", function() { return selectTreatmentPlanerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectRoleTaskMapping", function() { return selectRoleTaskMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectCommonConfiguration", function() { return selectCommonConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectBackendUrl", function() { return selectBackendUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectFrontendUrl", function() { return selectFrontendUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectDeviceList", function() { return selectDeviceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectStoreList", function() { return selectStoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectStoreByTechnicalName", function() { return selectStoreByTechnicalName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIPRProviderStore", function() { return isIPRProviderStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAttachmentProviderStore", function() { return isAttachmentProviderStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_sort__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_const__ = __webpack_require__(28);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectSalutationList=function selectSalutationList(state){return selectOwnState(state).salutationList;};var selectLeadStatusList=function selectLeadStatusList(state){return selectOwnState(state).leadStatusList;};var selectProcessStateNameList=function selectProcessStateNameList(state){return selectOwnState(state).processStateNameList;};var selectProcessNameList=function selectProcessNameList(state){return Object.keys(selectOwnState(state).processStateNameList);};var selectLeadStatusById=function selectLeadStatusById(state,statusId){var statusList=selectLeadStatusList(state);return __WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('id',statusId))(statusList);};var selectLeadStatusValueById=function selectLeadStatusValueById(state,statusId){var status=selectLeadStatusById(state,statusId);return status?status.value:null;};var selectSalesOrderTreatmentStatusList=function selectSalesOrderTreatmentStatusList(state){return selectOwnState(state).salesOrderTreatmentStatusList;};var selectSalesOrderTreatmentStatusById=function selectSalesOrderTreatmentStatusById(state,statusId){var statusList=selectSalesOrderTreatmentStatusList(state);return statusList?__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('id',statusId))(statusList):null;};var selectSalesOrderTreatmentStatusValueById=function selectSalesOrderTreatmentStatusValueById(state,statusId){var status=selectSalesOrderTreatmentStatusById(state,statusId);return status?status.value:null;};var selectSalesOrderStatusList=function selectSalesOrderStatusList(state){return selectOwnState(state).salesOrderStatusList;};var selectSalesOrderStatusById=function selectSalesOrderStatusById(state,statusId){var statusList=selectSalesOrderStatusList(state);return statusList?__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('id',statusId))(statusList):null;};var selectSalesOrderStatusValueById=function selectSalesOrderStatusValueById(state,statusId){var status=selectSalesOrderStatusById(state,statusId);return status?status.value:null;};var selectUser=function selectUser(state){return selectOwnState(state).user;};var selectUserViewPreferences=function selectUserViewPreferences(state){var _selectUser=selectUser(state),viewPreferences=_selectUser.viewPreferences;return viewPreferences||{};};var selectUserId=function selectUserId(state){var _selectUser2=selectUser(state),id=_selectUser2.id;return id;};var selectUserList=function selectUserList(state){return selectOwnState(state).userList;};var selectTreatingPhysicianList=function selectTreatingPhysicianList(state){var userList=selectUserList(state);return userList.filter(function(_ref){var roleList=_ref.roleList;return roleList.indexOf(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_const__["M" /* ROLE_TREATING_PHYSICIAN */])!==-1;});};var selectUserWithRoleList=function selectUserWithRoleList(state,requiredRoleList){var userList=selectUserList(state);return userList.filter(function(_ref2){var roleList=_ref2.roleList;for(var index=0;index<requiredRoleList.length;index++){var requiredRole=requiredRoleList[index];if(roleList.indexOf(requiredRole)!==-1){return true;}}return false;});};var selectUserById=function selectUserById(state,userId){var userList=selectUserList(state)||[];return __WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('id',userId))(userList);};var filterRoleList=function filterRoleList(roleList){var filteredList=roleList.filter(function(role){return role!=='reporting'&&role!=='employee'&&role!=='employee.store'&&role!=='employee.office'&&role!=='processAdmin'&&role!=='task_admin'&&role!=='partner';});var renamedRoleList=filteredList.map(function(role){return role.replace(/_/g,' ');});return renamedRoleList.join(',');};var selectUserDisplayNameById=function selectUserDisplayNameById(state,userId){var user=selectUserById(state,userId);if(!user){return'';}if(user.externalUserId){return user.firstName+' '+user.lastName+' (External)';}if(user.firstName&&user.lastName){return user.firstName+' '+user.lastName;}// externals only see roles
return filterRoleList(user.roleList);};var selectEmployeeList=function selectEmployeeList(state){return selectOwnState(state).employeeList;};var selectEmployeeById=function selectEmployeeById(state,employeeId){var employeeList=selectEmployeeList(state)||[];return __WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('id',employeeId))(employeeList);};var selectEmployeeNameById=function selectEmployeeNameById(state,employeeId){var employee=selectEmployeeById(state,employeeId);return employee?employee.firstName:null;};var selectTreatmentRateDefault=function selectTreatmentRateDefault(state){return selectOwnState(state).treatmentRateDefault;};var selectTreatmentPriceDefault=function selectTreatmentPriceDefault(state){return selectOwnState(state).treatmentPriceDefault;};var selectPartnerList=function selectPartnerList(state){var partnerList=selectOwnState(state).partnerList;if(!partnerList){return[];}Object(__WEBPACK_IMPORTED_MODULE_3__util_sort__["a" /* sortByProperty */])(partnerList,'displayName');return partnerList;};var selectPartnerById=function selectPartnerById(state,partnerId){var partnerList=selectPartnerList(state);return partnerList?__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('id',partnerId))(partnerList):null;};var selectPartnerDisplayNameById=function selectPartnerDisplayNameById(state,partnerId){var partner=selectPartnerById(state,partnerId);return partner?partner.displayName:'';};var selectPartnerTechnicalNameById=function selectPartnerTechnicalNameById(state,partnerId){var partner=selectPartnerById(state,partnerId);return partner?partner.technicalName:'';};var selectPhysicianList=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([selectPartnerList],function(partnerList){if(partnerList){return partnerList.filter(function(partner){return partner.isPhysician;});}else{return[];}});var selectSupplierDisplayNameWhiteList=function selectSupplierDisplayNameWhiteList(state){var supplierDisplayNameWhiteList=selectOwnState(state).supplierDisplayNameWhiteList;if(!supplierDisplayNameWhiteList){return[];}return supplierDisplayNameWhiteList;};var selectSupplierDisplayNameDefault=function selectSupplierDisplayNameDefault(state){var supplierDisplayNameDefault=selectOwnState(state).supplierDisplayNameDefault;if(!supplierDisplayNameDefault){return'SunshineSmile';}return supplierDisplayNameDefault;};var selectSupplierDefaultId=function selectSupplierDefaultId(state){var supplierList=selectSupplierList(state);var supplierDisplayNameDefault=selectSupplierDisplayNameDefault(state);var defaultSupplier=supplierList.filter(function(item){return item.displayName===supplierDisplayNameDefault;}).pop();if(!defaultSupplier){return null;}return defaultSupplier.id;};/**
 * Only SunshineSmile and HAT Group are allowed to be saved as supplier
 * @link https://sunshinesmile.atlassian.net/browse/ENG-4150
*/var selectSupplierList=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([selectPartnerList,selectSupplierDisplayNameWhiteList],function(partnerList,supplierDisplayNameWhiteList){if(partnerList){return partnerList.filter(function(partner){return partner.isSupplier&&supplierDisplayNameWhiteList.includes(partner.displayName);});}else{return[];}});var selectTreatmentPlanerList=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([selectPartnerList],function(partnerList){if(partnerList){return partnerList.filter(function(partner){return partner.isTreatmentPlaner;});}else{return[];}});var selectRoleTaskMapping=function selectRoleTaskMapping(state){return selectOwnState(state).roleTaskMapping;};var selectCommonConfiguration=function selectCommonConfiguration(state){return selectOwnState(state).common;};var selectBackendUrl=function selectBackendUrl(state){var commonConfig=selectCommonConfiguration(state);return commonConfig?commonConfig.backendUrl:'';};var selectFrontendUrl=function selectFrontendUrl(state){var commonConfig=selectCommonConfiguration(state);return commonConfig?commonConfig.frontendUrl:'';};var selectDeviceList=function selectDeviceList(state){return selectOwnState(state).sipGateDeviceList;};var selectStoreList=function selectStoreList(state){return selectOwnState(state).storeList;};var selectStoreByTechnicalName=function selectStoreByTechnicalName(state,storeTechnicalName){var storeList=selectStoreList(state);for(var index=0;index<storeList.length;index++){var store=storeList[index];if(store.technicalName===storeTechnicalName){return store;}}return null;};var isIPRProviderStore=function isIPRProviderStore(state,storeTechnicalName){var store=selectStoreByTechnicalName(state,storeTechnicalName);return store?store.iprProvider:false;};var isAttachmentProviderStore=function isAttachmentProviderStore(state,storeTechnicalName){var store=selectStoreByTechnicalName(state,storeTechnicalName);return store?store.attachmentAvailable:false;};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.27.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.27.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(285)(module)))

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(329);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_IMAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SIZE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFINED_IMAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFINED_PRE_CHECKIN_IMAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMAGE_TYPE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRE_CHECKIN_IMAGE_TYPE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TAB_BASIC_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TAB_ACCOUNTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TAB_PHOTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TAB_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TAB_MEDICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TAB_COMMENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img_faceSmiling_jpg__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img_faceSmiling_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__img_faceSmiling_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_face_jpg__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_face_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_face_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_profile_jpg__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_profile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_profile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_leftSide_jpg__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_leftSide_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_leftSide_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_frontal_jpg__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_frontal_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_frontal_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_rightSide_jpg__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_rightSide_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_rightSide_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_upperToothSector_jpg__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_upperToothSector_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_upperToothSector_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_bottomToothSector_jpg__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_bottomToothSector_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_bottomToothSector_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_optionalPhoto_jpg__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_optionalPhoto_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_optionalPhoto_jpg__);
var REDUCER_NAME='detail';var MAX_IMAGE_SIZE=10*1024*1024;var SIZE_LIST=[{id:'S',value:'S'},{id:'M',value:'M'},{id:'L',value:'L'}];var DEFINED_IMAGE_LIST=[{name:'face-smiling',title:'1. Gesichtsaufnahme (lachend) / Face front (smiling)',defaultImage:__WEBPACK_IMPORTED_MODULE_0__img_faceSmiling_jpg___default.a,shortTitle:'Face (Smile)'},{name:'face',title:'2. Gesichtsaufnahme (ohne Lachen) / Face front (not smiling)',defaultImage:__WEBPACK_IMPORTED_MODULE_1__img_face_jpg___default.a,shortTitle:'Face (Not Smiling)'},{name:'profile',title:'3. Gesichtsprofil (ohne Lachen) / Facial profile (not smiling)',defaultImage:__WEBPACK_IMPORTED_MODULE_2__img_profile_jpg___default.a,shortTitle:'Profile'},{name:'right-side',title:'4. Rechte Seitenaufnahme (mit Lippenspreizer) / Right side view (with lip spreader)',defaultImage:__WEBPACK_IMPORTED_MODULE_5__img_rightSide_jpg___default.a,shortTitle:'Right bite'},{name:'frontal',title:'5. Frontalaufnahme (mit Lippenspreizer) / Frontal shot (with lip spreader)',defaultImage:__WEBPACK_IMPORTED_MODULE_4__img_frontal_jpg___default.a,shortTitle:'Front bite'},{name:'left-side',title:'6. Linke Seitenaufnahme (mit Lippenspreizer)/ Left side view (with lip spreader)',defaultImage:__WEBPACK_IMPORTED_MODULE_3__img_leftSide_jpg___default.a,shortTitle:'Left bite'},{name:'upper-tooth-sector',title:'7. Oberer Zahnbogen (mit Lippenspreizer) / Upper dental arch (with lip spreader)',defaultImage:__WEBPACK_IMPORTED_MODULE_6__img_upperToothSector_jpg___default.a,shortTitle:'Upper'},{name:'bottom-tooth-sector',title:'8. Unterer Zahnbogen (mit Lippenspreizer) / Lower dental arch (with lip spreader)',defaultImage:__WEBPACK_IMPORTED_MODULE_7__img_bottomToothSector_jpg___default.a,shortTitle:'Lower'},{name:'lower-row-of-teeth',title:'9. Untere Zahnreihe / Lower row of teeth',shortTitle:'Untere Zahnreihe'},{name:'upper-row-with-aligner',title:'10. Oberer Zahnbogen (mit Zahnschiene) / Upper row (with aligner)',shortTitle:'Oberer Zahnbogen (mit Zahnschiene)'},{name:'lower-row-with-aligner',title:'11. Unterer Zahbogen (mit Zahnschiene) / Lower row (with aligner)',shortTitle:'Unterer Zahbogen (mit Zahnschiene)'},{name:'other',title:'12. Other ',defaultImage:__WEBPACK_IMPORTED_MODULE_8__img_optionalPhoto_jpg___default.a,shortTitle:'Other'}];var DEFINED_PRE_CHECKIN_IMAGE_LIST=[{name:'face-smiling',title:'1. Porträt (lächelnd) / Portrait (smiling)',defaultImage:__WEBPACK_IMPORTED_MODULE_0__img_faceSmiling_jpg___default.a,shortTitle:'Portrait (smiling)'},{name:'face',title:'2. Porträt (nicht lachend) / Portrait (not smiling)',defaultImage:__WEBPACK_IMPORTED_MODULE_1__img_face_jpg___default.a,shortTitle:'Portrait (not smiling)'},{name:'profile',title:'3. Seitliches Profil / Side Profile',defaultImage:__WEBPACK_IMPORTED_MODULE_2__img_profile_jpg___default.a,shortTitle:'Side Profile'},{name:'right-side',title:'4. Rechter Biss / Right Bite',defaultImage:__WEBPACK_IMPORTED_MODULE_5__img_rightSide_jpg___default.a,shortTitle:'Right bite'},{name:'frontal',title:'5. Vorderzähne / Front Teeth',defaultImage:__WEBPACK_IMPORTED_MODULE_4__img_frontal_jpg___default.a,shortTitle:'Front Teeth'},{name:'left-side',title:'6. Linker Biss / Left Bite',defaultImage:__WEBPACK_IMPORTED_MODULE_3__img_leftSide_jpg___default.a,shortTitle:'Left bite'},{name:'upper-tooth-sector',title:'7. Obere Zähne / Upper Teeth',defaultImage:__WEBPACK_IMPORTED_MODULE_6__img_upperToothSector_jpg___default.a,shortTitle:'Upper'},{name:'bottom-tooth-sector',title:'8. Untere Zähne / Lower Teeth',defaultImage:__WEBPACK_IMPORTED_MODULE_7__img_bottomToothSector_jpg___default.a,shortTitle:'Lower'},{name:'upper-row-with-aligner',title:'9. Oberkiefer mit Zahnschiene / Upper Jaw with Aligner',shortTitle:'Upper Jaw with Aligner'},{name:'lower-row-with-aligner',title:'10. Unterkiefer mit Zahnschiene / Lower Jaw with Aligner',shortTitle:'Lower Jaw with Aligner'},{name:'other',title:'11. Andere / Other ',defaultImage:__WEBPACK_IMPORTED_MODULE_8__img_optionalPhoto_jpg___default.a,shortTitle:'Other'}];var IMAGE_TYPE_SELECT=DEFINED_IMAGE_LIST.map(function(image){return{id:image.name,value:image.title};});var PRE_CHECKIN_IMAGE_TYPE_SELECT=DEFINED_PRE_CHECKIN_IMAGE_LIST.map(function(image){return{id:image.name,value:image.title};});var TAB_BASIC_DATA='basic_data';var TAB_ACCOUNTING='accounting';var TAB_PHOTOS='photos';var TAB_FILES='files';var TAB_MEDICAL='medical';var TAB_COMMENTS='comments';

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _dispatchable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isTransformer__ = __webpack_require__(260);



/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArray__["a" /* default */])(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_1__isTransformer__["a" /* default */])(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createInitialTableState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createTableSettingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTableSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createChangeTableSettingAction; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var createInitialTableState=function createInitialTableState(){var initConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var name=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'tableSetting';return _defineProperty({},name,Object.assign({currentPage:0,filterValueList:{},rowsPerPage:20,hiddenColumns:[]},initConfig));};var createTableSettingSelector=function createTableSettingSelector(selectOwnState){var name=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'tableSetting';return function(state){return selectOwnState(state)[name];};};var changeTableSettings=function changeTableSettings(){var propertyName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'tableSetting';return function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,_defineProperty({},propertyName,Object.assign({},state[propertyName],_defineProperty({},name,value))));};};var createChangeTableSettingAction=function createChangeTableSettingAction(type){return function(name,value){return{type:type,payload:{name:name,value:value}};};};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_action__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_selector__ = __webpack_require__(37);
/* harmony default export */ __webpack_exports__["a"] = ({action:{initGlobals:__WEBPACK_IMPORTED_MODULE_0__state_action__["a" /* initGlobals */]},selector:__WEBPACK_IMPORTED_MODULE_1__state_selector__});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__F__ = __webpack_require__(813);
/* unused harmony reexport F */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__T__ = __webpack_require__(814);
/* unused harmony reexport T */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(815);
/* unused harmony reexport __ */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add__ = __webpack_require__(167);
/* unused harmony reexport add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addIndex__ = __webpack_require__(816);
/* unused harmony reexport addIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adjust__ = __webpack_require__(401);
/* unused harmony reexport adjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__all__ = __webpack_require__(817);
/* unused harmony reexport all */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allPass__ = __webpack_require__(819);
/* unused harmony reexport allPass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__always__ = __webpack_require__(116);
/* unused harmony reexport always */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__and__ = __webpack_require__(405);
/* unused harmony reexport and */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__any__ = __webpack_require__(406);
/* unused harmony reexport any */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__anyPass__ = __webpack_require__(821);
/* unused harmony reexport anyPass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ap__ = __webpack_require__(262);
/* unused harmony reexport ap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__aperture__ = __webpack_require__(822);
/* unused harmony reexport aperture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__append__ = __webpack_require__(825);
/* unused harmony reexport append */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__apply__ = __webpack_require__(408);
/* unused harmony reexport apply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__applySpec__ = __webpack_require__(826);
/* unused harmony reexport applySpec */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__applyTo__ = __webpack_require__(827);
/* unused harmony reexport applyTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ascend__ = __webpack_require__(828);
/* unused harmony reexport ascend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assoc__ = __webpack_require__(171);
/* unused harmony reexport assoc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assocPath__ = __webpack_require__(410);
/* unused harmony reexport assocPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__binary__ = __webpack_require__(829);
/* unused harmony reexport binary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__bind__ = __webpack_require__(403);
/* unused harmony reexport bind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__both__ = __webpack_require__(830);
/* unused harmony reexport both */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__call__ = __webpack_require__(831);
/* unused harmony reexport call */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__chain__ = __webpack_require__(265);
/* unused harmony reexport chain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clamp__ = __webpack_require__(835);
/* unused harmony reexport clamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__clone__ = __webpack_require__(836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_27__clone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__comparator__ = __webpack_require__(837);
/* unused harmony reexport comparator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__complement__ = __webpack_require__(838);
/* unused harmony reexport complement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__compose__ = __webpack_require__(267);
/* unused harmony reexport compose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__composeK__ = __webpack_require__(418);
/* unused harmony reexport composeK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__composeP__ = __webpack_require__(840);
/* unused harmony reexport composeP */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__concat__ = __webpack_require__(269);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cond__ = __webpack_require__(849);
/* unused harmony reexport cond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__construct__ = __webpack_require__(850);
/* unused harmony reexport construct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__constructN__ = __webpack_require__(423);
/* unused harmony reexport constructN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__contains__ = __webpack_require__(851);
/* unused harmony reexport contains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__converge__ = __webpack_require__(424);
/* unused harmony reexport converge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__countBy__ = __webpack_require__(852);
/* unused harmony reexport countBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__curry__ = __webpack_require__(264);
/* unused harmony reexport curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__curryN__ = __webpack_require__(52);
/* unused harmony reexport curryN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__dec__ = __webpack_require__(854);
/* unused harmony reexport dec */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__defaultTo__ = __webpack_require__(425);
/* unused harmony reexport defaultTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__descend__ = __webpack_require__(855);
/* unused harmony reexport descend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__difference__ = __webpack_require__(426);
/* unused harmony reexport difference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__differenceWith__ = __webpack_require__(427);
/* unused harmony reexport differenceWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__dissoc__ = __webpack_require__(428);
/* unused harmony reexport dissoc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__dissocPath__ = __webpack_require__(856);
/* unused harmony reexport dissocPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__divide__ = __webpack_require__(857);
/* unused harmony reexport divide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__drop__ = __webpack_require__(430);
/* unused harmony reexport drop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__dropLast__ = __webpack_require__(859);
/* unused harmony reexport dropLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__dropLastWhile__ = __webpack_require__(863);
/* unused harmony reexport dropLastWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__dropRepeats__ = __webpack_require__(866);
/* unused harmony reexport dropRepeats */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__dropRepeatsWith__ = __webpack_require__(432);
/* unused harmony reexport dropRepeatsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__dropWhile__ = __webpack_require__(867);
/* unused harmony reexport dropWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__either__ = __webpack_require__(869);
/* unused harmony reexport either */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__empty__ = __webpack_require__(435);
/* unused harmony reexport empty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__endsWith__ = __webpack_require__(870);
/* unused harmony reexport endsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__eqBy__ = __webpack_require__(871);
/* unused harmony reexport eqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__eqProps__ = __webpack_require__(872);
/* unused harmony reexport eqProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__equals__ = __webpack_require__(67);
/* unused harmony reexport equals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__evolve__ = __webpack_require__(873);
/* unused harmony reexport evolve */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__filter__ = __webpack_require__(270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_63__filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__find__ = __webpack_require__(874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_64__find__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__findIndex__ = __webpack_require__(876);
/* unused harmony reexport findIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__findLast__ = __webpack_require__(878);
/* unused harmony reexport findLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__findLastIndex__ = __webpack_require__(880);
/* unused harmony reexport findLastIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__flatten__ = __webpack_require__(882);
/* unused harmony reexport flatten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__flip__ = __webpack_require__(179);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__forEach__ = __webpack_require__(883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_70__forEach__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__forEachObjIndexed__ = __webpack_require__(884);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_71__forEachObjIndexed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__fromPairs__ = __webpack_require__(885);
/* unused harmony reexport fromPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__groupBy__ = __webpack_require__(886);
/* unused harmony reexport groupBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__groupWith__ = __webpack_require__(887);
/* unused harmony reexport groupWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__gt__ = __webpack_require__(888);
/* unused harmony reexport gt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__gte__ = __webpack_require__(889);
/* unused harmony reexport gte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__has__ = __webpack_require__(890);
/* unused harmony reexport has */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__hasIn__ = __webpack_require__(891);
/* unused harmony reexport hasIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__head__ = __webpack_require__(892);
/* unused harmony reexport head */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__identical__ = __webpack_require__(421);
/* unused harmony reexport identical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__identity__ = __webpack_require__(275);
/* unused harmony reexport identity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__ifElse__ = __webpack_require__(893);
/* unused harmony reexport ifElse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__inc__ = __webpack_require__(894);
/* unused harmony reexport inc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__indexBy__ = __webpack_require__(895);
/* unused harmony reexport indexBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__indexOf__ = __webpack_require__(896);
/* unused harmony reexport indexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__init__ = __webpack_require__(897);
/* unused harmony reexport init */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__innerJoin__ = __webpack_require__(898);
/* unused harmony reexport innerJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__insert__ = __webpack_require__(899);
/* unused harmony reexport insert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__insertAll__ = __webpack_require__(900);
/* unused harmony reexport insertAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__intersection__ = __webpack_require__(901);
/* unused harmony reexport intersection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__intersperse__ = __webpack_require__(903);
/* unused harmony reexport intersperse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__into__ = __webpack_require__(904);
/* unused harmony reexport into */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__invert__ = __webpack_require__(907);
/* unused harmony reexport invert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__invertObj__ = __webpack_require__(908);
/* unused harmony reexport invertObj */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__invoker__ = __webpack_require__(138);
/* unused harmony reexport invoker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__is__ = __webpack_require__(439);
/* unused harmony reexport is */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__isEmpty__ = __webpack_require__(909);
/* unused harmony reexport isEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__isNil__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_98__isNil__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__join__ = __webpack_require__(910);
/* unused harmony reexport join */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__juxt__ = __webpack_require__(440);
/* unused harmony reexport juxt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__keys__ = __webpack_require__(75);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__keysIn__ = __webpack_require__(911);
/* unused harmony reexport keysIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__last__ = __webpack_require__(433);
/* unused harmony reexport last */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__lastIndexOf__ = __webpack_require__(912);
/* unused harmony reexport lastIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__length__ = __webpack_require__(441);
/* unused harmony reexport length */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__lens__ = __webpack_require__(180);
/* unused harmony reexport lens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__lensIndex__ = __webpack_require__(913);
/* unused harmony reexport lensIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__lensPath__ = __webpack_require__(914);
/* unused harmony reexport lensPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__lensProp__ = __webpack_require__(915);
/* unused harmony reexport lensProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__lift__ = __webpack_require__(174);
/* unused harmony reexport lift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__liftN__ = __webpack_require__(412);
/* unused harmony reexport liftN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__lt__ = __webpack_require__(916);
/* unused harmony reexport lt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__lte__ = __webpack_require__(917);
/* unused harmony reexport lte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__map__ = __webpack_require__(62);
/* unused harmony reexport map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__mapAccum__ = __webpack_require__(918);
/* unused harmony reexport mapAccum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__mapAccumRight__ = __webpack_require__(919);
/* unused harmony reexport mapAccumRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__mapObjIndexed__ = __webpack_require__(920);
/* unused harmony reexport mapObjIndexed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__match__ = __webpack_require__(921);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__mathMod__ = __webpack_require__(922);
/* unused harmony reexport mathMod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__max__ = __webpack_require__(117);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__maxBy__ = __webpack_require__(923);
/* unused harmony reexport maxBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__mean__ = __webpack_require__(443);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__median__ = __webpack_require__(924);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__memoize__ = __webpack_require__(925);
/* unused harmony reexport memoize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__memoizeWith__ = __webpack_require__(445);
/* unused harmony reexport memoizeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__merge__ = __webpack_require__(926);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__mergeAll__ = __webpack_require__(927);
/* unused harmony reexport mergeAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__mergeDeepLeft__ = __webpack_require__(928);
/* unused harmony reexport mergeDeepLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__mergeDeepRight__ = __webpack_require__(929);
/* unused harmony reexport mergeDeepRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__mergeDeepWith__ = __webpack_require__(930);
/* unused harmony reexport mergeDeepWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__mergeDeepWithKey__ = __webpack_require__(181);
/* unused harmony reexport mergeDeepWithKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__mergeWith__ = __webpack_require__(931);
/* unused harmony reexport mergeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__mergeWithKey__ = __webpack_require__(279);
/* unused harmony reexport mergeWithKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__min__ = __webpack_require__(932);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__minBy__ = __webpack_require__(933);
/* unused harmony reexport minBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__modulo__ = __webpack_require__(934);
/* unused harmony reexport modulo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__multiply__ = __webpack_require__(446);
/* unused harmony reexport multiply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__nAry__ = __webpack_require__(172);
/* unused harmony reexport nAry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__negate__ = __webpack_require__(935);
/* unused harmony reexport negate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__none__ = __webpack_require__(936);
/* unused harmony reexport none */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__not__ = __webpack_require__(416);
/* unused harmony reexport not */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__nth__ = __webpack_require__(137);
/* unused harmony reexport nth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__nthArg__ = __webpack_require__(937);
/* unused harmony reexport nthArg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__o__ = __webpack_require__(938);
/* unused harmony reexport o */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__objOf__ = __webpack_require__(438);
/* unused harmony reexport objOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__of__ = __webpack_require__(939);
/* unused harmony reexport of */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__omit__ = __webpack_require__(941);
/* unused harmony reexport omit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__once__ = __webpack_require__(942);
/* unused harmony reexport once */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__or__ = __webpack_require__(434);
/* unused harmony reexport or */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__over__ = __webpack_require__(447);
/* unused harmony reexport over */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__pair__ = __webpack_require__(943);
/* unused harmony reexport pair */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__partial__ = __webpack_require__(944);
/* unused harmony reexport partial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__partialRight__ = __webpack_require__(945);
/* unused harmony reexport partialRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__partition__ = __webpack_require__(946);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__path__ = __webpack_require__(118);
/* unused harmony reexport path */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__pathEq__ = __webpack_require__(947);
/* unused harmony reexport pathEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__pathOr__ = __webpack_require__(948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_157__pathOr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__pathSatisfies__ = __webpack_require__(949);
/* unused harmony reexport pathSatisfies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__pick__ = __webpack_require__(950);
/* unused harmony reexport pick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__pickAll__ = __webpack_require__(449);
/* unused harmony reexport pickAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__pickBy__ = __webpack_require__(951);
/* unused harmony reexport pickBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__pipe__ = __webpack_require__(417);
/* unused harmony reexport pipe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__pipeK__ = __webpack_require__(952);
/* unused harmony reexport pipeK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__pipeP__ = __webpack_require__(419);
/* unused harmony reexport pipeP */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__pluck__ = __webpack_require__(133);
/* unused harmony reexport pluck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__prepend__ = __webpack_require__(450);
/* unused harmony reexport prepend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__product__ = __webpack_require__(953);
/* unused harmony reexport product */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__project__ = __webpack_require__(954);
/* unused harmony reexport project */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__prop__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_169__prop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__propEq__ = __webpack_require__(955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_170__propEq__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__propIs__ = __webpack_require__(956);
/* unused harmony reexport propIs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__propOr__ = __webpack_require__(957);
/* unused harmony reexport propOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__propSatisfies__ = __webpack_require__(958);
/* unused harmony reexport propSatisfies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__props__ = __webpack_require__(959);
/* unused harmony reexport props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__range__ = __webpack_require__(960);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__reduce__ = __webpack_require__(76);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__reduceBy__ = __webpack_require__(178);
/* unused harmony reexport reduceBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__reduceRight__ = __webpack_require__(452);
/* unused harmony reexport reduceRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__reduceWhile__ = __webpack_require__(961);
/* unused harmony reexport reduceWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__reduced__ = __webpack_require__(962);
/* unused harmony reexport reduced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__reject__ = __webpack_require__(177);
/* unused harmony reexport reject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__remove__ = __webpack_require__(429);
/* unused harmony reexport remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__repeat__ = __webpack_require__(963);
/* unused harmony reexport repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__replace__ = __webpack_require__(964);
/* unused harmony reexport replace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__reverse__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_185__reverse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__scan__ = __webpack_require__(965);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__sequence__ = __webpack_require__(454);
/* unused harmony reexport sequence */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__set__ = __webpack_require__(966);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__slice__ = __webpack_require__(72);
/* unused harmony reexport slice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__sort__ = __webpack_require__(967);
/* unused harmony reexport sort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__sortBy__ = __webpack_require__(968);
/* unused harmony reexport sortBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__sortWith__ = __webpack_require__(969);
/* unused harmony reexport sortWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__split__ = __webpack_require__(970);
/* unused harmony reexport split */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__splitAt__ = __webpack_require__(971);
/* unused harmony reexport splitAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__splitEvery__ = __webpack_require__(972);
/* unused harmony reexport splitEvery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__splitWhen__ = __webpack_require__(973);
/* unused harmony reexport splitWhen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__startsWith__ = __webpack_require__(974);
/* unused harmony reexport startsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__subtract__ = __webpack_require__(975);
/* unused harmony reexport subtract */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__sum__ = __webpack_require__(444);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__symmetricDifference__ = __webpack_require__(976);
/* unused harmony reexport symmetricDifference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__symmetricDifferenceWith__ = __webpack_require__(977);
/* unused harmony reexport symmetricDifferenceWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__tail__ = __webpack_require__(268);
/* unused harmony reexport tail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__take__ = __webpack_require__(274);
/* unused harmony reexport take */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__takeLast__ = __webpack_require__(436);
/* unused harmony reexport takeLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__takeLastWhile__ = __webpack_require__(978);
/* unused harmony reexport takeLastWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__takeWhile__ = __webpack_require__(979);
/* unused harmony reexport takeWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__tap__ = __webpack_require__(981);
/* unused harmony reexport tap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__test__ = __webpack_require__(983);
/* unused harmony reexport test */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__times__ = __webpack_require__(453);
/* unused harmony reexport times */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__toLower__ = __webpack_require__(985);
/* unused harmony reexport toLower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__toPairs__ = __webpack_require__(986);
/* unused harmony reexport toPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__toPairsIn__ = __webpack_require__(987);
/* unused harmony reexport toPairsIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__toString__ = __webpack_require__(136);
/* unused harmony reexport toString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__toUpper__ = __webpack_require__(988);
/* unused harmony reexport toUpper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__transduce__ = __webpack_require__(989);
/* unused harmony reexport transduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__transpose__ = __webpack_require__(990);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__traverse__ = __webpack_require__(991);
/* unused harmony reexport traverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__trim__ = __webpack_require__(992);
/* unused harmony reexport trim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__tryCatch__ = __webpack_require__(993);
/* unused harmony reexport tryCatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__type__ = __webpack_require__(266);
/* unused harmony reexport type */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__unapply__ = __webpack_require__(994);
/* unused harmony reexport unapply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__unary__ = __webpack_require__(995);
/* unused harmony reexport unary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__uncurryN__ = __webpack_require__(996);
/* unused harmony reexport uncurryN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__unfold__ = __webpack_require__(997);
/* unused harmony reexport unfold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__union__ = __webpack_require__(998);
/* unused harmony reexport union */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__unionWith__ = __webpack_require__(999);
/* unused harmony reexport unionWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__uniq__ = __webpack_require__(277);
/* unused harmony reexport uniq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__uniqBy__ = __webpack_require__(437);
/* unused harmony reexport uniqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__uniqWith__ = __webpack_require__(455);
/* unused harmony reexport uniqWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__unless__ = __webpack_require__(1000);
/* unused harmony reexport unless */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__unnest__ = __webpack_require__(1001);
/* unused harmony reexport unnest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__until__ = __webpack_require__(1002);
/* unused harmony reexport until */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__update__ = __webpack_require__(273);
/* unused harmony reexport update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__useWith__ = __webpack_require__(451);
/* unused harmony reexport useWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__values__ = __webpack_require__(409);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__valuesIn__ = __webpack_require__(1003);
/* unused harmony reexport valuesIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__view__ = __webpack_require__(1004);
/* unused harmony reexport view */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__when__ = __webpack_require__(1005);
/* unused harmony reexport when */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__where__ = __webpack_require__(456);
/* unused harmony reexport where */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__whereEq__ = __webpack_require__(1006);
/* unused harmony reexport whereEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__without__ = __webpack_require__(1007);
/* unused harmony reexport without */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__xprod__ = __webpack_require__(1008);
/* unused harmony reexport xprod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__zip__ = __webpack_require__(1009);
/* unused harmony reexport zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__zipObj__ = __webpack_require__(1010);
/* unused harmony reexport zipObj */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__zipWith__ = __webpack_require__(1011);
/* unused harmony reexport zipWith */























































































































































































































































/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export applyFilter */
/* unused harmony export getColumnByProperty */
/* unused harmony export getColumnValue */
/* unused harmony export getColumnValueFromColumnList */
/* unused harmony export getColumnFilterType */
/* unused harmony export applyColumnFilter */
/* unused harmony export defaultComparator */
/* unused harmony export applySort */
/* unused harmony export extractDisplayRows */
/* unused harmony export calculateRange */
/* unused harmony export formatFollowUpType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ColumnSelector__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_datetime__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var moment=__webpack_require__(38);var applyFilter=function applyFilter(rowList,columnList,filterValue){if(!filterValue){return rowList;}if(filterValue&&filterValue.toLocaleLowerCase){filterValue=filterValue.toLocaleLowerCase();}return __WEBPACK_IMPORTED_MODULE_2_ramda__["b" /* filter */](function(row){var matched=false;__WEBPACK_IMPORTED_MODULE_2_ramda__["d" /* forEach */](function(_ref){var property=_ref.property,renderer=_ref.renderer;var value=renderer?renderer(row,property):row[property];if(value&&value.toLocaleLowerCase){value=value.toLocaleLowerCase();}if(value||value===0){value+='';matched=matched||value.indexOf(filterValue)!==-1;}},columnList);return matched;},rowList);};var toLocaleLowerCase=function toLocaleLowerCase(value){if(!value&&value!==0){return value;}if(!value.toLocaleLowerCase){return value;}return value.toLocaleLowerCase();};var getColumnByProperty=function getColumnByProperty(columnList,property){return __WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('property',property))(columnList);};var getColumnValue=function getColumnValue(row,column,property){if(column.renderer){return column.renderer(row,property);}var value=row[property];if(value===0){return'0';}if(!value){return null;}return value;};var getColumnValueFromColumnList=function getColumnValueFromColumnList(row,columnList,property){var column=getColumnByProperty(columnList,property);return getColumnValue(row,column,property);};var getColumnFilterType=function getColumnFilterType(columnList,property){var column=getColumnByProperty(columnList,property);return column.filterType;};var applyColumnFilter=function applyColumnFilter(rowList,columnList,filterValueList){return __WEBPACK_IMPORTED_MODULE_2_ramda__["b" /* filter */](function(row){var matched=true;__WEBPACK_IMPORTED_MODULE_2_ramda__["e" /* forEachObjIndexed */](function(columnFilterValue,property){if(!columnFilterValue||!matched){return;}columnFilterValue=''+toLocaleLowerCase(columnFilterValue);var columnValue=getColumnValueFromColumnList(row,columnList,property);var columnFilterType=getColumnFilterType(columnList,property);if(columnValue===null){matched=false;return;}columnValue=''+toLocaleLowerCase(columnValue);if(columnFilterType==='select'){matched=columnValue===columnFilterValue;return;}matched=columnValue.indexOf(columnFilterValue)!==-1;},filterValueList);return matched;},rowList);};var defaultComparator=function defaultComparator(property){return function(a,b,column){var aValue=column.sortValue?column.sortValue(a):a[property];var bValue=column.sortValue?column.sortValue(b):b[property];if(!aValue&&!bValue){return 0;}if(!aValue&&bValue){return-1;}if(aValue&&!bValue){return 1;}if(typeof aValue==='string'||aValue instanceof String){aValue=aValue.toLocaleLowerCase();}if(typeof bValue==='string'||bValue instanceof String){bValue=bValue.toLocaleLowerCase();}if(aValue<bValue){return-1;}if(aValue>bValue){return 1;}return 0;};};var applySort=function applySort(rowList,sortOrder,column){if(!column){return;}var comparator=column.comparator||defaultComparator(column.property);rowList.sort(function(a,b){return sortOrder*comparator(a,b,column);});};var extractDisplayRows=function extractDisplayRows(rowList,range){var displayRowList=[];for(var index=range.startIndex;index<range.endIndex;index++){displayRowList.push(rowList[index]);}return displayRowList;};var calculateRange=function calculateRange(rowListLength,rowsPerPage,currentPage){var range={currentPage:parseInt(currentPage,10),rowsPerPage:rowsPerPage,startIndex:0,endIndex:rowListLength,totalPages:1};if(rowsPerPage===0){range.currentPage=0;return range;}if(rowListLength<rowsPerPage){range.currentPage=0;range.startIndex=0;range.endIndex=rowListLength;range.totalPages=1;return range;}range.totalPages=Math.ceil(rowListLength/rowsPerPage);if(rowsPerPage*currentPage>=rowListLength){var rest=rowListLength%rowsPerPage;var page=(rowListLength-rest)/rowsPerPage;range.currentPage=rest!==0?page:page-1;}range.startIndex=rowsPerPage*range.currentPage;range.endIndex=range.startIndex+rowsPerPage;if(range.endIndex>rowListLength){range.endIndex=rowListLength;}return range;};var Table=function(_React$Component){_inherits(Table,_React$Component);function Table(props){_classCallCheck(this,Table);var _this=_possibleConstructorReturn(this,(Table.__proto__||Object.getPrototypeOf(Table)).call(this,props));_this.state=_this.calculateState(_this.props.rowList,_this.props.tableSetting);_this.changeSortOrder=_this.changeSortOrder.bind(_this);_this.displayPage=_this.displayPage.bind(_this);_this.rowsPerPageChanged=_this.rowsPerPageChanged.bind(_this);_this.onRowClick=_this.onRowClick.bind(_this);_this.onRowDoubleClick=_this.onRowDoubleClick.bind(_this);_this.changeFilterValue=_this.changeFilterValue.bind(_this);_this.exportCSV=_this.exportCSV.bind(_this);return _this;}_createClass(Table,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var state=this.calculateState(nextProps.rowList,nextProps.tableSetting);this.setState(state);}},{key:'changeSortOrder',value:function changeSortOrder(sortColumnName){var tableSetting=this.props.tableSetting;var sortOrder=tableSetting.sortColumnName===sortColumnName?tableSetting.sortOrder*-1:1;this.props.changeTableSetting('sortOrder',sortOrder);this.props.changeTableSetting('sortColumnName',sortColumnName);}},{key:'rowsPerPageChanged',value:function rowsPerPageChanged(event){this.props.changeTableSetting('rowsPerPage',parseInt(event.target.value,10));}},{key:'displayPage',value:function displayPage(currentPage){this.props.changeTableSetting('currentPage',currentPage);}},{key:'changeFilterValue',value:function changeFilterValue(property,value){var tableSetting=this.props.tableSetting;this.props.changeTableSetting('filterValueList',Object.assign({},tableSetting.filterValueList,_defineProperty({},property,value)));}},{key:'onRowClick',value:function onRowClick(row){if(this.props.onRowClick){this.props.onRowClick(row);}}},{key:'onRowDoubleClick',value:function onRowDoubleClick(row){if(this.props.onRowDoubleClick){this.props.onRowDoubleClick(row);}}},{key:'exportCSV',value:function exportCSV(){var _props=this.props,rowList=_props.rowList,columnList=_props.columnList,tableSetting=_props.tableSetting;var filteredRowList=applyColumnFilter(rowList,columnList,tableSetting.filterValueList);var sortColumn=__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('property',tableSetting.sortColumnName))(columnList);applySort(filteredRowList,tableSetting.sortOrder,sortColumn);var headerArray=[];__WEBPACK_IMPORTED_MODULE_2_ramda__["d" /* forEach */](function(_ref2){var header=_ref2.header;headerArray.push(header);},columnList);var csv=headerArray.join(';')+'\r\n';__WEBPACK_IMPORTED_MODULE_2_ramda__["d" /* forEach */](function(row){var rowList=[];__WEBPACK_IMPORTED_MODULE_2_ramda__["d" /* forEach */](function(_ref3){var renderer=_ref3.renderer,property=_ref3.property;var value=renderer?renderer(row,property):row[property];if(value&&value.replace){value=value.replace(';',',');}rowList.push(value);},columnList);csv+=rowList.join(';')+'\r\n';},filteredRowList);var blob=new Blob([csv]);this.downloadTag.href=window.URL.createObjectURL(blob,{type:'text/plain'});this.downloadTag.click();}},{key:'calculateState',value:function calculateState(rowList,tableSetting){var filteredRowList=applyColumnFilter(rowList,this.props.columnList,tableSetting.filterValueList);var sortColumn=__WEBPACK_IMPORTED_MODULE_2_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_2_ramda__["i" /* propEq */]('property',tableSetting.sortColumnName))(this.props.columnList);applySort(filteredRowList,tableSetting.sortOrder,sortColumn);var range=calculateRange(filteredRowList.length,tableSetting.rowsPerPage,tableSetting.currentPage);return Object.assign({},range,{filteredRowList:extractDisplayRows(filteredRowList,range),filteredRowListLength:filteredRowList.length,sortOrder:tableSetting.sortOrder,sortColumnName:tableSetting.sortColumn,filterValueList:tableSetting.filterValueList,hiddenColumns:tableSetting.hiddenColumns||[]});}},{key:'render',value:function render(){var _this2=this;var tableSetting=this.props.tableSetting;var options=tableSetting.rowsTotalOptions||[20,40];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',onChange:this.rowsPerPageChanged,value:this.state.rowsPerPage},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:option,value:option},option);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'all'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:5,className:'default-text number-status'},'Displaying ',this.state.filteredRowListLength,' of',' ',this.props.rowList.length,' Total',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{ref:function ref(downloadTag){_this2.downloadTag=downloadTag;},download:'export.csv',target:'_blank',rel:'noopener noreferrer',style:{display:'none'}},'link')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4,className:'text-right'},this.props.sync&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:this.props.sync},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-refresh'})),this.props.toggleColumnVisibility&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ColumnSelector__["a" /* default */],{title:'Columns',columnList:this.props.columnList,toggleColumnVisibility:this.props.toggleColumnVisibility,hiddenColumns:tableSetting.hiddenColumns}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableHeader,{columnList:this.props.columnList,sortColumnName:tableSetting.sortColumnName,sortOrder:tableSetting.sortOrder,filterValueList:tableSetting.filterValueList,changeFilterValue:this.changeFilterValue,changeSortOrder:this.changeSortOrder,hiddenColumns:tableSetting.hiddenColumns}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableBody,{columnList:this.props.columnList,rowList:this.state.filteredRowList,idProperty:this.props.idProperty,onRowClick:this.onRowClick,onRowDoubleClick:this.onRowDoubleClick,hiddenColumns:tableSetting.hiddenColumns})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pagination,Object.assign({},this.state,{displayPage:this.displayPage}))))));}}]);return Table;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Table.SORT_ORDER_DESC=-1;Table.SORT_ORDER_ASC=1;Table.dateComparator=function(property){return function(a,b){a=a[property];b=b[property];if(!a&&!b){return 0;}if(!a&&b){return-1;}if(a&&!b){return 1;}return moment(a).unix()-moment(b).unix();};};Table.dateTimeRenderer=function(property){return function(object){return Object(__WEBPACK_IMPORTED_MODULE_6__util_datetime__["c" /* formatDateTime */])(object[property]);};};Table.dateRenderer=function(property){return function(object){return Object(__WEBPACK_IMPORTED_MODULE_6__util_datetime__["b" /* formatDate */])(object[property]);};};var formatFollowUpType=function formatFollowUpType(followUpType){if(!followUpType){return'';}var labelMap={'In-Clinic-Follow-Up':'In-Clinic Follow-Up (ICSTP1)','Expert-Call-Follow-Up':'Expert Call Follow-Up (ICSTP2)','No-Follow-Up':'No Follow-Up booked (ICSTP3)','No-Pitch':'No Pitch and Follow-Up (ICSTP4)'};if(Object.keys(labelMap).includes(followUpType)){return labelMap[followUpType];}else{return followUpType;}};Table.followUpTypeRenderer=function(property){return function(object){return formatFollowUpType(object[property]);};};Table.defaultProps={sortOrder:1,sortColumn:null,rowsPerPage:20,currentPage:0,filterValue:null};Table.propTypes={idProperty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onRowDoubleClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRowClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,changeTableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};var TableHeader=function TableHeader(_ref4){var columnList=_ref4.columnList,sortColumnName=_ref4.sortColumnName,sortOrder=_ref4.sortOrder,changeSortOrder=_ref4.changeSortOrder,filterValueList=_ref4.filterValueList,changeFilterValue=_ref4.changeFilterValue,hiddenColumns=_ref4.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,columnList.filter(function(column){return!hiddenColumns.includes(column.property);}).map(function(column){var width=column.width?column.width:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:width,onClick:function onClick(){changeSortOrder(column.property);},key:column.property},column.header,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SortIcon,{sortColumnName:sortColumnName,property:column.property,sortOrder:sortOrder}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-filter-row'},columnList.filter(function(column){return!hiddenColumns.includes(column.property);}).map(function(_ref5){var property=_ref5.property,filterType=_ref5.filterType,filterOptions=_ref5.filterOptions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:property},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnFilter,{changeFilterValue:changeFilterValue,filterValueList:filterValueList,type:filterType,options:filterOptions,property:property}));})));};var ColumnFilter=function ColumnFilter(_ref6){var changeFilterValue=_ref6.changeFilterValue,filterValueList=_ref6.filterValueList,property=_ref6.property,_ref6$type=_ref6.type,type=_ref6$type===undefined?'input':_ref6$type,_ref6$options=_ref6.options,options=_ref6$options===undefined?[]:_ref6$options;if(type==='select'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{style:{height:'34px',width:'100%',backgroundColor:'#fff',border:0,outline:'none',fontWeight:'normal'},onChange:function onChange(event){changeFilterValue(property,event.currentTarget.value);},value:filterValueList[property]||''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'All'),options.map(function(_ref7){var id=_ref7.id,value=_ref7.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:id,value:id},value);}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-addon left-addon right-addon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-filter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle',onClick:function onClick(){changeFilterValue(property,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',onChange:function onChange(event){changeFilterValue(property,event.currentTarget.value);},value:filterValueList[property]||''}));}};var SortIcon=function SortIcon(_ref8){var sortColumnName=_ref8.sortColumnName,property=_ref8.property,sortOrder=_ref8.sortOrder;if(sortColumnName!==property){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sort sortIcon'});}if(sortOrder===Table.SORT_ORDER_ASC){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sort-amount-asc sortIcon'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sort-amount-desc sortIcon'});};var TableBody=function TableBody(_ref9){var columnList=_ref9.columnList,rowList=_ref9.rowList,idProperty=_ref9.idProperty,onRowClick=_ref9.onRowClick,onRowDoubleClick=_ref9.onRowDoubleClick,hiddenColumns=_ref9.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rowList.map(function(row,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableRow,{columnList:columnList,row:row,key:''+row[idProperty]+i,onRowClick:onRowClick,onRowDoubleClick:onRowDoubleClick,hiddenColumns:hiddenColumns});}));};var TableRow=function TableRow(_ref10){var row=_ref10.row,columnList=_ref10.columnList,onRowClick=_ref10.onRowClick,onRowDoubleClick=_ref10.onRowDoubleClick,hiddenColumns=_ref10.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-row',onClick:function onClick(){onRowClick(row);},onDoubleClick:function onDoubleClick(){onRowDoubleClick(row);}},columnList.filter(function(column){return!hiddenColumns.includes(column.property);}).map(function(_ref11){var property=_ref11.property,renderer=_ref11.renderer;var value=renderer?renderer(row,property):row[property];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:property},value);}));};var Pagination=function(_React$Component2){_inherits(Pagination,_React$Component2);function Pagination(props){_classCallCheck(this,Pagination);var _this3=_possibleConstructorReturn(this,(Pagination.__proto__||Object.getPrototypeOf(Pagination)).call(this,props));_this3.state=_this3.calculateState(props);return _this3;}_createClass(Pagination,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState(this.calculateState(nextProps));}},{key:'calculateState',value:function calculateState(props){var pageList=[];var startIndex=props.currentPage-5>0?props.currentPage-5:0;var endIndex=startIndex+10<props.totalPages?startIndex+10:props.totalPages;for(var index=startIndex;index<endIndex;index++){var className=index===props.currentPage?'active':'';pageList.push({className:className,page:index,displayPage:index+1});}return{pageList:pageList};}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pagination'},this.state.pageList.length>1&&this.state.pageList.map(function(page){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:page.page,onClick:function onClick(){_this4.props.displayPage(page.page);},className:page.className},page.displayPage);}));}}]);return Pagination;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Checkbox=function Checkbox(_ref){var _onChange=_ref.onChange,name=_ref.name,object=_ref.object,children=_ref.children,_ref$readOnly=_ref.readOnly,readOnly=_ref$readOnly===undefined?false:_ref$readOnly,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-form-checkbox",style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkbox-col"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",checked:object[name]||false,readOnly:readOnly,disabled:readOnly,onChange:function onChange(event){if(readOnly){return;}_onChange(name,event.currentTarget.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"label-col"},children));};/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectImageVersionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectOrderedImageVersionList; });
/* unused harmony export selectImageVersion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectVersionImageVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectShowImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectUploadingImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectRetryImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectSelectedImageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCurrentStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectSlideIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(102);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectImageVersionList=function selectImageVersionList(state){return selectOwnState(state).imageVersionList;};var getOverwrittenImageType=function getOverwrittenImageType(imageType,imageVersion){if(!imageVersion.meta){return imageType;}if(!imageVersion.meta.imageType){return imageType;}return imageVersion.meta.imageType;};var handleVersionList=function handleVersionList(versionList,fileName,imageVersionListSorted){versionList.forEach(function(imageVersion){var overwrittenImageType=getOverwrittenImageType(fileName,imageVersion);if(!imageVersionListSorted[overwrittenImageType]){imageVersionListSorted[overwrittenImageType]=[];}imageVersion.originalImageType=fileName;imageVersionListSorted[overwrittenImageType].push(imageVersion);});};var selectOrderedImageVersionList=function selectOrderedImageVersionList(state){var imageVersionList=selectImageVersionList(state);var imageVersionListSorted={};for(var fileName in imageVersionList){var versionList=imageVersionList[fileName];handleVersionList(versionList,fileName,imageVersionListSorted);}return imageVersionListSorted;};var selectImageVersion=function selectImageVersion(state,fileName){var imageVersionList=selectOwnState(state).imageVersionList;return imageVersionList?imageVersionList[fileName]:null;};var selectVersionImageVersion=function selectVersionImageVersion(state,fileName,versionId){var imageVersion=selectImageVersion(state,fileName);if(!imageVersion){return null;}for(var index=0;index<imageVersion.length;index++){var current=imageVersion[index];if(current.versionId===versionId){return current;}}return null;};var selectShowImages=function selectShowImages(state){return selectOwnState(state).showImages;};var selectUploadingImages=function selectUploadingImages(state){return selectOwnState(state).uploadingImages;};var selectRetryImages=function selectRetryImages(state){return selectOwnState(state).retryImages;};var selectSelectedImageType=function selectSelectedImageType(state){return selectOwnState(state).selectedImageType;};var selectCurrentStep=function selectCurrentStep(state){return selectOwnState(state).currentStep;};var selectSlideIndex=function selectSlideIndex(state){return selectOwnState(state).slideIndex;};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(150);
/* unused harmony reexport MemoryRouter */
/* unused harmony reexport Prompt */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* unused harmony reexport Router */
/* unused harmony reexport StaticRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* unused harmony reexport generatePath */
/* unused harmony reexport matchPath */
/* unused harmony reexport useHistory */
/* unused harmony reexport useLocation */
/* unused harmony reexport useParams */
/* unused harmony reexport useRouteMatch */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(203);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return selectSetTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCheckInTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectInShopScanTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectImplant3dScanTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectImplantPlanTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectImplantTreatmentTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return selectShopScanTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return selectTreatmentTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectRefinementProductionTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectRefinementBookingTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectRefinementShopTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectRefinementSetTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectRetainerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectRetainerRefinementTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectEscalationTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectEndOfTreatmentTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(249);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectSetTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["n" /* TABLE_SET */]);var selectCheckInTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["a" /* TABLE_CHECK_IN */]);var selectInShopScanTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["g" /* TABLE_IN_SHOP_SCAN */]);var selectImplant3dScanTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var selectImplantPlanTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["e" /* TABLE_IMPLANT_PLAN */]);var selectImplantTreatmentTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var selectShopScanTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["o" /* TABLE_SHOP_SCAN */]);var selectTreatmentTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["p" /* TABLE_TREATMENT */]);var selectRefinementProductionTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var selectRefinementBookingTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["h" /* TABLE_REFINEMENT_BOOKING */]);var selectRefinementShopTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["k" /* TABLE_REFINEMENT_SHOP */]);var selectRefinementSetTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["j" /* TABLE_REFINEMENT_SET */]);var selectRetainerTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["l" /* TABLE_RETAINER */]);var selectRetainerRefinementTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var selectEscalationTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["c" /* TABLE_ESCALATION */]);var selectEndOfTreatmentTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["b" /* TABLE_END_OF_TREATMENT */]);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return processInstanceLoaded; });
/* unused harmony export findProcessInstanceRequest */
/* unused harmony export dispatchActionList */
/* unused harmony export findProcessInstanceSuccess */
/* unused harmony export findProcessInstanceError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return findProcessInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return findProcessInstanceByMasterId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleProcessFlowVisibility; });
/* unused harmony export toggleVIPStatusRequest */
/* unused harmony export toggleVIPStatusSuccess */
/* unused harmony export toggleVIPStatusError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return toggleVIPStatus; });
/* unused harmony export toggleRushStatusRequest */
/* unused harmony export toggleRushStatusSuccess */
/* unused harmony export toggleRushStatusError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toggleRushStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeProcessComment; });
/* unused harmony export commentProcessInstanceRequest */
/* unused harmony export commentProcessInstanceSuccess */
/* unused harmony export commentProcessInstanceError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return commentProcessInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeProcessContext; });
/* unused harmony export saveProcessContextRequest */
/* unused harmony export saveProcessContextSuccess */
/* unused harmony export saveProcessContextError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return saveProcessContext; });
/* unused harmony export updateContext */
/* unused harmony export setValidationMessageList */
/* unused harmony export fireEventRequest */
/* unused harmony export fireEventSuccess */
/* unused harmony export fireEventError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return validateAndTriggerEvent; });
/* unused harmony export changeTimeRequest */
/* unused harmony export changeTimeSuccess */
/* unused harmony export changeTimeError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeBeamProcessState; });
/* unused harmony export beamProcessInstanceRequest */
/* unused harmony export beamProcessInstanceSuccess */
/* unused harmony export beamProcessInstanceError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beamProcessInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enrich_process_instance__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sales_order_state_detail_action__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_ui_definition__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_definition_process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treatment_state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treatment_state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prospect_state_detail_action__ = __webpack_require__(552);
var _ACTION_MAPPING;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ACTION_MAPPING=(_ACTION_MAPPING={},_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_6__ui_definition_process_action__["a" /* CUSTOMER */],__WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__["m" /* findCustomerSuccess */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_6__ui_definition_process_action__["h" /* TREATMENT_PLAN */],__WEBPACK_IMPORTED_MODULE_8__treatment_state_plan_action__["h" /* treatmentPlanLoaded */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_6__ui_definition_process_action__["i" /* TREATMENT_QUOTATION */],__WEBPACK_IMPORTED_MODULE_9__treatment_state_quotation_action__["f" /* processTaskLoaded */]),_ACTION_MAPPING);var processInstanceLoaded=function processInstanceLoaded(processInstance){return function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_process_instance__["c" /* enrichProcessInstance */])(getState(),processInstance);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__type__["s" /* PROCESS_INSTANCE_LOADED */],payload:{processInstance:processInstance}});};};var findProcessInstanceRequest=function findProcessInstanceRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["n" /* FIND_PROCESS_INSTANCE_REQUEST */]};};var dispatchActionList=function dispatchActionList(processInstance,dispatch){var definition=Object(__WEBPACK_IMPORTED_MODULE_5__ui_definition_ui_definition__["a" /* getUIDefinitionByStateName */])(processInstance.currentStateName);if(!definition||!definition.actionList){return;}definition.actionList.map(function(_ref){var action=_ref.action,taskPath=_ref.taskPath;action=ACTION_MAPPING[action];if(!action){return null;}var actionData=processInstance;for(var index=0;index<taskPath.length;index++){var key=taskPath[index];actionData=actionData?actionData[key]:null;}return dispatch(action(actionData));});};var findProcessInstanceSuccess=function findProcessInstanceSuccess(processInstance){return function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_process_instance__["c" /* enrichProcessInstance */])(getState(),processInstance);dispatchActionList(processInstance,dispatch);if(processInstance.masterObject==='salesorder_salesorder'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__sales_order_state_detail_action__["h" /* findSalesOrderSuccess */])(processInstance.objectDetail));}if(processInstance.masterObject==='prospect_prospect'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__prospect_state_detail_action__["a" /* findProspectSuccess */])(processInstance.objectDetail));}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__type__["o" /* FIND_PROCESS_INSTANCE_SUCCESS */],payload:{processInstance:processInstance}});};};var findProcessInstanceError=function findProcessInstanceError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_PROCESS_INSTANCE_ERROR */],payload:{error:error}};};var findProcessInstance=function findProcessInstance(processInstanceId){return function(dispatch,getState){dispatch(findProcessInstanceRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/instance/find-full?processInstanceId='+processInstanceId).then(function(processInstance){dispatch(findProcessInstanceSuccess(processInstance));}).catch(function(error){dispatch(findProcessInstanceError(error));});};};var findProcessInstanceByMasterId=function findProcessInstanceByMasterId(masterObject,masterId){return function(dispatch,getState){dispatch(findProcessInstanceRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/instance/find-full-by-master-id?masterObject='+masterObject+'&masterId='+masterId).then(function(processInstance){dispatch(findProcessInstanceSuccess(processInstance));}).catch(function(error){console.dir(error);dispatch(findProcessInstanceError(error));});};};var toggleProcessFlowVisibility=function toggleProcessFlowVisibility(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["x" /* TOGGLE_PROCESS_FLOW_VISIBILITY */]};};var toggleVIPStatusRequest=function toggleVIPStatusRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["C" /* TOGGLE_VIP_STATUS_REQUEST */]};};var toggleVIPStatusSuccess=function toggleVIPStatusSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["D" /* TOGGLE_VIP_STATUS_SUCCESS */]};};var toggleVIPStatusError=function toggleVIPStatusError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["B" /* TOGGLE_VIP_STATUS_ERROR */],payload:{error:error}};};var toggleVIPStatus=function toggleVIPStatus(){return function(dispatch,getState){dispatch(toggleVIPStatusRequest());var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectProcessInstance */](state).id;var vipStatus=!__WEBPACK_IMPORTED_MODULE_2__selector__["s" /* selectVIPStatus */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/instance/set-vip-status?processInstanceId='+processInstanceId+'&vip='+vipStatus).then(function(){dispatch(toggleVIPStatusSuccess());}).catch(function(error){dispatch(toggleVIPStatusError(error));});};};var toggleRushStatusRequest=function toggleRushStatusRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["z" /* TOGGLE_RUSH_STATUS_REQUEST */]};};var toggleRushStatusSuccess=function toggleRushStatusSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["A" /* TOGGLE_RUSH_STATUS_SUCCESS */]};};var toggleRushStatusError=function toggleRushStatusError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["y" /* TOGGLE_RUSH_STATUS_ERROR */],payload:{error:error}};};var toggleRushStatus=function toggleRushStatus(){return function(dispatch,getState){dispatch(toggleRushStatusRequest());var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectProcessInstance */](state).id;var rushStatus=!__WEBPACK_IMPORTED_MODULE_2__selector__["r" /* selectRushStatus */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/instance/set-rush-status?processInstanceId='+processInstanceId+'&rush='+rushStatus).then(function(){dispatch(toggleRushStatusSuccess());}).catch(function(error){dispatch(toggleRushStatusError(error));});};};var changeProcessComment=function changeProcessComment(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CHANGE_PROCESS_COMMENT */],payload:{name:name,value:value}};};var commentProcessInstanceRequest=function commentProcessInstanceRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* COMMENT_PROCESS_INSTANCE_REQUEST */],payload:{}};};var commentProcessInstanceSuccess=function commentProcessInstanceSuccess(comment){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* COMMENT_PROCESS_INSTANCE_SUCCESS */],payload:{comment:comment}};};var commentProcessInstanceError=function commentProcessInstanceError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* COMMENT_PROCESS_INSTANCE_ERROR */],payload:{error:error}};};var commentProcessInstance=function commentProcessInstance(){return function(dispatch,getState){dispatch(commentProcessInstanceRequest());var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectProcessInstanceId */](state);var commentText=__WEBPACK_IMPORTED_MODULE_2__selector__["e" /* selectCommentText */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/instance/comment',{processInstanceId:processInstanceId,commentText:commentText}).then(function(comment){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_process_instance__["a" /* enrichComment */])(state,comment);dispatch(commentProcessInstanceSuccess(comment));}).catch(function(error){dispatch(commentProcessInstanceError(error));});};};var changeProcessContext=function changeProcessContext(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_PROCESS_CONTEXT */],payload:{name:name,value:value}};};var saveProcessContextRequest=function saveProcessContextRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["u" /* SAVE_PROCESS_CONTEXT_REQUEST */]};};var saveProcessContextSuccess=function saveProcessContextSuccess(context){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["v" /* SAVE_PROCESS_CONTEXT_SUCCESS */],payload:{context:context}};};var saveProcessContextError=function saveProcessContextError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["t" /* SAVE_PROCESS_CONTEXT_ERROR */],payload:{error:error}};};var saveProcessContext=function saveProcessContext(){return function(dispatch,getState){dispatch(saveProcessContextRequest());var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectProcessInstanceId */](state);var context=__WEBPACK_IMPORTED_MODULE_2__selector__["k" /* selectProcessContext */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/instance/save-context',{processInstanceId:processInstanceId,context:context}).then(function(processInstance){dispatch(saveProcessContextSuccess());}).catch(function(error){dispatch(saveProcessContextError(error));});};};var updateContext=function updateContext(contextDiff){return function(dispatch,getState){dispatch(saveProcessContextRequest());var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectProcessInstanceId */](state);var context=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__selector__["k" /* selectProcessContext */](state),contextDiff);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/instance/save-context',{processInstanceId:processInstanceId,context:context}).then(function(processInstance){dispatch(saveProcessContextSuccess(processInstance.context));}).catch(function(error){dispatch(saveProcessContextError(error));});};};var setValidationMessageList=function setValidationMessageList(validationMessageList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["w" /* SET_VALIDATION_MESSAGE_LIST */],payload:{validationMessageList:validationMessageList}};};var fireEventRequest=function fireEventRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["q" /* FIRE_EVENT_REQUEST */],payload:{}};};var fireEventSuccess=function fireEventSuccess(processInstance){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["r" /* FIRE_EVENT_SUCCESS */],payload:{processInstance:processInstance}};};var fireEventError=function fireEventError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["p" /* FIRE_EVENT_ERROR */],payload:{error:error}};};var validateEvent=function validateEvent(state,stateName,eventName){var uiDefinition=Object(__WEBPACK_IMPORTED_MODULE_5__ui_definition_ui_definition__["a" /* getUIDefinitionByStateName */])(stateName);var _uiDefinition$taskVal=uiDefinition.taskValidatorSelector,taskValidatorSelector=_uiDefinition$taskVal===undefined?[]:_uiDefinition$taskVal,taskValidator=uiDefinition.taskValidator;if(!taskValidator){return null;}var processInstance=__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectProcessInstance */](state);var validatorParameter=[];for(var index=0;index<taskValidatorSelector.length;index++){var validatorParameterSelector=taskValidatorSelector[index];validatorParameter.push(validatorParameterSelector(state));}return taskValidator.apply(undefined,[processInstance,eventName].concat(validatorParameter));};var validateAndTriggerEvent=function validateAndTriggerEvent(processInstanceId,stateName,eventName){return function(dispatch,getState){var state=getState();var validationMessageList=validateEvent(state,stateName,eventName);if(validationMessageList&&validationMessageList.length!==0){dispatch(setValidationMessageList(validationMessageList));return;}dispatch(fireEventRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/instance/fire-event?processInstanceId='+processInstanceId+'&eventName='+eventName).then(function(processInstance){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_process_instance__["c" /* enrichProcessInstance */])(getState(),processInstance);dispatch(findProcessInstanceSuccess(processInstance));}).catch(function(error){dispatch(fireEventError(error));});};};var changeTimeRequest=function changeTimeRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* CHANGE_TIME_REQUEST */]};};var changeTimeSuccess=function changeTimeSuccess(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* CHANGE_TIME_SUCCESS */],payload:{name:name,value:value}};};var changeTimeError=function changeTimeError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* CHANGE_TIME_ERROR */],payload:{error:error}};};var changeTime=function changeTime(name,newTime){return function(dispatch,getState){var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectProcessInstanceId */](state);if(!processInstanceId){return;}dispatch(changeTimeRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/instance/change-wakeup-time',{processInstanceId:processInstanceId,name:name,newTime:newTime}).then(function(reponse){dispatch(changeTimeSuccess(name,newTime));}).catch(function(error){dispatch(changeTimeError(error));});};};var changeBeamProcessState=function changeBeamProcessState(name,beamProcessState){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_BEAM_PROCESS_STATE */],payload:{name:name,beamProcessState:beamProcessState}};};var beamProcessInstanceRequest=function beamProcessInstanceRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* BEAM_PROCESS_INSTANCE_REQUEST */]};};var beamProcessInstanceSuccess=function beamProcessInstanceSuccess(processInstance){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* BEAM_PROCESS_INSTANCE_SUCCESS */],payload:{processInstance:processInstance}};};var beamProcessInstanceError=function beamProcessInstanceError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* BEAM_PROCESS_INSTANCE_ERROR */],payload:{error:error}};};var beamProcessInstance=function beamProcessInstance(){return function(dispatch,getState){var state=getState();var _selector$selectBeamP=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectBeamProcessState */](state),beamProcessState=_selector$selectBeamP.beamProcessState;var processInstanceId=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectProcessInstanceId */](state);dispatch(beamProcessInstanceRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/instance/beam-to-state?processInstanceId='+processInstanceId+'&stateId='+beamProcessState).then(function(processInstance){dispatch(findProcessInstanceSuccess(processInstance));}).catch(function(error){dispatch(beamProcessInstanceError(error));});};};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_curryN__ = __webpack_require__(168);





/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
var curryN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_curry2__["a" /* default */])(function curryN(length, fn) {
  if (length === 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])(fn);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(length, Object(__WEBPACK_IMPORTED_MODULE_3__internal_curryN__["a" /* default */])(length, [], fn));
});
/* harmony default export */ __webpack_exports__["a"] = (curryN);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectVisualizationRequested; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(102);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state,fileTyp){return selectOwnState(state).fetching[fileTyp];};var selectVisualizationRequested=function selectVisualizationRequested(state){return selectOwnState(state).visualizationRequested;};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectSalesOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectShipmentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectSentEmailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectInvoiceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectHasChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectSalesOrderCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectSalesOrderCustomerContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAPIError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(458);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectSalesOrder=function selectSalesOrder(state){return selectOwnState(state).salesOrder;};var selectShipmentList=function selectShipmentList(state){var salesOrder=selectSalesOrder(state);return salesOrder?salesOrder.shipmentList:[];};var selectSentEmailList=function selectSentEmailList(state){var salesOrder=selectSalesOrder(state);return salesOrder?salesOrder.sentEmailList:[];};var selectInvoiceList=function selectInvoiceList(state){var salesOrder=selectSalesOrder(state);return salesOrder?salesOrder.invoiceList:[];};var selectPaymentList=function selectPaymentList(state){var salesOrder=selectSalesOrder(state);return salesOrder?salesOrder.paymentList:[];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectSalesOrderCustomer=function selectSalesOrderCustomer(state){var salesOrder=selectSalesOrder(state);return salesOrder?salesOrder.salesOrderCustomer:null;};var selectSalesOrderCustomerContact=function selectSalesOrderCustomerContact(state){return selectOwnState(state).contact;};var selectAPIError=function selectAPIError(state){return selectOwnState(state).error;};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return initialTableQuerySet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return changeFilterSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return toggleSortSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return toggleMultiSortSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return gotoPageSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return initialTableSettingsSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return toggleColumnVisibilitySet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return initialTableQueryCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFilterCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return toggleSortCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return toggleMultiSortCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return gotoPageCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return initialTableSettingsCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return toggleColumnVisibilityCheckIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return initialTableQueryInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return changeFilterInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return toggleSortInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return toggleMultiSortInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return gotoPageInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return initialTableSettingsInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return toggleColumnVisibilityInShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return initialTableQueryShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return changeFilterShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return toggleSortShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return toggleMultiSortShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return gotoPageShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return initialTableSettingsShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return toggleColumnVisibilityShopScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return initialTableQueryTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return changeFilterTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return toggleSortTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return toggleMultiSortTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return gotoPageTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return initialTableSettingsTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return toggleColumnVisibilityTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return initialTableQueryRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return changeFilterRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return toggleSortRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return toggleMultiSortRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return gotoPageRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return initialTableSettingsRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return toggleColumnVisibilityRefinementProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return initialTableQueryRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return changeFilterRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return toggleSortRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return toggleMultiSortRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return gotoPageRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return initialTableSettingsRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return toggleColumnVisibilityRefinementSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return initialTableQueryRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return changeFilterRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return toggleSortRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return toggleMultiSortRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return gotoPageRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return initialTableSettingsRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return toggleColumnVisibilityRefinementShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return initialTableQueryRefinementBooking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return changeFilterRefinementBooking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return toggleSortRefinementBooking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return toggleMultiSortRefinementBooking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return gotoPageRefinementBooking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return initialTableQueryRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return changeFilterRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return toggleSortRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return toggleMultiSortRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return gotoPageRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return initialTableSettingsRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return toggleColumnVisibilityRetainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return initialTableQueryRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return changeFilterRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return toggleSortRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return toggleMultiSortRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return gotoPageRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return initialTableSettingsRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return toggleColumnVisibilityRetainerRefinement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return initialTableQueryEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeFilterEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return toggleSortEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return toggleMultiSortEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return gotoPageEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return initialTableSettingsEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return toggleColumnVisibilityEscalation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return initialTableQueryEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeFilterEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return toggleSortEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return toggleMultiSortEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return gotoPageEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return initialTableSettingsEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return toggleColumnVisibilityEndOfTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return initialTableQueryImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeFilterImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return toggleSortImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return toggleMultiSortImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return gotoPageImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return initialTableSettingsImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return toggleColumnVisibilityImplant3dScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return initialTableQueryImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeFilterImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return toggleSortImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return toggleMultiSortImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return gotoPageImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return initialTableSettingsImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return toggleColumnVisibilityImplantPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return initialTableQueryImplantTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeFilterImplantTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return toggleSortImplantTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return toggleMultiSortImplantTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return gotoPageImplantTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return initialTableSettingsImplantTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return toggleColumnVisibilityImplantTreatment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(50);
/* set */var initialTableQuerySet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);var changeFilterSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);var toggleSortSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);var toggleMultiSortSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);var gotoPageSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);var initialTableSettingsSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);var toggleColumnVisibilitySet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["p" /* selectSetTable */],__WEBPACK_IMPORTED_MODULE_0__type__["n" /* TABLE_SET */]);/* checkin */var initialTableQueryCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);var changeFilterCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);var toggleSortCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);var toggleMultiSortCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);var gotoPageCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);var initialTableSettingsCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);var toggleColumnVisibilityCheckIn=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectCheckInTable */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TABLE_CHECK_IN */]);/* in shop scan */var initialTableQueryInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);var changeFilterInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);var toggleSortInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);var toggleMultiSortInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);var gotoPageInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);var initialTableSettingsInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);var toggleColumnVisibilityInShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["g" /* selectInShopScanTable */],__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TABLE_IN_SHOP_SCAN */]);/* in shop */var initialTableQueryShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);var changeFilterShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);var toggleSortShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);var toggleMultiSortShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);var gotoPageShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);var initialTableSettingsShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);var toggleColumnVisibilityShopScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["q" /* selectShopScanTable */],__WEBPACK_IMPORTED_MODULE_0__type__["o" /* TABLE_SHOP_SCAN */]);/* treatment */var initialTableQueryTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);var changeFilterTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);var toggleSortTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);var toggleMultiSortTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);var gotoPageTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);var initialTableSettingsTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);var toggleColumnVisibilityTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["r" /* selectTreatmentTable */],__WEBPACK_IMPORTED_MODULE_0__type__["p" /* TABLE_TREATMENT */]);/* treatment */var initialTableQueryRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var changeFilterRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var toggleSortRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var toggleMultiSortRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var gotoPageRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var initialTableSettingsRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);var toggleColumnVisibilityRefinementProduction=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["k" /* selectRefinementProductionTable */],__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]);/* refinement set */var initialTableQueryRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);var changeFilterRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);var toggleSortRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);var toggleMultiSortRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);var gotoPageRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);var initialTableSettingsRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);var toggleColumnVisibilityRefinementSet=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["l" /* selectRefinementSetTable */],__WEBPACK_IMPORTED_MODULE_0__type__["j" /* TABLE_REFINEMENT_SET */]);/* refinement shop */var initialTableQueryRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);var changeFilterRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);var toggleSortRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);var toggleMultiSortRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);var gotoPageRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);var initialTableSettingsRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);var toggleColumnVisibilityRefinementShop=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectRefinementShopTable */],__WEBPACK_IMPORTED_MODULE_0__type__["k" /* TABLE_REFINEMENT_SHOP */]);/* refinement booking */var initialTableQueryRefinementBooking=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["h" /* TABLE_REFINEMENT_BOOKING */]);var changeFilterRefinementBooking=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["h" /* TABLE_REFINEMENT_BOOKING */]);var toggleSortRefinementBooking=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["h" /* TABLE_REFINEMENT_BOOKING */]);var toggleMultiSortRefinementBooking=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["h" /* TABLE_REFINEMENT_BOOKING */]);var gotoPageRefinementBooking=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["h" /* TABLE_REFINEMENT_BOOKING */]);/* retainer */var initialTableQueryRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);var changeFilterRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);var toggleSortRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);var toggleMultiSortRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);var gotoPageRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);var initialTableSettingsRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);var toggleColumnVisibilityRetainer=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["o" /* selectRetainerTable */],__WEBPACK_IMPORTED_MODULE_0__type__["l" /* TABLE_RETAINER */]);/* retainer */var initialTableQueryRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var changeFilterRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var toggleSortRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var toggleMultiSortRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var gotoPageRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var initialTableSettingsRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);var toggleColumnVisibilityRetainerRefinement=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectRetainerRefinementTable */],__WEBPACK_IMPORTED_MODULE_0__type__["m" /* TABLE_RETAINER_REFINEMENT */]);/* escalation */var initialTableQueryEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);var changeFilterEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);var toggleSortEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);var toggleMultiSortEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);var gotoPageEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);var initialTableSettingsEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);var toggleColumnVisibilityEscalation=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectEscalationTable */],__WEBPACK_IMPORTED_MODULE_0__type__["c" /* TABLE_ESCALATION */]);/* end of treatment */var initialTableQueryEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);var changeFilterEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);var toggleSortEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);var toggleMultiSortEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);var gotoPageEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);var initialTableSettingsEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);var toggleColumnVisibilityEndOfTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectEndOfTreatmentTable */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* TABLE_END_OF_TREATMENT */]);/* implant 3d scan */var initialTableQueryImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var changeFilterImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var toggleSortImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var toggleMultiSortImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var gotoPageImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var initialTableSettingsImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);var toggleColumnVisibilityImplant3dScan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectImplant3dScanTable */],__WEBPACK_IMPORTED_MODULE_0__type__["d" /* TABLE_IMPLANT_3DSCAN */]);/* implant plan */var initialTableQueryImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);var changeFilterImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);var toggleSortImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);var toggleMultiSortImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);var gotoPageImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);var initialTableSettingsImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);var toggleColumnVisibilityImplantPlan=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["e" /* selectImplantPlanTable */],__WEBPACK_IMPORTED_MODULE_0__type__["e" /* TABLE_IMPLANT_PLAN */]);/* implant treatment */var initialTableQueryImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var changeFilterImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var toggleSortImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var toggleMultiSortImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["i" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var gotoPageImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var initialTableSettingsImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);var toggleColumnVisibilityImplantTreatment=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["f" /* selectImplantTreatmentTable */],__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TABLE_IMPLANT_TREATMENT */]);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_component_Table__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__set_column_list__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shop_scan_column_list__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__in_shop_scan_column_list__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__treatment_column_list__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__refinement_column_list__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_const__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__table_component_TableColumnSelector__ = __webpack_require__(121);
var getColumnList=function getColumnList(type){switch(type){case'set':return __WEBPACK_IMPORTED_MODULE_4__set_column_list__["a" /* default */];case'shop-scan':case'shop-scan-new':return __WEBPACK_IMPORTED_MODULE_5__shop_scan_column_list__["a" /* default */];case'check-in':case'in-shop-scan':case'in-shop-scan-new':return __WEBPACK_IMPORTED_MODULE_6__in_shop_scan_column_list__["a" /* default */];case'treatment':case'treatment-new':case'refinement-production':return __WEBPACK_IMPORTED_MODULE_7__treatment_column_list__["a" /* default */];default:return __WEBPACK_IMPORTED_MODULE_8__refinement_column_list__["a" /* default */];}};var TITLE={'set':'Set','treatment':'Treatment','treatment-new':'Treatment New','end-of-treatment':'End Of Treatment','shop-scan':'Shop Scan','shop-scan-new':'Shop Scan New','in-shop-scan':'Clinic 3D-Scan','in-shop-scan-new':'Clinic 3D-Scan New','check-in':'Clinic Check-In','retainer':'Retainer','retainer-new':'Retainer New','refinement-set':'Refinement Set','refinement-booking':'Refinement Shop Booking','refinement-shop':'Refinement Shop Scan','refinement-shop-new':'Refinement Shop Scan New','refinement-production':'Refinement Treatment','escalation':'Escalation','implant-3d-scan':'Implant Clinic 3D-Scan','implant-plan':'Implant Plan','implant-treatment':'Implant Treatment','retainer-refinement':'Retainer Refinement','retainer-refinement-new':'Retainer Refinement New'};var SalesOrderSearch=function SalesOrderSearch(_ref){var type=_ref.type,tableData=_ref.tableData,changeFilter=_ref.changeFilter,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,gotoPage=_ref.gotoPage,navigateToSalesOrder=_ref.navigateToSalesOrder,toggleColumnVisibility=_ref.toggleColumnVisibility;var title=TITLE[type];var columnList=getColumnList(type);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__table_component_TableColumnSelector__["a" /* default */],{resultsNumber:tableData.objectList.length,hiddenColumns:tableData.hiddenColumns,columnList:columnList,toggleColumnVisibility:toggleColumnVisibility}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__table_component_Table__["a" /* default */],Object.assign({},tableData,{changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,gotoPage:gotoPage,idProperty:'id',columnList:columnList,onRowClick:function onRowClick(salesOrder){navigateToSalesOrder(salesOrder.id);},filterSetting:{vip:{type:'select',valueList:[{id:'0',value:'no influencer'},{id:'1',value:'influencer'}]},paymentMethod:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_10__state_const__["a" /* PAYMENT_METHOD_SELECT */]},paymentReceived:{type:'select',valueList:[{id:'0',value:'no'},{id:'1',value:'yes'}]},store:{type:'select',valueList:Object(__WEBPACK_IMPORTED_MODULE_11__store_util_renderStoreName__["a" /* getStoreDropDown */])()},countryCode:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_12__internationalization_const__["e" /* COUNTRY_CODE_LIST */]},status:{type:'input',beforeQuery:function beforeQuery(value){if(!value){return value;}return value.replace(/ /g,'_');},beforeRender:function beforeRender(value){if(!value){return value;}return value.replace(/_/g,' ');}}}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableQuery();if(this.props.initialColumnsVisibility){this.props.initialColumnsVisibility();}}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(SalesOrderSearch)));

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uploadCustomerFileRequest */
/* unused harmony export uploadCustomerFileSuccess */
/* unused harmony export uploadCustomerFileError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uploadCustomerFile; });
/* unused harmony export setDeleteFlagRequest */
/* unused harmony export setDeleteFlagSuccess */
/* unused harmony export setDeleteFlagError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDeleteFlag; });
/* unused harmony export triggerVisualizationRequest */
/* unused harmony export triggerVisualizationSuccess */
/* unused harmony export triggerVisualizationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return triggerVisualization; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(29);
var _ADD_FILE_ENDPOINT_LI;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ADD_FILE_ENDPOINT_LIST=(_ADD_FILE_ENDPOINT_LI={},_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["d" /* FILE_TYPE_IMAGE */],''),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["i" /* FILE_TYPE_SCAN_FILE */],'/api/customer/add-scan-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["e" /* FILE_TYPE_IMPLANT_SCAN_FILE */],'/api/customer/add-implant-scan-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["l" /* FILE_TYPE_X_RAY */],'/api/customer/add-x-ray-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["j" /* FILE_TYPE_TREATMENT_PLAN */],'/api/customer/add-treatment-plan-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */],'/api/customer/add-treatment-plan-external-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["h" /* FILE_TYPE_PRODUCTION */],'/api/customer/add-production-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["f" /* FILE_TYPE_IMPLANT_TREATMENT_PLAN */],'/api/customer/add-implant-treatment-plan-file?customerId='),_defineProperty(_ADD_FILE_ENDPOINT_LI,__WEBPACK_IMPORTED_MODULE_2__const__["g" /* FILE_TYPE_OTHER_FILES */],'/api/customer/add-other-file?customerId='),_ADD_FILE_ENDPOINT_LI);var getEndpoint=function getEndpoint(fileType,customerId){return __WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+ADD_FILE_ENDPOINT_LIST[fileType]+customerId||'';};var uploadCustomerFileRequest=function uploadCustomerFileRequest(fileType){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* UPLOAD_CUSTOMER_FILE_REQUEST */],payload:{fileType:fileType}};};var uploadCustomerFileSuccess=function uploadCustomerFileSuccess(fileType,file){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* UPLOAD_CUSTOMER_FILE_SUCCESS */],payload:{fileType:fileType,file:file}};};var uploadCustomerFileError=function uploadCustomerFileError(fileType,error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* UPLOAD_CUSTOMER_FILE_ERROR */],payload:{fileType:fileType,error:error}};};var uploadCustomerFile=function uploadCustomerFile(fileList,customerId,fileType,onUploadSuccess){return function(dispatch,getState){dispatch(uploadCustomerFileRequest(fileType));for(var index=0;index<fileList.length;index++){var data=new FormData();data.append('file',fileList[index]);var endpoint=getEndpoint(fileType,customerId);fetch(endpoint,{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(file){dispatch(uploadCustomerFileSuccess(fileType,file));onUploadSuccess(fileType,file);}).catch(function(error){dispatch(uploadCustomerFileError(fileType,error));});}};};var setDeleteFlagRequest=function setDeleteFlagRequest(fileType,fileId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* SET_DELETE_FLAG_REQUEST */],payload:{fileType:fileType,fileId:fileId}};};var setDeleteFlagSuccess=function setDeleteFlagSuccess(fileType,fileId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* SET_DELETE_FLAG_SUCCESS */],payload:{fileType:fileType,fileId:fileId}};};var setDeleteFlagError=function setDeleteFlagError(fileType,error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* SET_DELETE_FLAG_ERROR */],payload:{fileType:fileType,error:error}};};var setDeleteFlag=function setDeleteFlag(fileType,fileId,onDeleteFlagSuccess){return function(dispatch,getState){dispatch(setDeleteFlagRequest(fileType,fileId));Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/file-system/set-delete-flag?fileId='+fileId).then(function(){dispatch(setDeleteFlagSuccess(fileType,fileId));onDeleteFlagSuccess(fileType,fileId);}).catch(function(error){dispatch(setDeleteFlagError(fileType,error));});};};var triggerVisualizationRequest=function triggerVisualizationRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TRIGGER_VISUALIZATION_REQUEST */]};};var triggerVisualizationSuccess=function triggerVisualizationSuccess(fileType,fileId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* TRIGGER_VISUALIZATION_SUCCESS */]};};var triggerVisualizationError=function triggerVisualizationError(fileType,error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TRIGGER_VISUALIZATION_ERROR */]};};var triggerVisualization=function triggerVisualization(customerId){return function(dispatch,getState){dispatch(triggerVisualizationRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/treatment/visualization/trigger?customerId='+customerId+'&processInstanceId='+customerId).then(function(){dispatch(triggerVisualizationSuccess());}).catch(function(error){dispatch(triggerVisualizationError(error));});};};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_file_upload_const__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__process_ui_definition_sales_order_set_and_shop_scan_task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_upload_helper__ = __webpack_require__(536);
var _HEADER_NAME_LIST;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var style={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'32px'};var VIEW_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/view-file?fileId=';var DOWNLOAD_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/download-file?fileId=';var PRODUCTION_FILE_DOWNLOAD_ALL_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/production/download-production-files?customerId=';var HEADER_NAME_LIST=(_HEADER_NAME_LIST={},_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["d" /* FILE_TYPE_IMAGE */],'Customer Images'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["l" /* FILE_TYPE_X_RAY */],'X Ray Files'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["i" /* FILE_TYPE_SCAN_FILE */],'Scan Files'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["e" /* FILE_TYPE_IMPLANT_SCAN_FILE */],'Implant Scan Files'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["j" /* FILE_TYPE_TREATMENT_PLAN */],'Treatment Plan Files'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */],'Treatment Plan External Files'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["h" /* FILE_TYPE_PRODUCTION */],'Production Files'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["b" /* FILE_TYPE_CONFORMITY_DECLARATION */],'Conformity declaration(s)'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["c" /* FILE_TYPE_CUSTOMS_INVOICE */],'Customs Invoice'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["f" /* FILE_TYPE_IMPLANT_TREATMENT_PLAN */],'Implant Treatment Plan'),_defineProperty(_HEADER_NAME_LIST,__WEBPACK_IMPORTED_MODULE_10__state_const__["g" /* FILE_TYPE_OTHER_FILES */],'Other Files'),_HEADER_NAME_LIST);var UploadedFileTable=function UploadedFileTable(_ref){var fileList=_ref.fileList,fileType=_ref.fileType,readOnly=_ref.readOnly,setDeleteFlag=_ref.setDeleteFlag,onFileDeleteFlagSuccess=_ref.onFileDeleteFlagSuccess;if(!fileList){return null;}if(fileType===__WEBPACK_IMPORTED_MODULE_10__state_const__["h" /* FILE_TYPE_PRODUCTION */]){fileList.sort(__WEBPACK_IMPORTED_MODULE_13__util_upload_helper__["b" /* sortProductionFilesByName */]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'File name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Uploaded'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Download'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Uploaded by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,fileList.map(function(file){if(file.deleted){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:file.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,file.fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__util_datetime__["c" /* formatDateTime */])(file.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:DOWNLOAD_URL+file.id},'download')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:VIEW_URL+file.id,target:'_blank',rel:'noopener noreferrer'},'view')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,file.createdByUser),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){setDeleteFlag(fileType,file.id,onFileDeleteFlagSuccess);},disabled:readOnly,className:'btn btn-primary btn-sm'},'delete')));})));};var CustomerFileUpload=function CustomerFileUpload(_ref2){var _ref2$widgetId=_ref2.widgetId,widgetId=_ref2$widgetId===undefined?null:_ref2$widgetId,customer=_ref2.customer,fileType=_ref2.fileType,uploadCustomerFile=_ref2.uploadCustomerFile,onUploadSuccess=_ref2.onUploadSuccess,setDeleteFlag=_ref2.setDeleteFlag,onFileDeleteFlagSuccess=_ref2.onFileDeleteFlagSuccess,fetching=_ref2.fetching,readOnly=_ref2.readOnly,triggerVisualization=_ref2.triggerVisualization,visualizationRequested=_ref2.visualizationRequested,taskName=_ref2.taskName;if(widgetId&&!Object(__WEBPACK_IMPORTED_MODULE_11__util_widget_helper__["a" /* default */])(widgetId)){return null;}if(!customer){return null;}var fileList=customer[fileType];var isTriggerButtonShown=taskName===__WEBPACK_IMPORTED_MODULE_12__process_ui_definition_sales_order_set_and_shop_scan_task_name__["S" /* UPLOAD_TREATMENT_PLAN_FILES */]?'none':'block';var displayedFileCount='';if(fileType===__WEBPACK_IMPORTED_MODULE_10__state_const__["h" /* FILE_TYPE_PRODUCTION */]){var nonDeletedFileCount=fileList.filter(function(obj){return obj.deleted===false;}).length;if(nonDeletedFileCount!==0)displayedFileCount='('+nonDeletedFileCount+')';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:HEADER_NAME_LIST[fileType]+' '+displayedFileCount},triggerVisualization&&!visualizationRequested&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){triggerVisualization(customer.id);},disabled:readOnly,style:{display:isTriggerButtonShown},className:'btn btn-primary btn-sm'},'trigger Visualization'))),fileType===__WEBPACK_IMPORTED_MODULE_10__state_const__["h" /* FILE_TYPE_PRODUCTION */]&&fileList.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:PRODUCTION_FILE_DOWNLOAD_ALL_URL+customer.id,className:'btn btn-primary btn-sm',target:'_blank',rel:'noopener noreferrer'},'Download all ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-cloud-download'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UploadedFileTable,{onFileDeleteFlagSuccess:onFileDeleteFlagSuccess,readOnly:readOnly,setDeleteFlag:setDeleteFlag,fileType:fileType,fileList:fileList}))),uploadCustomerFile!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__["a" /* default */],{multiple:true,maxSize:__WEBPACK_IMPORTED_MODULE_6__state_file_upload_const__["a" /* MAX_SCAN_FILE_SIZE */],style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadCustomerFile(fileList,customer.id,fileType,onUploadSuccess);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload a file'))))));};CustomerFileUpload.propTypes={widgetId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fileType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,triggerVisualization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,visualizationRequested:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,taskName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CustomerFileUpload);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PRODUCT_TYPE_ALIGNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRODUCT_TYPE_IMPLANTS; });
/* unused harmony export SUPPLIER_ID_KEY_MAP */
/* unused harmony export SUPPLIER_TECHNICAL_NAME_SUNSHINE_SMILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SUPPLIER_TECHNICAL_NAME_HAT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getQuotationCommentSelectValues; });
/* unused harmony export QUOTATION_COMMENT_SELECT_VALUES */
/* unused harmony export QUOTATION_COMMENT_SELECT_VALUES_WITHOUT_PRETREATMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return QUOTATION_COMMENT_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PACKAGESIZE_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRETREATMENT_NEEDED_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ATTACHMENT_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALIGNER_SYSTEM_LIST_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALIGNER_SYSTEM_DEFAULT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALIGNER_SYSTEM_LIST_HAT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALIGNER_SYSTEM_ALIGNERS_PER_STEP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_localized_text_with_replacements__ = __webpack_require__(393);
var _QUOTATION_COMMENT_TE;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUCER_NAME='quotation';var PRODUCT_TYPE_ALIGNERS='aligners';var PRODUCT_TYPE_IMPLANTS='implants';var QUOTATION_COMMENT_NOT_PERFECT='final_result_not_perfect';var QUOTATION_COMMENT_PZR_REQUIRED='pzr_required';var QUOTATION_COMMENT_PZR_RECOMMENDED='pzr_recommended';var QUOTATION_COMMENT_DURATION_DIFFERS='duration_differs';var QUOTATION_COMMENT_PRETREATMENT='pretreatment';var PACKAGESIZE_LIGHT='light';var PACKAGESIZE_MEDIUM='medium';var PACKAGESIZE_COMPLEX='complex';var SUPPLIER_ID_KEY_MAP={// for staging
'df3d945ad5e-016a-052c-46bc809e8ab9':'hat_group','df3d945ad80-9b5d-447f-49d98b3a4287':'sunshine_smile',// for prod
'df42ffbd2c7-f030-e185-4b6e9e9af833':'hat_group','df42ffbd2ec-1c61-6491-4d75802ba516':'sunshine_smile'};var SUPPLIER_TECHNICAL_NAME_SUNSHINE_SMILE='sunshine_smile';var SUPPLIER_TECHNICAL_NAME_HAT_GROUP='hat_group';var getQuotationCommentSelectValues=function getQuotationCommentSelectValues(isPretreatmentNeeded){return isPretreatmentNeeded?QUOTATION_COMMENT_SELECT_VALUES:QUOTATION_COMMENT_SELECT_VALUES_WITHOUT_PRETREATMENT;};var QUOTATION_COMMENT_SELECT_VALUES=[{id:QUOTATION_COMMENT_NOT_PERFECT,value:'Result not optimal'},{id:QUOTATION_COMMENT_PZR_REQUIRED,value:'PZR required'},{id:QUOTATION_COMMENT_PZR_RECOMMENDED,value:'PZR recommended'},{id:QUOTATION_COMMENT_DURATION_DIFFERS,value:'Duration differs'},{id:QUOTATION_COMMENT_PRETREATMENT,value:'Pretreatment'}];var QUOTATION_COMMENT_SELECT_VALUES_WITHOUT_PRETREATMENT=[{id:QUOTATION_COMMENT_NOT_PERFECT,value:'Result not optimal'},{id:QUOTATION_COMMENT_PZR_REQUIRED,value:'PZR required'},{id:QUOTATION_COMMENT_PZR_RECOMMENDED,value:'PZR recommended'},{id:QUOTATION_COMMENT_DURATION_DIFFERS,value:'Duration differs'}];var QUOTATION_COMMENT_TEXT=(_QUOTATION_COMMENT_TE={},_defineProperty(_QUOTATION_COMMENT_TE,QUOTATION_COMMENT_NOT_PERFECT,Object(__WEBPACK_IMPORTED_MODULE_0__util_localized_text_with_replacements__["a" /* default */])({DE:'Ihr Behandlungsplan zeigt das mit PlusDental Zahnschienen erreichbare optimale Ergebnis. Gerne besprechen wir Ihre Behandlung mit Ihnen im persönlichen Expertengespräch- buchen Sie sich einfach in der entsprechenden Auswahl unter Ihrem Behandlungsplan einen Termin.',GB:'Your treatment plan shows the optimal result which can be achieved with PlusDent aligners. We are go through your treatment plan with you and one of our experts- simply book a phone call with our Expert-team right below your treatment plan.',NL:'Uw behandelplan toont het optimale resultaat dat kan worden bereikt met Plus Dental aligners. We nemen uw behandelplan met u en een van onze experts door - boek eenvoudig een telefoongesprek met ons Expert-team onder uw behandelplan.',SE:'Din behandlingsplan visar det optimala resultatet som kan uppnås med PlusDentals tandskenor. Vi går gärna igenom din behandlingsplan med dig och en av våra experter - boka helt enkelt ett telefonsamtal med vårt Expert-team direkt under din behandlingsplan.'})),_defineProperty(_QUOTATION_COMMENT_TE,QUOTATION_COMMENT_PZR_REQUIRED,Object(__WEBPACK_IMPORTED_MODULE_0__util_localized_text_with_replacements__["a" /* default */])({DE:'Bei Ihnen wurde eine Entzündung und/oder Zahnstein diagnostiziert. Daher ist eine professionelle Zahnreinigung vor Einsetzen der ersten Zahnschienen unbedingt notwendig. Dies dient sowohl Ihrer Mundgesundheit, als auch dem Behandlungsergebnis. Erfolgt die Zahnreinigung vor Einsetzen der Zahnschienen nicht, beeinträchtigt es die Passgenauigkeit der Zahnschienen und so kann das errechnete Behandlungsergebnis nicht garantiert werden.',GB:'Prior to your treatment beginning you should have a professional teeth cleaning done with your dentist. This is a prerequisite for fitting your aligners and to achieve your optimal treatment results.',NL:'Voordat uw behandeling begint, moet u een professionele gebitsreiniging laten uitvoeren door uw tandarts. Dit is een voorwaarde voor het passen van uw aligners en voor het bereiken van uw optimale behandelresultaten.',SE:'En professionell tandrengöring är nödvändig innan du börjar använda dina tandskenor. Det gynnar både resultatet av din behandling såväl som din tandhälsa. Om du inte rengör tänderna ordentligt innan du använder skenorna kan det påverka hur skenorna sitter på tänderna och det optimala behandlingsresultatet kan därmed inte garanteras.'})),_defineProperty(_QUOTATION_COMMENT_TE,QUOTATION_COMMENT_PZR_RECOMMENDED,Object(__WEBPACK_IMPORTED_MODULE_0__util_localized_text_with_replacements__["a" /* default */])({DE:'Bitte lassen Sie eine professionelle Zahnreinigung vor Einsetzen der ersten Schienen bei Ihrem Hauszahnarzt durchführen. Danach sind Sie startklar für die Zahnschienenbehandlung.',GB:"We'd recommend to have a professional teeth cleaning done prior to your treatment with PlusDent aligners. Good dental hygiene ensures that you achieve an optimal treatment result.",NL:'We raden u aan om een professionele gebitsreiniging te ondergaan, voordat u de behandeling start bij. Een goede gebitshygiëne zorgt ervoor dat u een optimaal behandelresultaat behaalt.',SE:'Vi rekommenderar att din tandläkare utför en professionell tandrengöring innan du börjar använda dina tandskenor. Detta kommer att gynna både din tandhälsa såväl som resultatet av behandlingen.'})),_defineProperty(_QUOTATION_COMMENT_TE,QUOTATION_COMMENT_DURATION_DIFFERS,Object(__WEBPACK_IMPORTED_MODULE_0__util_localized_text_with_replacements__["a" /* default */])({DE:'Ihre Behandlung zeigt eine unterschiedliche Schienenanzahl pro Kiefer auf. Bitte tragen Sie die letzte Zahnschiene, der kürzeren Behandlung, insgesamt vier Wochen (statt nur zwei Wochen) und danach nur noch nachts. In Ihrem anderem Kiefer führen Sie bitte Ihre Behandlung regulär weiter und wechseln, wie in Ihrem Behandlungsplan vorgesehen, die Zahnschienen aus.',GB:'Your treatment shows a different number of aligners per jaw. Please wear the last set of aligners for the jaw with the shorter treatment period for four weeks (instead of just two) and then switch to wearing them at night only. For the other jaw you should continue to wear and switch the aligner sets as prescribed until you have finished the treatment.',NL:'Uw behandeling toont een verschillend aantal aligners per kaak. Draag de laatste set aligners voor de kaak met de kortere behandelperiode gedurende vier weken (in plaats van twee) en wacht tot de nacht retainer binnen is of anders bestel deze. Zodra deze ontvangen is kunt u hierop overstappen. Voor de andere kaak moet u de alignersets blijven dragen en wisselen zoals voorgeschreven totdat u klaar bent met de behandeling.',SE:'Din behandling visar olika antal tandskenor per käke. Bär den sista skenan för käken med den kortare behandlingsperioden i fyra veckor (i stället för bara två) och övergå sedan till att bara bära dem på natten. För den andra käken ska du fortsätta att bära och byta skenor enligt instruktionerna tills du har avslutat behandlingen.'})),_defineProperty(_QUOTATION_COMMENT_TE,QUOTATION_COMMENT_PRETREATMENT,Object(__WEBPACK_IMPORTED_MODULE_0__util_localized_text_with_replacements__["a" /* default */])({DE:'Bei dem Besuch in unserer Praxis haben wir festgestellt, dass eine Vorbehandlung notwendig ist. Bitte tragen Sie die Zahnschienen erst, wenn Sie die Vorbehandlung abgeschlossen haben.',GB:'During the visit in our practice, we discovered that a pretreatment is necessary. Please do not wear the aligners until you have completed the pre-treatment.',ES:'Durante la visita a nuestra clínica dental, descubrimos si es necesario un pretratamiento. Por favor, no use los alineadores hasta que haya completado el pretratamiento.'})),_QUOTATION_COMMENT_TE);var PACKAGESIZE_VALUES=[{id:PACKAGESIZE_LIGHT,value:'Leicht'},{id:PACKAGESIZE_MEDIUM,value:'Medium'},{id:PACKAGESIZE_COMPLEX,value:'Complex'}];var PRETREATMENT_NEEDED_VALUES=[{id:false,value:'No Pretreatment required'},{id:true,value:'Pretreatment required'}];var ATTACHMENT_VALUES=[{id:true,value:'Attachment Needed'},{id:false,value:'Attachment Not Needed'}];var ALIGNER_SYSTEM_LIST_FULL=[{id:'2-2',value:'2-2'},{id:'1-1-2',value:'1-1-2'}];var ALIGNER_SYSTEM_DEFAULT_VALUE='2-2';var ALIGNER_SYSTEM_LIST_HAT_GROUP=[{id:'2-2',value:'2-2'}];var ALIGNER_SYSTEM_ALIGNERS_PER_STEP={'1-1-2':3,'2-2':2};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setStoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderStoreName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderStoreNameById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStoreDropDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_sort__ = __webpack_require__(221);
var storeList=[];var setStoreList=function setStoreList(_storeList){Object(__WEBPACK_IMPORTED_MODULE_0__util_sort__["a" /* sortByProperty */])(_storeList,'displayName');storeList=_storeList;};var renderStoreName=function renderStoreName(storeTechnicalName){if(!storeList){return storeTechnicalName;}for(var index=0;index<storeList.length;index++){var store=storeList[index];if(store.technicalName===storeTechnicalName){return store.displayName;}}return storeTechnicalName;};var renderStoreNameById=function renderStoreNameById(storeId){if(!storeList){return'';}for(var index=0;index<storeList.length;index++){var store=storeList[index];if(store.id===storeId){return store.displayName;}}return'';};var getStoreDropDown=function getStoreDropDown(){return storeList.map(function(store){return{id:store.id,value:store.displayName};});};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _has;
function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_map__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_xmap__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys__ = __webpack_require__(75);








/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
var map = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['fantasy-land/map', 'map'], __WEBPACK_IMPORTED_MODULE_4__internal_xmap__["a" /* default */], function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return Object(__WEBPACK_IMPORTED_MODULE_5__curryN__["a" /* default */])(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce__["a" /* default */])(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, Object(__WEBPACK_IMPORTED_MODULE_6__keys__["a" /* default */])(functor));
    default:
      return Object(__WEBPACK_IMPORTED_MODULE_2__internal_map__["a" /* default */])(fn, functor);
  }
}));
/* harmony default export */ __webpack_exports__["a"] = (map);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var NO_AUTOCORRECT={autoComplete:'off',autoCorrect:'off',spellCheck:'false'};var TextArea=function TextArea(_ref){var _onChange=_ref.onChange,name=_ref.name,object=_ref.object,validation=_ref.validation,placeholder=_ref.placeholder,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className,_ref$type=_ref.type,type=_ref$type===undefined?'text':_ref$type,_ref$onBlur=_ref.onBlur,onBlur=_ref$onBlur===undefined?function(){}:_ref$onBlur,_ref$autoCapitalize=_ref.autoCapitalize,autoCapitalize=_ref$autoCapitalize===undefined?'words':_ref$autoCapitalize,_ref$autoCorrect=_ref.autoCorrect,autoCorrect=_ref$autoCorrect===undefined?true:_ref$autoCorrect,_ref$readOnly=_ref.readOnly,readOnly=_ref$readOnly===undefined?false:_ref$readOnly;className=validation&&validation[name]?'form-control text-area-default error '+className:'form-control text-area-default '+className;var autoCorrectAttributes=autoCorrect?{}:NO_AUTOCORRECT;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',Object.assign({className:className,placeholder:placeholder,value:object[name]||'',name:name,onBlur:onBlur},autoCorrectAttributes,{autoCapitalize:autoCapitalize,readOnly:readOnly,onChange:function onChange(event){_onChange(name,event.target.value);}}));};TextArea.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,object:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,validation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,autoCapitalize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,autoCorrect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectOwnState; });
/* unused harmony export selectAnamnesisListState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectAnamnesisList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAnamnesisByTemplateKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectMedicalAssessment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectShowAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectShowInfoLegendShown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(521);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["i" /* REDUCER_NAME */]];};var selectAnamnesisListState=function selectAnamnesisListState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state).list;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectAnamnesisList=function selectAnamnesisList(state){return selectOwnState(state).anamnesisList;};var selectAnamnesisByTemplateKey=function selectAnamnesisByTemplateKey(state,templateKey){var anamnesisList=selectAnamnesisList(state);return anamnesisList[templateKey];};var selectMedicalAssessment=function selectMedicalAssessment(state){return selectAnamnesisByTemplateKey(state,__WEBPACK_IMPORTED_MODULE_0__const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]);};var selectShowAnamnesis=function selectShowAnamnesis(state){return selectOwnState(state).showAnamnesis;};var selectShowInfoLegendShown=function selectShowInfoLegendShown(state){return selectOwnState(state).isInfoLegendShown;};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _reduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xwrap__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind__ = __webpack_require__(403);




function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}

function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}

function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](Object(__WEBPACK_IMPORTED_MODULE_2__bind__["a" /* default */])(xf['@@transducer/step'], xf), acc));
}

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

function _reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = Object(__WEBPACK_IMPORTED_MODULE_1__xwrap__["a" /* default */])(fn);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike__["a" /* default */])(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_equals__ = __webpack_require__(843);



/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
var equals = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function equals(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_equals__["a" /* default */])(a, b, [], []);
});
/* harmony default export */ __webpack_exports__["a"] = (equals);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var VIP_STYLE={color:'#f1c40f'};var VipIcon=function VipIcon(_ref){var active=_ref.active,_ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?function(){}:_ref$onClick;if(active){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-star',onClick:onClick,style:VIP_STYLE});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-star-o',onClick:onClick,style:VIP_STYLE});};VipIcon.propTypes={active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (VipIcon);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function Loader() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "loading-indicator" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "loading-bullet" },
      "\u2022"
    ),
    ' ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "loading-bullet" },
      "\u2022"
    ),
    ' ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "loading-bullet" },
      "\u2022"
    )
  );
}

// https://gist.github.com/Alex1990/046a6553dc83e22dd6f4
/**
 * Get the current active element safely.
 * Ref: https://github.com/jquery/jquery-ui/blob/2b84531ae9331f60e4d739fabca6d78abde89ae1/ui/safe-active-element.js
 */
function safeActiveElement(doc) {
  doc = doc || document;
  var activeElement = void 0;

  try {
    activeElement = document.activeElement;
    if (!activeElement || !activeElement.nodeName) {
      activeElement = doc.body;
    }
  } catch (error) {
    activeElement = doc.body;
  }

  return activeElement;
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var defaultProps = {
  tag: 'div',
  renderChildren: true,
  loader: Loader
};

var BlockUi$1 = function (_Component) {
  inherits(BlockUi, _Component);

  function BlockUi(props) {
    classCallCheck(this, BlockUi);

    var _this = possibleConstructorReturn(this, (BlockUi.__proto__ || Object.getPrototypeOf(BlockUi)).call(this, props));

    _this.tabbedUpTop = _this.tabbedUpTop.bind(_this);
    _this.tabbedDownTop = _this.tabbedDownTop.bind(_this);
    _this.tabbedUpBottom = _this.tabbedUpBottom.bind(_this);
    _this.tabbedDownBottom = _this.tabbedDownBottom.bind(_this);
    _this.setHelper = _this.setRef.bind(_this, 'helper');
    _this.setBlocker = _this.setRef.bind(_this, 'blocker');
    _this.setTopFocus = _this.setRef.bind(_this, 'topFocus');
    _this.setContainer = _this.setRef.bind(_this, 'container');
    _this.setMessageContainer = _this.setRef.bind(_this, 'messageContainer');
    _this.handleScroll = _this.handleScroll.bind(_this);

    _this.state = { top: '50%' };
    return _this;
  }

  createClass(BlockUi, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.blocking !== this.props.blocking) {
        if (nextProps.blocking) {
          // blocking started
          if (this.helper && this.helper.parentNode && this.helper.parentNode.contains && this.helper.parentNode.contains(safeActiveElement())) {
            this.focused = safeActiveElement();
            // https://www.tjvantoll.com/2013/08/30/bugs-with-document-activeelement-in-internet-explorer/#blurring-the-body-switches-windows-in-ie9-and-ie10
            if (this.focused && this.focused !== document.body) {
              (window.setImmediate || setTimeout)(function () {
                return _this2.focused && typeof _this2.focused.blur === 'function' && _this2.focused.blur();
              });
            }
          }
        } else {
          this.detachListeners();
          var ae = safeActiveElement();
          if (this.focused && (!ae || ae === document.body || ae === this.topFocus)) {
            if (typeof this.focused.focus === 'function') {
              this.focused.focus();
            }
            this.focused = null;
          }
        }
      }
      if (nextProps.keepInView && (nextProps.keepInView !== this.props.keepInView || nextProps.blocking && nextProps.blocking !== this.props.blocking)) {
        this.attachListeners();
        this.keepInView(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachListeners();
    }
  }, {
    key: 'setRef',
    value: function setRef(name, ref) {
      this[name] = ref;
    }
  }, {
    key: 'attachListeners',
    value: function attachListeners() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'detachListeners',
    value: function detachListeners() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'blockingTab',
    value: function blockingTab(e) {
      var withShift = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // eslint-disable-next-line eqeqeq
      return this.props.blocking && (e.key === 'Tab' || e.keyCode === 9) && e.shiftKey == withShift;
    }
  }, {
    key: 'tabbedUpTop',
    value: function tabbedUpTop(e) {
      if (this.blockingTab(e)) {
        this.blocker.focus();
      }
    }
  }, {
    key: 'tabbedDownTop',
    value: function tabbedDownTop(e) {
      if (this.blockingTab(e)) {
        e.preventDefault();
        this.blocker.focus();
      }
    }
  }, {
    key: 'tabbedUpBottom',
    value: function tabbedUpBottom(e) {
      if (this.blockingTab(e, true)) {
        this.topFocus.focus();
      }
    }
  }, {
    key: 'tabbedDownBottom',
    value: function tabbedDownBottom(e) {
      if (this.blockingTab(e, true)) {
        e.preventDefault();
        this.topFocus.focus();
      }
    }
  }, {
    key: 'keepInView',
    value: function keepInView() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (props.blocking && props.keepInView && this.container) {
        var containerBounds = this.container.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        if (containerBounds.top > windowHeight || containerBounds.bottom < 0) return;
        if (containerBounds.top >= 0 && containerBounds.bottom <= windowHeight) {
          if (this.state.top !== '50%') {
            this.setState({ top: '50%' });
          }
          return;
        }

        var messageBoundsHeight = this.messageContainer ? this.messageContainer.getBoundingClientRect().height : 0;
        var top = Math.max(Math.min(windowHeight, containerBounds.bottom) - Math.max(containerBounds.top, 0), messageBoundsHeight) / 2;
        if (containerBounds.top < 0) {
          top = Math.min(top - containerBounds.top, containerBounds.height - messageBoundsHeight / 2);
        }
        if (this.state.top !== top) {
          this.setState({ top: top });
        }
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      this.keepInView();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          blocking = _props.blocking,
          className = _props.className,
          children = _props.children,
          message = _props.message,
          Loader$$1 = _props.loader,
          renderChildren = _props.renderChildren,
          keepInView = _props.keepInView,
          attributes = objectWithoutProperties(_props, ['tag', 'blocking', 'className', 'children', 'message', 'loader', 'renderChildren', 'keepInView']);


      var classes = blocking ? 'block-ui ' + className : className;
      var renderChilds = !blocking || renderChildren;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({}, attributes, { className: classes, 'aria-busy': blocking }),
        blocking && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { tabIndex: '0', onKeyUp: this.tabbedUpTop, onKeyDown: this.tabbedDownTop, ref: this.setTopFocus }),
        renderChilds && children,
        blocking && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'block-ui-container',
            tabIndex: '0',
            ref: this.setBlocker,
            onKeyUp: this.tabbedUpBottom,
            onKeyDown: this.tabbedDownBottom
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'block-ui-overlay', ref: this.setContainer }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'block-ui-message-container',
              ref: this.setMessageContainer,
              style: { top: keepInView ? this.state.top : undefined }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'block-ui-message' },
              message,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(Loader$$1) ? Loader$$1 : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Loader$$1, null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { ref: this.setHelper })
      );
    }
  }]);
  return BlockUi;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BlockUi$1.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BlockUi$1);
//# sourceMappingURL=reactblockui.es.js.map


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXISTING_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DO_NOT_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LEAVE_SPACES_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IPR_INSTRUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IPR_NOT_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IS_IPR_INSTRUCTIONS_LIST_SAVED; });
/* unused harmony export TREATMENT_TYPE */
/* unused harmony export TREATMENT_REASON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IPR_VALUE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INSTRUCTION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPPER_TEETH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPPER_TEETH_FIRST_HALF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPPER_TEETH_SECOND_HALF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPPER_TEETH_IN_BETWEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOWER_TEETH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOWER_TEETH_FIRST_HALF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOWER_TEETH_SECOND_HALF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOWER_TEETH_IN_BETWEEN; });
var REDUCER_NAME='plan';var EXISTING_CONDITION='existingCondition';var DO_NOT_MOVE='doNotMove';var LEAVE_SPACES_OPEN='leaveSpacesOpen';var IPR_INSTRUCTION='iprInstructionList';var IPR_NOT_REQUIRED='iprNotRequired';var IS_IPR_INSTRUCTIONS_LIST_SAVED='isIprInstructionListSaved';var TREATMENT_TYPE='treatmentType';var TREATMENT_REASON='treatmentReason';var IPR_VALUE_LIST=[0,1,2,3,4,5,6].map(function(value){return{id:value,value:'0.'+value};});var INSTRUCTION_LIST='instructionList';var UPPER_TEETH=['18','17','16','15','14','13','12','11','21','22','23','24','25','26','27','28'];var UPPER_TEETH_FIRST_HALF=['18','17','16','15','14','13','12','11'];var UPPER_TEETH_SECOND_HALF=['21','22','23','24','25','26','27','28'];var UPPER_TEETH_IN_BETWEEN=['18-17','17-16','16-15','15-14','14-13','13-12','12-11','11-21','21-22','22-23','23-24','24-25','25-26','26-27','27-28'];var LOWER_TEETH=['48','47','46','45','44','43','42','41','31','32','33','34','35','36','37','38'];var LOWER_TEETH_FIRST_HALF=['48','47','46','45','44','43','42','41'];var LOWER_TEETH_SECOND_HALF=['31','32','33','34','35','36','37','38'];var LOWER_TEETH_IN_BETWEEN=['48-47','47-46','46-45','45-44','44-43','43-42','42-41','41-31','31-32','32-33','33-34','34-35','35-36','36-37','37-38'];

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _concat;
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3__ = __webpack_require__(20);



/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
var slice = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__["a" /* default */])('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
/* harmony default export */ __webpack_exports__["a"] = (slice);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Authorization__ = __webpack_require__(809);
var mapStateToProps=function mapStateToProps(state,props){return{hasRole:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["i" /* selectHasRole */](state,props.requiredRole)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__Authorization__["a" /* default */]));

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arity;
function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArguments__ = __webpack_require__(404);




// cover IE < 9 keys issues
var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {
  'use strict';

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArguments__["a" /* default */])(obj);
  for (prop in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
};
var keys = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(_keys);
/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce__ = __webpack_require__(66);



/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
var reduce = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_reduce__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (reduce);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectProcessFlowVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectHasNoFollowUpTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIsTaskReadOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectTaskName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectTaskId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectProcessInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectProcessInstanceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCurrentState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAvailableTransitionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return selectValidationMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectHasPreviousRetainerRefinementProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectOnyxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectOnyxServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_color__ = __webpack_require__(1023);
var SORT_ORDER={'btn-primary':0,'btn-success':1,'btn-info':2,'btn-warning':3,'btn-danger':4,'btn-default':5};var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectProcessFlowVisible=function selectProcessFlowVisible(state){return selectOwnState(state).processFlowVisible;};var selectHasNoFollowUpTask=function selectHasNoFollowUpTask(state){return selectOwnState(state).noFollowUp;};var selectTask=function selectTask(state){return selectOwnState(state).task;};var selectIsTaskReadOnly=function selectIsTaskReadOnly(state){var task=selectTask(state);if(!task){return true;}if(task.status==='finished'){return true;}var currentUserId=Object(__WEBPACK_IMPORTED_MODULE_2__security_state_auth_selector__["q" /* selectUserId */])(state);var assignedToUserId=task.assignedToUserId;var accessable=Object(__WEBPACK_IMPORTED_MODULE_2__security_state_auth_selector__["i" /* selectHasRole */])(state,task.role)&&(assignedToUserId===null||assignedToUserId===currentUserId);return!accessable;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectTaskName=function selectTaskName(state){var task=selectTask(state);if(!task){return null;}return task.name;};var selectTaskId=function selectTaskId(state){var task=selectTask(state);if(!task){return null;}return task.id;};var selectRole=function selectRole(state){var task=selectTask(state);if(!task){return null;}return task.role;};var selectProcessInstance=function selectProcessInstance(state){var task=selectTask(state);return task?task.processInstance:null;};var selectProcessInstanceId=function selectProcessInstanceId(state){var task=selectTask(state);return task?task.processInstanceId:null;};var selectCurrentState=function selectCurrentState(state){var processInstance=selectProcessInstance(state);if(!processInstance){return null;}return processInstance.currentState;};var selectAvailableTransitionList=function selectAvailableTransitionList(state){var currentState=selectCurrentState(state);if(!currentState){return null;}var transitionList=currentState.transitionList.filter(function(transition){return!!transition.eventName;});transitionList=transitionList.map(function(transition){var className=__WEBPACK_IMPORTED_MODULE_3__event_color__["a" /* default */][transition.eventName]||'btn-primary';return Object.assign({},transition,{className:className,sortOrder:SORT_ORDER[className]});});transitionList.sort(function(a,b){return a.sortOrder-b.sortOrder;});return transitionList;};var selectValidationMessageList=function selectValidationMessageList(state){return selectOwnState(state).validationMessageList;};var selectHasPreviousRetainerRefinementProcess=function selectHasPreviousRetainerRefinementProcess(state){var task=selectTask(state);if(!task){return null;}var salesOrderList=task.objectDetail.customer.salesOrderList;return salesOrderList.filter(function(salesOrder){return salesOrder.type==='retainer-refinement'||salesOrder.type==='retainer-refinement-new';}).length>0;};var selectOnyxId=function selectOnyxId(state){var task=selectTask(state);if(!task){return null;}return task.objectDetail.customer.onyxId;};var selectOnyxServer=function selectOnyxServer(state){var task=selectTask(state);if(!task){return null;}return task.objectDetail.customer.onyxServer;};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectTreatmentQuotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIsEditableForUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectHasChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectIsPreviewModalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectFunnelId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectIsUploadingVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectIsTreatmentQuotationValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectHasUserRoleToEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectIsImplantTreatmentQuotationValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectIsTreatmentQuotationReadyForPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectIsImplantTreatmentQuotationReadyForPurchase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_selector__ = __webpack_require__(23);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["k" /* REDUCER_NAME */]];};var selectCustomer=function selectCustomer(state){return selectOwnState(state).customer;};var selectTreatmentQuotation=function selectTreatmentQuotation(state){return selectOwnState(state).treatmentQuotation;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectIsEditableForUser=function selectIsEditableForUser(state){return selectOwnState(state).isEditableForUser;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectIsPreviewModalOpen=function selectIsPreviewModalOpen(state){return selectOwnState(state).previewModalOpen;};var selectCustomerId=function selectCustomerId(state){return selectOwnState(state).customerId;};var selectFunnelId=function selectFunnelId(state){return selectOwnState(state).funnelId;};var selectIsUploadingVideo=function selectIsUploadingVideo(state){return selectOwnState(state).uploadingVideo;};var selectIsTreatmentQuotationValid=function selectIsTreatmentQuotationValid(state){var treatmentQuotation=selectTreatmentQuotation(state);if(!treatmentQuotation){return false;}return!!(treatmentQuotation.brutPrice&&treatmentQuotation.physicianCost&&treatmentQuotation.treatmentDuration&&treatmentQuotation.numberOfAligner&&treatmentQuotation.validUntil&&treatmentQuotation.treatmentLink);};var selectHasUserRoleToEdit=function selectHasUserRoleToEdit(state){var usersThatCanEdit=[__WEBPACK_IMPORTED_MODULE_2__security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */],__WEBPACK_IMPORTED_MODULE_2__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_2__security_state_auth_const__["P" /* ROLE_TREATMENT_QUOTATION_ADMIN */]];return Object(__WEBPACK_IMPORTED_MODULE_3__security_state_auth_selector__["u" /* userHasAnyOfRoles */])(state,usersThatCanEdit);};var selectIsImplantTreatmentQuotationValid=function selectIsImplantTreatmentQuotationValid(state){var treatmentQuotation=selectTreatmentQuotation(state);if(!treatmentQuotation){return false;}return!!(treatmentQuotation.brutPrice&&(treatmentQuotation.physicianCost||treatmentQuotation.physicianCost===0)&&treatmentQuotation.validUntil);};var selectIsTreatmentQuotationReadyForPurchase=function selectIsTreatmentQuotationReadyForPurchase(state){var treatmentQuotation=selectTreatmentQuotation(state);return selectIsTreatmentQuotationValid(state)&&treatmentQuotation.approved;};var selectIsImplantTreatmentQuotationReadyForPurchase=function selectIsImplantTreatmentQuotationReadyForPurchase(state){var treatmentQuotation=selectTreatmentQuotation(state);return selectIsImplantTreatmentQuotationValid(state)&&treatmentQuotation.approved;};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(466);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderCountryName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internationalization_const__ = __webpack_require__(31);
var renderCountryName=function renderCountryName(countryCode){var country=__WEBPACK_IMPORTED_MODULE_0__internationalization_const__["e" /* COUNTRY_CODE_LIST */].find(function(item){return item.id===countryCode;});return country?country.value:'';};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics_state__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anamnesis_state__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appointment_state__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customer_state__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__email_state__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__employee_state__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__foil_state__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__globals_state__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__gmail_state__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice_state__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_state__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lead_state__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__logistic_state__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__payment_state__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__partner_state__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__voucher_state__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__process_state__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__prospect_state__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__refinement_state__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sales_order_state__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__security_state__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_state__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__threeshape_state__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__treatment_state__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__feedback_state__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__partial_refund_state__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__whatsapp_messages_state__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__worklist_attachment_state__ = __webpack_require__(796);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */];var createRootReducer=function createRootReducer(history){var _combineReducers;return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])((_combineReducers={router:Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["c" /* connectRouter */])(history)},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_4__analytics_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_4__analytics_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_5__anamnesis_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_6__appointment_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_6__appointment_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_7__customer_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_7__customer_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_8__email_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_8__email_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_9__employee_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_9__employee_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_28__feedback_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_28__feedback_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_10__foil_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_10__foil_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_11__globals_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_11__globals_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_12__gmail_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_12__gmail_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_13__invoice_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_13__invoice_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_14__layout_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_14__layout_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_15__lead_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_15__lead_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_16__logistic_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_16__logistic_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_17__payment_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_17__payment_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_18__partner_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_18__partner_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_19__voucher_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_19__voucher_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_20__process_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_20__process_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_21__prospect_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_21__prospect_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_22__refinement_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_22__refinement_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_23__sales_order_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_23__sales_order_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_24__security_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_24__security_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_25__store_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_25__store_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_26__threeshape_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_26__threeshape_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_27__treatment_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_27__treatment_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_29__partial_refund_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_29__partial_refund_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_30__whatsapp_messages_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_30__whatsapp_messages_state__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_31__worklist_attachment_state__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_31__worklist_attachment_state__["b" /* reducer */]),_combineReducers));};var history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])();var store=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */])(createRootReducer(history),composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */])(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["e" /* routerMiddleware */])(history),__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */])));/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='process';

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ContentBoxHeader=function ContentBoxHeader(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content-box-header"},children);};/* harmony default export */ __webpack_exports__["a"] = (ContentBoxHeader);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ContentBoxBody=function ContentBoxBody(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content-box-body"},children);};/* harmony default export */ __webpack_exports__["a"] = (ContentBoxBody);

/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatMoney; });
/* unused harmony export getCurrencySymbol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToCents; });
var formatMoney=function formatMoney(value,currency){if(!value||!value.toFixed){value=0;}value/=100;return value.toFixed(2)+' '+getCurrencySymbol(currency);};var getCurrencySymbol=function getCurrencySymbol(currency){switch(currency){case'EUR':return'€';case'GBP':return'£';case'CHF':return'CHF';case'SEK':return'SEK';default:return'*';}};var convertToCents=function convertToCents(num){return Math.round(num*100);};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createInitialTableState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DESC; });
/* unused harmony export toggleSort */
/* unused harmony export toggleSortMulti */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createReducerFunction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(155);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var createInitialTableState=function createInitialTableState(tableName,queryName){var orderBy=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var initialConfig=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};return _defineProperty({},tableName,Object.assign({queryName:queryName,currentPage:0,objectPerPage:20,filter:{},orderBy:orderBy,offset:0,limit:500,objectList:[],hiddenColumns:[]},initialConfig));};var ASC='ASC';var DESC='DESC';var toggleSort=function toggleSort(currentSortOrder){return!currentSortOrder||currentSortOrder===DESC?ASC:DESC;};var toggleSortMulti=function toggleSortMulti(currentSortOrder){if(!currentSortOrder){return ASC;}if(currentSortOrder===ASC){return DESC;}if(currentSortOrder===DESC){return null;}};var createReducerFunction=function createReducerFunction(tableName){var _ref2;return _ref2={},_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["d" /* QUERY_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["e" /* QUERY_SUCCESS */],function(state,action){var _Object$assign;var objectList=action.payload.objectList;return Object.assign({},state,(_Object$assign={},_defineProperty(_Object$assign,tableName,Object.assign({},state[tableName],{objectList:objectList})),_defineProperty(_Object$assign,'fetching',false),_Object$assign));}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["c" /* QUERY_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CHANGE_FILTER */],function(state,action){var _Object$assign3;var _action$payload=action.payload,columnName=_action$payload.columnName,filterValue=_action$payload.filterValue;return Object.assign({},state,(_Object$assign3={},_defineProperty(_Object$assign3,tableName,Object.assign({},state[tableName],{filter:Object.assign({},state[tableName].filter,_defineProperty({},columnName,filterValue))})),_defineProperty(_Object$assign3,'fetching',true),_Object$assign3));}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["h" /* TOGGLE_SORT */],function(state,action){var _Object$assign4;var columnName=action.payload.columnName;var currentOrder=state[tableName].orderBy[columnName];return Object.assign({},state,(_Object$assign4={},_defineProperty(_Object$assign4,tableName,Object.assign({},state[tableName],{orderBy:_defineProperty({},columnName,toggleSort(currentOrder))})),_defineProperty(_Object$assign4,'fetching',true),_Object$assign4));}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["f" /* SET_HIDDEN_COLUMNS */],function(state,action){var hiddenColumns=action.payload;return Object.assign({},state,_defineProperty({},tableName,Object.assign({},state[tableName],{hiddenColumns:hiddenColumns})));}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["g" /* TOGGLE_MULTI_SORT */],function(state,action){var _Object$assign7;var columnName=action.payload.columnName;var currentOrder=state[tableName].orderBy[columnName];return Object.assign({},state,(_Object$assign7={},_defineProperty(_Object$assign7,tableName,Object.assign({},state[tableName],{orderBy:Object.assign({},state[tableName].orderBy,_defineProperty({},columnName,toggleSortMulti(currentOrder)))})),_defineProperty(_Object$assign7,'fetching',true),_Object$assign7));}),_defineProperty(_ref2,__WEBPACK_IMPORTED_MODULE_0__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_0__type__["b" /* GOTO_PAGE */],function(state,action){var page=action.payload.page;return Object.assign({},state,_defineProperty({},tableName,Object.assign({},state[tableName],{currentPage:page})));}),_ref2;};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsNavigationCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectIsTablet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__email__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lead__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sales_order__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prospect__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treatment__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__voucher__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appointment_state_selector__ = __webpack_require__(290);
var selectIsFetching=function selectIsFetching(state){return __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* default */].selector.selectIsFetching(state)||Object(__WEBPACK_IMPORTED_MODULE_10__appointment_state_selector__["a" /* selectIsFetchingAppointment */])(state)||__WEBPACK_IMPORTED_MODULE_2__customer__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_3__email__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_4__lead__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_5__sales_order__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_6__process__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_7__prospect__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_8__treatment__["a" /* default */].selector.selectIsFetching(state)||__WEBPACK_IMPORTED_MODULE_9__voucher__["a" /* default */].selector.selectIsFetching(state);};var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsNavigationCollapsed=function selectIsNavigationCollapsed(state){return selectOwnState(state).isNavigationCollapsed;};var selectIsTablet=function selectIsTablet(state){return selectOwnState(state).isTablet;};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
/* harmony default export */ __webpack_exports__["a"] = (Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _reduced;
function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createTableSelector; });
var createTableSelector=function createTableSelector(selectOwnState,tableName){return function(state){return selectOwnState(state)[tableName];};};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createInitialTableQueryAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createToggleColumnVisibilityTableHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createToggleColumnVisibilityFormHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createInitialColumnsVisibilityTableHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createInitialColumnsVisibilityFormHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createChangeFilterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createToggleSortAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createToggleMultiSortAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createGotoPageAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals_state_type__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var controller=window.AbortController&&new window.AbortController();var stopRunningAndCreateSignal=function stopRunningAndCreateSignal(){if(controller){controller.abort();}controller=new window.AbortController();return controller.signal;};var saveTimeout=null;var SAVE_DELAY=2000;//two seconds delay to prevent multiple save operations when changing column visibility too fast
var queryTable=function queryTable(dispatch,state,tableName,selectOwnState,afterLoad){var localState=selectOwnState(state);var request=localState[tableName];var signal=stopRunningAndCreateSignal();Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/table/execute-table-query',request,signal).then(function(objectList){if(afterLoad){afterLoad(state,objectList);}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["e" /* QUERY_SUCCESS */],payload:{objectList:objectList}});}).catch(function(error){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["c" /* QUERY_ERROR */],payload:{error:error}});});};var createInitialTableQueryAction=function createInitialTableQueryAction(selectOwnState,tableName,afterLoad){return function(){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["d" /* QUERY_REQUEST */]});queryTable(dispatch,getState(),tableName,selectOwnState,afterLoad);};};};var saveTableConfigurationInBackend=function saveTableConfigurationInBackend(getState){var viewPreferences=Object(__WEBPACK_IMPORTED_MODULE_3__globals_state_selector__["selectUserViewPreferences"])(getState());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/security/user/save-view-preferences',viewPreferences).then(function(){//no actions needed
});};var saveTableConfigurationDelayed=function saveTableConfigurationDelayed(getState){if(saveTimeout){clearTimeout(saveTimeout);}saveTimeout=setTimeout(function(){saveTimeout=null;saveTableConfigurationInBackend(getState);},SAVE_DELAY);};var createNewViewPreferences=function createNewViewPreferences(getState,tableName,columns){var viewPreferences=Object(__WEBPACK_IMPORTED_MODULE_3__globals_state_selector__["selectUserViewPreferences"])(getState());var tableSettings=viewPreferences.tableSettings;var newTableSettings=Object.assign({},tableSettings,_defineProperty({},tableName,{hiddenColumns:columns}));return Object.assign({},viewPreferences,{tableSettings:newTableSettings});};var saveTableConfiguration=function saveTableConfiguration(getState,tableName,columns,dispatch){var newViewPreferences=createNewViewPreferences(getState,tableName,columns);saveTableConfigurationDelayed(getState);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__globals_state_type__["b" /* SAVE_VIEW_PREFERENCES */],payload:newViewPreferences});};var toggleColumnVisibility=function toggleColumnVisibility(hiddenColumns,columnName){var newHiddenColumns=[].concat(_toConsumableArray(hiddenColumns));if(newHiddenColumns.includes(columnName)){newHiddenColumns.splice(newHiddenColumns.indexOf(columnName),1);}else{newHiddenColumns.push(columnName);}return newHiddenColumns;};var createToggleColumnVisibilityTableHandler=function createToggleColumnVisibilityTableHandler(selectOwnState,tableName){return function(columnName){return function(dispatch,getState){var tableSetting=selectOwnState(getState());var hiddenColumns=toggleColumnVisibility(tableSetting.hiddenColumns,columnName);var actionName=__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["f" /* SET_HIDDEN_COLUMNS */];saveTableConfiguration(getState,tableName,hiddenColumns,dispatch);dispatch({type:actionName,payload:hiddenColumns});};};};var createToggleColumnVisibilityFormHandler=function createToggleColumnVisibilityFormHandler(selectOwnState,settingActionName,tableName){return function(columnName){return function(dispatch,getState){var _selectOwnState=selectOwnState(getState()),tableSetting=_selectOwnState.tableSetting;var hiddenColumns=toggleColumnVisibility(tableSetting.hiddenColumns,columnName);saveTableConfiguration(getState,tableName,hiddenColumns,dispatch);dispatch({"type":settingActionName,payload:{'name':'hiddenColumns','value':hiddenColumns}});};};};var getTableHiddenColumns=function getTableHiddenColumns(tableName,getState){var viewPreferences=Object(__WEBPACK_IMPORTED_MODULE_3__globals_state_selector__["selectUserViewPreferences"])(getState());var tableSettings=viewPreferences.tableSettings;if(!tableSettings){return[];}if(!tableSettings.hasOwnProperty(tableName)){return[];}var theTableSettings=tableSettings[tableName];if(!theTableSettings.hasOwnProperty('hiddenColumns')){return[];}return[].concat(_toConsumableArray(theTableSettings.hiddenColumns));};var createInitialColumnsVisibilityTableHandler=function createInitialColumnsVisibilityTableHandler(tableName){return function(){return function(dispatch,getState){var hiddenColumns=getTableHiddenColumns(tableName,getState);var actionName=__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["f" /* SET_HIDDEN_COLUMNS */];dispatch({type:actionName,payload:hiddenColumns});};};};var createInitialColumnsVisibilityFormHandler=function createInitialColumnsVisibilityFormHandler(tableName,actionName){return function(){return function(dispatch,getState){var hiddenColumns=getTableHiddenColumns(tableName,getState);dispatch({type:actionName,payload:{name:'hiddenColumns',value:hiddenColumns}});};};};var debouncedQueryTable=__WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(queryTable,1000,false);var createChangeFilterAction=function createChangeFilterAction(selectOwnState,tableName,afterLoad){return function(columnName,filterValue){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_FILTER */],payload:{columnName:columnName,filterValue:filterValue}});debouncedQueryTable(dispatch,getState(),tableName,selectOwnState,afterLoad);};};};var createToggleSortAction=function createToggleSortAction(selectOwnState,tableName,afterLoad){return function(columnName){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["h" /* TOGGLE_SORT */],payload:{columnName:columnName}});queryTable(dispatch,getState(),tableName,selectOwnState,afterLoad);};};};var createToggleMultiSortAction=function createToggleMultiSortAction(selectOwnState,tableName,afterLoad){return function(columnName){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["g" /* TOGGLE_MULTI_SORT */],payload:{columnName:columnName}});queryTable(dispatch,getState(),tableName,selectOwnState,afterLoad);};};};var createGotoPageAction=function createGotoPageAction(tableName){return function(page){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* TYPE_PREFIX */]+tableName+__WEBPACK_IMPORTED_MODULE_2__type__["b" /* GOTO_PAGE */],payload:{page:page}};};};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
var ContentBoxWithoutHeader=function ContentBoxWithoutHeader(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{layer:'lg',size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-box'},children)));};ContentBoxWithoutHeader.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (ContentBoxWithoutHeader);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CUSTOMER_PROCESS_INSTANCE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CUSTOMER_SALES_ORDER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CUSTOMER_XRAY_FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER_COMMENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOMER_ADD_COMMENT; });
// Please don't change values of constants since they are used in database
var CUSTOMER_PROCESS_INSTANCE_LIST='ProcessInstanceList';var CUSTOMER_SALES_ORDER_LIST='SalesOrderList';var CUSTOMER_XRAY_FILE_UPLOAD='XRayFileUploadContainer';var CUSTOMER_COMMENT_LIST='ProcessCommentList';var CUSTOMER_ADD_COMMENT='NewProcessComment';

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(1222);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toggleImageView; });
/* unused harmony export findImageVersionRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findImageVersionSuccess; });
/* unused harmony export findImageVersionError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findImageVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findRecentImageVersion; });
/* unused harmony export uploadCustomerImageRequest */
/* unused harmony export uploadCustomerImageError */
/* unused harmony export uploadCustomerImageSuccess */
/* unused harmony export reuploadCustomerImageSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return uploadCustomerImage; });
/* unused harmony export saveImageToLocalStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return retryUploadFromLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reuploadCustomerImage; });
/* unused harmony export rotateCustomerImageRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rotateCustomerImage; });
/* unused harmony export setImageTypeMetaDataRequest */
/* unused harmony export setImageTypeMetaDataError */
/* unused harmony export setImageTypeMetaDataSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setImageTypeMetaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setSelectedImageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCurrentStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setSlideIndex; });
/* unused harmony export deleteCustomerImageRequest */
/* unused harmony export deleteCustomerImageError */
/* unused harmony export deleteCustomerImageSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteCustomerImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_browser_image_compression__ = __webpack_require__(1256);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var toggleImageView=function toggleImageView(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["o" /* TOGGLE_IMAGE_VIEW */]};};var findImageVersionRequest=function findImageVersionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["e" /* FIND_IMAGE_VERSION_LIST_REQUEST */],payload:{}};};var findImageVersionSuccess=function findImageVersionSuccess(imageVersionList){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["f" /* FIND_IMAGE_VERSION_LIST_SUCCESS */],payload:{imageVersionList:imageVersionList}};};var findImageVersionError=function findImageVersionError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["d" /* FIND_IMAGE_VERSION_LIST_ERROR */],payload:{error:error}};};var findImageVersion=function findImageVersion(customerId){return function(dispatch,getState){dispatch(findImageVersionRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/customer/image-version-list?customerId='+customerId).then(function(imageVersionList){dispatch(findImageVersionSuccess(imageVersionList));}).catch(function(error){dispatch(findImageVersionError(error));});};};var findRecentImageVersion=function findRecentImageVersion(customerId){return function(dispatch,getState){dispatch(findImageVersionRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/customer/image-version-list?customerId='+customerId).then(function(imageVersionList){var filteredImageVersionList=filterImagesByAge(imageVersionList,30);dispatch(findImageVersionSuccess(filteredImageVersionList));}).catch(function(error){dispatch(findImageVersionError(error));});};};function filterImagesByAge(imageVersionList,maxAge){var filteredImageVersionList={};Object.entries(imageVersionList).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];filteredImageVersionList[key]=value.filter(function(image){return __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(image.lastModified,'days')<=maxAge;});if(filteredImageVersionList[key].length===0){delete filteredImageVersionList[key];}});return filteredImageVersionList;}var uploadCustomerImageRequest=function uploadCustomerImageRequest(fileName){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["q" /* UPLOAD_CUSTOMER_IMAGE_REQUEST */],payload:{fileName:fileName}};};var uploadCustomerImageError=function uploadCustomerImageError(error,fileName){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["p" /* UPLOAD_CUSTOMER_IMAGE_ERROR */],payload:{error:error,fileName:fileName}};};var uploadCustomerImageSuccess=function uploadCustomerImageSuccess(imageVersionList,fileName){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["r" /* UPLOAD_CUSTOMER_IMAGE_SUCCESS */],payload:{imageVersionList:imageVersionList,fileName:fileName}};};var reuploadCustomerImageSuccess=function reuploadCustomerImageSuccess(imageVersionList,imageType){var fileAdded=imageVersionList[imageType].filter(function(image){return image.isLatest;});return{type:__WEBPACK_IMPORTED_MODULE_2__type__["g" /* REUPLOAD_CUSTOMER_IMAGE_SUCCESS */],payload:{fileAdded:fileAdded,imageType:imageType}};};var uploadCustomerImage=function uploadCustomerImage(fileList,fileName,customerId){return function(dispatch,getState){var options={maxSizeMB:1,maxWidthOrHeight:1632,useWebWorker:true};Object(__WEBPACK_IMPORTED_MODULE_4_browser_image_compression__["a" /* default */])(fileList[0],options).then(function(compressedFile){fileList[0]=compressedFile;dispatch(uploadCustomerImageRequest(fileName));var data=new FormData();data.append('file',compressedFile);fetch(__WEBPACK_IMPORTED_MODULE_1__util_api__["a" /* BACKEND_URL */]+'/api/customer/image-upload-for-customer?customerId='+customerId+'&fileName='+fileName,{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(imageVersionList){dispatch(uploadCustomerImageSuccess(imageVersionList,fileName));}).catch(function(error){dispatch(saveImageToLocalStorage(fileList,fileName,customerId));dispatch(uploadCustomerImageError(error,fileName));});}).catch(function(error){console.log(error.message);});};};var saveImageToLocalStorage=function saveImageToLocalStorage(fileList,fileName,customerId){return function(){var reader=new FileReader();reader.readAsDataURL(fileList[0]);reader.addEventListener('load',function(){localStorage.setItem(customerId+'-'+fileName+'-img',this.result);});};};var retryUploadFromLocalStorage=function retryUploadFromLocalStorage(fileName,customerId){return function(dispatch,getState){var fileList=[convertBase64ToFile(localStorage.getItem(customerId+'-'+fileName+'-img'))];localStorage.removeItem(customerId+'-'+fileName+'-img');dispatch(reuploadCustomerImage(fileList,fileName,customerId));};};var convertBase64ToFile=function convertBase64ToFile(image){var byteString=atob(image.split(',')[1]);var ab=new ArrayBuffer(byteString.length);var ia=new Uint8Array(ab);for(var i=0;i<byteString.length;i+=1){ia[i]=byteString.charCodeAt(i);}return new File([ab],{type:'image/jpeg'});};var reuploadCustomerImage=function reuploadCustomerImage(fileList,fileName,customerId){return function(dispatch,getState){dispatch(uploadCustomerImageRequest(fileName));var data=new FormData();data.append('file',fileList[0]);fetch(__WEBPACK_IMPORTED_MODULE_1__util_api__["a" /* BACKEND_URL */]+'/api/customer/image-upload-for-customer?customerId='+customerId+'&fileName='+fileName,{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(imageVersionList){dispatch(reuploadCustomerImageSuccess(imageVersionList,fileName));}).catch(function(error){dispatch(saveImageToLocalStorage(fileList,fileName,customerId));dispatch(uploadCustomerImageError(error,fileName));});};};var rotateCustomerImageRequest=function rotateCustomerImageRequest(fileName,versionId,targetDegree){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["h" /* ROTATE_CUSTOMER_IMAGE_REQUEST */],payload:{fileName:fileName,versionId:versionId,targetDegree:targetDegree}};};var rotateCustomerImage=function rotateCustomerImage(fileName,versionId,degree){return function(dispatch,getState){var state=getState();var imageVersion=__WEBPACK_IMPORTED_MODULE_3__selector__["i" /* selectVersionImageVersion */](state,fileName,versionId);if(!imageVersion){return null;}var targetDegree=imageVersion.meta&&imageVersion.meta.rotate?imageVersion.meta.rotate:0;targetDegree=(targetDegree+degree)%360;if(targetDegree<0){targetDegree+=360;}dispatch(rotateCustomerImageRequest(fileName,versionId,targetDegree));Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/rotate-image-meta-data',{customerId:imageVersion.customerId,path:imageVersion.path,versionId:imageVersion.versionId,degree:targetDegree});};};var setImageTypeMetaDataRequest=function setImageTypeMetaDataRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["k" /* SET_IMAGE_TYPE_META_DATA_REQUEST */]};};var setImageTypeMetaDataError=function setImageTypeMetaDataError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["j" /* SET_IMAGE_TYPE_META_DATA_ERROR */],payload:{error:error}};};var setImageTypeMetaDataSuccess=function setImageTypeMetaDataSuccess(imageType,versionId,newImageType){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["l" /* SET_IMAGE_TYPE_META_DATA_SUCCESS */],payload:{imageType:imageType,versionId:versionId,newImageType:newImageType}};};var setImageTypeMetaData=function setImageTypeMetaData(customerId,imageType,versionId,path,newImageType){return function(dispatch,getState){dispatch(setImageTypeMetaDataRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/set-image-type-meta-data',{customerId:customerId,path:path,versionId:versionId,imageType:newImageType}).then(function(result){dispatch(setImageTypeMetaDataSuccess(imageType,versionId,newImageType));});};};var setSelectedImageType=function setSelectedImageType(value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["m" /* SET_SELECTED_IMAGE_TYPE */],payload:{selectedImageTypeName:value}};};var setCurrentStep=function setCurrentStep(value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* SET_CURRENT_STEP */],payload:{currentStep:value}};};var setSlideIndex=function setSlideIndex(value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["n" /* SET_SLIDE_INDEX */],payload:{slideIndex:value}};};var deleteCustomerImageRequest=function deleteCustomerImageRequest(fileId,versionId){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["b" /* DELETE_CUSTOMER_IMAGE_REQUEST */],payload:{fileId:fileId,versionId:versionId}};};var deleteCustomerImageError=function deleteCustomerImageError(error,fileId){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["a" /* DELETE_CUSTOMER_IMAGE_ERROR */],payload:{error:error,fileId:fileId}};};var deleteCustomerImageSuccess=function deleteCustomerImageSuccess(imageType,fileId,versionId){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* DELETE_CUSTOMER_IMAGE_SUCCESS */],payload:{imageType:imageType,fileId:fileId,versionId:versionId}};};var deleteCustomerImage=function deleteCustomerImage(fileId,imageType,versionId){return function(dispatch,getState){dispatch(deleteCustomerImageRequest(fileId,versionId));fetch(__WEBPACK_IMPORTED_MODULE_1__util_api__["a" /* BACKEND_URL */]+'/api/customer/delete-customer-image?versionId='+versionId+'&fileId='+fileId,{method:'post',headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(imageVersionList){dispatch(deleteCustomerImageSuccess(imageVersionList,fileId,versionId));}).catch(function(error){dispatch(deleteCustomerImageError(error,fileId,versionId));});dispatch(deleteCustomerImageSuccess(imageType,fileId,versionId));};};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return treatmentPlanLoaded; });
/* unused harmony export changeSegment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeTreatmentPlan; });
/* unused harmony export changeIPRInstructions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeExistingCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDoNotMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeLeaveSpaceOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeIPRInstruction; });
/* unused harmony export saveTreatmentPlanRequest */
/* unused harmony export saveTreatmentPlanSuccess */
/* unused harmony export saveTreatmentPlanError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return saveTreatmentPlan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(12);
function fixIPRInstructions(instructions){if(instructions===null){return null;}var filtered=Object.keys(instructions).reduce(function(rest,k){if(instructions[k]!==null){rest[k]=instructions[k];}return rest;},{});if(Object.keys(filtered).length===0){return null;}return filtered;}var treatmentPlanLoaded=function treatmentPlanLoaded(treatmentPlan){if(!treatmentPlan){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TREATMENT_PLAN_LOADED */],payload:{treatmentPlan:treatmentPlan}};}return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* TREATMENT_PLAN_LOADED */],payload:{treatmentPlan:Object.assign({},treatmentPlan,{iprInstructionList:fixIPRInstructions(treatmentPlan.iprInstructionList)})}};};var changeSegment=function changeSegment(segment,name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CHANGE_SEGMENT */],payload:{segment:segment,name:name,value:value}};};var changeTreatmentPlan=function changeTreatmentPlan(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CHANGE_TREATMENT_PLAN */],payload:{name:name,value:value}};};var changeIPRInstructions=function changeIPRInstructions(value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CHANGE_TREATMENT_PLAN */],payload:{iprInstructions:value}};};var changeExistingCondition=function changeExistingCondition(name,value){return changeSegment(__WEBPACK_IMPORTED_MODULE_2__const__["b" /* EXISTING_CONDITION */],name,value);};var changeInstruction=function changeInstruction(name,value){return changeSegment(__WEBPACK_IMPORTED_MODULE_2__const__["c" /* INSTRUCTION_LIST */],name,value);};var changeDoNotMove=function changeDoNotMove(name,value){return changeSegment(__WEBPACK_IMPORTED_MODULE_2__const__["a" /* DO_NOT_MOVE */],name,value);};var changeLeaveSpaceOpen=function changeLeaveSpaceOpen(name,value){return changeSegment(__WEBPACK_IMPORTED_MODULE_2__const__["h" /* LEAVE_SPACES_OPEN */],name,value);};var changeIPRInstruction=function changeIPRInstruction(name,value){return changeSegment(__WEBPACK_IMPORTED_MODULE_2__const__["d" /* IPR_INSTRUCTION */],name,value);};var saveTreatmentPlanRequest=function saveTreatmentPlanRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* SAVE_TREATMENT_PLAN_REQUEST */]};};var saveTreatmentPlanSuccess=function saveTreatmentPlanSuccess(treatmentPlan){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["e" /* SAVE_TREATMENT_PLAN_SUCCESS */],payload:{treatmentPlan:treatmentPlan}};};var saveTreatmentPlanError=function saveTreatmentPlanError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* SAVE_TREATMENT_PLAN_ERROR */],payload:{error:error}};};var saveTreatmentPlan=function saveTreatmentPlan(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_1__selector__["e" /* selectHasChanged */](state);if(!hasChanged){return;}var treatmentPlan=__WEBPACK_IMPORTED_MODULE_1__selector__["g" /* selectTreatmentPlan */](state);dispatch(saveTreatmentPlanRequest());Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["c" /* post */])('/api/treatment/plan/save',treatmentPlan).then(function(treatmentPlan){dispatch(saveTreatmentPlanSuccess(treatmentPlan));}).catch(function(error){dispatch(saveTreatmentPlanError(error));});};};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(606);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAYMENT_METHOD_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAYMENT_METHOD_SELECT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__ = __webpack_require__(384);
var _PAYMENT_METHOD_TEXT;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUCER_NAME='sales-order';var PRODUCT_TYPE={'set':'Set','treatment':'Treatment','treatment-new':'Treatment New','end-of-treatment':'End Of Treatment','shop-scan':'Shop Scan','shop-scan-new':'Shop Scan New','retainer':'Retainer','retainer-new':'Retainer New','refinement-set':'Refinement (Set)','refinement-booking':'Refinement (Booking)','refinement-shop':'Refinement (Shop)','refinement-shop-new':'Refinement (Shop New)','refinement-production':'Refinement Production','in-shop-scan':'Clinic 3D-Scan','in-shop-scan-new':'Clinic 3D-Scan New','escalation':'Escalation','check-in':'Clinic Check-In','aligner-reproduction':'Aligner Reproduction','implant-3d-scan':'Implant Clinic 3D-Scan','implant-plan':'Implant Plan','implant-treatment':'Implant Treatment','retainer-refinement':'Retainer Refinement','retainer-refinement-new':'Retainer Refinement New','partial-refund':'Partial Refund'};var PAYMENT_METHOD_TEXT=(_PAYMENT_METHOD_TEXT={},_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["b" /* PAYMENT_METHOD_CREDIT_CARD */],'credit card'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["h" /* PAYMENT_METHOD_SEPA */],'direct debit'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["e" /* PAYMENT_METHOD_PAYPAL_RATE_PAY */],'payPal ratePay'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["d" /* PAYMENT_METHOD_PAYPAL */],'PayPal'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["g" /* PAYMENT_METHOD_PREPAYMENT */],'prepayment'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["a" /* PAYMENT_METHOD_CHRYSALIS_RATE_PAY */],'Chrysalis Ratepay'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["c" /* PAYMENT_METHOD_KLARNA */],'Klarna'),_defineProperty(_PAYMENT_METHOD_TEXT,'zab_invoice','ZAB Invoice'),_defineProperty(_PAYMENT_METHOD_TEXT,'zab_ratepay','ZAB Ratepay'),_defineProperty(_PAYMENT_METHOD_TEXT,'tabeo_ratepay','Tabeo Ratepay'),_defineProperty(_PAYMENT_METHOD_TEXT,'chrysalis_ratepay','Chrysalis Ratepay'),_defineProperty(_PAYMENT_METHOD_TEXT,'pagamastarde_ratepay','PagaMasTarde'),_defineProperty(_PAYMENT_METHOD_TEXT,'splitit_ratepay','SplitIt'),_defineProperty(_PAYMENT_METHOD_TEXT,'ideal','iDEAL'),_defineProperty(_PAYMENT_METHOD_TEXT,'bancontact','Bancontact'),_defineProperty(_PAYMENT_METHOD_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_sales_order_constant__["f" /* PAYMENT_METHOD_PLEDG_RATE_PAY */],'Pledg'),_defineProperty(_PAYMENT_METHOD_TEXT,'null','none'),_PAYMENT_METHOD_TEXT);var PAYMENT_METHOD_SELECT=Object.keys(PAYMENT_METHOD_TEXT).map(function(key){return{id:key,value:PAYMENT_METHOD_TEXT[key]};});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CURRENCY_CODE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CURRENCY_CODE_SYMBOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_IMPLANT_TREATMENT_PRICE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AVAILABLE_TREATMENT_PRICE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IMPLANT_TREATMENT_PHYSICIAN_COST; });
var REDUCER_NAME='treatment';var CURRENCY_CODE_LIST=[{id:'CHF',value:'CHF'},{id:'EUR',value:'EUR'},{id:'GBP',value:'GBP'},{id:'SEK',value:'SEK'},{id:'DKK',value:'DKK'}];var CURRENCY_CODE_SYMBOL={CHF:'fa fa-money',EUR:'fa fa-euro',GBP:'fa fa-gbp',SEK:'fa fa-krw'};var AVAILABLE_IMPLANT_TREATMENT_PRICE_LIST=[{id:199900,value:'1999,00'},{id:399800,value:'3998,00'},{id:569700,value:'5697,00'},{id:719600,value:'7196,00'},{id:849500,value:'8495,00'}];var AVAILABLE_TREATMENT_PRICE_LIST=[// new and sorted prices
{id:20000,value:'200,00'},{id:99000,value:'990,00'},{id:104950,value:'1049,50'},{id:109000,value:'1090,00'},{id:119000,value:'1190,00'},{id:129000,value:'1290,00'},{id:139000,value:'1390,00'},{id:149000,value:'1490,00'},{id:159000,value:'1590,00'},{id:169000,value:'1690,00'},{id:169900,value:'1699,00'},{id:179000,value:'1790,00'},{id:189000,value:'1890,00'},{id:189900,value:'1899,00'},{id:199000,value:'1990,00'},{id:209000,value:'2090,00'},{id:215100,value:'2151,00'},{id:219000,value:'2190,00'},{id:219900,value:'2199,00'},{id:229000,value:'2290,00'},{id:239000,value:'2390,00'},{id:249000,value:'2490,00'},{id:249900,value:'2499,00'},{id:251100,value:'2511,00'},{id:259000,value:'2590,00'},{id:269000,value:'2690,00'},{id:269100,value:'2691,00'},{id:279000,value:'2790,00'},{id:289000,value:'2890,00'},{id:299000,value:'2990,00'},{id:309000,value:'3090,00'},{id:319000,value:'3190,00'},{id:349000,value:'3490,00'},{id:1628500,value:'16285,00'},{id:1926000,value:'19260,00'},{id:2074500,value:'20745,00'},{id:2399000,value:'23990,00'},{id:2799000,value:'27990,00'},{id:2999000,value:'29990,00'}];var IMPLANT_TREATMENT_PHYSICIAN_COST=0;

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]];};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1057),
    getValue = __webpack_require__(1062);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openPreviewModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closePreviewModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return processTaskLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customerLoaded; });
/* unused harmony export findOrCreateTreatmentQuotationRequest */
/* unused harmony export findOrCreateTreatmentQuotationSuccess */
/* unused harmony export findOrCreateTreatmentQuotationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findOrCreateTreatmentQuotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTreatmentQuotation; });
/* unused harmony export changeTreatmentPackagePrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setEditableForUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updatePackageAndPrice; });
/* unused harmony export saveTreatmentQuotationRequest */
/* unused harmony export saveTreatmentQuotationSuccess */
/* unused harmony export saveTreatmentQuotationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return saveTreatmentQuotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return saveImplantTreatmentQuotation; });
/* unused harmony export uploadVideoFileRequest */
/* unused harmony export uploadVideoFileError */
/* unused harmony export uploadVideoFileSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return uploadVideoFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__(59);
var openPreviewModal=function openPreviewModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* OPEN_PREVIEW_MODAL */]};};var closePreviewModal=function closePreviewModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CLOSE_PREVIEW_MODAL */]};};var processTaskLoaded=function processTaskLoaded(salesOrder){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* PROCESS_TASK_CUSTOMER_LOADED */],payload:{salesOrder:salesOrder}};};var customerLoaded=function customerLoaded(customer){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CUSTOMER_LOADED */],payload:{customer:customer}};};var findOrCreateTreatmentQuotationRequest=function findOrCreateTreatmentQuotationRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST */]};};var findOrCreateTreatmentQuotationSuccess=function findOrCreateTreatmentQuotationSuccess(treatmentQuotation){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS */],payload:{treatmentQuotation:treatmentQuotation}};};var findOrCreateTreatmentQuotationError=function findOrCreateTreatmentQuotationError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR */],payload:{error:error}};};function pickUrlByProductType(productType){if(productType===__WEBPACK_IMPORTED_MODULE_4__const__["h" /* PRODUCT_TYPE_ALIGNERS */]){return'/api/treatment/quotation/find-by-customer-id';}if(productType===__WEBPACK_IMPORTED_MODULE_4__const__["i" /* PRODUCT_TYPE_IMPLANTS */]){return'/api/implant-treatment/quotation/find-by-customer-id';}throw new Error('Unknown product type');}var findOrCreateTreatmentQuotation=function findOrCreateTreatmentQuotation(productType){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectCustomerId */](state);var funnelId=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectFunnelId */](state);if(!customerId){return;}dispatch(findOrCreateTreatmentQuotationRequest());var url=pickUrlByProductType(productType);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])(url+'?customerId='+customerId+'&funnelId='+funnelId).then(function(treatmentQuotation){dispatch(findOrCreateTreatmentQuotationSuccess(treatmentQuotation));}).catch(function(error){dispatch(findOrCreateTreatmentQuotationError(error));});};};var changeTreatmentQuotation=function changeTreatmentQuotation(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_TREATMENT_QUOTATION */],payload:{name:name,value:value}};};var changeTreatmentPackagePrice=function changeTreatmentPackagePrice(value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TREATMENT_PACKAGE_PRICE */],payload:{value:value}};};var setEditableForUser=function setEditableForUser(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["m" /* SET_EDITABLE_FOR_USER */]};};var updatePackageAndPrice=function updatePackageAndPrice(_ref){var treatmentQuotation=_ref.treatmentQuotation,customer=_ref.customer;return function(dispatch,getState){var countryCode=customer.countryCode;var numberOfAlignerLowerJaw=treatmentQuotation.numberOfAlignerLowerJaw,numberOfAlignerUpperJaw=treatmentQuotation.numberOfAlignerUpperJaw;Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/treatment/calculate-package?numberOfAlignerUpperJaw='+parseInt(numberOfAlignerUpperJaw,10)+('&numberOfAlignerLowerJaw='+parseInt(numberOfAlignerLowerJaw,10)+'&treatmentQuotationId='+treatmentQuotation.id)+('&countryCode='+countryCode)).then(function(packageAndPrice){var _ref2=packageAndPrice&&packageAndPrice[0],packageSize=_ref2.packageSize,price=_ref2.price;var confirmUpdate=window.confirm('Are you sure you want to update with \n\n New Package: '+packageSize+' \n\n New Price: '+price+' ');if(confirmUpdate===true){dispatch(changeTreatmentPackagePrice({packageSize:packageSize,price:price}));dispatch(saveTreatmentQuotation());}}).catch(function(error){console.log(error);});};};var saveTreatmentQuotationRequest=function saveTreatmentQuotationRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_TREATMENT_QUOTATION_REQUEST */]};};var saveTreatmentQuotationSuccess=function saveTreatmentQuotationSuccess(treatmentQuotation){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_TREATMENT_QUOTATION_SUCCESS */],payload:{treatmentQuotation:treatmentQuotation}};};var saveTreatmentQuotationError=function saveTreatmentQuotationError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SAVE_TREATMENT_QUOTATION_ERROR */],payload:{error:error}};};var saveTreatmentQuotation=function saveTreatmentQuotation(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectHasChanged */](state);if(!hasChanged){return;}var treatmentQuotation=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectTreatmentQuotation */](state);dispatch(saveTreatmentQuotationRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/treatment/quotation/save',treatmentQuotation).then(function(treatmentQuotation){dispatch(saveTreatmentQuotationSuccess(treatmentQuotation));}).catch(function(error){dispatch(saveTreatmentQuotationError(error));});};};var saveImplantTreatmentQuotation=function saveImplantTreatmentQuotation(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectHasChanged */](state);if(!hasChanged){return;}var treatmentQuotation=__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectTreatmentQuotation */](state);dispatch(saveTreatmentQuotationRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/implant-treatment/quotation/save',treatmentQuotation).then(function(treatmentQuotation){dispatch(saveTreatmentQuotationSuccess(treatmentQuotation));}).catch(function(error){dispatch(saveTreatmentQuotationError(error));});};};var uploadVideoFileRequest=function uploadVideoFileRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["o" /* UPLOAD_SCAN_VIDEO_REQUEST */]};};var uploadVideoFileError=function uploadVideoFileError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["n" /* UPLOAD_SCAN_VIDEO_ERROR */],payload:{error:error}};};var uploadVideoFileSuccess=function uploadVideoFileSuccess(file,frontendUrl){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["p" /* UPLOAD_SCAN_VIDEO_SUCCESS */],payload:{file:file,frontendUrl:frontendUrl}};};var uploadVideoFile=function uploadVideoFile(file,treatmentQuotationId){return function(dispatch,getState){var state=getState();var frontendUrl=__WEBPACK_IMPORTED_MODULE_3__globals__["a" /* default */].selector.selectFrontendUrl(state);dispatch(uploadVideoFileRequest());var data=new FormData();data.append('file',file);fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/treatment/add-video-file?treatmentQuotationId='+treatmentQuotationId,{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(file){dispatch(uploadVideoFileSuccess(file,frontendUrl));dispatch(saveTreatmentQuotation());}).catch(function(error){dispatch(uploadVideoFileError(error));});};};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1205);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var ToggleButton=function ToggleButton(_ref){var toggle=_ref.toggle,active=_ref.active,activeIcon=_ref.activeIcon,inactiveIcon=_ref.inactiveIcon;var iconClass=active?activeIcon:inactiveIcon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:iconClass}));};ToggleButton.propTypes={toggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,activeIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,inactiveIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var SelectChip=function SelectChip(_ref){var object=_ref.object,name=_ref.name,onChange=_ref.onChange,_ref$readOnly=_ref.readOnly,readOnly=_ref$readOnly===undefined?false:_ref$readOnly,_ref$valueList=_ref.valueList,valueList=_ref$valueList===undefined?[]:_ref$valueList;var currentValue=object[name];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,valueList.map(function(option,index){var selected=option.value===currentValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selected?'chip chip-selected':'chip',key:index,onClick:function onClick(){if(readOnly){return;}onChange(name,option.value);}},option.label);}));};SelectChip.propTypes={object:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,valueList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (SelectChip);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = (function(task,processInstance,taskName,eventName,context){var messageList=[];if(eventName==='request_medical_evaluation'){var ReasonMedicalEval=context.ReasonMedicalEval;if(!ReasonMedicalEval){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'Medical Evaluation Reason' before proceeding.",'checkMedicalEvaluationTracking.checkMedicalEvaluationTracking'));}}if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}}return messageList;});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PACK_SURGICAL_GUIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRINT_SURGICAL_GUIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NESTING_SURGICAL_GUIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SHIP_SURGICAL_GUIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIT_GUIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MARKING_AND_EXPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMPLANT_SURGERY; });
var PACK_SURGICAL_GUIDE='pack_surgical_guide';var PRINT_SURGICAL_GUIDE='print_surgical_guide';var NESTING_SURGICAL_GUIDE='nesting_surgical_guide';var SHIP_SURGICAL_GUIDE='ship_surgical_guide';var FIT_GUIDE='fit_guide';var MARKING_AND_EXPORT='marking_and_export';var IMPLANT_SURGERY='implant_surgery';

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
/* unused harmony export getPhaseName */
var REDUCER_NAME='analytics';var PHASE_NAME_LIST={lead:'Lead',setSalesOrder:'Set',treatment:'Treatment'};var getPhaseName=function getPhaseName(id){return PHASE_NAME_LIST[id];};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODE_MONTHLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODE_WEEKLY; });
var REDUCER_NAME='funnelBuilder';var MODE_MONTHLY='monthly';var MODE_WEEKLY='weekly';

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_SCAN_FILE_SIZE; });
var REDUCER_NAME='file-upload';var MAX_SCAN_FILE_SIZE=90*1024*1024;

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BANK_PAYMENT_TEXT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__ = __webpack_require__(370);
var _BANK_PAYMENT_TEXT;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUCER_NAME='payment';var BANK_PAYMENT_TEXT=(_BANK_PAYMENT_TEXT={},_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["b" /* BANK_SEPA_CANCELED */],'canceled sepa'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["f" /* BANK_TRANSFER_IN */],'prepayment'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["g" /* BANK_TRANSFER_OUT */],'outgoing tranfer'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["c" /* BANK_SEPA_IN */],'direct debit'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["h" /* BANK_ZAB */],'ZAB'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["e" /* BANK_TABEO */],'Tabeo'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["d" /* BANK_SPLIT_IT */],'SplitIt'),_defineProperty(_BANK_PAYMENT_TEXT,__WEBPACK_IMPORTED_MODULE_0__constant_payment_constant__["a" /* BANK_PLEDG */],'Pledg'),_BANK_PAYMENT_TEXT);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
var always = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function always(val) {
  return function () {
    return val;
  };
});
/* harmony default export */ __webpack_exports__["a"] = (always);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
var max = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function max(a, b) {
  return b > a ? b : a;
});
/* harmony default export */ __webpack_exports__["a"] = (max);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
var path = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});
/* harmony default export */ __webpack_exports__["a"] = (path);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indexOf__ = __webpack_require__(420);


function _contains(a, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__indexOf__["a" /* default */])(list, a, 0) >= 0;
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableHeader__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableBody__ = __webpack_require__(1171);
var Table=function Table(_ref){var objectList=_ref.objectList,idProperty=_ref.idProperty,orderBy=_ref.orderBy,filter=_ref.filter,changeFilter=_ref.changeFilter,filterSetting=_ref.filterSetting,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,columnList=_ref.columnList,onRowClick=_ref.onRowClick,onRowDoubleClick=_ref.onRowDoubleClick,hiddenColumns=_ref.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableHeader__["a" /* default */],{orderBy:orderBy,filter:filter,changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,columnList:columnList,filterSetting:filterSetting,hiddenColumns:hiddenColumns}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableBody__["a" /* default */],{objectList:objectList,idProperty:idProperty,columnList:columnList,onRowClick:onRowClick,onRowDoubleClick:onRowDoubleClick,hiddenColumns:hiddenColumns}));};Table.propTypes={currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,objectPerPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,orderBy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,objectList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleMultiSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,gotoPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,idProperty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onRowClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRowDoubleClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,filterSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_ColumnSelector__ = __webpack_require__(494);
var style={marginBottom:'16px'};var TableColumnSelector=function TableColumnSelector(_ref){var resultsNumber=_ref.resultsNumber,columnList=_ref.columnList,hiddenColumns=_ref.hiddenColumns,toggleColumnVisibility=_ref.toggleColumnVisibility;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'default-text number-status pb-1'},'Displaying ',resultsNumber,' results')),toggleColumnVisibility&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6,className:'align-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_ColumnSelector__["a" /* default */],{title:'Columns',columnList:columnList,toggleColumnVisibility:toggleColumnVisibility,hiddenColumns:hiddenColumns}))));};TableColumnSelector.propTypes={columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TableColumnSelector);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATE_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPOINTMENT_REMINDER_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECK_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPLETE_ANAMNESIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAKE_CUSTOMER_SCAN_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAKE_CUSTOMER_IPR_APPOINTMENT; });
var VALIDATE_APPOINTMENT='validate_appointment';var APPOINTMENT_REMINDER_CALL='appointment_reminder_call';var CHECK_ID='check_id';var COMPLETE_ANAMNESIS='complete_anamnesis';var MAKE_CUSTOMER_SCAN_APPOINTMENT='make_customer_scan_appointment';var MAKE_CUSTOMER_IPR_APPOINTMENT='make_customer_ipr_appointment';

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
var DEFAULT_NAMESPACE = '/';
var ACTION_TYPE_DELIMITER = '||';

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REDUCER_NAME; });
/* unused harmony export COUNT_ABSOLUTE */
/* unused harmony export COUNT_RELATIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNT_AGGREGATED_RELATIVE; });
/* unused harmony export COUNT_AGGREGATED_ABSOLUTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODE_LIST; });
var REDUCER_NAME='transition';var COUNT_ABSOLUTE='countAbsolute';var COUNT_RELATIVE='countRelative';var COUNT_AGGREGATED_RELATIVE='countAggregatedRelative';var COUNT_AGGREGATED_ABSOLUTE='countAggregatedAbsolute';var MODE_LIST=[{id:COUNT_AGGREGATED_RELATIVE,value:'percentage aggregated'},{id:COUNT_AGGREGATED_ABSOLUTE,value:'absolute aggregated'},{id:COUNT_ABSOLUTE,value:'absolute'},{id:COUNT_RELATIVE,value:'percentage'}];

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANAMNESIS_TITLE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__anamnesis_const__ = __webpack_require__(27);
var _ANAMNESIS_TITLE;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUCER_NAME='anamnesis';var ANAMNESIS_TITLE=(_ANAMNESIS_TITLE={},_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["a" /* ALIGNER_TREATMENT */],'Anamnesis'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["b" /* ALIGNER_TREATMENT_EXPECTATION */],'Aligner Treatment Expectation'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */],'Implant Consultation and Findings'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["c" /* ALIGNER_TREATMENT_MEDICAL_INFORMATION */],'Aligner Treatment Medical Condition (typeform)'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */],'Medical Assessment'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */],'Medical Assessment Implant'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["g" /* IMPLANT_TREATMENT */],'Implant Anamnesis'),_defineProperty(_ANAMNESIS_TITLE,__WEBPACK_IMPORTED_MODULE_0__anamnesis_const__["f" /* IMPLANT_SURGERY_DOCUMENTATION */],'Implant Surgery Documentation'),_ANAMNESIS_TITLE);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APPOINTMENT_TYPE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APPOINTMENT_REASON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALLOWED_TASKS_FOR_APPOINTMENT_INFO; });
var REDUCER_NAME='appointment';var APPOINTMENT_TYPE_LIST=[{id:'scan',value:'Scan'},{id:'implant-scan',value:'Implant Scan'},{id:'ipr',value:'IPR'}];var APPOINTMENT_REASON_LIST=[{id:'initial-scan',value:'Initial Scan'},{id:'refinement-scan',value:'Refinement Scan'},{id:'rescan',value:'ReScan'},{id:'refinement-rescan',value:'Refinement ReScan'},{id:'retainer-refinement',value:'Retainer Refinement'},{id:'retainer-refinement-new',value:'Retainer Refinement New'}];var ALLOWED_TASKS_FOR_APPOINTMENT_INFO=['medical_check','confirm_medical_check','rescan_medical_check','refinement_medical_check','confirm_refinement_medical_check','rescan','prepare_retainer_files','check_scans'];

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_DESIGN_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DESIGN_TEMPLATE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRAND_LIST; });
var REDUCER_NAME='email';var DEFAULT_DESIGN_TEMPLATE='288';var DESIGN_TEMPLATE_LIST=[{id:'288',value:'default'},{id:'315',value:'delivery'},{id:'303',value:'no_good_news'},{id:'343',value:'quotation'},{id:'318',value:'imprint_reminder'},{id:'317',value:'image_reminder'},{id:'316',value:'Payment'},{id:'282',value:'Payment_fwf'},{id:'319',value:'imprint_reminder_fwf'},{id:'320',value:'image_reminder_fwf'},{id:'287',value:'UK_Payment_fwf'},{id:'307',value:'UK_default'},{id:'286',value:'ESP_Payment'},{id:'305',value:'ESP_Medical'},{id:'308',value:'CH_Payment'},{id:'326',value:'CH_Medical'},{id:'338',value:'CH_Medical_Plain'},{id:'324',value:'AT_Payment'},{id:'309',value:'AT_Medical'},{id:'283',value:'FR_Payment'},{id:'298',value:'FR_Medical'},{id:'329',value:'AT_Medical_Plain'},{id:'284',value:'NL_Payment'},{id:'299',value:'NL_Medical'},{id:'285',value:'SE_Medical'},{id:'301',value:'SE_Payment'},{id:'328',value:'Insurance_first_alignerCheckin'},{id:'327',value:'How_to_take_Images'},{id:'331',value:'AT_How_to_take_Images'},{id:'335',value:'CH_How_to_take_Images'},{id:'333',value:'Benefits_of_the_app_DE'},{id:'330',value:'Benefits_of_the_app_AT'},{id:'337',value:'Benefits_of_the_app_CH'},{id:'278',value:'BE_Payment'},{id:'281',value:'BE_Payment_French'},{id:'273',value:'BE_Medical'},{id:'322',value:'BE_Medical_French'},{id:'277',value:'BE_4days'},{id:'300',value:'IT_Payment'},{id:'289',value:'IT_Medical'},{id:'306',value:'IT_4days'},{id:'272',value:'DK_Payment'},{id:'274',value:'DK_Medical'},{id:'275',value:'DK_4days'}];var BRAND_LIST=[{id:'sunshine',value:'Sunshine'},{id:'dentale',value:'Dentale'}];

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATE_RESPONSIBLE_SELECT; });
var REDUCER_NAME='state-responsible';var STATE_RESPONSIBLE_SELECT=[{id:'accounting',value:'Accounting'},{id:'customer_service',value:'Customer Service'},{id:'customer_service_sales',value:'Customer Service Sales'},{id:'customer_service_dental',value:'Customer Service Dental'},{id:'customer_service_shop',value:'Customer Service Shop Team'},{id:'first_level_cs',value:'First Level CS'},{id:'dental_team',value:'Dental Team'},{id:'CAD',value:'CAD'},{id:'logistic',value:'Logistic'},{id:'it',value:'IT'},{id:'medical',value:'Medical'},{id:'production',value:'Production'},{id:'production_external',value:'Production External'},{id:'retail',value:'Retail'},{id:'treatment_planning',value:'TreatmentPlaning'},{id:'not_assigned',value:'Not assigned'},{id:'end_state',value:'end state'}];

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REASSIGNMENT_TREATING_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REASSIGNMENT_PARTNER_PHYSICIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REASSIGNMENT_VALUE_LIST; });
var REDUCER_NAME='reassign';var REASSIGNMENT_TREATING_PHYSICIAN='REASSIGNMENT_TREATING_PHYSICIAN';var REASSIGNMENT_PARTNER_PHYSICIAN='REASSIGNMENT_PARTNER_PHYSICIAN';var REASSIGNMENT_VALUE_LIST=[{id:REASSIGNMENT_TREATING_PHYSICIAN,value:'Reassign to treating physician'},{id:REASSIGNMENT_PARTNER_PHYSICIAN,value:'Reassign to partner physician'}];

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prop__ = __webpack_require__(261);




/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
var pluck = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function pluck(p, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__prop__["a" /* default */])(p), list);
});
/* harmony default export */ __webpack_exports__["a"] = (pluck);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isString;
function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _checkForMethod;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray__ = __webpack_require__(89);


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
function _checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_0__isArray__["a" /* default */])(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_toString__ = __webpack_require__(842);



/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
var toString = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function toString(val) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_toString__["a" /* default */])(val, []);
});
/* harmony default export */ __webpack_exports__["a"] = (toString);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isString__ = __webpack_require__(134);



/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
var nth = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isString__["a" /* default */])(list) ? list.charAt(idx) : list[idx];
});
/* harmony default export */ __webpack_exports__["a"] = (nth);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isFunction__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString__ = __webpack_require__(136);





/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
var invoker = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function invoker(arity, method) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN__["a" /* default */])(arity + 1, function () {
    var target = arguments[arity];
    if (target != null && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isFunction__["a" /* default */])(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_3__toString__["a" /* default */])(target) + ' does not have a method named "' + method + '"');
  });
});
/* harmony default export */ __webpack_exports__["a"] = (invoker);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Doughnut; });
/* unused harmony export Pie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* unused harmony export HorizontalBar */
/* unused harmony export Radar */
/* unused harmony export Polar */
/* unused harmony export Bubble */
/* unused harmony export Scatter */
/* unused harmony export defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_keyBy__);
/* unused harmony reexport Chart */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production";

var ChartComponent = function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  function ChartComponent() {
    _classCallCheck(this, ChartComponent);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.handleOnClick = function (event) {
      var instance = _this.chartInstance;

      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;


      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    };

    _this.ref = function (element) {
      _this.element = element;
    };

    _this.chartInstance = undefined;
    return _this;
  }

  ChartComponent.prototype.componentDidMount = function componentDidMount() {
    this.renderChart();
  };

  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.redraw) {
      this.destroyChart();
      this.renderChart();
      return;
    }

    this.updateChart();
  };

  ChartComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _props = this.props,
        redraw = _props.redraw,
        type = _props.type,
        options = _props.options,
        plugins = _props.plugins,
        legend = _props.legend,
        height = _props.height,
        width = _props.width;


    if (nextProps.redraw === true) {
      return true;
    }

    if (height !== nextProps.height || width !== nextProps.width) {
      return true;
    }

    if (type !== nextProps.type) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(legend, nextProps.legend)) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(options, nextProps.options)) {
      return true;
    }

    var nextData = this.transformDataProp(nextProps);

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(this.shadowDataProp, nextData)) {
      return true;
    }

    return !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(plugins, nextProps.plugins);
  };

  ChartComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.destroyChart();
  };

  ChartComponent.prototype.transformDataProp = function transformDataProp(props) {
    var data = props.data;

    if (typeof data == 'function') {
      var node = this.element;
      return data(node);
    } else {
      return data;
    }
  };

  // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
  // this makes impossible to compare the current and next data changes
  // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
  // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617


  ChartComponent.prototype.memoizeDataProps = function memoizeDataProps() {
    if (!this.props.data) {
      return;
    }

    var data = this.transformDataProp(this.props);

    this.shadowDataProp = _extends({}, data, {
      datasets: data.datasets && data.datasets.map(function (set) {
        return _extends({}, set);
      })
    });

    this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed

    return data;
  };

  ChartComponent.prototype.checkDatasets = function checkDatasets(datasets) {
    var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
    var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
    var multipleDatasets = datasets.length > 1;

    if (isDev && multipleDatasets && !usingCustomKeyProvider) {
      var shouldWarn = false;
      datasets.forEach(function (dataset) {
        if (!dataset.label) {
          shouldWarn = true;
        }
      });

      if (shouldWarn) {
        console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
      }
    }
  };

  ChartComponent.prototype.getCurrentDatasets = function getCurrentDatasets() {
    return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
  };

  ChartComponent.prototype.saveCurrentDatasets = function saveCurrentDatasets() {
    var _this2 = this;

    this.datasets = this.datasets || {};
    var currentDatasets = this.getCurrentDatasets();
    currentDatasets.forEach(function (d) {
      _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
    });
  };

  ChartComponent.prototype.updateChart = function updateChart() {
    var _this3 = this;

    var options = this.props.options;


    var data = this.memoizeDataProps(this.props);

    if (!this.chartInstance) return;

    if (options) {
      this.chartInstance.options = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.helpers.configMerge(this.chartInstance.options, options);
    }

    // Pipe datasets to chart instance datasets enabling
    // seamless transitions
    var currentDatasets = this.getCurrentDatasets();
    var nextDatasets = data.datasets || [];
    this.checkDatasets(currentDatasets);

    var currentDatasetsIndexed = __WEBPACK_IMPORTED_MODULE_4_lodash_keyBy___default()(currentDatasets, this.props.datasetKeyProvider);

    // We can safely replace the dataset array, as long as we retain the _meta property
    // on each dataset.
    this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
      var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];

      if (current && current.type === next.type && next.data) {
        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
        // The data array must be edited in place. As chart.js adds listeners to it.
        current.data.splice(next.data.length);
        next.data.forEach(function (point, pid) {
          current.data[pid] = next.data[pid];
        });

        var _data = next.data,
            otherProps = _objectWithoutProperties(next, ['data']);
        // Merge properties. Notice a weakness here. If a property is removed
        // from next, it will be retained by current and never disappears.
        // Workaround is to set value to null or undefined in next.


        return _extends({}, current, otherProps);
      } else {
        return next;
      }
    });

    var datasets = data.datasets,
        rest = _objectWithoutProperties(data, ['datasets']);

    this.chartInstance.config.data = _extends({}, this.chartInstance.config.data, rest);

    this.chartInstance.update();
  };

  ChartComponent.prototype.renderChart = function renderChart() {
    var _props2 = this.props,
        options = _props2.options,
        legend = _props2.legend,
        type = _props2.type,
        plugins = _props2.plugins;

    var node = this.element;
    var data = this.memoizeDataProps();

    if (typeof legend !== 'undefined' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(ChartComponent.defaultProps.legend, legend)) {
      options.legend = legend;
    }

    this.chartInstance = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(node, {
      type: type,
      data: data,
      options: options,
      plugins: plugins
    });
  };

  ChartComponent.prototype.destroyChart = function destroyChart() {
    if (!this.chartInstance) {
      return;
    }

    // Put all of the datasets that have existed in the chart back on the chart
    // so that the metadata associated with this chart get destroyed.
    // This allows the datasets to be used in another chart. This can happen,
    // for example, in a tabbed UI where the chart gets created each time the
    // tab gets switched to the chart and uses the same data).
    this.saveCurrentDatasets();
    var datasets = Object.values(this.datasets);
    this.chartInstance.config.data.datasets = datasets;

    this.chartInstance.destroy();
  };

  ChartComponent.prototype.render = function render() {
    var _props3 = this.props,
        height = _props3.height,
        width = _props3.width,
        id = _props3.id;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
      ref: this.ref,
      height: height,
      width: width,
      id: id,
      onClick: this.handleOnClick
    });
  };

  return ChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ChartComponent.getLabelAsKey = function (d) {
  return d.label;
};

ChartComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  getDatasetAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementsAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  legend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onElementsClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
  redraw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: function type(props, propName, componentName) {
    if (!__WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  datasetKeyProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ChartComponent.defaultProps = {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
};


/* unused harmony default export */ var _unused_webpack_default_export = (ChartComponent);

var Doughnut = function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Doughnut.prototype.render = function render() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref) {
        return _this5.chartInstance = _ref && _ref.chartInstance;
      },
      type: 'doughnut'
    }));
  };

  return Doughnut;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Pie = function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  function Pie() {
    _classCallCheck(this, Pie);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  }

  Pie.prototype.render = function render() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref2) {
        return _this7.chartInstance = _ref2 && _ref2.chartInstance;
      },
      type: 'pie'
    }));
  };

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Line = function (_React$Component4) {
  _inherits(Line, _React$Component4);

  function Line() {
    _classCallCheck(this, Line);

    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref3) {
        return _this9.chartInstance = _ref3 && _ref3.chartInstance;
      },
      type: 'line'
    }));
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bar = function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  function Bar() {
    _classCallCheck(this, Bar);

    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
  }

  Bar.prototype.render = function render() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref4) {
        return _this11.chartInstance = _ref4 && _ref4.chartInstance;
      },
      type: 'bar'
    }));
  };

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var HorizontalBar = function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
  }

  HorizontalBar.prototype.render = function render() {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref5) {
        return _this13.chartInstance = _ref5 && _ref5.chartInstance;
      },
      type: 'horizontalBar'
    }));
  };

  return HorizontalBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Radar = function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  function Radar() {
    _classCallCheck(this, Radar);

    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
  }

  Radar.prototype.render = function render() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref6) {
        return _this15.chartInstance = _ref6 && _ref6.chartInstance;
      },
      type: 'radar'
    }));
  };

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Polar = function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  function Polar() {
    _classCallCheck(this, Polar);

    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
  }

  Polar.prototype.render = function render() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref7) {
        return _this17.chartInstance = _ref7 && _ref7.chartInstance;
      },
      type: 'polarArea'
    }));
  };

  return Polar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bubble = function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _possibleConstructorReturn(this, _React$Component9.apply(this, arguments));
  }

  Bubble.prototype.render = function render() {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref8) {
        return _this19.chartInstance = _ref8 && _ref8.chartInstance;
      },
      type: 'bubble'
    }));
  };

  return Bubble;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Scatter = function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _possibleConstructorReturn(this, _React$Component10.apply(this, arguments));
  }

  Scatter.prototype.render = function render() {
    var _this21 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref9) {
        return _this21.chartInstance = _ref9 && _ref9.chartInstance;
      },
      type: 'scatter'
    }));
  };

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var defaults = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.defaults;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(462)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186),
    getRawTag = __webpack_require__(1058),
    objectToString = __webpack_require__(1059);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datepicker__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css__);
var DatePicker=function DatePicker(_ref){var _onChange=_ref.onChange,name=_ref.name,object=_ref.object,onBlur=_ref.onBlur,readOnly=_ref.readOnly,_ref$minDate=_ref.minDate,minDate=_ref$minDate===undefined?__WEBPACK_IMPORTED_MODULE_2_moment___default()():_ref$minDate,_ref$maxDate=_ref.maxDate,maxDate=_ref$maxDate===undefined?null:_ref$maxDate,_ref$placeholder=_ref.placeholder,placeholder=_ref$placeholder===undefined?'':_ref$placeholder,_ref$dateFormat=_ref.dateFormat,dateFormat=_ref$dateFormat===undefined?'DD.MM.YYYY':_ref$dateFormat,_ref$showTimeSelect=_ref.showTimeSelect,showTimeSelect=_ref$showTimeSelect===undefined?false:_ref$showTimeSelect,_ref$onKeyDown=_ref.onKeyDown,onKeyDown=_ref$onKeyDown===undefined?null:_ref$onKeyDown;var value=object[name]?__WEBPACK_IMPORTED_MODULE_2_moment___default()(object[name]):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datepicker__["a" /* default */],{selected:value,className:'form-control',readOnly:readOnly,minDate:minDate,maxDate:maxDate,disabled:readOnly,showTimeSelect:showTimeSelect,dateFormat:dateFormat,placeholderText:placeholder,onChange:function onChange(date){var value=date?date.format('YYYY-MM-DDTHH:mm:ss'):null;_onChange(name,value);onBlur();},onKeyDown:onKeyDown}));};DatePicker.propType={};/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(480);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1226);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findOrCreateAnamnesisRequest */
/* unused harmony export findOrCreateAnamnesisSuccess */
/* unused harmony export findOrCreateAnamnesisError */
/* unused harmony export initializeAnamnesis */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findOrCreateAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return udpateAnamnesis; });
/* unused harmony export saveAnamnesisRequest */
/* unused harmony export saveAnamnesisSuccess */
/* unused harmony export saveAnamnesisError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleInfoLegend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleEditingTreatmentExpectation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initialize_aligner_treatment_physician_assesment__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__initialize_implant_treatment_physician_assesment__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__initialize_implant_consultation_and_findings__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__initialize_implant_surgery_documentation__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_state_task_detail_selector__ = __webpack_require__(77);
var findOrCreateAnamnesisRequest=function findOrCreateAnamnesisRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_OR_CREATE_ANAMNESIS_REQUEST */],payload:{}};};var findOrCreateAnamnesisSuccess=function findOrCreateAnamnesisSuccess(anamnesis){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_OR_CREATE_ANAMNESIS_SUCCESS */],payload:{anamnesis:anamnesis}};};var findOrCreateAnamnesisError=function findOrCreateAnamnesisError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_OR_CREATE_ANAMNESIS_ERROR */],payload:{error:error}};};var initializeAnamnesis=function initializeAnamnesis(anamnesis){switch(anamnesis.templateKey){case __WEBPACK_IMPORTED_MODULE_3__const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]:return Object(__WEBPACK_IMPORTED_MODULE_4__initialize_aligner_treatment_physician_assesment__["a" /* default */])(anamnesis);case __WEBPACK_IMPORTED_MODULE_3__const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]:return Object(__WEBPACK_IMPORTED_MODULE_5__initialize_implant_treatment_physician_assesment__["a" /* default */])(anamnesis);case __WEBPACK_IMPORTED_MODULE_3__const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]:return Object(__WEBPACK_IMPORTED_MODULE_6__initialize_implant_consultation_and_findings__["a" /* default */])(anamnesis);case __WEBPACK_IMPORTED_MODULE_3__const__["f" /* IMPLANT_SURGERY_DOCUMENTATION */]:return Object(__WEBPACK_IMPORTED_MODULE_7__initialize_implant_surgery_documentation__["a" /* default */])(anamnesis);default:return anamnesis;}};var findOrCreateAnamnesis=function findOrCreateAnamnesis(customerId,templateKey){return function(dispatch,getState){dispatch(findOrCreateAnamnesisRequest());var state=getState();var processInstanceId=__WEBPACK_IMPORTED_MODULE_8__process_state_task_detail_selector__["k" /* selectProcessInstanceId */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/anamnesis/get-or-create-anamnesis-by-customer-id?customerId='+customerId+'&templateKey='+templateKey+'&processInstanceId='+processInstanceId).then(function(anamnesis){anamnesis=initializeAnamnesis(anamnesis);dispatch(findOrCreateAnamnesisSuccess(anamnesis));}).catch(function(error){dispatch(findOrCreateAnamnesisError(error));});};};var changeAnamnesis=function changeAnamnesis(name,value,templateKey){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_ANAMNESIS */],payload:{name:name,value:value,templateKey:templateKey}};};var udpateAnamnesis=function udpateAnamnesis(anamnesis,templateKey){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* UPDATE_ANAMNESIS */],payload:{anamnesis:anamnesis,templateKey:templateKey}};};var saveAnamnesisRequest=function saveAnamnesisRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_ANAMNESIS_REQUEST */],payload:{}};};var saveAnamnesisSuccess=function saveAnamnesisSuccess(anamnesis){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_ANAMNESIS_SUCCESS */],payload:{anamnesis:anamnesis}};};var saveAnamnesisError=function saveAnamnesisError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_ANAMNESIS_ERROR */],payload:{error:error}};};var saveAnamnesis=function saveAnamnesis(templateKey){return function(dispatch,getState){var state=getState();var anamnesis=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectAnamnesisByTemplateKey */](state,templateKey);if(!anamnesis){return;}dispatch(saveAnamnesisRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/anamnesis/save-anamnesis',anamnesis).then(function(anamnesis){dispatch(saveAnamnesisSuccess(anamnesis));}).catch(function(error){if(error.messgage){return dispatch(saveAnamnesisError(error));}dispatch(saveAnamnesisError({messgage:'Something went wrong. Please try again.'}));});};};var toggleAnamnesis=function toggleAnamnesis(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* TOGGLE_ANAMNESIS */]};};var toggleInfoLegend=function toggleInfoLegend(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* TOGGLE_INFO_LEGEND */]};};var toggleEditingTreatmentExpectation=function toggleEditingTreatmentExpectation(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* TOGGLE_EDITING_TREATMENT_EXPECTATION */]};};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findSalesOrderRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return findSalesOrderSuccess; });
/* unused harmony export findSalesOrderError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return findSalesOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeSalesOrderCustomer; });
/* unused harmony export saveSalesOrderCustomerRequest */
/* unused harmony export saveSalesOrderCustomerSuccess */
/* unused harmony export saveSalesOrderCustomerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveSalesOrderCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeSalesOrder; });
/* unused harmony export saveSalesOrderRequest */
/* unused harmony export saveSalesOrderSuccess */
/* unused harmony export saveSalesOrderError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return saveSalesOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addSentEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hydrateSalesOrderCustomerContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeSalesOrderCustomerContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return saveSalesOrderCustomerContact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enrich_sales_order__ = __webpack_require__(1322);
var findSalesOrderRequest=function findSalesOrderRequest(salesOrderId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_SALES_ORDER_REQUEST */],payload:{salesOrderId:salesOrderId}};};var findSalesOrderSuccess=function findSalesOrderSuccess(salesOrder){return function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_sales_order__["a" /* enrichSalesOrder */])(getState(),salesOrder);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_SALES_ORDER_SUCCESS */],payload:{salesOrder:salesOrder}});};};var findSalesOrderError=function findSalesOrderError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_SALES_ORDER_ERROR */],payload:{error:error}};};var findSalesOrder=function findSalesOrder(salesOrderId){return function(dispatch,getState){dispatch(findSalesOrderRequest(salesOrderId));Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/sales-order/find-by-id?salesOrderId='+salesOrderId).then(function(salesOrder){dispatch(findSalesOrderSuccess(salesOrder));}).catch(function(error){dispatch(findSalesOrderError(error));});};};var changeSalesOrderCustomer=function changeSalesOrderCustomer(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CHANGE_SALES_ORDER_CUSTOMER */],payload:{name:name,value:value}};};var saveSalesOrderCustomerRequest=function saveSalesOrderCustomerRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_SALES_ORDER_CUSTOMER_REQUEST */]};};var saveSalesOrderCustomerSuccess=function saveSalesOrderCustomerSuccess(salesOrderCustomer){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["m" /* SAVE_SALES_ORDER_CUSTOMER_SUCCESS */],payload:{salesOrderCustomer:salesOrderCustomer}};};var saveSalesOrderCustomerError=function saveSalesOrderCustomerError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_SALES_ORDER_CUSTOMER_ERROR */],payload:{error:error}};};var saveSalesOrderCustomer=function saveSalesOrderCustomer(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectHasChanged */](state);if(!hasChanged){return;}var salesOrderCustomer=__WEBPACK_IMPORTED_MODULE_2__selector__["g" /* selectSalesOrderCustomer */](state);dispatch(saveSalesOrderCustomerRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/sales-order/customer/save',salesOrderCustomer).then(function(salesOrderCustomer){dispatch(saveSalesOrderCustomerSuccess(salesOrderCustomer));}).catch(function(error){dispatch(saveSalesOrderCustomerError(error));});};};var changeSalesOrder=function changeSalesOrder(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_SALES_ORDER */],payload:{name:name,value:value}};};var saveSalesOrderRequest=function saveSalesOrderRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["o" /* SAVE_SALES_ORDER_REQUEST */]};};var saveSalesOrderSuccess=function saveSalesOrderSuccess(salesOrder){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["p" /* SAVE_SALES_ORDER_SUCCESS */],payload:{salesOrder:salesOrder}};};var saveSalesOrderError=function saveSalesOrderError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["n" /* SAVE_SALES_ORDER_ERROR */],payload:{error:error}};};var saveSalesOrder=function saveSalesOrder(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectHasChanged */](state);if(!hasChanged){return;}var salesOrder=__WEBPACK_IMPORTED_MODULE_2__selector__["f" /* selectSalesOrder */](state);dispatch(saveSalesOrderRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/sales-order/save',salesOrder).then(function(salesOrder){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_sales_order__["a" /* enrichSalesOrder */])(state,salesOrder);dispatch(saveSalesOrderSuccess(salesOrder));}).catch(function(error){dispatch(saveSalesOrderError(error));});};};var addSentEmail=function addSentEmail(sentEmail){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* ADD_SENT_EMAIL */],payload:{sentEmail:sentEmail}};};var addInvoice=function addInvoice(invoice){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ADD_INVOICE */],payload:{invoice:invoice}};};var addShipment=function addShipment(shipment){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* ADD_SHIPMENT */],payload:{shipment:shipment}};};var hydrateSalesOrderCustomerContact=function hydrateSalesOrderCustomerContact(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* HYDRATE_SALESORDER_CUSTOMER_CONTACT */]};};var changeSalesOrderCustomerContact=function changeSalesOrderCustomerContact(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_SALES_ORDER_CUSTOMER_CONTACT */],payload:{name:name,value:value}};};var saveSalesOrderCustomerContact=function saveSalesOrderCustomerContact(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectHasChanged */](state);if(!hasChanged){return;}dispatch(saveSalesOrderCustomerRequest());var contact=__WEBPACK_IMPORTED_MODULE_2__selector__["h" /* selectSalesOrderCustomerContact */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/sales-order/customer-contact/save',contact).then(function(salesOrderCustomer){dispatch(saveSalesOrderCustomerSuccess(salesOrderCustomer));}).catch(function(error){dispatch(saveSalesOrderCustomerError(error));}).finally(function(){dispatch(hydrateSalesOrderCustomerContact());});};};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCE_RETAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRODUCE_RETAINER_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHIP_RETAINER_EXTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHIP_RETAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDER_RETAINER; });
var PRODUCE_RETAINER='produce_retainer';var PRODUCE_RETAINER_EXTERNAL='produce_retainer_external';var SHIP_RETAINER_EXTERNAL='ship_retainer_external';var SHIP_RETAINER='ship_retainer';var ORDER_RETAINER='order_retainer';

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(200);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var historyContext =
/*#__PURE__*/
createNamedContext("Router-History");

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext$1 = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext$1("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCATION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onLocationChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return push; });
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
var onLocationChanged = function onLocationChanged(location, action) {
  var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: LOCATION_CHANGE,
    payload: {
      location: location,
      action: action,
      isFirstRendering: isFirstRendering
    }
  };
};
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */

var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

var updateLocation = function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: {
        method: method,
        args: args
      }
    };
  };
};
/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */


var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');
var routerActions = {
  push: push,
  replace: replace,
  go: go,
  goBack: goBack,
  goForward: goForward
};

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'function';
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof Map !== 'undefined' && value instanceof Map;
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TYPE_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return QUERY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return QUERY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUERY_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_MULTI_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOTO_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_HIDDEN_COLUMNS; });
var TYPE_PREFIX='table/';var QUERY_REQUEST='/PREFIX_QUERY_REQUEST';var QUERY_SUCCESS='/TABLE_QUERY_SUCCESS';var QUERY_ERROR='/TABLE_QUERY_ERROR';var CHANGE_FILTER='/CHANGE_FILTER';var TOGGLE_SORT='/TOGGLE_SORT';var TOGGLE_MULTI_SORT='/MULTI_TOGGLE_SORT';var GOTO_PAGE='/GOTO_PAGE';var SET_HIDDEN_COLUMNS='/SET_HIDDEN_COLUMNS';

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PHOTO_REJECTION_REASONS; });
var REDUCER_NAME='task-widget';var PHOTO_REJECTION_REASONS=[{name:"teeth_are_overexposed",title:"Teeth are overexposed"},{name:"photo_is_too_blurry",title:"Photo is too blurry"},{name:"angle_of_the_photo_is_too_small",title:"Angle of the photo is too small"},{name:"upper_lip_blocks_the_gums",title:"Upper lip blocks the gums"},{name:"lower_lip_blocks_the_gums",title:"Lower lip blocks the gums"},{name:"teeth_are_not_properly_clenched_occlusion",title:"Teeth are not properly clenched (occlusion)"},{name:"molars_cannot_be_seen",title:"Molars cannot be seen"}];

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='security';

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='foil';

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='invoice';

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRIORITY_VALUE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXTERNAL_VALUE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SLA_VALUE_LIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_select__ = __webpack_require__(378);
var REDUCER_NAME='task-definition';var PRIORITY_VALUE_LIST=Object(__WEBPACK_IMPORTED_MODULE_0__util_select__["a" /* createSelectValueList */])([0,1,2,3,4,5,6,7,8,9,10,99]);var EXTERNAL_VALUE_LIST=Object(__WEBPACK_IMPORTED_MODULE_0__util_select__["a" /* createSelectValueList */])(['physician','supplier','treatment_planer']);var SLA_VALUE_LIST=Object(__WEBPACK_IMPORTED_MODULE_0__util_select__["a" /* createSelectValueList */])([0,1,2,3,4,5,6,7,8,9,10,99]);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TABLE_ALL_OPEN_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TABLE_PROCESS_WORKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_TASK_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_TASK_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_TASK_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TABLE_SETTING; });
/* unused harmony export CHANGE_ALL_OPEN_TABLE_SETTING */
/* unused harmony export FIND_ALL_OPEN_TASK_LIST_REQUEST */
/* unused harmony export FIND_ALL_OPEN_TASK_LIST_SUCCESS */
/* unused harmony export FIND_ALL_OPEN_TASK_LIST_ERROR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(243);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var TABLE_ALL_OPEN_TASK='allOpenTask';var TABLE_PROCESS_WORKLIST='ProcessWorklist';var FIND_TASK_LIST_REQUEST=NS+'FIND_TASK_LIST_REQUEST';var FIND_TASK_LIST_SUCCESS=NS+'FIND_TASK_LIST_SUCCESS';var FIND_TASK_LIST_ERROR=NS+'FIND_TASK_LIST_ERROR';var CHANGE_TABLE_SETTING=NS+'CHANGE_TABLE_SETTING';var CHANGE_ALL_OPEN_TABLE_SETTING=NS+'CHANGE_ALL_OPEN_TABLE_SETTING';var FIND_ALL_OPEN_TASK_LIST_REQUEST=NS+'FIND_ALL_OPEN_TASK_LIST_REQUEST';var FIND_ALL_OPEN_TASK_LIST_SUCCESS=NS+'FIND_ALL_OPEN_TASK_LIST_SUCCESS';var FIND_ALL_OPEN_TASK_LIST_ERROR=NS+'FIND_ALL_OPEN_TASK_LIST_ERROR';

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='prospect';

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_TASK_LIST_WITH_ATTACHMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TABLE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TABLE_PROCESS_WORKLIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(258);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT='allOpenTaskWithAttachment';var FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST=NS+'FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST';var FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS=NS+'FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS';var FIND_TASK_LIST_WITH_ATTACHMENT_ERROR=NS+'FIND_TASK_LIST_WITH_ATTACHMENT_ERROR';var CHANGE_TABLE_SETTING=NS+'CHANGE_TABLE_SETTING';var TABLE_PROCESS_WORKLIST='ProcessWorklist';

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initGlobals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadGlobals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_state_auth_action__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_util_renderStoreName__ = __webpack_require__(60);
var initGlobals=function initGlobals(globals){return function(dispatch){if(!globals){return;}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* INIT_GLOBALS */],payload:{globals:globals}});Object(__WEBPACK_IMPORTED_MODULE_3__store_util_renderStoreName__["d" /* setStoreList */])(globals.storeList);if(globals.user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__security_state_auth_action__["e" /* loginSuccess */])(globals.user));delete globals.user;}};};var loadGlobals=function loadGlobals(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/globals/get').then(function(globals){dispatch(initGlobals(globals));});};};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(112);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isPlaceholder;
function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
var add = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function add(a, b) {
  return Number(a) + Number(b);
});
/* harmony default export */ __webpack_exports__["a"] = (add);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _curryN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPlaceholder__ = __webpack_require__(166);



/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__isPlaceholder__["a" /* default */])(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : Object(__WEBPACK_IMPORTED_MODULE_0__arity__["a" /* default */])(left, _curryN(length, combined, fn));
  };
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _map;
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString__ = __webpack_require__(134);




/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
var _isArrayLike = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry1__["a" /* default */])(function isArrayLike(x) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isArray__["a" /* default */])(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== 'object') {
    return false;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isString__["a" /* default */])(x)) {
    return false;
  }
  if (x.nodeType === 1) {
    return !!x.length;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});
/* harmony default export */ __webpack_exports__["a"] = (_isArrayLike);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
var assoc = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (assoc);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      var takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */
var nAry = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function nAry(n, fn) {
  switch (n) {
    case 0:
      return function () {
        return fn.call(this);
      };
    case 1:
      return function (a0) {
        return fn.call(this, a0);
      };
    case 2:
      return function (a0, a1) {
        return fn.call(this, a0, a1);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.call(this, a0, a1, a2);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.call(this, a0, a1, a2, a3);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.call(this, a0, a1, a2, a3, a4);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.call(this, a0, a1, a2, a3, a4, a5);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
      };
    default:
      throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
  }
});
/* harmony default export */ __webpack_exports__["a"] = (nAry);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isFunction;
function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__liftN__ = __webpack_require__(412);



/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
var lift = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function lift(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__liftN__["a" /* default */])(fn.length, fn);
});
/* harmony default export */ __webpack_exports__["a"] = (lift);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isString__ = __webpack_require__(134);



/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
var reverse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function reverse(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isString__["a" /* default */])(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});
/* harmony default export */ __webpack_exports__["a"] = (reverse);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _containsWith;
function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_complement__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(270);




/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var reject = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function reject(pred, filterable) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__internal_complement__["a" /* default */])(pred), filterable);
});
/* harmony default export */ __webpack_exports__["a"] = (reject);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curryN__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_has__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_xreduceBy__ = __webpack_require__(853);






/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */
var reduceBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curryN__["a" /* default */])(4, [], /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_4__internal_xreduceBy__["a" /* default */], function reduceBy(valueFn, valueAcc, keyFn, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce__["a" /* default */])(function (acc, elt) {
    var key = keyFn(elt);
    acc[key] = valueFn(Object(__WEBPACK_IMPORTED_MODULE_2__internal_has__["a" /* default */])(key, acc) ? acc[key] : valueAcc, elt);
    return acc;
  }, {}, list);
}));
/* harmony default export */ __webpack_exports__["a"] = (reduceBy);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);



/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
var flip = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function flip(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(fn.length, function (a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});
/* harmony default export */ __webpack_exports__["a"] = (flip);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(62);



/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
var lens = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function lens(getter, setter) {
  return function (toFunctorFn) {
    return function (target) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(function (focus) {
        return setter(focus, target);
      }, toFunctorFn(getter(target)));
    };
  };
});
/* harmony default export */ __webpack_exports__["a"] = (lens);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isObject__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mergeWithKey__ = __webpack_require__(279);




/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */
var mergeDeepWithKey = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function mergeDeepWithKey(fn, lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__mergeWithKey__["a" /* default */])(function (k, lVal, rVal) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isObject__["a" /* default */])(lVal) && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isObject__["a" /* default */])(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});
/* harmony default export */ __webpack_exports__["a"] = (mergeDeepWithKey);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableSelectorEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tableSelectorPartner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(215);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var tableSelectorEmployee=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["b" /* CUSTOMER_TABLE */]);var tableSelectorPartner=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["a" /* CUSTOMER_PARTNER_TABLE */]);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* unused harmony export selectTaskList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectUserTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectTableSetting; });
/* unused harmony export selectAllOpenTaskTableSetting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type__ = __webpack_require__(161);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectTaskList=function selectTaskList(state){return selectOwnState(state).taskList;};var selectUserTaskList=function selectUserTaskList(state){var taskList=selectTaskList(state);return taskList.filter(function(task){return Object(__WEBPACK_IMPORTED_MODULE_3__security_state_auth_selector__["i" /* selectHasRole */])(state,task.role);});};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectTable=Object(__WEBPACK_IMPORTED_MODULE_4__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_5__type__["e" /* TABLE_ALL_OPEN_TASK */]);var selectTableSetting=Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState);var selectAllOpenTaskTableSetting=Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState,'allOpenTaskTableSetting');

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1047),
    listCacheDelete = __webpack_require__(1048),
    listCacheGet = __webpack_require__(1049),
    listCacheHas = __webpack_require__(1050),
    listCacheSet = __webpack_require__(1051);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(464);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(79);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1071);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(140),
    isObjectLike = __webpack_require__(142);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(189);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export makeAsyncSelect */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export makeCreatableSelect */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* unused harmony export components */
/* unused harmony export mergeStyles */
/* unused harmony export defaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_5_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  _createClass(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  var cn = cx(
  /*#__PURE__*/
  Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menu', props)), {
    menu: true
  }, className);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cn
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuList', props)), {
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('noOptionsMessage', props)), {
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingMessage', props)), {
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  _inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  _createClass(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuPortal', state))
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      label: 'a11yText',
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  _inherits(DummyInput, _Component);

  function DummyInput() {
    _classCallCheck(this, DummyInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
  }

  _createClass(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
        ref: innerRef
      }, props, {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          label: 'dummyInput',
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  _createClass(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      touchScrollTarget: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  _createClass(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onClick: this.blurSelectInput,
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          position: 'fixed',
          left: 0,
          bottom: 0,
          right: 0,
          top: 0
        })
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  _createClass(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no scroll available
      if (!el) return;
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  _inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    _classCallCheck(this, ScrollCaptorSwitch);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
  }

  _createClass(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('container', props)), {
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ValueContainer, _Component);

  function ValueContainer() {
    _classCallCheck(this, ValueContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
  }

  _createClass(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('valueContainer', this.props)), {
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorsContainer', props)), {
      'indicators': true
    }, className)
  }, children);
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('dropdownIndicator', props)), {
      'indicator': true,
      'dropdown-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('clearIndicator', props)), {
      'indicator': true,
      'clear-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorSeparator', props)), {
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';
var keyframesInjected = false;
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      animationDuration: '1s',
      animationDelay: "".concat(delay, "ms"),
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;
  var color = isFocused ? colors.neutral80 : colors.neutral20;

  if (!keyframesInjected) {
    // eslint-disable-next-line no-unused-expressions
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["b" /* injectGlobal */])("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
    keyframesInjected = true;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingIndicator', props)), {
      'indicator': true,
      'loading-indicator': true
    }, className)
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 0,
    offset: isRtl
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 160,
    offset: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('control', props)), {
      'control': true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('group', props)), {
      'group': true
    }, className)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('groupHeading', _objectSpread({
      theme: theme
    }, cleanProps))), {
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('input', _objectSpread({
      theme: theme
    }, props)))
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default.a, _extends({
    className: cx(null, {
      'input': true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    _classCallCheck(this, MultiValueRemove);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
  }

  _createClass(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  _inherits(MultiValue, _Component2);

  function MultiValue() {
    _classCallCheck(this, MultiValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
  }

  _createClass(MultiValue, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;

      var containerInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container, {
        data: data,
        innerProps: containerInnerProps,
        selectProps: selectProps
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, {
        data: data,
        innerProps: labelInnerProps,
        selectProps: selectProps
      }, children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Remove, {
        data: data,
        innerProps: removeInnerProps,
        selectProps: selectProps
      }));
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('option', props)), {
      'option': true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className)
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('placeholder', props)), {
      'placeholder': true
    }, className)
  }, innerProps), children);
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('singleValue', props)), {
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
var baseUnit = 4;
/* Used to calculate consistent margin/padding on elements */

var controlHeight = 38;
/* The minimum height of the control */

var menuGutter = baseUnit * 2;
/* The amount of space between the control and menu */

var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components$$1) {
      _this.components = defaultComponents({
        components: components$$1
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread({}, actionMeta, {
        name: name
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      _this.onChange(selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      }), {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        //$FlowFixMe
        if (event.target.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      } //$FlowFixMe


      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;
      setTimeout(function () {
        return _this.focusInput();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
      _this.isComposing = true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
      _this.isComposing = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(value);

    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = classNames.bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isOptionFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MultiValue, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SingleValue, _extends({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu$$1 = _this$components3.Menu,
          MenuList$$1 = _this$components3.MenuList,
          MenuPortal$$1 = _this$components3.MenuPortal,
          LoadingMessage$$1 = _this$components3.LoadingMessage,
          NoOptionsMessage$$1 = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option, _extends({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = _objectWithoutProperties(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, _extends({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingMessage$$1, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoOptionsMessage$$1, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Menu$$1, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuList$$1, _extends({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPortal$$1, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A11yText, {
        "aria-live": "assertive"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectContainer, _extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Control, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorsContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "defaultProps", defaultProps);

var defaultProps$1 = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    _createClass(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$1), _temp;
};

var defaultProps$2 = {
  cacheOptions: false,
  defaultOptions: false,
  filterOption: null
};
var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Async, _Component);

    function Async(props) {
      var _this;

      _classCallCheck(this, Async);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

        if (!inputValue) {
          delete _this.lastRequest;

          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });

          return;
        }

        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};

          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;

              if (options) {
                _this.optionsCache[inputValue] = options;
              }

              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;

              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }

        return inputValue;
      });

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    _createClass(Async, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;
        var inputValue = this.state.inputValue;

        if (defaultOptions === true) {
          this.loadOptions(inputValue, function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;

            _this2.setState({
              defaultOptions: options || [],
              isLoading: isLoading
            });
          });
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }

        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "loadOptions",
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;
        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);

        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props,
            loadOptions = _this$props2.loadOptions,
            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);

        var _this$state = this.state,
            defaultOptions = _this$state.defaultOptions,
            inputValue = _this$state.inputValue,
            isLoading = _this$state.isLoading,
            loadedInputValue = _this$state.loadedInputValue,
            loadedOptions = _this$state.loadedOptions,
            passEmptyOptions = _this$state.passEmptyOptions;
        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this3.select = _ref;
          },
          options: options,
          isLoading: isLoading,
          onInputChange: this.handleInputChange
        }));
      }
    }]);

    return Async;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$2), _temp;
};
var SelectState = manageState(Select);
var Async = makeAsyncSelect(SelectState);

var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps$3 = _objectSpread({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Creatable, _Component);

    function Creatable(props) {
      var _this;

      _classCallCheck(this, Creatable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option'
            };

            if (isMulti) {
              onChange([].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      });

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    _createClass(Creatable, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;
        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }

        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var props = _extends({}, this.props);

        var options = this.state.options;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);

    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$3), _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(Select);
var Creatable = manageState(SelectCreatable);

var SelectCreatable$1 = makeCreatableSelect(Select);
var SelectCreatableState = manageState(SelectCreatable$1);
var AsyncCreatable = makeAsyncSelect(SelectCreatableState);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };
};

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);

  var transition = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity ".concat(duration, "ms")
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
    mountOnEnter: true,
    unmountOnExit: true,
    in: inProp,
    timeout: duration
  }, function (state) {
    var innerProps = {
      style: _objectSpread({}, transition[state])
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
      innerProps: innerProps
    }, props));
  });
}; // ==============================
// Collapse Transition
// ==============================

var collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      width: 'auto'
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
      exiting: {
        width: 0,
        transition: "width ".concat(_this.duration, "ms ease-out")
      },
      exited: {
        width: 0
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
      if (ref && isNaN(_this.state.width)) {
        /*
          Here we're invoking requestAnimationFrame with a callback invoking our
          call to getBoundingClientRect and setState in order to resolve an edge case
          around portalling. Certain portalling solutions briefly remove children from the DOM
          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
          while the Select component is in this state.
        */
        // cannot use `offsetWidth` because it is rounded
        _this.rafID = window.requestAnimationFrame(function () {
          var _ref$getBoundingClien = ref.getBoundingClientRect(),
              width = _ref$getBoundingClien.width;

          _this.setState({
            width: width
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
      return _this.transition[state];
    });

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafID) {
        window.cancelAnimationFrame(this.rafID);
      }
    } // width must be calculated; cannot transition from `undefined` to `number`

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          inProp = _this$props.in;
      var width = this.state.width;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
        enter: false,
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        timeout: this.duration
      }, function (state) {
        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          ref: _this2.getWidth,
          style: style
        }, children);
      });
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties(_ref, ["in", "onExited"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, {
      in: inProp,
      onExited: onExited
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
      cropWithEllipsis: inProp
    }, props)));
  };
};

var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent
    }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({
      component: WrappedComponent
    }, props));
  };
};

var makeAnimated = function makeAnimated() {
  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components$$1 = defaultComponents({
    components: externalComponents
  });

  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = _objectWithoutProperties(components$$1, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);

  return _objectSpread({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();
var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;
var index = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* harmony default export */ __webpack_exports__["a"] = (index$1);



/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Comment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Row__ = __webpack_require__(5);
var textWithLink=function textWithLink(text){if(!text){return null;}var wordList=text.split(' ');return wordList.map(function(word,key){return word.startsWith('http')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:key,href:word,target:'_blank',rel:'noopener noreferrer'},word,'\xA0'):word+' ';});};var Comment=function Comment(_ref){var comment=_ref.comment;if(!comment.message){return null;}var className=comment.isUserAuthor?'comment comment-sender':'comment comment-receiver';var author=comment.isUserAuthor?'':comment.author+' ';var iconClassName=comment.isInternal?'fa fa-lock fa-lg':'fa fa-globe fa-lg';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:comment.id,className:'comment-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-timestamp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,author+Object(__WEBPACK_IMPORTED_MODULE_3__util_datetime__["c" /* formatDateTime */])(comment.created))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:iconClassName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},comment.message.split('\n').map(function(item,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:key},textWithLink(item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})));};var CommentList=function CommentList(_ref2){var changeProcessComment=_ref2.changeProcessComment,commentText=_ref2.commentText,commentProcessInstance=_ref2.commentProcessInstance,commentList=_ref2.commentList,validationMessageList=_ref2.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["k" /* COMMENT_LIST */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),commentList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-list'},commentList.map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comment,{key:comment.id,comment:comment});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_TextArea__["a" /* default */],{className:'form-control comment-post-textarea',object:{commentText:commentText},name:'commentText',onChange:changeProcessComment,placeholder:'Enter comment. Click button below to submit.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!commentText,onClick:commentProcessInstance},'Save Comment')));};CommentList.propTypes={changeProcessComment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,commentProcessInstance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,commentText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,commentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["b"] = (CommentList);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAnamnesisList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectShowAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectShowInfoLegendShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectLastMedicalAssessment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__anamnesis_const__ = __webpack_require__(27);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectAnamnesisList=function selectAnamnesisList(state){return selectOwnState(state).anamnesisList;};var selectShowAnamnesis=function selectShowAnamnesis(state){return selectOwnState(state).showAnamnesis;};var selectShowInfoLegendShown=function selectShowInfoLegendShown(state){return selectOwnState(state).isInfoLegendShown;};var selectLastMedicalAssessment=function selectLastMedicalAssessment(state){return selectAnamnesisList(state).find(function(el){return el.templateKey===__WEBPACK_IMPORTED_MODULE_2__anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */];});};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_money__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_const__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant_payment_constant__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__ = __webpack_require__(2);
var moment=__webpack_require__(38);var BankPayment=function BankPayment(_ref){var payment=_ref.payment;var bankPayment=payment.bankPayment;var type=__WEBPACK_IMPORTED_MODULE_7__state_const__["a" /* BANK_PAYMENT_TEXT */][bankPayment.type];var reference=bankPayment.reference;if(bankPayment.type===__WEBPACK_IMPORTED_MODULE_8__constant_payment_constant__["h" /* BANK_ZAB */]){reference+=' '+bankPayment.customerReference;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(payment.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'bank account'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,reference),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},Object(__WEBPACK_IMPORTED_MODULE_6__util_money__["b" /* formatMoney */])(payment.amount,payment.currency)));};var StripePayment=function StripePayment(_ref2){var payment=_ref2.payment;var stripePayment=payment.stripePayment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(payment.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'stripe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,stripePayment.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://dashboard.stripe.com/payments/'+stripePayment.transactionId,target:'_blank',rel:'noopener noreferrer'},stripePayment.transactionId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},Object(__WEBPACK_IMPORTED_MODULE_6__util_money__["b" /* formatMoney */])(payment.amount,payment.currency)));};var getPayPalId=function getPayPalId(_ref3){var paymentExecution=_ref3.paymentExecution;if(!paymentExecution){return null;}var transactions=paymentExecution.transactions;if(!transactions){return null;}var transaction=transactions[0];if(!transaction){return null;}var related_resources=transaction.related_resources;if(!related_resources){return null;}var related_resource=related_resources[0];if(!related_resource){return null;}var sale=related_resource.sale;if(!sale){return null;}return sale.id;};var PayPalPaymentExecuted=function PayPalPaymentExecuted(_ref4){var payment=_ref4.payment;var payPalPaymentExecuted=payment.payPalPaymentExecuted;var payPalPayment=payPalPaymentExecuted.payPalPayment;if(!payPalPayment){return null;}var payPalId=getPayPalId(payPalPayment);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(payment.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'paypal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,payPalPaymentExecuted.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.paypal.com/activity/payment/'+payPalId,target:'_blank',rel:'noopener noreferrer'},payPalId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},Object(__WEBPACK_IMPORTED_MODULE_6__util_money__["b" /* formatMoney */])(payment.amount,payment.currency)));};var Payment=function Payment(_ref5){var payment=_ref5.payment;if(payment.bankPayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BankPayment,{payment:payment});}if(payment.stripePayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StripePayment,{payment:payment});}if(payment.payPalPaymentExecuted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PayPalPaymentExecuted,{payment:payment});}return null;};var PaymentList=function PaymentList(_ref6){var _ref6$skipAuthorizati=_ref6.skipAuthorization,skipAuthorization=_ref6$skipAuthorizati===undefined?false:_ref6$skipAuthorizati,paymentList=_ref6.paymentList;if(!skipAuthorization&&!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__["O" /* PAYMENT_LIST_WIDGET */])){return null;}// sort by date
paymentList.sort(function(a,b){return moment(a.date).unix()-moment(b.date).unix();});var sum=0;var currency=paymentList.length!==0?paymentList[0].currency:'EUR';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Payments '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'150'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'150'},'Channel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'150'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reference'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'150'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,paymentList.map(function(payment){sum+=payment.amount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Payment,{key:payment.id,payment:payment});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'150',className:'align-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_6__util_money__["b" /* formatMoney */])(sum,currency)))))))));};PaymentList.propTypes={skipAuthorization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,paymentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PaymentList);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return callNumber; });
var callNumber=function callNumber(phoneNumber){return function(dispatch,getState){window.location.href="tel:"+phoneNumber;};};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUIDefinitionByStateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUIDefinitionByTaskName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sales_order_set_and_shop_scan_assign_physician__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sales_order_set_and_shop_scan_check_customer_images__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sales_order_set_and_shop_scan_check_images__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sales_order_set_and_shop_scan_check_images_and_scans__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sales_order_set_and_shop_scan_check_images_and_scans_refinement__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sales_order_set_and_shop_scan_check_images_post__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sales_order_set_and_shop_scan_check_imprints_visually__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sales_order_set_and_shop_scan_check_scans__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sales_order_set_and_shop_scan_confirm_treatment_plan_done__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sales_order_set_and_shop_scan_clarify_remarks__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sales_order_set_and_shop_scan_create_treatment_plan__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sales_order_set_and_shop_scan_create_treatment_plan_external__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sales_order_set_and_shop_scan_create_treatment_plan_external_planer__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sales_order_set_and_shop_scan_create_external_treatment_plan_visualization__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sales_order_set_and_shop_scan_check_treatability__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sales_order_set_and_shop_scan_create_treatment_quotation__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sales_order_set_and_shop_scan_create_refinement_plan__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sales_order_set_and_shop_scan_create_refinement_plan_external__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sales_order_set_and_shop_scan_create_refinement_quotation__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sales_order_set_and_shop_scan_do_sepa_payment__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sales_order_set_and_shop_scan_enter_physician_feedback__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sales_order_set_and_shop_scan_manually_check_image_availability__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sales_order_set_and_shop_scan_order_aligner__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sales_order_set_and_shop_scan_refund__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sales_order_set_and_shop_scan_provide_treatment_setup__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sales_order_set_and_shop_scan_provide_refinement_setup__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sales_order_set_and_shop_scan_review_treatment_plan__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sales_order_set_and_shop_scan_review_refinement_plan__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__sales_order_set_and_shop_scan_review_treatment_plan_internal__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sales_order_set_and_shop_scan_scan_imprints__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sales_order_set_and_shop_scan_send_treatment_quoation_reminder_whats_app_1__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sales_order_set_and_shop_scan_send_treatment_quoation_reminder_whats_app_2__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__sales_order_set_and_shop_scan_ship_set__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sales_order_set_and_shop_scan_treatment_quotation_created__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sales_order_set_and_shop_scan_treatment_quotation_created_whats_app__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__sales_order_set_and_shop_scan_treatment_quotation_follow_up_call_1__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sales_order_set_and_shop_scan_treatment_quotation_follow_up_call_2__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sales_order_set_and_shop_scan_upload_treatment_plan_files__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sales_order_set_and_shop_scan_visualization_check__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__sales_order_set_and_shop_scan_upload_case__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__sales_order_set_and_shop_scan_validate_cannot_be_treated__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__sales_order_set_and_shop_scan_clarify_pre_treatment__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__sales_order_set_and_shop_scan_pre_treatment_check__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__sales_order_set_and_shop_scan_bad_imprint_patient_call__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__sales_order_set_and_shop_scan_make_customer_appointment__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__sales_order_set_and_shop_scan_make_new_customer_appointment__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__sales_order_set_and_shop_scan_prepare_treatment_files__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__sales_order_check_in_appointment_reminder_call__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__sales_order_check_in_check_id__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__sales_order_check_in_complete_anamnesis__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__sales_order_check_in_validate_appointment__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__sales_order_check_in_make_customer_scan_appointment__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__sales_order_check_in_make_customer_ipr_appointment__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__sales_order_treatment_check_photo_checkin__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__sales_order_treatment_final_check_photo_checkin__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__sales_order_treatment_provide_customer_communication_reason__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__sales_order_treatment_clarify_refinement__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__sales_order_treatment_provide_physician_recommendation__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__sales_order_treatment_confirm_treatment_payments__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__sales_order_treatment_follow_up_call__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__sales_order_treatment_refinement_clarification_call__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__sales_order_treatment_print_models__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__sales_order_treatment_print_missing_models__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__sales_order_treatment_precheck_photo_checkin__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__sales_order_treatment_produce_aligner__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__sales_order_treatment_produce_aligner_external__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__sales_order_treatment_provide_movement_certificate_number__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__sales_order_treatment_ship_aligner__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__sales_order_treatment_ship_aligner_external__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__sales_order_treatment_thermo_form__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__sales_order_treatment_upload_production_files__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__sales_order_treatment_forward_images_to_physician__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__sales_order_treatment_marking_models__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__sales_order_treatment_make_customer_ipr_appointment__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__sales_order_treatment_nesting__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__sales_order_treatment_nest_missing_models__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__sales_order_treatment_create_invoice_correction__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__sales_order_treatment_print_case_card__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__sales_order_treatment_reduce_enamel__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__sales_order_treatment_start_sorting__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__sales_order_treatment_sorting_models__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__sales_order_aligner_reproduction_choose_aligner__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__sales_order_aligner_reproduction_produce_missing_aligner_external__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__sales_order_retainer_produce_retainer__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__sales_order_retainer_produce_retainer_external__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__sales_order_retainer_ship_retainer_external__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__sales_order_retainer_ship_retainer__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__sales_order_retainer_order_retainer__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__sales_order_default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__sales_order_in_shop_scan_consult_customer__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__sales_order_in_shop_scan_enter_dob__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__sales_order_in_shop_scan_medical_check__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__sales_order_in_shop_scan_rescan__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__sales_order_in_shop_scan_refinement_medical_check__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__sales_order_in_shop_scan_medical_check_with_pretreatment__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__sales_order_in_shop_scan_medical_assessment__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__sales_order_in_shop_scan_confirm_medical_check__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__sales_order_in_shop_scan_confirm_refinement_medical_check__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__sales_order_in_shop_scan_confirm_medical_check_with_pretreatment__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__sales_order_in_shop_scan_confirm_medical_assessment__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__sales_order_in_shop_scan_select_refinement_type__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__sales_order_in_shop_scan_scan_customer__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__sales_order_in_shop_scan_take_pictures__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__sales_order_in_shop_scan_upload_scans__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__sales_order_implant_3dscan_upload_cbct__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__sales_order_in_shop_scan_upload_scan_files_manually__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__sales_order_in_shop_scan_match_3shape__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__sales_order_in_shop_scan_validate_pretreatment__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__sales_order_in_shop_scan_ipr_clearing_up__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__sales_order_in_shop_scan_ipr_explanation__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__sales_order_in_shop_scan_manual_address_check__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__sales_order_set_and_shop_scan_treatment_plan_complexity_assignment__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__sales_order_implant_3dscan_implant_medical_check__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__sales_order_implant_3dscan_confirm_implant_medical_check__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__sales_order_implant_plan_implant_create_treatment_plan__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__sales_order_implant_plan_implant_review_treatment_plan__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__sales_order_implant_plan_implant_create_treatment_quotation__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__sales_order_implant_plan_qm_review_treatmen_plan_internal__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__sales_order_implant_treatment_nesting_surgical_guide__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__sales_order_implant_treatment_pack_surgical_guide__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__sales_order_implant_treatment_print_surgical_guide__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__sales_order_implant_treatment_ship_surgical_guide__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__sales_order_implant_treatment_fit_guide__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__sales_order_implant_treatment_marking_and_export__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__sales_order_implant_treatment_implant_surgery__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__sales_order_retainer_refinement_prepare_retainer_files__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__sales_order_escalation_call_customer__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__sales_order_end_of_treatment_end_of_treatment_call__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__sales_order_partial_refund_input_refund_data__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__sales_order_partial_refund_confirm_refund__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__sales_order_treatment_clarify_aligner_checkin_comment__ = __webpack_require__(1470);
// set and shop scan
// check in
// treatments
// aligner reproduction
// retainer
// in shop scan
// implant 3dscan
// implant plan
// implant treatment
//retainer refinement
// escalation
//end of treatment
// partial refund
var taskDefinition=[// checkin
__WEBPACK_IMPORTED_MODULE_47__sales_order_check_in_appointment_reminder_call__["a" /* default */],__WEBPACK_IMPORTED_MODULE_48__sales_order_check_in_check_id__["a" /* default */],__WEBPACK_IMPORTED_MODULE_49__sales_order_check_in_complete_anamnesis__["a" /* default */],__WEBPACK_IMPORTED_MODULE_50__sales_order_check_in_validate_appointment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_51__sales_order_check_in_make_customer_scan_appointment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_52__sales_order_check_in_make_customer_ipr_appointment__["a" /* default */],// shop and set
__WEBPACK_IMPORTED_MODULE_0__sales_order_set_and_shop_scan_assign_physician__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__sales_order_set_and_shop_scan_check_customer_images__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__sales_order_set_and_shop_scan_check_images__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3__sales_order_set_and_shop_scan_check_images_and_scans__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__sales_order_set_and_shop_scan_check_images_and_scans_refinement__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5__sales_order_set_and_shop_scan_check_images_post__["a" /* default */],__WEBPACK_IMPORTED_MODULE_6__sales_order_set_and_shop_scan_check_imprints_visually__["a" /* default */],__WEBPACK_IMPORTED_MODULE_7__sales_order_set_and_shop_scan_check_scans__["a" /* default */],__WEBPACK_IMPORTED_MODULE_14__sales_order_set_and_shop_scan_check_treatability__["a" /* default */],__WEBPACK_IMPORTED_MODULE_8__sales_order_set_and_shop_scan_confirm_treatment_plan_done__["a" /* default */],__WEBPACK_IMPORTED_MODULE_10__sales_order_set_and_shop_scan_create_treatment_plan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_11__sales_order_set_and_shop_scan_create_treatment_plan_external__["a" /* default */],__WEBPACK_IMPORTED_MODULE_12__sales_order_set_and_shop_scan_create_treatment_plan_external_planer__["a" /* default */],__WEBPACK_IMPORTED_MODULE_13__sales_order_set_and_shop_scan_create_external_treatment_plan_visualization__["a" /* default */],__WEBPACK_IMPORTED_MODULE_15__sales_order_set_and_shop_scan_create_treatment_quotation__["a" /* default */],__WEBPACK_IMPORTED_MODULE_16__sales_order_set_and_shop_scan_create_refinement_plan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_17__sales_order_set_and_shop_scan_create_refinement_plan_external__["a" /* default */],__WEBPACK_IMPORTED_MODULE_18__sales_order_set_and_shop_scan_create_refinement_quotation__["a" /* default */],__WEBPACK_IMPORTED_MODULE_41__sales_order_set_and_shop_scan_clarify_pre_treatment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_9__sales_order_set_and_shop_scan_clarify_remarks__["a" /* default */],__WEBPACK_IMPORTED_MODULE_19__sales_order_set_and_shop_scan_do_sepa_payment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_20__sales_order_set_and_shop_scan_enter_physician_feedback__["a" /* default */],__WEBPACK_IMPORTED_MODULE_21__sales_order_set_and_shop_scan_manually_check_image_availability__["a" /* default */],__WEBPACK_IMPORTED_MODULE_22__sales_order_set_and_shop_scan_order_aligner__["a" /* default */],__WEBPACK_IMPORTED_MODULE_23__sales_order_set_and_shop_scan_refund__["a" /* default */],__WEBPACK_IMPORTED_MODULE_42__sales_order_set_and_shop_scan_pre_treatment_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_24__sales_order_set_and_shop_scan_provide_treatment_setup__["a" /* default */],__WEBPACK_IMPORTED_MODULE_25__sales_order_set_and_shop_scan_provide_refinement_setup__["a" /* default */],__WEBPACK_IMPORTED_MODULE_26__sales_order_set_and_shop_scan_review_treatment_plan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_27__sales_order_set_and_shop_scan_review_refinement_plan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_28__sales_order_set_and_shop_scan_review_treatment_plan_internal__["a" /* default */],__WEBPACK_IMPORTED_MODULE_29__sales_order_set_and_shop_scan_scan_imprints__["a" /* default */],__WEBPACK_IMPORTED_MODULE_30__sales_order_set_and_shop_scan_send_treatment_quoation_reminder_whats_app_1__["a" /* default */],__WEBPACK_IMPORTED_MODULE_31__sales_order_set_and_shop_scan_send_treatment_quoation_reminder_whats_app_2__["a" /* default */],__WEBPACK_IMPORTED_MODULE_32__sales_order_set_and_shop_scan_ship_set__["a" /* default */],__WEBPACK_IMPORTED_MODULE_33__sales_order_set_and_shop_scan_treatment_quotation_created__["a" /* default */],__WEBPACK_IMPORTED_MODULE_34__sales_order_set_and_shop_scan_treatment_quotation_created_whats_app__["a" /* default */],__WEBPACK_IMPORTED_MODULE_35__sales_order_set_and_shop_scan_treatment_quotation_follow_up_call_1__["a" /* default */],__WEBPACK_IMPORTED_MODULE_36__sales_order_set_and_shop_scan_treatment_quotation_follow_up_call_2__["a" /* default */],__WEBPACK_IMPORTED_MODULE_39__sales_order_set_and_shop_scan_upload_case__["a" /* default */],__WEBPACK_IMPORTED_MODULE_40__sales_order_set_and_shop_scan_validate_cannot_be_treated__["a" /* default */],__WEBPACK_IMPORTED_MODULE_37__sales_order_set_and_shop_scan_upload_treatment_plan_files__["a" /* default */],__WEBPACK_IMPORTED_MODULE_38__sales_order_set_and_shop_scan_visualization_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_43__sales_order_set_and_shop_scan_bad_imprint_patient_call__["a" /* default */],__WEBPACK_IMPORTED_MODULE_111__sales_order_set_and_shop_scan_treatment_plan_complexity_assignment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_44__sales_order_set_and_shop_scan_make_customer_appointment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_45__sales_order_set_and_shop_scan_make_new_customer_appointment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_46__sales_order_set_and_shop_scan_prepare_treatment_files__["a" /* default */],// treatment
__WEBPACK_IMPORTED_MODULE_58__sales_order_treatment_confirm_treatment_payments__["a" /* default */],__WEBPACK_IMPORTED_MODULE_53__sales_order_treatment_check_photo_checkin__["a" /* default */],__WEBPACK_IMPORTED_MODULE_54__sales_order_treatment_final_check_photo_checkin__["a" /* default */],__WEBPACK_IMPORTED_MODULE_55__sales_order_treatment_provide_customer_communication_reason__["a" /* default */],__WEBPACK_IMPORTED_MODULE_56__sales_order_treatment_clarify_refinement__["a" /* default */],__WEBPACK_IMPORTED_MODULE_130__sales_order_treatment_clarify_aligner_checkin_comment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_57__sales_order_treatment_provide_physician_recommendation__["a" /* default */],__WEBPACK_IMPORTED_MODULE_59__sales_order_treatment_follow_up_call__["a" /* default */],__WEBPACK_IMPORTED_MODULE_60__sales_order_treatment_refinement_clarification_call__["a" /* default */],__WEBPACK_IMPORTED_MODULE_61__sales_order_treatment_print_models__["a" /* default */],__WEBPACK_IMPORTED_MODULE_64__sales_order_treatment_produce_aligner__["a" /* default */],__WEBPACK_IMPORTED_MODULE_65__sales_order_treatment_produce_aligner_external__["a" /* default */],__WEBPACK_IMPORTED_MODULE_66__sales_order_treatment_provide_movement_certificate_number__["a" /* default */],__WEBPACK_IMPORTED_MODULE_67__sales_order_treatment_ship_aligner__["a" /* default */],__WEBPACK_IMPORTED_MODULE_69__sales_order_treatment_thermo_form__["a" /* default */],__WEBPACK_IMPORTED_MODULE_70__sales_order_treatment_upload_production_files__["a" /* default */],__WEBPACK_IMPORTED_MODULE_68__sales_order_treatment_ship_aligner_external__["a" /* default */],__WEBPACK_IMPORTED_MODULE_63__sales_order_treatment_precheck_photo_checkin__["a" /* default */],__WEBPACK_IMPORTED_MODULE_71__sales_order_treatment_forward_images_to_physician__["a" /* default */],__WEBPACK_IMPORTED_MODULE_76__sales_order_treatment_create_invoice_correction__["a" /* default */],__WEBPACK_IMPORTED_MODULE_72__sales_order_treatment_marking_models__["a" /* default */],__WEBPACK_IMPORTED_MODULE_73__sales_order_treatment_make_customer_ipr_appointment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_77__sales_order_treatment_print_case_card__["a" /* default */],__WEBPACK_IMPORTED_MODULE_74__sales_order_treatment_nesting__["a" /* default */],__WEBPACK_IMPORTED_MODULE_78__sales_order_treatment_reduce_enamel__["a" /* default */],__WEBPACK_IMPORTED_MODULE_62__sales_order_treatment_print_missing_models__["a" /* default */],__WEBPACK_IMPORTED_MODULE_75__sales_order_treatment_nest_missing_models__["a" /* default */],__WEBPACK_IMPORTED_MODULE_79__sales_order_treatment_start_sorting__["a" /* default */],__WEBPACK_IMPORTED_MODULE_80__sales_order_treatment_sorting_models__["a" /* default */],// retainer
__WEBPACK_IMPORTED_MODULE_83__sales_order_retainer_produce_retainer__["a" /* default */],__WEBPACK_IMPORTED_MODULE_84__sales_order_retainer_produce_retainer_external__["a" /* default */],__WEBPACK_IMPORTED_MODULE_85__sales_order_retainer_ship_retainer_external__["a" /* default */],__WEBPACK_IMPORTED_MODULE_86__sales_order_retainer_ship_retainer__["a" /* default */],__WEBPACK_IMPORTED_MODULE_87__sales_order_retainer_order_retainer__["a" /* default */],// in shop scan
__WEBPACK_IMPORTED_MODULE_89__sales_order_in_shop_scan_consult_customer__["a" /* default */],__WEBPACK_IMPORTED_MODULE_90__sales_order_in_shop_scan_enter_dob__["a" /* default */],__WEBPACK_IMPORTED_MODULE_91__sales_order_in_shop_scan_medical_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_94__sales_order_in_shop_scan_medical_check_with_pretreatment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_95__sales_order_in_shop_scan_medical_assessment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_92__sales_order_in_shop_scan_rescan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_96__sales_order_in_shop_scan_confirm_medical_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_98__sales_order_in_shop_scan_confirm_medical_check_with_pretreatment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_99__sales_order_in_shop_scan_confirm_medical_assessment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_97__sales_order_in_shop_scan_confirm_refinement_medical_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_93__sales_order_in_shop_scan_refinement_medical_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_100__sales_order_in_shop_scan_select_refinement_type__["a" /* default */],__WEBPACK_IMPORTED_MODULE_101__sales_order_in_shop_scan_scan_customer__["a" /* default */],__WEBPACK_IMPORTED_MODULE_102__sales_order_in_shop_scan_take_pictures__["a" /* default */],__WEBPACK_IMPORTED_MODULE_103__sales_order_in_shop_scan_upload_scans__["a" /* default */],__WEBPACK_IMPORTED_MODULE_106__sales_order_in_shop_scan_match_3shape__["a" /* default */],__WEBPACK_IMPORTED_MODULE_104__sales_order_implant_3dscan_upload_cbct__["a" /* default */],__WEBPACK_IMPORTED_MODULE_105__sales_order_in_shop_scan_upload_scan_files_manually__["a" /* default */],__WEBPACK_IMPORTED_MODULE_107__sales_order_in_shop_scan_validate_pretreatment__["a" /* default */],__WEBPACK_IMPORTED_MODULE_108__sales_order_in_shop_scan_ipr_clearing_up__["a" /* default */],__WEBPACK_IMPORTED_MODULE_109__sales_order_in_shop_scan_ipr_explanation__["a" /* default */],__WEBPACK_IMPORTED_MODULE_110__sales_order_in_shop_scan_manual_address_check__["a" /* default */],// aligner reproduction
__WEBPACK_IMPORTED_MODULE_81__sales_order_aligner_reproduction_choose_aligner__["a" /* default */],__WEBPACK_IMPORTED_MODULE_82__sales_order_aligner_reproduction_produce_missing_aligner_external__["a" /* default */],// implant 3dScan
__WEBPACK_IMPORTED_MODULE_112__sales_order_implant_3dscan_implant_medical_check__["a" /* default */],__WEBPACK_IMPORTED_MODULE_113__sales_order_implant_3dscan_confirm_implant_medical_check__["a" /* default */],// implant plan
__WEBPACK_IMPORTED_MODULE_114__sales_order_implant_plan_implant_create_treatment_plan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_115__sales_order_implant_plan_implant_review_treatment_plan__["a" /* default */],__WEBPACK_IMPORTED_MODULE_116__sales_order_implant_plan_implant_create_treatment_quotation__["a" /* default */],__WEBPACK_IMPORTED_MODULE_117__sales_order_implant_plan_qm_review_treatmen_plan_internal__["a" /* default */],// implant treatment
__WEBPACK_IMPORTED_MODULE_118__sales_order_implant_treatment_nesting_surgical_guide__["a" /* default */],__WEBPACK_IMPORTED_MODULE_119__sales_order_implant_treatment_pack_surgical_guide__["a" /* default */],__WEBPACK_IMPORTED_MODULE_120__sales_order_implant_treatment_print_surgical_guide__["a" /* default */],__WEBPACK_IMPORTED_MODULE_121__sales_order_implant_treatment_ship_surgical_guide__["a" /* default */],__WEBPACK_IMPORTED_MODULE_122__sales_order_implant_treatment_fit_guide__["a" /* default */],__WEBPACK_IMPORTED_MODULE_123__sales_order_implant_treatment_marking_and_export__["a" /* default */],__WEBPACK_IMPORTED_MODULE_124__sales_order_implant_treatment_implant_surgery__["a" /* default */],// retainer refinement
__WEBPACK_IMPORTED_MODULE_125__sales_order_retainer_refinement_prepare_retainer_files__["a" /* default */],// escalation
__WEBPACK_IMPORTED_MODULE_126__sales_order_escalation_call_customer__["a" /* default */],//partial refund
__WEBPACK_IMPORTED_MODULE_128__sales_order_partial_refund_input_refund_data__["a" /* default */],__WEBPACK_IMPORTED_MODULE_129__sales_order_partial_refund_confirm_refund__["a" /* default */],//end of treatment
__WEBPACK_IMPORTED_MODULE_127__sales_order_end_of_treatment_end_of_treatment_call__["a" /* default */]];var getUIDefinitionByStateName=function getUIDefinitionByStateName(stateName){for(var index=0;index<taskDefinition.length;index++){var uiDefinition=taskDefinition[index];if(!uiDefinition.stateNameList){continue;}if(uiDefinition.stateNameList.indexOf(stateName)!==-1){return uiDefinition;}}return{};};var getUIDefinitionByTaskName=function getUIDefinitionByTaskName(taskName){for(var index=0;index<taskDefinition.length;index++){var uiDefinition=taskDefinition[index];if(uiDefinition.taskName===taskName){return uiDefinition;}}return __WEBPACK_IMPORTED_MODULE_88__sales_order_default_task_definition__["b" /* defaultUI */];};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMPLANT_CREATE_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMPLANT_REVIEW_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMPLANT_CREATE_TREATMENT_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return QM_REVIEW_TREATMENT_PLAN_INTERNAL; });
var IMPLANT_CREATE_TREATMENT_PLAN='implant_create_treatment_plan';var IMPLANT_REVIEW_TREATMENT_PLAN='implant_review_treatment_plan';var IMPLANT_CREATE_TREATMENT_QUOTATION='implant_create_treatment_quotation';var QM_REVIEW_TREATMENT_PLAN_INTERNAL='qm_review_treatment_plan_internal';

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(325);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(613);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(203);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='basis';

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_identity__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isNull__ = __webpack_require__(642);




function createAction(type, payloadCreator, metaCreator) {
  if (payloadCreator === void 0) {
    payloadCreator = __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */];
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(payloadCreator) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
  var finalPayloadCreator = Object(__WEBPACK_IMPORTED_MODULE_3__utils_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(void 0, [head].concat(args));
  };
  var hasMeta = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(void 0, arguments);
    var action = {
      type: type
    };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(void 0, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value;
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isMap__ = __webpack_require__(154);

function ownKeys(object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isMap__["a" /* default */])(object)) {
    // We are using loose transforms in babel. Here we are trying to convert an
    // interable to an array. Loose mode expects everything to already be an
    // array. The problem is that our eslint rules encourage us to prefer
    // spread over Array.from.
    //
    // Instead of disabling loose mode we simply disable the warning.
    // eslint-disable-next-line unicorn/prefer-spread
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
/* unused harmony export LAST_CHANGE_TYPE_TASK */
/* unused harmony export LAST_CHANGE_TYPE_STATE */
var REDUCER_NAME='state-responsible';var LAST_CHANGE_TYPE_TASK='task';var LAST_CHANGE_TYPE_STATE='state';

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='list';

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='detail';

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDUCER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPOINTMENT_TYPE; });
var REDUCER_NAME='search';var APPOINTMENT_TYPE=[{id:'scan',value:'scan'},{id:'ipr',value:'ipr'},{id:'3d-implant-scan',value:'3d-implant-scan'},{id:'implant-surgery',value:'implant-surgery'}];

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPOINTMENT_TABLE; });
var APPOINTMENT_TABLE='appointment';

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='tab-comments';

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='image';

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOMER_PARTNER_TABLE; });
var CUSTOMER_TABLE='customerTableEmployee';var CUSTOMER_PARTNER_TABLE='customerTablePartner';

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='transfer-drive-files';

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
/* unused harmony export MAX_SCAN_FILE_SIZE */
var REDUCER_NAME='cbct-file-upload';var MAX_SCAN_FILE_SIZE=90*1024*1024;

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='email';

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='employee';

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_LOGIN_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN_PASSWORD_RESET_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_PASSWORD_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(157);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]+'/';var CHANGE_LOGIN_DATA=NS+'CHANGE_LOGIN_DATA';var LOGIN_REQUEST=NS+'LOGIN_REQUEST';var LOGIN_ERROR=NS+'LOGIN_ERROR';var LOGIN_SUCCESS=NS+'LOGIN_SUCCESS';var LOGIN_PASSWORD_RESET_REQUIRED='LOGIN_PASSWORD_RESET_REQUIRED';var LOGOUT_SUCCESS=NS+'LOGOUT_SUCCESS';var CHANGE_PASSWORD_REQUEST=NS+'CHANGE_PASSWORD_REQUEST';var CHANGE_PASSWORD_SUCCESS=NS+'CHANGE_PASSWORD_SUCCESS';var CHANGE_PASSWORD_ERROR=NS+'CHANGE_PASSWORD_ERROR';

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sortByProperty; });
var sortByProperty=function sortByProperty(list,property){list.sort(function(aStore,bStore){if(aStore[property]<bStore[property]){return-1;}if(aStore[property]>bStore[property]){return 1;}return 0;});return list;};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='info-table';

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='csv-upload';

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='globals';

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_GLOBALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_VIEW_PREFERENCES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(224);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var INIT_GLOBALS=NS+'INIT_GLOBALS';var SAVE_VIEW_PREFERENCES=NS+'SAVE_VIEW_PREFERENCES';

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='correction';

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='display';

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='layout';

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PATH_LEAD_EDIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var PATH_LEAD_EDIT='';var REDUCER_NAME='lead';

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='logistic';

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='list';

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='associate-payment';

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='upload';

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='partner';

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PARTNER_TABLE; });
var PARTNER_TABLE='partnerTable';

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='detail';

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='voucher';

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='search';

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_VOUCHER_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_VOUCHER_TABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REQUEST_VOUCHER_TABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ERROR_VOUCHER_TABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VOUCHER_TABLE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(238);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_VOUCHER_CODE=NS+'CHANGE_VOUCHER_CODE';var CHANGE_VOUCHER_TABLE_DATA=NS+'CHANGE_VOUCHER_TABLE_DATA';var REQUEST_VOUCHER_TABLE_DATA=NS+'REQUEST_VOUCHER_TABLE_DATA';var ERROR_VOUCHER_TABLE_DATA=NS+'ERROR_VOUCHER_TABLE_DATA';var VOUCHER_TABLE='voucherTable';

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='barcode';

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='instance-detail';

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='task-detail';

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='task-list';

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='version-summary';

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='detail';

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='search';

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='refinement';

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='detail';

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TABLE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TABLE_CHECK_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TABLE_IN_SHOP_SCAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TABLE_IMPLANT_3DSCAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TABLE_IMPLANT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TABLE_IMPLANT_TREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TABLE_SHOP_SCAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TABLE_TREATMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TABLE_REFINEMENT_PRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TABLE_REFINEMENT_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TABLE_REFINEMENT_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TABLE_REFINEMENT_SHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TABLE_RETAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TABLE_RETAINER_REFINEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TABLE_ESCALATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TABLE_END_OF_TREATMENT; });
var TABLE_SET='set';var TABLE_CHECK_IN='checkIn';var TABLE_IN_SHOP_SCAN='inShopScan';var TABLE_IMPLANT_3DSCAN='implant3dScan';var TABLE_IMPLANT_PLAN='implantPlan';var TABLE_IMPLANT_TREATMENT='implantTreatment';var TABLE_SHOP_SCAN='shopScan';var TABLE_TREATMENT='treatment';var TABLE_REFINEMENT_PRODUCTION='refinementProduction';var TABLE_REFINEMENT_SET='refinementSet';var TABLE_REFINEMENT_BOOKING='refinementBooking';var TABLE_REFINEMENT_SHOP='refinementShop';var TABLE_RETAINER='retainer';var TABLE_RETAINER_REFINEMENT='retainerRefinement';var TABLE_ESCALATION='escalation';var TABLE_END_OF_TREATMENT='endOfTreatment';

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='manage';

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='store';

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORE_TABLE; });
var STORE_TABLE='storeTable';

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='detail';

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='match';

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PATH_LOW_NPS_REASON_ADD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var PATH_LOW_NPS_REASON_ADD='';var REDUCER_NAME='feedback';

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PATH_PARTIAL_REFUND_ADD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var PATH_PARTIAL_REFUND_ADD='';var REDUCER_NAME='partial-refund';

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='whatsapp-messages';

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='task-list-with-attachment';

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeLoginData; });
/* unused harmony export loginRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loginSuccess; });
/* unused harmony export loginError */
/* unused harmony export loginPasswordResetRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkLoginStatus; });
/* unused harmony export logoutSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return logout; });
/* unused harmony export changePasswordRequest */
/* unused harmony export changePasswordSuccess */
/* unused harmony export changePasswordError */
/* unused harmony export isPasswordStrong */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_state_action__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__(28);
var changeLoginData=function changeLoginData(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CHANGE_LOGIN_DATA */],payload:{name:name,value:value}};};var loginRequest=function loginRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["g" /* LOGIN_REQUEST */]};};var loginSuccess=function loginSuccess(user){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["h" /* LOGIN_SUCCESS */],payload:{user:user}};};var loginError=function loginError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["e" /* LOGIN_ERROR */],payload:{error:error}};};var loginPasswordResetRequired=function loginPasswordResetRequired(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* LOGIN_PASSWORD_RESET_REQUIRED */],payload:{error:error}};};var login=function login(){return function(dispatch,getState){var request=Object(__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectLoginData */])(getState());dispatch(loginRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/security/login',request).then(function(user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__globals_state_action__["b" /* loadGlobals */])());}).catch(function(error){if(error.exception==='PasswordResetRequiredException'){dispatch(loginPasswordResetRequired(error));}else{dispatch(loginError(error));}});};};var checkLoginStatus=function checkLoginStatus(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/security/check-employee-login-status').then(function(user){dispatch(loginSuccess(user));}).catch(function(error){});};};var logoutSuccess=function logoutSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["i" /* LOGOUT_SUCCESS */]};};var logout=function logout(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/security/logout').then(function(){dispatch(logoutSuccess());}).catch(function(error){});};};var changePasswordRequest=function changePasswordRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* CHANGE_PASSWORD_REQUEST */]};};var changePasswordSuccess=function changePasswordSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* CHANGE_PASSWORD_SUCCESS */]};};var changePasswordError=function changePasswordError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CHANGE_PASSWORD_ERROR */],payload:{error:error}};};var isPasswordStrong=function isPasswordStrong(password){if(!password){return false;}if(password.length<8){return false;}return /\d/.test(password)&&/[a-z]/.test(password)&&/[A-Z]/.test(password);};var changePassword=function changePassword(){return function(dispatch,getState){var state=getState();var _selectLoginData=Object(__WEBPACK_IMPORTED_MODULE_2__selector__["n" /* selectLoginData */])(state),email=_selectLoginData.email,password=_selectLoginData.password,newPassword=_selectLoginData.newPassword,newPasswordRepeat=_selectLoginData.newPasswordRepeat;if(!email||!password||!newPassword||!newPasswordRepeat){return;}if(newPassword!==newPasswordRepeat){return dispatch(changePasswordError(__WEBPACK_IMPORTED_MODULE_4__const__["b" /* ERROR_PASSWORD_NOT_IDENTICAL */]));}if(newPassword===password){return dispatch(changePasswordError(__WEBPACK_IMPORTED_MODULE_4__const__["a" /* ERROR_PASSWORD_MUST_BE_NEW */]));}if(!isPasswordStrong(newPassword)){return dispatch(changePasswordError(__WEBPACK_IMPORTED_MODULE_4__const__["c" /* ERROR_PASSWORD_NOT_SECURE */]));}dispatch(changePasswordRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/security/change-password-with-old-password',{email:email,password:password,newPassword:newPassword}).then(function(user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__globals_state_action__["b" /* loadGlobals */])());}).catch(function(error){dispatch(loginError(error));});};};

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isTransformer;
function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path__ = __webpack_require__(118);



/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */

var prop = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function prop(p, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__path__["a" /* default */])([p], obj);
});
/* harmony default export */ __webpack_exports__["a"] = (prop);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map__ = __webpack_require__(62);





/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
var ap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function ap(applyF, applyX) {
  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
    return applyF(x)(applyX(x));
  } :
  // else
  Object(__WEBPACK_IMPORTED_MODULE_2__internal_reduce__["a" /* default */])(function (acc, f) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */])(acc, Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* default */])(f, applyX));
  }, [], applyF);
});
/* harmony default export */ __webpack_exports__["a"] = (ap);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
/* harmony default export */ __webpack_exports__["a"] = (Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);



/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
var curry = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function curry(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(fn.length, fn);
});
/* harmony default export */ __webpack_exports__["a"] = (curry);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_makeFlat__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xchain__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__(62);






/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
var chain = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['fantasy-land/chain', 'chain'], __WEBPACK_IMPORTED_MODULE_3__internal_xchain__["a" /* default */], function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function (x) {
      return fn(monad(x))(x);
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__internal_makeFlat__["a" /* default */])(false)(Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* default */])(fn, monad));
}));
/* harmony default export */ __webpack_exports__["a"] = (chain);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */
var type = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipe__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reverse__ = __webpack_require__(175);



/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return __WEBPACK_IMPORTED_MODULE_0__pipe__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__reverse__["a" /* default */])(arguments));
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slice__ = __webpack_require__(72);




/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
var tail = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__["a" /* default */])('tail', /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__slice__["a" /* default */])(1, Infinity)));
/* harmony default export */ __webpack_exports__["a"] = (tail);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isArray__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isFunction__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isString__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toString__ = __webpack_require__(136);






/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */
var concat = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function concat(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArray__["a" /* default */])(a)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArray__["a" /* default */])(b)) {
      return a.concat(b);
    }
    throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_4__toString__["a" /* default */])(b) + ' is not an array');
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__internal_isString__["a" /* default */])(a)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_3__internal_isString__["a" /* default */])(b)) {
      return a + b;
    }
    throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_4__toString__["a" /* default */])(b) + ' is not a string');
  }
  if (a != null && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isFunction__["a" /* default */])(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }
  if (a != null && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isFunction__["a" /* default */])(a.concat)) {
    return a.concat(b);
  }
  throw new TypeError(Object(__WEBPACK_IMPORTED_MODULE_4__toString__["a" /* default */])(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
/* harmony default export */ __webpack_exports__["a"] = (concat);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_filter__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isObject__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_xfilter__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys__ = __webpack_require__(75);








/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var filter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['filter'], __WEBPACK_IMPORTED_MODULE_5__internal_xfilter__["a" /* default */], function (pred, filterable) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__internal_isObject__["a" /* default */])(filterable) ? Object(__WEBPACK_IMPORTED_MODULE_4__internal_reduce__["a" /* default */])(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, Object(__WEBPACK_IMPORTED_MODULE_6__keys__["a" /* default */])(filterable)) :
  // else
  Object(__WEBPACK_IMPORTED_MODULE_2__internal_filter__["a" /* default */])(pred, filterable);
}));
/* harmony default export */ __webpack_exports__["a"] = (filter);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _filter;
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isObject;
function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adjust__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__always__ = __webpack_require__(116);




/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */
var update = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function update(idx, x, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__adjust__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__always__["a" /* default */])(x), idx, list);
});
/* harmony default export */ __webpack_exports__["a"] = (update);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xtake__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice__ = __webpack_require__(72);





/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      var personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      var takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */
var take = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['take'], __WEBPACK_IMPORTED_MODULE_2__internal_xtake__["a" /* default */], function take(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice__["a" /* default */])(0, n < 0 ? Infinity : n, xs);
}));
/* harmony default export */ __webpack_exports__["a"] = (take);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_identity__ = __webpack_require__(276);



/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
var identity = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_identity__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (identity);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _identity;
function _identity(x) {
  return x;
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uniqBy__ = __webpack_require__(437);



/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
var uniq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__uniqBy__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (uniq);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectAssign__ = __webpack_require__(906);


/* harmony default export */ __webpack_exports__["a"] = (typeof Object.assign === 'function' ? Object.assign : __WEBPACK_IMPORTED_MODULE_0__objectAssign__["a" /* default */]);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);



/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */
var mergeWithKey = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;

  for (k in l) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(k, l)) {
      result[k] = Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(k, r) && !Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(k, result)) {
      result[k] = r[k];
    }
  }

  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (mergeWithKey);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatMoneyWithThousandSeparator; });
var formatMoneyWithThousandSeparator=function formatMoneyWithThousandSeparator(value){if(!value||!value.toFixed){value=0;}value/=100;value=value.toFixed(2)+' €';value=value.replace('.',',');var n=value.toString();while(true){var n2=n.replace(/(\d)(\d{3})($|,|\.)/g,'$1.$2$3');if(n===n2){break;}n=n2;}return n;};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectFunnelStartTime; });
/* unused harmony export selectFunnelStepList */
/* unused harmony export selectCohortList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectFirstFunnelStep; });
/* unused harmony export selectCurrentState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectEnrichedStateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectFilteredStateList; });
/* unused harmony export selectCohortByProcessNameAndState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectEnrichedStepList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(165);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_1__const__["c" /* REDUCER_NAME */]];};var selectFunnelStartTime=function selectFunnelStartTime(state){return selectOwnState(state).funnelStartTime;};var selectFunnelStepList=function selectFunnelStepList(state){return selectOwnState(state).funnelStepList;};var selectCohortList=function selectCohortList(state){return selectOwnState(state).cohortList;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectMode=function selectMode(state){return selectOwnState(state).mode;};var selectFirstFunnelStep=function selectFirstFunnelStep(state){var funnelStepList=selectFunnelStepList(state);return funnelStepList[0];};var selectCurrentState=function selectCurrentState(state){return selectOwnState(state).currentState;};var selectEnrichedStateList=function selectEnrichedStateList(state){var currentState=selectCurrentState(state);if(!currentState){return;}var total=0;__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(state){total+=state.count;},currentState);return currentState.map(function(state){return Object.assign({},state,{percentage:100*state.count/total});});};var selectFilteredStateList=function selectFilteredStateList(state){var currentState=selectEnrichedStateList(state);if(!currentState){return;}return currentState.filter(function(state){return state.percentage>3;});};var selectCohortByProcessNameAndState=function selectCohortByProcessNameAndState(state,processName,stateName){var cohortList=selectCohortList(state);for(var index=0;index<cohortList.length;index++){var cohort=cohortList[index];if(cohort.processName===processName&&cohort.stateName===stateName){return cohort;}}return null;};var selectEnrichedStepList=function selectEnrichedStepList(state){var enrichedList=[];var funnelStepList=selectFunnelStepList(state);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(funnelStep){var cohort=selectCohortByProcessNameAndState(state,funnelStep.processName,funnelStep.stateName);enrichedList.push(Object.assign({},funnelStep,{total:cohort?cohort.total:0,data:cohort?Object.assign({},cohort.data):{}}));},funnelStepList);return enrichedList;};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return selectTaskTableSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectStateTableSetting; });
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectUserSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectStateAnalytics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectTaskByDueDateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return selectTaskWeekDiffByIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectStateByLastChangedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectStatekDiffByIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCurrentStateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCurrentTaskName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProcessInstanceList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(165);
var selectTaskTableSetting=function selectTaskTableSetting(state){return selectOwnState(state).taskListTableSettings;};var selectStateTableSetting=function selectStateTableSetting(state){return selectOwnState(state).stateListTableSettings;};var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectUserSelection=function selectUserSelection(state){return selectOwnState(state).userSelection;};var selectStateAnalytics=function selectStateAnalytics(state){return selectOwnState(state).stateAnalytics;};var selectTaskByDueDateList=function selectTaskByDueDateList(state){return selectOwnState(state).taskByDueDateList;};var selectTaskWeekDiffByIndex=function selectTaskWeekDiffByIndex(state,index){var lastChangeList=selectTaskByDueDateList(state);var lastChange=lastChangeList[index];return lastChange.weekDiff;};var selectStateByLastChangedList=function selectStateByLastChangedList(state){return selectOwnState(state).stateByLastChangedList;};var selectStatekDiffByIndex=function selectStatekDiffByIndex(state,index){var lastChangeList=selectStateByLastChangedList(state);var lastChange=lastChangeList[index];return lastChange.weekDiff;};var selectCurrentStateName=function selectCurrentStateName(state){return selectOwnState(state).currentStateName;};var selectCurrentTaskName=function selectCurrentTaskName(state){return selectOwnState(state).currentTaskName;};var selectTaskList=function selectTaskList(state){return selectOwnState(state).taskList;};var selectProcessInstanceList=function selectProcessInstanceList(state){return selectOwnState(state).processInstanceList;};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectProcessState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectYearWeekList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectTransitionList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(165);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["c" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectProcessState=function selectProcessState(state){return selectOwnState(state).processState;};var selectMode=function selectMode(state){var processState=selectProcessState(state);return processState.mode;};var selectYearWeekList=function selectYearWeekList(state){return selectOwnState(state).yearWeekList;};var selectTransitionList=function selectTransitionList(state){return selectOwnState(state).transitionList;};

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectIsFetching; });
/* unused harmony export selectEmailTemplateList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectUserSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectUserSelectionProcess; });
/* unused harmony export selectUserSelectionLocale */
/* unused harmony export selectProcessMacroList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectProcessMacroListForCurrentProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectProcessList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectTemplateListForProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectEmailTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectEmailTemplateVariantList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectEmailTemplateVariantByLocalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectEmailTemplateVariantIdByLocalId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_util_names__ = __webpack_require__(25);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectEmailTemplateList=function selectEmailTemplateList(state){return selectOwnState(state).emailTemplateList;};var selectUserSelection=function selectUserSelection(state){return selectOwnState(state).userSelection;};var selectUserSelectionProcess=function selectUserSelectionProcess(state){var userSelection=selectUserSelection(state);return userSelection.processName;};var selectUserSelectionLocale=function selectUserSelectionLocale(state){var userSelection=selectUserSelection(state);return userSelection.locale;};var selectProcessMacroList=function selectProcessMacroList(state){return selectOwnState(state).processMacroList;};var selectProcessMacroListForCurrentProcess=function selectProcessMacroListForCurrentProcess(state){var processMacroList=selectProcessMacroList(state);var processName=selectUserSelectionProcess(state);if(!processMacroList||!processName){return null;}return processMacroList[processName];};var selectProcessList=function selectProcessList(state){var templateList=selectEmailTemplateList(state);if(!templateList){return[];}var processList={};templateList.map(function(_ref){var processName=_ref.processName;processList[processName]={id:processName,value:__WEBPACK_IMPORTED_MODULE_2__process_util_names__["a" /* PROCESS_NAMES */][processName]};return null;});return Object.values(processList);};var selectTemplateListForProcess=function selectTemplateListForProcess(state){var selectedProcessName=selectUserSelectionProcess(state);if(!selectedProcessName){return[];}var templateList=selectEmailTemplateList(state);templateList=templateList.filter(function(_ref2){var processName=_ref2.processName;return processName===selectedProcessName;});templateList.sort(function(a,b){if(a.technicalName<b.technicalName){return-1;}if(a.technicalName>b.technicalName){return 1;}return 0;});return templateList;};var selectEmailTemplate=function selectEmailTemplate(state){return selectOwnState(state).emailTemplate;};var selectEmailTemplateVariantList=function selectEmailTemplateVariantList(state){var emailTemplate=selectEmailTemplate(state);if(!emailTemplate){return[];}var locale=selectUserSelectionLocale(state);return emailTemplate.templateVariantList.filter(function(emailTemplateVariant){return emailTemplateVariant.locale===locale;});};var selectEmailTemplateVariantByLocalId=function selectEmailTemplateVariantByLocalId(state,localId){var emailTemplate=selectEmailTemplate(state);if(!emailTemplate){return null;}var variantList=emailTemplate.templateVariantList;for(var index=0;index<variantList.length;index++){var variant=variantList[index];if(variant.localId===localId){return variant;}}return null;};var selectEmailTemplateVariantIdByLocalId=function selectEmailTemplateVariantIdByLocalId(state,localId){var emailTemplateVariant=selectEmailTemplateVariantByLocalId(state,localId);return emailTemplateVariant?emailTemplateVariant.id:null;};

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectBarCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsFetching; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectBarCode=function selectBarCode(state){return selectOwnState(state).barcode;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(101);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["f" /* REDUCER_NAME */]];};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectReassignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIsReassignmentTreatingPhysician; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectIsReassignmentPartnerPhysician; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCurrentTreatingPhysicianId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectNewTreatingPhysicianId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectPartnerPhysicianId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectConfirmationLegalRequirementsMet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCanProceed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(287);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectReassignment=function selectReassignment(state){return selectOwnState(state).reassignment;};var selectIsReassignmentTreatingPhysician=function selectIsReassignmentTreatingPhysician(state){return selectReassignment(state).reassignTo===__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REASSIGNMENT_TREATING_PHYSICIAN */];};var selectIsReassignmentPartnerPhysician=function selectIsReassignmentPartnerPhysician(state){return selectReassignment(state).reassignTo===__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REASSIGNMENT_PARTNER_PHYSICIAN */];};var selectCurrentTreatingPhysicianId=function selectCurrentTreatingPhysicianId(state){return selectReassignment(state).currentTreatingPhysicianId;};var selectNewTreatingPhysicianId=function selectNewTreatingPhysicianId(state){return selectReassignment(state).newTreatingPhysicianId;};var selectPartnerPhysicianId=function selectPartnerPhysicianId(state){return selectReassignment(state).partnerPhysicianId;};var selectConfirmationLegalRequirementsMet=function selectConfirmationLegalRequirementsMet(state){return selectReassignment(state).confirmationLegalRequirementsMet;};var selectCanProceed=function selectCanProceed(state){var confirmation=selectConfirmationLegalRequirementsMet(state);if(!confirmation){return false;}var isReassignmentTreatingPhysician=selectIsReassignmentTreatingPhysician(state);var isReassignmentPartnerPhysician=selectIsReassignmentPartnerPhysician(state);var currentTreatingPhysicianId=selectCurrentTreatingPhysicianId(state);var newTreatingPhysicianId=selectNewTreatingPhysicianId(state);var partnerPhysicianId=selectPartnerPhysicianId(state);return Boolean(isReassignmentTreatingPhysician&&currentTreatingPhysicianId&&newTreatingPhysicianId&&currentTreatingPhysicianId!==newTreatingPhysicianId||isReassignmentPartnerPhysician&&currentTreatingPhysicianId&&partnerPhysicianId);};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectVoucherCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableSelectorVoucher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(239);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectVoucherCode=function selectVoucherCode(state){return selectOwnState(state).voucherCode;};var tableSelectorVoucher=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["e" /* VOUCHER_TABLE */]);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetchingAppointment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detail_selector__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_selector__ = __webpack_require__(292);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]];};var selectIsFetchingAppointment=function selectIsFetchingAppointment(state){return Object(__WEBPACK_IMPORTED_MODULE_1__detail_selector__["b" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__search_selector__["a" /* selectIsFetching */])(state);};

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectAppointment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(290);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["b" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectAppointment=function selectAppointment(state){return selectOwnState(state).appointment;};

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(212);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["b" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]];};var selectTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["a" /* APPOINTMENT_TABLE */]);var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1046),
    isObjectLike = __webpack_require__(142);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104),
    root = __webpack_require__(79);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1063),
    mapCacheDelete = __webpack_require__(1070),
    mapCacheGet = __webpack_require__(1072),
    mapCacheHas = __webpack_require__(1073),
    mapCacheSet = __webpack_require__(1074);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1091),
    baseKeys = __webpack_require__(1098),
    isArrayLike = __webpack_require__(473);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(85),
    isSymbol = __webpack_require__(189);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 300 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enrichStateHistory */
/* unused harmony export enrichTaskList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enrichComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enrichCommentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return enrichProcessInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
var enrichStateHistory=function enrichStateHistory(state,processInstance){__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* forEach */](function(stateHistory){if(stateHistory.changedByUserId!==null){stateHistory.changedByUserName=__WEBPACK_IMPORTED_MODULE_0__globals_index__["a" /* default */].selector.selectUserDisplayNameById(state,stateHistory.changedByUserId);}else{stateHistory.changedByUserName='System';}},processInstance.processStateHistoryList);};var enrichTaskList=function enrichTaskList(state,processInstance){__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* forEach */](function(processTask){if(processTask.finishedByUserId!==null){processTask.finishedByUserName=__WEBPACK_IMPORTED_MODULE_0__globals_index__["a" /* default */].selector.selectUserDisplayNameById(state,processTask.finishedByUserId);}},processInstance.processTaskList);};var enrichComment=function enrichComment(state,comment){comment.author=__WEBPACK_IMPORTED_MODULE_0__globals_index__["a" /* default */].selector.selectUserDisplayNameById(state,comment.createdByUserId);comment.isUserAuthor=__WEBPACK_IMPORTED_MODULE_0__globals_index__["a" /* default */].selector.selectUserId(state)===comment.createdByUserId;};var enrichCommentList=function enrichCommentList(state,processInstance){__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* forEach */](function(comment){enrichComment(state,comment);},processInstance.processCommentList);};var enrichProcessInstance=function enrichProcessInstance(state,processInstance){enrichStateHistory(state,processInstance);enrichCommentList(state,processInstance);enrichTaskList(state,processInstance);};

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(1210);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lead_prop_type__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treatment_quotation_obj_type__ = __webpack_require__(307);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,freshDeskId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,firstName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,gender:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,companyCode:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,brand:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,dob:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,referenceNumber:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,streetAddress:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,streetAddressExtension:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,street:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,houseNumber:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,zip:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,city:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,staircase:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,door:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,solvencyCheckFailed:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,countryCode:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,treatmentExpectation:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,medicalCondition:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,physician:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,googleClientId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,upperTraySize:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,lowerTraySize:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,store:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,phone:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,emailVerified:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,imagesUploaded:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,wantsRatePay:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,vip:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,inEscalation:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,activeTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,activeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,retainerCheckoutActive:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,firstRetainerFree:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,purchaseEstimation:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,leadList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,processList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,feedbackList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,created:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,leadId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,prospectId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,stripeCustomerId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,physicianId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,partnerPhysicianId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,partnerSupplierId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,partnerTreatmentPlanerId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,latitude:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,longitude:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,doubleOptInId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,treatingPhysicianId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,changedByUserId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,createdByUserId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,socialSecurityNumber:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,dataTransferDS:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,drSmileTransfer:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,// Rich props
lead:__WEBPACK_IMPORTED_MODULE_1__lead_prop_type__["a" /* default */],prospect:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,stripeCustomer:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,physicianObject:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,partnerPhysician:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,partnerSupplier:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,partnerTreatmentPlaner:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,doubleOptIn:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,treatingPhysician:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,changedByUser:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,createdByUser:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,// Arrays
treatmentPlanList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,treatmentQuotationList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2__treatment_quotation_obj_type__["a" /* default */]),treatmentExecutionList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,shipmentList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,salesOrderList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,invoiceList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,paymentList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,appointmentList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,imageList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,scanFileList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,treatmentPlanFileList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,treatmentPlanExternalFileList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,productionFileList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array}));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_obj_type__ = __webpack_require__(306);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,funnelId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,visualizationId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,brutPrice:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,approved:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,purchased:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,ratePayAllowed:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,rateCount:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,rateMonthly:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,prePayment:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,finalPayment:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,physicianCost:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,iprNeeded:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,physicianZabPartner:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,interestRate:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,treatmentDuration:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,numberOfAligner:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,numberOfStepsUpperJaw:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,numberOfStepsLowerJaw:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,numberOfAlignerUpperJaw:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,numberOfAlignerLowerJaw:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,system:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,validUntil:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,treatmentLink:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,customerName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,commentKey:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,comment:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,created:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,referenceNumber:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,currency:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,customerId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,customer:__WEBPACK_IMPORTED_MODULE_1__customer_obj_type__["a" /* default */],videoList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array}));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_list_action__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_list_selector__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShipmentList__ = __webpack_require__(511);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_list_selector__["b" /* selectOwnState */](state));};var mapDispatchToProps={createShipment:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["a" /* createShipment */],toggleShipmentTracking:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["c" /* toggleShipmentTracking */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ShipmentList__["a" /* default */]));

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createShipmentRequest */
/* unused harmony export createShipmentSuccess */
/* unused harmony export createShipmentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProviderUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleShipmentTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(369);
var createShipmentRequest=function createShipmentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CREATE_SHIPMENT_REQUEST */],payload:{}};};var createShipmentSuccess=function createShipmentSuccess(shipment){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CREATE_SHIPMENT_SUCCESS */],payload:{shipment:shipment}};};var createShipmentError=function createShipmentError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CREATE_SHIPMENT_ERROR */],payload:{error:error}};};var createShipment=function createShipment(salesOrderId,addShipment){return function(dispatch,getState){if(!salesOrderId){return;}dispatch(createShipmentRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/shipment/create?salesOrderId='+salesOrderId).then(function(shipment){addShipment(shipment);dispatch(createShipmentSuccess(shipment));}).catch(function(error){dispatch(createShipmentError(error));});};};var getProviderUrl=function getProviderUrl(shipmentProvider){return function(dispatch,getState){return Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/shipment/provider-url?provider='+shipmentProvider).then(function(response){return response.url;}).catch(function(error){console.log(error);});};};var toggleShipmentTracking=function toggleShipmentTracking(shipmentId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TOGGLE_SHIPMENT_TRACKING */],payload:{shipmentId:shipmentId}};};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quotation_ImplantTreatmentQuotation__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_quotation_const__ = __webpack_require__(59);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentQuotation:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["n" /* selectTreatmentQuotation */](state),isPreviewModalOpen:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["j" /* selectIsPreviewModalOpen */](state),isValid:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["i" /* selectIsImplantTreatmentQuotationValid */](state),customer:__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */](state),productType:__WEBPACK_IMPORTED_MODULE_5__state_quotation_const__["i" /* PRODUCT_TYPE_IMPLANTS */]};};var mapDispatchToProps={findOrCreateTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["d" /* findOrCreateTreatmentQuotation */],changeTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["a" /* changeTreatmentQuotation */],saveImplantTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["g" /* saveImplantTreatmentQuotation */],openPreviewModal:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["e" /* openPreviewModal */],closePreviewModal:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["b" /* closePreviewModal */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__quotation_ImplantTreatmentQuotation__["a" /* default */]));

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PricesContext */
/* harmony export (immutable) */ __webpack_exports__["b"] = usePrices;
/* harmony export (immutable) */ __webpack_exports__["a"] = PricesProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_api__ = __webpack_require__(12);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var PricesContext=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);function usePrices(){return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(PricesContext);}function PricesProvider(_ref){var _this=this;var children=_ref.children,countryCode=_ref.countryCode;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),loading=_useState2[0],setLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),_useState6=_slicedToArray(_useState5,2),prices=_useState6[0],setPrices=_useState6[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var loadedPrices;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__util_api__["c" /* post */])("/api/price/getpricelist",{countryCode:countryCode});case 3:loadedPrices=_context.sent;setPrices(loadedPrices);_context.next=10;break;case 7:_context.prev=7;_context.t0=_context["catch"](0);setError(_context.t0.message);case 10:setLoading(false);case 11:case"end":return _context.stop();}}},_callee,_this,[[0,7]]);}))();},[countryCode]);var value={country:countryCode,treatmentPrices:prices.treatmentPackageBrutPrices};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PricesContext.Provider,{value:value},error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"alert alert-danger",role:"alert"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"fa fa-exclamation-circle"}),error),!loading&&children,loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,"Loading..."));}

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Radio=function Radio(_ref){var _onChange=_ref.onChange,name=_ref.name,object=_ref.object,value=_ref.value,label=_ref.label,children=_ref.children,_ref$readOnly=_ref.readOnly,readOnly=_ref$readOnly===undefined?false:_ref$readOnly;var isChecked=object[name]===value;var style={display:'inline-block'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'',name:name,disabled:readOnly,value:value,checked:isChecked,onChange:function onChange(event){_onChange(name,event.target.value);}}),children);};Radio.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,object:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var React = __importStar(__webpack_require__(0));
var react_1 = __webpack_require__(1241);
var helpers_1 = __webpack_require__(1250);
var beat = react_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  50% {transform: scale(0.75);opacity: 0.2}\n  100% {transform: scale(1);opacity: 1}\n"], ["\n  50% {transform: scale(0.75);opacity: 0.2}\n  100% {transform: scale(1);opacity: 1}\n"])));
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function (i) {
            var _a = _this.props, color = _a.color, size = _a.size, margin = _a.margin, speedMultiplier = _a.speedMultiplier;
            return react_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: inline-block;\n      background-color: ", ";\n      width: ", ";\n      height: ", ";\n      margin: ", ";\n      border-radius: 100%;\n      animation: ", " ", "s ", "\n        infinite linear;\n      animation-fill-mode: both;\n    "], ["\n      display: inline-block;\n      background-color: ", ";\n      width: ", ";\n      height: ", ";\n      margin: ", ";\n      border-radius: 100%;\n      animation: ", " ", "s ", "\n        infinite linear;\n      animation-fill-mode: both;\n    "])), color, helpers_1.cssValue(size), helpers_1.cssValue(size), helpers_1.cssValue(margin), beat, 0.7 / speedMultiplier, i % 2 ? "0s" : 0.35 / speedMultiplier + "s");
        };
        return _this;
    }
    Loader.prototype.render = function () {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? (react_1.jsx("span", { css: [css] },
            react_1.jsx("span", { css: this.style(1) }),
            react_1.jsx("span", { css: this.style(2) }),
            react_1.jsx("span", { css: this.style(3) }))) : null;
    };
    Loader.defaultProps = helpers_1.sizeMarginDefaults(15);
    return Loader;
}(React.PureComponent));
exports.default = Loader;
var templateObject_1, templateObject_2;


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (weakMemoize);


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSwipeable = __webpack_require__(1257);

var _lodash = __webpack_require__(1258);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1259);

var _lodash4 = _interopRequireDefault(_lodash3);

var _resizeObserverPolyfill = __webpack_require__(1260);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var screenChangeEvents = ['fullscreenchange', 'MSFullscreenChange', 'mozfullscreenchange', 'webkitfullscreenchange'];

var ImageGallery = function (_React$Component) {
  _inherits(ImageGallery, _React$Component);

  function ImageGallery(props) {
    _classCallCheck(this, ImageGallery);

    var _this = _possibleConstructorReturn(this, (ImageGallery.__proto__ || Object.getPrototypeOf(ImageGallery)).call(this, props));

    _this.slideToIndex = function (index, event) {
      var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          isTransitioning = _this$state.isTransitioning;


      if (!isTransitioning) {
        if (event) {
          if (_this._intervalId) {
            // user triggered event while ImageGallery is playing, reset interval
            _this.pause(false);
            _this.play(false);
          }
        }

        var slideCount = _this.props.items.length - 1;
        var nextIndex = index;

        if (index < 0) {
          nextIndex = slideCount;
        } else if (index > slideCount) {
          nextIndex = 0;
        }

        _this.setState({
          previousIndex: currentIndex,
          currentIndex: nextIndex,
          isTransitioning: nextIndex !== currentIndex,
          offsetPercentage: 0,
          style: {
            transition: 'all ' + _this.props.slideDuration + 'ms ease-out'
          }
        }, _this._onSliding);
      }
    };

    _this._onSliding = function () {
      var isTransitioning = _this.state.isTransitioning;

      _this._transitionTimer = window.setTimeout(function () {
        if (isTransitioning) {
          _this.setState({ isTransitioning: !isTransitioning });
          if (_this.props.onSlide) {
            _this.props.onSlide(_this.state.currentIndex);
          }
        }
      }, _this.props.slideDuration + 50);
    };

    _this._handleScreenChange = function () {
      /*
        handles screen change events that the browser triggers e.g. esc key
      */
      var fullScreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

      if (_this.props.onScreenChange) {
        _this.props.onScreenChange(fullScreenElement);
      }

      _this.setState({ isFullscreen: !!fullScreenElement });
    };

    _this._toggleFullScreen = function () {
      if (_this.state.isFullscreen) {
        _this.exitFullScreen();
      } else {
        _this.fullScreen();
      }
    };

    _this._togglePlay = function () {
      if (_this._intervalId) {
        _this.pause();
      } else {
        _this.play();
      }
    };

    _this._initGalleryResizing = function (element) {
      /*
        When image-gallery-slide-wrapper unmounts and mounts when thumbnail bar position is changed
        ref is called twice, once with null and another with the element.
        Make sure element is available before calling observe.
      */
      if (element) {
        _this._imageGallerySlideWrapper = element;
        _this.resizeObserver = new _resizeObserverPolyfill2.default(_this._createResizeObserver);
        _this.resizeObserver.observe(element);
      }
    };

    _this._createResizeObserver = (0, _lodash4.default)(function (entries) {
      if (!entries) return;
      entries.forEach(function () {
        _this._handleResize();
      });
    }, 300);

    _this._handleResize = function () {
      var currentIndex = _this.state.currentIndex;

      if (_this._imageGallery) {
        _this.setState({
          galleryWidth: _this._imageGallery.offsetWidth
        });
      }

      if (_this._imageGallerySlideWrapper) {
        _this.setState({
          gallerySlideWrapperHeight: _this._imageGallerySlideWrapper.offsetHeight
        });
      }

      if (_this._thumbnailsWrapper) {
        if (_this._isThumbnailVertical()) {
          _this.setState({ thumbnailsWrapperHeight: _this._thumbnailsWrapper.offsetHeight });
        } else {
          _this.setState({ thumbnailsWrapperWidth: _this._thumbnailsWrapper.offsetWidth });
        }
      }

      // Adjust thumbnail container when thumbnail width or height is adjusted
      _this._setThumbsTranslate(-_this._getThumbsTranslate(currentIndex));
    };

    _this._handleKeyDown = function (event) {
      if (_this.props.disableArrowKeys) {
        return;
      }
      var LEFT_ARROW = 37;
      var RIGHT_ARROW = 39;
      var ESC_KEY = 27;
      var key = parseInt(event.keyCode || event.which || 0);

      switch (key) {
        case LEFT_ARROW:
          if (_this._canSlideLeft() && !_this._intervalId) {
            _this._slideLeft();
          }
          break;
        case RIGHT_ARROW:
          if (_this._canSlideRight() && !_this._intervalId) {
            _this._slideRight();
          }
          break;
        case ESC_KEY:
          if (_this.state.isFullscreen && !_this.props.useBrowserFullscreen) {
            _this.exitFullScreen();
          }
      }
    };

    _this._handleImageError = function (event) {
      if (_this.props.defaultImage && event.target.src.indexOf(_this.props.defaultImage) === -1) {
        event.target.src = _this.props.defaultImage;
      }
    };

    _this._handleOnSwiped = function (_ref) {
      var event = _ref.event,
          dir = _ref.dir,
          velocity = _ref.velocity;

      if (_this.props.disableSwipe) return;
      var _this$state2 = _this.state,
          scrollingUpDown = _this$state2.scrollingUpDown,
          scrollingLeftRight = _this$state2.scrollingLeftRight;
      var isRTL = _this.props.isRTL;

      if (_this.props.stopPropagation) event.stopPropagation();
      if (scrollingUpDown) {
        // user stopped scrollingUpDown
        _this.setState({ scrollingUpDown: false });
      }

      if (scrollingLeftRight) {
        // user stopped scrollingLeftRight
        _this.setState({ scrollingLeftRight: false });
      }

      if (!scrollingUpDown) {
        // don't swipe if user is scrolling
        var side = (dir === _reactSwipeable.LEFT ? 1 : -1) * (isRTL ? -1 : 1); // if it is RTL the direction is reversed
        var isFlick = velocity > _this.props.flickThreshold;
        _this._handleOnSwipedTo(side, isFlick);
      }
    };

    _this._handleSwiping = function (_ref2) {
      var event = _ref2.event,
          absX = _ref2.absX,
          dir = _ref2.dir;

      if (_this.props.disableSwipe) return;
      var _this$state3 = _this.state,
          galleryWidth = _this$state3.galleryWidth,
          isTransitioning = _this$state3.isTransitioning,
          scrollingUpDown = _this$state3.scrollingUpDown,
          scrollingLeftRight = _this$state3.scrollingLeftRight;
      var swipingTransitionDuration = _this.props.swipingTransitionDuration;

      _this._setScrollDirection(dir);
      if (_this.props.stopPropagation) event.stopPropagation();
      if ((_this.props.preventDefaultTouchmoveEvent || scrollingLeftRight) && event.cancelable) event.preventDefault();
      if (!isTransitioning && !scrollingUpDown) {
        var side = dir === _reactSwipeable.RIGHT ? 1 : -1;

        var offsetPercentage = absX / galleryWidth * 100;
        if (Math.abs(offsetPercentage) >= 100) {
          offsetPercentage = 100;
        }

        var swipingTransition = {
          transition: 'transform ' + swipingTransitionDuration + 'ms ease-out'
        };

        _this.setState({
          offsetPercentage: side * offsetPercentage,
          style: swipingTransition
        });
      } else {
        // don't move the slide
        _this.setState({ offsetPercentage: 0 });
      }
    };

    _this._slideLeft = function () {
      _this.props.isRTL ? _this._slideNext() : _this._slidePrevious();
    };

    _this._slideRight = function () {
      _this.props.isRTL ? _this._slidePrevious() : _this._slideNext();
    };

    _this._slidePrevious = function (event) {
      _this.slideToIndex(_this.state.currentIndex - 1, event);
    };

    _this._slideNext = function (event) {
      _this.slideToIndex(_this.state.currentIndex + 1, event);
    };

    _this._renderItem = function (item) {
      var onImageError = _this.props.onImageError || _this._handleImageError;

      return _react2.default.createElement(
        'div',
        { className: 'image-gallery-image' },
        item.imageSet ? _react2.default.createElement(
          'picture',
          {
            onLoad: _this.props.onImageLoad,
            onError: onImageError
          },
          item.imageSet.map(function (source, index) {
            return _react2.default.createElement('source', {
              key: index,
              media: source.media,
              srcSet: source.srcSet,
              type: source.type
            });
          }),
          _react2.default.createElement('img', {
            alt: item.originalAlt,
            src: item.original
          })
        ) : _react2.default.createElement('img', {
          src: item.original,
          alt: item.originalAlt,
          srcSet: item.srcSet,
          sizes: item.sizes,
          title: item.originalTitle,
          onLoad: _this.props.onImageLoad,
          onError: onImageError
        }),
        item.description && _react2.default.createElement(
          'span',
          { className: 'image-gallery-description' },
          item.description
        )
      );
    };

    _this._renderThumbInner = function (item) {
      var onThumbnailError = _this.props.onThumbnailError || _this._handleImageError;

      return _react2.default.createElement(
        'div',
        { className: 'image-gallery-thumbnail-inner' },
        _react2.default.createElement('img', {
          src: item.thumbnail,
          alt: item.thumbnailAlt,
          title: item.thumbnailTitle,
          onError: onThumbnailError
        }),
        item.thumbnailLabel && _react2.default.createElement(
          'div',
          { className: 'image-gallery-thumbnail-label' },
          item.thumbnailLabel
        )
      );
    };

    _this._onThumbnailClick = function (event, index) {
      _this.slideToIndex(index, event);
      if (_this.props.onThumbnailClick) {
        _this.props.onThumbnailClick(event, index);
      }
    };

    _this._onThumbnailMouseOver = function (event, index) {
      if (_this._thumbnailMouseOverTimer) {
        window.clearTimeout(_this._thumbnailMouseOverTimer);
        _this._thumbnailMouseOverTimer = null;
      }
      _this._thumbnailMouseOverTimer = window.setTimeout(function () {
        _this.slideToIndex(index);
        _this.pause();
      }, 300);
    };

    _this._onThumbnailMouseLeave = function () {
      if (_this._thumbnailMouseOverTimer) {
        window.clearTimeout(_this._thumbnailMouseOverTimer);
        _this._thumbnailMouseOverTimer = null;
        if (_this.props.autoPlay) {
          _this.play();
        }
      }
    };

    _this.state = {
      currentIndex: props.startIndex,
      thumbsTranslate: 0,
      offsetPercentage: 0,
      galleryWidth: 0,
      thumbnailsWrapperWidth: 0,
      thumbnailsWrapperHeight: 0,
      isFullscreen: false,
      isPlaying: false
    };

    // Used to update the throttle if slideDuration changes
    _this._unthrottledSlideToIndex = _this.slideToIndex;
    _this.slideToIndex = (0, _lodash2.default)(_this._unthrottledSlideToIndex, props.slideDuration, { trailing: false });

    if (props.lazyLoad) {
      _this._lazyLoaded = [];
    }
    return _this;
  }

  _createClass(ImageGallery, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var itemsSizeChanged = prevProps.items.length !== this.props.items.length;
      var itemsChanged = prevProps.items !== this.props.items;
      var startIndexUpdated = prevProps.startIndex !== this.props.startIndex;
      if (itemsSizeChanged) {
        this._handleResize();
      }
      if (prevState.currentIndex !== this.state.currentIndex) {
        this._slideThumbnailBar(prevState.currentIndex);
      }
      // if slideDuration changes, update slideToIndex throttle
      if (prevProps.slideDuration !== this.props.slideDuration) {
        this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, { trailing: false });
      }
      if (this.props.lazyLoad && (!prevProps.lazyLoad || itemsChanged)) {
        this._lazyLoaded = [];
      }

      if (startIndexUpdated || itemsChanged) {
        this.setState({ currentIndex: this.props.startIndex });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoPlay) {
        this.play();
      }
      window.addEventListener('keydown', this._handleKeyDown);
      this._onScreenChangeEvent();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this._handleKeyDown);

      this._offScreenChangeEvent();

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
      }

      if (this.resizeObserver && this._imageGallerySlideWrapper) {
        this.resizeObserver.unobserve(this._imageGallerySlideWrapper);
      }

      if (this._transitionTimer) {
        window.clearTimeout(this._transitionTimer);
      }

      if (this._createResizeObserver) {
        this._createResizeObserver();
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this2 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this._intervalId) {
        var _props = this.props,
            slideInterval = _props.slideInterval,
            slideDuration = _props.slideDuration;

        this.setState({ isPlaying: true });
        this._intervalId = window.setInterval(function () {
          if (!_this2.props.infinite && !_this2._canSlideRight()) {
            _this2.pause();
          } else {
            _this2.slideToIndex(_this2.state.currentIndex + 1);
          }
        }, Math.max(slideInterval, slideDuration));

        if (this.props.onPlay && callback) {
          this.props.onPlay(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
        this.setState({ isPlaying: false });

        if (this.props.onPause && callback) {
          this.props.onPause(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'setModalFullscreen',
    value: function setModalFullscreen(state) {
      this.setState({ modalFullscreen: state });
      // manually call because browser does not support screenchange events
      if (this.props.onScreenChange) {
        this.props.onScreenChange(state);
      }
    }
  }, {
    key: 'fullScreen',
    value: function fullScreen() {
      var gallery = this._imageGallery;

      if (this.props.useBrowserFullscreen) {
        if (gallery.requestFullscreen) {
          gallery.requestFullscreen();
        } else if (gallery.msRequestFullscreen) {
          gallery.msRequestFullscreen();
        } else if (gallery.mozRequestFullScreen) {
          gallery.mozRequestFullScreen();
        } else if (gallery.webkitRequestFullscreen) {
          gallery.webkitRequestFullscreen();
        } else {
          // fallback to fullscreen modal for unsupported browsers
          this.setModalFullscreen(true);
        }
      } else {
        this.setModalFullscreen(true);
      }

      this.setState({ isFullscreen: true });
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      if (this.state.isFullscreen) {
        if (this.props.useBrowserFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else {
            // fallback to fullscreen modal for unsupported browsers
            this.setModalFullscreen(false);
          }
        } else {
          this.setModalFullscreen(false);
        }

        this.setState({ isFullscreen: false });
      }
    }
  }, {
    key: 'getCurrentIndex',
    value: function getCurrentIndex() {
      return this.state.currentIndex;
    }
  }, {
    key: '_onScreenChangeEvent',
    value: function _onScreenChangeEvent() {
      var _this3 = this;

      screenChangeEvents.map(function (eventName) {
        document.addEventListener(eventName, _this3._handleScreenChange);
      });
    }
  }, {
    key: '_offScreenChangeEvent',
    value: function _offScreenChangeEvent() {
      var _this4 = this;

      screenChangeEvents.map(function (eventName) {
        document.removeEventListener(eventName, _this4._handleScreenChange);
      });
    }
  }, {
    key: '_isThumbnailVertical',
    value: function _isThumbnailVertical() {
      var thumbnailPosition = this.props.thumbnailPosition;

      return thumbnailPosition === 'left' || thumbnailPosition === 'right';
    }
  }, {
    key: '_setScrollDirection',
    value: function _setScrollDirection(dir) {
      var _state = this.state,
          scrollingUpDown = _state.scrollingUpDown,
          scrollingLeftRight = _state.scrollingLeftRight;


      if (!scrollingUpDown && !scrollingLeftRight) {
        if (dir === _reactSwipeable.LEFT || dir === _reactSwipeable.RIGHT) {
          this.setState({ scrollingLeftRight: true });
        } else {
          this.setState({ scrollingUpDown: true });
        }
      }
    }
  }, {
    key: '_handleOnSwipedTo',
    value: function _handleOnSwipedTo(side, isFlick) {
      var _state2 = this.state,
          currentIndex = _state2.currentIndex,
          isTransitioning = _state2.isTransitioning;

      var slideTo = currentIndex;

      if ((this._sufficientSwipeOffset() || isFlick) && !isTransitioning) {
        slideTo += side;
      }

      if (side < 0) {
        if (!this._canSlideLeft()) {
          slideTo = currentIndex;
        }
      } else {
        if (!this._canSlideRight()) {
          slideTo = currentIndex;
        }
      }

      this._unthrottledSlideToIndex(slideTo);
    }
  }, {
    key: '_sufficientSwipeOffset',
    value: function _sufficientSwipeOffset() {
      return Math.abs(this.state.offsetPercentage) > this.props.swipeThreshold;
    }
  }, {
    key: '_canNavigate',
    value: function _canNavigate() {
      return this.props.items.length >= 2;
    }
  }, {
    key: '_canSlideLeft',
    value: function _canSlideLeft() {
      return this.props.infinite || (this.props.isRTL ? this._canSlideNext() : this._canSlidePrevious());
    }
  }, {
    key: '_canSlideRight',
    value: function _canSlideRight() {
      return this.props.infinite || (this.props.isRTL ? this._canSlidePrevious() : this._canSlideNext());
    }
  }, {
    key: '_canSlidePrevious',
    value: function _canSlidePrevious() {
      return this.state.currentIndex > 0;
    }
  }, {
    key: '_canSlideNext',
    value: function _canSlideNext() {
      return this.state.currentIndex < this.props.items.length - 1;
    }
  }, {
    key: '_slideThumbnailBar',
    value: function _slideThumbnailBar(previousIndex) {
      var _state3 = this.state,
          thumbsTranslate = _state3.thumbsTranslate,
          currentIndex = _state3.currentIndex;

      if (this.state.currentIndex === 0) {
        this._setThumbsTranslate(0);
      } else {
        var indexDifference = Math.abs(previousIndex - currentIndex);
        var scroll = this._getThumbsTranslate(indexDifference);
        if (scroll > 0) {
          if (previousIndex < currentIndex) {
            this._setThumbsTranslate(thumbsTranslate - scroll);
          } else if (previousIndex > currentIndex) {
            this._setThumbsTranslate(thumbsTranslate + scroll);
          }
        }
      }
    }
  }, {
    key: '_setThumbsTranslate',
    value: function _setThumbsTranslate(thumbsTranslate) {
      this.setState({ thumbsTranslate: thumbsTranslate });
    }
  }, {
    key: '_getThumbsTranslate',
    value: function _getThumbsTranslate(indexDifference) {
      if (this.props.disableThumbnailScroll) {
        return 0;
      }

      var _state4 = this.state,
          thumbnailsWrapperWidth = _state4.thumbnailsWrapperWidth,
          thumbnailsWrapperHeight = _state4.thumbnailsWrapperHeight;

      var totalScroll = void 0;

      if (this._thumbnails) {
        // total scroll required to see the last thumbnail
        if (this._isThumbnailVertical()) {
          if (this._thumbnails.scrollHeight <= thumbnailsWrapperHeight) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollHeight - thumbnailsWrapperHeight;
        } else {
          if (this._thumbnails.scrollWidth <= thumbnailsWrapperWidth || thumbnailsWrapperWidth <= 0) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollWidth - thumbnailsWrapperWidth;
        }

        var totalThumbnails = this._thumbnails.children.length;
        // scroll-x required per index change
        var perIndexScroll = totalScroll / (totalThumbnails - 1);

        return indexDifference * perIndexScroll;
      }
    }
  }, {
    key: '_getAlignmentClassName',
    value: function _getAlignmentClassName(index) {
      /*
        Necessary for lazing loading
      */
      var currentIndex = this.state.currentIndex;

      var alignment = '';
      var leftClassName = 'left';
      var centerClassName = 'center';
      var rightClassName = 'right';

      switch (index) {
        case currentIndex - 1:
          alignment = ' ' + leftClassName;
          break;
        case currentIndex:
          alignment = ' ' + centerClassName;
          break;
        case currentIndex + 1:
          alignment = ' ' + rightClassName;
          break;
      }

      if (this.props.items.length >= 3 && this.props.infinite) {
        if (index === 0 && currentIndex === this.props.items.length - 1) {
          // set first slide as right slide if were sliding right from last slide
          alignment = ' ' + rightClassName;
        } else if (index === this.props.items.length - 1 && currentIndex === 0) {
          // set last slide as left slide if were sliding left from first slide
          alignment = ' ' + leftClassName;
        }
      }

      return alignment;
    }
  }, {
    key: '_isGoingFromFirstToLast',
    value: function _isGoingFromFirstToLast() {
      var _state5 = this.state,
          currentIndex = _state5.currentIndex,
          previousIndex = _state5.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === 0 && currentIndex === totalSlides;
    }
  }, {
    key: '_isGoingFromLastToFirst',
    value: function _isGoingFromLastToFirst() {
      var _state6 = this.state,
          currentIndex = _state6.currentIndex,
          previousIndex = _state6.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === totalSlides && currentIndex === 0;
    }
  }, {
    key: '_getTranslateXForTwoSlide',
    value: function _getTranslateXForTwoSlide(index) {
      // For taking care of infinite swipe when there are only two slides
      var _state7 = this.state,
          currentIndex = _state7.currentIndex,
          offsetPercentage = _state7.offsetPercentage,
          previousIndex = _state7.previousIndex;

      var baseTranslateX = -100 * currentIndex;
      var translateX = baseTranslateX + index * 100 + offsetPercentage;

      // keep track of user swiping direction
      if (offsetPercentage > 0) {
        this.direction = 'left';
      } else if (offsetPercentage < 0) {
        this.direction = 'right';
      }

      // when swiping make sure the slides are on the correct side
      if (currentIndex === 0 && index === 1 && offsetPercentage > 0) {
        translateX = -100 + offsetPercentage;
      } else if (currentIndex === 1 && index === 0 && offsetPercentage < 0) {
        translateX = 100 + offsetPercentage;
      }

      if (currentIndex !== previousIndex) {
        // when swiped move the slide to the correct side
        if (previousIndex === 0 && index === 0 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = 100;
        } else if (previousIndex === 1 && index === 1 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = -100;
        }
      } else {
        // keep the slide on the correct slide even when not a swipe
        if (currentIndex === 0 && index === 1 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = -100;
        } else if (currentIndex === 1 && index === 0 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = 100;
        }
      }

      return translateX;
    }
  }, {
    key: '_getThumbnailBarHeight',
    value: function _getThumbnailBarHeight() {
      if (this._isThumbnailVertical()) {
        return {
          height: this.state.gallerySlideWrapperHeight
        };
      }
      return {};
    }
  }, {
    key: '_shouldPushSlideOnInfiniteMode',
    value: function _shouldPushSlideOnInfiniteMode(index) {
      /*
        Push(show) slide if slide is the current slide, and the next slide
        OR
        The slide is going more than 1 slide left, or right, but not going from
        first to last and not going from last to first
         There is an edge case where if you go to the first or last slide, when they're
        not left, or right of each other they will try to catch up in the background
        so unless were going from first to last or vice versa we don't want the first
        or last slide to show up during our transition
      */
      return !this._slideIsTransitioning(index) || this._ignoreIsTransitioning() && !this._isFirstOrLastSlide(index);
    }
  }, {
    key: '_slideIsTransitioning',
    value: function _slideIsTransitioning(index) {
      /*
      returns true if the gallery is transitioning and the index is not the
      previous or currentIndex
      */
      var _state8 = this.state,
          isTransitioning = _state8.isTransitioning,
          previousIndex = _state8.previousIndex,
          currentIndex = _state8.currentIndex;

      var indexIsNotPreviousOrNextSlide = !(index === previousIndex || index === currentIndex);
      return isTransitioning && indexIsNotPreviousOrNextSlide;
    }
  }, {
    key: '_isFirstOrLastSlide',
    value: function _isFirstOrLastSlide(index) {
      var totalSlides = this.props.items.length - 1;
      var isLastSlide = index === totalSlides;
      var isFirstSlide = index === 0;
      return isLastSlide || isFirstSlide;
    }
  }, {
    key: '_ignoreIsTransitioning',
    value: function _ignoreIsTransitioning() {
      /*
        Ignore isTransitioning because were not going to sibling slides
        e.g. center to left or center to right
      */
      var _state9 = this.state,
          previousIndex = _state9.previousIndex,
          currentIndex = _state9.currentIndex;

      var totalSlides = this.props.items.length - 1;
      // we want to show the in between slides transition
      var slidingMoreThanOneSlideLeftOrRight = Math.abs(previousIndex - currentIndex) > 1;
      var notGoingFromFirstToLast = !(previousIndex === 0 && currentIndex === totalSlides);
      var notGoingFromLastToFirst = !(previousIndex === totalSlides && currentIndex === 0);

      return slidingMoreThanOneSlideLeftOrRight && notGoingFromFirstToLast && notGoingFromLastToFirst;
    }
  }, {
    key: '_getSlideStyle',
    value: function _getSlideStyle(index) {
      var _state10 = this.state,
          currentIndex = _state10.currentIndex,
          offsetPercentage = _state10.offsetPercentage;
      var _props2 = this.props,
          infinite = _props2.infinite,
          items = _props2.items,
          useTranslate3D = _props2.useTranslate3D,
          isRTL = _props2.isRTL;

      var baseTranslateX = -100 * currentIndex;
      var totalSlides = items.length - 1;

      // calculates where the other slides belong based on currentIndex
      // if it is RTL the base line should be reversed
      var translateX = (baseTranslateX + index * 100) * (isRTL ? -1 : 1) + offsetPercentage;

      if (infinite && items.length > 2) {
        if (currentIndex === 0 && index === totalSlides) {
          // make the last slide the slide before the first
          // if it is RTL the base line should be reversed
          translateX = -100 * (isRTL ? -1 : 1) + offsetPercentage;
        } else if (currentIndex === totalSlides && index === 0) {
          // make the first slide the slide after the last
          // if it is RTL the base line should be reversed
          translateX = 100 * (isRTL ? -1 : 1) + offsetPercentage;
        }
      }

      // Special case when there are only 2 items with infinite on
      if (infinite && items.length === 2) {
        translateX = this._getTranslateXForTwoSlide(index);
      }

      var translate = 'translate(' + translateX + '%, 0)';

      if (useTranslate3D) {
        translate = 'translate3d(' + translateX + '%, 0, 0)';
      }

      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: '_getThumbnailStyle',
    value: function _getThumbnailStyle() {
      var translate = void 0;
      var _props3 = this.props,
          useTranslate3D = _props3.useTranslate3D,
          isRTL = _props3.isRTL;
      var thumbsTranslate = this.state.thumbsTranslate;

      var verticalTranslateValue = isRTL ? thumbsTranslate * -1 : thumbsTranslate;

      if (this._isThumbnailVertical()) {
        translate = 'translate(0, ' + thumbsTranslate + 'px)';
        if (useTranslate3D) {
          translate = 'translate3d(0, ' + thumbsTranslate + 'px, 0)';
        }
      } else {
        translate = 'translate(' + verticalTranslateValue + 'px, 0)';
        if (useTranslate3D) {
          translate = 'translate3d(' + verticalTranslateValue + 'px, 0, 0)';
        }
      }
      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state11 = this.state,
          currentIndex = _state11.currentIndex,
          isFullscreen = _state11.isFullscreen,
          modalFullscreen = _state11.modalFullscreen,
          isPlaying = _state11.isPlaying;
      var _props4 = this.props,
          infinite = _props4.infinite,
          slideOnThumbnailOver = _props4.slideOnThumbnailOver,
          isRTL = _props4.isRTL,
          lazyLoad = _props4.lazyLoad;


      var thumbnailStyle = this._getThumbnailStyle();
      var thumbnailPosition = this.props.thumbnailPosition;

      var slideLeft = this._slideLeft;
      var slideRight = this._slideRight;

      var slides = [];
      var thumbnails = [];
      var bullets = [];

      this.props.items.forEach(function (item, index) {
        var alignment = _this5._getAlignmentClassName(index);
        var originalClass = item.originalClass ? ' ' + item.originalClass : '';
        var thumbnailClass = item.thumbnailClass ? ' ' + item.thumbnailClass : '';

        var renderItem = item.renderItem || _this5.props.renderItem || _this5._renderItem;

        var renderThumbInner = item.renderThumbInner || _this5.props.renderThumbInner || _this5._renderThumbInner;

        var showItem = !lazyLoad || alignment || _this5._lazyLoaded[index];
        if (showItem && lazyLoad && !_this5._lazyLoaded[index]) {
          _this5._lazyLoaded[index] = true;
        }

        var slideStyle = _this5._getSlideStyle(index);

        var slide = _react2.default.createElement(
          'div',
          {
            key: index,
            className: 'image-gallery-slide' + alignment + originalClass,
            style: _extends(slideStyle, _this5.state.style),
            onClick: _this5.props.onClick,
            onTouchMove: _this5.props.onTouchMove,
            onTouchEnd: _this5.props.onTouchEnd,
            onTouchStart: _this5.props.onTouchStart,
            onMouseOver: _this5.props.onMouseOver,
            onMouseLeave: _this5.props.onMouseLeave,
            role: _this5.props.onClick && 'button'
          },
          showItem ? renderItem(item) : _react2.default.createElement('div', { style: { height: '100%' } })
        );

        if (infinite) {
          // don't add some slides while transitioning to avoid background transitions
          if (_this5._shouldPushSlideOnInfiniteMode(index)) {
            slides.push(slide);
          }
        } else {
          slides.push(slide);
        }

        if (_this5.props.showThumbnails) {
          thumbnails.push(_react2.default.createElement(
            'a',
            {
              key: index,
              role: 'button',
              'aria-pressed': currentIndex === index ? 'true' : 'false',
              'aria-label': 'Go to Slide ' + (index + 1),
              className: 'image-gallery-thumbnail' + (currentIndex === index ? ' active' : '') + thumbnailClass,
              onMouseLeave: slideOnThumbnailOver ? _this5._onThumbnailMouseLeave : undefined,
              onMouseOver: function onMouseOver(event) {
                return slideOnThumbnailOver ? _this5._onThumbnailMouseOver(event, index) : undefined;
              },
              onClick: function onClick(event) {
                return _this5._onThumbnailClick(event, index);
              }
            },
            renderThumbInner(item)
          ));
        }

        if (_this5.props.showBullets) {
          var bulletOnClick = function bulletOnClick(event) {
            if (item.bulletOnClick) {
              item.bulletOnClick({ item: item, itemIndex: index, currentIndex: currentIndex });
            }
            return _this5.slideToIndex.call(_this5, index, event);
          };
          bullets.push(_react2.default.createElement('button', {
            key: index,
            type: 'button',
            className: ['image-gallery-bullet', currentIndex === index ? 'active' : '', item.bulletClass || ''].join(' '),
            onClick: bulletOnClick,
            'aria-pressed': currentIndex === index ? 'true' : 'false',
            'aria-label': 'Go to Slide ' + (index + 1)
          }));
        }
      });

      var slideWrapper = _react2.default.createElement(
        'div',
        {
          ref: this._initGalleryResizing,
          className: 'image-gallery-slide-wrapper ' + thumbnailPosition + ' ' + (isRTL ? 'image-gallery-rtl' : '')
        },
        this.props.renderCustomControls && this.props.renderCustomControls(),
        this.props.showFullscreenButton && this.props.renderFullscreenButton(this._toggleFullScreen, isFullscreen),
        this.props.showPlayButton && this.props.renderPlayPauseButton(this._togglePlay, isPlaying),
        this._canNavigate() ? [this.props.showNav && _react2.default.createElement(
          'span',
          { key: 'navigation' },
          this.props.renderLeftNav(slideLeft, !this._canSlideLeft()),
          this.props.renderRightNav(slideRight, !this._canSlideRight())
        ), _react2.default.createElement(
          _reactSwipeable.Swipeable,
          {
            className: 'image-gallery-swipe',
            key: 'swipeable',
            delta: 0,
            onSwiping: this._handleSwiping,
            onSwiped: this._handleOnSwiped
          },
          _react2.default.createElement(
            'div',
            { className: 'image-gallery-slides' },
            slides
          )
        )] : _react2.default.createElement(
          'div',
          { className: 'image-gallery-slides' },
          slides
        ),
        this.props.showBullets && _react2.default.createElement(
          'div',
          { className: 'image-gallery-bullets' },
          _react2.default.createElement(
            'div',
            {
              className: 'image-gallery-bullets-container',
              role: 'navigation',
              'aria-label': 'Bullet Navigation'
            },
            bullets
          )
        ),
        this.props.showIndex && _react2.default.createElement(
          'div',
          { className: 'image-gallery-index' },
          _react2.default.createElement(
            'span',
            { className: 'image-gallery-index-current' },
            this.state.currentIndex + 1
          ),
          _react2.default.createElement(
            'span',
            { className: 'image-gallery-index-separator' },
            this.props.indexSeparator
          ),
          _react2.default.createElement(
            'span',
            { className: 'image-gallery-index-total' },
            this.props.items.length
          )
        )
      );

      var classNames = ['image-gallery', this.props.additionalClass, modalFullscreen ? 'fullscreen-modal' : ''].filter(function (name) {
        return typeof name === 'string';
      }).join(' ');

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(i) {
            return _this5._imageGallery = i;
          },
          className: classNames,
          'aria-live': 'polite'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'image-gallery-content' + (isFullscreen ? ' fullscreen' : '')
          },
          (thumbnailPosition === 'bottom' || thumbnailPosition === 'right') && slideWrapper,
          this.props.showThumbnails && _react2.default.createElement(
            'div',
            {
              className: 'image-gallery-thumbnails-wrapper ' + thumbnailPosition + ' ' + (!this._isThumbnailVertical() && isRTL ? 'thumbnails-wrapper-rtl' : ''),
              style: this._getThumbnailBarHeight()
            },
            _react2.default.createElement(
              'div',
              {
                className: 'image-gallery-thumbnails',
                ref: function ref(i) {
                  return _this5._thumbnailsWrapper = i;
                }
              },
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(t) {
                    return _this5._thumbnails = t;
                  },
                  className: 'image-gallery-thumbnails-container',
                  style: thumbnailStyle,
                  'aria-label': 'Thumbnail Navigation'
                },
                thumbnails
              )
            )
          ),
          (thumbnailPosition === 'top' || thumbnailPosition === 'left') && slideWrapper
        )
      );
    }
  }]);

  return ImageGallery;
}(_react2.default.Component);

ImageGallery.propTypes = {
  flickThreshold: _propTypes2.default.number,
  items: _propTypes2.default.array.isRequired,
  showNav: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  lazyLoad: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  showIndex: _propTypes2.default.bool,
  showBullets: _propTypes2.default.bool,
  showThumbnails: _propTypes2.default.bool,
  showPlayButton: _propTypes2.default.bool,
  showFullscreenButton: _propTypes2.default.bool,
  disableThumbnailScroll: _propTypes2.default.bool,
  disableArrowKeys: _propTypes2.default.bool,
  disableSwipe: _propTypes2.default.bool,
  useBrowserFullscreen: _propTypes2.default.bool,
  preventDefaultTouchmoveEvent: _propTypes2.default.bool,
  defaultImage: _propTypes2.default.string,
  indexSeparator: _propTypes2.default.string,
  thumbnailPosition: _propTypes2.default.string,
  startIndex: _propTypes2.default.number,
  slideDuration: _propTypes2.default.number,
  slideInterval: _propTypes2.default.number,
  slideOnThumbnailOver: _propTypes2.default.bool,
  swipeThreshold: _propTypes2.default.number,
  swipingTransitionDuration: _propTypes2.default.number,
  onSlide: _propTypes2.default.func,
  onScreenChange: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onImageLoad: _propTypes2.default.func,
  onImageError: _propTypes2.default.func,
  onTouchMove: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onThumbnailError: _propTypes2.default.func,
  onThumbnailClick: _propTypes2.default.func,
  renderCustomControls: _propTypes2.default.func,
  renderLeftNav: _propTypes2.default.func,
  renderRightNav: _propTypes2.default.func,
  renderPlayPauseButton: _propTypes2.default.func,
  renderFullscreenButton: _propTypes2.default.func,
  renderItem: _propTypes2.default.func,
  stopPropagation: _propTypes2.default.bool,
  additionalClass: _propTypes2.default.string,
  useTranslate3D: _propTypes2.default.bool,
  isRTL: _propTypes2.default.bool
};
ImageGallery.defaultProps = {
  items: [],
  showNav: true,
  autoPlay: false,
  lazyLoad: false,
  infinite: true,
  showIndex: false,
  showBullets: false,
  showThumbnails: true,
  showPlayButton: true,
  showFullscreenButton: true,
  disableThumbnailScroll: false,
  disableArrowKeys: false,
  disableSwipe: false,
  useTranslate3D: true,
  isRTL: false,
  useBrowserFullscreen: true,
  preventDefaultTouchmoveEvent: false,
  flickThreshold: 0.4,
  stopPropagation: false,
  indexSeparator: ' / ',
  thumbnailPosition: 'bottom',
  startIndex: 0,
  slideDuration: 450,
  swipingTransitionDuration: 0,
  slideInterval: 3000,
  swipeThreshold: 30,
  renderLeftNav: function renderLeftNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-left-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Previous Slide'
    });
  },
  renderRightNav: function renderRightNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-right-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Next Slide'
    });
  },
  renderPlayPauseButton: function renderPlayPauseButton(onClick, isPlaying) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-play-button' + (isPlaying ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Play or Pause Slideshow'
    });
  },
  renderFullscreenButton: function renderFullscreenButton(onClick, isFullscreen) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-fullscreen-button' + (isFullscreen ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Open Fullscreen'
    });
  }
};
exports.default = ImageGallery;

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_invoice_constant__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_money__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_ConfirmationModal__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__ = __webpack_require__(2);
var _INVOICE_TYPE_LIST;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PRODUCT_TYPE={set:'Set',treatment:'Treatment',retainer:'Retainer','retainer-new':'Retainer New','implant-treatment':'Implant Treatment','retainer-refinement':'Retainer Refinement','retainer-refinement-new':'Retainer Refinement New'};var INVOICE_TYPE_LIST=(_INVOICE_TYPE_LIST={},_defineProperty(_INVOICE_TYPE_LIST,__WEBPACK_IMPORTED_MODULE_6__constant_invoice_constant__["b" /* INVOICE_TYPE_INVOICE_CORRECTION */],'Correction'),_defineProperty(_INVOICE_TYPE_LIST,__WEBPACK_IMPORTED_MODULE_6__constant_invoice_constant__["a" /* INVOICE_TYPE_INVOICE */],'Invoice'),_INVOICE_TYPE_LIST);var Invoice=function Invoice(_ref){var invoice=_ref.invoice,createCorrection=_ref.createCorrection,onCorrectionCreated=_ref.onCorrectionCreated,showConfirmationModal=_ref.showConfirmationModal;var productType=invoice.thirdParty?'Physician':PRODUCT_TYPE[invoice.type];var invoiceType=INVOICE_TYPE_LIST[invoice.invoiceType];var downloadLink=__WEBPACK_IMPORTED_MODULE_9__util_api__["a" /* BACKEND_URL */]+'/api/invoice/pdf/download?fileId='+invoice.fileId;var viewLink=__WEBPACK_IMPORTED_MODULE_9__util_api__["a" /* BACKEND_URL */]+'/api/invoice/pdf/view?fileId='+invoice.fileId;var showCorrection=invoice.invoiceType===__WEBPACK_IMPORTED_MODULE_6__constant_invoice_constant__["a" /* INVOICE_TYPE_INVOICE */]&&!invoice.thirdParty;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,productType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,invoice.referenceNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(invoice.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,invoiceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:downloadLink},'download')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:viewLink,target:'_blank',rel:'noopener noreferrer'},'view')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__util_money__["b" /* formatMoney */])(invoice.brutPrice,invoice.currency)),onCorrectionCreated&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,showCorrection&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){showConfirmationModal(invoice);},className:'btn btn-primary btn-sm'},'correction')));};var InvoiceList=function InvoiceList(_ref2){var invoice=_ref2.invoice,invoiceList=_ref2.invoiceList,onCorrectionCreated=_ref2.onCorrectionCreated,createCorrection=_ref2.createCorrection,confirmationModalOpen=_ref2.confirmationModalOpen,showConfirmationModal=_ref2.showConfirmationModal,closeConfirmationModal=_ref2.closeConfirmationModal;if(!Object(__WEBPACK_IMPORTED_MODULE_10__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__["D" /* INVOICE_LIST_WIDGET */])){return null;}var total=0;var currency=invoiceList&&invoiceList.length?invoiceList[0].currency:'EUR';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Invoices '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_ConfirmationModal__["a" /* default */],{showModal:confirmationModalOpen,confirmClicked:function confirmClicked(){createCorrection(onCorrectionCreated);},cancelClicked:closeConfirmationModal},'Please confirm the creation of invoice correction for invoice ',invoice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,invoice.referenceNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reference Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Download'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Brut'),onCorrectionCreated&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Correction'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,invoiceList.map(function(invoice){if(!invoice.thirdParty){total+=invoice.brutPrice;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Invoice,{key:invoice.id,invoice:invoice,showConfirmationModal:showConfirmationModal,closeConfirmationModal:closeConfirmationModal,onCorrectionCreated:onCorrectionCreated,createCorrection:createCorrection});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Total (Sunshine Smile)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_7__util_money__["b" /* formatMoney */])(total,currency))),onCorrectionCreated&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)))))));};InvoiceList.propTypes={invoiceList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,createCorrection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCorrectionCreated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (InvoiceList);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SALES_ORDER_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SALES_ORDER_STATUS_HISTORY; });
// Please don't change values of constants since they are used in database
var SALES_ORDER_OVERVIEW='SalesOrderOverview';var SALES_ORDER_STATUS_HISTORY='StatusHistory';

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IMPLANT_MEDICAL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIRM_IMPLANT_MEDICAL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPLOAD_CBCT; });
var IMPLANT_MEDICAL_CHECK='implant_medical_check';var CONFIRM_IMPLANT_MEDICAL_CHECK='confirm_implant_medical_check';var UPLOAD_CBCT='implant_upload_cbct';

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InitialHesitationWidget__ = __webpack_require__(1549);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__InitialHesitationWidget__["a" /* default */]));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectCurrentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectPasswordStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectHasChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectValidationMessageList; });
/* unused harmony export selectError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIsUniqueConstraintViolation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCurrentRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCurrentRoleId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(399);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectCurrentUser=function selectCurrentUser(state){return selectOwnState(state).currentUser;};var selectUserList=function selectUserList(state){return selectOwnState(state).userList;};var selectCurrentUserId=function selectCurrentUserId(state){return selectOwnState(state).currentUserId;};var selectPasswordStatus=function selectPasswordStatus(state){return selectOwnState(state).passwordStatus;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectValidationMessageList=function selectValidationMessageList(state){return selectOwnState(state).validationMessageList;};var selectError=function selectError(state){return selectOwnState(state).error;};var selectIsUniqueConstraintViolation=function selectIsUniqueConstraintViolation(state){var error=selectError(state);return error?error.uniqueConstraintViolation:false;};var selectRoleList=function selectRoleList(state){return selectOwnState(state).roleList;};var selectCurrentRole=function selectCurrentRole(state){return selectOwnState(state).currentRole;};var selectCurrentRoleId=function selectCurrentRoleId(state){return selectOwnState(state).currentRoleId;};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectValidationMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectHasChanged; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(590);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectStore=function selectStore(state){return selectOwnState(state).store;};var selectRedirect=function selectRedirect(state){return selectOwnState(state).redirect;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectValidationMessageList=function selectValidationMessageList(state){return selectOwnState(state).validationMessageList;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectValidationMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectHasChanged; });
/* unused harmony export selectStoreList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectRedirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(587);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectPartner=function selectPartner(state){return selectOwnState(state).partner;};var selectError=function selectError(state){return selectOwnState(state).error;};var selectValidationMessageList=function selectValidationMessageList(state){return selectOwnState(state).validationMessageList;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectStoreList=function selectStoreList(state){return selectOwnState(state).storeList;};var selectRedirect=function selectRedirect(state){return selectOwnState(state).redirect;};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(601);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(99);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  Object(__WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(617);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65), __webpack_require__(616)(module)))

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(331);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(332);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(334);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore =
/*#__PURE__*/
createStoreHook();

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(99);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */]);

  if (false) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(150);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



var createSelectors = function createSelectors(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;

  var isRouter = function isRouter(value) {
    return value != null && _typeof(value) === 'object' && getIn(value, ['location']) && getIn(value, ['action']);
  };

  var getRouter = function getRouter(state) {
    var router = toJS(getIn(state, ['router']));

    if (!isRouter(router)) {
      throw 'Could not find router reducer in state tree, it must be mounted under "router"';
    }

    return router;
  };

  var getLocation = function getLocation(state) {
    return toJS(getIn(getRouter(state), ['location']));
  };

  var getAction = function getAction(state) {
    return toJS(getIn(getRouter(state), ['action']));
  };

  var getSearch = function getSearch(state) {
    return toJS(getIn(getRouter(state), ['location', 'search']));
  };

  var getHash = function getHash(state) {
    return toJS(getIn(getRouter(state), ['location', 'hash']));
  }; // It only makes sense to recalculate the `matchPath` whenever the pathname
  // of the location changes. That's why `createMatchSelector` memoizes
  // the latest result based on the location's pathname.


  var createMatchSelector = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;
    return function (state) {
      var _ref = getLocation(state) || {},
          pathname = _ref.pathname;

      if (pathname === lastPathname) {
        return lastMatch;
      }

      lastPathname = pathname;
      var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(pathname, path);

      if (!match || !lastMatch || match.url !== lastMatch.url // When URL matched for nested routes, URL is the same but isExact is not.
      || match.isExact !== lastMatch.isExact) {
        lastMatch = match;
      }

      return lastMatch;
    };
  };

  return {
    getLocation: getLocation,
    getAction: getAction,
    getRouter: getRouter,
    getSearch: getSearch,
    getHash: getHash,
    createMatchSelector: createMatchSelector
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createSelectors);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.length === 0;
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.toString();
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'string';
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === null || value === undefined;
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_to_camel_case__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_to_camel_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_to_camel_case__);

var namespacer = '/';
/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.indexOf(namespacer) === -1 ? __WEBPACK_IMPORTED_MODULE_0_to_camel_case___default()(type) : type.split(namespacer).map(__WEBPACK_IMPORTED_MODULE_0_to_camel_case___default.a).join(namespacer);
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get__ = __webpack_require__(342);



/* harmony default export */ __webpack_exports__["a"] = (function (predicate) {
  return function flatten(map, _temp, partialFlatMap, partialFlatActionType) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === void 0 ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace,
        prefix = _ref.prefix;

    if (partialFlatMap === void 0) {
      partialFlatMap = {};
    }

    if (partialFlatActionType === void 0) {
      partialFlatActionType = '';
    }

    function connectNamespace(type) {
      var _ref2;

      if (!partialFlatActionType) return type;
      var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
      var partials = partialFlatActionType.split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
      return (_ref2 = []).concat.apply(_ref2, partials.map(function (p) {
        return types.map(function (t) {
          return "" + p + namespace + t;
        });
      })).join(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
    }

    function connectPrefix(type) {
      if (partialFlatActionType || !prefix || prefix && new RegExp("^" + prefix + namespace).test(type)) {
        return type;
      }

      return "" + prefix + namespace + type;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectPrefix(connectNamespace(type));
      var mapValue = Object(__WEBPACK_IMPORTED_MODULE_2__get__["a" /* default */])(type, map);

      if (predicate(mapValue)) {
        flatten(mapValue, {
          namespace: namespace,
          prefix: prefix
        }, partialFlatMap, nextNamespace);
      } else {
        partialFlatMap[nextNamespace] = mapValue;
      }
    });
    return partialFlatMap;
  };
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isMap__ = __webpack_require__(154);

function get(key, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isNil__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isUndefined__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_toString__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(125);








function handleAction(type, reducer, defaultState) {
  if (reducer === void 0) {
    reducer = __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */];
  }

  var types = Object(__WEBPACK_IMPORTED_MODULE_6__utils_toString__["a" /* default */])(type).split(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(!Object(__WEBPACK_IMPORTED_MODULE_5__utils_isUndefined__["a" /* default */])(defaultState), "defaultState for reducer handling " + types.join(', ') + " should be defined");
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(reducer) || Object(__WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */] : aReducer;
  }),
      nextReducer = _ref[0],
      throwReducer = _ref[1];

  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    var actionType = action.type;

    if (!actionType || types.indexOf(Object(__WEBPACK_IMPORTED_MODULE_6__utils_toString__["a" /* default */])(actionType)) === -1) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_BASIS_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_BASIS_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_BASIS_REPORT_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(204);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FETCH_BASIS_REPORT_REQUEST=NS+'FETCH_BASIS_REPORT_REQUEST';var FETCH_BASIS_REPORT_SUCCESS=NS+'FETCH_BASIS_REPORT_SUCCESS';var FETCH_BASIS_REPORT_ERROR=NS+'FETCH_BASIS_REPORT_ERROR';

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_FUNNEL_START_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_FUNNEL_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_COHORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_COHORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_COHORT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_CURRENT_STATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FIND_CURRENT_STATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_CURRENT_STATE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(113);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["c" /* REDUCER_NAME */]+'/';var CHANGE_MODE=NS+'CHANGE_MODE';var CHANGE_FUNNEL_START_DEFINITION=NS+'CHANGE_FUNNEL_START_DEFINITION';var CHANGE_FUNNEL_STEP=NS+'CHANGE_FUNNEL_STEP';var FIND_COHORT_REQUEST=NS+'FIND_COHORT_REQUEST';var FIND_COHORT_SUCCESS=NS+'FIND_COHORT_SUCCESS';var FIND_COHORT_ERROR=NS+'FIND_COHORT_ERROR';var FIND_CURRENT_STATE_REQUEST=NS+'FIND_CURRENT_STATE_REQUEST';var FIND_CURRENT_STATE_SUCCESS=NS+'FIND_CURRENT_STATE_SUCCESS';var FIND_CURRENT_STATE_ERROR=NS+'FIND_CURRENT_STATE_ERROR';

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_USER_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_STATE_ANALYTICS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_STATE_ANALYTICS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_STATE_ANALYTICS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_STATE_LAST_CHANGED_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_STATE_LAST_CHANGED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_STATE_LAST_CHANGED_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_TASK_BY_DUE_DATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_TASK_BY_DUE_DATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_TASK_BY_DUE_DATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_TASK_BY_WEEK_DIFF_DATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_TASK_TABLE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_STATE_TABLE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(208);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_USER_SELECTION=NS+'CHANGE_USER_SELECTION';var GET_STATE_ANALYTICS_REQUEST=NS+'GET_STATE_ANALYTICS_REQUEST';var GET_STATE_ANALYTICS_SUCCESS=NS+'GET_STATE_ANALYTICS_SUCCESS';var GET_STATE_ANALYTICS_ERROR=NS+'GET_STATE_ANALYTICS_ERROR';var GET_STATE_LAST_CHANGED_REQUEST=NS+'GET_STATE_LAST_CHANGED_REQUEST';var GET_STATE_LAST_CHANGED_SUCCESS=NS+'GET_STATE_LAST_CHANGED_SUCCESS';var GET_STATE_LAST_CHANGED_ERROR=NS+'GET_STATE_LAST_CHANGED_ERROR';var GET_TASK_BY_DUE_DATE_REQUEST=NS+'GET_TASK_BY_DUE_DATE_REQUEST';var GET_TASK_BY_DUE_DATE_SUCCESS=NS+'GET_TASK_BY_DUE_DATE_SUCCESS';var GET_TASK_BY_DUE_DATE_ERROR=NS+'GET_TASK_BY_DUE_DATE_ERROR';var FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST=NS+'FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST';var FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS=NS+'FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS';var FIND_TASK_BY_WEEK_DIFF_DATE_ERROR=NS+'FIND_TASK_BY_WEEK_DIFF_DATE_ERROR';var CHANGE_TASK_TABLE_SETTINGS=NS+'CHANGE_TASK_TABLE_SETTINGS';var CHANGE_STATE_TABLE_SETTINGS=NS+'CHANGE_STATE_TABLE_SETTINGS';var FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST=NS+'FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST';var FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS=NS+'FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS';var FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR=NS+'FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR';

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_PROCESS_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_YEAR_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_YEAR_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_TRANSITION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_TRANSITION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_TRANSITION_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(127);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["c" /* REDUCER_NAME */]+'/';var CHANGE_PROCESS_STATE=NS+'CHANGE_PROCESS_STATE';var CHANGE_YEAR_WEEK=NS+'CHANGE_YEAR_WEEK';var DELETE_YEAR_WEEK=NS+'DELETE_YEAR_WEEK';var CHANGE_MODE=NS+'CHANGE_MODE';var FIND_TRANSITION_REQUEST=NS+'FIND_COHORT_REQUEST';var FIND_TRANSITION_SUCCESS=NS+'FIND_COHORT_SUCCESS';var FIND_TRANSITION_ERROR=NS+'FIND_COHORT_ERROR';

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_OR_CREATE_ANAMNESIS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_OR_CREATE_ANAMNESIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_OR_CREATE_ANAMNESIS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_ANAMNESIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_ANAMNESIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_ANAMNESIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_EDITING_TREATMENT_EXPECTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TOGGLE_INFO_LEGEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_ANAMNESIS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_ANAMNESIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_ANAMNESIS_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(27);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["i" /* REDUCER_NAME */]+'/';var FIND_OR_CREATE_ANAMNESIS_REQUEST=NS+'FIND_OR_CREATE_ANAMNESIS_REQUEST';var FIND_OR_CREATE_ANAMNESIS_SUCCESS=NS+'FIND_OR_CREATE_ANAMNESIS_SUCCESS';var FIND_OR_CREATE_ANAMNESIS_ERROR=NS+'FIND_OR_CREATE_ANAMNESIS_ERROR';var CHANGE_ANAMNESIS=NS+'CHANGE_ANAMNESIS';var UPDATE_ANAMNESIS=NS+'UPDATE_ANAMNESIS';var TOGGLE_ANAMNESIS=NS+'TOGGLE_ANAMNESIS';var TOGGLE_EDITING_TREATMENT_EXPECTATION=NS+'TOGGLE_EDITING_TREATMENT_EXPECTATION';var TOGGLE_INFO_LEGEND=NS+'TOGGLE_INFO_LEGEND';var SAVE_ANAMNESIS_REQUEST=NS+'SAVE_ANAMNESIS_REQUEST';var SAVE_ANAMNESIS_SUCCESS=NS+'SAVE_ANAMNESIS_SUCCESS';var SAVE_ANAMNESIS_ERROR=NS+'SAVE_ANAMNESIS_ERROR';

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_BY_CUSTOMER_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_BY_CUSTOMER_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIND_BY_CUSTOMER_ID_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_ANAMNESIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOGGLE_INFO_LEGEND; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(209);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FIND_BY_CUSTOMER_ID_REQUEST=NS+'FIND_BY_CUSTOMER_ID_REQUEST';var FIND_BY_CUSTOMER_ID_SUCCESS=NS+'FIND_BY_CUSTOMER_ID_SUCCESS';var FIND_BY_CUSTOMER_ID_ERROR=NS+'FIND_BY_CUSTOMER_ID_ERROR';var TOGGLE_ANAMNESIS=NS+'TOGGLE_ANAMNESIS';var TOGGLE_INFO_LEGEND=NS+'TOGGLE_INFO_LEGEND';

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_APPOINTMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_APPOINTMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_APPOINTMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_APPOINTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_APPOINTMENT_CANCEL_CATEGORY_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(210);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FIND_APPOINTMENT_REQUEST=NS+'FIND_APPOINTMENT_REQUEST';var FIND_APPOINTMENT_SUCCESS=NS+'FIND_APPOINTMENT_SUCCESS';var FIND_APPOINTMENT_ERROR=NS+'FIND_APPOINTMENT_ERROR';var CHANGE_APPOINTMENT=NS+'CHANGE_APPOINTMENT';var SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST=NS+'SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST';var SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS=NS+'SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS';var SET_APPOINTMENT_CANCEL_CATEGORY_ERROR=NS+'SET_APPOINTMENT_CANCEL_CATEGORY_ERROR';

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FIND_CUSTOMER_PARTIAL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FIND_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FIND_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FIND_CUSTOMER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return HYDRATE_CUSTOMER_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return START_REFINEMENT_SHOP_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return START_REFINEMENT_SHOP_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return START_REFINEMENT_SHOP_PROCESS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return START_RETAINER_REFINEMENT_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return START_RETAINER_REFINEMENT_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return START_RETAINER_REFINEMENT_PROCESS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return START_REFINEMENT_SET_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return START_REFINEMENT_SET_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return START_REFINEMENT_SET_PROCESS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return START_ESCALATION_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return START_ESCALATION_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return START_ESCALATION_PROCESS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return START_ALIGNER_REPRODUCTION_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return START_ALIGNER_REPRODUCTION_PROCESS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return START_PARTIAL_REFUND_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return START_PARTIAL_REFUND_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return START_PARTIAL_REFUND_PROCESS_ERROR; });
/* unused harmony export START_DOWNLOAD_CUSTOMER_DATA_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return START_DOWNLOAD_CUSTOMER_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return START_DOWNLOAD_CUSTOMER_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_CUSTOMER_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SAVE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SAVE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SAVE_CUSTOMER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return UPLOAD_CUSTOMER_IMAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return UPLOAD_CUSTOMER_IMAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return UPLOAD_CUSTOMER_IMAGE_ERROR; });
/* unused harmony export ROTATE_CUSTOMER_IMAGE_REQUEST */
/* unused harmony export ROTATE_CUSTOMER_IMAGE_SUCCESS */
/* unused harmony export ROTATE_CUSTOMER_IMAGE_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return TOGGLE_IMAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CUSTOMER_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_FILE_DELETE_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FIX_ACCOUNT_PROBLEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FIX_ACCOUNT_PROBLEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FIX_ACCOUNT_PROBLEM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OPEN_CHANGE_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLOSE_CHANGE_EMAIL_MODAL; });
/* unused harmony export OPEN_RESPONSE_FEEDBACK_MODAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLOSE_RESPONSE_FEEDBACK_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return HANDLE_DELETE_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SHOW_ERROR_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return OPEN_DELETE_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLOSE_DELETE_CONFIRMATION_MODAL; });
/* unused harmony export DELETE_CUSTOMER_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DELETE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DELETE_CUSTOMER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHANGE_NEW_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_EMAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_EMAIL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FIND_PROCESS_COMMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FIND_PROCESS_COMMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FIND_PROCESS_COMMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_WHATSAPP_OPT_IN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPDATE_WHATSAPP_OPT_IN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_WHATSAPP_OPT_IN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(40);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["f" /* REDUCER_NAME */]+'/';var CHANGE_ACTIVE_TAB=NS+'CHANGE_ACTIVE_TAB';var FIND_CUSTOMER_PARTIAL_REQUEST=NS+'FIND_CUSTOMER_PARTIAL_REQUEST';var FIND_CUSTOMER_REQUEST=NS+'FIND_CUSTOMER_REQUEST';var FIND_CUSTOMER_SUCCESS=NS+'FIND_CUSTOMER_SUCCESS';var FIND_CUSTOMER_ERROR=NS+'FIND_CUSTOMER_ERROR';var HYDRATE_CUSTOMER_CONTACT=NS+'HYDRATE_CUSTOMER_CONTACT';var START_REFINEMENT_SHOP_PROCESS_REQUEST=NS+'START_REFINEMENT_SHOP_PROCESS_REQUEST';var START_REFINEMENT_SHOP_PROCESS_SUCCESS=NS+'START_REFINEMENT_SHOP_PROCESS_SUCCESS';var START_REFINEMENT_SHOP_PROCESS_ERROR=NS+'START_REFINEMENT_SHOP_PROCESS_ERROR';var START_RETAINER_REFINEMENT_PROCESS_REQUEST=NS+'START_RETAINER_REFINEMENT_PROCESS_REQUEST';var START_RETAINER_REFINEMENT_PROCESS_SUCCESS=NS+'START_RETAINER_REFINEMENT_PROCESS_SUCCESS';var START_RETAINER_REFINEMENT_PROCESS_ERROR=NS+'START_RETAINER_REFINEMENT_PROCESS_ERROR';var START_REFINEMENT_SET_PROCESS_REQUEST=NS+'START_REFINEMENT_SET_PROCESS_REQUEST';var START_REFINEMENT_SET_PROCESS_SUCCESS=NS+'START_REFINEMENT_SET_PROCESS_SUCCESS';var START_REFINEMENT_SET_PROCESS_ERROR=NS+'START_REFINEMENT_SET_PROCESS_ERROR';var START_ESCALATION_PROCESS_REQUEST=NS+'START_ESCALATION_PROCESS_REQUEST';var START_ESCALATION_PROCESS_SUCCESS=NS+'START_ESCALATION_PROCESS_SUCCESS';var START_ESCALATION_PROCESS_ERROR=NS+'START_ESCALATION_PROCESS_ERROR';var START_ALIGNER_REPRODUCTION_PROCESS_REQUEST=NS+'START_ALIGNER_REPRODUCTION_PROCESS_REQUEST';var START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS=NS+'START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS';var START_ALIGNER_REPRODUCTION_PROCESS_ERROR=NS+'START_ALIGNER_REPRODUCTION_PROCESS_ERROR';var START_PARTIAL_REFUND_PROCESS_REQUEST=NS+'START_PARTIAL_REFUND_PROCESS_REQUEST';var START_PARTIAL_REFUND_PROCESS_SUCCESS=NS+'START_PARTIAL_REFUND_PROCESS_SUCCESS';var START_PARTIAL_REFUND_PROCESS_ERROR=NS+'START_PARTIAL_REFUND_PROCESS_ERROR';var START_DOWNLOAD_CUSTOMER_DATA_REQUEST=NS+'START_DOWNLOAD_CUSTOMER_DATA_REQUEST';var START_DOWNLOAD_CUSTOMER_DATA_SUCCESS=NS+'START_DOWNLOAD_CUSTOMER_DATA_SUCCESS';var START_DOWNLOAD_CUSTOMER_DATA_ERROR=NS+'START_DOWNLOAD_CUSTOMER_DATA_ERROR';var CHANGE_CUSTOMER=NS+'CHANGE_CUSTOMER';var CHANGE_CUSTOMER_CONTACT=NS+'CHANGE_CUSTOMER_CONTACT';var SAVE_CUSTOMER_REQUEST=NS+'SAVE_CUSTOMER_REQUEST';var SAVE_CUSTOMER_SUCCESS=NS+'SAVE_CUSTOMER_SUCCESS';var SAVE_CUSTOMER_ERROR=NS+'SAVE_CUSTOMER_ERROR';var UPLOAD_CUSTOMER_IMAGE_REQUEST=NS+'UPLOAD_CUSTOMER_IMAGE_REQUEST';var UPLOAD_CUSTOMER_IMAGE_SUCCESS=NS+'UPLOAD_CUSTOMER_IMAGE_SUCCESS';var UPLOAD_CUSTOMER_IMAGE_ERROR=NS+'UPLOAD_CUSTOMER_IMAGE_ERROR';var ROTATE_CUSTOMER_IMAGE_REQUEST=NS+'ROTATE_CUSTOMER_IMAGE_REQUEST';var ROTATE_CUSTOMER_IMAGE_SUCCESS=NS+'ROTATE_CUSTOMER_IMAGE_SUCCESS';var ROTATE_CUSTOMER_IMAGE_ERROR=NS+'ROTATE_CUSTOMER_IMAGE_ERROR';var TOGGLE_IMAGE_VIEW=NS+'TOGGLE_IMAGE_VIEW';var ADD_CUSTOMER_FILE=NS+'ADD_CUSTOMER_FILE';var SET_FILE_DELETE_FLAG=NS+'SET_FILE_DELETE_FLAG';var FIX_ACCOUNT_PROBLEM_REQUEST=NS+'FIX_ACCOUNT_PROBLEM_REQUEST';var FIX_ACCOUNT_PROBLEM_SUCCESS=NS+'FIX_ACCOUNT_PROBLEM_SUCCESS';var FIX_ACCOUNT_PROBLEM_ERROR=NS+'FIX_ACCOUNT_PROBLEM_ERROR';var OPEN_CHANGE_EMAIL_MODAL=NS+'OPEN_CHANGE_EMAIL_MODAL';var CLOSE_CHANGE_EMAIL_MODAL=NS+'CLOSE_CHANGE_EMAIL_MODAL';var OPEN_RESPONSE_FEEDBACK_MODAL=NS+'OPEN_RESPONSE_FEEDBACK_MODAL';var CLOSE_RESPONSE_FEEDBACK_MODAL=NS+'CLOSE_RESPONSE_FEEDBACK_MODAL';var HANDLE_DELETE_CONFIRMATION_MODAL=NS+'HANDLE_DELETE_CONFIRMATION_MODAL';var SHOW_ERROR_CONFIRMATION_MODAL=NS+'SHOW_ERROR_CONFIRMATION_MODAL';var OPEN_DELETE_CONFIRMATION_MODAL=NS+'OPEN_DELETE_CONFIRMATION_MODAL';var CLOSE_DELETE_CONFIRMATION_MODAL=NS+'CLOSE_DELETE_CONFIRMATION_MODAL';var DELETE_CUSTOMER_REQUEST=NS+'DELETE_CUSTOMER_REQUEST';var DELETE_CUSTOMER_SUCCESS=NS+'DELETE_CUSTOMER_SUCCESS';var DELETE_CUSTOMER_ERROR=NS+'DELETE_CUSTOMER_ERROR';var CHANGE_NEW_EMAIL=NS+'CHANGE_NEW_EMAIL';var CHANGE_EMAIL_REQUEST=NS+'CHANGE_EMAIL_REQUEST';var CHANGE_EMAIL_SUCCESS=NS+'CHANGE_EMAIL_SUCCESS';var CHANGE_EMAIL_ERROR=NS+'CHANGE_EMAIL_ERROR';var FIND_PROCESS_COMMENT_REQUEST=NS+'FIND_PROCESS_COMMENT_REQUEST';var FIND_PROCESS_COMMENT_SUCCESS=NS+'FIND_PROCESS_COMMENT_SUCCESS';var FIND_PROCESS_COMMENT_ERROR=NS+'FIND_PROCESS_COMMENT_ERROR';var SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST=NS+'SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST';var SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS=NS+'SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS';var SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR=NS+'SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR';var UPDATE_WHATSAPP_OPT_IN_REQUEST=NS+'UPDATE_WHATSAPP_OPT_IN_REQUEST';var UPDATE_WHATSAPP_OPT_IN_SUCCESS=NS+'UPDATE_WHATSAPP_OPT_IN_SUCCESS';var UPDATE_WHATSAPP_OPT_IN_ERROR=NS+'UPDATE_WHATSAPP_OPT_IN_ERROR';var UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE=NS+'UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE';var UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST=NS+'UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST';var UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS=NS+'UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS';var UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR=NS+'UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR';

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_PROCESS_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_IS_COMMENT_INTERNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMMENT_PROCESS_INSTANCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMMENT_PROCESS_INSTANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMMENT_PROCESS_INSTANCE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_PROCESS_COMMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_PROCESS_COMMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_PROCESS_COMMENT_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(213);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["f" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_PROCESS_COMMENT=NS+'CHANGE_PROCESS_COMMENT';var CHANGE_IS_COMMENT_INTERNAL=NS+'CHANGE_IS_COMMENT_INTERNAL';var COMMENT_PROCESS_INSTANCE_REQUEST=NS+'COMMENT_PROCESS_INSTANCE_REQUEST';var COMMENT_PROCESS_INSTANCE_SUCCESS=NS+'COMMENT_PROCESS_INSTANCE_SUCCESS';var COMMENT_PROCESS_INSTANCE_ERROR=NS+'COMMENT_PROCESS_INSTANCE_ERROR';var FIND_PROCESS_COMMENT_REQUEST=NS+'FIND_PROCESS_COMMENT_REQUEST';var FIND_PROCESS_COMMENT_SUCCESS=NS+'FIND_PROCESS_COMMENT_SUCCESS';var FIND_PROCESS_COMMENT_ERROR=NS+'FIND_PROCESS_COMMENT_ERROR';

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPLOAD_CUSTOMER_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPLOAD_CUSTOMER_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPLOAD_CUSTOMER_FILE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DELETE_FLAG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DELETE_FLAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_DELETE_FLAG_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIGGER_VISUALIZATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIGGER_VISUALIZATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIGGER_VISUALIZATION_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(114);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["b" /* REDUCER_NAME */]+'/';var UPLOAD_CUSTOMER_FILE_REQUEST=NS+'UPLOAD_CUSTOMER_REQUEST';var UPLOAD_CUSTOMER_FILE_SUCCESS=NS+'UPLOAD_CUSTOMER_FILE_SUCCESS';var UPLOAD_CUSTOMER_FILE_ERROR=NS+'UPLOAD_CUSTOMER_FILE_ERROR';var SET_DELETE_FLAG_REQUEST=NS+'SET_DELETE_FLAG_REQUEST';var SET_DELETE_FLAG_SUCCESS=NS+'SET_DELETE_FLAG_SUCCESS';var SET_DELETE_FLAG_ERROR=NS+'SET_DELETE_FLAG_ERROR';var TRIGGER_VISUALIZATION_REQUEST=NS+'TRIGGER_VISUALIZATION_REQUEST';var TRIGGER_VISUALIZATION_SUCCESS=NS+'TRIGGER_VISUALIZATION_SUCCESS';var TRIGGER_VISUALIZATION_ERROR=NS+'TRIGGER_VISUALIZATION_ERROR';

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_IMAGE_VERSION_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_IMAGE_VERSION_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_IMAGE_VERSION_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPLOAD_CUSTOMER_IMAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPLOAD_CUSTOMER_IMAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REUPLOAD_CUSTOMER_IMAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPLOAD_CUSTOMER_IMAGE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ROTATE_CUSTOMER_IMAGE_REQUEST; });
/* unused harmony export ROTATE_CUSTOMER_IMAGE_SUCCESS */
/* unused harmony export ROTATE_CUSTOMER_IMAGE_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TOGGLE_IMAGE_VIEW; });
/* unused harmony export CHANGE_NEW_IMAGE_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_IMAGE_TYPE_META_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_IMAGE_TYPE_META_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_IMAGE_TYPE_META_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_SELECTED_IMAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CURRENT_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_SLIDE_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_CUSTOMER_IMAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_CUSTOMER_IMAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_CUSTOMER_IMAGE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(214);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FIND_IMAGE_VERSION_LIST_REQUEST=NS+'FIND_IMAGE_VERSION_LIST_REQUEST';var FIND_IMAGE_VERSION_LIST_SUCCESS=NS+'FIND_IMAGE_VERSION_LIST_SUCCESS';var FIND_IMAGE_VERSION_LIST_ERROR=NS+'FIND_IMAGE_VERSION_LIST_ERROR';var UPLOAD_CUSTOMER_IMAGE_REQUEST=NS+'UPLOAD_CUSTOMER_IMAGE_REQUEST';var UPLOAD_CUSTOMER_IMAGE_SUCCESS=NS+'UPLOAD_CUSTOMER_IMAGE_SUCCESS';var REUPLOAD_CUSTOMER_IMAGE_SUCCESS=NS+'REUPLOAD_CUSTOMER_IMAGE_SUCCESS';var UPLOAD_CUSTOMER_IMAGE_ERROR=NS+'UPLOAD_CUSTOMER_IMAGE_ERROR';var ROTATE_CUSTOMER_IMAGE_REQUEST=NS+'ROTATE_CUSTOMER_IMAGE_REQUEST';var ROTATE_CUSTOMER_IMAGE_SUCCESS=NS+'ROTATE_CUSTOMER_IMAGE_SUCCESS';var ROTATE_CUSTOMER_IMAGE_ERROR=NS+'ROTATE_CUSTOMER_IMAGE_ERROR';var TOGGLE_IMAGE_VIEW=NS+'TOGGLE_IMAGE_VIEW';var CHANGE_NEW_IMAGE_TYPE=NS+'CHANGE_NEW_IMAGE_TYPE';var SET_IMAGE_TYPE_META_DATA_REQUEST=NS+'SET_IMAGE_TYPE_META_DATA_REQUEST';var SET_IMAGE_TYPE_META_DATA_SUCCESS=NS+'SET_IMAGE_TYPE_META_DATA_SUCCESS';var SET_IMAGE_TYPE_META_DATA_ERROR=NS+'SET_IMAGE_TYPE_META_DATA_ERROR';var SET_SELECTED_IMAGE_TYPE=NS+'SET_SELECTED_IMAGE_TYPE';var SET_CURRENT_STEP=NS+'SET_CURRENT_STEP';var SET_SLIDE_INDEX=NS+'SET_SLIDE_INDEX';var DELETE_CUSTOMER_IMAGE_REQUEST=NS+'DELETE_CUSTOMER_IMAGE_REQUEST';var DELETE_CUSTOMER_IMAGE_SUCCESS=NS+'DELETE_CUSTOMER_IMAGE_SUCCESS';var DELETE_CUSTOMER_IMAGE_ERROR=NS+'DELETE_CUSTOMER_IMAGE_ERROR';

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='search';

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_SCAN_FOLDER_CONTENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_SCAN_FOLDER_CONTENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SCAN_FOLDER_CONTENT_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(216);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var GET_SCAN_FOLDER_CONTENT_REQUEST=NS+'GET_SCAN_FOLDER_CONTENT_REQUEST';var GET_SCAN_FOLDER_CONTENT_SUCCESS=NS+'GET_SCAN_FOLDER_CONTENT_SUCCESS';var GET_SCAN_FOLDER_CONTENT_ERROR=NS+'GET_SCAN_FOLDER_CONTENT_ERROR';

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_NEW_PHOTOS_NEEDED_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SELECTED_IMAGE_VERSIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(156);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["b" /* REDUCER_NAME */]+'/';var SET_NEW_PHOTOS_NEEDED_REASON=NS+'SET_NEW_PHOTOS_NEEDED_REASON';var SET_SELECTED_IMAGE_VERSIONS=NS+'SET_SELECTED_IMAGE_VERSIONS';

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TABLE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPLOAD_CUSTOMER_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPLOAD_CUSTOMER_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPLOAD_CUSTOMER_FILE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DELETE_FLAG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DELETE_FLAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DELETE_FLAG_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(217);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_TABLE_SETTING=NS+'CHANGE_TABLE_SETTING';var UPLOAD_CUSTOMER_FILE_REQUEST=NS+'UPLOAD_CUSTOMER_REQUEST';var UPLOAD_CUSTOMER_FILE_SUCCESS=NS+'UPLOAD_CUSTOMER_FILE_SUCCESS';var UPLOAD_CUSTOMER_FILE_ERROR=NS+'UPLOAD_CUSTOMER_FILE_ERROR';var SET_DELETE_FLAG_REQUEST=NS+'SET_DELETE_FLAG_REQUEST';var SET_DELETE_FLAG_SUCCESS=NS+'SET_DELETE_FLAG_SUCCESS';var SET_DELETE_FLAG_ERROR=NS+'SET_DELETE_FLAG_ERROR';

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FIND_EMAIL_TEMPLATE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FIND_EMAIL_TEMPLATE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FIND_EMAIL_TEMPLATE_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_PROCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_EMAIL_TEMPLATE_VARIANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FIND_EMAIL_TEMPLATE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_EMAIL_TEMPLATE_BY_ID_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_EMAIL_TEMPLATE_VARIANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SAVE_EMAIL_TEMPLATE_VARIANT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_EMAIL_TEMPLATE_VARIANT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_PROCESS_MACRO_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_PROCESS_MACRO_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_PROCESS_MACRO_LIST_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(130);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["d" /* REDUCER_NAME */]+'/';var FIND_EMAIL_TEMPLATE_LIST_REQUEST='FIND_EMAIL_TEMPLATE_LIST_REQUEST';var FIND_EMAIL_TEMPLATE_LIST_SUCCESS='FIND_EMAIL_TEMPLATE_LIST_SUCCESS';var FIND_EMAIL_TEMPLATE_LIST_ERROR='FIND_EMAIL_TEMPLATE_LIST_ERROR';var CHANGE_PROCESS=NS+'CHANGE_PROCESS';var CHANGE_LOCALE=NS+'CHANGE_LOCALE';var CREATE_EMAIL_TEMPLATE_VARIANT=NS+'CREATE_EMAIL_TEMPLATE_VARIANT';var FIND_EMAIL_TEMPLATE_BY_ID_REQUEST=NS+'FIND_EMAIL_TEMPLATE_BY_ID_REQUEST';var FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS=NS+'FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS';var FIND_EMAIL_TEMPLATE_BY_ID_ERROR=NS+'FIND_EMAIL_TEMPLATE_BY_ID_ERROR';var CHANGE_EMAIL_TEMPLATE_VARIANT=NS+'CHANGE_EMAIL_TEMPLATE_VARIANT';var SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST=NS+'SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST';var SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS=NS+'SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS';var SAVE_EMAIL_TEMPLATE_VARIANT_ERROR=NS+'SAVE_EMAIL_TEMPLATE_VARIANT_ERROR';var DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST=NS+'DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST';var DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS=NS+'DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS';var DELETE_EMAIL_TEMPLATE_VARIANT_ERROR=NS+'DELETE_EMAIL_TEMPLATE_VARIANT_ERROR';var GET_PROCESS_MACRO_LIST_REQUEST=NS+'GET_PROCESS_MACRO_LIST_REQUEST';var GET_PROCESS_MACRO_LIST_SUCCESS=NS+'GET_PROCESS_MACRO_LIST_SUCCESS';var GET_PROCESS_MACRO_LIST_ERROR=NS+'GET_PROCESS_MACRO_LIST_ERROR';

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){// http://www.ietf.org/rfc/rfc4122.txt
var s=[];var hexDigits='0123456789abcdef';for(var i=0;i<36;i++){s[i]=hexDigits.substr(Math.floor(Math.random()*0x10),1);}s[14]='4';// bits 12-15 of the time_hi_and_version field to 0010
s[19]=hexDigits.substr(s[19]&0x3|0x8,1);// bits 6-7 of the
// clock_seq_hi_and_reserved
// to 01
s[8]=s[13]=s[18]=s[23]='-';return s.join('');});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_EMPLOYEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SIPGATE_DEVICE_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SIPGATE_DEVICE_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SIPGATE_DEVICE_ID_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(219);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_EMPLOYEE=NS+'CHANGE_EMPLOYEE';var SET_SIPGATE_DEVICE_ID_REQUEST=NS+'SET_SIPGATE_DEVICE_ID_REQUEST';var SET_SIPGATE_DEVICE_ID_SUCCESS=NS+'SET_SIPGATE_DEVICE_ID_SUCCESS';var SET_SIPGATE_DEVICE_ID_ERROR=NS+'SET_SIPGATE_DEVICE_ID_ERROR';

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TABLE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_FOIL_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_FOIL_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_FOIL_LIST_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(222);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_TABLE_SETTING=NS+'CHANGE_TABLE_SETTING';var FIND_FOIL_LIST_REQUEST=NS+'FIND_FOIL_LIST_REQUEST';var FIND_FOIL_LIST_SUCCESS=NS+'FIND_FOIL_LIST_SUCCESS';var FIND_FOIL_LIST_ERROR=NS+'FIND_FOIL_LIST_ERROR';

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPLOAD_CSV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPLOAD_CSV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPLOAD_CSV_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(158);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var UPLOAD_CSV_REQUEST=NS+'UPLOAD_CSV_REQUEST';var UPLOAD_CSV_SUCCESS=NS+'UPLOAD_CSV_SUCCESS';var UPLOAD_CSV_ERROR=NS+'UPLOAD_CSV_ERROR';

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='gmail';

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_INVOICE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FIND_INVOICE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_INVOICE_BY_ID_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SHOW_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_INVOICE_CORRECTION_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_INVOICE_CORRECTION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_INVOICE_CORRECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_INVOICE_CORRECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_INVOICE_CORRECTION_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(159);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var FIND_INVOICE_BY_ID_REQUEST=NS+'FIND_INVOICE_BY_ID_REQUEST';var FIND_INVOICE_BY_ID_SUCCESS=NS+'FIND_INVOICE_BY_ID_SUCCESS';var FIND_INVOICE_BY_ID_ERROR=NS+'FIND_INVOICE_BY_ID_ERROR';var SHOW_CONFIRMATION_MODAL=NS+'SHOW_CONFIRMATION_MODAL';var CLOSE_CONFIRMATION_MODAL=NS+'CLOSE_CONFIRMATION_MODAL';var CHANGE_INVOICE_CORRECTION_ITEM=NS+'CHANGE_INVOICE_CORRECTION_ITEM';var CHANGE_INVOICE_CORRECTION_DATA=NS+'CHANGE_INVOICE_CORRECTION_DATA';var CREATE_INVOICE_CORRECTION_REQUEST=NS+'CREATE_INVOICE_CORRECTION_REQUEST';var CREATE_INVOICE_CORRECTION_SUCCESS=NS+'CREATE_INVOICE_CORRECTION_SUCCESS';var CREATE_INVOICE_CORRECTION_ERROR=NS+'CREATE_INVOICE_CORRECTION_ERROR';

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_CORRECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_CORRECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_CORRECTION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_CONFIRMATION_MODAL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(159);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var CREATE_CORRECTION_REQUEST=NS+'CREATE_CORRECTION_REQUEST';var CREATE_CORRECTION_SUCCESS=NS+'CREATE_CORRECTION_SUCCESS';var CREATE_CORRECTION_ERROR=NS+'CREATE_CORRECTION_ERROR';var SHOW_CONFIRMATION_MODAL=NS+'SHOW_CONFIRMATION_MODAL';var CLOSE_CONFIRMATION_MODAL=NS+'CLOSE_CONFIRMATION_MODAL';

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_NAVIGATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(228);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var TOGGLE_NAVIGATION=NS+'TOGGLE_NAVIGATION';

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_TABLE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_ALL_LEAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_ALL_LEAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_ALL_LEAD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_LEAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FIND_LEAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_LEAD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_LEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_LEAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_LEAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_LEAD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SENT_EMAIL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(229);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_TABLE_SETTING=NS+'CHANGE_TABLE_SETTING';var FIND_ALL_LEAD_REQUEST=NS+'FIND_ALL_LEAD_REQUEST';var FIND_ALL_LEAD_SUCCESS=NS+'FIND_ALL_LEAD_SUCCESS';var FIND_ALL_LEAD_ERROR=NS+'FIND_ALL_LEAD_ERROR';var FIND_LEAD_REQUEST=NS+'FIND_LEAD_REQUEST';var FIND_LEAD_SUCCESS=NS+'FIND_LEAD_SUCCESS';var FIND_LEAD_ERROR=NS+'FIND_LEAD_ERROR';var CHANGE_LEAD=NS+'CHANGE_LEAD';var SAVE_LEAD_REQUEST=NS+'SAVE_LEAD_REQUEST';var SAVE_LEAD_SUCCESS=NS+'SAVE_LEAD_SUCCESS';var SAVE_LEAD_ERROR=NS+'SAVE_LEAD_ERROR';var ADD_SENT_EMAIL=NS+'ADD_SENT_EMAIL';

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_SHIPMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_SHIPMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_SHIPMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_SHIPMENT_TRACKING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(231);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CREATE_SHIPMENT_REQUEST=NS+'CREATE_SHIPMENT_REQUEST';var CREATE_SHIPMENT_SUCCESS=NS+'CREATE_SHIPMENT_SUCCESS';var CREATE_SHIPMENT_ERROR=NS+'CREATE_SHIPMENT_ERROR';var TOGGLE_SHIPMENT_TRACKING=NS+'TOGGLE_SHIPMENT_TRACKING';

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BANK_TRANSFER_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BANK_TRANSFER_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BANK_SEPA_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BANK_SEPA_CANCELED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BANK_ZAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BANK_TABEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BANK_SPLIT_IT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BANK_PLEDG; });
var BANK_TRANSFER_IN='transfer_in';var BANK_TRANSFER_OUT='transfer_out';var BANK_SEPA_IN='sepa_in';var BANK_SEPA_CANCELED='sepa_canceled';var BANK_ZAB='zab_payment';var BANK_TABEO='tabeo_payment';var BANK_SPLIT_IT='splitit_payment';var BANK_PLEDG='pledg_payment';

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_TABLE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TABLE_ASSOCIATE_PAYMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FIND_UNASSIGNED_PAYMENT_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FIND_UNASSIGNED_PAYMENT_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EDIT_UNASSIGNED_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_SALES_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ASSOCIATE_PAYMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ASSOCIATE_PAYMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSOCIATE_PAYMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_PAYMENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_PAYMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_PAYMENT_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(232);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_TABLE_SETTINGS=NS+'CHANGE_TABLE_SETTINGS';var TABLE_ASSOCIATE_PAYMENTS='associatePayments';var FIND_UNASSIGNED_PAYMENT_LIST_REQUEST=NS+'FIND_UNASSIGNED_PAYMENT_LIST_REQUEST';var FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS=NS+'FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS';var FIND_UNASSIGNED_PAYMENT_LIST_ERROR=NS+'FIND_UNASSIGNED_PAYMENT_LIST_ERROR';var EDIT_UNASSIGNED_PAYMENT=NS+'EDIT_UNASSIGNED_PAYMENT';var CHANGE_CUSTOMER=NS+'CHANGE_CUSTOMER';var CHANGE_SALES_ORDER=NS+'CHANGE_SALES_ORDER';var ASSOCIATE_PAYMENT_REQUEST=NS+'ASSOCIATE_PAYMENT_REQUEST';var ASSOCIATE_PAYMENT_SUCCESS=NS+'ASSOCIATE_PAYMENT_SUCCESS';var ASSOCIATE_PAYMENT_ERROR=NS+'ASSOCIATE_PAYMENT_ERROR';var DELETE_PAYMENT_REQUEST=NS+'DELETE_PAYMENT_REQUEST';var DELETE_PAYMENT_SUCCESS=NS+'DELETE_PAYMENT_SUCCESS';var DELETE_PAYMENT_ERROR=NS+'DELETE_PAYMENT_ERROR';

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPLOAD_CSV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPLOAD_CSV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPLOAD_CSV_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(233);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var UPLOAD_CSV_REQUEST=NS+'UPLOAD_CSV_REQUEST';var UPLOAD_CSV_SUCCESS=NS+'UPLOAD_CSV_SUCCESS';var UPLOAD_CSV_ERROR=NS+'UPLOAD_CSV_ERROR';

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='search';

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_PARTNER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_PARTNER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_PARTNER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_PARTNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VALIDATION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_PARTNER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_PARTNER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_PARTNER_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(236);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var SAVE_PARTNER_REQUEST=NS+'SAVE_PARTNER_REQUEST';var SAVE_PARTNER_SUCCESS=NS+'SAVE_PARTNER_SUCCESS';var SAVE_PARTNER_ERROR=NS+'SAVE_PARTNER_ERROR';var EDIT_PARTNER=NS+'EDIT_PARTNER';var VALIDATION_LIST=NS+'VALIDATION_LIST';var CLEAR_STATE=NS+'CLEAR_STATE';var FIND_PARTNER_REQUEST=NS+'FIND_PARTNER_REQUEST';var FIND_PARTNER_SUCCESS=NS+'FIND_PARTNER_SUCCESS';var FIND_PARTNER_ERROR=NS+'FIND_PARTNER_ERROR';

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_BAR_CODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(240);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_BAR_CODE=NS+'CHANGE_BAR_CODE';

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PROCESS_INSTANCE_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FIND_PROCESS_INSTANCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FIND_PROCESS_INSTANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FIND_PROCESS_INSTANCE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TOGGLE_PROCESS_FLOW_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return TOGGLE_VIP_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TOGGLE_VIP_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TOGGLE_VIP_STATUS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TOGGLE_RUSH_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TOGGLE_RUSH_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TOGGLE_RUSH_STATUS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_PROCESS_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMMENT_PROCESS_INSTANCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMMENT_PROCESS_INSTANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMMENT_PROCESS_INSTANCE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_PROCESS_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAVE_PROCESS_CONTEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SAVE_PROCESS_CONTEXT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SAVE_PROCESS_CONTEXT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_VALIDATION_MESSAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FIRE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FIRE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FIRE_EVENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHANGE_TIME_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHANGE_TIME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_TIME_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_BEAM_PROCESS_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BEAM_PROCESS_INSTANCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BEAM_PROCESS_INSTANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BEAM_PROCESS_INSTANCE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(241);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var PROCESS_INSTANCE_LOADED=NS+'PROCESS_INSTANCE_LOADED';var FIND_PROCESS_INSTANCE_REQUEST=NS+'FIND_PROCESS_INSTANCE_REQUEST';var FIND_PROCESS_INSTANCE_SUCCESS=NS+'FIND_PROCESS_INSTANCE_SUCCESS';var FIND_PROCESS_INSTANCE_ERROR=NS+'FIND_PROCESS_INSTANCE_ERROR';var TOGGLE_PROCESS_FLOW_VISIBILITY=NS+'TOGGLE_PROCESS_FLOW_VISIBILITY';var TOGGLE_VIP_STATUS_REQUEST=NS+'TOGGLE_VIP_STATUS_REQUEST';var TOGGLE_VIP_STATUS_SUCCESS=NS+'TOGGLE_VIP_STATUS_SUCCESS';var TOGGLE_VIP_STATUS_ERROR=NS+'TOGGLE_VIP_STATUS_ERROR';var TOGGLE_RUSH_STATUS_REQUEST=NS+'TOGGLE_RUSH_STATUS_REQUEST';var TOGGLE_RUSH_STATUS_SUCCESS=NS+'TOGGLE_RUSH_STATUS_SUCCESS';var TOGGLE_RUSH_STATUS_ERROR=NS+'TOGGLE_RUSH_STATUS_ERROR';var CHANGE_PROCESS_COMMENT=NS+'CHANGE_PROCESS_COMMENT';var COMMENT_PROCESS_INSTANCE_REQUEST=NS+'COMMENT_PROCESS_INSTANCE_REQUEST';var COMMENT_PROCESS_INSTANCE_SUCCESS=NS+'COMMENT_PROCESS_INSTANCE_SUCCESS';var COMMENT_PROCESS_INSTANCE_ERROR=NS+'COMMENT_PROCESS_INSTANCE_ERROR';var CHANGE_PROCESS_CONTEXT=NS+'CHANGE_PROCESS_CONTEXT';var SAVE_PROCESS_CONTEXT_REQUEST=NS+'SAVE_PROCESS_CONTEXT_REQUEST';var SAVE_PROCESS_CONTEXT_SUCCESS=NS+'SAVE_PROCESS_CONTEXT_SUCCESS';var SAVE_PROCESS_CONTEXT_ERROR=NS+'SAVE_PROCESS_CONTEXT_ERROR';var SET_VALIDATION_MESSAGE_LIST=NS+'SET_VALIDATION_MESSAGE_LIST';var FIRE_EVENT_REQUEST=NS+'FIRE_EVENT_REQUEST';var FIRE_EVENT_SUCCESS=NS+'FIRE_EVENT_SUCCESS';var FIRE_EVENT_ERROR=NS+'FIRE_EVENT_ERROR';var CHANGE_TIME_REQUEST=NS+'CHANGE_TIME_REQUEST';var CHANGE_TIME_SUCCESS=NS+'CHANGE_TIME_SUCCESS';var CHANGE_TIME_ERROR=NS+'CHANGE_TIME_ERROR';var CHANGE_BEAM_PROCESS_STATE=NS+'CHANGE_BEAM_PROCESS_STATE';var BEAM_PROCESS_INSTANCE_REQUEST=NS+'BEAM_PROCESS_INSTANCE_REQUEST';var BEAM_PROCESS_INSTANCE_SUCCESS=NS+'BEAM_PROCESS_INSTANCE_SUCCESS';var BEAM_PROCESS_INSTANCE_ERROR=NS+'BEAM_PROCESS_INSTANCE_ERROR';

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_STATE_RESPONSIBLE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_STATE_RESPONSIBLE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_STATE_RESPONSIBLE_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_STATE_RESPONSIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_STATE_RESPONSIBLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_STATE_RESPONSIBLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_STATE_RESPONSIBLE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(131);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FIND_STATE_RESPONSIBLE_LIST_REQUEST=NS+'FIND_STATE_RESPONSIBLE_LIST_REQUEST';var FIND_STATE_RESPONSIBLE_LIST_SUCCESS=NS+'FIND_STATE_RESPONSIBLE_LIST_SUCCESS';var FIND_STATE_RESPONSIBLE_LIST_ERROR=NS+'FIND_STATE_RESPONSIBLE_LIST_ERROR';var CHANGE_STATE_RESPONSIBLE=NS+'CHANGE_STATE_RESPONSIBLE';var SAVE_STATE_RESPONSIBLE_REQUEST=NS+'SAVE_STATE_RESPONSIBLE_REQUEST';var SAVE_STATE_RESPONSIBLE_SUCCESS=NS+'SAVE_STATE_RESPONSIBLE_SUCCESS';var SAVE_STATE_RESPONSIBLE_ERROR=NS+'SAVE_STATE_RESPONSIBLE_ERROR';

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelectValueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelectValue; });
var createSelectValueList=function createSelectValueList(itemList){return itemList.map(function(item){return{id:item,value:item};});};var getSelectValue=function getSelectValue(itemList,_id){if(!itemList){return'';}var item=itemList.find(function(_ref){var id=_ref.id;return id===_id;});return item?item.value:'';};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_TASK_DEFINITION_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_TASK_DEFINITION_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_TASK_DEFINITION_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TASK_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_TASK_DEFINITION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_TASK_DEFINITION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_TASK_DEFINITION_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(160);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["c" /* REDUCER_NAME */]+'/';var FIND_TASK_DEFINITION_LIST_REQUEST=NS+'FIND_TASK_DEFINITION_LIST_REQUEST';var FIND_TASK_DEFINITION_LIST_SUCCESS=NS+'FIND_TASK_DEFINITION_LIST_SUCCESS';var FIND_TASK_DEFINITION_LIST_ERROR=NS+'FIND_TASK_DEFINITION_LIST_ERROR';var CHANGE_TASK_DEFINITION=NS+'CHANGE_TASK_DEFINITION';var SAVE_TASK_DEFINITION_REQUEST=NS+'SAVE_TASK_DEFINITION_REQUEST';var SAVE_TASK_DEFINITION_SUCCESS=NS+'SAVE_TASK_DEFINITION_SUCCESS';var SAVE_TASK_DEFINITION_ERROR=NS+'SAVE_TASK_DEFINITION_ERROR';

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FIND_TASK_DETAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FIND_TASK_DETAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FIND_TASK_DETAIL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_VALIDATION_MESSAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TOGGLE_PROCESS_FLOW_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_DUE_DATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_DUE_DATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_DUE_DATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_TASK_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_TASK_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_TASK_STATUS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TRIGGER_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TRIGGER_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TRIGGER_EVENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLAIM_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLAIM_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLAIM_TASK_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UN_CLAIM_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UN_CLAIM_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UN_CLAIM_TASK_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_ASSIGNED_TO_USER_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_ASSIGNED_TO_USER_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_ASSIGNED_TO_USER_ID_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PROCESS_TASK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(242);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FIND_TASK_DETAIL_REQUEST=NS+'FIND_TASK_DETAIL_REQUEST';var FIND_TASK_DETAIL_SUCCESS=NS+'FIND_TASK_DETAIL_SUCCESS';var FIND_TASK_DETAIL_ERROR=NS+'FIND_TASK_DETAIL_ERROR';var UPDATE_VALIDATION_MESSAGE_LIST=NS+'UPDATE_VALIDATION_MESSAGE_LIST';var TOGGLE_PROCESS_FLOW_VISIBILITY=NS+'TOGGLE_PROCESS_FLOW_VISIBILITY';var CHANGE_DUE_DATE_REQUEST=NS+'CHANGE_DUE_DATE_REQUEST';var CHANGE_DUE_DATE_SUCCESS=NS+'CHANGE_DUE_DATE_SUCCESS';var CHANGE_DUE_DATE_ERROR=NS+'CHANGE_DUE_DATE_ERROR';var CHANGE_TASK_STATUS_REQUEST=NS+'CHANGE_TASK_STATUS_REQUEST';var CHANGE_TASK_STATUS_SUCCESS=NS+'CHANGE_TASK_STATUS_SUCCESS';var CHANGE_TASK_STATUS_ERROR=NS+'CHANGE_TASK_STATUS_ERROR';var TRIGGER_EVENT_REQUEST=NS+'TRIGGER_EVENT_REQUEST';var TRIGGER_EVENT_SUCCESS=NS+'TRIGGER_EVENT_SUCCESS';var TRIGGER_EVENT_ERROR=NS+'TRIGGER_EVENT_ERROR';var TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK=NS+'TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK';var CLAIM_TASK_REQUEST=NS+'CLAIM_TASK_REQUEST';var CLAIM_TASK_SUCCESS=NS+'CLAIM_TASK_SUCCESS';var CLAIM_TASK_ERROR=NS+'CLAIM_TASK_ERROR';var UN_CLAIM_TASK_REQUEST=NS+'UN_CLAIM_TASK_REQUEST';var UN_CLAIM_TASK_SUCCESS=NS+'UN_CLAIM_TASK_SUCCESS';var UN_CLAIM_TASK_ERROR=NS+'UN_CLAIM_TASK_ERROR';var UPDATE_ASSIGNED_TO_USER_ID_REQUEST=NS+'UPDATE_ASSIGNED_TO_USER_ID_REQUEST';var UPDATE_ASSIGNED_TO_USER_ID_SUCCESS=NS+'UPDATE_ASSIGNED_TO_USER_ID_SUCCESS';var UPDATE_ASSIGNED_TO_USER_ID_ERROR=NS+'UPDATE_ASSIGNED_TO_USER_ID_ERROR';var CHANGE_PROCESS_TASK=NS+'CHANGE_PROCESS_TASK';

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_VERSION_SUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_VERSION_SUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_VERSION_SUMMARY_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(244);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var GET_VERSION_SUMMARY_REQUEST=NS+'GET_VERSION_SUMMARY_REQUEST';var GET_VERSION_SUMMARY_SUCCESS=NS+'GET_VERSION_SUMMARY_SUCCESS';var GET_VERSION_SUMMARY_ERROR=NS+'GET_VERSION_SUMMARY_ERROR';

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_PROSPECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_PROSPECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_PROSPECT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PROSPECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_PROSPECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_PROSPECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_PROSPECT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARCHIVE_PROSPECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARCHIVE_PROSPECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARCHIVE_PROSPECT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NO_SHOW_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NO_SHOW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NO_SHOW_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return START_IN_SHOP_PROCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return START_IN_SHOP_PROCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return START_IN_SHOP_PROCESS_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(245);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var FIND_PROSPECT_REQUEST=NS+'FIND_PROSPECT_REQUEST';var FIND_PROSPECT_SUCCESS=NS+'FIND_PROSPECT_SUCCESS';var FIND_PROSPECT_ERROR=NS+'FIND_PROSPECT_ERROR';var CHANGE_PROSPECT=NS+'CHANGE_PROSPECT';var SAVE_PROSPECT_REQUEST=NS+'SAVE_PROSPECT_REQUEST';var SAVE_PROSPECT_SUCCESS=NS+'SAVE_PROSPECT_SUCCESS';var SAVE_PROSPECT_ERROR=NS+'SAVE_PROSPECT_ERROR';var ARCHIVE_PROSPECT_REQUEST=NS+'ARCHIVE_PROSPECT_REQUEST';var ARCHIVE_PROSPECT_SUCCESS=NS+'ARCHIVE_PROSPECT_SUCCESS';var ARCHIVE_PROSPECT_ERROR=NS+'ARCHIVE_PROSPECT_ERROR';var NO_SHOW_REQUEST=NS+'NO_SHOW_REQUEST';var NO_SHOW_SUCCESS=NS+'NO_SHOW_SUCCESS';var NO_SHOW_ERROR=NS+'NO_SHOW_ERROR';var START_IN_SHOP_PROCESS_REQUEST=NS+'START_IN_SHOP_PROCESS_REQUEST';var START_IN_SHOP_PROCESS_SUCCESS=NS+'START_IN_SHOP_PROCESS_SUCCESS';var START_IN_SHOP_PROCESS_ERROR=NS+'START_IN_SHOP_PROCESS_ERROR';

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_REFINEMENT_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_REFINEMENT_REASON_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_REFINEMENT_REASON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_REFINEMENT_REASON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_REFINEMENT_REASON_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_REFINEMENT_REASON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_REFINEMENT_REASON_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(247);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_REFINEMENT_REASON=NS+'CHANGE_REFINEMENT_REASON';var GET_REFINEMENT_REASON_REQUEST=NS+'GET_REFINEMENT_REASON_REQUEST';var GET_REFINEMENT_REASON_SUCCESS=NS+'GET_REFINEMENT_REASON_SUCCESS';var GET_REFINEMENT_REASON_ERROR=NS+'GET_REFINEMENT_REASON__ERROR';var SAVE_REFINEMENT_REASON_REQUEST=NS+'SAVE_REFINEMENT_REASON_REQUEST';var SAVE_REFINEMENT_REASON_SUCCESS=NS+'SAVE_REFINEMENT_REASON_SUCCESS';var SAVE_REFINEMENT_REASON_ERROR=NS+'SAVE_REFINEMENT_REASON__ERROR';

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TYPE_SET */
/* unused harmony export TYPE_TREATMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAYMENT_METHOD_CREDIT_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAYMENT_METHOD_PREPAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAYMENT_METHOD_KLARNA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PAYMENT_METHOD_SEPA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAYMENT_METHOD_PAYPAL_RATE_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAYMENT_METHOD_PAYPAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAYMENT_METHOD_PLEDG_RATE_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAYMENT_METHOD_CHRYSALIS_RATE_PAY; });
var TYPE_SET='type_set';var TYPE_TREATMENT='type_treatment';var PAYMENT_METHOD_CREDIT_CARD='credit_card';var PAYMENT_METHOD_PREPAYMENT='prepayment';var PAYMENT_METHOD_KLARNA='klarna';var PAYMENT_METHOD_SEPA='sepa';var PAYMENT_METHOD_PAYPAL_RATE_PAY='paypal_ratepay';var PAYMENT_METHOD_PAYPAL='paypal';var PAYMENT_METHOD_PLEDG_RATE_PAY='pledg_ratepay';var PAYMENT_METHOD_CHRYSALIS_RATE_PAY='chrysalis_ratepay';

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FIND_SALES_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FIND_SALES_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_SALES_ORDER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_SALES_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SAVE_SALES_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SAVE_SALES_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAVE_SALES_ORDER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_SALES_ORDER_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_SALES_ORDER_CUSTOMER_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_SALES_ORDER_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_SALES_ORDER_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_SALES_ORDER_CUSTOMER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SHIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_SENT_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_INVOICE; });
/* unused harmony export ADD_LOW_NPS_REASON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HYDRATE_SALESORDER_CUSTOMER_CONTACT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(248);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var FIND_SALES_ORDER_REQUEST=NS+'FIND_SALES_ORDER_REQUEST';var FIND_SALES_ORDER_SUCCESS=NS+'FIND_SALES_ORDER_SUCCESS';var FIND_SALES_ORDER_ERROR=NS+'FIND_SALES_ORDER_ERROR';var CHANGE_SALES_ORDER=NS+'CHANGE_SALES_ORDER';var SAVE_SALES_ORDER_REQUEST=NS+'SAVE_SALES_ORDER_REQUEST';var SAVE_SALES_ORDER_SUCCESS=NS+'SAVE_SALES_ORDER_SUCCESS';var SAVE_SALES_ORDER_ERROR=NS+'SAVE_SALES_ORDER_ERROR';var CHANGE_SALES_ORDER_CUSTOMER=NS+'CHANGE_SALES_ORDER_CUSTOMER';var CHANGE_SALES_ORDER_CUSTOMER_CONTACT=NS+'CHANGE_SALES_ORDER_CUSTOMER_CONTACT';var SAVE_SALES_ORDER_CUSTOMER_REQUEST=NS+'SAVE_SALES_ORDER_CUSTOMER_REQUEST';var SAVE_SALES_ORDER_CUSTOMER_SUCCESS=NS+'SAVE_SALES_ORDER_CUSTOMER_SUCCESS';var SAVE_SALES_ORDER_CUSTOMER_ERROR=NS+'SAVE_SALES_ORDER_CUSTOMER_ERROR';var ADD_SHIPMENT=NS+'ADD_SHIPMENT';var ADD_SENT_EMAIL=NS+'ADD_SENT_EMAIL';var ADD_INVOICE=NS+'ADD_INVOICE';var ADD_LOW_NPS_REASON=NS+'ADD_LOW_NPS_REASON';var HYDRATE_SALESORDER_CUSTOMER_CONTACT=NS+'HYDRATE_SALESORDER_CUSTOMER_CONTACT';

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='search';

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FIND_ALL_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FIND_ALL_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FIND_ALL_USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_CURRENT_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TOGGLE_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TOGGLE_WIDGET_ACCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_EMPLOYEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_EXTERNAL_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_EXTERNAL_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SAVE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SAVE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SAVE_USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GENERATE_NEW_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GENERATE_NEW_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GENERATE_NEW_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_USER_VALIDATION_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FIND_ALL_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FIND_ALL_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FIND_ALL_ROLE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_CURRENT_ROLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SAVE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAVE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SAVE_ROLE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TOGGLE_ROLE_WIDGET_ACCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(157);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var FIND_ALL_USER_REQUEST=NS+'FIND_ALL_USER_REQUEST';var FIND_ALL_USER_SUCCESS=NS+'FIND_ALL_USER_SUCCESS';var FIND_ALL_USER_ERROR=NS+'FIND_ALL_USER_ERROR';var CHANGE_CURRENT_USER_ID=NS+'CHANGE_CURRENT_USER_ID';var CHANGE_USER=NS+'CHANGE_USER';var TOGGLE_ROLE=NS+'TOGGLE_ROLE';var TOGGLE_WIDGET_ACCESS=NS+'TOGGLE_WIDGET_ACCESS';var CREATE_EMPLOYEE=NS+'CREATE_EMPLOYEE';var CREATE_EXTERNAL_USER=NS+'CREATE_EXTERNAL_USER';var CHANGE_EXTERNAL_USER=NS+'CHANGE_EXTERNAL_USER';var SAVE_USER_REQUEST=NS+'SAVE_USER_REQUEST';var SAVE_USER_SUCCESS=NS+'SAVE_USER_SUCCESS';var SAVE_USER_ERROR=NS+'SAVE_USER_ERROR';var GENERATE_NEW_PASSWORD_REQUEST=NS+'GENERATE_NEW_PASSWORD_REQUEST';var GENERATE_NEW_PASSWORD_SUCCESS=NS+'GENERATE_NEW_PASSWORD_SUCCESS';var GENERATE_NEW_PASSWORD_ERROR=NS+'GENERATE_NEW_PASSWORD_ERROR';var CREATE_USER_REQUEST=NS+'CREATE_USER_REQUEST';var CREATE_USER_SUCCESS=NS+'CREATE_USER_SUCCESS';var CREATE_USER_ERROR=NS+'CREATE_USER_ERROR';var SET_USER_VALIDATION_RESULT=NS+'SET_USER_VALIDATION_RESULT';var FIND_ALL_ROLE_REQUEST=NS+'FIND_ALL_ROLE_REQUEST';var FIND_ALL_ROLE_SUCCESS=NS+'FIND_ALL_ROLE_SUCCESS';var FIND_ALL_ROLE_ERROR=NS+'FIND_ALL_ROLE_ERROR';var CHANGE_CURRENT_ROLE_ID=NS+'CHANGE_CURRENT_ROLE_ID';var SAVE_ROLE_REQUEST=NS+'SAVE_ROLE_REQUEST';var SAVE_ROLE_SUCCESS=NS+'SAVE_ROLE_SUCCESS';var SAVE_ROLE_ERROR=NS+'SAVE_ROLE_ERROR';var TOGGLE_ROLE_WIDGET_ACCESS=NS+'TOGGLE_ROLE_WIDGET_ACCESS';

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='search';

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_STORE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_STORE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_STORE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VALIDATION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_STORE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_STORE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_STORE_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(253);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var SAVE_STORE_REQUEST=NS+'SAVE_STORE_REQUEST';var SAVE_STORE_SUCCESS=NS+'SAVE_STORE_SUCCESS';var SAVE_STORE_ERROR=NS+'SAVE_STORE_ERROR';var EDIT_STORE=NS+'EDIT_STORE';var VALIDATION_LIST=NS+'VALIDATION_LIST';var CLEAR_STATE=NS+'CLEAR_STATE';var FIND_STORE_REQUEST=NS+'FIND_STORE_REQUEST';var FIND_STORE_SUCCESS=NS+'FIND_STORE_SUCCESS';var FIND_STORE_ERROR=NS+'FIND_STORE_ERROR';

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDUCER_NAME; });
var REDUCER_NAME='three-shape';

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_UNASSIGNED_CASE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_UNASSIGNED_CASE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIND_UNASSIGNED_CASE_LIST_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(254);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var FIND_UNASSIGNED_CASE_LIST_REQUEST=NS+'FIND_UNASSIGNED_CASE_LIST_REQUEST';var FIND_UNASSIGNED_CASE_LIST_SUCCESS=NS+'FIND_UNASSIGNED_CASE_LIST_SUCCESS';var FIND_UNASSIGNED_CASE_LIST_ERROR=NS+'FIND_UNASSIGNED_CASE_LIST_ERROR';

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TREATMENT_PLAN_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_TREATMENT_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_SEGMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_TREATMENT_PLAN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_TREATMENT_PLAN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_TREATMENT_PLAN_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(101);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["f" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["m" /* REDUCER_NAME */]+'/';var TREATMENT_PLAN_LOADED=NS+'TREATMENT_PLAN_LOADED';var CHANGE_TREATMENT_PLAN=NS+'CHANGE_TREATMENT_PLAN';var CHANGE_SEGMENT=NS+'CHANGE_SEGMENT';var SAVE_TREATMENT_PLAN_REQUEST=NS+'SAVE_TREATMENT_PLAN_REQUEST';var SAVE_TREATMENT_PLAN_SUCCESS=NS+'SAVE_TREATMENT_PLAN_SUCCESS';var SAVE_TREATMENT_PLAN_ERROR=NS+'SAVE_TREATMENT_PLAN_ERROR';

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DEFAULT_LANGUAGE='DE';var LOCALISED_ENHANCED_TEXT_MAP={DE:{m:'Herr',f:'Frau'},AT:{m:'Herr',f:'Frau'},CH:{m:'Herr',f:'Frau'},GB:{m:'Mr.',f:'Mrs.'}};var getLocalisedEnhancedText=function getLocalisedEnhancedText(language,text){return LOCALISED_ENHANCED_TEXT_MAP[language]?LOCALISED_ENHANCED_TEXT_MAP[language][text]:LOCALISED_ENHANCED_TEXT_MAP[DEFAULT_LANGUAGE][text];};/* harmony default export */ __webpack_exports__["a"] = (function(){var texts=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var textsWithUppercasedKeys=Object.keys(texts).reduce(function(obj,nextKey){obj[nextKey.toUpperCase()]=texts[nextKey];return obj;},{});return function(){var language=arguments.length>0&&arguments[0]!==undefined?arguments[0]:DEFAULT_LANGUAGE;var replacements=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var languageUpperCase=(language||DEFAULT_LANGUAGE).toUpperCase();var baseText=textsWithUppercasedKeys[languageUpperCase]||textsWithUppercasedKeys[DEFAULT_LANGUAGE];return injectValues(baseText,replacements,language).trim();};});var injectValues=function injectValues(text){var replacements=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var language=arguments[2];var output=text;for(var key in replacements){var replacedText=getLocalisedEnhancedText(language,replacements[key])||replacements[key];output=output.replace(new RegExp('\\$'+key,'g'),replacedText);}return output;};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROCESS_TASK_CUSTOMER_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CUSTOMER_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_TREATMENT_QUOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TREATMENT_PACKAGE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_TREATMENT_QUOTATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_TREATMENT_QUOTATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_TREATMENT_QUOTATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPEN_PREVIEW_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_PREVIEW_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPLOAD_SCAN_VIDEO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPLOAD_SCAN_VIDEO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPLOAD_SCAN_VIDEO_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_EDITABLE_FOR_USER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(101);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["f" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["k" /* REDUCER_NAME */]+'/';var PROCESS_TASK_CUSTOMER_LOADED=NS+'PROCESS_TASK_CUSTOMER_LOADED';var CUSTOMER_LOADED=NS+'CUSTOMER_LOADED';var FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST=NS+'FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST';var FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS=NS+'FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS';var FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR=NS+'FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR';var CHANGE_TREATMENT_QUOTATION=NS+'CHANGE_TREATMENT_QUOTATION';var CHANGE_TREATMENT_PACKAGE_PRICE=NS+'CHANGE_TREATMENT_PACKAGE_PRICE';var SAVE_TREATMENT_QUOTATION_REQUEST=NS+'SAVE_TREATMENT_QUOTATION_REQUEST';var SAVE_TREATMENT_QUOTATION_SUCCESS=NS+'SAVE_TREATMENT_QUOTATION_SUCCESS';var SAVE_TREATMENT_QUOTATION_ERROR=NS+'SAVE_TREATMENT_QUOTATION_ERROR';var OPEN_PREVIEW_MODAL=NS+'OPEN_PREVIEW_MODAL';var CLOSE_PREVIEW_MODAL=NS+'CLOSE_PREVIEW_MODAL';var UPLOAD_SCAN_VIDEO_REQUEST=NS+'UPLOAD_SCAN_VIDEO_REQUEST';var UPLOAD_SCAN_VIDEO_SUCCESS=NS+'UPLOAD_SCAN_VIDEO_SUCCESS';var UPLOAD_SCAN_VIDEO_ERROR=NS+'UPLOAD_SCAN_VIDEO_ERROR';var SET_EDITABLE_FOR_USER=NS+'SET_EDITABLE_FOR_USER';

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_REASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REASSIGN_TREATING_PHYSICIAN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REASSIGN_TREATING_PHYSICIAN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REASSIGN_TREATING_PHYSICIAN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REASSIGN_TO_PARTNER_PHYSICIAN_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(101);
var NS=__WEBPACK_IMPORTED_MODULE_1__const__["f" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]+'/';var CHANGE_REASSIGNMENT=NS+'CHANGE_REASSIGNMENT';var REASSIGN_TREATING_PHYSICIAN_REQUEST=NS+'REASSIGN_TREATING_PHYSICIAN_REQUEST';var REASSIGN_TREATING_PHYSICIAN_SUCCESS=NS+'REASSIGN_TREATING_PHYSICIAN_SUCCESS';var REASSIGN_TREATING_PHYSICIAN_ERROR=NS+'REASSIGN_TREATING_PHYSICIAN_ERROR';var REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST=NS+'REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST';var REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS=NS+'REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS';var REASSIGN_TO_PARTNER_PHYSICIAN_ERROR=NS+'REASSIGN_TO_PARTNER_PHYSICIAN_ERROR';

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_LOW_NPS_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_LOW_NPS_REASON_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_LOW_NPS_REASON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_LOW_NPS_REASON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_FEEDBACK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_FEEDBACK_DETAILS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_FEEDBACK_DETAILS_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(255);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var TOGGLE_LOW_NPS_REASON=NS+'TOGGLE_LOW_NPS_REASON';var SAVE_LOW_NPS_REASON_REQUEST=NS+'SAVE_LOW_NPS_REASON_REQUEST    ';var SAVE_LOW_NPS_REASON_SUCCESS=NS+'SAVE_LOW_NPS_REASON_SUCCESS';var SAVE_LOW_NPS_REASON_ERROR=NS+'SAVE_LOW_NPS_REASON_ERROR';var GET_FEEDBACK_REQUEST=NS+'GET_FEEDBACK_REQUEST';var GET_FEEDBACK_DETAILS_SUCCESS=NS+'GET_FEEDBACK_DETAILS_SUCCESS';var GET_FEEDBACK_DETAILS_ERROR=NS+'GET_FEEDBACK_DETAILS_ERROR';

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_PARTIAL_REFUND_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_PARTIAL_REFUND_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_PARTIAL_REFUND_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_REFUNDABLE_SALES_ORDER_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_PARTIAL_REFUND_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_PARTIAL_REFUND_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_PARTIAL_REFUND_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_PARTIAL_REFUND_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_VALIDATION_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_VALIDATION_MESSAGE_LIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(256);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var GET_PARTIAL_REFUND_DATA_REQUEST=NS+'GET_PARTIAL_REFUND_DATA_REQUEST';var GET_PARTIAL_REFUND_DATA_SUCCESS=NS+'GET_PARTIAL_REFUND_DATA_SUCCESS';var GET_PARTIAL_REFUND_DATA_ERROR=NS+'GET_PARTIAL_REFUND_DATA_ERROR';var GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST=NS+'GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST';var GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS=NS+'GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS';var GET_REFUNDABLE_SALES_ORDER_LIST_ERROR=NS+'GET_REFUNDABLE_SALES_ORDER_LIST_ERROR';var SAVE_PARTIAL_REFUND_DATA_REQUEST=NS+'SAVE_PARTIAL_REFUND_DATA_REQUEST';var SAVE_PARTIAL_REFUND_DATA_SUCCESS=NS+'SAVE_PARTIAL_REFUND_DATA_SUCCESS';var SAVE_PARTIAL_REFUND_DATA_ERROR=NS+'SAVE_PARTIAL_REFUND_DATA_ERROR';var CHANGE_PARTIAL_REFUND_DATA=NS+'CHANGE_PARTIAL_REFUND_DATA';var ADD_VALIDATION_MESSAGE=NS+'ADD_VALIDATION_MESSAGE';var CLEAR_VALIDATION_MESSAGE_LIST=NS+'CLEAR_VALIDATION_MESSAGE_LIST';

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WHATSAPP_MESSAGES_TABLE */
/* unused harmony export WHATSAPP_DELIVERED_MESSAGE_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(257);
var WHATSAPP_MESSAGES_TABLE='freshchatWhatsappTable';var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var WHATSAPP_DELIVERED_MESSAGE_LIST=NS+'WHATSAPP_DELIVERED_MESSAGE_LIST';var FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST=NS+'FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST';var FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS=NS+'FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS';var FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR=NS+'FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR';

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(157);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectIsFetching; });
/* unused harmony export selectMonthList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateSetReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateTreatmentByOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateTreatmentByPayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__set_table__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treatment_by_order__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_by_payment__ = __webpack_require__(1013);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectMonthList=function selectMonthList(state){return selectOwnState(state).monthList;};var calculateSetReport=function calculateSetReport(state){var monthList=selectMonthList(state);return Object(__WEBPACK_IMPORTED_MODULE_2__set_table__["a" /* compileSetTable */])(monthList);};var calculateTreatmentByOrder=function calculateTreatmentByOrder(state){var monthList=selectMonthList(state);return Object(__WEBPACK_IMPORTED_MODULE_3__treatment_by_order__["a" /* compileTreatmentByOrder */])(monthList);};var calculateTreatmentByPayment=function calculateTreatmentByPayment(state){var monthList=selectMonthList(state);return Object(__WEBPACK_IMPORTED_MODULE_4__treatment_by_payment__["a" /* compileTreatmentByPayment */])(monthList);};

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3__ = __webpack_require__(20);



/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */
var adjust = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3__["a" /* default */])(function adjust(fn, idx, list) {
  if (idx >= list.length || idx < -list.length) {
    return list;
  }
  var start = idx < 0 ? list.length : 0;
  var _idx = start + idx;
  var _list = Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */])(list);
  _list[_idx] = fn(list[_idx]);
  return _list;
});
/* harmony default export */ __webpack_exports__["a"] = (adjust);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _xwrap;
var XWrap = /*#__PURE__*/function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap(fn) {
  return new XWrap(fn);
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
var bind = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function bind(fn, thisObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
/* harmony default export */ __webpack_exports__["a"] = (bind);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has__ = __webpack_require__(61);


var toString = Object.prototype.toString;
var _isArguments = function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__has__["a" /* default */])('callee', x);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (_isArguments);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */
var and = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function and(a, b) {
  return a && b;
});
/* harmony default export */ __webpack_exports__["a"] = (and);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xany__ = __webpack_require__(407);




/**
 * Returns `true` if at least one of elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      var lessThan0 = R.flip(R.lt)(0);
 *      var lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */
var any = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['any'], __WEBPACK_IMPORTED_MODULE_2__internal_xany__["a" /* default */], function any(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (fn(list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}));
/* harmony default export */ __webpack_exports__["a"] = (any);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XAny = /*#__PURE__*/function () {
  function XAny(f, xf) {
    this.xf = xf;
    this.f = f;
    this.any = false;
  }
  XAny.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XAny.prototype['@@transducer/result'] = function (result) {
    if (!this.any) {
      result = this.xf['@@transducer/step'](result, false);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAny.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.any = true;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced__["a" /* default */])(this.xf['@@transducer/step'](result, true));
    }
    return result;
  };

  return XAny;
}();

var _xany = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xany(f, xf) {
  return new XAny(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xany);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      var nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */
var apply = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function apply(fn, args) {
  return fn.apply(this, args);
});
/* harmony default export */ __webpack_exports__["a"] = (apply);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys__ = __webpack_require__(75);



/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */
var values = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function values(obj) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_1__keys__["a" /* default */])(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});
/* harmony default export */ __webpack_exports__["a"] = (values);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isInteger__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assoc__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isNil__ = __webpack_require__(411);







/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */
var assocPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function assocPath(path, val, obj) {
  if (path.length === 0) {
    return val;
  }
  var idx = path[0];
  if (path.length > 1) {
    var nextObj = !Object(__WEBPACK_IMPORTED_MODULE_5__isNil__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(idx, obj) ? obj[idx] : Object(__WEBPACK_IMPORTED_MODULE_3__internal_isInteger__["a" /* default */])(path[1]) ? [] : {};
    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__internal_isInteger__["a" /* default */])(idx) && Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray__["a" /* default */])(obj)) {
    var arr = [].concat(obj);
    arr[idx] = val;
    return arr;
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_4__assoc__["a" /* default */])(idx, val, obj);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (assocPath);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
var isNil = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function isNil(x) {
  return x == null;
});
/* harmony default export */ __webpack_exports__["a"] = (isNil);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ap__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__(62);






/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
var liftN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function liftN(arity, fn) {
  var lifted = Object(__WEBPACK_IMPORTED_MODULE_3__curryN__["a" /* default */])(arity, fn);
  return Object(__WEBPACK_IMPORTED_MODULE_3__curryN__["a" /* default */])(arity, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__internal_reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__ap__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* default */])(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});
/* harmony default export */ __webpack_exports__["a"] = (liftN);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _makeFlat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike__ = __webpack_require__(170);


/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike__["a" /* default */])(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneRegExp__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(266);



/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */
function _clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx + 1] = value;
    refTo[idx + 1] = copiedValue;
    for (var key in value) {
      copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
    }
    return copiedValue;
  };
  switch (Object(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* default */])(value)) {
    case 'Object':
      return copy({});
    case 'Array':
      return copy([]);
    case 'Date':
      return new Date(value.valueOf());
    case 'RegExp':
      return Object(__WEBPACK_IMPORTED_MODULE_0__cloneRegExp__["a" /* default */])(value);
    default:
      return value;
  }
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _cloneRegExp;
function _cloneRegExp(pattern) {
                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
var not = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function not(a) {
  return !a;
});
/* harmony default export */ __webpack_exports__["a"] = (not);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_pipe__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tail__ = __webpack_require__(268);





/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(arguments[0].length, Object(__WEBPACK_IMPORTED_MODULE_2__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_pipe__["a" /* default */], arguments[0], Object(__WEBPACK_IMPORTED_MODULE_3__tail__["a" /* default */])(arguments)));
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = composeK;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chain__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(62);




/**
 * Returns the right-to-left Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipeK
 * @example
 *
 *       //  get :: String -> Object -> Maybe *
 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
 *
 *       //  getStateCode :: Maybe String -> Maybe String
 *       var getStateCode = R.composeK(
 *         R.compose(Maybe.of, R.toUpper),
 *         get('state'),
 *         get('address'),
 *         get('user'),
 *       );
 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
 *       getStateCode({}); //=> Maybe.Nothing()
 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
 */
function composeK() {
  if (arguments.length === 0) {
    throw new Error('composeK requires at least one argument');
  }
  var init = Array.prototype.slice.call(arguments);
  var last = init.pop();
  return Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_2__map__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__chain__["a" /* default */], init)), last);
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipeP;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_pipeP__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tail__ = __webpack_require__(268);





/**
 * Performs left-to-right composition of one or more Promise-returning
 * functions. The leftmost function may have any arity; the remaining functions
 * must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeP
 * @example
 *
 *      //  followersForUser :: String -> Promise [User]
 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
 */
function pipeP() {
  if (arguments.length === 0) {
    throw new Error('pipeP requires at least one argument');
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(arguments[0].length, Object(__WEBPACK_IMPORTED_MODULE_2__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_pipeP__["a" /* default */], arguments[0], Object(__WEBPACK_IMPORTED_MODULE_3__tail__["a" /* default */])(arguments)));
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _indexOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__equals__ = __webpack_require__(67);


function _indexOf(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__equals__["a" /* default */])(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
var identical = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function identical(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});
/* harmony default export */ __webpack_exports__["a"] = (identical);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _complement;
function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nAry__ = __webpack_require__(172);




/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        var instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      var ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */
var constructN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function constructN(n, Fn) {
  if (n > 10) {
    throw new Error('Constructor with greater than ten arguments');
  }
  if (n === 0) {
    return function () {
      return new Fn();
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__curry__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__nAry__["a" /* default */])(n, function ($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
    switch (arguments.length) {
      case 1:
        return new Fn($0);
      case 2:
        return new Fn($0, $1);
      case 3:
        return new Fn($0, $1, $2);
      case 4:
        return new Fn($0, $1, $2, $3);
      case 5:
        return new Fn($0, $1, $2, $3, $4);
      case 6:
        return new Fn($0, $1, $2, $3, $4, $5);
      case 7:
        return new Fn($0, $1, $2, $3, $4, $5, $6);
      case 8:
        return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
      case 9:
        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
      case 10:
        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
    }
  }));
});
/* harmony default export */ __webpack_exports__["a"] = (constructN);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_map__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__max__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pluck__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reduce__ = __webpack_require__(76);







/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
var converge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function converge(after, fns) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__max__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_4__pluck__["a" /* default */])('length', fns)), function () {
    var args = arguments;
    var context = this;
    return after.apply(context, Object(__WEBPACK_IMPORTED_MODULE_1__internal_map__["a" /* default */])(function (fn) {
      return fn.apply(context, args);
    }, fns));
  });
});
/* harmony default export */ __webpack_exports__["a"] = (converge);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      var defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */
var defaultTo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function defaultTo(d, v) {
  return v == null || v !== v ? d : v;
});
/* harmony default export */ __webpack_exports__["a"] = (defaultTo);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */
var difference = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function difference(first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__internal_contains__["a" /* default */])(first[idx], second) && !Object(__WEBPACK_IMPORTED_MODULE_0__internal_contains__["a" /* default */])(first[idx], out)) {
      out[out.length] = first[idx];
    }
    idx += 1;
  }
  return out;
});
/* harmony default export */ __webpack_exports__["a"] = (difference);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_containsWith__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3__ = __webpack_require__(20);



/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      var cmp = (x, y) => x.a === y.a;
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      var l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */
var differenceWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3__["a" /* default */])(function differenceWith(pred, first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__internal_containsWith__["a" /* default */])(pred, first[idx], second) && !Object(__WEBPACK_IMPORTED_MODULE_0__internal_containsWith__["a" /* default */])(pred, first[idx], out)) {
      out.push(first[idx]);
    }
    idx += 1;
  }
  return out;
});
/* harmony default export */ __webpack_exports__["a"] = (differenceWith);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
var dissoc = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (dissoc);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */
var remove = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function remove(start, count, list) {
  var result = Array.prototype.slice.call(list, 0);
  result.splice(start, count);
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (remove);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdrop__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice__ = __webpack_require__(72);





/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */
var drop = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['drop'], __WEBPACK_IMPORTED_MODULE_2__internal_xdrop__["a" /* default */], function drop(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice__["a" /* default */])(Math.max(0, n), Infinity, xs);
}));
/* harmony default export */ __webpack_exports__["a"] = (drop);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XDropRepeatsWith = /*#__PURE__*/function () {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XDropRepeatsWith.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return XDropRepeatsWith;
}();

var _xdropRepeatsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xdropRepeatsWith(pred, xf) {
  return new XDropRepeatsWith(pred, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropRepeatsWith);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__last__ = __webpack_require__(433);





/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
var dropRepeatsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith__["a" /* default */], function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(Object(__WEBPACK_IMPORTED_MODULE_3__last__["a" /* default */])(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));
/* harmony default export */ __webpack_exports__["a"] = (dropRepeatsWith);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nth__ = __webpack_require__(137);


/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
var last = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__nth__["a" /* default */])(-1);
/* harmony default export */ __webpack_exports__["a"] = (last);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */
var or = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function or(a, b) {
  return a || b;
});
/* harmony default export */ __webpack_exports__["a"] = (or);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isArguments__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_isObject__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_isString__ = __webpack_require__(134);






/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */
var empty = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function empty(x) {
  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray__["a" /* default */])(x) ? [] : Object(__WEBPACK_IMPORTED_MODULE_4__internal_isString__["a" /* default */])(x) ? '' : Object(__WEBPACK_IMPORTED_MODULE_3__internal_isObject__["a" /* default */])(x) ? {} : Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArguments__["a" /* default */])(x) ? function () {
    return arguments;
  }() :
  // else
  void 0;
});
/* harmony default export */ __webpack_exports__["a"] = (empty);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drop__ = __webpack_require__(430);



/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */
var takeLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function takeLast(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__drop__["a" /* default */])(n >= 0 ? xs.length - n : 0, xs);
});
/* harmony default export */ __webpack_exports__["a"] = (takeLast);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_Set__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
var uniqBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function uniqBy(fn, list) {
  var set = new __WEBPACK_IMPORTED_MODULE_0__internal_Set__["a" /* default */]();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (uniqBy);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      var matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */
var objOf = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function objOf(key, val) {
  var obj = {};
  obj[key] = val;
  return obj;
});
/* harmony default export */ __webpack_exports__["a"] = (objOf);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */
var is = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function is(Ctor, val) {
  return val != null && val.constructor === Ctor || val instanceof Ctor;
});
/* harmony default export */ __webpack_exports__["a"] = (is);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__converge__ = __webpack_require__(424);



/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
var juxt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function juxt(fns) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__converge__["a" /* default */])(function () {
    return Array.prototype.slice.call(arguments, 0);
  }, fns);
});
/* harmony default export */ __webpack_exports__["a"] = (juxt);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isNumber__ = __webpack_require__(442);



/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */
var length = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function length(list) {
  return list != null && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isNumber__["a" /* default */])(list.length) ? list.length : NaN;
});
/* harmony default export */ __webpack_exports__["a"] = (length);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNumber;
function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sum__ = __webpack_require__(444);



/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */
var mean = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function mean(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__sum__["a" /* default */])(list) / list.length;
});
/* harmony default export */ __webpack_exports__["a"] = (mean);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce__ = __webpack_require__(76);



/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
var sum = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__add__["a" /* default */], 0);
/* harmony default export */ __webpack_exports__["a"] = (sum);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_has__ = __webpack_require__(61);




/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoizeWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function memoizeWith(mFn, fn) {
  var cache = {};
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(fn.length, function () {
    var key = mFn.apply(this, arguments);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__internal_has__["a" /* default */])(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});
/* harmony default export */ __webpack_exports__["a"] = (memoizeWith);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
var multiply = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function multiply(a, b) {
  return a * b;
});
/* harmony default export */ __webpack_exports__["a"] = (multiply);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


// `Identity` is a functor that holds a single value, where `map` simply
// transforms the held value with the provided function.
var Identity = function (x) {
  return { value: x, map: function (f) {
      return Identity(f(x));
    } };
};

/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */
var over = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function over(lens, f, x) {
  // The value returned by the getter function is first transformed with `f`,
  // then set as the value of an `Identity`. This is then mapped over with the
  // setter function of the lens.
  return lens(function (y) {
    return Identity(f(y));
  })(x).value;
});
/* harmony default export */ __webpack_exports__["a"] = (over);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createPartialApplicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry2__ = __webpack_require__(4);



function _createPartialApplicator(concat) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function (fn, args) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arity__["a" /* default */])(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
var pickAll = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (pickAll);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */
var prepend = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function prepend(el, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */])([el], list);
});
/* harmony default export */ __webpack_exports__["a"] = (prepend);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);



/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
var useWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function useWith(fn, transformers) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(transformers.length, function () {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});
/* harmony default export */ __webpack_exports__["a"] = (useWith);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */
var reduceRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function reduceRight(fn, acc, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    acc = fn(list[idx], acc);
    idx -= 1;
  }
  return acc;
});
/* harmony default export */ __webpack_exports__["a"] = (reduceRight);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
var times = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});
/* harmony default export */ __webpack_exports__["a"] = (times);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ap__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prepend__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduceRight__ = __webpack_require__(452);






/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */
var sequence = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function sequence(of, traversable) {
  return typeof traversable.sequence === 'function' ? traversable.sequence(of) : Object(__WEBPACK_IMPORTED_MODULE_4__reduceRight__["a" /* default */])(function (x, acc) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__ap__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__prepend__["a" /* default */], x), acc);
  }, of([]), traversable);
});
/* harmony default export */ __webpack_exports__["a"] = (sequence);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_containsWith__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      var strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */
var uniqWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;
  while (idx < len) {
    item = list[idx];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__internal_containsWith__["a" /* default */])(pred, item, result)) {
      result[result.length] = item;
    }
    idx += 1;
  }
  return result;
});
/* harmony default export */ __webpack_exports__["a"] = (uniqWith);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);



/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */
var where = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function where(spec, testObj) {
  for (var prop in spec) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(prop, spec) && !spec[prop](testObj[prop])) {
      return false;
    }
  }
  return true;
});
/* harmony default export */ __webpack_exports__["a"] = (where);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectLeadList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectLeadById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectHasChanged; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectLeadList=function selectLeadList(state){return selectOwnState(state).leadList;};var selectLeadById=function selectLeadById(state,leadId){var leadList=selectLeadList(state);return __WEBPACK_IMPORTED_MODULE_1_ramda__["c" /* find */](__WEBPACK_IMPORTED_MODULE_1_ramda__["i" /* propEq */]('id',leadId))(leadList);};var selectLead=function selectLead(state){return selectOwnState(state).lead;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(100);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["d" /* REDUCER_NAME */]];};

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectProspect; });
/* unused harmony export selectMedicalCondition */
/* unused harmony export selectTreatmentExpectation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProspectId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectHasChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsFetching; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(460);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectProspect=function selectProspect(state){return selectOwnState(state).prospect;};var selectMedicalCondition=function selectMedicalCondition(state){var prospect=selectProspect(state);return prospect?prospect.medicalCondition:null;};var selectTreatmentExpectation=function selectTreatmentExpectation(state){var prospect=selectProspect(state);return prospect?prospect.treatmentExpectation:null;};var selectProspectId=function selectProspectId(state){var prospect=selectProspect(state);return prospect?prospect.id:null;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(162);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProcessSelectList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStateSelectList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_util_names__ = __webpack_require__(25);
var getProcessSelectList=function getProcessSelectList(processStateNameList){var processNameList=[];__WEBPACK_IMPORTED_MODULE_0_ramda__["e" /* forEachObjIndexed */](function(value,key){processNameList.push({id:key,value:Object(__WEBPACK_IMPORTED_MODULE_1__process_util_names__["d" /* renderProcessName */])(key)});},processStateNameList);return processNameList;};var getStateSelectList=function getStateSelectList(processStateNameList,processName){var currentProcess=processStateNameList[processName];var stateNameList=[];if(currentProcess){__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(stateName){stateNameList.push({id:stateName,value:stateName});},currentProcess);}stateNameList.sort(function(a,b){if(a.id<b.id){return-1;}if(a.id>b.id){return 1;}return 0;});return stateNameList;};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(184),
    stackClear = __webpack_require__(1052),
    stackDelete = __webpack_require__(1053),
    stackGet = __webpack_require__(1054),
    stackHas = __webpack_require__(1055),
    stackSet = __webpack_require__(1056);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(140),
    isObject = __webpack_require__(141);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 467 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1075),
    arraySome = __webpack_require__(1078),
    cacheHas = __webpack_require__(1079);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1093),
    isObjectLike = __webpack_require__(142);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(79),
    stubFalse = __webpack_require__(1094);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(285)(module)))

/***/ }),
/* 471 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1095),
    baseUnary = __webpack_require__(1096),
    nodeUtil = __webpack_require__(1097);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(465),
    isLength = __webpack_require__(297);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(141);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(477),
    toKey = __webpack_require__(190);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(85),
    isKey = __webpack_require__(298),
    stringToPath = __webpack_require__(1124),
    toString = __webpack_require__(1127);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(1140);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(point);
}

function newDateWithOffset(utcOffset) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, dateFormat, locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date);
}

function isDate(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isOutOfBounds(day) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref6) {
  var minTime = _ref6.minTime,
      maxTime = _ref6.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = __WEBPACK_IMPORTED_MODULE_4_moment___default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref7.minDate,
      includeDates = _ref7.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref8.maxDate,
      includeDates = _ref8.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref9) {
  var minDate = _ref9.minDate,
      includeDates = _ref9.includeDates;

  if (includeDates && minDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref10) {
  var maxDate = _ref10.maxDate,
      includeDates = _ref10.includeDates;

  if (includeDates && maxDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdownOptions.propTypes = {
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  monthNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day)
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Day.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WeekNumber.propTypes = {
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          renderDayContents: _this.props.renderDayContents,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Week.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderDayContents: _this.props.renderDayContents
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox",
        "aria-label": "month-" + this.props.day.format("YYYY-MM")
      },
      this.renderWeeks()
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Month.propTypes = {
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM),
            ref: function ref(li) {
              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
                _this.centerLi = li;
              }
            }
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef && this.header) {
      height = this.props.monthRef.clientHeight - this.header.clientHeight;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--time",
          ref: function ref(header) {
            _this2.header = header;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Time.propTypes = {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  intervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  monthRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

Time.calcCenterPosition = function (listHeight, centerLiRef) {
  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$arrowProps = _ref.arrowProps,
      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({ className: "react-datepicker__triangle" }, arrowProps)),
    children
  );
}

CalendarContainer.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  arrowProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object // react-popper arrow props
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month"
      };
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderDefaultHeader = function (_ref) {
      var monthDate = _ref.monthDate,
          i = _ref.i;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__header" },
        _this.renderCurrentMonth(monthDate),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
            onFocus: _this.handleDropdownFocus
          },
          _this.renderMonthDropdown(i !== 0),
          _this.renderMonthYearDropdown(i !== 0),
          _this.renderYearDropdown(i !== 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderCustomHeader = function (_ref2) {
      var monthDate = _ref2.monthDate,
          i = _ref2.i;

      if (i !== 0) {
        return null;
      }

      var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: _this.props.onDropdownFocus
        },
        _this.props.renderCustomHeader(_extends({}, _this.state, {
          changeMonth: _this.changeMonth,
          changeYear: _this.changeYear,
          decreaseMonth: _this.decreaseMonth,
          increaseMonth: _this.increaseMonth,
          prevMonthButtonDisabled: prevMonthButtonDisabled,
          nextMonthButtonDisabled: nextMonthButtonDisabled
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          _this.props.renderCustomHeader ? _this.renderCustomHeader({ monthDate: monthDate, i: i }) : _this.renderDefaultHeader({ monthDate: monthDate, i: i }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset,
            renderDayContents: _this.props.renderDayContents,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: null
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Container,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]),
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDropdownFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  renderCustomHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        popperProps = _props.popperProps,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker-popper", className);
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */],
        _extends({
          modifiers: popperModifiers,
          placement: popperPlacement
        }, popperProps),
        function (_ref) {
          var ref = _ref.ref,
              style = _ref.style,
              placement = _ref.placement,
              arrowProps = _ref.arrowProps;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            _extends({ ref: ref, style: style }, {
              className: classes,
              "data-placement": placement
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(popperComponent, { arrowProps: arrowProps })
          );
        }
      );
    }

    if (this.props.popperContainer) {
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Reference */],
        null,
        function (_ref2) {
          var ref = _ref2.ref;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { ref: ref, className: "react-datepicker-wrapper" },
            targetComponent
          );
        }
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperProps: {},
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidePopper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  popperComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <datepicker/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  targetComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */
var INPUT_ERR_1 = "Date input not valid.";

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onInputClick: function onInputClick() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},
        onInputError: function onInputError() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month",
        renderDayContents: function renderDayContents(date) {
          return date;
        }
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setBlur = function () {
      if (_this.input && _this.input.blur) {
        _this.input.blur();
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }

      _this.cancelFocusInput();
    };

    _this.setOpen = function (open) {
      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      }, function () {
        if (!open) {
          _this.setState(function (prev) {
            return {
              focused: skipSetBlur ? prev.focused : false
            };
          }, function () {
            !skipSetBlur && _this.setBlur();

            _this.setState({ inputValue: null });
          });
        }
      });
    };

    _this.inputOk = function () {
      return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
    };

    _this.isCalendarOpen = function () {
      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        if (isOutOfBounds(changedDate, _this.props)) {
          _this.props.onChange(date, event);
          _this.props.onSelect(changedDate, event);
        }

        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      if (_this.props.shouldCloseOnSelect) {
        _this.setOpen(false);
      }
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }

      _this.props.onInputClick();
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();

        _this.setOpen(false);
        if (!_this.inputOk()) {
          _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
        }
      } else if (eventKey === "Tab") {
        _this.setOpen(false, true);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) {
          if (_this.props.onInputError) {
            _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
          }
          return; // Let the input component handle this keydown
        }
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && !_this.isCalendarOpen()) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderCustomHeader: _this.props.renderCustomHeader,
          popperProps: _this.props.popperProps,
          renderDayContents: _this.props.renderDayContents
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.isCalendarOpen(),
      popperModifiers: this.props.popperModifiers,
      targetComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement,
      popperProps: this.props.popperProps
    });
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowSameDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  calendarContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  customInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  dateFormatCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isClearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeRaw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // <PopperComponent/> props
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <PopperComponent/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  popperProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  preventOpenOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  startOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  shouldCloseOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearButtonTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  previousMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextMonthButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  renderCustomHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderDayContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";


/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 479 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(481);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1144);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(483);

var GetIntrinsic = __webpack_require__(1148);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

module.exports = function callBind() {
	return $reflectApply(bind, $call, arguments);
};

module.exports.apply = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1147);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(1149);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(485);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(487);

var supportsDescriptors = __webpack_require__(144).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initialTableQueryEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFilterEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleSortEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleMultiSortEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gotoPageEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initialTableQueryPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeFilterPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toggleSortPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toggleMultiSortPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gotoPagePartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return initialTableSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleColumnVisibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(182);
var initialTableQueryEmployee=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);var changeFilterEmployee=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);var toggleSortEmployee=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);var toggleMultiSortEmployee=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);var gotoPageEmployee=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);var initialTableQueryPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CUSTOMER_PARTNER_TABLE */]);var changeFilterPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CUSTOMER_PARTNER_TABLE */]);var toggleSortPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CUSTOMER_PARTNER_TABLE */]);var toggleMultiSortPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CUSTOMER_PARTNER_TABLE */]);var gotoPagePartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CUSTOMER_PARTNER_TABLE */]);var initialTableSettings=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);var toggleColumnVisibility=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* tableSelectorEmployee */],__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CUSTOMER_TABLE */]);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_component_Table__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_column_list__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__table_component_TableColumnSelector__ = __webpack_require__(121);
var CustomerSearch=function CustomerSearch(_ref){var tableData=_ref.tableData,changeFilter=_ref.changeFilter,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,gotoPage=_ref.gotoPage,navigateToCustomer=_ref.navigateToCustomer,isTablet=_ref.isTablet,isPartner=_ref.isPartner,toggleColumnVisibility=_ref.toggleColumnVisibility;var columnList=Object(__WEBPACK_IMPORTED_MODULE_6__customer_column_list__["a" /* default */])(isTablet,isPartner);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Customer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__table_component_TableColumnSelector__["a" /* default */],{resultsNumber:tableData.objectList.length,hiddenColumns:tableData.hiddenColumns,columnList:columnList,toggleColumnVisibility:toggleColumnVisibility}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__table_component_Table__["a" /* default */],Object.assign({},tableData,{filterSetting:{language:languageSimplifierFilterSetting,countryCode:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["e" /* COUNTRY_CODE_LIST */]}},changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,gotoPage:gotoPage,idProperty:'id',columnList:columnList,onRowClick:function onRowClick(customer){navigateToCustomer(customer.id);}})));};CustomerSearch.propTypes={tableData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,navigateToCustomer:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,isTablet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,changeFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,toggleSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,gotoPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isPartner:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool/*
 * Filtering happens on the server, so we need to feed in server-stored values
 * To achieve filtering by locale string snippets, we need a `select` type table filter,
 *  where we display language families (English) and do filtering by the corresponding locale snippet
 */};var languageSimplifierFilterSetting={type:'select',valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["f" /* LANGUAGE_LIST */].filter(function(entry){return entry.id!=='';})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableSettings();this.props.initialTableQuery();}})(CustomerSearch)));

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultiSelect__ = __webpack_require__(1174);
var ColumnSelector=function ColumnSelector(props){var columnList=props.columnList,hiddenColumns=props.hiddenColumns;var options=columnList.map(function(column){return{'name':column.property,'checked':!hiddenColumns.includes(column.property),'title':column.header};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MultiSelect__["a" /* default */],Object.assign({options:options},props));};ColumnSelector.propTypes={'columnList':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (ColumnSelector);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export renderLanguageFamily */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(31);
var renderLanguageFamily=function renderLanguageFamily(_ref){var language=_ref.language;var found=__WEBPACK_IMPORTED_MODULE_0__const__["f" /* LANGUAGE_LIST */].find(function(element){return element.id===language;});return found?found.value:'';};/* harmony default export */ __webpack_exports__["a"] = (renderLanguageFamily);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCommentText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsInternal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectProcessInstanceList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(13);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["e" /* selectCustomerDetailState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectCommentText=function selectCommentText(state){return selectOwnState(state).commentText;};var selectIsInternal=function selectIsInternal(state){return selectOwnState(state).isInternal;};var selectProcessInstanceList=function selectProcessInstanceList(state){return selectOwnState(state).processList;};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(98));

var _reactLifecyclesCompat = __webpack_require__(304);

var _PropTypes = __webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(304);

var _ChildMapping = __webpack_require__(1201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(1209);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_DateOfBirth__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CustomerContact=function CustomerContact(_ref){var contact=_ref.contact,changeCustomerContact=_ref.changeCustomerContact,saveCustomerContact=_ref.saveCustomerContact,salutationList=_ref.salutationList,callNumber=_ref.callNumber,countryCodeList=_ref.countryCodeList,languageList=_ref.languageList,hydrateContact=_ref.hydrateContact,error=_ref.error;if(!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */])){return null;}function formatPhoneNumber(e){var phone=e.target.value;var pattern=new RegExp(/^\+?[0-9\b]+$/);if(!pattern.test(phone)){var startsWithPlus=phone.startsWith('+');var formattedPhone=void 0;if(startsWithPlus){formattedPhone=phone.replace(/(?!^)+[^0-9 ]/g,'');}else{formattedPhone=phone.replace(/[^0-9 ]/g,'');}changeCustomerContact('phone',formattedPhone);}}var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),readOnly=_useState2[0],setReadOnly=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isVisible=_useState4[0],setIsVisible=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState6=_slicedToArray(_useState5,2),validationMsgList=_useState6[0],setValidationMsgList=_useState6[1];var noop=function noop(){};function validate(e){if(e.value.length===0||!e.value.trim()){setValidationMsgList(Object.assign({},validationMsgList,_defineProperty({},e.name,'Is mandatory field, please fill before save')));return;}if(validationMsgList[e.name]){setValidationMsgList(Object.assign({},validationMsgList,_defineProperty({},e.name,null)));}}function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var res=re.test(String(email).trim().toLowerCase());if(!res){setValidationMsgList(Object.assign({},validationMsgList,{email:'email format not valid, please use a valid email'}));return;}if(validationMsgList.email){setValidationMsgList(Object.assign({},validationMsgList,{email:null}));}}function validateSocialSecurityNumberSE(socialSecurityNumber){var pattern=/^((19|20)?(\d{2})(0?[1-9]|1[012])[0-3][0-9])([-+]|\s){0,1}\d{4}$/;isValidSocialSecurityNumber(socialSecurityNumber,pattern);}function validateSocialSecurityNumberDK(socialSecurityNumber){var pattern=/^[0-3][0-9][0-1][1-9][0-9][0-9]-[0-9][0-9][0-9][0-9]$/;isValidSocialSecurityNumber(socialSecurityNumber,pattern);}function isValidSocialSecurityNumber(socialSecurityNumber,pattern){var isValidSSN=pattern.test(socialSecurityNumber);if(!isValidSSN){setValidationMsgList(Object.assign({},validationMsgList,{socialSecurityNumber:'social security number is invalid'}));return;}if(validationMsgList.socialSecurityNumber){setValidationMsgList(Object.assign({},validationMsgList,{socialSecurityNumber:null}));}}var toggleEditButtons=function toggleEditButtons(){setReadOnly(!readOnly);setIsVisible(!isVisible);};var ButtonGroup=function ButtonGroup(){var btnStyle={marginRight:'10px'};var onCancel=function onCancel(){toggleEditButtons();hydrateContact();setValidationMsgList({});};var onSave=function onSave(){if(!checkValidationMsgList()){return;}saveCustomerContact();toggleEditButtons();};function checkValidationMsgList(){return Object.values(validationMsgList).every(function(currentValue){return currentValue===null;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:onSave},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default pull-right',style:btnStyle,onClick:onCancel},'Cancel'));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__["a" /* default */],{title:'Personal Information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},error)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},!isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:toggleEditButtons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-edit','aria-hidden':'true'})),isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Salutation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:contact,name:'gender',readOnly:readOnly,valueList:salutationList,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Reference',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'referenceNumber',readOnly:true,onChange:noop})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Firstname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'firstName',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){validate(e.target);}})),validationMsgList.firstName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.firstName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Lastname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'lastName',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){validate(e.target);}})),validationMsgList.lastName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.lastName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Street address',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'streetAddress',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Street address extension',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'streetAddressExtension',readOnly:readOnly,onChange:changeCustomerContact})))),contact.countryCode==='AT'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Staircase',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'staircase',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Door',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'door',readOnly:readOnly,onChange:changeCustomerContact})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'ZIP',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'zip',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'City',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'city',readOnly:readOnly,onChange:changeCustomerContact})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Country'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:contact,addEmpty:!contact.countryCode,name:'countryCode',readOnly:readOnly,valueList:countryCodeList,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Language'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:contact,name:'language',readOnly:readOnly,valueList:languageList,onChange:changeCustomerContact})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'email',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){validateEmail(e.target.value.trim());}}),validationMsgList.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.email))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Phone',groupAddOnIcon:'fa fa-phone',actionAddOnIcon:'fa fa-phone',onActionAddOnClick:function onActionAddOnClick(){callNumber(contact.phone);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'phone',type:'phone',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){formatPhoneNumber(e);saveCustomerContact();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Date of birth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_DateOfBirth__["a" /* default */],{object:contact,name:'dob',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},contact.store&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Store',groupAddOnIcon:'fa fa-bank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:contact,name:'store',readOnly:true,onChange:noop})))),contact.countryCode==='DK'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Social Security Number (Format: DDMMYY-SSSS)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{placeholder:'191200-3421',object:contact,name:'socialSecurityNumber',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){validateSocialSecurityNumberDK(e.target.value.trim());}})),validationMsgList.socialSecurityNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.socialSecurityNumber))),contact.countryCode==='SE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Social Security Number (Format: YYMMDD-nnnC)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{placeholder:'001219-3421',object:contact,name:'socialSecurityNumber',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){validateSocialSecurityNumberSE(e.target.value.trim());}})),validationMsgList.socialSecurityNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.socialSecurityNumber)))));};CustomerContact.propTypes={contact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,salutationList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,changeCustomerContact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveCustomerContact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,hydrateContact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,countryCodeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,languageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.hydrateContact();}})(CustomerContact));

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_component_instance_detail_CommentList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_definition_customer_ui__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ProcessCommentList=function ProcessCommentList(_ref){var processCommentList=_ref.processCommentList;if(processCommentList.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',style:{border:'1px solid #eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,processCommentList.map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__process_component_instance_detail_CommentList__["a" /* Comment */],{comment:comment});}))));};var ProcessInstance=function ProcessInstance(_ref2){var processInstance=_ref2.processInstance,isVisible=_ref2.isVisible;var viewLink='/process/instance/view/'+processInstance.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__process_util_names__["d" /* renderProcessName */])(processInstance.processName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__util_datetime__["b" /* formatDate */])(processInstance.started)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__util_datetime__["b" /* formatDate */])(processInstance.lastStatusChange)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__process_util_names__["f" /* renderStateName */])(processInstance.currentStateName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__process_util_names__["g" /* renderTaskName */])(processInstance.currentTaskName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:viewLink},'view'))),isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessCommentList,{processCommentList:processInstance.processCommentList}));};var ProcessInstanceList=function ProcessInstanceList(_ref3){var processInstanceList=_ref3.processInstanceList;if(!Object(__WEBPACK_IMPORTED_MODULE_10__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__ui_definition_customer_ui__["c" /* CUSTOMER_PROCESS_INSTANCE_LIST */])){return null;}if(!processInstanceList||processInstanceList.length===0){return null;}var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isVisible=_useState2[0],setIsVisible=_useState2[1];var toggleComments=function toggleComments(){setIsVisible(!isVisible);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__["a" /* default */],{title:'Process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:toggleComments},'load comments\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-comments'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Process'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Started'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Status Change'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Current State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Current Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processInstanceList.map(function(processInstance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessInstance,{key:processInstance.id,processInstance:processInstance,isVisible:isVisible});}))))));};ProcessInstanceList.propTypes={processInstanceList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,findProcessComment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findProcessComment(this.props.customerId);}})(ProcessInstanceList));

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_names__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__ = __webpack_require__(2);
var AppointmentList=function AppointmentList(_ref){var appointmentList=_ref.appointmentList;if(!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__["f" /* APPOINTMENT_LIST_WIDGET_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Appointment List'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Store'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Start Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'End Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Appointment Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cancel Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,appointmentList.map(function(appointment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:appointment.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(appointment.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__store_util_renderStoreName__["c" /* renderStoreNameById */])(appointment.storeId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(appointment.startTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(appointment.endTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__util_names__["b" /* renderAppointmentStatus */])(appointment.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,appointment.appointmentType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,appointment.cancelCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Link */],{to:'/appointment/edit/'+appointment.id},'View')));}))))));};AppointmentList.propTypes={appointmentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AppointmentList);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderAppointmentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderAppointmentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderAppointmentReason; });
var renderAppointmentStatus=function renderAppointmentStatus(status){if(!status){return'';}return status.replace(/_/g,' ');};var renderAppointmentType=function renderAppointmentType(appointmentType){return appointmentType;};var renderAppointmentReason=function renderAppointmentReason(appointmentReason){return appointmentReason;};

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TreatmentQuotation__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_quotation_const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_plan_selector__ = __webpack_require__(33);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentQuotation:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["n" /* selectTreatmentQuotation */](state),customer:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["a" /* selectCustomer */](state),isPreviewModalOpen:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["j" /* selectIsPreviewModalOpen */](state),isValid:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["l" /* selectIsTreatmentQuotationValid */](state),uploadingVideo:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["m" /* selectIsUploadingVideo */](state),isEditableForUser:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["f" /* selectIsEditableForUser */](state),hasUserRoleToEdit:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["e" /* selectHasUserRoleToEdit */](state),productType:__WEBPACK_IMPORTED_MODULE_4__state_quotation_const__["h" /* PRODUCT_TYPE_ALIGNERS */],treatmentPlan:__WEBPACK_IMPORTED_MODULE_5__state_plan_selector__["g" /* selectTreatmentPlan */](state)};};var mapDispatchToProps={findOrCreateTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["d" /* findOrCreateTreatmentQuotation */],changeTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["a" /* changeTreatmentQuotation */],saveTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["h" /* saveTreatmentQuotation */],openPreviewModal:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["e" /* openPreviewModal */],closePreviewModal:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["b" /* closePreviewModal */],uploadVideoFile:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["k" /* uploadVideoFile */],updatePackageAndPrice:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["j" /* updatePackageAndPrice */],setEditableForUser:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["i" /* setEditableForUser */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__TreatmentQuotation__["a" /* default */]));

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_DatePicker__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TreatmentPreview__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__customer_state_file_upload_const__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__state_const__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__state_quotation_const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__prop_types_customer_obj_type__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__prop_types_treatment_quotation_obj_type__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_api__ = __webpack_require__(12);
var moment=__webpack_require__(38);var getProlongValidDate=function getProlongValidDate(date){return moment(date).add(23,'hours').add(59,'minutes').add(59,'seconds').format('YYYY-MM-DDTHH:mm:ss');};var style={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'32px'};var buttonStyle={marginTop:'24px',marginLeft:'12px'};var downloadPDFButtonStyle={marginTop:'24px',marginBottom:'24px'/**
 * this checks if the customer has an @sunshinesmile.de email. If so the purchased state can be reset manually
 * (To allow multiple treatment checkouts for testing)
 * @param customer
 */};var isSunshineSmileCustomer=function isSunshineSmileCustomer(customer){if(!customer){return false;}if(!customer.email){return false;}return customer.email.indexOf('@sunshinesmile.de')!==-1;};var getCommentText=function getCommentText(commentKey){var countryCode=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'DE';var getLocalizedText=__WEBPACK_IMPORTED_MODULE_18__state_quotation_const__["j" /* QUOTATION_COMMENT_TEXT */][commentKey];if(getLocalizedText){return getLocalizedText(countryCode);}else{return'';}};var EditAlignerButton=function EditAlignerButton(_ref){var setEditableForUser=_ref.setEditableForUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:buttonStyle,className:'btn btn-success btn-sm ',onClick:setEditableForUser},'Edit quotation');};var UpdatePackageSizePriceButton=function UpdatePackageSizePriceButton(_ref2){var isUpdatePackagePriceEnabled=_ref2.isUpdatePackagePriceEnabled,updatePackageAndPrice=_ref2.updatePackageAndPrice,treatmentQuotation=_ref2.treatmentQuotation,customer=_ref2.customer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:buttonStyle,className:['btn btn-primary btn-sm',isUpdatePackagePriceEnabled?'':' btn-secondary disabled'].join(' '),onClick:function onClick(){if(isUpdatePackagePriceEnabled){updatePackageAndPrice({treatmentQuotation:treatmentQuotation,customer:customer});}}},'Update Package Size / BrutPrice');};var getComment=function getComment(_ref3){var treatmentQuotation=_ref3.treatmentQuotation,changeTreatmentQuotation=_ref3.changeTreatmentQuotation,saveTreatmentQuotation=_ref3.saveTreatmentQuotation,customer=_ref3.customer;var commentText=getCommentText(treatmentQuotation.commentKey,customer.countryCode);changeTreatmentQuotation('comment',commentText);saveTreatmentQuotation();};var currentUserHasReadOnlyRole=function currentUserHasReadOnlyRole(){var canModifyTQRoles=[__WEBPACK_IMPORTED_MODULE_25__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_25__security_state_auth_const__["O" /* ROLE_TREATMENT_PLANER */],__WEBPACK_IMPORTED_MODULE_25__security_state_auth_const__["I" /* ROLE_QM_TREATMENT_PLANNER */],__WEBPACK_IMPORTED_MODULE_25__security_state_auth_const__["P" /* ROLE_TREATMENT_QUOTATION_ADMIN */]];var state=__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].getState();return!Object(__WEBPACK_IMPORTED_MODULE_24__security_state_auth_selector__["u" /* userHasAnyOfRoles */])(state,canModifyTQRoles);};var TreatmentQuotation=function TreatmentQuotation(_ref4){var treatmentQuotation=_ref4.treatmentQuotation,uploadingVideo=_ref4.uploadingVideo,uploadVideoFile=_ref4.uploadVideoFile,isValid=_ref4.isValid,changeTreatmentQuotation=_ref4.changeTreatmentQuotation,saveTreatmentQuotation=_ref4.saveTreatmentQuotation,customer=_ref4.customer,isPreviewModalOpen=_ref4.isPreviewModalOpen,openPreviewModal=_ref4.openPreviewModal,closePreviewModal=_ref4.closePreviewModal,validationMessageList=_ref4.validationMessageList,updatePackageAndPrice=_ref4.updatePackageAndPrice,isEditableForUser=_ref4.isEditableForUser,hasUserRoleToEdit=_ref4.hasUserRoleToEdit,setEditableForUser=_ref4.setEditableForUser,treatmentPlan=_ref4.treatmentPlan;if(!Object(__WEBPACK_IMPORTED_MODULE_21__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_22__process_ui_definition_process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */])){return null;}if(!customer){return null;}if(customer.isImplantCustomer){return null;}if(!treatmentPlan){var activeTreatmentPlan=customer.activeTreatmentPlan,treatmentPlanList=customer.treatmentPlanList;treatmentPlan=treatmentPlanList[activeTreatmentPlan];}var onChangeSelect=function onChangeSelect(name,value){changeTreatmentQuotation(name,value);saveTreatmentQuotation();};if(treatmentQuotation===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBox__["a" /* default */],{title:'Treatment Quotation'});}var commentExists=treatmentQuotation&&treatmentQuotation.commentKey&&!treatmentQuotation.comment;if(commentExists){getComment({treatmentQuotation:treatmentQuotation,changeTreatmentQuotation:changeTreatmentQuotation,saveTreatmentQuotation:saveTreatmentQuotation,customer:customer});}var currencyCodeSymbol=__WEBPACK_IMPORTED_MODULE_16__state_const__["d" /* CURRENCY_CODE_SYMBOL */][treatmentQuotation.currency];var isSunshineSmile=isSunshineSmileCustomer(customer);var hasPhysician=!!(customer.partnerPhysicianId||customer.treatingPhysicianId);var isPretreatmentNeeded=treatmentQuotation.pretreatmentNeeded;var needsIPR=treatmentQuotation.iprNeeded;var readonly=treatmentQuotation.purchased||currentUserHasReadOnlyRole();var isUpdatePackagePriceEnabled=!treatmentQuotation.purchased;customer.treatmentPlanPDFList.sort(function(firstItem,secondItem){var firstItemCreationDate=firstItem.created;var secondItemCreationDate=secondItem.created;if(!firstItemCreationDate&&!secondItemCreationDate)return 0;if(!firstItemCreationDate&&secondItemCreationDate)return-1;if(firstItemCreationDate&&!secondItemCreationDate)return 1;return moment(secondItemCreationDate).unix()-moment(firstItemCreationDate).unix();});var isDownloadPDFButtonEnabled=Object.keys(customer.treatmentPlanPDFList).length>0;var pdfDownloadURL=isDownloadPDFButtonEnabled?__WEBPACK_IMPORTED_MODULE_26__util_api__["a" /* BACKEND_URL */]+'/api/file-system/download-file?fileId='+customer.treatmentPlanPDFList[0].id:'';var title='Treatment Quotation  '+treatmentQuotation.customerName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TreatmentPreview__["a" /* default */],{treatmentQuotation:treatmentQuotation,isPreviewModalOpen:isPreviewModalOpen,closePreviewModal:closePreviewModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),isSunshineSmile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_Checkbox__["a" /* default */],{object:treatmentQuotation,name:'purchased',onChange:onChangeSelect},'Purchased')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_Checkbox__["a" /* default */],{object:treatmentQuotation,name:'approved',readOnly:!isValid||!hasPhysician||readonly,onChange:onChangeSelect},'Allow customer to purchase'),!hasPhysician&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-error'},'Please select a physician to activate this quotation. (in the status area of the Sales Order)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_Checkbox__["a" /* default */],{object:treatmentQuotation,name:'ratePayAllowed',readOnly:readonly,onChange:onChangeSelect},'Rate pay allowed'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Valid Until'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_DatePicker__["a" /* default */],{object:treatmentQuotation,name:'validUntil',readOnly:readonly,onChange:function onChange(name,value){changeTreatmentQuotation(name,getProlongValidDate(value));},onBlur:saveTreatmentQuotation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Treatment duration (in weeks)',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{type:'number',object:treatmentQuotation,readOnly:true,name:'treatmentDuration',onChange:changeTreatmentQuotation}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Number of aligner steps',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{type:'number',object:treatmentQuotation,readOnly:true,name:'numberOfAligner',onChange:changeTreatmentQuotation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Number of aligner lower jaw',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{type:'number',object:treatmentQuotation,readOnly:readonly&&!isEditableForUser,name:'numberOfAlignerLowerJaw',onChange:changeTreatmentQuotation,onBlur:saveTreatmentQuotation}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Number of aligner upper jaw',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{type:'number',object:treatmentQuotation,readOnly:readonly&&!isEditableForUser,name:'numberOfAlignerUpperJaw',onChange:changeTreatmentQuotation,onBlur:saveTreatmentQuotation}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:4},hasUserRoleToEdit&&treatmentQuotation.purchased&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditAlignerButton,{setEditableForUser:setEditableForUser}),isUpdatePackagePriceEnabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdatePackageSizePriceButton,{updatePackageAndPrice:updatePackageAndPrice,isUpdatePackagePriceEnabled:isUpdatePackagePriceEnabled,treatmentQuotation:treatmentQuotation,customer:customer}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Package Size',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__form_component_Select__["a" /* default */],{name:'packageSize',object:treatmentQuotation,valueList:__WEBPACK_IMPORTED_MODULE_18__state_quotation_const__["f" /* PACKAGESIZE_VALUES */],readOnly:readonly,onChange:onChangeSelect}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'IPR',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:treatmentQuotation,name:'iprNeeded',readOnly:true,placeholder:needsIPR?'IPR required':'IPR Not required'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Pretreatment',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__form_component_Select__["a" /* default */],{name:'pretreatmentNeeded',object:treatmentQuotation,valueList:__WEBPACK_IMPORTED_MODULE_18__state_quotation_const__["g" /* PRETREATMENT_NEEDED_VALUES */],readOnly:true}))),treatmentPlan&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Attachment',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__form_component_Select__["a" /* default */],{name:'attachmentNeeded',object:treatmentPlan,valueList:__WEBPACK_IMPORTED_MODULE_18__state_quotation_const__["e" /* ATTACHMENT_VALUES */],readOnly:true,addEmpty:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'BrutPrice',groupAddOnIcon:currencyCodeSymbol},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__form_component_Select__["a" /* default */],{name:'brutPrice',object:treatmentQuotation,valueList:__WEBPACK_IMPORTED_MODULE_16__state_const__["b" /* AVAILABLE_TREATMENT_PRICE_LIST */],readOnly:readonly,type:'int',onChange:onChangeSelect}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Physician Cost',groupAddOnIcon:currencyCodeSymbol},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:treatmentQuotation,name:'physicianCost',readOnly:true,onChange:changeTreatmentQuotation,onBlur:saveTreatmentQuotation,isMoney:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__form_component_Select__["a" /* default */],{name:'commentKey',object:treatmentQuotation,valueList:Object(__WEBPACK_IMPORTED_MODULE_18__state_quotation_const__["m" /* getQuotationCommentSelectValues */])(isPretreatmentNeeded),readOnly:readonly,addEmpty:true,onChange:function onChange(name,value){changeTreatmentQuotation(name,value);var commentText=getCommentText(value,customer.countryCode);changeTreatmentQuotation('comment',commentText);saveTreatmentQuotation();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Currency'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__form_component_Select__["a" /* default */],{name:'currency',object:treatmentQuotation,valueList:__WEBPACK_IMPORTED_MODULE_16__state_const__["c" /* CURRENCY_CODE_LIST */],readOnly:readonly,addEmpty:false,onChange:onChangeSelect})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Treatment Link',groupAddOnIcon:'fa fa-info',actionAddOnIcon:'fa fa-search',onActionAddOnClick:openPreviewModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:treatmentQuotation,name:'treatmentLink',readOnly:readonly&&!isEditableForUser,onChange:changeTreatmentQuotation,onBlur:saveTreatmentQuotation}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:treatmentQuotation.treatmentLink,target:'_blank',rel:'noopener noreferrer'},'Open in new Window'))),customer.countryCode==='FR'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:downloadPDFButtonStyle,className:['btn btn-primary',isDownloadPDFButtonEnabled?'':' btn-secondary disabled'].join(' '),onClick:function onClick(){if(isDownloadPDFButtonEnabled){window.open(pdfDownloadURL);}}},'Download Treatment Quotation PDF'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__form_component_TextArea__["a" /* default */],{name:'comment',readOnly:readonly&&!isEditableForUser,object:treatmentQuotation,onChange:changeTreatmentQuotation,onBlur:saveTreatmentQuotation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},treatmentQuotation.id&&!treatmentQuotation.purchased&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_block_ui__["a" /* default */],{tag:'div',blocking:uploadingVideo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,maxSize:__WEBPACK_IMPORTED_MODULE_15__customer_state_file_upload_const__["a" /* MAX_SCAN_FILE_SIZE */],style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadVideoFile(fileList[0],treatmentQuotation.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload a video'))))));};TreatmentQuotation.propTypes={updatePackageAndPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,treatmentQuotation:__WEBPACK_IMPORTED_MODULE_20__prop_types_treatment_quotation_obj_type__["a" /* default */],isPreviewModalOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,findOrCreateTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPreviewModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,closePreviewModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,uploadVideoFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,uploadingVideo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,customer:__WEBPACK_IMPORTED_MODULE_19__prop_types_customer_obj_type__["a" /* default */],isEditableForUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,hasUserRoleToEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,setEditableForUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){if(this.props.onlyDisplay){return;}if(!this.props.customer.isImplantCustomer){this.props.findOrCreateTreatmentQuotation(this.props.productType);}}})(TreatmentQuotation));

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
var TreatmentPreview=function TreatmentPreview(_ref){var isPreviewModalOpen=_ref.isPreviewModalOpen,closePreviewModal=_ref.closePreviewModal,treatmentQuotation=_ref.treatmentQuotation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:isPreviewModalOpen,onRequestClose:closePreviewModal,className:'preview-modal',overlayClassName:'modal-overlay',contentLabel:'Example Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'treatment-quotation-preview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Preview')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2,className:'align-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:closePreviewModal,className:'btn btn-primary'},'x'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:treatmentQuotation.treatmentLink,title:'preview'})));};TreatmentPreview.propTypes={treatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isPreviewModalOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,closePreviewModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TreatmentPreview);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_money__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_const__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__customer_ui_definition_customer_ui__ = __webpack_require__(94);
var SalesOrder=function SalesOrder(_ref){var salesOrder=_ref.salesOrder;var productType=__WEBPACK_IMPORTED_MODULE_7__state_const__["c" /* PRODUCT_TYPE */][salesOrder.type];var viewLink='/sales-order/edit/'+salesOrder.id;var ratePay=salesOrder.isRatePay?'yes':'no';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,productType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.referenceNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_7__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ratePay),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_8__process_util_names__["f" /* renderStateName */])(salesOrder.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{to:viewLink},'view')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_money__["b" /* formatMoney */])(salesOrder.brutPrice,salesOrder.currency)));};var SalesOrderList=function SalesOrderList(_ref2){var salesOrderList=_ref2.salesOrderList;if(!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__customer_ui_definition_customer_ui__["d" /* CUSTOMER_SALES_ORDER_LIST */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Sales Order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reference Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Payment method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rate Pay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Brut'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,salesOrderList.map(function(salesOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesOrder,{key:salesOrder.id,salesOrder:salesOrder});}))))));};SalesOrderList.propTypes={salesOrderList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderList);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectShipmentDetailOpen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(1224);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectShipmentDetailOpen=function selectShipmentDetailOpen(state){return selectOwnState(state).shipmentDetailOpen;};

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_ToggleButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__ = __webpack_require__(2);
var DHL_TRACKING_URL='https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode=';var FinalStatus=function FinalStatus(_ref){var status=_ref.status;if(!status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'in delivery');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,status.replace(/_/g,' '));};var DHLTrackingLink=function DHLTrackingLink(_ref2){var shipmentId=_ref2.shipmentId;if(!shipmentId){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:DHL_TRACKING_URL+shipmentId,target:'_blank',rel:'noopener noreferrer'},shipmentId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'}));};var LabelUrl=function LabelUrl(_ref3){var labelURL=_ref3.labelURL;if(!labelURL){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:labelURL,target:'_blank',rel:'noopener noreferrer'},'view');};var ShipmentDetail=function ShipmentDetail(_ref4){var shipment=_ref4.shipment,toggleShipmentTracking=_ref4.toggleShipmentTracking,shipmentDetailOpen=_ref4.shipmentDetailOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(shipment.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DHLTrackingLink,{shipmentId:shipment.externalShipmentId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DHLTrackingLink,{shipmentId:shipment.externalReturnShipmentId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,shipment.shipmentProvider),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FinalStatus,{status:shipment.finalState})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelUrl,{labelURL:shipment.labelURL})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelUrl,{labelURL:shipment.returnLabelURL})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_ToggleButton__["a" /* default */],{toggle:function toggle(){toggleShipmentTracking(shipment.id);},active:!!shipmentDetailOpen[shipment.id],activeIcon:'fa fa-search-minus',inactiveIcon:'fa fa-search-plus'})));};var TrackingDetail=function TrackingDetail(_ref5){var shipment=_ref5.shipment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,shipment.shipmentEventList&&shipment.shipmentEventList.map(function(tracking){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:tracking.timestamp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,tracking.timestamp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{dangerouslySetInnerHTML:{__html:tracking.eventText}}));}))),shipment.returnShipmentEventList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Return tracking'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,shipment.returnShipmentEventList&&shipment.returnShipmentEventList.map(function(tracking){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:tracking.timestamp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,tracking.timestamp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,tracking.eventText));}))))));};var Shipment=function Shipment(_ref6){var shipment=_ref6.shipment,shipmentDetailOpen=_ref6.shipmentDetailOpen,toggleShipmentTracking=_ref6.toggleShipmentTracking;var rowList=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShipmentDetail,{key:shipment.id+'s',shipment:shipment,shipmentDetailOpen:shipmentDetailOpen,toggleShipmentTracking:toggleShipmentTracking})];if(shipmentDetailOpen[shipment.id]){rowList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TrackingDetail,{key:shipment.id+'t',shipment:shipment}));}return rowList;};var AddShipment=function AddShipment(_ref7){var salesOrder=_ref7.salesOrder,addShipment=_ref7.addShipment,createShipment=_ref7.createShipment,fetching=_ref7.fetching;if(!salesOrder||!addShipment||!salesOrder.salesOrderCustomer){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){createShipment(salesOrder.id,addShipment);},disabled:fetching,className:'btn btn-warning btn-sm'},'create Shipment')));};var ShipmentList=function ShipmentList(_ref8){var shipmentList=_ref8.shipmentList,salesOrder=_ref8.salesOrder,addShipment=_ref8.addShipment,createShipment=_ref8.createShipment,fetching=_ref8.fetching,shipmentDetailOpen=_ref8.shipmentDetailOpen,toggleShipmentTracking=_ref8.toggleShipmentTracking;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Shipment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddShipment,{fetching:fetching,salesOrder:salesOrder,addShipment:addShipment,createShipment:createShipment}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tracking'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tracking (return)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Return Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tracking'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,shipmentList.map(function(shipment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Shipment,{toggleShipmentTracking:toggleShipmentTracking,shipmentDetailOpen:shipmentDetailOpen,key:shipment.id,shipment:shipment});}))))));};ShipmentList.propTypes={shipmentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,addShipment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,createShipment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ShipmentList);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PricesContext__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sdk__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__security_state_auth_const__ = __webpack_require__(28);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var SalesNotes=function SalesNotes(_ref){var customerId=_ref.customerId,isReadOnly=_ref.isReadOnly,state=_ref.state;var isVisible=__WEBPACK_IMPORTED_MODULE_10__security_state_auth_selector__["v" /* userHasWidgetInVisibleList */](state,__WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__["_0" /* SALES_NOTE_WIDGET_CONTAINER */]);var hasRole=__WEBPACK_IMPORTED_MODULE_10__security_state_auth_selector__["i" /* selectHasRole */](state,__WEBPACK_IMPORTED_MODULE_12__security_state_auth_const__["i" /* ROLE_CLINIC_SALES */]);if(!hasRole&&isVisible){isReadOnly=true;}if(!hasRole&&!isVisible){return'';}var _usePrices=Object(__WEBPACK_IMPORTED_MODULE_6__PricesContext__["b" /* usePrices */])(),treatmentPrices=_usePrices.treatmentPrices;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),persistedNote=_useState2[0],setPersistedNote=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({followUpType:'',promisedPrice:'',treatmentPlanDeadline:null}),_useState4=_slicedToArray(_useState3,2),note=_useState4[0],setNote=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),loading=_useState6[0],setLoading=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),error=_useState8[0],setError=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),editing=_useState10[0],setEditing=_useState10[1];var treatmentDeadlineIsEnabled=[__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].IN_CLINIC,__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].EXPERT_CALL].includes(note.followUpType);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_7__sdk__["b" /* default */].findNote(customerId);case 3:data=_context.sent;setPersistedNote(data);setNote(data);_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);setError(_context.t0.message);case 11:setLoading(false);case 12:case'end':return _context.stop();}}},_callee,this,[[0,8]]);}))();},[customerId]);var enableEditing=function enableEditing(){setEditing(true);};var cancelEditing=function cancelEditing(){setEditing(false);setError(null);setNote(persistedNote||{followUpType:'',promisedPrice:treatmentPrices.medium,treatmentPlanDeadline:null});};var saveChanges=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:setLoading(true);setError(null);_context2.prev=2;_context2.next=5;return __WEBPACK_IMPORTED_MODULE_7__sdk__["b" /* default */].saveNote(customerId,note);case 5:setPersistedNote(note);setEditing(false);_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](2);setError(_context2.t0.message||JSON.stringify(_context2.t0));case 12:setLoading(false);case 13:case'end':return _context2.stop();}}},_callee2,_this,[[2,9]]);}));return function saveChanges(){return _ref3.apply(this,arguments);};}();function setPromisedPrice(promisedPrice){setError(null);return setNote(Object.assign({},note,{promisedPrice:promisedPrice}));}function setFollowUp(followUpType){setError(null);if([__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].NO_PITCH,__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].NO_FOLLOW_UP].includes(followUpType)){return setNote(Object.assign({},note,{followUpType:followUpType,treatmentPlanDeadline:null}));}return setNote(Object.assign({},note,{followUpType:followUpType}));}function setTreatmentPlanDeadline(date){setError(null);return setNote(Object.assign({},note,{treatmentPlanDeadline:date}));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{layer:'lg',size:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{layer:'md',size:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Sales Notes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{layer:'md',size:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'right'}},!editing&&!isReadOnly&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:enableEditing,className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-edit'})),editing&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:cancelEditing,className:'btn',disabled:loading,style:{marginLeft:'5px'}},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:saveChanges,className:'btn btn-primary',disabled:loading,type:'submit',style:{marginLeft:'5px'}},'Save')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__layout_component_ContentBoxBody__["a" /* default */],null,error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{layer:'md',size:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert alert-danger',role:'alert'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-exclamation-circle'}),error))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{layer:'md',size:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'sales_promise_followup_type'},'Follow-up type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{name:'followup',id:'sales_promise_followup_type',className:'form-control',disabled:!editing||loading,value:note.followUpType,onChange:function onChange(e){return setFollowUp(e.target.value);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'empty',value:''}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].IN_CLINIC,value:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].IN_CLINIC},'In-Clinic Follow-Up (ICSTP1)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].EXPERT_CALL,value:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].EXPERT_CALL},'Expert Call Follow-Up (ICSTP2)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].NO_FOLLOW_UP,value:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].NO_FOLLOW_UP},'No Follow-Up booked (ICSTP3)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].NO_PITCH,value:__WEBPACK_IMPORTED_MODULE_7__sdk__["a" /* FOLLOW_UP */].NO_PITCH},'No Pitch and Follow-Up (ICSTP4)'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'sales_promise_price'},'Promised price'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'input-group-addon'},'\u20AC'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{name:'promisedPrice',id:'sales_promise_price',className:'form-control',disabled:!editing||loading,value:note.promisedPrice,onChange:function onChange(e){return setPromisedPrice(e.target.value);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'empty',value:''}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'zero',value:'0'},'0.0'),Object.entries(treatmentPrices).map(function(_ref4){var _ref5=_slicedToArray(_ref4,2),value=_ref5[0],label=_ref5[1];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:value,value:label},(label/100).toFixed(2));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'sales_promise_deadline'},'Treatment plan deadline'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datepicker__["a" /* default */],{id:'sales_promise_deadline',className:'form-control',autoComplete:'off',selected:note.treatmentPlanDeadline,minDate:note.treatmentPlanDeadline,readOnly:!editing,disabled:!editing||loading||!treatmentDeadlineIsEnabled,showTimeSelect:false,dateFormat:'DD.MM.YYYY',onChange:setTreatmentPlanDeadline}))))))))));};SalesNotes.propTypes={customerId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,isReadOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SalesNotes);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__globals_state_selector__ = __webpack_require__(37);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ExternalPhysicianSelect=function ExternalPhysicianSelect(_ref){var customer=_ref.customer,physicianList=_ref.physicianList,changeCustomer=_ref.changeCustomer,readOnly=_ref.readOnly;if(customer.treatingPhysicianId){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Partner Physician (External)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,name:'partnerPhysicianId',valueList:physicianList,addEmpty:!customer.partnerPhysicianId,renderer:function renderer(physician){return physician.displayName;},readOnly:readOnly,onChange:function onChange(name,value){changeCustomer(name,value);}}));};var RemotePhysicianSelect=function RemotePhysicianSelect(_ref2){var customer=_ref2.customer,userList=_ref2.userList,changeCustomer=_ref2.changeCustomer,readOnly=_ref2.readOnly;var remotePhysicianList=RemotePhysicianList(userList);var isRemotePhysician=IsRemotePhysician(remotePhysicianList,customer);if(customer.treatingPhysicianId&&!isRemotePhysician){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Treating Physician (Remote)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,id:'treatingPhysicianId',name:'treatingPhysicianId',valueList:remotePhysicianList,addEmpty:!customer.treatingPhysicianId,renderer:function renderer(user){return user.firstName+' '+user.lastName;},readOnly:readOnly,onChange:function onChange(name,value){changeCustomer('partnerPhysicianId',null);changeCustomer(name,value);}}));};var RemotePhysicianList=function RemotePhysicianList(userList){var remotePhysicianList=[];userList.forEach(function(user){var roleList=user.roleList;if(roleList.includes(__WEBPACK_IMPORTED_MODULE_10__security_state_auth_const__["N" /* ROLE_TREATING_PHYSICIAN_REMOTE */])||roleList.includes(__WEBPACK_IMPORTED_MODULE_10__security_state_auth_const__["C" /* ROLE_PARTNER_PHYSICIAN_REMOTE */])){remotePhysicianList.push(user);}},userList);return remotePhysicianList;};var IsRemotePhysician=function IsRemotePhysician(remotePhysicianList,customer){var isRemotePhysician=false;var treatingPhysicianId=customer.treatingPhysicianId;remotePhysicianList.forEach(function(user){if(user.id===treatingPhysicianId){if(user.store){isRemotePhysician=user.store!==customer.store;}else{isRemotePhysician=true;}}},remotePhysicianList);return isRemotePhysician;};var SunshinePhysicianSelect=function SunshinePhysicianSelect(_ref3){var customer=_ref3.customer,userList=_ref3.userList;if(!customer.treatingPhysicianId){return null;}var remotePhysicianList=RemotePhysicianList(userList);var isRemotePhysician=IsRemotePhysician(remotePhysicianList,customer);if(isRemotePhysician){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Treating Physician'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,name:'treatingPhysicianId',valueList:userList,addEmpty:false,renderer:function renderer(user){return user.firstName+' '+user.lastName;},readOnly:true,onChange:function onChange(){}}));};var PhysicianAndSupplier=function PhysicianAndSupplier(_ref4){var customer=_ref4.customer,changeCustomer=_ref4.changeCustomer,saveCustomer=_ref4.saveCustomer,physicianList=_ref4.physicianList,treatmentPlanerList=_ref4.treatmentPlanerList,supplierList=_ref4.supplierList,validationMessageList=_ref4.validationMessageList,userList=_ref4.userList,isExternalTreatmentPlanerPossible=_ref4.isExternalTreatmentPlanerPossible;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */])){return null;}var defaultSupplierId=Object(__WEBPACK_IMPORTED_MODULE_12__globals_state_selector__["selectSupplierDefaultId"])(__WEBPACK_IMPORTED_MODULE_11__modules_store__["a" /* default */].getState());var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),readOnly=_useState2[0],setReadOnly=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isVisible=_useState4[0],setIsVisible=_useState4[1];// set customer supplier Id to default if undefined so validation does not complain
if(customer.partnerSupplierId===undefined||!customer.partnerSupplierId){changeCustomer('partnerSupplierId',defaultSupplierId);var remotePhysicianList=RemotePhysicianList(userList);var isRemotePhysician=IsRemotePhysician(remotePhysicianList,customer);var treatingPhysicianIdSelect=document.getElementById('treatingPhysicianId');if(isRemotePhysician&&treatingPhysicianIdSelect){var treatingPhysicianId=treatingPhysicianIdSelect.value;changeCustomer('treatingPhysicianId',treatingPhysicianId);}saveCustomer();}var toggleEditButtons=function toggleEditButtons(){setReadOnly(!readOnly);setIsVisible(!isVisible);};var ButtonGroup=function ButtonGroup(){var btnStyle={marginRight:'10px'};var onCancel=function onCancel(){toggleEditButtons();};var onSave=function onSave(){saveCustomer();toggleEditButtons();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:onSave},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default pull-right',style:btnStyle,onClick:onCancel},'Cancel'));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Physician and Supplier'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},!isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:toggleEditButtons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-edit','aria-hidden':'true'})),isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalPhysicianSelect,{readOnly:readOnly,customer:customer,physicianList:physicianList,changeCustomer:changeCustomer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemotePhysicianSelect,{readOnly:readOnly,customer:customer,userList:userList,changeCustomer:changeCustomer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SunshinePhysicianSelect,{customer:customer,userList:userList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Supplier'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,name:'partnerSupplierId',valueList:supplierList,addEmpty:!customer.partnerSupplierId,renderer:function renderer(supplier){return supplier.displayName;},readOnly:readOnly,onChange:function onChange(name,value){changeCustomer('partnerTreatmentPlanerId',null);changeCustomer(name,value);},defaultValue:defaultSupplierId}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},isExternalTreatmentPlanerPossible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'External Treatment Planer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,name:'partnerTreatmentPlanerId',valueList:treatmentPlanerList,addEmpty:true,renderer:function renderer(supplier){return supplier.displayName;},readOnly:readOnly,onChange:function onChange(name,value){changeCustomer(name,value);}})))));};PhysicianAndSupplier.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,physicianList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,treatmentPlanerList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,userList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,supplierList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isExternalTreatmentPlanerPossible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (PhysicianAndSupplier);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
var TraySize=function TraySize(_ref){var readOnly=_ref.readOnly,customer=_ref.customer,changeCustomer=_ref.changeCustomer,saveCustomer=_ref.saveCustomer;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["_10" /* TRAY_SIZE_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Tray Size'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Upper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,name:'upperTraySize',valueList:__WEBPACK_IMPORTED_MODULE_7__state_detail_const__["g" /* SIZE_LIST */],addEmpty:!customer.upperTraySize,readOnly:readOnly,onChange:function onChange(name,value){changeCustomer(name,value);saveCustomer();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Lower'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:customer,name:'lowerTraySize',valueList:__WEBPACK_IMPORTED_MODULE_7__state_detail_const__["g" /* SIZE_LIST */],addEmpty:!customer.lowerTraySize,readOnly:readOnly,onChange:function onChange(name,value){changeCustomer(name,value);saveCustomer();}})))));};TraySize.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TraySize);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var HOURS_WORN={1:'1 - 22 hours or more',2:'18-21 hours',3:'less than 18 Stunden'};var ALIGNER_PRESSURE={0:'very weak',1:'weak',2:'somewhat weak',3:'medium',4:'strong',5:'very strong'// const META_DATA_KEYS = {
//     'hoursWore': 'hours worn',
//     'alignerPressureBegin': 'pressure at the beginning',
//     'alignerPressureEnd': 'pressure at the end',
//     'alignerChangeDate': 'change date',
// }
// const formatValue = (key, value) => {
//     switch (key) {
//         case 'hoursWore':
//             return HOURS_WORN[value]
//         case 'alignerPressureBegin':
//         case 'alignerPressureEnd':
//             return ALIGNER_PRESSURE[value]
//         default:
//             return value
//     }
// }
//
// const formatKey = (key) => {
//     return META_DATA_KEYS[key] || key
// }
// const AlignerCheckInMetaData = ({ metaData }) => {
//     let keyList = Object.keys(metaData)
//
//     return (
//         <table>
//             <tbody>
//             {keyList.map((key, index) => {
//                 return (
//                     <tr key={index}>
//                         <td>{formatKey(key)}</td>
//                         <td>{formatValue(key, metaData[key])}</td>
//                     </tr>)
//             })}
//             </tbody>
//         </table>)
// }
};var AlignerCheckIn=function AlignerCheckIn(_ref){var alignerCheckIn=_ref.alignerCheckIn;var meta=alignerCheckIn.metaData||{};var alignerChangeDateOld=__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(meta.alignerChangeDate,'DD.MM.YYYY',true);var alignerChangeDateNew=__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(meta.alignerChangeDate);var alignerChangeDate=alignerChangeDateOld.isValid()?alignerChangeDateOld:alignerChangeDateNew;var checkinDate=__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(alignerCheckIn.checkinDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerChangeDate.format('YYYY-MM-DD HH:mm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,checkinDate.format('YYYY-MM-DD HH:mm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerCheckIn.alignerNumberLower),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerCheckIn.alignerNumberUpper),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerCheckIn.newAlignerNumberLower),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerCheckIn.newAlignerNumberUpper),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,HOURS_WORN[meta.hoursWore]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ALIGNER_PRESSURE[meta.alignerPressureBegin]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ALIGNER_PRESSURE[meta.alignerPressureEnd]));};var TreatmentExecution=function TreatmentExecution(_ref2){var customer=_ref2.customer;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */])){return null;}if(!customer.treatmentExecutionList||!customer.treatmentExecutionList.length){return null;}var alignerCheckins=customer.treatmentExecutionList.reduce(function(previous,current){return previous.concat(current.alignerCheckInList);},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Treatment Execution'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'customer-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Aligner Change Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Checkin date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Lower'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Upper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'New Lower'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'New Upper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hours worn'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pressure Begin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pressure End'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,alignerCheckins.map(function(checkIn,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AlignerCheckIn,{key:index,alignerCheckIn:checkIn});}))))));};TreatmentExecution.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (TreatmentExecution);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var Feeback=function Feeback(_ref){var satisfactionScore=_ref.satisfactionScore,created=_ref.created,comment=_ref.comment,alignerNumberUpper=_ref.alignerNumberUpper,alignerNumberLower=_ref.alignerNumberLower;var date=__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(created).format('YYYY-MM-DD HH:mm');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerNumberLower),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,alignerNumberUpper),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,satisfactionScore),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{maxWidth:200}},comment));};var TreatmentFeedback=function TreatmentFeedback(_ref2){var customer=_ref2.customer;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */])){return null;}if(!customer.treatmentExecutionList||!customer.treatmentExecutionList.length){return null;}var feedbackList=customer.treatmentExecutionList.reduce(function(accumulator,current){return accumulator.concat(current.treatmentFeedbackList);},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Treatment Feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'customer-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Lower'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Upper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Satisfaction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Feedback'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,feedbackList.map(function(feedback,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Feeback,Object.assign({key:index},feedback));}))))));};TreatmentFeedback.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (TreatmentFeedback);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findByCustomerIdRequest */
/* unused harmony export findByCustomerIdSuccess */
/* unused harmony export findByCustomerIdError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findByCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleAnamnesis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleInfoLegend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_initialize_implant_consultation_and_findings__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anamnesis_initialize_implant_treatment_physician_assesment__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anamnesis_initialize_implant_surgery_documentation__ = __webpack_require__(520);
var findByCustomerIdRequest=function findByCustomerIdRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_BY_CUSTOMER_ID_REQUEST */],payload:{}};};var findByCustomerIdSuccess=function findByCustomerIdSuccess(anamnesisList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_BY_CUSTOMER_ID_SUCCESS */],payload:{anamnesisList:anamnesisList}};};var findByCustomerIdError=function findByCustomerIdError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FIND_BY_CUSTOMER_ID_ERROR */],payload:{error:error}};};var enrichCreatedByUser=function enrichCreatedByUser(state,anamnesis){return Object.assign({},anamnesis,{createdByUser:__WEBPACK_IMPORTED_MODULE_2__globals__["a" /* default */].selector.selectUserDisplayNameById(state,anamnesis.createdByUserId)});};var enrichAnamnesisList=function enrichAnamnesisList(state,anamnesisList){return anamnesisList.map(function(anamnesis){if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_4__anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]){anamnesis=Object(__WEBPACK_IMPORTED_MODULE_3__anamnesis_initialize_implant_consultation_and_findings__["a" /* default */])(anamnesis);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_4__anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]){anamnesis=Object(__WEBPACK_IMPORTED_MODULE_5__anamnesis_initialize_implant_treatment_physician_assesment__["a" /* default */])(anamnesis);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_4__anamnesis_const__["f" /* IMPLANT_SURGERY_DOCUMENTATION */]){anamnesis=Object(__WEBPACK_IMPORTED_MODULE_6__anamnesis_initialize_implant_surgery_documentation__["a" /* default */])(anamnesis);}anamnesis=enrichCreatedByUser(state,anamnesis);return anamnesis;});};var findByCustomerId=function findByCustomerId(customerId){return function(dispatch,getState){var state=getState();dispatch(findByCustomerIdRequest());// this endpoint return all anamnesis with customerId equals to the
// query-parma ordered by creation date DESC.
Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/anamnesis/find-by-customer-id?customerId='+customerId).then(function(anamnesisList){anamnesisList=enrichAnamnesisList(state,anamnesisList);dispatch(findByCustomerIdSuccess(anamnesisList));}).catch(function(error){dispatch(findByCustomerIdError(error));});};};var toggleAnamnesis=function toggleAnamnesis(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TOGGLE_ANAMNESIS */]};};var toggleInfoLegend=function toggleInfoLegend(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TOGGLE_INFO_LEGEND */]};};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(anamesis){if(!anamesis.formData){anamesis.formData={};}return anamesis;});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(anamesis){if(!anamesis.formData){anamesis.formData={};}if(!anamesis.formData.teethIndication){anamesis.formData.teethIndication={};}if(!anamesis.formData.additionalIndication){anamesis.formData.additionalIndication=null;}if(!anamesis.formData.treatmentExpectation){anamesis.formData.treatmentExpectation=[];}return anamesis;});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(anamesis){if(!anamesis.formData){anamesis.formData={};}return anamesis;});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(128);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]];};

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_Anamnesis__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__ = __webpack_require__(2);
var AnamnesisList=function AnamnesisList(_ref){var isUserFromCustomerStore=_ref.isUserFromCustomerStore,anamnesisList=_ref.anamnesisList,isIprReadOnly=_ref.isIprReadOnly,findOrCreateAnamnesis=_ref.findOrCreateAnamnesis,_ref$excludeTemplateK=_ref.excludeTemplateKeyList,excludeTemplateKeyList=_ref$excludeTemplateK===undefined?[]:_ref$excludeTemplateK,isIPRProviderStore=_ref.isIPRProviderStore,customerId=_ref.customerId,showAnamnesis=_ref.showAnamnesis,changeAnamnesis=_ref.changeAnamnesis,saveAnamnesis=_ref.saveAnamnesis,toggleAnamnesis=_ref.toggleAnamnesis,isInfoLegendShown=_ref.isInfoLegendShown,toggleInfoLegend=_ref.toggleInfoLegend;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */])){return null;}if(!anamnesisList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,anamnesisList.map(function(anamnesis){if(excludeTemplateKeyList.indexOf(anamnesis.templateKey)!==-1){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__anamnesis_Anamnesis__["a" /* default */],{skipAuthorization:true,key:anamnesis.id,findOrCreateAnamnesis:findOrCreateAnamnesis,isIPRProviderStore:isIPRProviderStore,isUserFromCustomerStore:isUserFromCustomerStore,anamnesis:anamnesis,readOnly:true,isIprReadOnly:isIprReadOnly,templateKey:anamnesis.templateKey,customerId:customerId,showAnamnesis:showAnamnesis,toggleAnamnesis:toggleAnamnesis,changeAnamnesis:changeAnamnesis,saveAnamnesis:saveAnamnesis,isInfoLegendShown:isInfoLegendShown,toggleInfoLegend:toggleInfoLegend});}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){var _props=this.props,findByCustomerId=_props.findByCustomerId,customerId=_props.customerId;findByCustomerId(customerId);}})(AnamnesisList));AnamnesisList.propTypes={isUserFromCustomerStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__renderer_AlignerTreatmentCustomerAssessment__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__renderer_AlignerTreatmentPhysicianAssessment__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__renderer_ImplantConslutationAndFindings__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__renderer_AlignerTreatmentMedical__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__renderer_AlignerTreatmentExpectation__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__renderer_ImplantTreatmentPhysicianAssessment__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__state_const__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__renderer_ImplantSurgeryDocumentation__ = __webpack_require__(1238);
var AnamnesisRenderer=function AnamnesisRenderer(props){var anamnesis=props.anamnesis;if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["a" /* ALIGNER_TREATMENT */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__renderer_AlignerTreatmentCustomerAssessment__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["g" /* IMPLANT_TREATMENT */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__renderer_AlignerTreatmentCustomerAssessment__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__renderer_AlignerTreatmentPhysicianAssessment__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["c" /* ALIGNER_TREATMENT_MEDICAL_INFORMATION */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__renderer_AlignerTreatmentMedical__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["b" /* ALIGNER_TREATMENT_EXPECTATION */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__renderer_AlignerTreatmentExpectation__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__renderer_ImplantConslutationAndFindings__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__renderer_ImplantTreatmentPhysicianAssessment__["a" /* default */],props);}if(anamnesis.templateKey===__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["f" /* IMPLANT_SURGERY_DOCUMENTATION */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__renderer_ImplantSurgeryDocumentation__["a" /* default */],props);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'no ',anamnesis.templateKey,' renderer for');};var Author=function Author(_ref){var anamnesis=_ref.anamnesis;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},anamnesis.createdByUser||'',' ',Object(__WEBPACK_IMPORTED_MODULE_13__util_datetime__["c" /* formatDateTime */])(anamnesis.created))));};var Anamnesis=function Anamnesis(props){var anamnesis=props.anamnesis,_props$skipAuthorizat=props.skipAuthorization,skipAuthorization=_props$skipAuthorizat===undefined?false:_props$skipAuthorizat;if(!skipAuthorization&&!Object(__WEBPACK_IMPORTED_MODULE_15__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__process_ui_definition_process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */])){return null;}if(!anamnesis){return null;}var title=__WEBPACK_IMPORTED_MODULE_14__state_const__["a" /* ANAMNESIS_TITLE */][anamnesis.templateKey];var shouldRenderHeader=anamnesis.templateKey!==__WEBPACK_IMPORTED_MODULE_3__state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:title},shouldRenderHeader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Author,props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AnamnesisRenderer,props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){var _props=this.props,anamnesis=_props.anamnesis,templateKey=_props.templateKey,customerId=_props.customerId,findOrCreateAnamnesis=_props.findOrCreateAnamnesis;if(!anamnesis&&templateKey&&findOrCreateAnamnesis){findOrCreateAnamnesis(customerId,templateKey);}}})(Anamnesis));Anamnesis.propTypes={skipAuthorization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IPRInstructionList__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_SelectChip__ = __webpack_require__(108);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var IPR_NOT_NEEDED_VALUE=[{value:false,label:'IPR needed'},{value:true,label:'IPR not needed'}];var IPRInstructions=function IPRInstructions(_ref){var treatmentPlan=_ref.treatmentPlan,context=_ref.context,readOnly=_ref.readOnly,isWidget=_ref.isWidget,changeTreatmentPlan=_ref.changeTreatmentPlan,changeIPRInstruction=_ref.changeIPRInstruction,saveTreatmentPlan=_ref.saveTreatmentPlan,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,isIPRProviderStore=_ref.isIPRProviderStore;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isVisible=_useState2[0],setIsVisible=_useState2[1];if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */])){return null;}if(!isIPRProviderStore){return null;}var iprInstructionList=treatmentPlan.iprInstructionList;var iprNotDecided=context[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["e" /* IPR_NOT_REQUIRED */]]===undefined;var iprNotRequired=context[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["e" /* IPR_NOT_REQUIRED */]];// workaround for Reduce Enamel task where we are not going to edit this values
// but the value must be displayed properly
var vContext=Object.assign({},context);if(readOnly&&iprNotDecided){vContext[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["e" /* IPR_NOT_REQUIRED */]]=!iprInstructionList;}// workaround for inconsistent data, when we have instructions,
// but don't have IPR_NOT_REQUIRED in context
// to be removed when
if(isWidget&&iprNotDecided&&iprInstructionList){changeProcessContext(__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["e" /* IPR_NOT_REQUIRED */],false);saveProcessContext();vContext[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["e" /* IPR_NOT_REQUIRED */]]=false;context[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["g" /* IS_IPR_INSTRUCTIONS_LIST_SAVED */]]=false;}var toggleEditButtons=function toggleEditButtons(){setIsVisible(!isVisible);};var ButtonGroup=function ButtonGroup(){var btnStyle={marginRight:'10px'};var onCancel=function onCancel(){toggleEditButtons();};var onSave=function onSave(){saveTreatmentPlan();toggleEditButtons();context[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["g" /* IS_IPR_INSTRUCTIONS_LIST_SAVED */]]=true;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:onSave},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default pull-right',style:btnStyle,onClick:onCancel},'Cancel'));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'additional-instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'IPR(ASR) instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},!isVisible&&!iprNotRequired&&!readOnly&&!iprNotDecided&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:toggleEditButtons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-edit','aria-hidden':'true'})),isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup,null))),isWidget&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_SelectChip__["a" /* default */],{object:vContext,name:__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["e" /* IPR_NOT_REQUIRED */],readOnly:readOnly,addEmpty:true,valueList:IPR_NOT_NEEDED_VALUE,onChange:function onChange(name,value){if(value){changeTreatmentPlan('iprInstructionList',null);context[__WEBPACK_IMPORTED_MODULE_6__state_plan_const__["g" /* IS_IPR_INSTRUCTIONS_LIST_SAVED */]]=false;}else{changeTreatmentPlan('iprInstructionList',{});}saveTreatmentPlan();changeProcessContext(name,value);saveProcessContext();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__IPRInstructionList__["a" /* default */],{readOnly:readOnly||iprNotRequired||iprNotDecided||!isVisible,changeIPRInstruction:changeIPRInstruction,iprInstructionList:iprInstructionList})))));};IPRInstructions.propTypes={treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({iprInstructionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,iprPossible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}).isRequired,isWidget:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeIPRInstruction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (IPRInstructions);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PatientIPRWishesWidget__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__anamnesis_state_anamnesis_action__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anamnesis_state_list_selector__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_task_detail_selector__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(state,props){var customer=Object(__WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__["c" /* selectCustomer */])(state);var anamnesis=Object(__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_list_selector__["b" /* selectLastMedicalAssessment */])(state);if(props.taskName==='medical_assessment'){anamnesis=Object(__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__["d" /* selectMedicalAssessment */])(state);}return{anamnesis:anamnesis,readOnly:Object(__WEBPACK_IMPORTED_MODULE_7__state_task_detail_selector__["f" /* selectIsTaskReadOnly */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__["c" /* selectIsFetching */])(state),isIPRProviderStore:Object(__WEBPACK_IMPORTED_MODULE_2__globals_state_selector__["isIPRProviderStore"])(state,customer.store),taskName:props.taskName||''};};var mapDispatchToProps={changeAnamnesis:__WEBPACK_IMPORTED_MODULE_4__anamnesis_state_anamnesis_action__["a" /* changeAnamnesis */],saveAnamnesis:__WEBPACK_IMPORTED_MODULE_4__anamnesis_state_anamnesis_action__["c" /* saveAnamnesis */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PatientIPRWishesWidget__["a" /* default */]));

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_memoize__ = __webpack_require__(1244);





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["h" /* peek */])(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["o" /* token */])(character)) {
      break;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["g" /* next */])();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["m" /* slice */])(begin, __WEBPACK_IMPORTED_MODULE_1_stylis__["i" /* position */]);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["o" /* token */])(character)) {
      case 0:
        // &\f
        if (character === 38 && Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["h" /* peek */])() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(__WEBPACK_IMPORTED_MODULE_1_stylis__["i" /* position */] - 1, points, index);
        break;

      case 2:
        parsed[index] += Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["d" /* delimit */])(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["h" /* peek */])() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["e" /* from */])(character);
    }
  } while (character = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["g" /* next */])());

  return parsed;
};

var getRules = function getRules(value, points) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["c" /* dealloc */])(toRules(Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["a" /* alloc */])(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["j" /* prefixer */]];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  {
    var currentSheet;
    var finalizingPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["n" /* stringify */],  false ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["k" /* rulesheet */])(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["f" /* middleware */])(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["l" /* serialize */])(Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["b" /* compile */])(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Emotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __unsafe_useEmotionCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createEmotionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return useInsertionEffectMaybe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return withEmotionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_cache__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isolated_hnrs_dist_emotion_react_isolated_hnrs_browser_esm_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_utils__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_serialize__ = __webpack_require__(530);









var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_cache__["a" /* default */])({
  key: 'css'
}) : null);

if (false) {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
    // the cache will never be null in the browser
    var cache = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});

if (false) {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var useTheme = function useTheme() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (false) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (outerTheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext);
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return Object(__WEBPACK_IMPORTED_MODULE_4__isolated_hnrs_dist_emotion_react_isolated_hnrs_browser_esm_js__["a" /* default */])(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var useInsertionEffect = __WEBPACK_IMPORTED_MODULE_0_react__['useInsertion' + 'Effect'] ? __WEBPACK_IMPORTED_MODULE_0_react__['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  Object(__WEBPACK_IMPORTED_MODULE_5__emotion_utils__["c" /* registerStyles */])(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5__emotion_utils__["b" /* insertStyles */])(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_6__emotion_serialize__["a" /* serializeStyles */])(registeredStyles, undefined, Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext));

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, newProps));
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
}




/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics = (function (targetComponent, sourceComponent) {
  return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(targetComponent, sourceComponent);
});

/* harmony default export */ __webpack_exports__["a"] = (hoistNonReactStatics);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return registerStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(1248);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_image_gallery__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_image_gallery_styles_css_image_gallery_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_image_gallery_styles_css_image_gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_image_gallery_styles_css_image_gallery_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_component_ToggleButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DeleteModal__ = __webpack_require__(1261);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DOWNLOAD_URL=__WEBPACK_IMPORTED_MODULE_9__util_api__["a" /* BACKEND_URL */]+'/api/customer/download-images?customerId=';var moment=__webpack_require__(38);var deleteStyle={float:'right'};var style={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'60px'};var ROTATE_CSS={0:'rotate-0',90:'rotate-90',180:'rotate-180',270:'rotate-270'};var RenderDeleteImage=function RenderDeleteImage(_ref){var fileId=_ref.fileId,imageType=_ref.imageType,versionId=_ref.versionId,deleteCustomerImage=_ref.deleteCustomerImage;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showConfirmationModal=_useState2[0],setShowConfirmationModal=_useState2[1];var handleOnClick=function handleOnClick(){setShowConfirmationModal(true);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',style:deleteStyle,onClick:handleOnClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'glyphicon glyphicon-trash'},' Delete ')),showConfirmationModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DeleteModal__["a" /* default */],{processDelete:function processDelete(){return deleteCustomerImage(fileId,imageType,versionId);},isOpen:showConfirmationModal,handleClose:function handleClose(){return setShowConfirmationModal(false);}}));};var renderImage=function renderImage(_ref2){var rotateCustomerImage=_ref2.rotateCustomerImage,customerId=_ref2.customerId,setImageTypeMetaData=_ref2.setImageTypeMetaData,lastModified=_ref2.lastModified,fileId=_ref2.fileId,versionId=_ref2.versionId,originalImageType=_ref2.originalImageType,original=_ref2.original,rotate=_ref2.rotate,image=_ref2.image,path=_ref2.path,deleteCustomerImage=_ref2.deleteCustomerImage,showDeleteImage=_ref2.showDeleteImage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-slider-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inline-block vertical-align-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge'},lastModified)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inline-block vertical-align-top image-slide-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__form_component_Select__["a" /* default */],{object:{},name:'name',addEmpty:true,style:{height:'18px'},valueList:__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["c" /* IMAGE_TYPE_SELECT */],onChange:function onChange(name,newImageType){if(!newImageType||newImageType===image.name){return;}setImageTypeMetaData(customerId,originalImageType,versionId,path,newImageType);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inline-block vertical-align-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'customer-image-rotate-icon fa fa-rotate-left',onClick:function onClick(event){event.stopPropagation();event.preventDefault();rotateCustomerImage(originalImageType,versionId,-90);}}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'customer-image-rotate-icon fa fa-rotate-right',onClick:function onClick(event){event.stopPropagation();event.preventDefault();rotateCustomerImage(originalImageType,versionId,90);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:ROTATE_CSS[rotate],src:original,alt:''})),showDeleteImage&&fileId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderDeleteImage,{fileId:fileId,deleteCustomerImage:deleteCustomerImage,imageType:originalImageType,versionId:versionId}));};var renderThumbnail=function renderThumbnail(_ref3){var original=_ref3.original,rotate=_ref3.rotate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflow:'hidden',display:'flex',justifyContent:'center',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:ROTATE_CSS[rotate],src:original,alt:''}));};var VersionedImageGallery=function VersionedImageGallery(_ref4){var versionImageList=_ref4.versionImageList,rotateCustomerImage=_ref4.rotateCustomerImage,image=_ref4.image,setImageTypeMetaData=_ref4.setImageTypeMetaData,customerId=_ref4.customerId,deleteCustomerImage=_ref4.deleteCustomerImage,showDeleteImage=_ref4.showDeleteImage;if(!versionImageList){return null;}versionImageList.sort(function(a,b){a=a.lastModified;b=b.lastModified;if(!a&&!b){return 0;}if(!a&&b){return-1;}if(a&&!b){return 1;}return moment(a).unix()-moment(b).unix();});var imageList=versionImageList.map(function(version){return{path:version.path,original:__WEBPACK_IMPORTED_MODULE_9__util_api__["a" /* BACKEND_URL */]+version.link,thumbnail:__WEBPACK_IMPORTED_MODULE_9__util_api__["a" /* BACKEND_URL */]+version.link,lastModified:Object(__WEBPACK_IMPORTED_MODULE_14__util_datetime__["c" /* formatDateTime */])(version.lastModified),fileName:image.name,fileId:version.fileId,versionId:version.versionId,rotate:version.meta&&version.meta.rotate?version.meta.rotate:0,originalImageType:version.originalImageType,image:image,rotateCustomerImage:rotateCustomerImage,setImageTypeMetaData:setImageTypeMetaData,customerId:customerId,deleteCustomerImage:deleteCustomerImage,showDeleteImage:showDeleteImage};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_image_gallery___default.a,{startIndex:imageList.length-1,renderItem:renderImage,infinite:false,items:imageList,renderThumbInner:renderThumbnail,showFullscreenButton:false});};var VersionedImage=function VersionedImage(_ref5){var image=_ref5.image,versionImageList=_ref5.versionImageList,customerId=_ref5.customerId,uploadCustomerImage=_ref5.uploadCustomerImage,rotateCustomerImage=_ref5.rotateCustomerImage,setImageTypeMetaData=_ref5.setImageTypeMetaData,deleteCustomerImage=_ref5.deleteCustomerImage,showDeleteImage=_ref5.showDeleteImage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],{size:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,image.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VersionedImageGallery,{image:image,customerId:customerId,rotateCustomerImage:rotateCustomerImage,setImageTypeMetaData:setImageTypeMetaData,versionImageList:versionImageList,deleteCustomerImage:deleteCustomerImage,showDeleteImage:showDeleteImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__["a" /* default */],{multiple:false,accept:'image/*',maxSize:__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["d" /* MAX_IMAGE_SIZE */],style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadCustomerImage(fileList,image.name,customerId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload a picture'))));};var ImageDownload=function ImageDownload(_ref6){var imageVersionList=_ref6.imageVersionList,customerId=_ref6.customerId;if(!imageVersionList||Object.keys(imageVersionList).length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:DOWNLOAD_URL+customerId},'download')));};var VersionedImageList=function VersionedImageList(_ref7){var canSeeImages=_ref7.canSeeImages,setImageTypeMetaData=_ref7.setImageTypeMetaData,imageVersionList=_ref7.imageVersionList,uploadCustomerImage=_ref7.uploadCustomerImage,deleteCustomerImage=_ref7.deleteCustomerImage,rotateCustomerImage=_ref7.rotateCustomerImage,customerId=_ref7.customerId,showImages=_ref7.showImages,showDeleteImage=_ref7.showDeleteImage,toggleImageView=_ref7.toggleImageView,_ref7$skipImages=_ref7.skipImages,skipImages=_ref7$skipImages===undefined?[]:_ref7$skipImages;if(!Object(__WEBPACK_IMPORTED_MODULE_17__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__process_ui_definition_process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */])){return null;}if(!canSeeImages){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],{size:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Patient Photos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],{size:4,className:'align-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__form_component_ToggleButton__["a" /* default */],{toggle:toggleImageView,active:showImages,activeIcon:'fa fa-search-minus',inactiveIcon:'fa fa-search-plus'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageDownload,{imageVersionList:imageVersionList,customerId:customerId}),showImages&&__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["a" /* DEFINED_IMAGE_LIST */].map(function(image,index){if(skipImages.includes(image.name)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VersionedImage,{key:index,image:image,customerId:customerId,setImageTypeMetaData:setImageTypeMetaData,rotateCustomerImage:rotateCustomerImage,uploadCustomerImage:uploadCustomerImage,deleteCustomerImage:deleteCustomerImage,versionImageList:imageVersionList[image.name],showDeleteImage:showDeleteImage});})));};VersionedImageList.propTypes={customerId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,findImageVersion:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,deleteCustomerImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,showImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,toggleImageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,canSeeImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,skipImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["a" /* DEFINED_IMAGE_LIST */].map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('name')))),imageVersionList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,showDeleteImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findImageVersion(this.props.customerId);}})(VersionedImageList));

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectInvoice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(534);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectInvoice=function selectInvoice(state){return selectOwnState(state).invoice;};

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(159);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
var ConfirmationModal=function ConfirmationModal(_ref){var showModal=_ref.showModal,cancelClicked=_ref.cancelClicked,confirmClicked=_ref.confirmClicked,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:showModal,className:'confirmation-modal',overlayClassName:'confirmation-modal-overlay',onRequestClose:cancelClicked,contentLabel:'Confirmation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:confirmClicked},'Yes'),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm',onClick:cancelClicked},'Cancel')));};ConfirmationModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,confirmClicked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,cancelClicked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConfirmationModal);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDataTransferFiles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDroppedOrSelectedFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sortProductionFilesByName; });
/* THIS IS A CLONE OF html5-file-selector package */var DEFAULT_FILES_TO_IGNORE=['.DS_Store',// OSX indexing file
'Thumbs.db'// Windows indexing file
];// map of common (mostly media types) mime types to use when the browser does not supply the mime type
var EXTENSION_TO_MIME_TYPE_MAP={avi:'video/avi',gif:'image/gif',ico:'image/x-icon',jpeg:'image/jpeg',jpg:'image/jpeg',mkv:'video/x-matroska',mov:'video/quicktime',mp4:'video/mp4',pdf:'application/pdf',png:'image/png',zip:'application/zip'};function shouldIgnoreFile(file){return DEFAULT_FILES_TO_IGNORE.indexOf(file.name)>=0;}function copyString(aString){return(' '+aString).slice(1);}function traverseDirectory(entry){var reader=entry.createReader();// Resolved when the entire directory is traversed
return new Promise(function(resolveDirectory){var iterationAttempts=[];var errorHandler=function errorHandler(){};function readEntries(){// According to the FileSystem API spec, readEntries() must be called until
// it calls the callback with an empty array.
reader.readEntries(function(batchEntries){if(!batchEntries.length){// Done iterating this particular directory
resolveDirectory(Promise.all(iterationAttempts));}else{// Add a list of promises for each directory entry.  If the entry is itself
// a directory, then that promise won't resolve until it is fully traversed.
iterationAttempts.push(Promise.all(batchEntries.map(function(batchEntry){if(batchEntry.isDirectory){// return traverseDirectory(batchEntry);
return Promise.resolve([]);}return Promise.resolve(batchEntry);})));// Try calling readEntries() again for the same dir, according to spec
readEntries();}},errorHandler);}// initial call to recursive entry reader function
readEntries();});}// package the file in an object that includes the fullPath from the file entry
// that would otherwise be lost
function packageFile(file,entry){var fileTypeOverride='';// handle some browsers sometimes missing mime types for dropped files
var hasExtension=file.name&&file.name.lastIndexOf('.')!==-1;if(hasExtension&&!file.type){var fileExtension=(file.name||'').split('.').pop();fileTypeOverride=EXTENSION_TO_MIME_TYPE_MAP[fileExtension];}return{fileObject:file,// provide access to the raw File object (required for uploading)
fullPath:entry?copyString(entry.fullPath):file.name,lastModified:file.lastModified,lastModifiedDate:file.lastModifiedDate,name:file.name,size:file.size,type:file.type?file.type:fileTypeOverride,webkitRelativePath:file.webkitRelativePath};}function getFile(entry){return new Promise(function(resolve){entry.file(function(file){resolve(packageFile(file,entry));});});}function handleFilePromises(promises,fileList){return Promise.all(promises).then(function(files){files.forEach(function(file){if(!shouldIgnoreFile(file)){fileList.push(file);}});return fileList;});}function getDataTransferFiles(dataTransfer){var dataTransferFiles=[];var folderPromises=[];var filePromises=[];[].slice.call(dataTransfer.items).forEach(function(listItem){if(typeof listItem.webkitGetAsEntry==='function'){var entry=listItem.webkitGetAsEntry();if(entry){if(entry.isDirectory){folderPromises.push(traverseDirectory(entry));}else{filePromises.push(getFile(entry));}}}else{dataTransferFiles.push(listItem);}});if(folderPromises.length){var flatten=function flatten(array){return array.reduce(function(a,b){return a.concat(Array.isArray(b)?flatten(b):b);},[]);};return Promise.all(folderPromises).then(function(fileEntries){var flattenedEntries=flatten(fileEntries);// collect async promises to convert each fileEntry into a File object
flattenedEntries.forEach(function(fileEntry){filePromises.push(getFile(fileEntry));});return handleFilePromises(filePromises,dataTransferFiles);});}else if(filePromises.length){return handleFilePromises(filePromises,dataTransferFiles);}return Promise.resolve(dataTransferFiles);}/**
 * This function should be called from both the onDrop event from your drag/drop
 * dropzone as well as from the HTML5 file selector input field onChange event
 * handler.  Pass the event object from the triggered event into this function.
 * Supports mix of files and folders dropped via drag/drop.
 *
 * Returns: an array of File objects, that includes all files within folders
 *   and subfolders of the dropped/selected items.
 */function getDroppedOrSelectedFiles(event){var dataTransfer=event.dataTransfer;if(dataTransfer&&dataTransfer.items){return getDataTransferFiles(dataTransfer).then(function(fileList){return Promise.resolve(fileList);});}var files=[];var dragDropFileList=dataTransfer&&dataTransfer.files;var inputFieldFileList=event.target&&event.target.files;var fileList=dragDropFileList||inputFieldFileList||[];// convert the FileList to a simple array of File objects
for(var i=0;i<fileList.length;i++){files.push(packageFile(fileList[i]));}return Promise.resolve(files);}/**
 * Html5 File Selector
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 *///# sourceMappingURL=index.es.js.map
/**
 *  Sorting callback for sorting Production Files in CustomerFileUpload Widget
 */function sortProductionFilesByName(a,b){var PARSE_INT_RADIX=10;var SPLIT_NAME_NUMBER_INDEX=1;var firstSplit=a.fileName.split('-');var secondSplit=b.fileName.split('-');var numA=parseInt(firstSplit[SPLIT_NAME_NUMBER_INDEX],PARSE_INT_RADIX);var numB=parseInt(secondSplit[SPLIT_NAME_NUMBER_INDEX],PARSE_INT_RADIX);if(numA!==numB){return numA-numB;}var jawA=firstSplit[firstSplit.length-1];var jawB=secondSplit[secondSplit.length-1];return jawA.localeCompare(jawB);}

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_cbct_file_upload_action__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_cbct_file_upload_selector__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CbctFileUpload__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_detail_selector__ = __webpack_require__(13);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_cbct_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_6__state_detail_selector__["c" /* selectCustomer */](state),fetching:__WEBPACK_IMPORTED_MODULE_3__state_cbct_file_upload_selector__["a" /* selectIsFetching */](state),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["a" /* FILE_TYPE_CBCT_FILE */],tableSetting:__WEBPACK_IMPORTED_MODULE_3__state_cbct_file_upload_selector__["c" /* selectTableSetting */](state)});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_cbct_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_cbct_file_upload_action__["b" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */],changeTableSetting:__WEBPACK_IMPORTED_MODULE_1__state_cbct_file_upload_action__["a" /* changeTableSetting */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CbctFileUpload__["a" /* default */]));

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_component_scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__ = __webpack_require__(32);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__customer_state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */](state),readOnly:true,fetching:__WEBPACK_IMPORTED_MODULE_2__customer_state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_3__customer_state_const__["c" /* FILE_TYPE_CUSTOMS_INVOICE */]),widgetId:__WEBPACK_IMPORTED_MODULE_4__process_ui_definition_process_ui__["w" /* CUSTOMS_INVOICE_LIST_WIDGET */],fileType:__WEBPACK_IMPORTED_MODULE_3__customer_state_const__["c" /* FILE_TYPE_CUSTOMS_INVOICE */]});};var mapDispatchToProps={setDeleteFlag:__WEBPACK_IMPORTED_MODULE_6__customer_state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__customer_component_scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectSipGateDeviceId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(219);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectEmployee=function selectEmployee(state){return selectOwnState(state).employee;};var selectSipGateDeviceId=function selectSipGateDeviceId(state){var employee=selectEmployee(state);return employee.sipGateDeviceId;};

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* unused harmony export selectUnassignedPaymentList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCurrentPayment; });
/* unused harmony export selectTableSetting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectUnassignedPaymentList=function selectUnassignedPaymentList(state){return selectOwnState(state).paymentList;};var selectCurrentPayment=function selectCurrentPayment(state){return selectOwnState(state).payment;};var selectTableSetting=Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(115);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["b" /* REDUCER_NAME */]];};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
var CustomerLink=function CustomerLink(_ref){var customer=_ref.customer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/customer/edit/'+customer.id},customer.firstName+' '+customer.lastName);};CustomerLink.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (CustomerLink);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_money__ = __webpack_require__(86);
var SalesOrderPriceTable=function SalesOrderPriceTable(_ref){var salesOrder=_ref.salesOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-price-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Brut'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_money__["b" /* formatMoney */])(salesOrder.brutPrice,salesOrder.currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Net'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_money__["b" /* formatMoney */])(salesOrder.netPrice,salesOrder.currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'VAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_money__["b" /* formatMoney */])(salesOrder.vat,salesOrder.currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Voucher'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.voucherCode||'none'))));};SalesOrderPriceTable.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderPriceTable);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_const__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_money__ = __webpack_require__(86);
var SEPA_XML_DOWNLOAD=__WEBPACK_IMPORTED_MODULE_3__util_api__["a" /* BACKEND_URL */]+'/api/sepa/download-sepa-xml?sepaMandateId=';var StripeSubscription=function StripeSubscription(_ref){var salesOrder=_ref.salesOrder;var stripeSubscription=salesOrder.stripeSubscription;if(!stripeSubscription){return null;}var treatmentQuotation=salesOrder.treatmentQuotation;var rateDetails=treatmentQuotation?treatmentQuotation.rateCount+' x '+Object(__WEBPACK_IMPORTED_MODULE_5__util_money__["b" /* formatMoney */])(treatmentQuotation.rateMonthly,treatmentQuotation.currency):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ratepay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rateDetails)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Name on card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,stripeSubscription.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,stripeSubscription.brand+' ****'+stripeSubscription.last4+' valid until '+stripeSubscription.expMonth+'/'+stripeSubscription.expYear)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Subscription'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://dashboard.stripe.com/subscriptions/'+stripeSubscription.stripeId,target:'_blank',rel:'noopener noreferrer'},stripeSubscription.stripeId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Plan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://dashboard.stripe.com/plans/'+stripeSubscription.planId,target:'_blank',rel:'noopener noreferrer'},stripeSubscription.planId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'}))))));};var StripeTransaction=function StripeTransaction(_ref2){var salesOrder=_ref2.salesOrder;var stripeTransaction=salesOrder.stripeTransaction;if(!stripeTransaction){return null;}var cardInfo=stripeTransaction.brand+' ****'+stripeTransaction.last4+' valid until '+stripeTransaction.expMonth+'/'+stripeTransaction.expYear;var isCardTransaction=stripeTransaction.paymentMethod==='credit_card';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ratepay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'no')),isCardTransaction&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Name on card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,stripeTransaction.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,cardInfo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Transaction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://dashboard.stripe.com/payments/'+stripeTransaction.transactionId,target:'_blank',rel:'noopener noreferrer'},stripeTransaction.transactionId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'}))))));};var PledgPayment=function PledgPayment(_ref3){var salesOrder=_ref3.salesOrder,pledgPayment=_ref3.pledgPayment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.rateCount,' months ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Charge ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,pledgPayment.chargeId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Reference'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,pledgPayment.reference))));};var ZabPayment=function ZabPayment(_ref4){var zabPayment=_ref4.zabPayment,currency=_ref4.currency;var isRatePay=zabPayment.paymentMethod==='zab_ratepay';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][zabPayment.paymentMethod])),isRatePay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms (Sunshine)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,zabPayment.rateCount+' x ',' ',Object(__WEBPACK_IMPORTED_MODULE_5__util_money__["b" /* formatMoney */])(zabPayment.rateMonthly,currency),' ')),isRatePay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms (incl. Physician)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,zabPayment.rateCount+' x ',' ',Object(__WEBPACK_IMPORTED_MODULE_5__util_money__["b" /* formatMoney */])(zabPayment.rateMonthlyTotal,currency),' '))));};var TabeoPayment=function TabeoPayment(_ref5){var tabeoPayment=_ref5.tabeoPayment;var isRatePay=tabeoPayment.paymentMethod==='tabeo_ratepay';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][tabeoPayment.paymentMethod])),isRatePay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,tabeoPayment.rateCount,' months '))));};var ChrysalisPayment=function ChrysalisPayment(_ref6){var salesOrder=_ref6.salesOrder;var isRatePay=salesOrder.paymentMethod===__WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__["a" /* PAYMENT_METHOD_CHRYSALIS_RATE_PAY */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod])),isRatePay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.rateCount,' months '))));};var SplititPayment=function SplititPayment(_ref7){var splititPayment=_ref7.splititPayment;var isRatePay=splititPayment.paymentMethod==='splitit_ratepay';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][splititPayment.paymentMethod])),isRatePay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,splititPayment.rateCount,' months '))));};var PagaMasTardePayment=function PagaMasTardePayment(_ref8){var pagaMasTardePayment=_ref8.pagaMasTardePayment;var isRatePay=pagaMasTardePayment.paymentMethod==='pagamastarde_ratepay';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][pagaMasTardePayment.paymentMethod])),isRatePay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Terms '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,pagaMasTardePayment.rateCount,' months '))));};var PrePayment=function PrePayment(_ref9){var salesOrder=_ref9.salesOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod]))));};var KlarnaPayment=function KlarnaPayment(_ref10){var salesOrder=_ref10.salesOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod]))));};var SepaDetails=function SepaDetails(_ref11){var salesOrder=_ref11.salesOrder;var treatmentQuotation=salesOrder.treatmentQuotation;var rateDetails=treatmentQuotation?treatmentQuotation.rateCount+' x '+Object(__WEBPACK_IMPORTED_MODULE_5__util_money__["b" /* formatMoney */])(treatmentQuotation.rateMonthly,treatmentQuotation.currency):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ratepay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.isRatePay?rateDetails:'no')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'IBAN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.iban)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Account Owner'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.accountOwner)),salesOrder.sepaMandate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Sepa Mandate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:SEPA_XML_DOWNLOAD+salesOrder.sepaMandate.id},'download')))));};var getPayPalId=function getPayPalId(_ref12){var paymentExecution=_ref12.paymentExecution;if(!paymentExecution){return null;}var transactions=paymentExecution.transactions;if(!transactions){return null;}var transaction=transactions[0];if(!transaction){return null;}var related_resources=transaction.related_resources;if(!related_resources){return null;}var related_resource=related_resources[0];if(!related_resource){return null;}var sale=related_resource.sale;if(!sale){return null;}return sale.id;};var PayPalPaymentDetails=function PayPalPaymentDetails(_ref13){var salesOrder=_ref13.salesOrder;var payPalPayment=salesOrder.payPalPayment;if(!payPalPayment){return null;}var payPalId=getPayPalId(payPalPayment);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Transaction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.paypal.com/activity/payment/'+payPalId,target:'_blank',rel:'noopener noreferrer'},payPalId,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'}))))));};var SalesOrderPaymentDetails=function SalesOrderPaymentDetails(_ref14){var salesOrder=_ref14.salesOrder;if(salesOrder.pledgPayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PledgPayment,{pledgPayment:salesOrder.pledgPayment,salesOrder:salesOrder});}if(salesOrder.zabPayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZabPayment,{zabPayment:salesOrder.zabPayment,currency:salesOrder.currency});}if(salesOrder.tabeoPayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabeoPayment,{tabeoPayment:salesOrder.tabeoPayment});}if(salesOrder.paymentMethod===__WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__["a" /* PAYMENT_METHOD_CHRYSALIS_RATE_PAY */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChrysalisPayment,{salesOrder:salesOrder});}if(salesOrder.splititPayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SplititPayment,{splititPayment:salesOrder.splititPayment});}if(salesOrder.pagaMasTardePayment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PagaMasTardePayment,{pagaMasTardePayment:salesOrder.pagaMasTardePayment});}if(salesOrder.paymentMethod===__WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__["g" /* PAYMENT_METHOD_PREPAYMENT */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrePayment,{salesOrder:salesOrder});}if(salesOrder.paymentMethod===__WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__["c" /* PAYMENT_METHOD_KLARNA */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(KlarnaPayment,{salesOrder:salesOrder});}if(salesOrder.paymentMethod===__WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__["h" /* PAYMENT_METHOD_SEPA */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SepaDetails,{salesOrder:salesOrder});}if(salesOrder.paymentMethod===__WEBPACK_IMPORTED_MODULE_2__constant_sales_order_constant__["d" /* PAYMENT_METHOD_PAYPAL */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PayPalPaymentDetails,{salesOrder:salesOrder});}if(salesOrder.stripeTransaction||salesOrder.stripeSubscription){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StripeTransaction,{salesOrder:salesOrder}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StripeSubscription,{salesOrder:salesOrder}));}return null;};SalesOrderPaymentDetails.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderPaymentDetails);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var SalesOrderCustomer=function SalesOrderCustomer(_ref){var contact=_ref.contact,salesOrderCustomer=_ref.salesOrderCustomer,callNumber=_ref.callNumber,salutationList=_ref.salutationList,changeCustomerContact=_ref.changeCustomerContact,saveCustomerContact=_ref.saveCustomerContact,hydrateContact=_ref.hydrateContact,error=_ref.error;if(!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */])){return null;}var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),readOnly=_useState2[0],setReadOnly=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isVisible=_useState4[0],setIsVisible=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState6=_slicedToArray(_useState5,2),validationMsgList=_useState6[0],setValidationMsgList=_useState6[1];function validate(e){if(e.value.length===0||!e.value.trim()){setValidationMsgList(Object.assign({},validationMsgList,_defineProperty({},e.name,'Is mandatory field, please fill before save')));return;}if(validationMsgList[e.name]){setValidationMsgList(Object.assign({},validationMsgList,_defineProperty({},e.name,null)));}}function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var res=re.test(String(email).trim().toLowerCase());if(!res){setValidationMsgList(Object.assign({},validationMsgList,{email:'email format not valid, please use a valid email'}));return;}if(validationMsgList.email){setValidationMsgList(Object.assign({},validationMsgList,{email:null}));}}var toggleEditButtons=function toggleEditButtons(){setReadOnly(!readOnly);setIsVisible(!isVisible);};var ButtonGroup=function ButtonGroup(){var btnStyle={marginRight:'10px'};var onCancel=function onCancel(){toggleEditButtons();hydrateContact();setValidationMsgList({});};var onSave=function onSave(){if(!checkValidationMsgList()){return;}saveCustomerContact();toggleEditButtons();};function checkValidationMsgList(){return Object.values(validationMsgList).every(function(currentValue){return currentValue===null;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:onSave},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default pull-right',style:btnStyle,onClick:onCancel},'Cancel'));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Sales Order Customer '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},error)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},!isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary pull-right',onClick:toggleEditButtons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-edit','aria-hidden':'true'})),isVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Salutation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:contact,name:'gender',readOnly:readOnly,valueList:salutationList,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Firstname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'firstName',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){return validate(e.target);}})),validationMsgList.firstName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.firstName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Lastname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'lastName',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){return validate(e.target);}})),validationMsgList.lastName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.lastName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Street address',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'streetAddress',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Street address extension',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,readOnly:readOnly,name:'streetAddressExtension',onChange:changeCustomerContact})))),salesOrderCustomer.countryCode==='AT'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Staircase',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'staircase',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Door',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'door',readOnly:readOnly,onChange:changeCustomerContact})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'ZIP',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'zip',readOnly:readOnly,onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'City',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'city',readOnly:readOnly,onChange:changeCustomerContact})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Country'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:contact,addEmpty:!salesOrderCustomer.countryCode,name:'countryCode',readOnly:readOnly,valueList:__WEBPACK_IMPORTED_MODULE_8__internationalization_const__["e" /* COUNTRY_CODE_LIST */],onChange:changeCustomerContact}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Email',groupAddOnIcon:'fa fa-envelope'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'email',readOnly:readOnly,onChange:changeCustomerContact,onBlur:function onBlur(e){validateEmail(e.target.value.trim());}}),validationMsgList.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},validationMsgList.email))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Phone',groupAddOnIcon:'fa fa-phone',actionAddOnIcon:'fa fa-phone',onActionAddOnClick:function onActionAddOnClick(){callNumber(salesOrderCustomer.phone);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,readOnly:readOnly,name:'phone',onChange:changeCustomerContact})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Year of birth',groupAddOnIcon:'fa fa-child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{object:contact,name:'dob',readOnly:true,onChange:function onChange(){}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};SalesOrderCustomer.propTypes={salesOrderCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,salutationList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,changeCustomerContact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveCustomerContact:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,callNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.hydrateContact();}})(SalesOrderCustomer));

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_ToggleButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var placeMessageInHtml=function placeMessageInHtml(messageHtml){return'<html><style>span {font-family: Arial, "Helvetica Neue", Helvetica, sans-serif; color:#344644} a {color: #3498db}</style><body>'+messageHtml+'</body></html>';};var Time=function Time(_ref){var time=_ref.time;if(!time){return null;}return Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(time);};var SentEmailList=function(_React$Component){_inherits(SentEmailList,_React$Component);function SentEmailList(props){_classCallCheck(this,SentEmailList);var _this=_possibleConstructorReturn(this,(SentEmailList.__proto__||Object.getPrototypeOf(SentEmailList)).call(this,props));_this.iframeList={};_this.state={sentEmailListOpen:{}};_this.toggleMessageVisibility=_this.toggleMessageVisibility.bind(_this);return _this;}_createClass(SentEmailList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({sentEmailListOpen:{}});}},{key:'toggleMessageVisibility',value:function toggleMessageVisibility(messageId){this.setState({sentEmailListOpen:Object.assign({},this.state.sentEmailListOpen,_defineProperty({},messageId,!this.state.sentEmailListOpen[messageId]))});}},{key:'componentDidUpdate',value:function componentDidUpdate(){for(var index=0;index<this.props.sentEmailList.length;index++){var message=this.props.sentEmailList[index];var iFrame=this.iframeList[message.id];if(!iFrame){continue;}if(!message.text){continue;}var frameDocument=iFrame.contentWindow;var messageHtml=placeMessageInHtml('<span><b>'+message.subject+'</b></span><br/><br/>'+message.text);frameDocument.document.open();frameDocument.document.write(messageHtml);frameDocument.document.close();}}},{key:'render',value:function render(){var _this2=this;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__["_4" /* SENT_EMAIL_WIDGET */])){return null;}var sentEmailList=this.props.sentEmailList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Emails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'40%'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%'},'Variant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%'},'Delivered'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%'},'Opened'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%'},'Clicked'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%'},'Spam/Blocked'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%',className:'align-right'},'Show/Hide'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,sentEmailList.map(function(sentEmail){var rows=[];var open=!!_this2.state.sentEmailListOpen[sentEmail.id];rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:sentEmail.id+'_overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,sentEmail.messageName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,sentEmail.variant),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time,{time:sentEmail.delivered})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time,{time:sentEmail.opened})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time,{time:sentEmail.click})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time,{time:sentEmail.spam}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time,{time:sentEmail.blocked})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},sentEmail.text&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_ToggleButton__["a" /* default */],{toggle:function toggle(){_this2.toggleMessageVisibility(sentEmail.id);},active:open,activeIcon:'fa fa-search-minus',inactiveIcon:'fa fa-search-plus'}))));if(!open){return rows;}rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:sentEmail.id+'_iframe'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{frameBorder:'1',title:'Email Content',ref:function ref(iFrame){_this2.iframeList[sentEmail.id]=iFrame;},className:'customer-transaction-email-iframe'}))));return rows;}))))));}}]);return SentEmailList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SentEmailList.propTypes={sentEmailList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (SentEmailList);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internationalization_renderLanguageFamily__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_util_names__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appointment_util_names__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appointment_state_const__ = __webpack_require__(129);
/* harmony default export */ __webpack_exports__["a"] = (function(canSeeCustomerNames,isTablet,currentUserId){var columnList=[];if(!isTablet){columnList.push({property:'vip',header:'VIP',width:'45',renderer:function renderer(processInstance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__form_component_VipIcon__["a" /* default */],{active:processInstance.vip});}});columnList.push({property:'created',header:'Created',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('created'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('created')});}columnList.push({property:'due',header:'Due',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('due'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('due')});if(!isTablet){columnList.push({property:'processName',header:'process Name',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["d" /* renderProcessName */])(processInstance.processName);},sortValue:function sortValue(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["d" /* renderProcessName */])(processInstance.processName);}});}columnList.push({property:'name',header:'taskname',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["g" /* renderTaskName */])(processInstance.name);},sortValue:function sortValue(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["g" /* renderTaskName */])(processInstance.name);}});columnList.push({property:'appointmentType',header:'Appointment Type',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_8__appointment_util_names__["c" /* renderAppointmentType */])(processInstance.appointmentType);},filterType:'select',filterOptions:__WEBPACK_IMPORTED_MODULE_9__appointment_state_const__["c" /* APPOINTMENT_TYPE_LIST */].map(function(appointmentType){return{id:appointmentType.id,value:appointmentType.value};})});columnList.push({property:'appointmentReason',header:'Reason',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_8__appointment_util_names__["a" /* renderAppointmentReason */])(processInstance.appointmentReason);},filterType:'select',filterOptions:__WEBPACK_IMPORTED_MODULE_9__appointment_state_const__["b" /* APPOINTMENT_REASON_LIST */].map(function(appointmentReason){return{id:appointmentReason.id,value:appointmentReason.value};})});columnList.push({property:'role',header:'Role',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["e" /* renderRoleName */])(processInstance.role);},sortValue:function sortValue(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["e" /* renderRoleName */])(processInstance.role);}});if(canSeeCustomerNames){columnList.push({property:'processDisplayName',header:'Name'});}columnList.push({property:'complexity',header:'Complexity'});if(!isTablet){columnList.push({property:'priority',header:'Priority'});columnList.push({property:'reference',header:'Reference'});columnList.push({property:'customerReference',header:'Customer'});}columnList.push({property:'status',header:'Status',renderer:function renderer(task){if(task.assignedToUserId===currentUserId){return'my task '+task.status;}if(task.assignedToUserId!==null){return'assigned '+task.status;}return task.status;}});if(!isTablet){columnList.push({property:'store',header:'Store',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__["b" /* renderStoreName */])(processInstance.store);}});columnList.push({property:'dealOwner',header:'DealOwner'});columnList.push({property:'language',header:'Language',renderer:__WEBPACK_IMPORTED_MODULE_5__internationalization_renderLanguageFamily__["a" /* default */],filterType:'select',filterOptions:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["f" /* LANGUAGE_LIST */].map(function(entry){return{id:entry.value,value:entry.value};}).filter(function(entry){return entry.id!=='';})});}columnList.push({property:'countryCode',header:'Country',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_6__customer_util_names__["a" /* renderCountryName */])(processInstance.countryCode);},filterType:'select',filterOptions:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["e" /* COUNTRY_CODE_LIST */].map(function(country){return{id:country.value,value:country.value};})});columnList.push({property:'followUpType',header:'Follow-up type',renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].followUpTypeRenderer('followUpType')});columnList.push({property:'treatmentPlanDeadline',header:'TP Deadline',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('treatmentPlanDeadline'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('treatmentPlanDeadline')});return columnList;});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initialTableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toggleMultiSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gotoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initialColumnsVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleColumnVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return initialTableSettingsAllOpenTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleColumnVisibilityAllOpenTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeTableSetting; });
/* unused harmony export findTaskListRequest */
/* unused harmony export findTaskListSuccess */
/* unused harmony export findPTaskListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findTaskList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selector__ = __webpack_require__(183);
var initialTableQuery=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var changeFilter=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var toggleSort=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var toggleMultiSort=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var gotoPage=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var initialColumnsVisibility=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["c" /* createInitialColumnsVisibilityFormHandler */](__WEBPACK_IMPORTED_MODULE_2__type__["f" /* TABLE_PROCESS_WORKLIST */],__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_TABLE_SETTING */]);var toggleColumnVisibility=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["f" /* createToggleColumnVisibilityFormHandler */](__WEBPACK_IMPORTED_MODULE_4__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_TABLE_SETTING */],__WEBPACK_IMPORTED_MODULE_2__type__["f" /* TABLE_PROCESS_WORKLIST */]);var initialTableSettingsAllOpenTask=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var toggleColumnVisibilityAllOpenTask=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_4__selector__["c" /* selectTable */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK */]);var changeTableSetting=Object(__WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_TABLE_SETTING */]);var findTaskListRequest=function findTaskListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* FIND_TASK_LIST_REQUEST */],payload:{}};};var findTaskListSuccess=function findTaskListSuccess(taskList){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["d" /* FIND_TASK_LIST_SUCCESS */],payload:{taskList:taskList}};};var findPTaskListError=function findPTaskListError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["b" /* FIND_TASK_LIST_ERROR */],payload:{error:error}};};var findTaskList=function findTaskList(){return function(dispatch){dispatch(findTaskListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/task/find-open').then(function(taskList){dispatch(findTaskListSuccess(taskList));}).catch(function(error){dispatch(findPTaskListError(error));});};};

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findTaskDetailRequest */
/* unused harmony export findTaskDetailSuccess */
/* unused harmony export findTaskDetailError */
/* unused harmony export invokeTaskActionList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return findTaskDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return findTaskDetailByProcessInstanceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleProcessFlowVisibility; });
/* unused harmony export changeTaskDueDateRequest */
/* unused harmony export changeTaskDueDateSuccess */
/* unused harmony export changeTaskDueDateError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeTaskDueDate; });
/* unused harmony export changeTaskStatusRequest */
/* unused harmony export changeTaskStatusSuccess */
/* unused harmony export changeTaskStatusError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeTaskStatus; });
/* unused harmony export triggerEventRequest */
/* unused harmony export triggerEventSuccess */
/* unused harmony export triggerEventError */
/* unused harmony export triggerEventSuccessNoFollowUp */
/* unused harmony export updateValidationMessageList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return validateAndTriggerEvent; });
/* unused harmony export claimTaskRequest */
/* unused harmony export claimTaskSuccess */
/* unused harmony export claimTaskError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return claimTask; });
/* unused harmony export unClaimTaskRequest */
/* unused harmony export unClaimTaskSuccess */
/* unused harmony export unClaimTaskError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return unClaimTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeAssignedTo; });
/* unused harmony export updateAssignedToUserIdRequest */
/* unused harmony export updateAssignedToUserIdSuccess */
/* unused harmony export updateAssignedToUserIdError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateAssignedToUserId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_definition_ui_definition__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sales_order_state_detail_action__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treatment_state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treatment_state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enrich_task_detail__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prospect_state_detail_action__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice_state_correction_action__ = __webpack_require__(553);
var _ACTION_MAPPING;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ACTION_MAPPING=(_ACTION_MAPPING={},_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["a" /* CUSTOMER */],__WEBPACK_IMPORTED_MODULE_7__customer_state_detail_action__["m" /* findCustomerSuccess */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["g" /* SALES_ORDER */],__WEBPACK_IMPORTED_MODULE_6__sales_order_state_detail_action__["h" /* findSalesOrderSuccess */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["c" /* PROCESS_INSTANCE */],__WEBPACK_IMPORTED_MODULE_5__state_instance_detail_action__["i" /* processInstanceLoaded */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["h" /* TREATMENT_PLAN */],__WEBPACK_IMPORTED_MODULE_8__treatment_state_plan_action__["h" /* treatmentPlanLoaded */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["i" /* TREATMENT_QUOTATION */],__WEBPACK_IMPORTED_MODULE_9__treatment_state_quotation_action__["f" /* processTaskLoaded */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["d" /* PROSPECT_LOADED */],__WEBPACK_IMPORTED_MODULE_11__prospect_state_detail_action__["a" /* findProspectSuccess */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],__WEBPACK_IMPORTED_MODULE_9__treatment_state_quotation_action__["c" /* customerLoaded */]),_defineProperty(_ACTION_MAPPING,__WEBPACK_IMPORTED_MODULE_4__ui_definition_process_action__["b" /* INVOICE_CORRECTION */],__WEBPACK_IMPORTED_MODULE_13__invoice_state_correction_action__["e" /* findInvoiceById */]),_ACTION_MAPPING);var findTaskDetailRequest=function findTaskDetailRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["l" /* FIND_TASK_DETAIL_REQUEST */],payload:{}};};var findTaskDetailSuccess=function findTaskDetailSuccess(task){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["m" /* FIND_TASK_DETAIL_SUCCESS */],payload:{task:task}};};var findTaskDetailError=function findTaskDetailError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["k" /* FIND_TASK_DETAIL_ERROR */],payload:{error:error}};};var invokeTaskActionList=function invokeTaskActionList(task,dispatch){var _getUIDefinitionByTas=Object(__WEBPACK_IMPORTED_MODULE_1__ui_definition_ui_definition__["b" /* getUIDefinitionByTaskName */])(task.name),actionList=_getUIDefinitionByTas.actionList;actionList.map(function(_ref){var action=_ref.action,taskPath=_ref.taskPath;action=ACTION_MAPPING[action];if(!action){return null;}var actionData=task;for(var index=0;index<taskPath.length;index++){var key=taskPath[index];actionData=actionData?actionData[key]:null;}return dispatch(action(actionData));});};var findTaskDetail=function findTaskDetail(taskId){return function(dispatch,getState){var state=getState();dispatch(findTaskDetailRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/task/find-by-id-full?processTaskId='+taskId).then(function(task){invokeTaskActionList(task,dispatch);Object(__WEBPACK_IMPORTED_MODULE_10__enrich_task_detail__["a" /* enrichTaskDetail */])(state,task);dispatch(findTaskDetailSuccess(task));}).catch(function(error){dispatch(findTaskDetailError(error));});};};var findTaskDetailByProcessInstanceId=function findTaskDetailByProcessInstanceId(processInstanceId){return function(dispatch,getState){var state=getState();dispatch(findTaskDetailRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/partner/task/find-active-by-process-instance-id?processInstanceId='+processInstanceId).then(function(task){invokeTaskActionList(task,dispatch);Object(__WEBPACK_IMPORTED_MODULE_10__enrich_task_detail__["a" /* enrichTaskDetail */])(state,task);dispatch(findTaskDetailSuccess(task));}).catch(function(error){dispatch(findTaskDetailError(error));});};};var toggleProcessFlowVisibility=function toggleProcessFlowVisibility(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["n" /* TOGGLE_PROCESS_FLOW_VISIBILITY */]};};var changeTaskDueDateRequest=function changeTaskDueDateRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["b" /* CHANGE_DUE_DATE_REQUEST */]};};var changeTaskDueDateSuccess=function changeTaskDueDateSuccess(due){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["c" /* CHANGE_DUE_DATE_SUCCESS */],payload:{due:due}};};var changeTaskDueDateError=function changeTaskDueDateError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["a" /* CHANGE_DUE_DATE_ERROR */],payload:{error:error}};};var changeTaskDueDate=function changeTaskDueDate(name,due){return function(dispatch,getState){var state=getState();var processTaskId=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["n" /* selectTaskId */](state);if(!processTaskId){return;}dispatch(changeTaskDueDateRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/task/change-due-date',{processTaskId:processTaskId,due:due}).then(function(response){dispatch(changeTaskDueDateSuccess(due));}).catch(function(error){dispatch(changeTaskDueDateError());});};};var changeTaskStatusRequest=function changeTaskStatusRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["f" /* CHANGE_TASK_STATUS_REQUEST */]};};var changeTaskStatusSuccess=function changeTaskStatusSuccess(status){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["g" /* CHANGE_TASK_STATUS_SUCCESS */],payload:{status:status}};};var changeTaskStatusError=function changeTaskStatusError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["e" /* CHANGE_TASK_STATUS_ERROR */],payload:{error:error}};};var changeTaskStatus=function changeTaskStatus(name,status){return function(dispatch,getState){var state=getState();var processTaskId=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["n" /* selectTaskId */](state);if(!processTaskId){return;}dispatch(changeTaskStatusRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/task/change-status',{processTaskId:processTaskId,status:status}).then(function(response){dispatch(changeTaskStatusSuccess(status));}).catch(function(error){dispatch(changeTaskStatusError());});};};var triggerEventRequest=function triggerEventRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["p" /* TRIGGER_EVENT_REQUEST */]};};var triggerEventSuccess=function triggerEventSuccess(task){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["q" /* TRIGGER_EVENT_SUCCESS */],payload:{task:task}};};var triggerEventError=function triggerEventError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["o" /* TRIGGER_EVENT_ERROR */],payload:{error:error}};};var triggerEventSuccessNoFollowUp=function triggerEventSuccessNoFollowUp(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["r" /* TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK */]};};var validateEvent=function validateEvent(taskName,eventName,state){var _getUIDefinitionByTas2=Object(__WEBPACK_IMPORTED_MODULE_1__ui_definition_ui_definition__["b" /* getUIDefinitionByTaskName */])(taskName),_getUIDefinitionByTas3=_getUIDefinitionByTas2.taskValidatorSelector,taskValidatorSelector=_getUIDefinitionByTas3===undefined?[]:_getUIDefinitionByTas3,taskValidator=_getUIDefinitionByTas2.taskValidator;if(!taskValidator){return null;}var task=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["m" /* selectTask */](state);var processInstance=Object(__WEBPACK_IMPORTED_MODULE_12__instance_detail_selector__["m" /* selectProcessInstance */])(state);var validatorParameter=[];for(var index=0;index<taskValidatorSelector.length;index++){var validatorParameterSelector=taskValidatorSelector[index];validatorParameter.push(validatorParameterSelector(state));}return taskValidator.apply(undefined,[task,processInstance,taskName,eventName].concat(validatorParameter));};var updateValidationMessageList=function updateValidationMessageList(validationMessageList){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["y" /* UPDATE_VALIDATION_MESSAGE_LIST */],payload:{validationMessageList:validationMessageList}};};var validateAndTriggerEvent=function validateAndTriggerEvent(taskName,eventName){return function(dispatch,getState){var state=getState();var validationMessageList=validateEvent(taskName,eventName,state);if(validationMessageList&&validationMessageList.length!==0){dispatch(updateValidationMessageList(validationMessageList));return;}var processTaskId=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["n" /* selectTaskId */](state);dispatch(triggerEventRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/task/fire-event',{eventName:eventName,processTaskId:processTaskId}).then(function(task){if(!task.name){dispatch(triggerEventSuccessNoFollowUp());}else{invokeTaskActionList(task,dispatch);Object(__WEBPACK_IMPORTED_MODULE_10__enrich_task_detail__["a" /* enrichTaskDetail */])(state,task);dispatch(triggerEventSuccess(task));}}).catch(function(error){console.log(error);dispatch(triggerEventError(error));});};};var claimTaskRequest=function claimTaskRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["i" /* CLAIM_TASK_REQUEST */]};};var claimTaskSuccess=function claimTaskSuccess(task){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["j" /* CLAIM_TASK_SUCCESS */],payload:{task:task}};};var claimTaskError=function claimTaskError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["h" /* CLAIM_TASK_ERROR */],payload:{error:error}};};var claimTask=function claimTask(){return function(dispatch,getState){var state=getState();var processTaskId=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["n" /* selectTaskId */](state);dispatch(claimTaskRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/task/claim?processTaskId='+processTaskId).then(function(task){dispatch(claimTaskSuccess(task));}).catch(function(error){dispatch(claimTaskError(error));});};};var unClaimTaskRequest=function unClaimTaskRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["t" /* UN_CLAIM_TASK_REQUEST */]};};var unClaimTaskSuccess=function unClaimTaskSuccess(task){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["u" /* UN_CLAIM_TASK_SUCCESS */],payload:{task:task}};};var unClaimTaskError=function unClaimTaskError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["s" /* UN_CLAIM_TASK_ERROR */],payload:{error:error}};};var unClaimTask=function unClaimTask(){return function(dispatch,getState){var state=getState();var processTaskId=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["n" /* selectTaskId */](state);dispatch(unClaimTaskRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/task/unclaim?processTaskId='+processTaskId).then(function(task){dispatch(unClaimTaskSuccess(task));}).catch(function(error){dispatch(unClaimTaskError(error));});};};var changeAssignedTo=function changeAssignedTo(name,value){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["d" /* CHANGE_PROCESS_TASK */],payload:{name:'assignedToUserId',value:value}};};var updateAssignedToUserIdRequest=function updateAssignedToUserIdRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["w" /* UPDATE_ASSIGNED_TO_USER_ID_REQUEST */]};};var updateAssignedToUserIdSuccess=function updateAssignedToUserIdSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["x" /* UPDATE_ASSIGNED_TO_USER_ID_SUCCESS */]};};var updateAssignedToUserIdError=function updateAssignedToUserIdError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["v" /* UPDATE_ASSIGNED_TO_USER_ID_ERROR */],payload:{error:error}};};var updateAssignedToUserId=function updateAssignedToUserId(){return function(dispatch,getState){var state=getState();var _selector$selectTask=__WEBPACK_IMPORTED_MODULE_2__task_detail_selector__["m" /* selectTask */](state),id=_selector$selectTask.id,assignedToUserId=_selector$selectTask.assignedToUserId;dispatch(updateAssignedToUserIdRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/task/update-assigned-to-user-id',{processTaskId:id,userId:assignedToUserId}).then(function(task){dispatch(updateAssignedToUserIdSuccess(task));}).catch(function(error){dispatch(updateAssignedToUserIdError(error));});};};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHOOSE_ALIGNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCE_MISSING_ALIGNER_EXTERNAL; });
var CHOOSE_ALIGNER='choose_aligner';var PRODUCE_MISSING_ALIGNER_EXTERNAL='produce_missing_aligner_external';

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INPUT_REFUND_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIRM_REFUND; });
var INPUT_REFUND_DATA='input_refund_data';var CONFIRM_REFUND='confirm_refund';

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findProspectRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findProspectSuccess; });
/* unused harmony export findProspectError */
/* unused harmony export findProspect */
/* unused harmony export changeProspect */
/* unused harmony export saveProspectRequest */
/* unused harmony export saveProspectSuccess */
/* unused harmony export saveProspectError */
/* unused harmony export saveProspect */
/* unused harmony export archiveProspectRequest */
/* unused harmony export archiveProspectSuccess */
/* unused harmony export archiveProspectError */
/* unused harmony export archiveProspect */
/* unused harmony export noShowRequest */
/* unused harmony export noShowSuccess */
/* unused harmony export noShowError */
/* unused harmony export noShow */
/* unused harmony export startInShopProcessRequest */
/* unused harmony export startInShopProcessSuccess */
/* unused harmony export startInShopProcessError */
/* unused harmony export startInShopProcess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(382);
var findProspectRequest=function findProspectRequest(prospectId){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["f" /* FIND_PROSPECT_REQUEST */],payload:{prospectId:prospectId}};};var findProspectSuccess=function findProspectSuccess(prospect){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["g" /* FIND_PROSPECT_SUCCESS */],payload:{prospect:prospect}};};var findProspectError=function findProspectError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["e" /* FIND_PROSPECT_ERROR */],payload:{error:error}};};var findProspect=function findProspect(prospectId){return function(dispatch,getState){dispatch(findProspectRequest(prospectId));Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/prospect/find-by-id-full?prospectId='+prospectId).then(function(prospect){dispatch(findProspectSuccess(prospect));}).catch(function(error){dispatch(findProspectError(error));});};};var changeProspect=function changeProspect(name,value){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["d" /* CHANGE_PROSPECT */],payload:{name:name,value:value}};};var saveProspectRequest=function saveProspectRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["l" /* SAVE_PROSPECT_REQUEST */],payload:{}};};var saveProspectSuccess=function saveProspectSuccess(prospect){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["m" /* SAVE_PROSPECT_SUCCESS */],payload:{prospect:prospect}};};var saveProspectError=function saveProspectError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["k" /* SAVE_PROSPECT_ERROR */],payload:{error:error}};};var saveProspect=function saveProspect(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectHasChanged */](state);if(!hasChanged){return;}var prospect=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectProspect */](state);dispatch(saveProspectRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/prospect/save',prospect).then(function(prospect){dispatch(saveProspectSuccess(prospect));}).catch(function(error){dispatch(saveProspectError(error));});};};var archiveProspectRequest=function archiveProspectRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["b" /* ARCHIVE_PROSPECT_REQUEST */],payload:{}};};var archiveProspectSuccess=function archiveProspectSuccess(prospect){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["c" /* ARCHIVE_PROSPECT_SUCCESS */],payload:{prospect:prospect}};};var archiveProspectError=function archiveProspectError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["a" /* ARCHIVE_PROSPECT_ERROR */],payload:{error:error}};};var archiveProspect=function archiveProspect(){return function(dispatch,getState){var state=getState();var prospectId=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectProspectId */](state);dispatch(archiveProspectRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/prospect/archive?prospectId='+prospectId).then(function(prospect){dispatch(archiveProspectSuccess(prospect));}).catch(function(error){dispatch(archiveProspectError(error));});};};var noShowRequest=function noShowRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["i" /* NO_SHOW_REQUEST */],payload:{}};};var noShowSuccess=function noShowSuccess(prospect){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["j" /* NO_SHOW_SUCCESS */],payload:{prospect:prospect}};};var noShowError=function noShowError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["h" /* NO_SHOW_ERROR */],payload:{error:error}};};var noShow=function noShow(){return function(dispatch,getState){var state=getState();var prospectId=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectProspectId */](state);dispatch(noShowRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/prospect/no-show?prospectId='+prospectId).then(function(prospect){dispatch(noShowSuccess(prospect));}).catch(function(error){dispatch(noShowError(error));});};};var startInShopProcessRequest=function startInShopProcessRequest(){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["o" /* START_IN_SHOP_PROCESS_REQUEST */],payload:{}};};var startInShopProcessSuccess=function startInShopProcessSuccess(processTaskId){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["p" /* START_IN_SHOP_PROCESS_SUCCESS */],payload:{processTaskId:processTaskId}};};var startInShopProcessError=function startInShopProcessError(error){return{type:__WEBPACK_IMPORTED_MODULE_3__type__["n" /* START_IN_SHOP_PROCESS_ERROR */],payload:{error:error}};};var startingInShopProcess=false;var startInShopProcess=function startInShopProcess(){return function(dispatch,getState){var state=getState();var prospectId=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectProspectId */](state);if(!prospectId||startingInShopProcess){return;}startingInShopProcess=true;dispatch(startInShopProcessRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/customer/start-in-shop-from-prospect?prospectId='+prospectId).then(function(_ref){var processTaskId=_ref.processTaskId;dispatch(startInShopProcessSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/task/detail/'+processTaskId));startingInShopProcess=false;}).catch(function(error){dispatch(startInShopProcessError(error));startingInShopProcess=false;});};};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findInvoiceByIdRequest */
/* unused harmony export findInvoiceByIdSuccess */
/* unused harmony export findInvoiceByIdError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return findInvoiceById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeInvoiceCorrectionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeInvoiceCorrectionData; });
/* unused harmony export createInvoiceCorrectionRequest */
/* unused harmony export createInvoiceCorrectionError */
/* unused harmony export createInvoiceCorrectionSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createInvoiceCorrection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(554);
var findInvoiceByIdRequest=function findInvoiceByIdRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_INVOICE_BY_ID_REQUEST */],payload:{}};};var findInvoiceByIdSuccess=function findInvoiceByIdSuccess(invoice){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_INVOICE_BY_ID_SUCCESS */],payload:{invoice:invoice}};};var findInvoiceByIdError=function findInvoiceByIdError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_INVOICE_BY_ID_ERROR */],payload:{error:error}};};var findInvoiceById=function findInvoiceById(invoiceId){return function(dispatch,getState){if(!invoiceId){return null;}dispatch(findInvoiceByIdRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/invoice/find-by-id-full?invoiceId='+invoiceId).then(function(invoice){dispatch(findInvoiceByIdSuccess(invoice));}).catch(function(error){dispatch(findInvoiceByIdError(error));});};};var showConfirmationModal=function showConfirmationModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SHOW_CONFIRMATION_MODAL */]};};var closeConfirmationModal=function closeConfirmationModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CLOSE_CONFIRMATION_MODAL */]};};var changeInvoiceCorrectionItem=function changeInvoiceCorrectionItem(invoiceItemId,name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_INVOICE_CORRECTION_ITEM */],payload:{invoiceItemId:invoiceItemId,name:name,value:value}};};var changeInvoiceCorrectionData=function changeInvoiceCorrectionData(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_INVOICE_CORRECTION_DATA */],payload:{name:name,value:value}};};var createInvoiceCorrectionRequest=function createInvoiceCorrectionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CREATE_INVOICE_CORRECTION_REQUEST */]};};var createInvoiceCorrectionError=function createInvoiceCorrectionError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CREATE_INVOICE_CORRECTION_ERROR */],payload:{error:error}};};var createInvoiceCorrectionSuccess=function createInvoiceCorrectionSuccess(invoiceCorrection){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CREATE_INVOICE_CORRECTION_SUCCESS */],payload:{invoiceCorrection:invoiceCorrection}};};var createInvoiceCorrection=function createInvoiceCorrection(){return function(dispatch,getState){var state=getState();var payload=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectInvoiceCorrectionPayload */](state);dispatch(createInvoiceCorrectionRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/invoice/create-partial-correction',payload).then(function(invoiceCorrection){dispatch(createInvoiceCorrectionSuccess(invoiceCorrection));}).catch(function(error){dispatch(createInvoiceCorrectionError(error));});};};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* unused harmony export selectInvoice */
/* unused harmony export selectInvoiceCorrectionData */
/* unused harmony export selectCustomText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectInvoiceCorrectionPayload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(534);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectInvoice=function selectInvoice(state){return selectOwnState(state).invoice;};var selectInvoiceCorrectionData=function selectInvoiceCorrectionData(state){return selectOwnState(state).invoiceCorrectionData;};var selectCustomText=function selectCustomText(state){return selectInvoiceCorrectionData(state).customText;};var selectInvoiceCorrectionPayload=function selectInvoiceCorrectionPayload(state){var invoice=selectInvoice(state);if(!invoice){return null;}return{invoiceId:invoice.id,customText:selectCustomText(state),invoiceItemCorrectionList:invoice.invoiceItemList.map(function(invoiceItem){return{originalInvoiceItemId:invoiceItem.id,correctionAmount:Math.round(invoiceItem.correctionAmount*100)};})};};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detail_PhysicianAndSupplier__ = __webpack_require__(513);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["c" /* selectCustomer */](state),physicianList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectPhysicianList(state),supplierList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSupplierList(state),isExternalTreatmentPlanerPossible:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["k" /* selectIsExternalTreatmentPlanerPossible */](state),treatmentPlanerList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectTreatmentPlanerList(state),userList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectUserList(state)};};var mapDispatchToProps={changeCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["c" /* changeCustomer */],saveCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["w" /* saveCustomer */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__detail_PhysicianAndSupplier__["a" /* default */]));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dropzone__ = __webpack_require__(95);
var moment=__webpack_require__(38);var ROTATE_CSS={0:'rotate-0',90:'rotate-90',180:'rotate-180',270:'rotate-270'};var UploadingImageMask=function UploadingImageMask(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'uploading-image-mask'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'loader-1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',width:'80%',height:'80%',viewBox:'0 0 50 50',xmlSpace:'preserve'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3498db',d:'M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animateTransform',{attributeType:'xml',attributeName:'transform',type:'rotate',from:'0 25 25',to:'360 25 25',dur:'1s',repeatCount:'indefinite'}))));};var ImageUploadDiv=function ImageUploadDiv(_ref){var image=_ref.image,versionImageList=_ref.versionImageList,customerId=_ref.customerId,uploadingImages=_ref.uploadingImages,retryImages=_ref.retryImages,retryUploadFromLocalStorage=_ref.retryUploadFromLocalStorage,uploadCustomerImage=_ref.uploadCustomerImage;if(versionImageList){versionImageList.sort(function(a,b){a=a.lastModified;b=b.lastModified;if(!a&&!b){return 0;}if(!a&&b){return-1;}if(a&&!b){return 1;}return moment(b).unix()-moment(a).unix();});}var ImageShown=function ImageShown(){var versionImage=versionImageList&&versionImageList[0];var rotate=versionImage&&versionImage.meta&&versionImage.meta.rotate?versionImage.meta.rotate:0;return versionImageList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload-div '+ROTATE_CSS[rotate],style:{backgroundImage:'url('+(__WEBPACK_IMPORTED_MODULE_9__util_api__["a" /* BACKEND_URL */]+versionImageList[0].link)+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image.defaultImage,width:'100%',height:'auto',alt:'alt'}));};var PlusIcon=function PlusIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-icon-upload-image'},'+');};var isCurrentImageUploading=uploadingImages[image.name]===true;var shouldRetryImage=retryImages[image.name]===true||localStorage.getItem(customerId+'-'+image.name+'-img')!==null;var retryUploadClass=shouldRetryImage?'retry-upload':'';var RetryButton=function RetryButton(){return shouldRetryImage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Image upload failed.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return retryUploadFromLocalStorage(image.name,customerId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-refresh'}),'\xA0Retry')):null;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:retryUploadClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_dropzone__["a" /* default */],{multiple:false,accept:'image/*',maxSize:__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["d" /* MAX_IMAGE_SIZE */],className:'image-upload-dropzone',disablePreview:true,onDrop:function onDrop(fileList){uploadCustomerImage(fileList,image.name,customerId);}},isCurrentImageUploading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UploadingImageMask,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlusIcon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageShown,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,image.shortTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RetryButton,null));};var ImageUpload=function ImageUpload(_ref2){var canSeeImages=_ref2.canSeeImages,imageVersionList=_ref2.imageVersionList,uploadCustomerImage=_ref2.uploadCustomerImage,retryUploadFromLocalStorage=_ref2.retryUploadFromLocalStorage,customerId=_ref2.customerId,_ref2$skipImages=_ref2.skipImages,skipImages=_ref2$skipImages===undefined?[]:_ref2$skipImages,uploadingImages=_ref2.uploadingImages,retryImages=_ref2.retryImages;if(!canSeeImages){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Column__["a" /* default */],{size:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Upload Photos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click on the photo to take a picture or uploading from camera roll. In case the image is not good enough (blurry, wrong rotation, wrong angle), please click again on the photo and repeat.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-upload-grid'},__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["a" /* DEFINED_IMAGE_LIST */].map(function(image,index){if(skipImages.includes(image.name)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageUploadDiv,{key:index,image:image,customerId:customerId,uploadCustomerImage:uploadCustomerImage,uploadingImages:uploadingImages,retryUploadFromLocalStorage:retryUploadFromLocalStorage,retryImages:retryImages,versionImageList:imageVersionList[image.name]});}))));};ImageUpload.propTypes={uploadingImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,customerId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,findImageVersion:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,canSeeImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,imageVersionList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,skipImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["a" /* DEFINED_IMAGE_LIST */].map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('name'))))};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findImageVersion(this.props.customerId);}})(ImageUpload));

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_names__ = __webpack_require__(25);
var TransitionList=function TransitionList(_ref){var taskReadOnly=_ref.taskReadOnly,task=_ref.task,availableTransitionList=_ref.availableTransitionList,validateAndTriggerEvent=_ref.validateAndTriggerEvent;if(taskReadOnly||task.status==='skipped'||task.status==='finished'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,availableTransitionList.map(function(transition){var className=transition.className,eventName=transition.eventName,technicalEvent=transition.technicalEvent,isAllowedForUser=transition.isAllowedForUser;if(technicalEvent||!isAllowedForUser){return null;}className+=' btn btn-sm '+task.name+' '+eventName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:eventName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:className,onClick:function onClick(){validateAndTriggerEvent(task.name,eventName);}},Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["c" /* renderEventName */])(eventName)),'\xA0');}));};TransitionList.propTypes={taskReadOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,availableTransitionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,validateAndTriggerEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TransitionList);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_definition_process_ui__ = __webpack_require__(2);
var PRE_STYLE={width:'100%',height:'300px',fontFamily:'Menlo, Monaco, Consolas, "Courier New", monospace',backgroundColor:'#f5f5f5',border:'1px solid #ccc',padding:'9.5px',borderRadius:'3px'};var TABLE_STYLE={tableLayout:'auto'};var TechnicalLog=function TechnicalLog(_ref){var processLogList=_ref.processLogList,context=_ref.context;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__ui_definition_process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Technical Log'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table',style:TABLE_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Event'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Description'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processLogList.map(function(processLog){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:processLog.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(processLog.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,processLog.event),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,processLog.text));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{style:PRE_STYLE,readOnly:true,value:JSON.stringify(context,null,2)}))));};TechnicalLog.propTypes={context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,processLogList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (TechnicalLog);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__ = __webpack_require__(2);
var StateTransitionLog=function StateTransitionLog(_ref){var processStateHistoryList=_ref.processStateHistoryList;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'State History'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'new status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Changed by'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processStateHistoryList.map(function(history){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:history.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(history.changed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__util_names__["f" /* renderStateName */])(history.targetStateName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,history.changedByUserName));}))))));};StateTransitionLog.propTypes={processStateHistoryList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (StateTransitionLog);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesOrderOverviewWidget__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
var mapStateToProps=function mapStateToProps(state,props){return{salesOrder:Object(__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["f" /* selectSalesOrder */])(state),dealOwner:Object(__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["h" /* selectFreshSalesDealOwner */])(state),calendlyLink:Object(__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["g" /* selectFreshSalesCalendlyLink */])(state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__SalesOrderOverviewWidget__["a" /* default */]));

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__ = __webpack_require__(2);
var REASON_LIST=[{id:'out_of_tray',value:'Out of tray'},{id:'shallow',value:'Shallow'},{id:'distortions',value:'Distortions'},{id:'pulls',value:'Pulls'},{id:'washed_margins',value:'Washed margins'},{id:'bubbles_folds',value:'Bubbles/folds'},{id:'saliva',value:'Saliva'},{id:'not_enough_space',value:'Not enough space'},{id:'pressed',value:'Pressed'},{id:'silicone_not_mixed_well',value:'Silicone not mixed well'},{id:'used_wrong_tray',value:'Used wrong tray'},{id:'others',value:'Others'}];var computeReasonArray=function computeReasonArray(context,reasonIndex,name,value){var reasonList=context.reasonList?__WEBPACK_IMPORTED_MODULE_1_ramda__["a" /* clone */](context.reasonList):[];var shipment=reasonList[reasonIndex]||{};shipment[name]=value;reasonList[reasonIndex]=shipment;return reasonList;};var ImprintScanStatusWidget=function ImprintScanStatusWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,salesOrder=_ref.salesOrder,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */])){return null;}if(salesOrder.type!=='set'&&salesOrder.type!=='refinement-set'){return null;}var reasonArray=[];for(var reasonIndex=0;reasonIndex<salesOrder.numberOfSetsSent;reasonIndex++){reasonArray.push(reasonIndex);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Imprint and Scan Status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},'Upper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},'Lower')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:2},'Send'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:context,name:'sendUpperTray',readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Send upper tray')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:context,readOnly:readOnly,name:'sendLowerTray',onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Send lower tray'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:2},'Visually'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:context,name:'upperJawVisuallyOK',readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Upper Jaw visually OK')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:context,readOnly:readOnly,name:'lowerJawVisuallyOK',onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Lower Jaw visually OK'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:2},'Scans'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:context,name:'upperJawScanOk',readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Upper Jaw scan OK')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:context,readOnly:readOnly,name:'lowerJawScanOK',onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Lower Jaw scan OK'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},'Problem with impression')),reasonArray.map(function(reasonIndex){var reasonObject=context.reasonList&&context.reasonList[reasonIndex]?context.reasonList[reasonIndex]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M',key:reasonIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:2},'Shipment # ',reasonIndex+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:reasonObject,name:'lower',readOnly:readOnly,valueList:REASON_LIST,addEmpty:true,onChange:function onChange(name,value){var reasonList=computeReasonArray(context,reasonIndex,name,value);changeProcessContext('reasonList',reasonList);saveProcessContext();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:reasonObject,name:'upper',readOnly:readOnly,valueList:REASON_LIST,addEmpty:true,onChange:function onChange(name,value){var reasonList=computeReasonArray(context,reasonIndex,name,value);changeProcessContext('reasonList',reasonList);saveProcessContext();}})));}));};ImprintScanStatusWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,context:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,salesOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ImprintScanStatusWidget);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sipgate_state_action__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detail_SalesOrderCustomer__ = __webpack_require__(545);
var mapStateToProps=function mapStateToProps(state,props){return{salesOrderCustomer:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["g" /* selectSalesOrderCustomer */](state),salutationList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSalutationList(state),contact:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["h" /* selectSalesOrderCustomerContact */](state),error:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["a" /* selectAPIError */](state)};};var mapDispatchToProps={callNumber:__WEBPACK_IMPORTED_MODULE_4__sipgate_state_action__["a" /* callNumber */],changeSalesOrderCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["e" /* changeSalesOrderCustomer */],saveSalesOrderCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["k" /* saveSalesOrderCustomer */],changeCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["f" /* changeSalesOrderCustomerContact */],saveCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["l" /* saveSalesOrderCustomerContact */],hydrateContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["i" /* hydrateSalesOrderCustomerContact */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__detail_SalesOrderCustomer__["a" /* default */]));

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email_component_sent_SentEmailList__ = __webpack_require__(546);
var mapStateToProps=function mapStateToProps(state,props){return{sentEmailList:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["i" /* selectSentEmailList */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__email_component_sent_SentEmailList__["a" /* default */]));

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invoice_component_list_InvoiceList__ = __webpack_require__(316);
var mapStateToProps=function mapStateToProps(state,props){return{invoiceList:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["c" /* selectInvoiceList */](state),confirmationModalOpen:false,closeConfirmationModal:function closeConfirmationModal(){}};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__invoice_component_list_InvoiceList__["a" /* default */]));

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_component_list_PaymentList__ = __webpack_require__(194);
var mapStateToProps=function mapStateToProps(state,props){return{paymentList:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["e" /* selectPaymentList */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__payment_component_list_PaymentList__["a" /* default */]));

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quotation_TreatmentQuotation__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_quotation_const__ = __webpack_require__(59);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentQuotation:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["n" /* selectTreatmentQuotation */](state),isPreviewModalOpen:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["j" /* selectIsPreviewModalOpen */](state),isValid:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["l" /* selectIsTreatmentQuotationValid */](state),uploadingVideo:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["m" /* selectIsUploadingVideo */](state),customer:__WEBPACK_IMPORTED_MODULE_5__customer_state_detail_selector__["c" /* selectCustomer */](state),isTQAdmin:Object(__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["m" /* selectIsTQAdmin */])(state),isEditableForUser:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["f" /* selectIsEditableForUser */](state),hasUserRoleToEdit:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["e" /* selectHasUserRoleToEdit */](state),productType:__WEBPACK_IMPORTED_MODULE_7__state_quotation_const__["h" /* PRODUCT_TYPE_ALIGNERS */],treatmentPlan:__WEBPACK_IMPORTED_MODULE_3__state_plan_selector__["g" /* selectTreatmentPlan */](state)};};var mapDispatchToProps={findOrCreateTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["d" /* findOrCreateTreatmentQuotation */],changeTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["a" /* changeTreatmentQuotation */],saveTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["h" /* saveTreatmentQuotation */],openPreviewModal:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["e" /* openPreviewModal */],closePreviewModal:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["b" /* closePreviewModal */],uploadVideoFile:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["k" /* uploadVideoFile */],updatePackageAndPrice:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["j" /* updatePackageAndPrice */],setEditableForUser:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["i" /* setEditableForUser */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__quotation_TreatmentQuotation__["a" /* default */]));

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TreatmentPaymentWidget__ = __webpack_require__(1508);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state),salesOrder:__WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__["f" /* selectSalesOrder */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__TreatmentPaymentWidget__["a" /* default */]));

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copyToClipboard; });
var copyToClipboard=function copyToClipboard(text){var el=document.createElement('textarea');el.value=text;document.body.appendChild(el);el.select();document.execCommand('copy');document.body.removeChild(el);};

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCannotBeTreatedReasonsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__ = __webpack_require__(35);
var CANNOT_BE_TREATED_REASON_LIST_WITH_PRETREATMENT=[{id:'Anterior_crossbite_involving_too_many_anterior_teeth',value:'Anterior crossbite involving too many anterior teeth'},{id:'Class_III',value:'Class III'},{id:'Crowding_Spacing_higher_than_6_mm',value:'Crowding/Spacing higher than 6 mm'},{id:'Deep_bite_cannot_be_solved',value:'Deep bite cannot be solved (ONLY when chief complaint)'},{id:'Diastema_too_massive',value:'Diastema too massive'},{id:'Due_to_Tooth_Status',value:'Due to Tooth Status (i.e. missing teeth, implants/bridges in anterior region)'},{id:'Intrusion_Extrusion_not_possible',value:'Intrusion/Extrusion not possible (ONLY if chief complaint)'},{id:'Midline_discrepancy_cannot_be_solved',value:'Midline discrepancy cannot be solved (ONLY when chief complaint)'},{id:'other',value:'Other (write reason in comment field)'},{id:'Overjet_too_large',value:'Overjet too large'},{id:'parodontosis',value:'Periodontitis'},{id:'Posterior_open_bite',value:'Posterior open bite'},{id:'Pre_Treatment_necessary',value:'Pre-Treatment necessary (i.e. periodontitis, caries)'},{id:'Rotation_of_canines_too_massive',value:'Rotation of canines too massive'},{id:'Rotation_of_incisors_too_massive',value:'Rotation of incisors too massive'},{id:'tmj',value:'TMJ disorder (CMD)'},{id:'Unstable_bite',value:'Unstable bite'}];var CANNOT_BE_TREATED_REASON_LIST_WITHOUT_PRETREATMENT=[{id:'Anterior_crossbite_involving_too_many_anterior_teeth',value:'Anterior crossbite involving too many anterior teeth'},{id:'Class_III',value:'Class III'},{id:'Crowding_Spacing_higher_than_6_mm',value:'Crowding/Spacing higher than 6 mm'},{id:'Deep_bite_cannot_be_solved',value:'Deep bite cannot be solved (ONLY when chief complaint)'},{id:'Diastema_too_massive',value:'Diastema too massive'},{id:'Due_to_Tooth_Status',value:'Due to Tooth Status (i.e. missing teeth, implants/bridges in anterior region)'},{id:'Intrusion_Extrusion_not_possible',value:'Intrusion/Extrusion not possible (ONLY if chief complaint)'},{id:'Midline_discrepancy_cannot_be_solved',value:'Midline discrepancy cannot be solved (ONLY when chief complaint)'},{id:'other',value:'Other (write reason in comment field)'},{id:'Overjet_too_large',value:'Overjet too large'},{id:'Posterior_open_bite',value:'Posterior open bite'},{id:'Pre_Treatment_necessary',value:'Pre-Treatment necessary (i.e. periodontitis, caries)'},{id:'Rotation_of_canines_too_massive',value:'Rotation of canines too massive'},{id:'Rotation_of_incisors_too_massive',value:'Rotation of incisors too massive'},{id:'Unstable_bite',value:'Unstable bite'}];var getCannotBeTreatedReasonsList=function getCannotBeTreatedReasonsList(taskName){var taskList=[__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["c" /* CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT */],__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["m" /* MEDICAL_CHECK_WITH_PRETREATMENT */],__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["k" /* MEDICAL_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["a" /* CONFIRM_MEDICAL_ASSESSMENT */]];var found=taskList.includes(taskName);return found?CANNOT_BE_TREATED_REASON_LIST_WITH_PRETREATMENT:CANNOT_BE_TREATED_REASON_LIST_WITHOUT_PRETREATMENT;};var CannotBeTreatedReasonWidget=function CannotBeTreatedReasonWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,taskName=_ref.taskName,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Cannot be treated reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{name:'cannotBeTreatedReason',object:context,valueList:getCannotBeTreatedReasonsList(taskName),addEmpty:true,readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};CannotBeTreatedReasonWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,taskName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CannotBeTreatedReasonWidget);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VoucherWidget__ = __webpack_require__(1568);
var mapStateToProps=function mapStateToProps(state,props){return{voucherList:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_selector__["q" /* selectProcessVoucherList */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__VoucherWidget__["a" /* default */]));

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectSelectedImageVersions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selector__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(156);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_0__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_1__const__["b" /* REDUCER_NAME */]];};var selectSelectedImageVersions=function selectSelectedImageVersions(state){return selectOwnState(state).selectedImageVersions;};

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setSelectedImageVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPhotoRejectionReason; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_action__ = __webpack_require__(96);
var setSelectedImageVersions=function setSelectedImageVersions(preCheckinPhotoIndex,imageVersionIndexInGallery){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* SET_SELECTED_IMAGE_VERSIONS */],payload:{selectedImageVersions:[{preCheckinPhotoIndex:preCheckinPhotoIndex,imageVersionIndexInGallery:imageVersionIndexInGallery}]}};};var setPhotoRejectionReason=function setPhotoRejectionReason(imageVersion,reason){return function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/customer/set-image-reason-meta-data',{customerId:imageVersion.customerId,path:imageVersion.path,versionId:imageVersion.versionId,reason:reason}).then(function(imageVersionList){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__image_action__["c" /* findImageVersionSuccess */])(imageVersionList));});return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* SET_NEW_PHOTOS_NEEDED_REASON */],payload:[{versionId:imageVersion.versionId,reason:reason}]};};};

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectRefinementReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectHasChanged; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(247);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectRefinementReason=function selectRefinementReason(state){return selectOwnState(state).refinementReason;};var selectHasChanged=function selectHasChanged(state){return selectOwnState(state).hasChanged;};

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectLowNpsReasonList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCreated; });
/* unused harmony export selectFeedbackId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(255);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectLowNpsReasonList=function selectLowNpsReasonList(state){return selectOwnState(state).lowNpsReasonList;};var selectScore=function selectScore(state){return selectOwnState(state).feedbackScore;};var selectCreated=function selectCreated(state){return selectOwnState(state).feedbackCreated;};var selectFeedbackId=function selectFeedbackId(state){return selectOwnState(state).feedbackId;};

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectSalesOrderPartialRefundList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectPartialRefund; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectValidationMessageList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(256);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectSalesOrderPartialRefundList=function selectSalesOrderPartialRefundList(state){return selectOwnState(state).salesOrderList;};var selectPartialRefund=function selectPartialRefund(state){return selectOwnState(state).partialRefundData;};var selectFetching=function selectFetching(state){return selectOwnState(state).fetching;};var selectValidationMessageList=function selectValidationMessageList(state){return selectOwnState(state).validationMessageList;};

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_action__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WhatsappMessages__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_selector__ = __webpack_require__(1601);
var mapStateToProps=function mapStateToProps(state){return{processInstanceId:__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["n" /* selectProcessInstanceId */](state),whatsappMessageList:__WEBPACK_IMPORTED_MODULE_4__state_selector__["a" /* selectWhatsappMessageList */](state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_1__state_action__["a" /* findWhatsappMessageList */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__WhatsappMessages__["a" /* default */]));

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findAllUserRequest */
/* unused harmony export findAllUserSuccess */
/* unused harmony export findAllUserError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return findAllUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeCurrentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeExternalUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return toggleRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toggleWidgetAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createExternalUser; });
/* unused harmony export saveUserRequest */
/* unused harmony export saveUserSuccess */
/* unused harmony export saveUserError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return saveUser; });
/* unused harmony export generateNewPassworRequest */
/* unused harmony export generateNewPasswordSuccess */
/* unused harmony export generateNewPasswordError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return generateNewPassword; });
/* unused harmony export validateUser */
/* unused harmony export setUserValidationResult */
/* unused harmony export createUserRequest */
/* unused harmony export createUserSuccess */
/* unused harmony export createUserError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createUser; });
/* unused harmony export findAllRoleRequest */
/* unused harmony export findAllRoleSuccess */
/* unused harmony export findAllRoleError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return findAllRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeCurrentRoleId; });
/* unused harmony export saveRoleRequest */
/* unused harmony export saveRoleSuccess */
/* unused harmony export saveRoleError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return toggleRoleWidgetAccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
var findAllUserRequest=function findAllUserRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["n" /* FIND_ALL_USER_REQUEST */]};};var findAllUserSuccess=function findAllUserSuccess(userList){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["o" /* FIND_ALL_USER_SUCCESS */],payload:{userList:userList}};};var findAllUserError=function findAllUserError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["m" /* FIND_ALL_USER_ERROR */],payload:{error:error}};};var findAllUser=function findAllUser(){return function(dispatch,getState){dispatch(findAllUserRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/security/user/find-employee-external').then(function(userList){dispatch(findAllUserSuccess(userList));}).catch(function(error){dispatch(findAllUserError(error));});};};var changeCurrentUserId=function changeCurrentUserId(name,currentUserId){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CHANGE_CURRENT_USER_ID */],payload:{currentUserId:currentUserId}};};var changeUser=function changeUser(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* CHANGE_USER */],payload:{name:name,value:value}};};var changeExternalUser=function changeExternalUser(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* CHANGE_EXTERNAL_USER */],payload:{name:name,value:value}};};var toggleRole=function toggleRole(role,active){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["z" /* TOGGLE_ROLE */],payload:{role:role,active:active}};};var toggleWidgetAccess=function toggleWidgetAccess(widgetId,active){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["B" /* TOGGLE_WIDGET_ACCESS */],payload:{widgetId:widgetId,active:active}};};var createEmployee=function createEmployee(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["e" /* CREATE_EMPLOYEE */]};};var createExternalUser=function createExternalUser(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* CREATE_EXTERNAL_USER */]};};var saveUserRequest=function saveUserRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["w" /* SAVE_USER_REQUEST */]};};var saveUserSuccess=function saveUserSuccess(currentUser){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["x" /* SAVE_USER_SUCCESS */],payload:{currentUser:currentUser}};};var saveUserError=function saveUserError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["v" /* SAVE_USER_ERROR */],payload:{error:error}};};var saveUser=function saveUser(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["e" /* selectHasChanged */](state);var user=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectCurrentUser */](state);if(!hasChanged||!user.id){return;}dispatch(saveUserRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/security/user/save',user).then(function(user){dispatch(saveUserSuccess(user));}).catch(function(error){dispatch(saveUserError(error));});};};var generateNewPassworRequest=function generateNewPassworRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["q" /* GENERATE_NEW_PASSWORD_REQUEST */]};};var generateNewPasswordSuccess=function generateNewPasswordSuccess(currentUser){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["r" /* GENERATE_NEW_PASSWORD_SUCCESS */],payload:{currentUser:currentUser}};};var generateNewPasswordError=function generateNewPasswordError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["p" /* GENERATE_NEW_PASSWORD_ERROR */],payload:{error:error}};};var generateNewPassword=function generateNewPassword(){return function(dispatch,getState){var state=getState();var userId=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectCurrentUserId */](state);if(!userId){return;}dispatch(generateNewPassworRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/security/user/generate-new-password?userId='+userId).then(function(user){dispatch(generateNewPasswordSuccess(user));}).catch(function(error){dispatch(generateNewPasswordError(error));});};};var validateUser=function validateUser(user){var validationMessageList=[];if(!user.gender){validationMessageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Salutation is mandatory','salutation'));}if(!user.firstName){validationMessageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Firstname is mandatory','firstName'));}if(!user.lastName){validationMessageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Lastname is mandatory','lastName'));}if(!user.email){validationMessageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Email is mandatory','email'));}if(user.externalUser&&!user.externalUser.partnerId){validationMessageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Partner is mandatory','partner'));}return validationMessageList;};var setUserValidationResult=function setUserValidationResult(validationMessageList){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["y" /* SET_USER_VALIDATION_RESULT */],payload:{validationMessageList:validationMessageList}};};var createUserRequest=function createUserRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["h" /* CREATE_USER_REQUEST */]};};var createUserSuccess=function createUserSuccess(currentUser){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["i" /* CREATE_USER_SUCCESS */],payload:{currentUser:currentUser}};};var createUserError=function createUserError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["g" /* CREATE_USER_ERROR */],payload:{error:error}};};var createUser=function createUser(){return function(dispatch,getState){var state=getState();var user=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectCurrentUser */](state);var validationResult=validateUser(user);if(validationResult.length!==0){dispatch(setUserValidationResult(validationResult));return;}dispatch(createUserRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/security/user/create-employee-or-external-user',user).then(function(currentUser){dispatch(createUserSuccess(currentUser));}).catch(function(error){dispatch(createUserError(error));});};};var findAllRoleRequest=function findAllRoleRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["k" /* FIND_ALL_ROLE_REQUEST */]};};var findAllRoleSuccess=function findAllRoleSuccess(roleList){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["l" /* FIND_ALL_ROLE_SUCCESS */],payload:{roleList:roleList}};};var findAllRoleError=function findAllRoleError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["j" /* FIND_ALL_ROLE_ERROR */],payload:{error:error}};};var findAllRole=function findAllRole(){return function(dispatch,getState){dispatch(findAllRoleRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/security/role/find-all').then(function(roleList){dispatch(findAllRoleSuccess(roleList));}).catch(function(error){dispatch(findAllRoleError(error));});};};var changeCurrentRoleId=function changeCurrentRoleId(name,currentRoleId){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CHANGE_CURRENT_ROLE_ID */],payload:{currentRoleId:currentRoleId}};};var saveRoleRequest=function saveRoleRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["t" /* SAVE_ROLE_REQUEST */]};};var saveRoleSuccess=function saveRoleSuccess(currentRole){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["u" /* SAVE_ROLE_SUCCESS */],payload:{currentRole:currentRole}};};var saveRoleError=function saveRoleError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["s" /* SAVE_ROLE_ERROR */],payload:{error:error}};};var saveRole=function saveRole(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["e" /* selectHasChanged */](state);var role=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectCurrentRole */](state);if(!hasChanged){return;}dispatch(saveRoleRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/security/role/save',role).then(function(role){dispatch(saveRoleSuccess(role));dispatch(findAllRole());}).catch(function(error){dispatch(saveRoleError(error));});};};var toggleRoleWidgetAccess=function toggleRoleWidgetAccess(widgetId,active){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["A" /* TOGGLE_ROLE_WIDGET_ACCESS */],payload:{widgetId:widgetId,active:active}};};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(user){if(user.employee){return user.firstName+' '+user.lastName;}return user.firstName+' '+user.lastName+' (External)';});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WIDGET_LIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_customer_ui_definition_customer_ui__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_sales_order_ui_definition_sales_order_ui__ = __webpack_require__(318);
var _WIDGET_LIST;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var WIDGET_LIST=(_WIDGET_LIST={},_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["K" /* OVERVIEW */],'Task Overview'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["k" /* COMMENT_LIST */],'Comment Section'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["o" /* CREATE_IPR_APPOINTMENT */],'Create IPR Appointment'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["n" /* CREATE_3DSCAN_APPOINTMENT */],'Create 3D-Scan Appointment'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */],'State History'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */],'Technical Log'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],'Overview'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],'Sales Order Customer'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_4" /* SENT_EMAIL_WIDGET */],'Emails'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_22" /* WHATSAPP_MESSAGES_WIDGET */],'Whatsapp Messages'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["w" /* CUSTOMS_INVOICE_LIST_WIDGET */],'Customs Invoices'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["J" /* MOVEMENT_CERTIFICATE_NUMBER_WIDGET */],'Movement Certificate Number'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["D" /* INVOICE_LIST_WIDGET */],'Invoices'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["O" /* PAYMENT_LIST_WIDGET */],'Payments'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_10" /* TRAY_SIZE_WIDGET */],'Tray size'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */],'Imprint and Scan Status'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],'Physician and Supplier'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */],'Treatment Execution'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */],'Treatment Feedback'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],'Patient Photos'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],'Upload Photos'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */],'Address'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],'Treatment Plan'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],'Scan File Upload'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],'Treatment Plan File Upload'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */],'IPR Instructions'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["M" /* PATIENT_IPR_WISHES_WIDGET */],'Patient IPR Wishes'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_16" /* TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET */],'Treatment File Plan Upload (external)'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],'Production File Upload'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],'Treatment Quotation'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["Y" /* REFUND_SEPA_TRANSFER_WIDGET */],'Refund with Sepa Transfer File'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */],'Aligner Label'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */],'Cannot be treated reason'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],'Pre Treatment / Cannot be treated reason'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_23" /* WHATS_APP_TEXT_WIDGET_CONTAINER */],'WhatsApp Text'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],'Number of aligners'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_11" /* TREATMENT_CLASSIFICATION_WIDGET_CONTAINER */],'Medical/Non Medical Treatment Classification'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */],'Treatment Vizualization'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */],'Shipment'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */],'Initial Hesitation'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */],'Transition List'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_15" /* TREATMENT_PAYMENT_WIDGET */],'Treatment Payments'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["x" /* DELIVERY_TRACKING_WIDGET */],'Shipping Tracking Number'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_7" /* SUPPLIER_TRACKING_NUMBER_WIDGET */],'Supplier Tracking Number'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["P" /* PHOTO_CHECKIN_WIDGET */],'Photo Checkin Result'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */],'Medical Photo Check'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["C" /* INVOICE_CORRECTION_WIDGET */],'Invoice Correction'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["V" /* PRODUCTION_CASE_CARD_WIDGET */],'Production Case Card'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["I" /* MODEL_SELECTION_WIDGET */],'Model Selection'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["G" /* MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER */],'Match 3Shape'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["N" /* PATIENT_SCANNED_WIDGET */],'Patient Scanned'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],'Anamnesis Edit'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],'Anamnesis List'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["f" /* APPOINTMENT_LIST_WIDGET_CONTAINER */],'Appointment List'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["T" /* PROCESS_OVERVIEW */],'Process Overview'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["U" /* PROCESS_TASK_LIST */],'Worklist'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_21" /* VOUCHER_WIDGET_CONTAINER */],'Voucher Info'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["l" /* COMPLEXITY_TREATMENT_WIDGET */],'Treatment Plan Complexity'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_2__modules_sales_order_ui_definition_sales_order_ui__["a" /* SALES_ORDER_OVERVIEW */],'Sales Order Overview'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_2__modules_sales_order_ui_definition_sales_order_ui__["b" /* SALES_ORDER_STATUS_HISTORY */],'Status History'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_1__modules_customer_ui_definition_customer_ui__["c" /* CUSTOMER_PROCESS_INSTANCE_LIST */],'Process'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_1__modules_customer_ui_definition_customer_ui__["d" /* CUSTOMER_SALES_ORDER_LIST */],'Sales Order'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_1__modules_customer_ui_definition_customer_ui__["e" /* CUSTOMER_XRAY_FILE_UPLOAD */],'X-Ray Upload (external)'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["u" /* CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET */],'Drive Files'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["t" /* CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET */],'Photo precheck'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */],'CBCT Upload'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */],'Implant Treatment Plan'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["z" /* IMPLANT_TREATMENT_QUOTATION_WIDGET */],'Implant Treatment Quotation'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["X" /* REFINEMENT_REASON_WIDGET */],'Refinement Reason'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["F" /* LOW_NPS_REASON_WIDGET_CONTAINER */],'Low NPS reason'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["L" /* PARTIAL_INVOICE_CORRECTION_CONTAINER */],'Partial Invoice Correction'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_1__modules_customer_ui_definition_customer_ui__["b" /* CUSTOMER_COMMENT_LIST */],'View comments (Customer)'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_1__modules_customer_ui_definition_customer_ui__["a" /* CUSTOMER_ADD_COMMENT */],'Add comments (Customer)'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["Z" /* REQUEST_MEDICAL_EVALUATION */],'Request Medical Eval'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["S" /* PROCESS_LIST */],'Process'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["_0" /* SALES_NOTE_WIDGET_CONTAINER */],'Sales Note'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["h" /* ATTACHMENT_NEEDED_WIDGET */],'Attachment Needed'),_defineProperty(_WIDGET_LIST,__WEBPACK_IMPORTED_MODULE_0__modules_process_ui_definition_process_ui__["g" /* ATTACHMENT_AGREEMENT_WIDGET */],'Attachment Agreement'),_WIDGET_LIST);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL_CATEGORY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(49);
var CANCEL_CATEGORY=[{id:'fake',value:'fake'},{id:'test',value:'test'},{id:'cancelledbyhq',value:'Cancelled by HQ'},{id:'rescheduledbyhq',value:'Rescheduled by HQ'}];var Appointment=function Appointment(_ref){var appointment=_ref.appointment,salutationList=_ref.salutationList,changeAppointment=_ref.changeAppointment,setAppointmentCancelCategory=_ref.setAppointmentCancelCategory;if(!appointment){return null;}var aStore=appointment.store;var noop=function noop(){};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Appointment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Change Appointment Category'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:appointment,name:'cancelCategory',readOnly:false,addEmpty:true,onChange:function onChange(name,value){changeAppointment(name,value);setAppointmentCancelCategory();},valueList:CANCEL_CATEGORY})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},appointment.externalChangeUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:appointment.externalChangeUrl,className:'btn btn-danger btn-sm',target:'_blank',rel:'noopener noreferrer'},'Change Appointment\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Customer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Link */],{to:'/customer/edit/'+appointment.customerId},appointment.firstName+' '+appointment.lastName))),appointment.processInstanceId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Process'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Link */],{to:'/process/instance/view/'+appointment.processInstanceId},'Process')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:8})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Salutation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:appointment,name:'gender',readOnly:true,valueList:salutationList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Firstname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:appointment,name:'firstName',onChange:noop,readOnly:true,onBlur:noop}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Lastname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:appointment,name:'lastName',onChange:noop,readOnly:true,onBlur:noop})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Email',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:appointment,name:'email',onChange:noop,readOnly:true,onBlur:noop}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Phone',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:appointment,name:'phone',onChange:noop,readOnly:true,onBlur:noop})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Start Time',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',readOnly:true,value:Object(__WEBPACK_IMPORTED_MODULE_9__util_datetime__["c" /* formatDateTime */])(appointment.startTime)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'End Time',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',readOnly:true,value:Object(__WEBPACK_IMPORTED_MODULE_9__util_datetime__["c" /* formatDateTime */])(appointment.endTime)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},aStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Store',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:aStore,name:'technicalName',onChange:noop,readOnly:true,onBlur:noop}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Status',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Input__["a" /* default */],{object:appointment,name:'status',onChange:noop,readOnly:true,onBlur:noop})))));};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findAppointment(this.props.appointmentId);}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(Appointment)));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectStateResponsibleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectStateResponsibleById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectStateResponsibleList=function selectStateResponsibleList(state){return selectOwnState(state).stateResponsibleList;};var selectStateResponsibleById=function selectStateResponsibleById(state,stateResponsibleId){var stateResponsibleList=selectStateResponsibleList(state);for(var index=0;index<stateResponsibleList.length;index++){var stateResponsible=stateResponsibleList[index];if(stateResponsible.id===stateResponsibleId){return stateResponsible;}}return null;};

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectTaskDefinitionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectTaskDefinitionById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["c" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectTaskDefinitionList=function selectTaskDefinitionList(state){return selectOwnState(state).taskDefinitionList;};var selectTaskDefinitionById=function selectTaskDefinitionById(state,taskDefinitionId){var taskDefinitionList=selectTaskDefinitionList(state);for(var index=0;index<taskDefinitionList.length;index++){var taskDefinition=taskDefinitionList[index];if(taskDefinition.id===taskDefinitionId){return taskDefinition;}}return null;};

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uploadCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadFoilList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
var uploadCSV=function uploadCSV(data){return fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/foil-supply/upload-foil-csv',{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'});};var loadFoilList=function loadFoilList(){return Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/foil-supply/get-foil-list');};

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTableSetting; });
/* unused harmony export findFoilListRequest */
/* unused harmony export findFoilListSuccess */
/* unused harmony export findFoilListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFoilList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(583);
var changeTableSetting=Object(__WEBPACK_IMPORTED_MODULE_0__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */]);var findFoilListRequest=function findFoilListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_FOIL_LIST_REQUEST */],payload:{}};};var findFoilListSuccess=function findFoilListSuccess(foilList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_FOIL_LIST_SUCCESS */],payload:{foilList:foilList}};};var findFoilListError=function findFoilListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_FOIL_LIST_ERROR */],payload:{error:error}};};var getFoilList=function getFoilList(){return function(dispatch,getState){dispatch(findFoilListRequest());Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* loadFoilList */])().then(function(foilList){dispatch(findFoilListSuccess(foilList));}).catch(function(error){dispatch(findFoilListError(error));});};};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(158);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableSelectorPartner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(235);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var tableSelectorPartner=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["a" /* PARTNER_TABLE */]);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(234);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LANGUAGE_FAMILIES */
/* unused harmony export LANGUAGE_SHORTCODES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LANGUAGE_FAMILY_PREFIXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUPPORTED_LANGUAGES; });
var _Object$freeze,_Object$freeze2;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var LANGUAGE_FAMILIES=Object.freeze({Spanish:'Spanish',English:'English',German:'German',French:'French',Dutch:'Dutch',Swedish:'Swedish',Italian:'Italian',Danish:'Danish',Dutch_Be:'Dutch (Belgium)',French_Be:'French (Belgium)'});var LANGUAGE_SHORTCODES=Object.freeze((_Object$freeze={},_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.Spanish,'es'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.English,'en'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.German,'de'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.French,'fr'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.Dutch,'nl'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.Swedish,'sv'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.Italian,'it'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.Danish,'da'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.Dutch_Be,'nl'),_defineProperty(_Object$freeze,LANGUAGE_FAMILIES.French_Be,'fr'),_Object$freeze));var LANGUAGE_FAMILY_PREFIXES=Object.freeze((_Object$freeze2={},_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.Spanish,'es_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.English,'en_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.German,'de_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.French,'fr_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.Dutch,'nl_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.Swedish,'sv_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.Italian,'it_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.Danish,'da_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.Dutch_Be,'nl_'),_defineProperty(_Object$freeze2,LANGUAGE_FAMILIES.French_Be,'fr_'),_Object$freeze2));var SUPPORTED_LANGUAGES=[LANGUAGE_FAMILIES.English,LANGUAGE_FAMILIES.German,LANGUAGE_FAMILIES.Spanish,LANGUAGE_FAMILIES.French,LANGUAGE_FAMILIES.Dutch,LANGUAGE_FAMILIES.Swedish,LANGUAGE_FAMILIES.Italian,LANGUAGE_FAMILIES.Danish,LANGUAGE_FAMILIES.Dutch_Be,LANGUAGE_FAMILIES.French_Be];

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableSelectorStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(252);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var tableSelectorStore=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["a" /* STORE_TABLE */]);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(251);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__const__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__region_list__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MessageBox__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(49);
var InputLine=function InputLine(props){var labelClass=checkMessageList(props.validation,props.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:props.label,labelClassName:labelClass})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:props.store,onChange:props.onChange,name:props.name,readOnly:props.readOnly})));};function filterInt(min,max){return function(value){var filteredValue=value.replace(',','.').split('.')[0].replace(/[\D]/,'');if(filteredValue===''){return'';}return Math.min(Math.max(filteredValue,min),max);};}function filterDecimalDegreesNumber(){return function(value){var filteredValue=value.replace(',','.').replace(/[^0-9.-]/,'');if(filteredValue===''){return null;}return filteredValue;};}var PositiveNumberInputLine=function PositiveNumberInputLine(props){var labelClass=checkMessageList(props.validation,props.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:props.label,labelClassName:labelClass})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:props.store,onChange:props.onChange,name:props.name,readOnly:props.readOnly,filterValue:filterInt(0,props.max||Infinity)})));};var FloatNumberInputLine=function FloatNumberInputLine(props){var labelClass=checkMessageList(props.validation,props.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:props.label,labelClassName:labelClass})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:props.store,onChange:props.onChange,name:props.name,readOnly:props.readOnly,filterValue:filterDecimalDegreesNumber()})));};var SelectLine=function SelectLine(props){var labelClass=checkMessageList(props.validation,props.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:props.label,labelClassName:labelClass})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{name:props.name,object:props.store,valueList:props.valueList,onChange:props.onChange,addEmpty:props.addEmpty})));};var CheckboxLine=function CheckboxLine(props){var labelClass=checkMessageList(props.validation,props.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:props.label,labelClassName:labelClass})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Checkbox__["a" /* default */],{object:props.store,name:props.name,onChange:props.onChange},' Yes ',props.note)));};var checkMessageList=function checkMessageList(messageList,item){if(Array.isArray(messageList)&&messageList.find(function(el){return el.messageId===item;})){return'text-danger bg-danger';}return'';};var MAX_DAYS_IN_FUTURE=365;// eslint-disable-next-line react/prop-types
var StoreForm=function StoreForm(_ref){var title=_ref.title,store=_ref.store,saveStore=_ref.saveStore,editStore=_ref.editStore,validationMessageList=_ref.validationMessageList,pushValidationList=_ref.pushValidationList,redirect=_ref.redirect,isFetching=_ref.isFetching;var onChange=function onChange(name,value){editStore(name,value);};var onChangeFrontendBookingName=function onChangeFrontendBookingName(name,value){value=value.toLowerCase().replace(/ /g,'-');editStore(name,value);};var onChangeTechnicalName=function onChangeTechnicalName(name,value){value=value.toLowerCase().replace(/ /g,'-');editStore(name,value);};var isReadOnly=function isReadOnly(){return!!store.id;};var onSave=function onSave(){var messageList=validate();if(messageList.length===0){saveStore();}};var validate=function validate(){var messageList=[];__WEBPACK_IMPORTED_MODULE_9__const__["c" /* MANDATORY_FIELDS */].forEach(function(el){// eslint-disable-next-line no-prototype-builtins
if(!store.hasOwnProperty(el.id)||!store[el.id]){messageList.push({messageId:el.id,message:'Field '+el.value+' is mandatory, please fill before saving'});}});pushValidationList(messageList);return messageList;};if(redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Redirect */],{to:'/store/search/'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Clinic Name *',store:store,name:'clinicName',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'City *',store:store,name:'city',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Address *',store:store,name:'streetAddress',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'ZIP *',store:store,name:'zip',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Country *',name:'countryCode',store:store,valueList:__WEBPACK_IMPORTED_MODULE_10__internationalization_const__["e" /* COUNTRY_CODE_LIST */],onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'State',name:'state',store:store,valueList:Object(__WEBPACK_IMPORTED_MODULE_11__region_list__["a" /* default */])(store.countryCode),onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Address extension',store:store,name:'addressExtension',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Address description',store:store,name:'addressDescription',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'eMail Address *',store:store,name:'email',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'text-primary'},'Clinic Characteristics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Active',store:store,name:'isActive',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Partner clinic',store:store,name:'isPartner',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Provides Pretreatment',store:store,name:'isPretreatmentProvider',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Clinic Region',name:'clinicRegion',store:store,valueList:__WEBPACK_IMPORTED_MODULE_9__const__["b" /* CLINIC_REGION_LIST */],onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Clinic Prioritization',name:'clinicPrioritization',store:store,onChange:onChange,valueList:__WEBPACK_IMPORTED_MODULE_9__const__["a" /* CLINIC_PRIORITIZATION_LIST */],validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Partner Mgmt. Cat. *',name:'partnerMgmtCategory',store:store,valueList:__WEBPACK_IMPORTED_MODULE_9__const__["e" /* PARTNER_MGMT_CATEGORY_LIST */],onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'IPR available',store:store,name:'iprProvider',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Attachment available',store:store,name:'attachmentAvailable',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Allow IPR/3DScan timeslots in parallel',store:store,name:'hasSpecialIprLogic',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Implant provider',store:store,name:'isImplantProvider',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Upload Mechanism *',name:'scanFileUploadMechanism',store:store,valueList:__WEBPACK_IMPORTED_MODULE_9__const__["f" /* SCAN_UPLOAD_MODE_LIST */],onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PositiveNumberInputLine,{label:'3D-scan price',store:store,name:'inShopScanPrice',onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PositiveNumberInputLine,{label:'IPR price',store:store,name:'iprPrice',onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'text-primary'},'Other'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Technical Name *',store:store,name:'technicalName',onChange:onChangeTechnicalName,validation:validationMessageList,readOnly:isReadOnly()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Display Name *',store:store,name:'displayName',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Frontend Booking Name *',store:store,name:'frontendBookingName',onChange:onChangeFrontendBookingName,readOnly:isReadOnly(),validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Budget City Name *',store:store,name:'budgetCityName',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Cost Center *',store:store,name:'costCenter',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Google Maps URL *',store:store,name:'googleMapsLink',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Google Place ID *',store:store,name:'googlePlaceId',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'Google Feedback Link',store:store,name:'googleFeedbackLink',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FloatNumberInputLine,{label:'Latitude *',store:store,name:'latitude',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FloatNumberInputLine,{label:'Longitude *',store:store,name:'longitude',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PositiveNumberInputLine,{label:'Booking days in advance 3d Scan *',store:store,name:'bookingDaysInAdvance3dScan',onChange:onChange,validation:validationMessageList,max:MAX_DAYS_IN_FUTURE}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PositiveNumberInputLine,{label:'Booking days in advance IPR *',store:store,name:'bookingDaysInAdvanceIpr',onChange:onChange,validation:validationMessageList,max:MAX_DAYS_IN_FUTURE}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:onSave,disabled:isFetching},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MessageBox__["a" /* default */],{messageList:validationMessageList}))));};StoreForm.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,store:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,saveStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,editStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,pushValidationList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (StoreForm);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PARTNER_MGMT_CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLINIC_REGION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLINIC_PRIORITIZATION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SCAN_UPLOAD_MODE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGE_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MANDATORY_FIELDS; });
var PARTNER_MGMT_CATEGORY_LIST=[{id:'none',value:'none'},{id:'R1',value:'R1'},{id:'R2',value:'R2'},{id:'R3',value:'R3'},{id:'R4',value:'R4'},{id:'R5',value:'R5'}];var CLINIC_REGION_LIST=[{id:'East',value:'East'},{id:'North',value:'North'},{id:'South',value:'South'},{id:'West',value:'West'}];var CLINIC_PRIORITIZATION_LIST=[{id:'A',value:'A'},{id:'B',value:'B'},{id:'C',value:'C'}];var SCAN_UPLOAD_MODE_LIST=[{id:'manual',value:'manual'},{id:'3shape',value:'3shape'}];var MESSAGE_PLACEHOLDER='%item%';var MANDATORY_FIELDS=[{id:'clinicName',value:'Clinic Name'},{id:'city',value:'City'},{id:'streetAddress',value:'Address'},{id:'zip',value:'ZIP'},{id:'countryCode',value:'Country'},{id:'email',value:'eMail Address'},{id:'partnerMgmtCategory',value:'Partner Mgmt. Cat.'},{id:'scanFileUploadMechanism',value:'Upload Mechanism'},{id:'technicalName',value:'Technical Name'},{id:'displayName',value:'Display Name'},{id:'frontendBookingName',value:'Frontend Booking Name'},{id:'budgetCityName',value:'Budget City Name'},{id:'costCenter',value:'Cost Center'},{id:'googleMapsLink',value:'Google Maps URL'},{id:'googlePlaceId',value:'Google Place ID'},{id:'latitude',value:'Latitude'},{id:'longitude',value:'Longitude'},{id:'bookingDaysInAdvance3dScan',value:'Booking days in advance 3d Scan'},{id:'bookingDaysInAdvanceIpr',value:'Booking days in advance IPR'}];

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createOrUpdateStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findStore; });
/* unused harmony export findStoreRequest */
/* unused harmony export findStoreSuccess */
/* unused harmony export findStoreError */
/* unused harmony export saveStoreRequest */
/* unused harmony export saveStoreSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearState; });
/* unused harmony export saveStoreError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editFormValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pushValidationList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_state_action__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(322);
var createOrUpdateStore=function createOrUpdateStore(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["a" /* selectHasChanged */](state);var isFetching=__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["b" /* selectIsFetching */](state);if(!hasChanged||isFetching){return;}dispatch(saveStoreRequest());var store=__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["d" /* selectStore */](state);Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/store/create-update-store',store).then(function(){dispatch(saveStoreSuccess());dispatch(clearState());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__globals_state_action__["b" /* loadGlobals */])());}).catch(function(error){dispatch(saveStoreError(error));});};};var findStore=function findStore(storeId){return function(dispatch,getState){dispatch(findStoreRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/store/get-by-id?id='+storeId).then(function(store){dispatch(findStoreSuccess(store));}).catch(function(error){dispatch(findStoreError(error));});};};var findStoreRequest=function findStoreRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* FIND_STORE_REQUEST */]};};var findStoreSuccess=function findStoreSuccess(store){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["e" /* FIND_STORE_SUCCESS */],payload:{store:store}};};var findStoreError=function findStoreError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* FIND_STORE_ERROR */],payload:{error:error}};};var saveStoreRequest=function saveStoreRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["g" /* SAVE_STORE_REQUEST */]};};var saveStoreSuccess=function saveStoreSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["h" /* SAVE_STORE_SUCCESS */]};};var clearState=function clearState(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CLEAR_STATE */]};};var saveStoreError=function saveStoreError(_ref){var validationMessageList=_ref.validationMessageList;return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* SAVE_STORE_ERROR */],payload:{validationMessageList:validationMessageList}};};var editFormValue=function editFormValue(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* EDIT_STORE */],payload:{name:name,value:value}};};var pushValidationList=function pushValidationList(list){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["i" /* VALIDATION_LIST */],payload:{list:list}};};

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__const__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MessageBox__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(49);
var InputLine=function InputLine(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_LabelInput__["a" /* default */],{label:props.label})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Input__["a" /* default */],{object:props.partner,onChange:props.onChange,name:props.name})));};var SelectLine=function SelectLine(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_LabelInput__["a" /* default */],{label:props.label})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{name:props.name,object:props.partner,valueList:props.valueList,onChange:props.onChange,addEmpty:props.addEmpty})));};var CheckboxLine=function CheckboxLine(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M',bottom:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_LabelInput__["a" /* default */],{label:props.label})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{object:props.partner,name:props.name,onChange:props.onChange},' Yes')));};var getStoreValueList=function getStoreValueList(storeList){var storeValueList=storeList.map(function(store){return{id:store.technicalName,value:store.displayName};});storeValueList.sort(function(aStore,bStore){if(aStore.value<bStore.value){return-1;}if(aStore.value>bStore.value){return 1;}return 0;});return storeValueList;};var PartnerForm=function PartnerForm(_ref){var title=_ref.title,partner=_ref.partner,savePartner=_ref.savePartner,editPartner=_ref.editPartner,validationMessageList=_ref.validationMessageList,pushValidationList=_ref.pushValidationList,storeList=_ref.storeList,redirect=_ref.redirect;if(!partner){return null;}var storeValueList=getStoreValueList(storeList);var onChange=function onChange(name,value){editPartner(name,value);};var onSave=function onSave(){var messageList=validate();if(messageList.length===0){savePartner();}};var validate=function validate(){var messageList=[];__WEBPACK_IMPORTED_MODULE_8__const__["a" /* MANDATORY_FIELDS */].forEach(function(el){if(!partner.hasOwnProperty(el.id)||!partner[el.id]){messageList.push({messageId:el.id,message:'Field '+el.value+' is mandatory, please fill before saving'});}});pushValidationList(messageList);return messageList;};if(redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["b" /* Redirect */],{to:'/partner/search/'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Title',name:'title',partner:partner,valueList:__WEBPACK_IMPORTED_MODULE_8__const__["c" /* TITLE_LIST */],onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'FirstName',partner:partner,name:'firstName',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLine,{label:'LastName',partner:partner,name:'lastName',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLine,{label:'Associated Clinic',partner:partner,name:'store',valueList:storeValueList,onChange:onChange,validation:validationMessageList,addEmpty:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Treating Physician',partner:partner,name:'isTreatingPhysician',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxLine,{label:'Active',partner:partner,name:'active',onChange:onChange,validation:validationMessageList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:onSave},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__MessageBox__["a" /* default */],{messageList:validationMessageList}))));};PartnerForm.propTypes={title:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,partner:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,savePartner:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,editPartner:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,pushValidationList:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (PartnerForm);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TITLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MESSAGE_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MANDATORY_FIELDS; });
var TITLE_LIST=[{id:'dr',value:'Dr'}];var MESSAGE_PLACEHOLDER='%item%';var MANDATORY_FIELDS=[{id:'firstName',value:'Firstname'},{id:'lastName',value:'Lastname'},{id:'store',value:'Associated Clinic'}];

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return savePartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findPartner; });
/* unused harmony export findPartnerRequest */
/* unused harmony export findPartnerSuccess */
/* unused harmony export findPartnerError */
/* unused harmony export savePartnerRequest */
/* unused harmony export savePartnerSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearState; });
/* unused harmony export savePartnerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editPartnerFormValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pushValidationList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(323);
var savePartner=function savePartner(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectHasChanged */](state);if(!hasChanged){return;}dispatch(savePartnerRequest());var partner=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectPartner */](state);Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])('/api/partner/create-update-store-partner',partner).then(function(){dispatch(savePartnerSuccess());dispatch(clearState());}).catch(function(error){dispatch(savePartnerError(error));});};};var findPartner=function findPartner(partnerId){return function(dispatch,getState){dispatch(findPartnerRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/api/partner/get-by-id?id='+partnerId).then(function(partner){dispatch(findPartnerSuccess(partner));}).catch(function(error){dispatch(findPartnerError(error));});};};var findPartnerRequest=function findPartnerRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* FIND_PARTNER_REQUEST */]};};var findPartnerSuccess=function findPartnerSuccess(partner){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["e" /* FIND_PARTNER_SUCCESS */],payload:{partner:partner}};};var findPartnerError=function findPartnerError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* FIND_PARTNER_ERROR */],payload:{error:error}};};var savePartnerRequest=function savePartnerRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["g" /* SAVE_PARTNER_REQUEST */]};};var savePartnerSuccess=function savePartnerSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["h" /* SAVE_PARTNER_SUCCESS */]};};var clearState=function clearState(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CLEAR_STATE */]};};var savePartnerError=function savePartnerError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* SAVE_PARTNER_ERROR */],payload:{error:error}};};var editPartnerFormValue=function editPartnerFormValue(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* EDIT_PARTNER */],payload:{name:name,value:value}};};var pushValidationList=function pushValidationList(list){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["i" /* VALIDATION_LIST */],payload:{list:list}};};

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectTaskListWithAttachment; });
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectTableSetting; });
/* unused harmony export selectAllOpenTaskWithAttachmentTableSetting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_selector__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(163);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectTaskListWithAttachment=function selectTaskListWithAttachment(state){return selectOwnState(state).taskListWithAttachment;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectTable=Object(__WEBPACK_IMPORTED_MODULE_2__table_state_selector__["a" /* createTableSelector */])(selectOwnState,__WEBPACK_IMPORTED_MODULE_3__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var selectTableSetting=Object(__WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState);var selectAllOpenTaskWithAttachmentTableSetting=Object(__WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState,'allOpenTaskWithAttachmentTableSetting');

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(599);
module.exports = __webpack_require__(604);


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(600).enable();
  window.Promise = __webpack_require__(602);
}

// fetch() polyfill for making API calls.
__webpack_require__(603);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(198);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(324);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(324);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 603 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_de__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_de__);
__webpack_require__(38).locale('de');var root=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a.setAppElement(root);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null),document.getElementById('root'));// registerServiceWorker();

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(198),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(198),r=__webpack_require__(607);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(608);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_globals_state_action__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_layout_component_ScrollTop__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_analytics_component_basis_BasisReportContainer__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_analytics_component_funnel_builder_FunnelBuilderContainer__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_analytics_component_invoice_csv_InvoiceCSV__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_customer_component_search_CustomerSearchContainer__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_customer_component_detail_CustomerContainer__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_email_component_manage_ManageEmailTemplateContainer__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_employee_component_EmployeeSettingsContainer__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_payment_component_associate_payment_AssociatePaymentContainer__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_payment_component_upload_CSVUploadContainer__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_sales_order_component_search_SetSalesOrderSearchContainer__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_sales_order_component_search_ShopScanSalesOrderSearchContainer__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_sales_order_component_search_TreatmentSalesOrderSearchContainer__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_sales_order_component_detail_SalesOrderDetailContainer__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_process_component_barcode_BarcodeContainer__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_process_component_task_list_TaskListContainer__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_process_component_task_detail_TaskDetailContainer__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_process_component_instance_detail_InstanceDetailContainer__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__css_bootstrap_css__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_process_component_task_list_AllOpenTaskListContainer__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_sales_order_component_search_RetainerSalesOrderSearchContainer__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_sales_order_component_search_RetainerRefinementSalesOrderSearchContainer__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_analytics_component_transition_TransitionContainer__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_sales_order_component_search_RefinementSetSalesOrderSearchContainer__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modules_sales_order_component_search_RefinementBookingSalesOrderSearchContainer__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modules_sales_order_component_search_RefinementShopSalesOrderSearchContainer__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modules_security_component_manage_ManageUserContainer__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modules_appointment_component_search_AppointmentSearchContainer__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modules_sales_order_component_search_InShopScanSalesOrderSearchContainer__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__modules_customer_component_search_CustomerPartnerSearchContainer__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__modules_appointment_component_detail_AppointmentDetailContainer__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modules_sales_order_component_search_RefinementProductionSalesOrderSearchContainer__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modules_process_component_version_summary_VersionSummaryContainer__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modules_sales_order_component_search_EscalationSalesOrderSearchContainer__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modules_sales_order_component_search_CheckInSalesOrderSearchContainer__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modules_process_component_state_responsible_StateResponsibleConfigurationContainer__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modules_analytics_component_state_responsible_StateResponsibleContainer__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modules_process_component_task_definition_TaskDefinitionContainer__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modules_treatment_component_reassign_ReassignContainer__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modules_security_component_manage_ManageRoleWidgetsContainer__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modules_foil_component_overview_FoilOverviewContainer__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modules_sales_order_component_search_Implant3DScanSalesOrderSearchContainer__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modules_sales_order_component_search_ImplantPlanSalesOrderSearchContainer__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__modules_sales_order_component_search_ImplantTreatmentSalesOrderSearchContainer__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__modules_partner_component_search_PartnerSearchContainer__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__modules_voucher_component_search_VoucherSearchContainer__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modules_sales_order_component_search_EndOfTreatmentSalesOrderSearchContainer__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__modules_store_component_search_StoreSearchContainer__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__modules_store_component_add_AddStoreContainer__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__modules_store_component_edit_EditStoreContainer__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__modules_partner_component_add_AddPartnerContainer__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__modules_partner_component_edit_EditPartnerContainer__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__modules_worklist_attachment_component_WorklistAttachmentContainer__ = __webpack_require__(1710);
__WEBPACK_IMPORTED_MODULE_4__modules_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__modules_globals_state_action__["a" /* initGlobals */])(window.__sunshine_globals__));var App=function App(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4__modules_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["a" /* ConnectedRouter */],{history:__WEBPACK_IMPORTED_MODULE_4__modules_store__["b" /* history */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modules_layout_component_ScrollTop__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/analytics/transition',component:__WEBPACK_IMPORTED_MODULE_30__modules_analytics_component_transition_TransitionContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["J" /* ROLE_REPORTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/analytics/sales-order',component:__WEBPACK_IMPORTED_MODULE_11__modules_analytics_component_invoice_csv_InvoiceCSV__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["J" /* ROLE_REPORTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/analytics/funnel-builder',component:__WEBPACK_IMPORTED_MODULE_10__modules_analytics_component_funnel_builder_FunnelBuilderContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["J" /* ROLE_REPORTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/analytics/y2d-basis',component:__WEBPACK_IMPORTED_MODULE_9__modules_analytics_component_basis_BasisReportContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["J" /* ROLE_REPORTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/analytics/state-responsible',component:__WEBPACK_IMPORTED_MODULE_44__modules_analytics_component_state_responsible_StateResponsibleContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["J" /* ROLE_REPORTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/appointment/search',component:__WEBPACK_IMPORTED_MODULE_35__modules_appointment_component_search_AppointmentSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/appointment/edit/:appointmentId',component:__WEBPACK_IMPORTED_MODULE_38__modules_appointment_component_detail_AppointmentDetailContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/store/search',component:__WEBPACK_IMPORTED_MODULE_55__modules_store_component_search_StoreSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/store/add',component:__WEBPACK_IMPORTED_MODULE_56__modules_store_component_add_AddStoreContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/store/edit/:storeId',component:__WEBPACK_IMPORTED_MODULE_57__modules_store_component_edit_EditStoreContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/customer/search',component:__WEBPACK_IMPORTED_MODULE_12__modules_customer_component_search_CustomerSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["D" /* ROLE_PARTNER_SCAN_PHYSICIAN */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/customer/search/partner',component:__WEBPACK_IMPORTED_MODULE_37__modules_customer_component_search_CustomerPartnerSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["B" /* ROLE_PARTNER_PHYSICIAN */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/customer/edit/:customerId',component:__WEBPACK_IMPORTED_MODULE_13__modules_customer_component_detail_CustomerContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["l" /* ROLE_EMPLOYEE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["D" /* ROLE_PARTNER_SCAN_PHYSICIAN */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["B" /* ROLE_PARTNER_PHYSICIAN */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/voucher/search',component:__WEBPACK_IMPORTED_MODULE_53__modules_voucher_component_search_VoucherSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/partner/search',component:__WEBPACK_IMPORTED_MODULE_52__modules_partner_component_search_PartnerSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/partner/add',component:__WEBPACK_IMPORTED_MODULE_58__modules_partner_component_add_AddPartnerContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/partner/edit/:partnerId',component:__WEBPACK_IMPORTED_MODULE_59__modules_partner_component_edit_EditPartnerContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/medical/reassign-physician',component:__WEBPACK_IMPORTED_MODULE_46__modules_treatment_component_reassign_ReassignContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["z" /* ROLE_MEDICAL_ADVISOR */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/email/template/manage',component:__WEBPACK_IMPORTED_MODULE_14__modules_email_component_manage_ManageEmailTemplateContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["k" /* ROLE_EMAIL_ADMIN */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/instance/barcode',component:__WEBPACK_IMPORTED_MODULE_22__modules_process_component_barcode_BarcodeContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/instance/view/:processInstanceId',component:__WEBPACK_IMPORTED_MODULE_25__modules_process_component_instance_detail_InstanceDetailContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["l" /* ROLE_EMPLOYEE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/instance/view-by-master-id/:masterObject/:masterId',component:__WEBPACK_IMPORTED_MODULE_25__modules_process_component_instance_detail_InstanceDetailContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["l" /* ROLE_EMPLOYEE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_23__modules_process_component_task_list_TaskListContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/task/all',component:__WEBPACK_IMPORTED_MODULE_27__modules_process_component_task_list_AllOpenTaskListContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["J" /* ROLE_REPORTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/state-responsible/all',component:__WEBPACK_IMPORTED_MODULE_43__modules_process_component_state_responsible_StateResponsibleConfigurationContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["G" /* ROLE_PROCESS_MANAGER */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/task-definition/all',component:__WEBPACK_IMPORTED_MODULE_45__modules_process_component_task_definition_TaskDefinitionContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["G" /* ROLE_PROCESS_MANAGER */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/process/version-summary',component:__WEBPACK_IMPORTED_MODULE_40__modules_process_component_version_summary_VersionSummaryContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/task/detail/:taskId',component:__WEBPACK_IMPORTED_MODULE_24__modules_process_component_task_detail_TaskDetailContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/task/detail-by-process-instance-id/:processInstanceId',component:__WEBPACK_IMPORTED_MODULE_24__modules_process_component_task_detail_TaskDetailContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/set',component:__WEBPACK_IMPORTED_MODULE_18__modules_sales_order_component_search_SetSalesOrderSearchContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/treatment',component:__WEBPACK_IMPORTED_MODULE_20__modules_sales_order_component_search_TreatmentSalesOrderSearchContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/end-of-treatment',component:__WEBPACK_IMPORTED_MODULE_54__modules_sales_order_component_search_EndOfTreatmentSalesOrderSearchContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/check-in',component:__WEBPACK_IMPORTED_MODULE_42__modules_sales_order_component_search_CheckInSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/in-shop-scan',component:__WEBPACK_IMPORTED_MODULE_36__modules_sales_order_component_search_InShopScanSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/shop-scan',component:__WEBPACK_IMPORTED_MODULE_19__modules_sales_order_component_search_ShopScanSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/refinement-set',component:__WEBPACK_IMPORTED_MODULE_31__modules_sales_order_component_search_RefinementSetSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/refinement-booking',component:__WEBPACK_IMPORTED_MODULE_32__modules_sales_order_component_search_RefinementBookingSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/refinement-shop',component:__WEBPACK_IMPORTED_MODULE_33__modules_sales_order_component_search_RefinementShopSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/refinement-production',component:__WEBPACK_IMPORTED_MODULE_39__modules_sales_order_component_search_RefinementProductionSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/retainer',component:__WEBPACK_IMPORTED_MODULE_28__modules_sales_order_component_search_RetainerSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/retainer-refinement',component:__WEBPACK_IMPORTED_MODULE_29__modules_sales_order_component_search_RetainerRefinementSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/escalation',component:__WEBPACK_IMPORTED_MODULE_41__modules_sales_order_component_search_EscalationSalesOrderSearchContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/implant-3dscan',component:__WEBPACK_IMPORTED_MODULE_49__modules_sales_order_component_search_Implant3DScanSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/implant-plan',component:__WEBPACK_IMPORTED_MODULE_50__modules_sales_order_component_search_ImplantPlanSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/search/implant-treatment',component:__WEBPACK_IMPORTED_MODULE_51__modules_sales_order_component_search_ImplantTreatmentSalesOrderSearchContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/sales-order/edit/:salesOrderId',component:__WEBPACK_IMPORTED_MODULE_21__modules_sales_order_component_detail_SalesOrderDetailContainer__["a" /* default */],requiredRole:[__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/settings/employee',component:__WEBPACK_IMPORTED_MODULE_15__modules_employee_component_EmployeeSettingsContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/user/manage',component:__WEBPACK_IMPORTED_MODULE_34__modules_security_component_manage_ManageUserContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["Q" /* ROLE_USER_ADMIN */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/role/widgets',component:__WEBPACK_IMPORTED_MODULE_47__modules_security_component_manage_ManageRoleWidgetsContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["R" /* ROLE_WIDGET_ADMIN */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/payment/associate',component:__WEBPACK_IMPORTED_MODULE_16__modules_payment_component_associate_payment_AssociatePaymentContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["f" /* ROLE_ACCOUNTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/payment/upload',component:__WEBPACK_IMPORTED_MODULE_17__modules_payment_component_upload_CSVUploadContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["f" /* ROLE_ACCOUNTING */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/foil/overview',component:__WEBPACK_IMPORTED_MODULE_48__modules_foil_component_overview_FoilOverviewContainer__["a" /* default */],requiredRole:__WEBPACK_IMPORTED_MODULE_6__modules_security_state_auth_const__["u" /* ROLE_FOIL_METADATA_ADMIN */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_security_component_auth_PrivateRouteContainer__["a" /* default */],{exact:true,path:'/worklist/attachment',component:__WEBPACK_IMPORTED_MODULE_60__modules_worklist_attachment_component_WorklistAttachmentContainer__["a" /* default */]})))));};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(199);





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(612);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(621);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(330);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(330);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(331);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(622);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(332);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDispatchHook */
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(333);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch =
/*#__PURE__*/
createDispatchHook();

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSelectorHook */
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useReduxContext__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(99);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {
      throw new Error("You must pass a selector to useSelectors");
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector =
/*#__PURE__*/
createSelectorHook();

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(151);





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(630)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__(335);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








var createConnectedRouter = function createConnectedRouter(structure) {
  var _createSelectors = Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["a" /* default */])(structure),
      getLocation = _createSelectors.getLocation;
  /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */


  var ConnectedRouter = /*#__PURE__*/function (_PureComponent) {
    _inherits(ConnectedRouter, _PureComponent);

    function ConnectedRouter(props) {
      var _this;

      _classCallCheck(this, ConnectedRouter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectedRouter).call(this, props));
      var store = props.store,
          history = props.history,
          onLocationChanged = props.onLocationChanged;
      _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling

      _this.unsubscribe = store.subscribe(function () {
        // Extract store's location
        var _getLocation = getLocation(store.getState()),
            pathnameInStore = _getLocation.pathname,
            searchInStore = _getLocation.search,
            hashInStore = _getLocation.hash,
            stateInStore = _getLocation.state; // Extract history's location


        var _history$location = history.location,
            pathnameInHistory = _history$location.pathname,
            searchInHistory = _history$location.search,
            hashInHistory = _history$location.hash,
            stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed

        if (props.history.action === 'PUSH' && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || stateInStore !== stateInHistory)) {
          _this.inTimeTravelling = true; // Update history's location to match store's location

          history.push({
            pathname: pathnameInStore,
            search: searchInStore,
            hash: hashInStore,
            state: stateInStore
          });
        }
      });

      var handleLocationChange = function handleLocationChange(location, action) {
        var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // Dispatch onLocationChanged except when we're in time travelling
        if (!_this.inTimeTravelling) {
          onLocationChanged(location, action, isFirstRendering);
        } else {
          _this.inTimeTravelling = false;
        }
      }; // Listen to history changes


      _this.unlisten = history.listen(handleLocationChange);

      if (!props.noInitialPop) {
        // Dispatch a location change action for the initial location.
        // This makes it backward-compatible with react-router-redux.
        // But, we add `isFirstRendering` to `true` to prevent double-rendering.
        handleLocationChange(history.location, history.action, true);
      }

      return _this;
    }

    _createClass(ConnectedRouter, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unlisten();
        this.unsubscribe();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            history = _this$props.history,
            children = _this$props.children;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Router */], {
          history: history
        }, children);
      }
    }]);

    return ConnectedRouter;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

  ConnectedRouter.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      getState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      listen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    onLocationChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    noInitialPop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* onLocationChanged */])(location, action, isFirstRendering));
      }
    };
  };

  var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
    var Context = props.context || __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* ReactReduxContext */];

    if (Context == null) {
      throw 'Please upgrade to react-redux v6';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Consumer, null, function (_ref) {
      var store = _ref.store;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedRouter, _extends({
        store: store
      }, props));
    });
  };

  ConnectedRouterWithContext.propTypes = {
    context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* connect */])(null, mapDispatchToProps)(ConnectedRouterWithContext);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedRouter);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(152);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Adds query to location.
 * Utilises the search prop of location to construct query.
 */

var injectQuery = function injectQuery(location) {
  if (location && location.query) {
    // Don't inject query if it already exists in history
    return location;
  }

  var searchQuery = location && location.search;

  if (typeof searchQuery !== 'string' || searchQuery.length === 0) {
    return _objectSpread({}, location, {
      query: {}
    });
  } // Ignore the `?` part of the search string e.g. ?username=codejockie


  var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy

  var queries = search.split('&'); // Contruct query

  var query = queries.reduce(function (acc, currentQuery) {
    // Split on `=`, to get key and value
    var _currentQuery$split = currentQuery.split('='),
        _currentQuery$split2 = _slicedToArray(_currentQuery$split, 2),
        queryKey = _currentQuery$split2[0],
        queryValue = _currentQuery$split2[1];

    return _objectSpread({}, acc, _defineProperty({}, queryKey, queryValue));
  }, {});
  return _objectSpread({}, location, {
    query: query
  });
};

var createConnectRouter = function createConnectRouter(structure) {
  var fromJS = structure.fromJS,
      merge = structure.merge;

  var createRouterReducer = function createRouterReducer(history) {
    var initialRouterState = fromJS({
      location: injectQuery(history.location),
      action: history.action
    });
    /*
    * This reducer will update the state with the most recent location history
    * has transitioned to.
    */

    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          type = _ref.type,
          payload = _ref.payload;

      if (type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* LOCATION_CHANGE */]) {
        var location = payload.location,
            action = payload.action,
            isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
        // to prevent the double-rendering issue on initilization

        return isFirstRendering ? state : merge(state, {
          location: fromJS(injectQuery(location)),
          action: action
        });
      }

      return state;
    };
  };

  return createRouterReducer;
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectRouter);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getIn__ = __webpack_require__(634);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var structure = {
  fromJS: function fromJS(value) {
    return value;
  },
  getIn: __WEBPACK_IMPORTED_MODULE_0__getIn__["a" /* default */],
  merge: function merge(state, payload) {
    return _objectSpread({}, state, {}, payload);
  },
  toJS: function toJS(value) {
    return value;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Code from github.com/erikras/redux-form by Erik Rasmussen */
var getIn = function getIn(state, path) {
  if (!state) {
    return state;
  }

  var length = path.length;

  if (!length) {
    return undefined;
  }

  var result = state;

  for (var i = 0; i < length && !!result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(152);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */

var routerMiddleware = function routerMiddleware(history) {
  return function (store) {
    return function (next) {
      return function (action) {
        // eslint-disable-line no-unused-vars
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;
        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (routerMiddleware);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__funnel_builder__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_responsible__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transition__ = __webpack_require__(663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__basis__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__basis__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__funnel_builder__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__funnel_builder__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_4__state_responsible__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_4__state_responsible__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_5__transition__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_5__transition__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(344);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={monthList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FETCH_BASIS_REPORT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FETCH_BASIS_REPORT_SUCCESS */],function(state,action){var monthList=action.payload.monthList;return Object.assign({},state,{monthList:monthList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FETCH_BASIS_REPORT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isSymbol__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isEmpty__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_toString__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isString__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(125);








function isValidActionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_2__utils_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_isEmpty__["a" /* default */])(types)) {
    return false;
  }

  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_4__utils_toString__["a" /* default */]).join(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ACTION_TYPE_DELIMITER */]);
  return {
    toString: function toString() {
      return combinedActionType;
    }
  };
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === null;
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isArray__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isString__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_isNil__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getLastElement__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_camelCase__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_flattenActionMap__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_unflattenActionCreators__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__createAction__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(125);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_getLastElement__["a" /* default */])(identityActions)) ? identityActions.pop() : {};
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */]) && (Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(actionMap) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');

  if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
  }

  return _objectSpread({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
}

function actionCreatorsFromActionMap(actionMap, options) {
  var flatActionMap = Object(__WEBPACK_IMPORTED_MODULE_10__utils_flattenActionMap__["a" /* default */])(actionMap, options);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_11__utils_unflattenActionCreators__["a" /* default */])(flatActionCreators, options);
}

function actionMapToActionCreators(actionMap, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      prefix = _ref.prefix,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace;

  function isValidActionMapValue(actionMapValue) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(actionMapValue) || Object(__WEBPACK_IMPORTED_MODULE_6__utils_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue$ = actionMapValue[0],
          payload = _actionMapValue$ === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */] : _actionMapValue$,
          meta = actionMapValue[1];
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(payload) && Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(meta);
    }

    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var _objectSpread2;

    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ("functions for " + type));
    var prefixedType = prefix ? "" + prefix + namespace + type : type;
    var actionCreator = Object(__WEBPACK_IMPORTED_MODULE_4__utils_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_12__createAction__["a" /* default */].apply(void 0, [prefixedType].concat(actionMapValue)) : Object(__WEBPACK_IMPORTED_MODULE_12__createAction__["a" /* default */])(prefixedType, actionMapValue);
    return _objectSpread({}, partialActionCreators, (_objectSpread2 = {}, _objectSpread2[type] = actionCreator, _objectSpread2));
  });
}

function actionCreatorsFromIdentityActions(identityActions, options) {
  var actionMap = Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    var _objectSpread3;

    return _objectSpread({}, partialActionMap, (_objectSpread3 = {}, _objectSpread3[type] = __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */], _objectSpread3));
  });
  var actionCreators = actionMapToActionCreators(actionMap, options);
  return Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    var _objectSpread4;

    return _objectSpread({}, partialActionCreators, (_objectSpread4 = {}, _objectSpread4[Object(__WEBPACK_IMPORTED_MODULE_8__utils_camelCase__["a" /* default */])(type)] = actionCreators[type], _objectSpread4));
  });
}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return Array.isArray(value);
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array) {
  return array[array.length - 1];
});

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(647)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(648)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 648 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flattenWhenNode__ = __webpack_require__(341);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__flattenWhenNode__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */]));

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unflattenActionCreators;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isEmpty__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__camelCase__ = __webpack_require__(340);



function unflattenActionCreators(flatActionCreators, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace,
      prefix = _ref.prefix;

  function unflatten(flatActionType, partialNestedActionCreators, partialFlatActionTypePath) {
    var nextNamespace = Object(__WEBPACK_IMPORTED_MODULE_2__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());

    if (Object(__WEBPACK_IMPORTED_MODULE_1__isEmpty__["a" /* default */])(partialFlatActionTypePath)) {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    } else {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }

      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    var unprefixedType = prefix ? type.replace("" + prefix + namespace, '') : type;
    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
  });
  return nestedActionCreators;
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_just_curry_it__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_just_curry_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_just_curry_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAction__ = __webpack_require__(205);


/* unused harmony default export */ var _unused_webpack_default_export = (function (type, payloadCreator) {
  return __WEBPACK_IMPORTED_MODULE_0_just_curry_it___default()(Object(__WEBPACK_IMPORTED_MODULE_1__createAction__["a" /* default */])(type, payloadCreator), payloadCreator.length);
});

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = curry;

/*
  function add(a, b, c) {
    return a + b + c;
  }
  curry(add)(1)(2)(3); // 6
  curry(add)(1)(2)(2); // 5
  curry(add)(2)(4, 3); // 9

  function add(...args) {
    return args.reduce((sum, n) => sum + n, 0)
  }
  var curryAdd4 = curry(add, 4)
  curryAdd4(1)(2, 3)(4); // 10

  function converter(ratio, input) {
    return (input*ratio).toFixed(1);
  }
  const curriedConverter = curry(converter)
  const milesToKm = curriedConverter(1.62);
  milesToKm(35); // 56.7
  milesToKm(10); // 16.2
*/

function curry(fn, arity) {
  return function curried() {
    if (arity == null) {
      arity = fn.length;
    }
    var args = [].slice.call(arguments);
    if (args.length >= arity) {
      return fn.apply(this, args);
    } else {
      return function() {
        return curried.apply(this, args.concat([].slice.call(arguments)));
      };
    }
  };
}


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === undefined;
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduce_reducers__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isMap__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownKeys__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_flattenReducerMap__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handleAction__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_get__ = __webpack_require__(342);








function handleActions(handlers, defaultState, options) {
  if (options === void 0) {
    options = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__["a" /* default */])(handlers) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_isMap__["a" /* default */])(handlers), 'Expected handlers to be a plain object.');
  var flattenedReducerMap = Object(__WEBPACK_IMPORTED_MODULE_5__utils_flattenReducerMap__["a" /* default */])(handlers, options);
  var reducers = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__handleAction__["a" /* default */])(type, Object(__WEBPACK_IMPORTED_MODULE_7__utils_get__["a" /* default */])(type, flattenedReducerMap), defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_0_reduce_reducers__["a" /* default */].apply(void 0, reducers.concat([defaultState]));
  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    return reducer(state, action);
  };
}

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var initialState = typeof args[args.length - 1] !== 'function' && args.pop();
  var reducers = args;

  if (typeof initialState === 'undefined') {
    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
  }

  return function (prevState, value) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    var prevStateIsUndefined = typeof prevState === 'undefined';
    var valueIsUndefined = typeof value === 'undefined';

    if (prevStateIsUndefined && valueIsUndefined && initialState) {
      return initialState;
    }

    return reducers.reduce(function (newState, reducer) {
      return reducer.apply(undefined, [newState, value].concat(args));
    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
  };
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMap__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flattenWhenNode__ = __webpack_require__(341);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__flattenWhenNode__["a" /* default */])(function (node) {
  return (Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(node) || Object(__WEBPACK_IMPORTED_MODULE_1__isMap__["a" /* default */])(node)) && !Object(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
}));

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__(207);

function hasGeneratorInterface(handler) {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["c"]; });


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internationalization_const__ = __webpack_require__(31);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var today=new Date();var initialState={funnelStartTime:{month:today.getMonth()+1,year:today.getFullYear(),companyCode:__WEBPACK_IMPORTED_MODULE_3__internationalization_const__["b" /* COMPANY_CODE_SUNSHINE_SMILE_GERMANY */]},currentState:null,mode:__WEBPACK_IMPORTED_MODULE_2__const__["a" /* MODE_MONTHLY */],funnelStepList:[{processName:'salesorder-set',stateName:'new'},{processName:null,stateName:null}],cohortList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_MODE */],function(state,action){var mode=action.payload.mode;return Object.assign({},state,{mode:mode});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_FUNNEL_START_DEFINITION */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{funnelStartTime:Object.assign({},state.funnelStartTime,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_FUNNEL_STEP */],function(state,action){var _action$payload2=action.payload,name=_action$payload2.name,value=_action$payload2.value,funnelStepIndex=_action$payload2.funnelStepIndex;var _funnelStep=state.funnelStepList[funnelStepIndex];// todo: clean up
state.funnelStepList[funnelStepIndex]=Object.assign({},_funnelStep,_defineProperty({},name,value));if(funnelStepIndex===state.funnelStepList.length-1){state.funnelStepList.push({processName:null,stateName:null});}return Object.assign({},state,{funnelStepList:[].concat(_toConsumableArray(state.funnelStepList))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_COHORT_REQUEST */],function(state,action){return Object.assign({},state,{cohortList:[],fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_COHORT_SUCCESS */],function(state,action){var cohortList=action.payload.cohortList;return Object.assign({},state,{cohortList:cohortList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_CURRENT_STATE_SUCCESS */],function(state,action){var currentState=action.payload.currentState;return Object.assign({},state,{currentState:currentState});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_COHORT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__ = __webpack_require__(42);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({userSelection:{processName:null,responsible:null,companyCode:__WEBPACK_IMPORTED_MODULE_2__internationalization_const__["b" /* COMPANY_CODE_SUNSHINE_SMILE_GERMANY */]},stateAnalytics:null,fetching:false,error:null,taskByDueDateList:null,currentTaskName:null,taskList:null},Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:0,sortColumnName:'created',sortOrder:-1},'taskListTableSettings'),{currentStateName:null,stateByLastChangedList:null,processInstanceList:null},Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:0,sortColumnName:'created',sortOrder:-1},'stateListTableSettings'));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_TASK_TABLE_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["a" /* changeTableSettings */])('taskListTableSettings')),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_STATE_TABLE_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["a" /* changeTableSettings */])('stateListTableSettings')),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_USER_SELECTION */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{userSelection:Object.assign({},state.userSelection,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* GET_STATE_ANALYTICS_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,currentTaskName:null,currentStateName:null,taskList:null,processInstanceList:null,stateByLastChangedList:null,taskByDueDateList:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* GET_STATE_ANALYTICS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* GET_STATE_ANALYTICS_SUCCESS */],function(state,action){var stateAnalytics=action.payload.stateAnalytics;return Object.assign({},state,{stateAnalytics:stateAnalytics,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* GET_STATE_LAST_CHANGED_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,taskByDueDateList:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* GET_STATE_LAST_CHANGED_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* GET_STATE_LAST_CHANGED_SUCCESS */],function(state,action){var _action$payload2=action.payload,stateByLastChangedList=_action$payload2.stateByLastChangedList,stateName=_action$payload2.stateName;return Object.assign({},state,{fetching:false,stateByLastChangedList:stateByLastChangedList,currentStateName:stateName,currentTaskName:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS */],function(state,action){var processInstanceList=action.payload.processInstanceList;return Object.assign({},state,{fetching:false,processInstanceList:processInstanceList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["q" /* GET_TASK_BY_DUE_DATE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,stateByLastChangedList:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* GET_TASK_BY_DUE_DATE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["r" /* GET_TASK_BY_DUE_DATE_SUCCESS */],function(state,action){var _action$payload3=action.payload,taskByDueDateList=_action$payload3.taskByDueDateList,taskName=_action$payload3.taskName;return Object.assign({},state,{fetching:false,taskByDueDateList:taskByDueDateList,currentTaskName:taskName,currentStateName:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_TASK_BY_WEEK_DIFF_DATE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS */],function(state,action){var taskList=action.payload.taskList;return Object.assign({},state,{fetching:false,taskList:taskList});}),_handleActions),initialState));

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["c"]; });


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internationalization_const__ = __webpack_require__(31);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={processState:{startProcessName:null,startStatus:null,endProcessName:null,endStatus:null,mode:__WEBPACK_IMPORTED_MODULE_2__const__["a" /* COUNT_AGGREGATED_RELATIVE */],companyCode:__WEBPACK_IMPORTED_MODULE_3__internationalization_const__["b" /* COMPANY_CODE_SUNSHINE_SMILE_GERMANY */]},yearWeekList:[],transitionList:null,fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_PROCESS_STATE */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{processState:Object.assign({},state.processState,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_YEAR_WEEK */],function(state,action){var _action$payload2=action.payload,index=_action$payload2.index,name=_action$payload2.name,value=_action$payload2.value;var yearWeekList=state.yearWeekList.map(function(item,mapIndex){return mapIndex!==index?item:Object.assign({},item,_defineProperty({},name,value));});if(index>=yearWeekList.length){yearWeekList.push(_defineProperty({year:new Date().getFullYear()},name,value));}return Object.assign({},state,{yearWeekList:yearWeekList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* DELETE_YEAR_WEEK */],function(state,action){var index=action.payload.index;return Object.assign({},state,{yearWeekList:state.yearWeekList.filter(function(item,filterIndex){return index!==filterIndex;})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_TRANSITION_REQUEST */],function(state,action){return Object.assign({},state,{cohortList:[],fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_TRANSITION_SUCCESS */],function(state,action){var transitionList=action.payload.transitionList;return Object.assign({},state,{transitionList:transitionList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_TRANSITION_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__anamnesis__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["b"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__anamnesis__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__anamnesis__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__list__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__list__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["i"]; });


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={anamnesisList:{},fetching:false,error:null,showAnamnesis:false,isEditingTreatmentExpectation:false,isInfoLegendShown:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_OR_CREATE_ANAMNESIS_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_OR_CREATE_ANAMNESIS_SUCCESS */],function(state,action){var anamnesis=action.payload.anamnesis;return Object.assign({},state,{fetching:false,anamnesisList:Object.assign({},state.anamnesisList,_defineProperty({},anamnesis.templateKey,anamnesis))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_OR_CREATE_ANAMNESIS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_ANAMNESIS */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value,templateKey=_action$payload.templateKey;return Object.assign({},state,{anamnesisList:Object.assign({},state.anamnesisList,_defineProperty({},templateKey,Object.assign({},state.anamnesisList[templateKey],_defineProperty({},name,value))))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* UPDATE_ANAMNESIS */],function(state,action){var _action$payload2=action.payload,anamnesis=_action$payload2.anamnesis,templateKey=_action$payload2.templateKey;return Object.assign({},state,{anamnesisList:Object.assign({},state.anamnesisList,_defineProperty({},templateKey,Object.assign({},state.anamnesisList[templateKey],{formData:anamnesis})))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_ANAMNESIS_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_ANAMNESIS_SUCCESS */],function(state,action){var anamnesis=action.payload.anamnesis;return Object.assign({},state,{fetching:false,anamnesisList:Object.assign({},state.anamnesisList,_defineProperty({},anamnesis.templateKey,anamnesis))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_ANAMNESIS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* TOGGLE_ANAMNESIS */],function(state,action){return Object.assign({},state,{showAnamnesis:!state.showAnamnesis});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* TOGGLE_EDITING_TREATMENT_EXPECTATION */],function(state,action){return Object.assign({},state,{isEditingTreatmentExpectation:!state.isEditingTreatmentExpectation});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* TOGGLE_INFO_LEGEND */],function(state,action){return Object.assign({},state,{isInfoLegendShown:!state.isInfoLegendShown});}),_handleActions),initialState));

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(349);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={anamnesisList:[],fetching:false,error:null,showAnamnesis:false,isInfoLegendShown:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_BY_CUSTOMER_ID_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_BY_CUSTOMER_ID_SUCCESS */],function(state,action){var anamnesisList=action.payload.anamnesisList;return Object.assign({},state,{fetching:false,anamnesisList:anamnesisList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FIND_BY_CUSTOMER_ID_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TOGGLE_ANAMNESIS */],function(state,action){return Object.assign({},state,{showAnamnesis:!state.showAnamnesis});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TOGGLE_INFO_LEGEND */],function(state,action){return Object.assign({},state,{isInfoLegendShown:!state.isInfoLegendShown});}),_handleActions),initialState));

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["d"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__detail__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__search__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(350);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={appointment:{},fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_APPOINTMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_APPOINTMENT_SUCCESS */],function(state,action){var appointment=action.payload.appointment;return Object.assign({},state,{appointment:appointment,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_APPOINTMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_APPOINTMENT */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{appointment:Object.assign({},state.appointment,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS */],function(state,action){var appointment=action.payload.appointment;return Object.assign({},state,{appointment:appointment,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SET_APPOINTMENT_CANCEL_CATEGORY_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["b"]; });


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_reducer__ = __webpack_require__(87);
var initialState=Object.assign({appointmentList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* APPOINTMENT_TABLE */],'appointment_appointment',{created:__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* APPOINTMENT_TABLE */])),initialState));

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__file_upload__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transfer_drive_files__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__task_widget__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cbct_file_upload__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["m"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__detail__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__file_upload__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__file_upload__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_4__image__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_4__image__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_5__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_5__search__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_6__transfer_drive_files__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_6__transfer_drive_files__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_7__task_widget__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_7__task_widget__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_8__cbct_file_upload__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_8__cbct_file_upload__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tab_comments__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["f"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_0__const__["f" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* default */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__tab_comments__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__tab_comments__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__(40);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={customer:null,fetching:false,error:null,hasChanged:false,showImages:false,accountFix:null,startProcessFetching:false,responseFeedback:{responseFeedbackModalOpen:false,responseValue:null,status:null},changeEmailData:{changeEmailModalOpen:false,newEmail:null,emailAlreadyInUse:false},deleteConfirmationModal:{open:false,checked:false,warning:false},contact:{id:null,gender:null,referenceNumber:null,firstName:null,lastName:null,streetAddress:null,streetAddressExtension:null,staircase:null,door:null,zip:null,city:null,countryCode:null,language:null,email:null,phone:null,dob:null,store:null,socialSecurityNumber:null},tab:__WEBPACK_IMPORTED_MODULE_3__const__["i" /* TAB_BASIC_DATA */],imageFetching:{'face-smiling':false,face:false,profile:false,'upper-tooth-sector':false,'bottom-tooth-sector':false,'right-side':false,frontal:false,'left-side':false}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["b" /* CHANGE_ACTIVE_TAB */],function(state,action){var tab=action.payload.tab;return Object.assign({},state,{tab:tab});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["o" /* FIND_CUSTOMER_PARTIAL_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["p" /* FIND_CUSTOMER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,customer:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["q" /* FIND_CUSTOMER_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{customer:Object.assign({},state.customer,customer),fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["n" /* FIND_CUSTOMER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["y" /* HYDRATE_CUSTOMER_CONTACT */],function(state,action){var customer=state.customer;return Object.assign({},state,{contact:{id:customer.id,gender:customer.gender,referenceNumber:customer.referenceNumber,firstName:customer.firstName,lastName:customer.lastName,streetAddress:customer.streetAddress,streetAddressExtension:customer.streetAddressExtension,staircase:customer.staircase,door:customer.door,zip:customer.zip,city:customer.city,countryCode:customer.countryCode,language:customer.language,email:customer.email,phone:customer.phone,dob:customer.dob,store:customer.store,socialSecurityNumber:customer.socialSecurityNumber}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["c" /* CHANGE_CUSTOMER */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{hasChanged:true,customer:Object.assign({},state.customer,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["d" /* CHANGE_CUSTOMER_CONTACT */],function(state,action){var _action$payload2=action.payload,name=_action$payload2.name,value=_action$payload2.value;return Object.assign({},state,{hasChanged:true,contact:Object.assign({},state.contact,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_12" /* UPLOAD_CUSTOMER_IMAGE_REQUEST */],function(state,action){var fileName=action.payload.fileName;return Object.assign({},state,{imageFetching:Object.assign({},state.imageFetching,_defineProperty({},fileName,true)),fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_13" /* UPLOAD_CUSTOMER_IMAGE_SUCCESS */],function(state,action){var file=action.payload.file;var imageReplaced=false;var imageList=state.customer.imageList.map(function(image){if(image.fileName===file.fileName){imageReplaced=true;return file;}return image;});if(!imageReplaced){imageList.push(file);}return Object.assign({},state,{customer:Object.assign({},state.customer,{imageList:[].concat(_toConsumableArray(imageList))}),imageFetching:Object.assign({},state.imageFetching,_defineProperty({},file.fileName,false)),fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_11" /* UPLOAD_CUSTOMER_IMAGE_ERROR */],function(state,action){var _action$payload3=action.payload,error=_action$payload3.error,fileName=_action$payload3.fileName;return Object.assign({},state,{fetching:false,error:error,imageFetching:Object.assign({},state.imageFetching,_defineProperty({},fileName,false))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["a" /* ADD_CUSTOMER_FILE */],function(state,action){var _action$payload4=action.payload,fileType=_action$payload4.fileType,file=_action$payload4.file;var found=false;var fileList=state.customer[fileType].map(function(existingFile){found=found||existingFile.id===file.id;return existingFile.id===file.id?file:existingFile;});if(!found){fileList.push(file);}return Object.assign({},state,{customer:Object.assign({},state.customer,_defineProperty({},fileType,fileList))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["H" /* SET_FILE_DELETE_FLAG */],function(state,action){var _action$payload5=action.payload,fileType=_action$payload5.fileType,fileId=_action$payload5.fileId;var fileList=state.customer[fileType].map(function(file){return file.id!==fileId?file:Object.assign({},file,{deleted:true});});return Object.assign({},state,{customer:Object.assign({},state.customer,_defineProperty({},fileType,fileList))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_3" /* TOGGLE_IMAGE_VIEW */],function(state,action){return Object.assign({},state,{showImages:!state.showImages});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["C" /* SAVE_CUSTOMER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["D" /* SAVE_CUSTOMER_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{customer:customer,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["B" /* SAVE_CUSTOMER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["P" /* START_ESCALATION_PROCESS_REQUEST */],function(state,action){return Object.assign({},state,{startProcessFetching:true,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["Q" /* START_ESCALATION_PROCESS_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{startProcessFetching:false,fetching:false,customer:customer});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["O" /* START_ESCALATION_PROCESS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{startProcessFetching:false,fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["S" /* START_PARTIAL_REFUND_PROCESS_REQUEST */],function(state,action){return Object.assign({},state,{startProcessFetching:true,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["T" /* START_PARTIAL_REFUND_PROCESS_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{startProcessFetching:false,fetching:false,customer:customer});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["R" /* START_PARTIAL_REFUND_PROCESS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{startProcessFetching:false,fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["V" /* START_REFINEMENT_SET_PROCESS_REQUEST */],function(state,action){return Object.assign({},state,{startProcessFetching:true,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["W" /* START_REFINEMENT_SET_PROCESS_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{startProcessFetching:false,fetching:false,customer:customer});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["U" /* START_REFINEMENT_SET_PROCESS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{startProcessFetching:false,fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["Y" /* START_REFINEMENT_SHOP_PROCESS_REQUEST */],function(state,action){return Object.assign({},state,{startProcessFetching:true,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["Z" /* START_REFINEMENT_SHOP_PROCESS_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{startProcessFetching:false,fetching:false,customer:customer});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["X" /* START_REFINEMENT_SHOP_PROCESS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{startProcessFetching:false,fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_1" /* START_RETAINER_REFINEMENT_PROCESS_REQUEST */],function(state,action){return Object.assign({},state,{startProcessFetching:true,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_2" /* START_RETAINER_REFINEMENT_PROCESS_SUCCESS */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{startProcessFetching:false,fetching:false,customer:customer});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_0" /* START_RETAINER_REFINEMENT_PROCESS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{startProcessFetching:false,fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["v" /* FIX_ACCOUNT_PROBLEM_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,accountFix:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["w" /* FIX_ACCOUNT_PROBLEM_SUCCESS */],function(state,action){var accountFix=action.payload.accountFix;return Object.assign({},state,{fetching:false,accountFix:accountFix});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["u" /* FIX_ACCOUNT_PROBLEM_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["z" /* OPEN_CHANGE_EMAIL_MODAL */],function(state,action){return Object.assign({},state,{changeEmailData:Object.assign({},state.changeEmailData,{changeEmailModalOpen:true})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["i" /* CLOSE_CHANGE_EMAIL_MODAL */],function(state,action){return Object.assign({},state,{changeEmailData:Object.assign({},state.changeEmailData,{changeEmailModalOpen:false})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["h" /* CHANGE_NEW_EMAIL */],function(state,action){var value=action.payload.value;return Object.assign({},state,{changeEmailData:Object.assign({},state.changeEmailData,{newEmail:value})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["f" /* CHANGE_EMAIL_REQUEST */],function(state,action){return Object.assign({},state,{changeEmailData:Object.assign({},state.changeEmailData,{emailAlreadyInUse:false}),fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["g" /* CHANGE_EMAIL_SUCCESS */],function(state,action){var email=action.payload.email;return Object.assign({},state,{changeEmailData:Object.assign({},state.changeEmailData,{newEmail:null,changeEmailModalOpen:false}),customer:Object.assign({},state.customer,{email:email})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["e" /* CHANGE_EMAIL_ERROR */],function(state,action){return Object.assign({},state,{changeEmailData:Object.assign({},state.changeEmailData,{emailAlreadyInUse:true})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["s" /* FIND_PROCESS_COMMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["t" /* FIND_PROCESS_COMMENT_SUCCESS */],function(state,action){var processList=action.payload.processList;return Object.assign({},state,{customer:Object.assign({},state.customer,{processList:processList}),fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["r" /* FIND_PROCESS_COMMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["N" /* START_DOWNLOAD_CUSTOMER_DATA_SUCCESS */],function(state,action){return Object.assign({},state,{responseFeedback:{responseFeedbackModalOpen:true,responseValue:true,status:101}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["M" /* START_DOWNLOAD_CUSTOMER_DATA_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,responseFeedback:{responseFeedbackModalOpen:true,responseValue:false,status:401}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["k" /* CLOSE_RESPONSE_FEEDBACK_MODAL */],function(state,action){return Object.assign({},state,{responseFeedback:{responseFeedbackModalOpen:false,responseValue:null,status:null}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["A" /* OPEN_DELETE_CONFIRMATION_MODAL */],function(state,action){return Object.assign({},state,{deleteConfirmationModal:{open:true,checked:false}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["j" /* CLOSE_DELETE_CONFIRMATION_MODAL */],function(state,action){return Object.assign({},state,{deleteConfirmationModal:{open:false,checked:false}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["x" /* HANDLE_DELETE_CONFIRMATION_MODAL */],function(state,action){var value=action.payload.value;return Object.assign({},state,{deleteConfirmationModal:Object.assign({},state.deleteConfirmationModal,{checked:value,warning:!value})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["I" /* SHOW_ERROR_CONFIRMATION_MODAL */],function(state,action){return Object.assign({},state,{deleteConfirmationModal:Object.assign({},state.deleteConfirmationModal,{warning:true})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["m" /* DELETE_CUSTOMER_SUCCESS */],function(state,action){var response=action.payload.response;return Object.assign({},state,{responseFeedback:{responseValue:true,responseFeedbackModalOpen:true,status:response.deleteStatus}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["l" /* DELETE_CUSTOMER_ERROR */],function(state,action){return Object.assign({},state,{responseFeedback:{responseValue:false,responseFeedbackModalOpen:true,status:400}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["F" /* SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["G" /* SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS */],function(state,action){var treatmentExecutionList=action.payload.treatmentExecutionList;return Object.assign({},state,{fetching:false,hasChanged:true,customer:Object.assign({},state.customer,{treatmentExecutionList:[treatmentExecutionList]})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["E" /* SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_9" /* UPDATE_WHATSAPP_OPT_IN_REQUEST */],function(state){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_10" /* UPDATE_WHATSAPP_OPT_IN_SUCCESS */],function(state,action){var value=action.payload.value;return Object.assign({},state,{customer:Object.assign({},state.customer,{isWhatsAppOptIn:value}),responseFeedback:{responseFeedbackModalOpen:true,responseValue:true,status:601},fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_7" /* UPDATE_WHATSAPP_OPT_IN_ERROR */],function(state){return Object.assign({},state,{fetching:false,responseFeedback:{responseFeedbackModalOpen:true,responseValue:false,status:600}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["_8" /* UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE */],function(state){return Object.assign({},state,{fetching:false,responseFeedback:{responseFeedbackModalOpen:true,responseValue:false,status:602}});}),_handleActions),initialState));

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(688);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(352);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={processList:null,fetching:false,error:null,commentText:null,isInternal:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_IS_COMMENT_INTERNAL */],function(state,action){var value=action.payload.value;return Object.assign({},state,{isInternal:value});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_PROCESS_COMMENT */],function(state,action){var value=action.payload.value;return Object.assign({},state,{commentText:value});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* COMMENT_PROCESS_INSTANCE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* COMMENT_PROCESS_INSTANCE_SUCCESS */],function(state,action){var comment=action.payload.comment;var processList=state.processList;processList[processList.length-1].processCommentList.push(comment);return Object.assign({},state,{fetching:false,error:null,commentText:'',processList:processList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* COMMENT_PROCESS_INSTANCE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_PROCESS_COMMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_PROCESS_COMMENT_SUCCESS */],function(state,action){var processList=action.payload.processList;return Object.assign({},state,{processList:processList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_PROCESS_COMMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_handleActions),initialState));

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["b"]; });


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(22);
var _fetching,_handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={fetching:(_fetching={},_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["i" /* FILE_TYPE_SCAN_FILE */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["l" /* FILE_TYPE_X_RAY */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["e" /* FILE_TYPE_IMPLANT_SCAN_FILE */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["j" /* FILE_TYPE_TREATMENT_PLAN */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["h" /* FILE_TYPE_PRODUCTION */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["f" /* FILE_TYPE_IMPLANT_TREATMENT_PLAN */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["b" /* FILE_TYPE_CONFORMITY_DECLARATION */],false),_defineProperty(_fetching,__WEBPACK_IMPORTED_MODULE_2__const__["g" /* FILE_TYPE_OTHER_FILES */],false),_fetching),error:null,deleteFileConfirmationModalOpen:false,visualizationRequested:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TRIGGER_VISUALIZATION_REQUEST */],function(state,action){return Object.assign({},state,{visualizationRequested:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* UPLOAD_CUSTOMER_FILE_REQUEST */],function(state,action){var fileType=action.payload.fileType;return Object.assign({},state,{fetching:Object.assign({},state.fetching,_defineProperty({},fileType,true)),error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* UPLOAD_CUSTOMER_FILE_SUCCESS */],function(state,action){var fileType=action.payload.fileType;return Object.assign({},state,{fetching:Object.assign({},state.fetching,_defineProperty({},fileType,false))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* UPLOAD_CUSTOMER_FILE_ERROR */],function(state,action){var _action$payload=action.payload,fileType=_action$payload.fileType,error=_action$payload.error;return Object.assign({},state,{fetching:Object.assign({},state.fetching,_defineProperty({},fileType,false)),error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* SET_DELETE_FLAG_REQUEST */],function(state,action){var fileType=action.payload.fileType;return Object.assign({},state,{fetching:Object.assign({},state.fetching,_defineProperty({},fileType,true)),error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* SET_DELETE_FLAG_SUCCESS */],function(state,action){var fileType=action.payload.fileType;return Object.assign({},state,{fetching:Object.assign({},state.fetching,_defineProperty({},fileType,false))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* SET_DELETE_FLAG_ERROR */],function(state,action){var _action$payload2=action.payload,fileType=_action$payload2.fileType,error=_action$payload2.error;return Object.assign({},state,{error:error,fetching:Object.assign({},state.fetching,_defineProperty({},fileType,false))});}),_handleActions),initialState));

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detail_const__ = __webpack_require__(40);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={imageVersionList:{},fetching:false,error:null,showImages:true,uploadingImages:{},retryImages:{},selectedImageType:__WEBPACK_IMPORTED_MODULE_3__detail_const__["a" /* DEFINED_IMAGE_LIST */][10],currentStep:-1,slideIndex:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* TOGGLE_IMAGE_VIEW */],function(state,action){return Object.assign({},state,{showImages:!state.showImages});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_IMAGE_VERSION_LIST_REQUEST */],function(state,action){return Object.assign({},state,{imageVersionList:{},fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_IMAGE_VERSION_LIST_SUCCESS */],function(state,action){var imageVersionList=action.payload.imageVersionList;return Object.assign({},state,{imageVersionList:imageVersionList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_IMAGE_VERSION_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["q" /* UPLOAD_CUSTOMER_IMAGE_REQUEST */],function(state,action){var fileName=action.payload.fileName;var uploadingImages=state.uploadingImages;uploadingImages[fileName]=true;return Object.assign({},state,{uploadingImages:uploadingImages});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["r" /* UPLOAD_CUSTOMER_IMAGE_SUCCESS */],function(state,action){var _action$payload=action.payload,imageVersionList=_action$payload.imageVersionList,fileName=_action$payload.fileName;var uploadingImages=state.uploadingImages;uploadingImages[fileName]=false;var retryImages=state.retryImages;retryImages[fileName]=false;return Object.assign({},state,{imageVersionList:imageVersionList,fetching:false,uploadingImages:uploadingImages,retryImages:retryImages});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* REUPLOAD_CUSTOMER_IMAGE_SUCCESS */],function(state,action){var _action$payload2=action.payload,fileAdded=_action$payload2.fileAdded,imageType=_action$payload2.imageType;var uploadingImages=state.uploadingImages;uploadingImages[imageType]=false;var retryImages=state.retryImages;retryImages[imageType]=false;return Object.assign({},state,{imageVersionList:Object.assign({},state.imageVersionList,_defineProperty({},imageType,fileAdded)),fetching:false,uploadingImages:uploadingImages});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* UPLOAD_CUSTOMER_IMAGE_ERROR */],function(state,action){var fileName=action.payload.fileName;var uploadingImages=state.uploadingImages;uploadingImages[fileName]=false;var retryImages=state.retryImages;retryImages[fileName]=true;return Object.assign({},state,{uploadingImages:uploadingImages,retryImages:retryImages});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* ROTATE_CUSTOMER_IMAGE_REQUEST */],function(state,action){var _action$payload3=action.payload,fileName=_action$payload3.fileName,versionId=_action$payload3.versionId,targetDegree=_action$payload3.targetDegree;var imageVersion=state.imageVersionList[fileName].map(function(version){if(version.versionId!==versionId){return version;}var meta=version.meta?version.meta:{rotate:0};meta.rotate=targetDegree;return Object.assign({},version,{meta:meta});});return Object.assign({},state,{imageVersionList:Object.assign({},state.imageVersionList,_defineProperty({},fileName,imageVersion))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SET_IMAGE_TYPE_META_DATA_SUCCESS */],function(state,action){var _action$payload4=action.payload,imageType=_action$payload4.imageType,versionId=_action$payload4.versionId,newImageType=_action$payload4.newImageType;var imageVersion=state.imageVersionList[imageType].map(function(version){if(version.versionId!==versionId){return version;}var meta=version.meta?version.meta:{imageType:newImageType};meta.imageType=newImageType;return Object.assign({},version,{meta:meta});});return Object.assign({},state,{imageVersionList:Object.assign({},state.imageVersionList,_defineProperty({},imageType,imageVersion))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* SET_SELECTED_IMAGE_TYPE */],function(state,action){var selectedImageTypeName=action.payload.selectedImageTypeName;var selectedImageType=__WEBPACK_IMPORTED_MODULE_3__detail_const__["a" /* DEFINED_IMAGE_LIST */].find(function(item){return item.name===selectedImageTypeName;});return Object.assign({},state,{selectedImageType:selectedImageType});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* SET_CURRENT_STEP */],function(state,action){var currentStep=action.payload.currentStep;return Object.assign({},state,{currentStep:currentStep});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* SET_SLIDE_INDEX */],function(state,action){var slideIndex=action.payload.slideIndex;return Object.assign({},state,{slideIndex:slideIndex});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* DELETE_CUSTOMER_IMAGE_REQUEST */],function(state,action){return Object.assign({},state);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* DELETE_CUSTOMER_IMAGE_SUCCESS */],function(state,action){var _action$payload5=action.payload,imageType=_action$payload5.imageType,versionId=_action$payload5.versionId;var imageVersion=state.imageVersionList[imageType].filter(function(version){return version.versionId!==versionId;});return Object.assign({},state,{imageVersionList:Object.assign({},state.imageVersionList,_defineProperty({},imageType,imageVersion))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* DELETE_CUSTOMER_IMAGE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error});}),_handleActions),initialState));

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_reducer__ = __webpack_require__(87);
var initialState=Object.assign({customerList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CUSTOMER_TABLE */],'customer_customer',{'customer_customer.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CUSTOMER_PARTNER_TABLE */],'customer_customer_partner',{'customer_customer.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CUSTOMER_TABLE */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CUSTOMER_PARTNER_TABLE */])),initialState));

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(356);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={fileList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_SCAN_FOLDER_CONTENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* GET_SCAN_FOLDER_CONTENT_SUCCESS */],function(state,action){var fileList=action.payload.fileList;return Object.assign({},state,{fileList:fileList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* GET_SCAN_FOLDER_CONTENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["b"]; });


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(14);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={imageVersionList:[],selectedImageVersions:[]};var isMatchedWithCurrentlySelectedImageVersion=function isMatchedWithCurrentlySelectedImageVersion(selectedImageVersionFromState,selectedImageVersionFromPayload){return selectedImageVersionFromState.preCheckinPhotoIndex===selectedImageVersionFromPayload.preCheckinPhotoIndex;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* handleActions */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__type__["b" /* SET_SELECTED_IMAGE_VERSIONS */],function(state,action){var selectedImageVersions=state.selectedImageVersions?state.selectedImageVersions:action.payload.selectedImageVersions;var matched=false;for(var i in selectedImageVersions){matched=isMatchedWithCurrentlySelectedImageVersion(selectedImageVersions[i],action.payload.selectedImageVersions[0]);if(matched){selectedImageVersions[i].imageVersionIndexInGallery=action.payload.selectedImageVersions[0].imageVersionIndexInGallery;}}if(!matched){selectedImageVersions.push(action.payload.selectedImageVersions[0]);}return Object.assign({},state,{selectedImageVersions:selectedImageVersions});}),initialState));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__ = __webpack_require__(42);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({fetching:false,error:null,deleteFileConfirmationModalOpen:false},Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:20,sortColumnName:'fileName',sortOrder:1,rowsTotalOptions:[20,40,80,200]}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */],Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["a" /* changeTableSettings */])()),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* UPLOAD_CUSTOMER_FILE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* UPLOAD_CUSTOMER_FILE_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* UPLOAD_CUSTOMER_FILE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* SET_DELETE_FLAG_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* SET_DELETE_FLAG_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* SET_DELETE_FLAG_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_handleActions),initialState));

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manage__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__manage__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__manage__["b" /* reducer */]));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["d"]; });


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_create_uuid__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__(130);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={emailTemplateList:[],emailTemplateAttachmentList:[],userSelection:{processName:null,emailTemplateId:null,locale:'de_DE'},fetching:false,error:null,hasChanged:false,emailTemplate:null,processMacroList:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* FIND_EMAIL_TEMPLATE_LIST_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_EMAIL_TEMPLATE_LIST_SUCCESS */],function(state,action){var emailTemplateList=action.payload.emailTemplateList;return Object.assign({},state,{emailTemplateList:emailTemplateList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* FIND_EMAIL_TEMPLATE_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_PROCESS */],function(state,action){var value=action.payload.value;return Object.assign({},state,{userSelection:Object.assign({},state.userSelection,{processName:value,templateId:null}),emailTemplate:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_LOCALE */],function(state,action){var locale=action.payload.locale;return Object.assign({},state,{userSelection:Object.assign({},state.userSelection,{locale:locale})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_EMAIL_TEMPLATE_BY_ID_REQUEST */],function(state,action){var emailTemplateId=action.payload.emailTemplateId;return Object.assign({},state,{userSelection:Object.assign({},state.userSelection,{emailTemplateId:emailTemplateId}),fetching:true,error:null,emailTemplate:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS */],function(state,action){var emailTemplate=action.payload.emailTemplate;return Object.assign({},state,{fetching:false,emailTemplate:emailTemplate});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_EMAIL_TEMPLATE_BY_ID_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_EMAIL_TEMPLATE_VARIANT */],function(state,action){var _action$payload=action.payload,localId=_action$payload.localId,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{emailTemplate:Object.assign({},state.emailTemplate,{templateVariantList:state.emailTemplate.templateVariantList.map(function(variant){return variant.localId!==localId?variant:Object.assign({},variant,_defineProperty({},name,value));})})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CREATE_EMAIL_TEMPLATE_VARIANT */],function(state,action){if(!state.userSelection.emailTemplateId){return state;}return Object.assign({},state,{emailTemplate:Object.assign({},state.emailTemplate,{templateVariantList:[].concat(_toConsumableArray(state.emailTemplate.templateVariantList),[{locale:state.userSelection.locale,localId:Object(__WEBPACK_IMPORTED_MODULE_2__util_create_uuid__["a" /* default */])(),templateId:state.userSelection.emailTemplateId,designTemplateId:__WEBPACK_IMPORTED_MODULE_3__const__["b" /* DEFAULT_DESIGN_TEMPLATE */],probability:0}])})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["r" /* SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["s" /* SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS */],function(state,action){var _action$payload2=action.payload,localId=_action$payload2.localId,emailTemplateVariant=_action$payload2.emailTemplateVariant;return Object.assign({},state,{emailTemplate:Object.assign({},state.emailTemplate,{templateVariantList:state.emailTemplate.templateVariantList.map(function(variant){return variant.localId===localId?emailTemplateVariant:variant;})}),fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["q" /* SAVE_EMAIL_TEMPLATE_VARIANT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST */],function(state,action){var localId=action.payload.localId;return Object.assign({},state,{emailTemplate:Object.assign({},state.emailTemplate,{templateVariantList:state.emailTemplate.templateVariantList.filter(function(variant){return variant.localId!==localId;})}),error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS */],function(state,action){return Object.assign({},state,{error:null,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* DELETE_EMAIL_TEMPLATE_VARIANT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* GET_PROCESS_MACRO_LIST_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* GET_PROCESS_MACRO_LIST_SUCCESS */],function(state,action){var _action$payload3=action.payload,processName=_action$payload3.processName,emailMacroList=_action$payload3.emailMacroList;return Object.assign({},state,{fetching:false,processMacroList:Object.assign({},state.processMacroList,_defineProperty({},processName,emailMacroList))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* GET_PROCESS_MACRO_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_handleActions),initialState));

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_state_auth_type__ = __webpack_require__(220);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={employee:null,fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__security_state_auth_type__["h" /* LOGIN_SUCCESS */],function(state,action){var user=action.payload.user;return Object.assign({},state,{employee:user.employee});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_EMPLOYEE */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{employee:Object.assign({},state.employee,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* SET_SIPGATE_DEVICE_ID_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* SET_SIPGATE_DEVICE_ID_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* SET_SIPGATE_DEVICE_ID_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overview_info_table__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__overview_csv_upload__ = __webpack_require__(709);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__overview_csv_upload__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__overview_csv_upload__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__overview_info_table__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__overview_info_table__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({foilList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:20,sortColumnName:'status',sortOrder:1}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */],Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["a" /* changeTableSettings */])()),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_FOIL_LIST_REQUEST */],function(state){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_FOIL_LIST_SUCCESS */],function(state,action){var foilList=action.payload.foilList;return Object.assign({},state,{foilList:foilList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_FOIL_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(710);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(363);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* UPLOAD_CSV_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* UPLOAD_CSV_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* UPLOAD_CSV_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_handleActions),initialState));

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(225);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* INIT_GLOBALS */],function(state,action){var globals=action.payload.globals;return Object.assign({},globals);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* SAVE_VIEW_PREFERENCES */],function(state,action){var viewPreferences=action.payload;return Object.assign({},state,{user:Object.assign({},state.user,{viewPreferences:viewPreferences})});}),_handleActions),initialState));

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(715);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={messageList:[],email:null,fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FIND_GMAIL_MESSAGES_REQUEST */],function(state,action){return Object.assign({},state,{messageList:[],email:null,fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_GMAIL_MESSAGES_SUCCESS */],function(state,action){var _action$payload=action.payload,email=_action$payload.email,messageList=_action$payload.messageList;return Object.assign({},state,{messageList:messageList,email:email,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_GMAIL_MESSAGE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TOGGLE_GMAIL_MESSAGE */],function(state,action){var messageId=action.payload.messageId;return Object.assign({},state,{messageList:state.messageList.map(function(message){return messageId!==message.id?message:Object.assign({},message,{open:!message.open});})});}),_handleActions),initialState));

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIND_GMAIL_MESSAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_GMAIL_MESSAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_GMAIL_MESSAGE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_GMAIL_MESSAGE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(364);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/';var FIND_GMAIL_MESSAGES_REQUEST=NS+'FIND_GMAIL_MESSAGES_REQUEST';var FIND_GMAIL_MESSAGES_SUCCESS=NS+'FIND_GMAIL_MESSAGES_SUCCESS';var FIND_GMAIL_MESSAGE_ERROR=NS+'FIND_GMAIL_MESSAGE_ERROR';var TOGGLE_GMAIL_MESSAGE=NS+'TOGGLE_GMAIL_MESSAGE';

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__correction__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__display__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__correction__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__correction__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__display__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__display__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(365);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={confirmationModalOpen:false,invoice:null,invoiceCorrection:null,fetching:false,error:null,invoiceCorrectionData:{customText:''}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_INVOICE_BY_ID_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_INVOICE_BY_ID_SUCCESS */],function(state,action){var invoice=action.payload.invoice;return Object.assign({},state,{fetching:false,invoice:Object.assign({},invoice,{invoiceItemList:invoice.invoiceItemList.map(function(invoiceItem){return Object.assign({},invoiceItem,{correctionAmount:0});})})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_INVOICE_BY_ID_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SHOW_CONFIRMATION_MODAL */],function(state,action){return Object.assign({},state,{confirmationModalOpen:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CLOSE_CONFIRMATION_MODAL */],function(state,action){return Object.assign({},state,{confirmationModalOpen:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_INVOICE_CORRECTION_ITEM */],function(state,action){var _action$payload=action.payload,invoiceItemId=_action$payload.invoiceItemId,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{invoice:Object.assign({},state.invoice,{invoiceItemList:state.invoice.invoiceItemList.map(function(invoice){return invoice.id!==invoiceItemId?invoice:Object.assign({},invoice,_defineProperty({},name,value));})})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_INVOICE_CORRECTION_DATA */],function(state,action){var _action$payload2=action.payload,name=_action$payload2.name,value=_action$payload2.value;return Object.assign({},state,{invoiceCorrectionData:Object.assign({},state.invoiceCorrectionData,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CREATE_INVOICE_CORRECTION_REQUEST */],function(state,action){return Object.assign({},state,{confirmationModalOpen:false,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CREATE_INVOICE_CORRECTION_SUCCESS */],function(state,action){var invoiceCorrection=action.payload.invoiceCorrection;return Object.assign({},state,{invoiceCorrection:invoiceCorrection,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CREATE_INVOICE_CORRECTION_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(366);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={confirmationModalOpen:false,invoice:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SHOW_CONFIRMATION_MODAL */],function(state,action){var invoice=action.payload.invoice;return Object.assign({},state,{confirmationModalOpen:true,invoice:invoice});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CLOSE_CONFIRMATION_MODAL */],function(state,action){return Object.assign({},state,{confirmationModalOpen:false,invoice:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CREATE_CORRECTION_SUCCESS */],function(state,action){return Object.assign({},state,{confirmationModalOpen:false,invoice:null});}),_handleActions),initialState));

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(367);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var isTablet=!!navigator.userAgent.match(/Tablet|iPad|iPod/i);var initialState={isNavigationCollapsed:isTablet||window.innerWidth<600,isTablet:isTablet};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_1__type__["a" /* TOGGLE_NAVIGATION */],function(state,action){return Object.assign({},state,{isNavigationCollapsed:!state.isNavigationCollapsed});}),initialState));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_reducer_helper__ = __webpack_require__(725);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({leadList:[],fetching:false,error:null,lead:null,hasChanged:false},Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["c" /* createInitialTableState */])());/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_TABLE_SETTING */],Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["a" /* changeTableSettings */])()),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_ALL_LEAD_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_ALL_LEAD_SUCCESS */],function(state,action){var leadList=action.payload.leadList;return Object.assign({},state,{leadList:leadList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_ALL_LEAD_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_LEAD_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,lead:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_LEAD_SUCCESS */],function(state,action){var lead=action.payload.lead;return Object.assign({},state,{lead:lead,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_LEAD_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_LEAD */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{lead:Object.assign({},state.lead,_defineProperty({},name,value)),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_LEAD_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_LEAD_SUCCESS */],function(state,action){var lead=action.payload.lead;return Object.assign({},state,{lead:lead,fetching:false,hasChanged:false,leadList:Object(__WEBPACK_IMPORTED_MODULE_3__util_reducer_helper__["a" /* changeInList */])(state.leadList,lead)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SAVE_LEAD_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ADD_SENT_EMAIL */],function(state,action){var sentEmail=action.payload.sentEmail;return Object.assign({},state,{lead:Object.assign({},state.lead,{sentEmailList:[].concat(_toConsumableArray(state.lead.sentEmailList),[sentEmail])})});}),_handleActions),initialState));

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeInList; });
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var changeInList=function changeInList(list,item){if(!item.id){list.push(item);return[].concat(_toConsumableArray(list));}list=list.filter(function(listItem){return listItem.id!==item.id;});list.push(item);return[].concat(_toConsumableArray(list));};

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list__ = __webpack_require__(727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__list__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__list__["b" /* reducer */]));

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={fetching:false,error:null,shipmentDetailOpen:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CREATE_SHIPMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CREATE_SHIPMENT_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CREATE_SHIPMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TOGGLE_SHIPMENT_TRACKING */],function(state,action){var shipmentId=action.payload.shipmentId;return Object.assign({},state,{shipmentDetailOpen:Object.assign({},state.shipmentDetailOpen,_defineProperty({},shipmentId,!state.shipmentDetailOpen[shipmentId]))});}),_handleActions),initialState));

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__associate_payment__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__upload__ = __webpack_require__(732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["b"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__associate_payment__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__associate_payment__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__upload__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__upload__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({paymentList:[],payment:null,fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:10,sortColumnName:'date',sortOrder:-1}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_TABLE_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["a" /* changeTableSettings */])()),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* FIND_UNASSIGNED_PAYMENT_LIST_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS */],function(state,action){var paymentList=action.payload.paymentList;return Object.assign({},state,{paymentList:paymentList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* FIND_UNASSIGNED_PAYMENT_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* EDIT_UNASSIGNED_PAYMENT */],function(state,action){var payment=action.payload.payment;return Object.assign({},state,{payment:payment});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_CUSTOMER */],function(state,action){var customer=action.payload.customer;return Object.assign({},state,{payment:Object.assign({},state.payment,{customer:customer,customerId:customer.id,salesOrderId:null})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CHANGE_SALES_ORDER */],function(state,action){var value=action.payload.value;return Object.assign({},state,{payment:Object.assign({},state.payment,{salesOrderId:value})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* ASSOCIATE_PAYMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* ASSOCIATE_PAYMENT_SUCCESS */],function(state,action){var paymentList=action.payload.paymentList;return Object.assign({},state,{paymentList:paymentList,payment:null,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ASSOCIATE_PAYMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* DELETE_PAYMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* DELETE_PAYMENT_SUCCESS */],function(state,action){var paymentList=action.payload.paymentList;return Object.assign({},state,{paymentList:paymentList,payment:null,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* DELETE_PAYMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(372);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={paymentList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* UPLOAD_CSV_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,paymentList:[]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* UPLOAD_CSV_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* UPLOAD_CSV_SUCCESS */],function(state,action){var paymentList=action.payload.paymentList;return Object.assign({},state,{fetching:false,paymentList:paymentList});}),_handleActions),initialState));

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detail__ = __webpack_require__(737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__search__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__detail__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(736);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_reducer__ = __webpack_require__(87);
var initialState=Object.assign({partnerList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* PARTNER_TABLE */],'partner_partner',{'partner.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]},{'limit':5000}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* PARTNER_TABLE */])),initialState));

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(374);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={partner:{'active':0,'isTreatingPhysician':0},error:null,hasChanged:false,redirect:false,fetching:false,validationMessageList:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* EDIT_PARTNER */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{hasChanged:true,partner:Object.assign({},state.partner,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_PARTNER_REQUEST */],function(state){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* SAVE_PARTNER_SUCCESS */],function(state){return Object.assign({},state,{redirect:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_PARTNER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,validationMessageList:[error]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_PARTNER_REQUEST */],function(state){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_PARTNER_SUCCESS */],function(state,action){var partner=action.payload.partner;return Object.assign({},state,{partner:partner,hasChanged:false,fetching:false,validationMessageList:[]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_PARTNER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* VALIDATION_LIST */],function(state,action){var list=action.payload.list;return Object.assign({},state,{validationMessageList:list});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CLEAR_STATE */],function(){return Object.assign({},initialState);}),_handleActions),initialState));

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__search__["b" /* reducer */]));

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(239);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={voucherCode:{value:''},fetching:false,error:null,voucherTable:{objectList:[]}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_VOUCHER_CODE */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{voucherCode:_defineProperty({},name,value)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* REQUEST_VOUCHER_TABLE_DATA */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_VOUCHER_TABLE_DATA */],function(state,action){var _Object$assign;var objectList=action.payload.objectList;return Object.assign({},state,(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* VOUCHER_TABLE */],Object.assign({},state[__WEBPACK_IMPORTED_MODULE_1__type__["e" /* VOUCHER_TABLE */]],{objectList:objectList})),_defineProperty(_Object$assign,'fetching',false),_Object$assign));}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* ERROR_VOUCHER_TABLE_DATA */],function(state,action){var _Object$assign2;var error=action.payload.error;return Object.assign({},state,(_Object$assign2={},_defineProperty(_Object$assign2,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* VOUCHER_TABLE */],Object.assign({},state[__WEBPACK_IMPORTED_MODULE_1__type__["e" /* VOUCHER_TABLE */]],{'objectList':[]})),_defineProperty(_Object$assign2,'fetching',false),_defineProperty(_Object$assign2,'error',error),_Object$assign2));}),_handleActions),initialState));

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__barcode__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instance_detail__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_responsible__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__task_definition__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__task_detail__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__task_list__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__version_summary__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__barcode__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__barcode__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__instance_detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__instance_detail__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_4__state_responsible__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_4__state_responsible__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_5__task_definition__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_5__task_definition__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_6__task_detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_6__task_detail__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_7__task_list__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_7__task_list__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_8__version_summary__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_8__version_summary__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(744);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(375);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={barcode:{value:''}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_BAR_CODE */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{barcode:_defineProperty({},name,value)});}),initialState));

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(746);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={processInstance:null,fetching:false,error:null,processFlowVisible:false,commentText:null,contextHasChanged:false,beamProcessState:{},validationMessageList:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},state,{processInstance:null,processFlowVisible:false,fetching:false,commentText:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["s" /* PROCESS_INSTANCE_LOADED */],function(state,action){var processInstance=action.payload.processInstance;return Object.assign({},state,{processInstance:processInstance,fetching:false,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* FIND_PROCESS_INSTANCE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* FIND_PROCESS_INSTANCE_SUCCESS */],function(state,action){var processInstance=action.payload.processInstance;return Object.assign({},state,{processInstance:processInstance,fetching:false,processFlowVisible:false,validationMessageList:[]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_PROCESS_INSTANCE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["x" /* TOGGLE_PROCESS_FLOW_VISIBILITY */],function(state,action){return Object.assign({},state,{processFlowVisible:!state.processFlowVisible});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["C" /* TOGGLE_VIP_STATUS_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["B" /* TOGGLE_VIP_STATUS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["D" /* TOGGLE_VIP_STATUS_SUCCESS */],function(state,action){return Object.assign({},state,{processInstance:Object.assign({},state.processInstance,{vip:!state.processInstance.vip}),fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["z" /* TOGGLE_RUSH_STATUS_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["y" /* TOGGLE_RUSH_STATUS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["A" /* TOGGLE_RUSH_STATUS_SUCCESS */],function(state,action){return Object.assign({},state,{processInstance:Object.assign({},state.processInstance,{rush:!state.processInstance.rush}),fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CHANGE_PROCESS_COMMENT */],function(state,action){var value=action.payload.value;return Object.assign({},state,{commentText:value});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* COMMENT_PROCESS_INSTANCE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* COMMENT_PROCESS_INSTANCE_SUCCESS */],function(state,action){var comment=action.payload.comment;return Object.assign({},state,{processInstance:Object.assign({},state.processInstance,{processCommentList:[].concat(_toConsumableArray(state.processInstance.processCommentList),[comment])}),fetching:false,error:null,commentText:''});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* COMMENT_PROCESS_INSTANCE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_PROCESS_CONTEXT */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{processInstance:Object.assign({},state.processInstance,{context:Object.assign({},state.processInstance.context,_defineProperty({},name,value))}),contextHasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["u" /* SAVE_PROCESS_CONTEXT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["v" /* SAVE_PROCESS_CONTEXT_SUCCESS */],function(state,action){return Object.assign({},state,{processInstance:Object.assign({},state.processInstance,{context:Object.assign({},state.processInstance.context,action.payload.context)}),fetching:false,contextHasChanged:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["t" /* SAVE_PROCESS_CONTEXT_ERROR */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["w" /* SET_VALIDATION_MESSAGE_LIST */],function(state,action){var validationMessageList=action.payload.validationMessageList;return Object.assign({},state,{validationMessageList:validationMessageList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["q" /* FIRE_EVENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,processFlowVisible:false,validationMessageList:[]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["r" /* FIRE_EVENT_SUCCESS */],function(state,action){var processInstance=action.payload.processInstance;return Object.assign({},state,{processInstance:processInstance,fetching:false,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* FIRE_EVENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* CHANGE_TIME_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* CHANGE_TIME_SUCCESS */],function(state,action){var _action$payload2=action.payload,name=_action$payload2.name,value=_action$payload2.value;return Object.assign({},state,{fetching:false,processInstance:Object.assign({},state.processInstance,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* CHANGE_TIME_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_BEAM_PROCESS_STATE */],function(state,action){var _action$payload3=action.payload,name=_action$payload3.name,beamProcessState=_action$payload3.beamProcessState;return Object.assign({},state,{beamProcessState:_defineProperty({},name,beamProcessState)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* BEAM_PROCESS_INSTANCE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* BEAM_PROCESS_INSTANCE_SUCCESS */],function(state,action){var processInstance=action.payload.processInstance;return Object.assign({},state,{processInstance:processInstance,fetching:false,processFlowVisible:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* BEAM_PROCESS_INSTANCE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error,processFlowVisible:false});}),_handleActions),initialState));

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(377);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={stateResponsibleList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_STATE_RESPONSIBLE_LIST_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_STATE_RESPONSIBLE_LIST_SUCCESS */],function(state,action){var stateResponsibleList=action.payload.stateResponsibleList;return Object.assign({},state,{stateResponsibleList:stateResponsibleList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_STATE_RESPONSIBLE_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_STATE_RESPONSIBLE */],function(state,action){var _action$payload=action.payload,stateResponsibleId=_action$payload.stateResponsibleId,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{stateResponsibleList:state.stateResponsibleList.map(function(stateResponsible){return stateResponsible.id!==stateResponsibleId?stateResponsible:Object.assign({},stateResponsible,_defineProperty({},name,value));})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_STATE_RESPONSIBLE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_STATE_RESPONSIBLE_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_STATE_RESPONSIBLE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(750);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["c"]; });


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(379);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={taskDefinitionList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_TASK_DEFINITION_LIST_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_TASK_DEFINITION_LIST_SUCCESS */],function(state,action){var taskDefinitionList=action.payload.taskDefinitionList;return Object.assign({},state,{taskDefinitionList:taskDefinitionList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_TASK_DEFINITION_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TASK_DEFINITION */],function(state,action){var _action$payload=action.payload,taskDefinitionId=_action$payload.taskDefinitionId,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{taskDefinitionList:state.taskDefinitionList.map(function(taskDefinition){return taskDefinition.id!==taskDefinitionId?taskDefinition:Object.assign({},taskDefinition,_defineProperty({},name,value));})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_TASK_DEFINITION_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_TASK_DEFINITION_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_TASK_DEFINITION_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={task:null,fetching:false,error:null,noFollowUp:false,processFlowVisible:false,validationMessageList:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},state,{task:null,noFollowUp:false,fetching:false,validationMessageList:[]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* FIND_TASK_DETAIL_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,noFollowUp:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_TASK_DETAIL_SUCCESS */],function(state,action){var task=action.payload.task;return Object.assign({},state,{task:task,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* FIND_TASK_DETAIL_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* TOGGLE_PROCESS_FLOW_VISIBILITY */],function(state,action){return Object.assign({},state,{processFlowVisible:!state.processFlowVisible});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["y" /* UPDATE_VALIDATION_MESSAGE_LIST */],function(state,action){var validationMessageList=action.payload.validationMessageList;return Object.assign({},state,{validationMessageList:validationMessageList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_TASK_STATUS_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* CHANGE_TASK_STATUS_SUCCESS */],function(state,action){var status=action.payload.status;return Object.assign({},state,{fetching:false,task:Object.assign({},state.task,{status:status})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CHANGE_TASK_STATUS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_DUE_DATE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_DUE_DATE_SUCCESS */],function(state,action){var due=action.payload.due;return Object.assign({},state,{fetching:false,task:Object.assign({},state.task,{due:due})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_DUE_DATE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_PROCESS_TASK */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{task:Object.assign({},state.task,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["w" /* UPDATE_ASSIGNED_TO_USER_ID_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["x" /* UPDATE_ASSIGNED_TO_USER_ID_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["v" /* UPDATE_ASSIGNED_TO_USER_ID_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* TRIGGER_EVENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["q" /* TRIGGER_EVENT_SUCCESS */],function(state,action){var task=action.payload.task;return Object.assign({},state,{fetching:false,validationMessageList:[],task:task});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["r" /* TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK */],function(state,action){return Object.assign({},state,{fetching:false,noFollowUp:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* TRIGGER_EVENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* CLAIM_TASK_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* CLAIM_TASK_SUCCESS */],function(state,action){var task=action.payload.task;return Object.assign({},state,{fetching:false,task:Object.assign({},state.task,{assignedToUserId:task.assignedToUserId})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* CLAIM_TASK_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["t" /* UN_CLAIM_TASK_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["u" /* UN_CLAIM_TASK_SUCCESS */],function(state,action){var task=action.payload.task;return Object.assign({},state,{fetching:false,task:Object.assign({},state.task,{assignedToUserId:task.assignedToUserId})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["s" /* UN_CLAIM_TASK_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_state_reducer__ = __webpack_require__(87);
var _Object$assign;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({taskList:[],allOpenTaskList:[],allOpenTask:{},fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:20,sortColumnName:'created',sortOrder:-1}),Object(__WEBPACK_IMPORTED_MODULE_3__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TABLE_ALL_OPEN_TASK */],'process_task_all',{'process_task.created':__WEBPACK_IMPORTED_MODULE_3__table_state_reducer__["b" /* DESC */]}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TABLE_ALL_OPEN_TASK */]),(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */],Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["a" /* changeTableSettings */])()),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_TASK_LIST_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_TASK_LIST_SUCCESS */],function(state,action){var taskList=action.payload.taskList;return Object.assign({},state,{taskList:taskList,fetching:false});}),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_TASK_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_Object$assign)),initialState));

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(381);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={versionSummary:[],error:null,fetching:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_VERSION_SUMMARY_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* GET_VERSION_SUMMARY_SUCCESS */],function(state,action){var versionSummary=action.payload.versionSummary;return Object.assign({},state,{versionSummary:versionSummary,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* GET_VERSION_SUMMARY_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error,fetching:false});}),_handleActions),initialState));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__search__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__detail__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={prospect:null,fetching:false,error:null,hasChanged:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_PROSPECT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_PROSPECT_SUCCESS */],function(state,action){var prospect=action.payload.prospect;return Object.assign({},state,{prospect:prospect,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_PROSPECT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_PROSPECT */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{hasChanged:true,prospect:Object.assign({},state.prospect,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_PROSPECT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* SAVE_PROSPECT_SUCCESS */],function(state,action){var prospect=action.payload.prospect;return Object.assign({},state,{fetching:false,hasChanged:false,prospect:prospect});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_PROSPECT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* NO_SHOW_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* NO_SHOW_SUCCESS */],function(state,action){var prospect=action.payload.prospect;return Object.assign({},state,{fetching:false,hasChanged:false,prospect:prospect});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* NO_SHOW_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* START_IN_SHOP_PROCESS_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* START_IN_SHOP_PROCESS_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* START_IN_SHOP_PROCESS_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* ARCHIVE_PROSPECT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* ARCHIVE_PROSPECT_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ARCHIVE_PROSPECT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({prospectList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["c" /* createInitialTableState */])({sortColumnName:'created',sortOrder:-1},'prospectTableSetting'));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */],Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["a" /* changeTableSettings */])('prospectTableSetting')),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_ALL_PROSPECT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_ALL_PROSPECT_SUCCESS */],function(state,action){var prospectList=action.payload.prospectList;return Object.assign({},state,{prospectList:prospectList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_ALL_PROSPECT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TABLE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_ALL_PROSPECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIND_ALL_PROSPECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_ALL_PROSPECT_ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(246);
var NS=__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]+'/'+__WEBPACK_IMPORTED_MODULE_1__const__["a" /* REDUCER_NAME */]+'/';var CHANGE_TABLE_SETTING=NS+'CHANGE_TABLE_SETTING';var FIND_ALL_PROSPECT_REQUEST=NS+'FIND_ALL_PROSPECT_REQUEST';var FIND_ALL_PROSPECT_SUCCESS=NS+'FIND_ALL_PROSPECT_SUCCESS';var FIND_ALL_PROSPECT_ERROR=NS+'FIND_ALL_PROSPECT_ERROR';

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(383);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={refinementReason:null,hasChanged:false,fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* GET_REFINEMENT_REASON_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,refinementReason:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* GET_REFINEMENT_REASON_SUCCESS */],function(state,action){var refinementReason=action.payload.refinementReason;return Object.assign({},state,{refinementReason:refinementReason,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_REFINEMENT_REASON_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_REFINEMENT_REASON */],function(state,action){var refinementReason=action.payload.refinementReason;return Object.assign({},state,{refinementReason:refinementReason,hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_REFINEMENT_REASON_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_REFINEMENT_REASON_SUCCESS */],function(state,action){var refinementReason=action.payload.refinementReason;return Object.assign({},state,{refinementReason:refinementReason,fetching:false,hasChanged:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_REFINEMENT_REASON_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["d"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__detail__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__search__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(385);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={salesOrder:null,fetching:false,error:null,hasChanged:false,contact:{id:null,gender:null,firstName:null,lastName:null,streetAddress:null,streetAddressExtension:null,staircase:null,door:null,zip:null,city:null,countryCode:null,email:null,phone:null,dob:null}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},state,{salesOrder:null,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["h" /* FIND_SALES_ORDER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,salesOrder:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["i" /* FIND_SALES_ORDER_SUCCESS */],function(state,action){var salesOrder=action.payload.salesOrder;return Object.assign({},state,{salesOrder:salesOrder,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["g" /* FIND_SALES_ORDER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["e" /* CHANGE_SALES_ORDER_CUSTOMER */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{salesOrder:Object.assign({},state.salesOrder,{salesOrderCustomer:Object.assign({},state.salesOrder.salesOrderCustomer,_defineProperty({},name,value))}),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["l" /* SAVE_SALES_ORDER_CUSTOMER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["m" /* SAVE_SALES_ORDER_CUSTOMER_SUCCESS */],function(state,action){var salesOrderCustomer=action.payload.salesOrderCustomer;return Object.assign({},state,{fetching:false,hasChanged:false,salesOrder:Object.assign({},state.salesOrder,{salesOrderCustomer:salesOrderCustomer})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["k" /* SAVE_SALES_ORDER_CUSTOMER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["d" /* CHANGE_SALES_ORDER */],function(state,action){var _action$payload2=action.payload,name=_action$payload2.name,value=_action$payload2.value;return Object.assign({},state,{salesOrder:Object.assign({},state.salesOrder,_defineProperty({},name,value)),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["o" /* SAVE_SALES_ORDER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["p" /* SAVE_SALES_ORDER_SUCCESS */],function(state,action){var salesOrder=action.payload.salesOrder;return Object.assign({},state,{salesOrder:salesOrder,fetching:false,hasChanged:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["n" /* SAVE_SALES_ORDER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["b" /* ADD_SENT_EMAIL */],function(state,action){var sentEmail=action.payload.sentEmail;return Object.assign({},state,{salesOrder:Object.assign({},state.salesOrder,{sentEmailList:[].concat(_toConsumableArray(state.salesOrder.sentEmailList),[sentEmail])})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["a" /* ADD_INVOICE */],function(state,action){var invoice=action.payload.invoice;return Object.assign({},state,{salesOrder:Object.assign({},state.salesOrder,{invoiceList:[].concat(_toConsumableArray(state.salesOrder.invoiceList),[invoice])})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["c" /* ADD_SHIPMENT */],function(state,action){var shipment=action.payload.shipment;return Object.assign({},state,{salesOrder:Object.assign({},state.salesOrder,{shipmentList:[].concat(_toConsumableArray(state.salesOrder.shipmentList),[shipment])})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["j" /* HYDRATE_SALESORDER_CUSTOMER_CONTACT */],function(state,action){var salesOrder=state.salesOrder;var salesOrderCustomer=salesOrder.salesOrderCustomer;return Object.assign({},state,{contact:{id:salesOrderCustomer.id,gender:salesOrderCustomer.gender,firstName:salesOrderCustomer.firstName,lastName:salesOrderCustomer.lastName,streetAddress:salesOrderCustomer.streetAddress,streetAddressExtension:salesOrderCustomer.streetAddressExtension,staircase:salesOrderCustomer.staircase,door:salesOrderCustomer.door,zip:salesOrderCustomer.zip,city:salesOrderCustomer.city,countryCode:salesOrderCustomer.countryCode,email:salesOrderCustomer.email,phone:salesOrderCustomer.phone,dob:salesOrderCustomer.dob}});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["f" /* CHANGE_SALES_ORDER_CUSTOMER_CONTACT */],function(state,action){var _action$payload3=action.payload,name=_action$payload3.name,value=_action$payload3.value;return Object.assign({},state,{hasChanged:true,contact:Object.assign({},state.contact,_defineProperty({},name,value))});}),_handleActions),initialState));

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_reducer__ = __webpack_require__(87);
var initialState=Object.assign({salesOrderList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["n" /* TABLE_SET */],'salesorder_salesorder_set',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* TABLE_CHECK_IN */],'salesorder_salesorder_check_in',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["g" /* TABLE_IN_SHOP_SCAN */],'salesorder_salesorder_in_shop_scan',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["o" /* TABLE_SHOP_SCAN */],'salesorder_salesorder_shop_scan',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["p" /* TABLE_TREATMENT */],'salesorder_salesorder_treatment',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["b" /* TABLE_END_OF_TREATMENT */],'salesorder_salesorder_end_of_treatment',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["i" /* TABLE_REFINEMENT_PRODUCTION */],'salesorder_salesorder_refinement_production',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["j" /* TABLE_REFINEMENT_SET */],'salesorder_salesorder_refinement_set',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["h" /* TABLE_REFINEMENT_BOOKING */],'salesorder_salesorder_refinement_booking',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["k" /* TABLE_REFINEMENT_SHOP */],'salesorder_salesorder_refinement_shop',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["l" /* TABLE_RETAINER */],'salesorder_salesorder_retainer',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["m" /* TABLE_RETAINER_REFINEMENT */],'salesorder_salesorder_retainer_refinement',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["c" /* TABLE_ESCALATION */],'salesorder_salesorder_escalation',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TABLE_IMPLANT_3DSCAN */],'salesorder_salesorder_implant_3dscan',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TABLE_IMPLANT_PLAN */],'salesorder_salesorder_implant_plan',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["f" /* TABLE_IMPLANT_TREATMENT */],'salesorder_salesorder_implant_treatment',{'salesorder_salesorder.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["n" /* TABLE_SET */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* TABLE_CHECK_IN */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["g" /* TABLE_IN_SHOP_SCAN */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["o" /* TABLE_SHOP_SCAN */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["p" /* TABLE_TREATMENT */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["b" /* TABLE_END_OF_TREATMENT */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["i" /* TABLE_REFINEMENT_PRODUCTION */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["j" /* TABLE_REFINEMENT_SET */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["k" /* TABLE_REFINEMENT_SHOP */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["h" /* TABLE_REFINEMENT_BOOKING */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["l" /* TABLE_RETAINER */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["m" /* TABLE_RETAINER_REFINEMENT */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["c" /* TABLE_ESCALATION */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["d" /* TABLE_IMPLANT_3DSCAN */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TABLE_IMPLANT_PLAN */]),Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["f" /* TABLE_IMPLANT_TREATMENT */])),initialState));

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manage__ = __webpack_require__(773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__auth__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__manage__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__manage__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["d"]; });


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(220);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={loginData:{email:'',password:''},validation:null,error:null,user:null,loading:false,passwordResetRequired:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_LOGIN_DATA */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{loginData:Object.assign({},state.loginData,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* LOGIN_REQUEST */],function(state,action){return Object.assign({},state,{loading:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* LOGIN_SUCCESS */],function(state,action){var user=action.payload.user;return Object.assign({},state,{loading:false,user:user});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* LOGIN_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{loading:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* LOGIN_PASSWORD_RESET_REQUIRED */],function(state,action){return Object.assign({},state,{loading:false,passwordResetRequired:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_PASSWORD_REQUEST */],function(state,action){return Object.assign({},state,{loading:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_PASSWORD_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{loading:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* LOGOUT_SUCCESS */],function(state,action){return initialState;}),_handleActions),initialState));

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(387);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={userList:[],currentUser:null,currentUserId:null,error:null,fetching:false,passwordStatus:null,hasChanged:false,validationMessageList:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* FIND_ALL_USER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* FIND_ALL_USER_SUCCESS */],function(state,action){var userList=action.payload.userList;return Object.assign({},state,{fetching:false,userList:userList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_ALL_USER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CREATE_EMPLOYEE */],function(state,action){return Object.assign({},state,{currentUser:{firstName:'',lastName:'',employee:{},roleList:[],visibleWidgetList:[]},error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CREATE_EXTERNAL_USER */],function(state,action){return Object.assign({},state,{currentUser:{firstName:'',lastName:'',externalUser:{roleList:[],visibleWidgetList:[]},roleList:[],visibleWidgetList:[]},error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_CURRENT_USER_ID */],function(state,action){var currentUserId=action.payload.currentUserId;var currentUser=state.userList.find(function(user){return user.id===currentUserId;});return Object.assign({},state,{currentUserId:currentUserId,passwordStatus:null,currentUser:currentUser,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_USER */],function(state,action){var _Object$assign2,_Object$assign4;var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return state.currentUser.employee?Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,(_Object$assign2={},_defineProperty(_Object$assign2,name,value),_defineProperty(_Object$assign2,'employee',Object.assign({},state.currentUser.employee,_defineProperty({},name,value))),_Object$assign2))}):Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,(_Object$assign4={},_defineProperty(_Object$assign4,name,value),_defineProperty(_Object$assign4,'externalUser',Object.assign({},state.currentUser.externalUser,_defineProperty({},name,value))),_Object$assign4))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_EXTERNAL_USER */],function(state,action){var _action$payload2=action.payload,name=_action$payload2.name,value=_action$payload2.value;return Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,{externalUser:Object.assign({},state.currentUser.externalUser,_defineProperty({},name,value))})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["z" /* TOGGLE_ROLE */],function(state,action){var _action$payload3=action.payload,role=_action$payload3.role,active=_action$payload3.active;var visibleWidgetListManuallyRemoved=[];var visibleWidgetListManuallyAdded=[];if(!state.currentUser.visibleWidgetListManuallyRemoved){state.currentUser.visibleWidgetListManuallyRemoved=visibleWidgetListManuallyRemoved;}if(!state.currentUser.visibleWidgetListManuallyAdded){state.currentUser.visibleWidgetListManuallyAdded=visibleWidgetListManuallyAdded;}var roleList=!active?state.currentUser.roleList.filter(function(roleName){return roleName!==role;}):[].concat(_toConsumableArray(state.currentUser.roleList),[role]);var visibleWidgetSet=new Set();roleList.forEach(function(role){var widgetsForRole=state.roleList.find(function(roleObject){return roleObject.role===role;});if(widgetsForRole){widgetsForRole.widgetList.forEach(function(widgetId){return visibleWidgetSet.add(widgetId);});}});state.currentUser.visibleWidgetListManuallyAdded.forEach(function(widgetId){return visibleWidgetSet.add(widgetId);});state.currentUser.visibleWidgetListManuallyRemoved.forEach(function(widgetId){if(visibleWidgetSet.has(widgetId)){visibleWidgetSet.delete(widgetId);}});var visibleWidgetList=[].concat(_toConsumableArray(visibleWidgetSet));return state.currentUser.employee?Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,{roleList:roleList,visibleWidgetList:visibleWidgetList})}):Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,{roleList:roleList,visibleWidgetList:visibleWidgetList,externalUser:Object.assign({},state.currentUser.externalUser,{roleList:roleList,visibleWidgetList:visibleWidgetList})})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["B" /* TOGGLE_WIDGET_ACCESS */],function(state,action){var _action$payload4=action.payload,widgetId=_action$payload4.widgetId,active=_action$payload4.active;var visibleWidgetListManuallyRemoved=[];var visibleWidgetListManuallyAdded=[];if(!state.currentUser.visibleWidgetListManuallyRemoved){state.currentUser.visibleWidgetListManuallyRemoved=visibleWidgetListManuallyRemoved;}if(!state.currentUser.visibleWidgetListManuallyAdded){state.currentUser.visibleWidgetListManuallyAdded=visibleWidgetListManuallyAdded;}if(active){visibleWidgetListManuallyRemoved=state.currentUser.visibleWidgetListManuallyRemoved.filter(function(currentWidgetId){return currentWidgetId!==widgetId;});visibleWidgetListManuallyAdded=[].concat(_toConsumableArray(state.currentUser.visibleWidgetListManuallyAdded),[widgetId]);}else{visibleWidgetListManuallyAdded=state.currentUser.visibleWidgetListManuallyAdded.filter(function(currentWidgetId){return currentWidgetId!==widgetId;});visibleWidgetListManuallyRemoved=[].concat(_toConsumableArray(state.currentUser.visibleWidgetListManuallyRemoved),[widgetId]);}var visibleWidgetList=!active?state.currentUser.visibleWidgetList.filter(function(currentWidgetId){return currentWidgetId!==widgetId;}):[].concat(_toConsumableArray(state.currentUser.visibleWidgetList),[widgetId]);return state.currentUser.employee?Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,{visibleWidgetList:visibleWidgetList,visibleWidgetListManuallyAdded:visibleWidgetListManuallyAdded,visibleWidgetListManuallyRemoved:visibleWidgetListManuallyRemoved})}):Object.assign({},state,{hasChanged:true,currentUser:Object.assign({},state.currentUser,{visibleWidgetList:visibleWidgetList,visibleWidgetListManuallyAdded:visibleWidgetListManuallyAdded,visibleWidgetListManuallyRemoved:visibleWidgetListManuallyRemoved,externalUser:Object.assign({},state.currentUser.externalUser,{visibleWidgetList:visibleWidgetList,visibleWidgetListManuallyAdded:visibleWidgetListManuallyAdded,visibleWidgetListManuallyRemoved:visibleWidgetListManuallyRemoved})})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["w" /* SAVE_USER_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["x" /* SAVE_USER_SUCCESS */],function(state,action){var currentUser=action.payload.currentUser;return Object.assign({},state,{fetching:false,hasChanged:false,currentUser:currentUser});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["v" /* SAVE_USER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["q" /* GENERATE_NEW_PASSWORD_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,passwordStatus:'processing'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["r" /* GENERATE_NEW_PASSWORD_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false,passwordStatus:'sent'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* GENERATE_NEW_PASSWORD_ERROR */],function(state,action){return Object.assign({},state,{fetching:false,passwordStatus:'error'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["y" /* SET_USER_VALIDATION_RESULT */],function(state,action){var validationMessageList=action.payload.validationMessageList;return Object.assign({},state,{validationMessageList:validationMessageList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* CREATE_USER_REQUEST */],function(state,action){return Object.assign({},state,{error:null,fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* CREATE_USER_SUCCESS */],function(state,action){var currentUser=action.payload.currentUser;return Object.assign({},state,{currentUser:currentUser,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* CREATE_USER_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* FIND_ALL_ROLE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* FIND_ALL_ROLE_SUCCESS */],function(state,action){var roleList=action.payload.roleList;return Object.assign({},state,{fetching:false,roleList:roleList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* FIND_ALL_ROLE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_CURRENT_ROLE_ID */],function(state,action){var currentRoleId=action.payload.currentRoleId;var currentRole=state.roleList.find(function(role){return role.id===currentRoleId;});return Object.assign({},state,{currentRoleId:currentRoleId,currentRole:currentRole,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["A" /* TOGGLE_ROLE_WIDGET_ACCESS */],function(state,action){var _action$payload5=action.payload,widgetId=_action$payload5.widgetId,active=_action$payload5.active;var widgetList=!active?state.currentRole.widgetList.filter(function(currentWidgetId){return currentWidgetId!==widgetId;}):[].concat(_toConsumableArray(state.currentRole.widgetList),[widgetId]);return Object.assign({},state,{hasChanged:true,currentRole:Object.assign({},state.currentRole,{widgetList:widgetList})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["t" /* SAVE_ROLE_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["u" /* SAVE_ROLE_SUCCESS */],function(state,action){var currentRole=action.payload.currentRole;return Object.assign({},state,{fetching:false,hasChanged:false,currentRole:currentRole});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["s" /* SAVE_ROLE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detail__ = __webpack_require__(778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__search__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__search__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__detail__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__detail__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_state_reducer__ = __webpack_require__(87);
var initialState=Object.assign({storeList:[],fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* STORE_TABLE */],'store_store',{'store_store.created':__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["b" /* DESC */]},{'limit':5000}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* STORE_TABLE */])),initialState));

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(389);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={store:{'isPartner':0,'isPretreatmentProvider':0,'iprProvider':0,'hasSpecialIprLogic':0,'isImplantProvider':0},hasChanged:false,redirect:false,fetching:false,validationMessageList:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* EDIT_STORE */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{store:Object.assign({},state.store,_defineProperty({},name,value)),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_STORE_REQUEST */],function(state){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* SAVE_STORE_SUCCESS */],function(state){return Object.assign({},state,{redirect:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_STORE_ERROR */],function(state,action){var validationMessageList=action.payload.validationMessageList;return Object.assign({},state,{fetching:false,validationMessageList:validationMessageList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_STORE_REQUEST */],function(state){return Object.assign({},state,{fetching:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_STORE_SUCCESS */],function(state,action){var store=action.payload.store;return Object.assign({},state,{store:store,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_STORE_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* VALIDATION_LIST */],function(state,action){var list=action.payload.list;return Object.assign({},state,{validationMessageList:list});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CLEAR_STATE */],function(){return Object.assign({},initialState);}),_handleActions),initialState));

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match__ = __webpack_require__(781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["a"]; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__match__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__match__["b" /* reducer */]));

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(391);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={caseList:[],fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["b" /* FIND_UNASSIGNED_CASE_LIST_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["c" /* FIND_UNASSIGNED_CASE_LIST_SUCCESS */],function(state,action){var caseList=action.payload.caseList;return Object.assign({},state,{caseList:caseList,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__type__["a" /* FIND_UNASSIGNED_CASE_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quotation__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reassign__ = __webpack_require__(788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__const__["f"]; });
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__plan__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_2__plan__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_3__quotation__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_3__quotation__["b" /* reducer */]),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_4__reassign__["a" /* REDUCER_NAME */],__WEBPACK_IMPORTED_MODULE_4__reassign__["b" /* reducer */]),_combineReducers));

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["m"]; });


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(392);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={treatmentPlan:null,fetching:false,error:null,hasChanged:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* TREATMENT_PLAN_LOADED */],function(state,action){var treatmentPlan=action.payload.treatmentPlan;return Object.assign({},state,{treatmentPlan:treatmentPlan});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_TREATMENT_PLAN */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{hasChanged:true,treatmentPlan:Object.assign({},state.treatmentPlan,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_SEGMENT */],function(state,action){var _action$payload2=action.payload,segment=_action$payload2.segment,name=_action$payload2.name,value=_action$payload2.value;var segmentValue=state.treatmentPlan[segment]||{};return Object.assign({},state,{hasChanged:true,treatmentPlan:Object.assign({},state.treatmentPlan,_defineProperty({},segment,Object.assign({},segmentValue,_defineProperty({},name,value))))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* SAVE_TREATMENT_PLAN_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_TREATMENT_PLAN_SUCCESS */],function(state,action){var treatmentPlan=action.payload.treatmentPlan;return Object.assign({},state,{fetching:false,treatmentPlan:treatmentPlan});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* SAVE_TREATMENT_PLAN_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["k"]; });


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={customerId:null,treatmentQuotation:null,fetching:false,uploadingVideo:false,error:null,hasChanged:false,previewModalOpen:false,isEditableForUser:false};var VIEW_VIDEO_URL='/api/treatment/view-video-file?treatmentQuotationId=';/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CUSTOMER_LOADED */],function(state,action){var customer=action.payload.customer;if(customer.treatmentQuotationList.length===0){return state;}return Object.assign({},state,{customer:customer,treatmentQuotation:customer.treatmentQuotationList[0]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* PROCESS_TASK_CUSTOMER_LOADED */],function(state,action){var salesOrder=action.payload.salesOrder;return Object.assign({},state,{customerId:salesOrder.customerId,funnelId:salesOrder.funnelId});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null,treatmentQuotation:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS */],function(state,action){var treatmentQuotation=action.payload.treatmentQuotation;return Object.assign({},state,{treatmentQuotation:treatmentQuotation,fetching:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_TREATMENT_QUOTATION */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{treatmentQuotation:Object.assign({},state.treatmentQuotation,_defineProperty({},name,value)),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TREATMENT_PACKAGE_PRICE */],function(state,action){var _action$payload$value=action.payload.value,packageSize=_action$payload$value.packageSize,price=_action$payload$value.price;return Object.assign({},state,{treatmentQuotation:Object.assign({},state.treatmentQuotation,{packageSize:packageSize,brutPrice:price}),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_TREATMENT_QUOTATION_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_TREATMENT_QUOTATION_SUCCESS */],function(state,action){var treatmentQuotation=action.payload.treatmentQuotation;return Object.assign({},state,{treatmentQuotation:treatmentQuotation,fetching:false,hasChanged:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SAVE_TREATMENT_QUOTATION_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["h" /* OPEN_PREVIEW_MODAL */],function(state,action){return Object.assign({},state,{previewModalOpen:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CLOSE_PREVIEW_MODAL */],function(state,action){return Object.assign({},state,{previewModalOpen:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["o" /* UPLOAD_SCAN_VIDEO_REQUEST */],function(state,action){return Object.assign({},state,{uploadingVideo:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["p" /* UPLOAD_SCAN_VIDEO_SUCCESS */],function(state,action){var frontendUrl=action.payload.frontendUrl;return Object.assign({},state,{uploadingVideo:false,treatmentQuotation:Object.assign({},state.treatmentQuotation,{treatmentLink:frontendUrl+VIEW_VIDEO_URL+state.treatmentQuotation.id}),hasChanged:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["n" /* UPLOAD_SCAN_VIDEO_ERROR */],function(state,action){return Object.assign({},state,{uploadingVideo:false});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["m" /* SET_EDITABLE_FOR_USER */],function(state,action){return Object.assign({},state,{isEditableForUser:true});}),_handleActions),initialState));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["d"]; });


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__(132);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={reassignment:{reassignTo:__WEBPACK_IMPORTED_MODULE_3__const__["b" /* REASSIGNMENT_TREATING_PHYSICIAN */],currentTreatingPhysicianId:null,newTreatingPhysicianId:null,partnerPhysicianId:null,confirmationLegalRequirementsMet:false},fetching:false,error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["b" /* LOCATION_CHANGE */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_REASSIGNMENT */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{reassignment:Object.assign({},state.reassignment,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* REASSIGN_TREATING_PHYSICIAN_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* REASSIGN_TREATING_PHYSICIAN_SUCCESS */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* REASSIGN_TREATING_PHYSICIAN_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS */],function(state,action){return Object.assign({},initialState);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* REASSIGN_TO_PARTNER_PHYSICIAN_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_handleActions),initialState));

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(396);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={lowNpsReasonList:[],fetching:false,error:null,feedbackId:'',feedbackCreated:'',feedbackScore:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* TOGGLE_LOW_NPS_REASON */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;var prevLowNpsReason=[].concat(_toConsumableArray(state.lowNpsReasonList));return Object.assign({},state,{lowNpsReasonList:value?[].concat(_toConsumableArray(prevLowNpsReason),[name]):prevLowNpsReason.filter(function(reason){return reason!==name;})});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_FEEDBACK_DETAILS_SUCCESS */],function(state,action){var _action$payload2=action.payload,feedbackCreated=_action$payload2.feedbackCreated,lowScoreReason=_action$payload2.lowScoreReason,feedbackScore=_action$payload2.feedbackScore;var lowNpsReason=[];if(lowScoreReason){lowNpsReason=JSON.parse(lowScoreReason);}return Object.assign({},state,{lowNpsReasonList:lowNpsReason,feedbackCreated:feedbackCreated,feedbackScore:feedbackScore});}),_handleActions),initialState));

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(397);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={fetching:false,error:null,validationMessageList:[],salesOrderList:[],partialRefundData:{salesOrderId:'',amount:0.00,numberOfProducts:1,reason:''}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_PARTIAL_REFUND_DATA */],function(state,action){var _action$payload=action.payload,name=_action$payload.name,value=_action$payload.value;return Object.assign({},state,{partialRefundData:Object.assign({},state.partialRefundData,_defineProperty({},name,value))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["e" /* GET_PARTIAL_REFUND_DATA_REQUEST */],function(state){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["f" /* GET_PARTIAL_REFUND_DATA_SUCCESS */],function(state,action){var partialRefundData=action.payload.partialRefundData;return Object.assign({},state,{partialRefundData:partialRefundData,fetching:false,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* GET_PARTIAL_REFUND_DATA_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["i" /* GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS */],function(state,action){var salesOrderList=action.payload.salesOrderList;return Object.assign({},state,{salesOrderList:salesOrderList});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["g" /* GET_REFUNDABLE_SALES_ORDER_LIST_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_PARTIAL_REFUND_DATA_REQUEST */],function(state){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_PARTIAL_REFUND_DATA_SUCCESS */],function(state,action){return Object.assign({},state,{fetching:false,error:null});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SAVE_PARTIAL_REFUND_DATA_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ADD_VALIDATION_MESSAGE */],function(state,action){var message=action.payload.message;return Object.assign({},state,{validationMessageList:[].concat(_toConsumableArray(state.validationMessageList),[message])});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CLEAR_VALIDATION_MESSAGE_LIST */],function(state,action){return Object.assign({},state,{validationMessageList:[]});}),_handleActions),initialState));

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whatsapp_messages_state_type__ = __webpack_require__(398);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={whatsappMessageList:[],fetching:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_1__whatsapp_messages_state_type__["c" /* FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS */],function(state,action){var whatsappMessageList=action.payload.whatsappMessageList;return Object.assign({},state,{whatsappMessageList:whatsappMessageList,fetching:false});}),initialState));

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__const__["a"]; });


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_state_reducer__ = __webpack_require__(87);
var _Object$assign;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object.assign({taskListWithAttachment:[],allOpenTaskList:[],allOpenTask:{},fetching:false,error:null},Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["c" /* createInitialTableState */])({rowsPerPage:20,sortColumnName:'created',sortOrder:-1}),Object(__WEBPACK_IMPORTED_MODULE_3__table_state_reducer__["c" /* createInitialTableState */])(__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */],'process_task_all',{'process_task.created':__WEBPACK_IMPORTED_MODULE_3__table_state_reducer__["b" /* DESC */]}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* handleActions */])(Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__table_state_reducer__["d" /* createReducerFunction */])(__WEBPACK_IMPORTED_MODULE_1__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]),(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */],Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["a" /* changeTableSettings */])()),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST */],function(state,action){return Object.assign({},state,{fetching:true,error:null});}),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS */],function(state,action){var taskListWithAttachment=action.payload.taskListWithAttachment;return Object.assign({},state,{taskListWithAttachment:taskListWithAttachment,fetching:false});}),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_TASK_LIST_WITH_ATTACHMENT_ERROR */],function(state,action){var error=action.payload.error;return Object.assign({},state,{fetching:false,error:error});}),_Object$assign)),initialState));

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivateRoute__ = __webpack_require__(799);
var mapStateToProps=function mapStateToProps(state,props){return{user:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["p" /* selectUser */](state),hasRole:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["i" /* selectHasRole */](state,props.requiredRole)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__PrivateRoute__["a" /* default */]));

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginContainer__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_EmptyPage__ = __webpack_require__(804);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PrivateRoute=function PrivateRoute(_ref){var user=_ref.user,Component=_ref.component,exact=_ref.exact,path=_ref.path,hasRole=_ref.hasRole,requiredRole=_ref.requiredRole,props=_objectWithoutProperties(_ref,['user','component','exact','path','hasRole','requiredRole']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{exact:exact,path:path,render:function render(){if(user&&(hasRole||!requiredRole)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props);}if(user&&!hasRole){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_EmptyPage__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LoginContainer__["a" /* default */],null);}});};/* harmony default export */ __webpack_exports__["a"] = (PrivateRoute);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_auth_action__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login__ = __webpack_require__(801);
var mapStateToProps=function mapStateToProps(state){return{loginData:__WEBPACK_IMPORTED_MODULE_2__state_auth_selector__["n" /* selectLoginData */](state),error:__WEBPACK_IMPORTED_MODULE_2__state_auth_selector__["o" /* selectLoginError */](state),isPasswordResetRequired:__WEBPACK_IMPORTED_MODULE_2__state_auth_selector__["l" /* selectIsPasswordResetRequired */](state)};};var mapDispatchToProps={login:__WEBPACK_IMPORTED_MODULE_1__state_auth_action__["d" /* login */],changeLoginData:__WEBPACK_IMPORTED_MODULE_1__state_auth_action__["a" /* changeLoginData */],changePassword:__WEBPACK_IMPORTED_MODULE_1__state_auth_action__["b" /* changePassword */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Login__["a" /* default */]));

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Container__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Password__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_auth_const__ = __webpack_require__(28);
var LoginForm=function LoginForm(_ref){var login=_ref.login,error=_ref.error,loginData=_ref.loginData,changeLoginData=_ref.changeLoginData,isPasswordResetRequired=_ref.isPasswordResetRequired;if(isPasswordResetRequired){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:login,target:'iframe',action:'/api/security/dummy-endpoint',method:'POST'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-box-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Input__["a" /* default */],{name:'email',object:loginData,onChange:changeLoginData,placeholder:'Email'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Password__["a" /* default */],{name:'password',object:loginData,onChange:changeLoginData,placeholder:'Password'}),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-error'},'Email/Password is wrong'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary col-xs-12'},'Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{name:'iframe',id:'iframe',style:{display:'none'},title:'login-iframe'}));};var PasswordResetForm=function PasswordResetForm(_ref2){var changePassword=_ref2.changePassword,error=_ref2.error,loginData=_ref2.loginData,changeLoginData=_ref2.changeLoginData,isPasswordResetRequired=_ref2.isPasswordResetRequired;if(!isPasswordResetRequired){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:changePassword,target:'iframe',action:'/api/security/dummy-endpoint',method:'POST'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-box-inner',style:{height:'420px'}},'Please set a new password',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Input__["a" /* default */],{name:'email',object:loginData,onChange:changeLoginData,placeholder:'Email'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Password__["a" /* default */],{name:'password',object:loginData,onChange:changeLoginData,placeholder:'old Password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Password__["a" /* default */],{name:'newPassword',object:loginData,onChange:changeLoginData,placeholder:'new Password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Password__["a" /* default */],{name:'newPasswordRepeat',object:loginData,onChange:changeLoginData,placeholder:'repeat new Password'}),error===__WEBPACK_IMPORTED_MODULE_4__state_auth_const__["c" /* ERROR_PASSWORD_NOT_SECURE */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-error'},'Password needs 10 digits, capital & lowercase, number, and special characted'),error===__WEBPACK_IMPORTED_MODULE_4__state_auth_const__["b" /* ERROR_PASSWORD_NOT_IDENTICAL */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-error'},'Passwords are not identical'),error===__WEBPACK_IMPORTED_MODULE_4__state_auth_const__["a" /* ERROR_PASSWORD_MUST_BE_NEW */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-error'},'You need to set a new password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary col-xs-12'},'Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{name:'iframe',id:'iframe',style:{display:'none'},title:'login-iframe'}));};var Login=function Login(_ref3){var loginData=_ref3.loginData,changePassword=_ref3.changePassword,changeLoginData=_ref3.changeLoginData,login=_ref3.login,error=_ref3.error,isPasswordResetRequired=_ref3.isPasswordResetRequired;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-full-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/asset/image/logo-white.svg',alt:'Logo',width:200})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoginForm,{changeLoginData:changeLoginData,login:login,error:error,isPasswordResetRequired:isPasswordResetRequired,loginData:loginData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PasswordResetForm,{changeLoginData:changeLoginData,changePassword:changePassword,error:error,isPasswordResetRequired:isPasswordResetRequired,loginData:loginData}))));};/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Container=function Container(props){var _props$className=props.className,className=_props$className===undefined?'':_props$className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container '+className},props.children);};Container.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SPAN_STYLE={paddingTop:'5px',paddingBottom:'0px',cursor:'pointer'};var ICON_STYLE={fontSize:'18px'};var Password=function(_React$Component){_inherits(Password,_React$Component);function Password(props){_classCallCheck(this,Password);var _this=_possibleConstructorReturn(this,(Password.__proto__||Object.getPrototypeOf(Password)).call(this,props));_this.state={hidePassword:true};_this.togglePassword=_this.togglePassword.bind(_this);return _this;}_createClass(Password,[{key:'togglePassword',value:function togglePassword(){this.setState({hidePassword:!this.state.hidePassword});}},{key:'render',value:function render(){var icon='icon-eye';var type='password';if(!this.state.hidePassword){icon='icon-eye-slash';type='text';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Input__["a" /* default */],Object.assign({},this.props,{type:type,className:'form-control',autocapitalize:'Off'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-addon',style:SPAN_STYLE,onClick:this.togglePassword},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:icon,style:ICON_STYLE})));}}]);return Password;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Password.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Password);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withLayout__ = __webpack_require__(24);
var EmptyPage=function EmptyPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__withLayout__["a" /* default */])(EmptyPage));

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__security__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_selector__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_selector__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_action__ = __webpack_require__(1030);
var mapStateToProps=function mapStateToProps(state){return{isFetching:Object(__WEBPACK_IMPORTED_MODULE_3__state_selector__["a" /* selectIsFetching */])(state),locationPath:Object(__WEBPACK_IMPORTED_MODULE_4__router_selector__["a" /* selectLocationPath */])(state),user:Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["p" /* selectUser */])(state),isNavigationCollapsed:__WEBPACK_IMPORTED_MODULE_3__state_selector__["b" /* selectIsNavigationCollapsed */](state)};};var mapDispatchToProps={logout:__WEBPACK_IMPORTED_MODULE_1__security__["a" /* default */].action.logout,toggleNavigation:__WEBPACK_IMPORTED_MODULE_6__state_action__["a" /* toggleNavigation */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__Layout__["a" /* default */]));

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_auth_action__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_auth_selector__ = __webpack_require__(23);
/* harmony default export */ __webpack_exports__["a"] = ({action:{logout:__WEBPACK_IMPORTED_MODULE_0__state_auth_action__["f" /* logout */],checkLoginStatus:__WEBPACK_IMPORTED_MODULE_0__state_auth_action__["c" /* checkLoginStatus */],loginSuccess:__WEBPACK_IMPORTED_MODULE_0__state_auth_action__["e" /* loginSuccess */]},selector:{selectHasRole:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["i" /* selectHasRole */],selectHasReportingRole:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["h" /* selectHasReportingRole */],selectEmployeeRoleList:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["f" /* selectEmployeeRoleList */],selectEmployeeId:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["e" /* selectEmployeeId */],selectHasAccountingRole:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["g" /* selectHasAccountingRole */]}});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navigation__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(810);
var Layout=function Layout(props){var isNavigationCollapsed=props.isNavigationCollapsed,toggleNavigation=props.toggleNavigation;var navigationOverlayCls=isNavigationCollapsed?'navigation-overlay':'navigation-overlay navigation-expanded';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Navigation__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:navigationOverlayCls,onClick:toggleNavigation}))));};/* harmony default export */ __webpack_exports__["a"] = (Layout);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__ = __webpack_require__(28);
var NavigationItem=function NavigationItem(_ref){var locationPath=_ref.locationPath,targetPath=_ref.targetPath,name=_ref.name,history=_ref.history,icon=_ref.icon,isNavigationCollapsed=_ref.isNavigationCollapsed;var className=locationPath===targetPath?'active':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:className,onClick:function onClick(){history.push(targetPath);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:icon,title:name}),!isNavigationCollapsed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,name));};var Navigation=function Navigation(_ref2){var history=_ref2.history,locationPath=_ref2.locationPath,isNavigationCollapsed=_ref2.isNavigationCollapsed;var className=isNavigationCollapsed?'sidebar-small':'sidebar-large';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'main-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["J" /* ROLE_REPORTING */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/process/task/all',icon:'fa fa-bar-chart-o',name:'Task Overview'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["J" /* ROLE_REPORTING */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/analytics/sales-order',icon:'fa fa-bar-chart-o',name:'Invoice CSV'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/process/version-summary',icon:'fa fa-code-fork',name:'Process Version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/appointment/search',icon:'fa fa-calendar',name:'Appointment'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/',icon:'fa fa-inbox',name:'Worklist'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/worklist/attachment',icon:'fa fa-inbox',name:'Worklist Attachment'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/process/instance/barcode',icon:'fa fa-barcode',name:'Barcode Reader'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["D" /* ROLE_PARTNER_SCAN_PHYSICIAN */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/customer/search',icon:'fa fa-child',name:'Customer'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/store/search',icon:'fa fa-map-marker',name:'Clinics / Stores'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["B" /* ROLE_PARTNER_PHYSICIAN */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/customer/search/partner',icon:'fa fa-child',name:'Customer'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["K" /* ROLE_RETAIL_QA */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["h" /* ROLE_CLINIC_MANAGEMENT */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/partner/search',icon:'fa fa-group',name:'Partners'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/set',icon:'fa fa-shopping-cart',name:'Sets'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/check-in',icon:'fa fa-shopping-cart',name:'Clinic Check-In'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/in-shop-scan',icon:'fa fa-shopping-cart',name:'Clinic 3D-Scan'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["t" /* ROLE_EMPLOYEE_STORE */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/shop-scan',icon:'fa fa-shopping-cart',name:'Shop Scan'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/treatment',icon:'fa fa-shopping-cart',name:'Treatments'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/refinement-set',icon:'fa fa-shopping-cart',name:'Refinement Set'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/refinement-booking',icon:'fa fa-shopping-cart',name:'Refinement Booking'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/refinement-shop',icon:'fa fa-shopping-cart',name:'Refinement Shop Scan'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/refinement-production',icon:'fa fa-shopping-cart',name:'Refinement Treatment'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/end-of-treatment',icon:'fa fa-shopping-cart',name:'End Treatment'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/retainer',icon:'fa fa-shopping-cart',name:'Retainer'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/retainer-refinement',icon:'fa fa-shopping-cart',name:'Retainer Refinement'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/sales-order/search/escalation',icon:'fa fa-bolt',name:'Escalation'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["f" /* ROLE_ACCOUNTING */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/payment/associate',icon:'fa fa-money',name:'Payments'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["f" /* ROLE_ACCOUNTING */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/payment/upload',icon:'fa fa-money',name:'Upload Payment'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["Q" /* ROLE_USER_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/user/manage',icon:'fa fa-user',name:'Manage User'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["R" /* ROLE_WIDGET_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/role/widgets',icon:'fa fa-gears',name:'Manage Widgets'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["p" /* ROLE_EMPLOYEE_OFFICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/settings/employee',icon:'fa fa-cog',name:'My Settings'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["G" /* ROLE_PROCESS_MANAGER */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/process/task-definition/all',icon:'fa fa-gears',name:'Task Definition'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["u" /* ROLE_FOIL_METADATA_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/foil/overview',icon:'fa fa-gears',name:'Foil Metadata'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationItem,{isNavigationCollapsed:isNavigationCollapsed,locationPath:locationPath,history:history,targetPath:'/voucher/search',icon:'fa fa-search',name:'Vouchers'}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(Navigation));

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var Authorization=function Authorization(_ref){var children=_ref.children,hasRole=_ref.hasRole;return hasRole?children:null;};Authorization.propTypes={requiredRole:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array]),hasRole:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Authorization);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var style={fontSize:'12.25px'};var Header=function Header(props){var logout=props.logout,isFetching=props.isFetching,isNavigationCollapsed=props.isNavigationCollapsed,user=props.user,toggleNavigation=props.toggleNavigation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-navigation '+(isNavigationCollapsed?'collapsed':'expanded')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-navigation-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/asset/image/logo-white.svg',alt:'Logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:toggleNavigation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-bars'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,isFetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'no-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-spinner iconRotate'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'no-hover',style:style},'Welcome ',user.firstName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:logout},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-power-off'}))))));};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_basis_selector__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_funnel_builder_selector__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_state_responsible_selector__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_transition_selector__ = __webpack_require__(283);
/* harmony default export */ __webpack_exports__["a"] = ({action:{},selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_basis_selector__["d" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_funnel_builder_selector__["f" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_3__state_transition_selector__["a" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_selector__["c" /* selectIsFetching */])(state);}}});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compileSetTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(280);
var compileSetTable=function compileSetTable(monthList){var table=[];table.push(compileNetRevenuesFromSet(monthList));table.push(compileProspectCreated(monthList));table.push(compileSetOrders(monthList));table.push(compileSetsShipment(monthList));table.push(compileSetOrderCashFlow(monthList));table.push(compileSetAverageSellingPrice(monthList));table.push(compileRefundedSetOrders(monthList));table.push(compileRefundedSetOrdersAmount(monthList));table.push(compileCannotBeTreatedSetOrders(monthList));table.push(compileCannotBeTreatedSetOrdersAmount(monthList));table.push(compileCanceledSetOrders(monthList));table.push(compileCanceledSetOrdersAmount(monthList));return table;};// prospectCreated
var compileProspectCreated=function compileProspectCreated(monthList){var result=[];result.push('Prospect created');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(month.prospectCreated);},monthList);return result;};var compileNetRevenuesFromSet=function compileNetRevenuesFromSet(monthList){var result=[];result.push('Net Revenues from Kit Operations');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlow_net-month.setCashFlowCanceled_net-month.setCashFlowCannotBeTreated_net;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var compileSetOrders=function compileSetOrders(monthList){var result=[];result.push('Kit Orders (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(month.setCashFlow_count);},monthList);return result;};var compileSetsShipment=function compileSetsShipment(monthList){var result=[];result.push('Kit Shipments (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(month.setShipped);},monthList);return result;};var compileSetOrderCashFlow=function compileSetOrderCashFlow(monthList){var result=[];result.push('Kit Orders (net)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(month.setCashFlow_net));},monthList);return result;};var compileSetAverageSellingPrice=function compileSetAverageSellingPrice(monthList){var result=[];result.push('Kit - Average Selling Price (gross)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlow_brut/month.setCashFlow_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var compileRefundedSetOrders=function compileRefundedSetOrders(monthList){var result=[];result.push('Refunded Orders (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlowCannotBeTreated_count+month.setCashFlowCanceled_count;result.push(amount);},monthList);return result;};var compileRefundedSetOrdersAmount=function compileRefundedSetOrdersAmount(monthList){var result=[];result.push('Refunded Orders (net)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlowCannotBeTreated_net+month.setCashFlowCanceled_net;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var compileCannotBeTreatedSetOrders=function compileCannotBeTreatedSetOrders(monthList){var result=[];result.push('Cannot be treated (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlowCannotBeTreated_count;result.push(amount);},monthList);return result;};var compileCannotBeTreatedSetOrdersAmount=function compileCannotBeTreatedSetOrdersAmount(monthList){var result=[];result.push('Cannot be treated (net)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlowCannotBeTreated_net;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var compileCanceledSetOrders=function compileCanceledSetOrders(monthList){var result=[];result.push('Other (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlowCanceled_count;result.push(amount);},monthList);return result;};var compileCanceledSetOrdersAmount=function compileCanceledSetOrdersAmount(monthList){var result=[];result.push('Other (€)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.setCashFlowCanceled_net;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__always__ = __webpack_require__(116);


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
var F = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__always__["a" /* default */])(false);
/* unused harmony default export */ var _unused_webpack_default_export = (F);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__always__ = __webpack_require__(116);


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
var T = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__always__["a" /* default */])(true);
/* unused harmony default export */ var _unused_webpack_default_export = (T);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
/* unused harmony default export */ var _unused_webpack_default_export = ({ '@@functional/placeholder': true });

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN__ = __webpack_require__(52);




/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
var addIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])(function addIndex(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN__["a" /* default */])(fn.length, function () {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function () {
      var result = origFn.apply(this, Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */])(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (addIndex);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xall__ = __webpack_require__(818);




/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      var equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */
var all = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['all'], __WEBPACK_IMPORTED_MODULE_2__internal_xall__["a" /* default */], function all(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (!fn(list[idx])) {
      return false;
    }
    idx += 1;
  }
  return true;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (all);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XAll = /*#__PURE__*/function () {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }
  XAll.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XAll.prototype['@@transducer/result'] = function (result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAll.prototype['@@transducer/step'] = function (result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced__["a" /* default */])(this.xf['@@transducer/step'](result, false));
    }
    return result;
  };

  return XAll;
}();

var _xall = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xall(f, xf) {
  return new XAll(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xall);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__max__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pluck__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduce__ = __webpack_require__(76);






/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      var isQueen = R.propEq('rank', 'Q');
 *      var isSpade = R.propEq('suit', '♠︎');
 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */
var allPass = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function allPass(preds) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__max__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_3__pluck__["a" /* default */])('length', preds)), function () {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (!preds[idx].apply(this, arguments)) {
        return false;
      }
      idx += 1;
    }
    return true;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (allPass);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XMap = /*#__PURE__*/function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XMap.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xmap(f, xf) {
  return new XMap(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xmap);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__max__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pluck__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduce__ = __webpack_require__(76);






/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      var isClub = R.propEq('suit', '♣');
 *      var isSpade = R.propEq('suit', '♠');
 *      var isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */
var anyPass = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function anyPass(preds) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__max__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_3__pluck__["a" /* default */])('length', preds)), function () {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }
      idx += 1;
    }
    return false;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (anyPass);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_aperture__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xaperture__ = __webpack_require__(824);





/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */
var aperture = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_3__internal_xaperture__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__internal_aperture__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (aperture);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _aperture;
function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
}

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XAperture = /*#__PURE__*/function () {
  function XAperture(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XAperture.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XAperture.prototype['@@transducer/result'] = function (result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XAperture.prototype['@@transducer/step'] = function (result, input) {
    this.store(input);
    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
  };
  XAperture.prototype.store = function (input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };
  XAperture.prototype.getCopy = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__concat__["a" /* default */])(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
  };

  return XAperture;
}();

var _xaperture = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__curry2__["a" /* default */])(function _xaperture(n, xf) {
  return new XAperture(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xaperture);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */
var append = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function append(el, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */])(list, [el]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (append);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apply__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__max__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pluck__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reduce__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__values__ = __webpack_require__(409);









/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      var getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */
var applySpec = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function applySpec(spec) {
  spec = Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* default */])(function (v) {
    return typeof v == 'function' ? v : applySpec(v);
  }, spec);
  return Object(__WEBPACK_IMPORTED_MODULE_2__curryN__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__max__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_5__pluck__["a" /* default */])('length', Object(__WEBPACK_IMPORTED_MODULE_7__values__["a" /* default */])(spec))), function () {
    var args = arguments;
    return Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* default */])(function (f) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__apply__["a" /* default */])(f, args);
    }, spec);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (applySpec);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
* Takes a value and applies a function to it.
*
* This function is also known as the `thrush` combinator.
*
* @func
* @memberOf R
 * @since v0.25.0
* @category Function
* @sig a -> (a -> b) -> b
* @param {*} x The value
* @param {Function} f The function to apply
* @return {*} The result of applying `f` to `x`
* @example
*
*      var t42 = R.applyTo(42);
*      t42(R.identity); //=> 42
*      t42(R.add(1)); //=> 43
*/
var applyTo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function applyTo(x, f) {
  return f(x);
});
/* unused harmony default export */ var _unused_webpack_default_export = (applyTo);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      var byAge = R.ascend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByYoungestFirst = R.sort(byAge, people);
 */
var ascend = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function ascend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa < bb ? -1 : aa > bb ? 1 : 0;
});
/* unused harmony default export */ var _unused_webpack_default_export = (ascend);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nAry__ = __webpack_require__(172);



/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      var takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      var takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */
var binary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function binary(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__nAry__["a" /* default */])(2, fn);
});
/* unused harmony default export */ var _unused_webpack_default_export = (binary);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isFunction__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__and__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lift__ = __webpack_require__(174);





/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      var gt10 = R.gt(R.__, 10)
 *      var lt20 = R.lt(R.__, 20)
 *      var f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 */
var both = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function both(f, g) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isFunction__["a" /* default */])(f) ? function _both() {
    return f.apply(this, arguments) && g.apply(this, arguments);
  } : Object(__WEBPACK_IMPORTED_MODULE_3__lift__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__and__["a" /* default */])(f, g);
});
/* unused harmony default export */ var _unused_webpack_default_export = (both);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry__ = __webpack_require__(264);


/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
var call = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry__["a" /* default */])(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
/* unused harmony default export */ var _unused_webpack_default_export = (call);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatCat__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(62);




var _xchain = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xchain(f, xf) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__map__["a" /* default */])(f, Object(__WEBPACK_IMPORTED_MODULE_1__flatCat__["a" /* default */])(xf));
});
/* harmony default export */ __webpack_exports__["a"] = (_xchain);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forceReduced__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xfBase__ = __webpack_require__(45);





var preservingReduced = function (xf) {
  return {
    '@@transducer/init': __WEBPACK_IMPORTED_MODULE_3__xfBase__["a" /* default */].init,
    '@@transducer/result': function (result) {
      return xf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      var ret = xf['@@transducer/step'](result, input);
      return ret['@@transducer/reduced'] ? Object(__WEBPACK_IMPORTED_MODULE_0__forceReduced__["a" /* default */])(ret) : ret;
    }
  };
};

var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    '@@transducer/init': __WEBPACK_IMPORTED_MODULE_3__xfBase__["a" /* default */].init,
    '@@transducer/result': function (result) {
      return rxf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      return !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike__["a" /* default */])(input) ? Object(__WEBPACK_IMPORTED_MODULE_2__reduce__["a" /* default */])(rxf, result, [input]) : Object(__WEBPACK_IMPORTED_MODULE_2__reduce__["a" /* default */])(rxf, result, input);
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (_flatCat);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _forceReduced;
function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */
var clamp = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function clamp(min, max, value) {
  if (min > max) {
    throw new Error('min must not be greater than max in clamp(min, max, value)');
  }
  return value < min ? min : value > max ? max : value;
});
/* unused harmony default export */ var _unused_webpack_default_export = (clamp);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_clone__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);



/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      var objects = [{}, {}, {}];
 *      var objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */
var clone = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])(function clone(value) {
  return value != null && typeof value.clone === 'function' ? value.clone() : Object(__WEBPACK_IMPORTED_MODULE_0__internal_clone__["a" /* default */])(value, [], [], true);
});
/* harmony default export */ __webpack_exports__["a"] = (clone);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      var byAge = R.comparator((a, b) => a.age < b.age);
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByIncreasingAge = R.sort(byAge, people);
 */
var comparator = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function comparator(pred) {
  return function (a, b) {
    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
  };
});
/* unused harmony default export */ var _unused_webpack_default_export = (comparator);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lift__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__not__ = __webpack_require__(416);



/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
var complement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__lift__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__not__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (complement);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _pipe;
function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipeP__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reverse__ = __webpack_require__(175);



/**
 * Performs right-to-left composition of one or more Promise-returning
 * functions. The rightmost function may have any arity; the remaining
 * functions must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
 * @param {...Function} functions The functions to compose
 * @return {Function}
 * @see R.pipeP
 * @example
 *
 *      var db = {
 *        users: {
 *          JOE: {
 *            name: 'Joe',
 *            followers: ['STEVE', 'SUZY']
 *          }
 *        }
 *      }
 *
 *      // We'll pretend to do a db lookup which returns a promise
 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
 *      lookupUser('JOE').then(lookupFollowers)
 *
 *      //  followersForUser :: String -> Promise [UserId]
 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
 *      // Followers: ["STEVE","SUZY"]
 */
function composeP() {
  if (arguments.length === 0) {
    throw new Error('composeP requires at least one argument');
  }
  return __WEBPACK_IMPORTED_MODULE_0__pipeP__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__reverse__["a" /* default */])(arguments));
}

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _pipeP;
function _pipeP(f, g) {
  return function () {
    var ctx = this;
    return f.apply(ctx, arguments).then(function (x) {
      return g.call(ctx, x);
    });
  };
}

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quote__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toISOString__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reject__ = __webpack_require__(177);







function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return Object(__WEBPACK_IMPORTED_MODULE_0__contains__["a" /* default */])(y, xs) ? '<Circular>' : _toString(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function (obj, keys) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(function (k) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__quote__["a" /* default */])(k) + ': ' + recur(obj[k]);
    }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(recur, x).concat(mapPairs(x, Object(__WEBPACK_IMPORTED_MODULE_5__reject__["a" /* default */])(function (k) {
        return (/^\d+$/.test(k)
        );
      }, Object(__WEBPACK_IMPORTED_MODULE_4__keys__["a" /* default */])(x)))).join(', ') + ']';
    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : Object(__WEBPACK_IMPORTED_MODULE_2__quote__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toISOString__["a" /* default */])(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : Object(__WEBPACK_IMPORTED_MODULE_2__quote__["a" /* default */])(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, Object(__WEBPACK_IMPORTED_MODULE_4__keys__["a" /* default */])(x)).join(', ') + '}';
  }
}

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _equals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFromIterator__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containsWith__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functionName__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__has__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identical__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type__ = __webpack_require__(266);








/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = Object(__WEBPACK_IMPORTED_MODULE_0__arrayFromIterator__["a" /* default */])(aIterator);
  var b = Object(__WEBPACK_IMPORTED_MODULE_0__arrayFromIterator__["a" /* default */])(bIterator);

  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }

  // if *a* array contains any element that is not included in *b*
  return !Object(__WEBPACK_IMPORTED_MODULE_1__containsWith__["a" /* default */])(function (b, aItem) {
    return !Object(__WEBPACK_IMPORTED_MODULE_1__containsWith__["a" /* default */])(eq, aItem, b);
  }, b, a);
}

function _equals(a, b, stackA, stackB) {
  if (Object(__WEBPACK_IMPORTED_MODULE_4__identical__["a" /* default */])(a, b)) {
    return true;
  }

  var typeA = Object(__WEBPACK_IMPORTED_MODULE_6__type__["a" /* default */])(a);

  if (typeA !== Object(__WEBPACK_IMPORTED_MODULE_6__type__["a" /* default */])(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && Object(__WEBPACK_IMPORTED_MODULE_2__functionName__["a" /* default */])(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && Object(__WEBPACK_IMPORTED_MODULE_4__identical__["a" /* default */])(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!Object(__WEBPACK_IMPORTED_MODULE_4__identical__["a" /* default */])(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = Object(__WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */])(a);
  if (keysA.length !== Object(__WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */])(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);

  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(Object(__WEBPACK_IMPORTED_MODULE_3__has__["a" /* default */])(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayFromIterator;
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _functionName;
function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _quote;
function _quote(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

/* harmony default export */ __webpack_exports__["a"] = (_toISOString);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XFilter = /*#__PURE__*/function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XFilter.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].result;
  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xfilter(f, xf) {
  return new XFilter(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfilter);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__max__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reduce__ = __webpack_require__(76);






/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @example
 *
 *      var fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */
var cond = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])(function cond(pairs) {
  var arity = Object(__WEBPACK_IMPORTED_MODULE_4__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__max__["a" /* default */], 0, Object(__WEBPACK_IMPORTED_MODULE_2__map__["a" /* default */])(function (pair) {
    return pair[0].length;
  }, pairs));
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(arity, function () {
    var idx = 0;
    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }
      idx += 1;
    }
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (cond);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructN__ = __webpack_require__(423);



/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      var AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      var animalTypes = ["Lion", "Tiger", "Bear"];
 *      var animalSighting = R.invoker(0, 'sighting');
 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */
var construct = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function construct(Fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__constructN__["a" /* default */])(Fn.length, Fn);
});
/* unused harmony default export */ var _unused_webpack_default_export = (construct);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 */
var contains = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_contains__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (contains);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduceBy__ = __webpack_require__(178);


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
var countBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__reduceBy__["a" /* default */])(function (acc, elem) {
  return acc + 1;
}, 0);
/* unused harmony default export */ var _unused_webpack_default_export = (countBy);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curryN__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XReduceBy = /*#__PURE__*/function () {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XReduceBy.prototype['@@transducer/result'] = function (result) {
    var key;
    for (key in this.inputs) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__has__["a" /* default */])(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return XReduceBy;
}();

var _xreduceBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curryN__["a" /* default */])(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xreduceBy);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(167);


/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
var dec = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__add__["a" /* default */])(-1);
/* unused harmony default export */ var _unused_webpack_default_export = (dec);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      var byAge = R.descend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByOldestFirst = R.sort(byAge, people);
 */
var descend = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function descend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa > bb ? -1 : aa < bb ? 1 : 0;
});
/* unused harmony default export */ var _unused_webpack_default_export = (descend);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isInteger__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assoc__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dissoc__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__remove__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__update__ = __webpack_require__(273);







/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */
var dissocPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function dissocPath(path, obj) {
  switch (path.length) {
    case 0:
      return obj;
    case 1:
      return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger__["a" /* default */])(path[0]) ? Object(__WEBPACK_IMPORTED_MODULE_4__remove__["a" /* default */])(path[0], 1, obj) : Object(__WEBPACK_IMPORTED_MODULE_3__dissoc__["a" /* default */])(path[0], obj);
    default:
      var head = path[0];
      var tail = Array.prototype.slice.call(path, 1);
      if (obj[head] == null) {
        return obj;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger__["a" /* default */])(path[0])) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__update__["a" /* default */])(head, dissocPath(tail, obj[head]), obj);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_2__assoc__["a" /* default */])(head, dissocPath(tail, obj[head]), obj);
      }
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (dissocPath);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      var half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      var reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */
var divide = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function divide(a, b) {
  return a / b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (divide);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XDrop = /*#__PURE__*/function () {
  function XDrop(n, xf) {
    this.xf = xf;
    this.n = n;
  }
  XDrop.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XDrop.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].result;
  XDrop.prototype['@@transducer/step'] = function (result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return XDrop;
}();

var _xdrop = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xdrop(n, xf) {
  return new XDrop(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdrop);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dropLast__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xdropLast__ = __webpack_require__(862);





/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */
var dropLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_3__internal_xdropLast__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__internal_dropLast__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (dropLast);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dropLast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__take__ = __webpack_require__(274);


function dropLast(n, xs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__take__["a" /* default */])(n < xs.length ? xs.length - n : 0, xs);
}

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XTake = /*#__PURE__*/function () {
  function XTake(n, xf) {
    this.xf = xf;
    this.n = n;
    this.i = 0;
  }
  XTake.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XTake.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].result;
  XTake.prototype['@@transducer/step'] = function (result, input) {
    this.i += 1;
    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
    return this.n >= 0 && this.i >= this.n ? Object(__WEBPACK_IMPORTED_MODULE_1__reduced__["a" /* default */])(ret) : ret;
  };

  return XTake;
}();

var _xtake = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xtake(n, xf) {
  return new XTake(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xtake);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XDropLast = /*#__PURE__*/function () {
  function XDropLast(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XDropLast.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XDropLast.prototype['@@transducer/result'] = function (result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLast.prototype['@@transducer/step'] = function (result, input) {
    if (this.full) {
      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
    }
    this.store(input);
    return result;
  };
  XDropLast.prototype.store = function (input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  return XDropLast;
}();

var _xdropLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xdropLast(n, xf) {
  return new XDropLast(n, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropLast);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dropLastWhile__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xdropLastWhile__ = __webpack_require__(865);





/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      var lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */
var dropLastWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_3__internal_xdropLastWhile__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__internal_dropLastWhile__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (dropLastWhile);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dropLastWhile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slice__ = __webpack_require__(72);


function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__slice__["a" /* default */])(0, idx + 1, xs);
}

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XDropLastWhile = /*#__PURE__*/function () {
  function XDropLastWhile(fn, xf) {
    this.f = fn;
    this.retained = [];
    this.xf = xf;
  }
  XDropLastWhile.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XDropLastWhile.prototype['@@transducer/result'] = function (result) {
    this.retained = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLastWhile.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.retain(result, input) : this.flush(result, input);
  };
  XDropLastWhile.prototype.flush = function (result, input) {
    result = Object(__WEBPACK_IMPORTED_MODULE_1__reduce__["a" /* default */])(this.xf['@@transducer/step'], result, this.retained);
    this.retained = [];
    return this.xf['@@transducer/step'](result, input);
  };
  XDropLastWhile.prototype.retain = function (result, input) {
    this.retained.push(input);
    return result;
  };

  return XDropLastWhile;
}();

var _xdropLastWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xdropLastWhile(fn, xf) {
  return new XDropLastWhile(fn, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropLastWhile);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropRepeatsWith__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__equals__ = __webpack_require__(67);






/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
var dropRepeats = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_xdropRepeatsWith__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__equals__["a" /* default */]), /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__dropRepeatsWith__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__equals__["a" /* default */])));
/* unused harmony default export */ var _unused_webpack_default_export = (dropRepeats);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xdropWhile__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice__ = __webpack_require__(72);





/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      var lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */
var dropWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['dropWhile'], __WEBPACK_IMPORTED_MODULE_2__internal_xdropWhile__["a" /* default */], function dropWhile(pred, xs) {
  var idx = 0;
  var len = xs.length;
  while (idx < len && pred(xs[idx])) {
    idx += 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice__["a" /* default */])(idx, Infinity, xs);
}));
/* unused harmony default export */ var _unused_webpack_default_export = (dropWhile);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XDropWhile = /*#__PURE__*/function () {
  function XDropWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XDropWhile.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XDropWhile.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].result;
  XDropWhile.prototype['@@transducer/step'] = function (result, input) {
    if (this.f) {
      if (this.f(input)) {
        return result;
      }
      this.f = null;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return XDropWhile;
}();

var _xdropWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xdropWhile(f, xf) {
  return new XDropWhile(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xdropWhile);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isFunction__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lift__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__or__ = __webpack_require__(434);





/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      var gt10 = x => x > 10;
 *      var even = x => x % 2 === 0;
 *      var f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 */
var either = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function either(f, g) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_isFunction__["a" /* default */])(f) ? function _either() {
    return f.apply(this, arguments) || g.apply(this, arguments);
  } : Object(__WEBPACK_IMPORTED_MODULE_2__lift__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__or__["a" /* default */])(f, g);
});
/* unused harmony default export */ var _unused_webpack_default_export = (either);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__takeLast__ = __webpack_require__(436);




/**
 * Checks if a list ends with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
var endsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function (suffix, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__takeLast__["a" /* default */])(suffix.length, list), suffix);
});
/* unused harmony default export */ var _unused_webpack_default_export = (endsWith);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);



/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */
var eqBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function eqBy(f, x, y) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */])(f(x), f(y));
});
/* unused harmony default export */ var _unused_webpack_default_export = (eqBy);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);



/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */
var eqProps = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function eqProps(prop, obj1, obj2) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */])(obj1[prop], obj2[prop]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (eqProps);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      var transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */
var evolve = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function evolve(transformations, object) {
  var result = {};
  var transformation, key, type;
  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (evolve);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfind__ = __webpack_require__(875);




/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */
var find = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['find'], __WEBPACK_IMPORTED_MODULE_2__internal_xfind__["a" /* default */], function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));
/* harmony default export */ __webpack_exports__["a"] = (find);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XFind = /*#__PURE__*/function () {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XFind.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.found = true;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced__["a" /* default */])(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return XFind;
}();

var _xfind = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xfind(f, xf) {
  return new XFind(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfind);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfindIndex__ = __webpack_require__(877);




/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */
var findIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xfindIndex__["a" /* default */], function findIndex(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (findIndex);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XFindIndex = /*#__PURE__*/function () {
  function XFindIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.found = false;
  }
  XFindIndex.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XFindIndex.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, -1);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFindIndex.prototype['@@transducer/step'] = function (result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.found = true;
      result = Object(__WEBPACK_IMPORTED_MODULE_1__reduced__["a" /* default */])(this.xf['@@transducer/step'](result, this.idx));
    }
    return result;
  };

  return XFindIndex;
}();

var _xfindIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xfindIndex(f, xf) {
  return new XFindIndex(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfindIndex);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfindLast__ = __webpack_require__(879);




/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */
var findLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xfindLast__["a" /* default */], function findLast(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx -= 1;
  }
}));
/* unused harmony default export */ var _unused_webpack_default_export = (findLast);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XFindLast = /*#__PURE__*/function () {
  function XFindLast(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFindLast.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XFindLast.prototype['@@transducer/result'] = function (result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
  };
  XFindLast.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.last = input;
    }
    return result;
  };

  return XFindLast;
}();

var _xfindLast = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xfindLast(f, xf) {
  return new XFindLast(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfindLast);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xfindLastIndex__ = __webpack_require__(881);




/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */
var findLastIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xfindLastIndex__["a" /* default */], function findLastIndex(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return idx;
    }
    idx -= 1;
  }
  return -1;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (findLastIndex);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XFindLastIndex = /*#__PURE__*/function () {
  function XFindLastIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.lastIdx = -1;
  }
  XFindLastIndex.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XFindLastIndex.prototype['@@transducer/result'] = function (result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
  };
  XFindLastIndex.prototype['@@transducer/step'] = function (result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.lastIdx = this.idx;
    }
    return result;
  };

  return XFindLastIndex;
}();

var _xfindLastIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xfindLastIndex(f, xf) {
  return new XFindLastIndex(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xfindLastIndex);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_makeFlat__ = __webpack_require__(413);



/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */
var flatten = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_makeFlat__["a" /* default */])(true));
/* unused harmony default export */ var _unused_webpack_default_export = (flatten);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      var printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */
var forEach = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__["a" /* default */])('forEach', function forEach(fn, list) {
  var len = list.length;
  var idx = 0;
  while (idx < len) {
    fn(list[idx]);
    idx += 1;
  }
  return list;
}));
/* harmony default export */ __webpack_exports__["a"] = (forEach);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys__ = __webpack_require__(75);



/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */
var forEachObjIndexed = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function forEachObjIndexed(fn, obj) {
  var keyList = Object(__WEBPACK_IMPORTED_MODULE_1__keys__["a" /* default */])(obj);
  var idx = 0;
  while (idx < keyList.length) {
    var key = keyList[idx];
    fn(obj[key], key, obj);
    idx += 1;
  }
  return obj;
});
/* harmony default export */ __webpack_exports__["a"] = (forEachObjIndexed);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */
var fromPairs = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function fromPairs(pairs) {
  var result = {};
  var idx = 0;
  while (idx < pairs.length) {
    result[pairs[idx][0]] = pairs[idx][1];
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (fromPairs);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduceBy__ = __webpack_require__(178);




/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
var groupBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__["a" /* default */])('groupBy', /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__reduceBy__["a" /* default */])(function (acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));
/* unused harmony default export */ var _unused_webpack_default_export = (groupBy);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */
var groupWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function (fn, list) {
  var res = [];
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    var nextidx = idx + 1;
    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
      nextidx += 1;
    }
    res.push(list.slice(idx, nextidx));
    idx = nextidx;
  }
  return res;
});
/* unused harmony default export */ var _unused_webpack_default_export = (groupWith);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */
var gt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function gt(a, b) {
  return a > b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (gt);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */
var gte = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function gte(a, b) {
  return a >= b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (gte);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);



/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      var hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      var point = {x: 0, y: 0};
 *      var pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */
var has = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (has);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      var square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */
var hasIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function hasIn(prop, obj) {
  return prop in obj;
});
/* unused harmony default export */ var _unused_webpack_default_export = (hasIn);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nth__ = __webpack_require__(137);


/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
var head = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__nth__["a" /* default */])(0);
/* unused harmony default export */ var _unused_webpack_default_export = (head);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);



/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when
 * @example
 *
 *      var incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */
var ifElse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function ifElse(condition, onTrue, onFalse) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
    return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (ifElse);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(167);


/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
var inc = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__add__["a" /* default */])(1);
/* unused harmony default export */ var _unused_webpack_default_export = (inc);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduceBy__ = __webpack_require__(178);


/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
var indexBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__reduceBy__["a" /* default */])(function (acc, elem) {
  return elem;
}, null);
/* unused harmony default export */ var _unused_webpack_default_export = (indexBy);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_indexOf__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isArray__ = __webpack_require__(89);




/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */
var indexOf = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function indexOf(target, xs) {
  return typeof xs.indexOf === 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__internal_isArray__["a" /* default */])(xs) ? xs.indexOf(target) : Object(__WEBPACK_IMPORTED_MODULE_1__internal_indexOf__["a" /* default */])(xs, target, 0);
});
/* unused harmony default export */ var _unused_webpack_default_export = (indexOf);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slice__ = __webpack_require__(72);


/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
var init = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__slice__["a" /* default */])(0, -1);
/* unused harmony default export */ var _unused_webpack_default_export = (init);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_containsWith__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_filter__ = __webpack_require__(271);




/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
var innerJoin = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3__["a" /* default */])(function innerJoin(pred, xs, ys) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__internal_filter__["a" /* default */])(function (x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__internal_containsWith__["a" /* default */])(pred, x, ys);
  }, xs);
});
/* unused harmony default export */ var _unused_webpack_default_export = (innerJoin);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */
var insert = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function insert(idx, elt, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  var result = Array.prototype.slice.call(list, 0);
  result.splice(idx, 0, elt);
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (insert);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */
var insertAll = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function insertAll(idx, elts, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
/* unused harmony default export */ var _unused_webpack_default_export = (insertAll);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_filter__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flip__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__uniq__ = __webpack_require__(277);






/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */
var intersection = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function intersection(list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__uniq__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__internal_filter__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__flip__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_contains__["a" /* default */])(lookupList), filteredList));
});
/* unused harmony default export */ var _unused_webpack_default_export = (intersection);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contains__ = __webpack_require__(119);


var _Set = /*#__PURE__*/function () {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  return _Set;
}();

function hasOrAdd(item, shouldAdd, set) {
  var type = typeof item;
  var prevSize, newSize;
  switch (type) {
    case 'string':
    case 'number':
      // distinguish between +0 and -0
      if (item === 0 && 1 / item === -Infinity) {
        if (set._items['-0']) {
          return true;
        } else {
          if (shouldAdd) {
            set._items['-0'] = true;
          }
          return false;
        }
      }
      // these types can all utilise the native Set
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = {};
            set._items[type][item] = true;
          }
          return false;
        } else if (item in set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][item] = true;
          }
          return false;
        }
      }

    case 'boolean':
      // set._items['boolean'] holds a two element array
      // representing [ falseExists, trueExists ]
      if (type in set._items) {
        var bIdx = item ? 1 : 0;
        if (set._items[type][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set._items[type] = item ? [false, true] : [true, false];
        }
        return false;
      }

    case 'function':
      // compare functions for reference equality
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }
          return false;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__contains__["a" /* default */])(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }
          return false;
        }
        return true;
      }

    case 'undefined':
      if (set._items[type]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type] = true;
        }
        return false;
      }

    case 'object':
      if (item === null) {
        if (!set._items['null']) {
          if (shouldAdd) {
            set._items['null'] = true;
          }
          return false;
        }
        return true;
      }
    /* falls through */
    default:
      // reduce the search size of heterogeneous sets by creating buckets
      // for each type.
      type = Object.prototype.toString.call(item);
      if (!(type in set._items)) {
        if (shouldAdd) {
          set._items[type] = [item];
        }
        return false;
      }
      // scan through all previously applied items
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__contains__["a" /* default */])(item, set._items[type])) {
        if (shouldAdd) {
          set._items[type].push(item);
        }
        return false;
      }
      return true;
  }
}

// A simple Set type that honours R.equals semantics
/* harmony default export */ __webpack_exports__["a"] = (_Set);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
 */
var intersperse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_checkForMethod__["a" /* default */])('intersperse', function intersperse(separator, list) {
  var out = [];
  var idx = 0;
  var length = list.length;
  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], separator);
    }
    idx += 1;
  }
  return out;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (intersperse);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_clone__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isTransformer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_stepCat__ = __webpack_require__(905);






/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      var intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */
var into = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3__["a" /* default */])(function into(acc, xf, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__internal_isTransformer__["a" /* default */])(acc) ? Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce__["a" /* default */])(xf(acc), acc['@@transducer/init'](), list) : Object(__WEBPACK_IMPORTED_MODULE_3__internal_reduce__["a" /* default */])(xf(Object(__WEBPACK_IMPORTED_MODULE_4__internal_stepCat__["a" /* default */])(acc)), Object(__WEBPACK_IMPORTED_MODULE_0__internal_clone__["a" /* default */])(acc, [], [], false), list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (into);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _stepCat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assign__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTransformer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objOf__ = __webpack_require__(438);






var _stepCatArray = {
  '@@transducer/init': Array,
  '@@transducer/step': function (xs, x) {
    xs.push(x);
    return xs;
  },
  '@@transducer/result': __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]
};
var _stepCatString = {
  '@@transducer/init': String,
  '@@transducer/step': function (a, b) {
    return a + b;
  },
  '@@transducer/result': __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]
};
var _stepCatObject = {
  '@@transducer/init': Object,
  '@@transducer/step': function (result, input) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__assign__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike__["a" /* default */])(input) ? Object(__WEBPACK_IMPORTED_MODULE_4__objOf__["a" /* default */])(input[0], input[1]) : input);
  },
  '@@transducer/result': __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]
};

function _stepCat(obj) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isTransformer__["a" /* default */])(obj)) {
    return obj;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike__["a" /* default */])(obj)) {
    return _stepCatArray;
  }
  if (typeof obj === 'string') {
    return _stepCatString;
  }
  if (typeof obj === 'object') {
    return _stepCatObject;
  }
  throw new Error('Cannot create transformer for ' + obj);
}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectAssign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has__ = __webpack_require__(61);


// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
function _objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;
  while (idx < length) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__has__["a" /* default */])(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
}

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys__ = __webpack_require__(75);




/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      var raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */
var invert = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function invert(obj) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_2__keys__["a" /* default */])(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    var val = obj[key];
    var list = Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(val, out) ? out[val] : out[val] = [];
    list[list.length] = key;
    idx += 1;
  }
  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (invert);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys__ = __webpack_require__(75);



/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      var raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      var raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */
var invertObj = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function invertObj(obj) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_1__keys__["a" /* default */])(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    out[obj[key]] = key;
    idx += 1;
  }
  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (invertObj);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__empty__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equals__ = __webpack_require__(67);




/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */
var isEmpty = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function isEmpty(x) {
  return x != null && Object(__WEBPACK_IMPORTED_MODULE_2__equals__["a" /* default */])(x, Object(__WEBPACK_IMPORTED_MODULE_1__empty__["a" /* default */])(x));
});
/* unused harmony default export */ var _unused_webpack_default_export = (isEmpty);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker__ = __webpack_require__(138);


/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
var join = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker__["a" /* default */])(1, 'join');
/* unused harmony default export */ var _unused_webpack_default_export = (join);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */
var keysIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function keysIn(obj) {
  var prop;
  var ks = [];
  for (prop in obj) {
    ks[ks.length] = prop;
  }
  return ks;
});
/* unused harmony default export */ var _unused_webpack_default_export = (keysIn);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isArray__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equals__ = __webpack_require__(67);




/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */
var lastIndexOf = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function lastIndexOf(target, xs) {
  if (typeof xs.lastIndexOf === 'function' && !Object(__WEBPACK_IMPORTED_MODULE_1__internal_isArray__["a" /* default */])(xs)) {
    return xs.lastIndexOf(target);
  } else {
    var idx = xs.length - 1;
    while (idx >= 0) {
      if (Object(__WEBPACK_IMPORTED_MODULE_2__equals__["a" /* default */])(xs[idx], target)) {
        return idx;
      }
      idx -= 1;
    }
    return -1;
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (lastIndexOf);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lens__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nth__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__update__ = __webpack_require__(273);





/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */
var lensIndex = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function lensIndex(n) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__lens__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__nth__["a" /* default */])(n), Object(__WEBPACK_IMPORTED_MODULE_3__update__["a" /* default */])(n));
});
/* unused harmony default export */ var _unused_webpack_default_export = (lensIndex);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assocPath__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lens__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__path__ = __webpack_require__(118);





/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */
var lensPath = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function lensPath(p) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__lens__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__path__["a" /* default */])(p), Object(__WEBPACK_IMPORTED_MODULE_1__assocPath__["a" /* default */])(p));
});
/* unused harmony default export */ var _unused_webpack_default_export = (lensPath);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assoc__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lens__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prop__ = __webpack_require__(261);





/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
var lensProp = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function lensProp(k) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__lens__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__prop__["a" /* default */])(k), Object(__WEBPACK_IMPORTED_MODULE_1__assoc__["a" /* default */])(k));
});
/* unused harmony default export */ var _unused_webpack_default_export = (lensProp);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */
var lt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function lt(a, b) {
  return a < b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (lt);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */
var lte = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function lte(a, b) {
  return a <= b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (lte);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccumRight
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */
var mapAccum = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function mapAccum(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var tuple = [acc];
  while (idx < len) {
    tuple = fn(tuple[0], list[idx]);
    result[idx] = tuple[1];
    idx += 1;
  }
  return [tuple[0], result];
});
/* unused harmony default export */ var _unused_webpack_default_export = (mapAccum);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *value* and *acc*, and should
 * return a tuple *[value, acc]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((x, acc) -> (y, acc)) -> acc -> [x] -> ([y], acc)
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var append = (a, b) => [a + b, a + b];
 *
 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   [
 *     f(b, f(c, f(d, a)[0])[0])[1],
 *     f(c, f(d, a)[0])[1],
 *     f(d, a)[1],
 *   ]
 *   f(b, f(c, f(d, a)[0])[0])[0],
 * ]
 */
var mapAccumRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function mapAccumRight(fn, acc, list) {
  var idx = list.length - 1;
  var result = [];
  var tuple = [acc];
  while (idx >= 0) {
    tuple = fn(list[idx], tuple[0]);
    result[idx] = tuple[1];
    idx -= 1;
  }
  return [result, tuple[0]];
});
/* unused harmony default export */ var _unused_webpack_default_export = (mapAccumRight);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys__ = __webpack_require__(75);




/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      var values = { x: 1, y: 2, z: 3 };
 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */
var mapObjIndexed = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function mapObjIndexed(fn, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_reduce__["a" /* default */])(function (acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, Object(__WEBPACK_IMPORTED_MODULE_2__keys__["a" /* default */])(obj));
});
/* unused harmony default export */ var _unused_webpack_default_export = (mapObjIndexed);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */
var match = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function match(rx, str) {
  return str.match(rx) || [];
});
/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isInteger__ = __webpack_require__(263);



/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      var clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      var seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */
var mathMod = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function mathMod(m, p) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger__["a" /* default */])(m)) {
    return NaN;
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__internal_isInteger__["a" /* default */])(p) || p < 1) {
    return NaN;
  }
  return (m % p + p) % p;
});
/* unused harmony default export */ var _unused_webpack_default_export = (mathMod);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */
var maxBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function maxBy(f, a, b) {
  return f(b) > f(a) ? b : a;
});
/* unused harmony default export */ var _unused_webpack_default_export = (maxBy);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mean__ = __webpack_require__(443);



/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */
var median = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function median(list) {
  var len = list.length;
  if (len === 0) {
    return NaN;
  }
  var width = 2 - len % 2;
  var idx = (len - width) / 2;
  return Object(__WEBPACK_IMPORTED_MODULE_1__mean__["a" /* default */])(Array.prototype.slice.call(list, 0).sort(function (a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }).slice(idx, idx + width));
});
/* unused harmony default export */ var _unused_webpack_default_export = (median);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeWith__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString__ = __webpack_require__(136);



/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @deprecated since v0.25.0
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoize = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__memoizeWith__["a" /* default */])(function () {
  return Object(__WEBPACK_IMPORTED_MODULE_1__toString__["a" /* default */])(arguments);
});
/* unused harmony default export */ var _unused_webpack_default_export = (memoize);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_assign__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);



/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      var resetToDefault = R.merge(R.__, {x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
 */
var merge = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function merge(l, r) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_assign__["a" /* default */])({}, l, r);
});
/* unused harmony default export */ var _unused_webpack_default_export = (merge);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_assign__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);



/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */
var mergeAll = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])(function mergeAll(list) {
  return __WEBPACK_IMPORTED_MODULE_0__internal_assign__["a" /* default */].apply(null, [{}].concat(list));
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeAll);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey__ = __webpack_require__(181);



/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */
var mergeDeepLeft = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function mergeDeepLeft(lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey__["a" /* default */])(function (k, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeDeepLeft);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey__ = __webpack_require__(181);



/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */
var mergeDeepRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function mergeDeepRight(lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey__["a" /* default */])(function (k, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeDeepRight);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey__ = __webpack_require__(181);



/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */
var mergeDeepWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function mergeDeepWith(fn, lObj, rObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeDeepWithKey__["a" /* default */])(function (k, lVal, rVal) {
    return fn(lVal, rVal);
  }, lObj, rObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeDeepWith);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeWithKey__ = __webpack_require__(279);



/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */
var mergeWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function mergeWith(fn, l, r) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__mergeWithKey__["a" /* default */])(function (_, _l, _r) {
    return fn(_l, _r);
  }, l, r);
});
/* unused harmony default export */ var _unused_webpack_default_export = (mergeWith);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */
var min = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function min(a, b) {
  return b < a ? b : a;
});
/* unused harmony default export */ var _unused_webpack_default_export = (min);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */
var minBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function minBy(f, a, b) {
  return f(b) < f(a) ? b : a;
});
/* unused harmony default export */ var _unused_webpack_default_export = (minBy);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      var isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */
var modulo = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function modulo(a, b) {
  return a % b;
});
/* unused harmony default export */ var _unused_webpack_default_export = (modulo);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
var negate = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function negate(n) {
  return -n;
});
/* unused harmony default export */ var _unused_webpack_default_export = (negate);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_complement__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_xany__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__any__ = __webpack_require__(406);






/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *      var isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */
var none = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_complement__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_dispatchable__["a" /* default */])(['any'], __WEBPACK_IMPORTED_MODULE_3__internal_xany__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__any__["a" /* default */])));
/* unused harmony default export */ var _unused_webpack_default_export = (none);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nth__ = __webpack_require__(137);




/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */
var nthArg = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function nthArg(n) {
  var arity = n < 0 ? 1 : n + 1;
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(arity, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nth__["a" /* default */])(n, arguments);
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (nthArg);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */
var o = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function o(f, g, x) {
  return f(g(x));
});
/* unused harmony default export */ var _unused_webpack_default_export = (o);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_of__ = __webpack_require__(940);



/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */
var of = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_of__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (of);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _of;
function _of(x) {
  return [x];
}

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */
var omit = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function omit(names, obj) {
  var result = {};
  var index = {};
  var idx = 0;
  var len = names.length;

  while (idx < len) {
    index[names[idx]] = 1;
    idx += 1;
  }

  for (var prop in obj) {
    if (!index.hasOwnProperty(prop)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (omit);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry1__ = __webpack_require__(15);



/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      var addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */
var once = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry1__["a" /* default */])(function once(fn) {
  var called = false;
  var result;
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(fn.length, function () {
    if (called) {
      return result;
    }
    called = true;
    result = fn.apply(this, arguments);
    return result;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (once);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */
var pair = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function pair(fst, snd) {
  return [fst, snd];
});
/* unused harmony default export */ var _unused_webpack_default_export = (pair);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator__ = __webpack_require__(448);



/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight
 * @example
 *
 *      var multiply2 = (a, b) => a * b;
 *      var double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var sayHello = R.partial(greet, ['Hello']);
 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */
var partial = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (partial);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flip__ = __webpack_require__(179);




/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
var partialRight = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_createPartialApplicator__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__flip__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (partialRight);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__juxt__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reject__ = __webpack_require__(177);




/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
var partition = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__juxt__["a" /* default */])([__WEBPACK_IMPORTED_MODULE_0__filter__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__reject__["a" /* default */]]);
/* unused harmony default export */ var _unused_webpack_default_export = (partition);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path__ = __webpack_require__(118);




/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      var user1 = { address: { zipCode: 90210 } };
 *      var user2 = { address: { zipCode: 55555 } };
 *      var user3 = { name: 'Bob' };
 *      var users = [ user1, user2, user3 ];
 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */
var pathEq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function pathEq(_path, val, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__path__["a" /* default */])(_path, obj), val);
});
/* unused harmony default export */ var _unused_webpack_default_export = (pathEq);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultTo__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path__ = __webpack_require__(118);




/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */
var pathOr = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function pathOr(d, p, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defaultTo__["a" /* default */])(d, Object(__WEBPACK_IMPORTED_MODULE_2__path__["a" /* default */])(p, obj));
});
/* harmony default export */ __webpack_exports__["a"] = (pathOr);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path__ = __webpack_require__(118);



/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */
var pathSatisfies = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function pathSatisfies(pred, propPath, obj) {
  return propPath.length > 0 && pred(Object(__WEBPACK_IMPORTED_MODULE_1__path__["a" /* default */])(propPath, obj));
});
/* unused harmony default export */ var _unused_webpack_default_export = (pathSatisfies);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */
var pick = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function pick(names, obj) {
  var result = {};
  var idx = 0;
  while (idx < names.length) {
    if (names[idx] in obj) {
      result[names[idx]] = obj[names[idx]];
    }
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (pick);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
var pickBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (pickBy);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composeK__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reverse__ = __webpack_require__(175);



/**
 * Returns the left-to-right Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(f, R.chain(g), R.chain(h))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
 * @param {...Function}
 * @return {Function}
 * @see R.composeK
 * @example
 *
 *      //  parseJson :: String -> Maybe *
 *      //  get :: String -> Object -> Maybe *
 *
 *      //  getStateCode :: Maybe String -> Maybe String
 *      var getStateCode = R.pipeK(
 *        parseJson,
 *        get('user'),
 *        get('address'),
 *        get('state'),
 *        R.compose(Maybe.of, R.toUpper)
 *      );
 *
 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
 *      //=> Just('NY')
 *      getStateCode('[Invalid JSON]');
 *      //=> Nothing()
 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
 */
function pipeK() {
  if (arguments.length === 0) {
    throw new Error('pipeK requires at least one argument');
  }
  return __WEBPACK_IMPORTED_MODULE_0__composeK__["a" /* default */].apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__reverse__["a" /* default */])(arguments));
}

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiply__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce__ = __webpack_require__(76);



/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
var product = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__multiply__["a" /* default */], 1);
/* unused harmony default export */ var _unused_webpack_default_export = (product);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_map__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pickAll__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useWith__ = __webpack_require__(451);





/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
var project = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__useWith__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_map__["a" /* default */], [__WEBPACK_IMPORTED_MODULE_2__pickAll__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]]); // passing `identity` gives correct arity
/* unused harmony default export */ var _unused_webpack_default_export = (project);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);



/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      var kids = [abby, fred, rusty, alois];
 *      var hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */
var propEq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function propEq(name, val, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */])(val, obj[name]);
});
/* harmony default export */ __webpack_exports__["a"] = (propEq);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(439);



/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */
var propIs = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function propIs(type, name, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__is__["a" /* default */])(type, obj[name]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (propIs);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);



/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var favorite = R.prop('favoriteLibrary');
 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */
var propOr = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function propOr(val, p, obj) {
  return obj != null && Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(p, obj) ? obj[p] : val;
});
/* unused harmony default export */ var _unused_webpack_default_export = (propOr);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */
var propSatisfies = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function propSatisfies(pred, name, obj) {
  return pred(obj[name]);
});
/* unused harmony default export */ var _unused_webpack_default_export = (propSatisfies);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */
var props = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function props(ps, obj) {
  var len = ps.length;
  var out = [];
  var idx = 0;

  while (idx < len) {
    out[idx] = obj[ps[idx]];
    idx += 1;
  }

  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (props);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_isNumber__ = __webpack_require__(442);



/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in tthe set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */
var range = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function range(from, to) {
  if (!(Object(__WEBPACK_IMPORTED_MODULE_1__internal_isNumber__["a" /* default */])(from) && Object(__WEBPACK_IMPORTED_MODULE_1__internal_isNumber__["a" /* default */])(to))) {
    throw new TypeError('Both arguments to range must be numbers');
  }
  var result = [];
  var n = from;
  while (n < to) {
    result.push(n);
    n += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (range);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curryN__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_reduced__ = __webpack_require__(90);




/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */
var reduceWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curryN__["a" /* default */])(4, [], function _reduceWhile(pred, fn, a, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__internal_reduce__["a" /* default */])(function (acc, x) {
    return pred(acc, x) ? fn(acc, x) : Object(__WEBPACK_IMPORTED_MODULE_2__internal_reduced__["a" /* default */])(acc);
  }, a, list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (reduceWhile);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_reduced__ = __webpack_require__(90);



/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is unavailable to functions not explicitly listed
 * above. For instance, it is not currently supported by
 * [`reduceRight`](#reduceRight).
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */
var reduced = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__internal_reduced__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (reduced);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__always__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__times__ = __webpack_require__(453);




/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */
var repeat = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function repeat(value, n) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__times__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__always__["a" /* default */])(value), n);
});
/* unused harmony default export */ var _unused_webpack_default_export = (repeat);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */
var replace = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function replace(regex, replacement, str) {
  return str.replace(regex, replacement);
});
/* unused harmony default export */ var _unused_webpack_default_export = (replace);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */
var scan = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function scan(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [acc];
  while (idx < len) {
    acc = fn(acc, list[idx]);
    result[idx + 1] = acc;
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (scan);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__always__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__over__ = __webpack_require__(447);




/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */
var set = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function set(lens, v, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__over__["a" /* default */])(lens, Object(__WEBPACK_IMPORTED_MODULE_1__always__["a" /* default */])(v), x);
});
/* unused harmony default export */ var _unused_webpack_default_export = (set);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      var diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */
var sort = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function sort(comparator, list) {
  return Array.prototype.slice.call(list, 0).sort(comparator);
});
/* unused harmony default export */ var _unused_webpack_default_export = (sort);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      var sortByFirstItem = R.sortBy(R.prop(0));
 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      var people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */
var sortBy = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (sortBy);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      var alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      var bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      var people = [clara, bob, alice];
 *      var ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */
var sortWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function sortWith(fns, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var result = 0;
    var i = 0;
    while (result === 0 && i < fns.length) {
      result = fns[i](a, b);
      i += 1;
    }
    return result;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (sortWith);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker__ = __webpack_require__(138);


/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
var split = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker__["a" /* default */])(1, 'split');
/* unused harmony default export */ var _unused_webpack_default_export = (split);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__length__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slice__ = __webpack_require__(72);




/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */
var splitAt = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function splitAt(index, array) {
  return [Object(__WEBPACK_IMPORTED_MODULE_2__slice__["a" /* default */])(0, index, array), Object(__WEBPACK_IMPORTED_MODULE_2__slice__["a" /* default */])(index, Object(__WEBPACK_IMPORTED_MODULE_1__length__["a" /* default */])(array), array)];
});
/* unused harmony default export */ var _unused_webpack_default_export = (splitAt);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(72);



/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */
var splitEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function splitEvery(n, list) {
  if (n <= 0) {
    throw new Error('First argument to splitEvery must be a positive integer');
  }
  var result = [];
  var idx = 0;
  while (idx < list.length) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(idx, idx += n, list));
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (splitEvery);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */
var splitWhen = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function splitWhen(pred, list) {
  var idx = 0;
  var len = list.length;
  var prefix = [];

  while (idx < len && !pred(list[idx])) {
    prefix.push(list[idx]);
    idx += 1;
  }

  return [prefix, Array.prototype.slice.call(list, idx)];
});
/* unused harmony default export */ var _unused_webpack_default_export = (splitWhen);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__take__ = __webpack_require__(274);




/**
 * Checks if a list starts with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
var startsWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function (prefix, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__take__["a" /* default */])(prefix.length, list), prefix);
});
/* unused harmony default export */ var _unused_webpack_default_export = (startsWith);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      var minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      var complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */
var subtract = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function subtract(a, b) {
  return Number(a) - Number(b);
});
/* unused harmony default export */ var _unused_webpack_default_export = (subtract);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__concat__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__difference__ = __webpack_require__(426);




/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */
var symmetricDifference = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function symmetricDifference(list1, list2) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__concat__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__difference__["a" /* default */])(list1, list2), Object(__WEBPACK_IMPORTED_MODULE_2__difference__["a" /* default */])(list2, list1));
});
/* unused harmony default export */ var _unused_webpack_default_export = (symmetricDifference);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__concat__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceWith__ = __webpack_require__(427);




/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      var eqA = R.eqBy(R.prop('a'));
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */
var symmetricDifferenceWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function symmetricDifferenceWith(pred, list1, list2) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__concat__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__differenceWith__["a" /* default */])(pred, list1, list2), Object(__WEBPACK_IMPORTED_MODULE_2__differenceWith__["a" /* default */])(pred, list2, list1));
});
/* unused harmony default export */ var _unused_webpack_default_export = (symmetricDifferenceWith);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(72);



/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      var isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */
var takeLastWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function takeLastWhile(fn, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && fn(xs[idx])) {
    idx -= 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(idx + 1, Infinity, xs);
});
/* unused harmony default export */ var _unused_webpack_default_export = (takeLastWhile);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xtakeWhile__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slice__ = __webpack_require__(72);





/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      var isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */
var takeWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])(['takeWhile'], __WEBPACK_IMPORTED_MODULE_2__internal_xtakeWhile__["a" /* default */], function takeWhile(fn, xs) {
  var idx = 0;
  var len = xs.length;
  while (idx < len && fn(xs[idx])) {
    idx += 1;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__slice__["a" /* default */])(0, idx, xs);
}));
/* unused harmony default export */ var _unused_webpack_default_export = (takeWhile);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfBase__ = __webpack_require__(45);




var XTakeWhile = /*#__PURE__*/function () {
  function XTakeWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTakeWhile.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].init;
  XTakeWhile.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_2__xfBase__["a" /* default */].result;
  XTakeWhile.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : Object(__WEBPACK_IMPORTED_MODULE_1__reduced__["a" /* default */])(result);
  };

  return XTakeWhile;
}();

var _xtakeWhile = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xtakeWhile(f, xf) {
  return new XTakeWhile(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xtakeWhile);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_xtap__ = __webpack_require__(982);




/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      var sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */
var tap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_dispatchable__["a" /* default */])([], __WEBPACK_IMPORTED_MODULE_2__internal_xtap__["a" /* default */], function tap(fn, x) {
  fn(x);
  return x;
}));
/* unused harmony default export */ var _unused_webpack_default_export = (tap);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfBase__ = __webpack_require__(45);



var XTap = /*#__PURE__*/function () {
  function XTap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTap.prototype['@@transducer/init'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].init;
  XTap.prototype['@@transducer/result'] = __WEBPACK_IMPORTED_MODULE_1__xfBase__["a" /* default */].result;
  XTap.prototype['@@transducer/step'] = function (result, input) {
    this.f(input);
    return this.xf['@@transducer/step'](result, input);
  };

  return XTap;
}();

var _xtap = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__curry2__["a" /* default */])(function _xtap(f, xf) {
  return new XTap(f, xf);
});
/* harmony default export */ __webpack_exports__["a"] = (_xtap);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_cloneRegExp__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_isRegExp__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString__ = __webpack_require__(136);





/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */
var test = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function test(pattern, str) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__internal_isRegExp__["a" /* default */])(pattern)) {
    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + Object(__WEBPACK_IMPORTED_MODULE_3__toString__["a" /* default */])(pattern));
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_cloneRegExp__["a" /* default */])(pattern).test(str);
});
/* unused harmony default export */ var _unused_webpack_default_export = (test);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isRegExp;
function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker__ = __webpack_require__(138);


/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
var toLower = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker__["a" /* default */])(0, 'toLowerCase');
/* unused harmony default export */ var _unused_webpack_default_export = (toLower);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_has__ = __webpack_require__(61);



/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
var toPairs = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__internal_has__["a" /* default */])(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});
/* unused harmony default export */ var _unused_webpack_default_export = (toPairs);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */
var toPairsIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function toPairsIn(obj) {
  var pairs = [];
  for (var prop in obj) {
    pairs[pairs.length] = [prop, obj[prop]];
  }
  return pairs;
});
/* unused harmony default export */ var _unused_webpack_default_export = (toPairsIn);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invoker__ = __webpack_require__(138);


/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
var toUpper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__invoker__["a" /* default */])(0, 'toUpperCase');
/* unused harmony default export */ var _unused_webpack_default_export = (toUpper);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_reduce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_xwrap__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curryN__ = __webpack_require__(52);




/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */
var transduce = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__curryN__["a" /* default */])(4, function transduce(xf, fn, acc, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_reduce__["a" /* default */])(xf(typeof fn === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__internal_xwrap__["a" /* default */])(fn) : fn), acc, list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (transduce);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */
var transpose = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function transpose(outerlist) {
  var i = 0;
  var result = [];
  while (i < outerlist.length) {
    var innerlist = outerlist[i];
    var j = 0;
    while (j < innerlist.length) {
      if (typeof result[j] === 'undefined') {
        result[j] = [];
      }
      result[j].push(innerlist[j]);
      j += 1;
    }
    i += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (transpose);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sequence__ = __webpack_require__(454);




/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Nothing` if the given divisor is `0`
 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
 */
var traverse = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function traverse(of, f, traversable) {
  return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : Object(__WEBPACK_IMPORTED_MODULE_2__sequence__["a" /* default */])(of, Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(f, traversable));
});
/* unused harmony default export */ var _unused_webpack_default_export = (traverse);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
var zeroWidth = '\u200b';
var hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
var _trim = !hasProtoTrim || /*#__PURE__*/ws.trim() || ! /*#__PURE__*/zeroWidth.trim() ? function trim(str) {
  var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
  var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
  return str.replace(beginRx, '').replace(endRx, '');
} : function trim(str) {
  return str.trim();
};
var trim = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(_trim);
/* unused harmony default export */ var _unused_webpack_default_export = (trim);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_arity__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_curry2__ = __webpack_require__(4);




/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
 */
var tryCatch = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__internal_curry2__["a" /* default */])(function _tryCatch(tryer, catcher) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__internal_arity__["a" /* default */])(tryer.length, function () {
    try {
      return tryer.apply(this, arguments);
    } catch (e) {
      return catcher.apply(this, Object(__WEBPACK_IMPORTED_MODULE_1__internal_concat__["a" /* default */])([e], arguments));
    }
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (tryCatch);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */
var unapply = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function unapply(fn) {
  return function () {
    return fn(Array.prototype.slice.call(arguments, 0));
  };
});
/* unused harmony default export */ var _unused_webpack_default_export = (unapply);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nAry__ = __webpack_require__(172);



/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      var takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */
var unary = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function unary(fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__nAry__["a" /* default */])(1, fn);
});
/* unused harmony default export */ var _unused_webpack_default_export = (unary);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curryN__ = __webpack_require__(52);



/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      var addFour = a => b => c => d => a + b + c + d;
 *
 *      var uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */
var uncurryN = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function uncurryN(depth, fn) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__curryN__["a" /* default */])(depth, function () {
    var currentDepth = 1;
    var value = fn;
    var idx = 0;
    var endIdx;
    while (currentDepth <= depth && typeof value === 'function') {
      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
      currentDepth += 1;
      idx = endIdx;
    }
    return value;
  });
});
/* unused harmony default export */ var _unused_webpack_default_export = (uncurryN);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      var f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */
var unfold = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function unfold(fn, seed) {
  var pair = fn(seed);
  var result = [];
  while (pair && pair.length) {
    result[result.length] = pair[0];
    pair = fn(pair[1]);
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (unfold);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uniq__ = __webpack_require__(277);





/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
var union = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2__compose__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__uniq__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (union);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_concat__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry3__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uniqWith__ = __webpack_require__(455);




/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      var l1 = [{a: 1}, {a: 2}];
 *      var l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */
var unionWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry3__["a" /* default */])(function unionWith(pred, list1, list2) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__uniqWith__["a" /* default */])(pred, Object(__WEBPACK_IMPORTED_MODULE_0__internal_concat__["a" /* default */])(list1, list2));
});
/* unused harmony default export */ var _unused_webpack_default_export = (unionWith);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */
var unless = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function unless(pred, whenFalseFn, x) {
  return pred(x) ? x : whenFalseFn(x);
});
/* unused harmony default export */ var _unused_webpack_default_export = (unless);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_identity__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chain__ = __webpack_require__(265);



/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
var unnest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__chain__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_identity__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (unnest);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */
var until = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function until(pred, fn, init) {
  var val = init;
  while (!pred(val)) {
    val = fn(val);
  }
  return val;
});
/* unused harmony default export */ var _unused_webpack_default_export = (until);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry1__ = __webpack_require__(15);


/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */
var valuesIn = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry1__["a" /* default */])(function valuesIn(obj) {
  var prop;
  var vs = [];
  for (prop in obj) {
    vs[vs.length] = obj[prop];
  }
  return vs;
});
/* unused harmony default export */ var _unused_webpack_default_export = (valuesIn);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


// `Const` is a functor that effectively ignores the function given to `map`.
var Const = function (x) {
  return { value: x, 'fantasy-land/map': function () {
      return this;
    } };
};

/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */
var view = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function view(lens, x) {
  // Using `Const` effectively ignores the setter function of the `lens`,
  // leaving the value returned by the getter function unmodified.
  return lens(Const)(x).value;
});
/* unused harmony default export */ var _unused_webpack_default_export = (view);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless
 * @example
 *
 *      // truncate :: String -> String
 *      var truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */
var when = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function when(pred, whenTrueFn, x) {
  return pred(x) ? whenTrueFn(x) : x;
});
/* unused harmony default export */ var _unused_webpack_default_export = (when);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equals__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__where__ = __webpack_require__(456);





/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */
var whereEq = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function whereEq(spec, testObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__where__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__equals__["a" /* default */], spec), testObj);
});
/* unused harmony default export */ var _unused_webpack_default_export = (whereEq);

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_curry2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flip__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reject__ = __webpack_require__(177);





/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */
var without = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__internal_curry2__["a" /* default */])(function (xs, list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__reject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__flip__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__internal_contains__["a" /* default */])(xs), list);
});
/* unused harmony default export */ var _unused_webpack_default_export = (without);

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */
var xprod = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function xprod(a, b) {
  // = xprodWith(prepend); (takes about 3 times as long...)
  var idx = 0;
  var ilen = a.length;
  var j;
  var jlen = b.length;
  var result = [];
  while (idx < ilen) {
    j = 0;
    while (j < jlen) {
      result[result.length] = [a[idx], b[j]];
      j += 1;
    }
    idx += 1;
  }
  return result;
});
/* unused harmony default export */ var _unused_webpack_default_export = (xprod);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */
var zip = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function zip(a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = [a[idx], b[idx]];
    idx += 1;
  }
  return rv;
});
/* unused harmony default export */ var _unused_webpack_default_export = (zip);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry2__ = __webpack_require__(4);


/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */
var zipObj = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry2__["a" /* default */])(function zipObj(keys, values) {
  var idx = 0;
  var len = Math.min(keys.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys[idx]] = values[idx];
    idx += 1;
  }
  return out;
});
/* unused harmony default export */ var _unused_webpack_default_export = (zipObj);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_curry3__ = __webpack_require__(20);


/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      var f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */
var zipWith = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__internal_curry3__["a" /* default */])(function zipWith(fn, a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = fn(a[idx], b[idx]);
    idx += 1;
  }
  return rv;
});
/* unused harmony default export */ var _unused_webpack_default_export = (zipWith);

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compileTreatmentByOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(280);
var compileTreatmentByOrder=function compileTreatmentByOrder(monthList){var table=[];table.push(addTreatmentOrders(monthList));table.push(addTreatmentAveragePrice(monthList));table.push(addTreatmentGrossPrice(monthList));table.push(addTreatmentNetIncludingMedicalPrice(monthList));table.push(addMedicalFees(monthList));table.push(addMedicalNetTreatment(monthList));return table;};var addTreatmentOrders=function addTreatmentOrders(monthList){var result=[];result.push('Treatments ordered (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(month.treatmentIncomingOrder_count);},monthList);return result;};//
var addTreatmentAveragePrice=function addTreatmentAveragePrice(monthList){var result=[];result.push('Treatment - Average Selling Price (gross, incl medical fee, €)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=(month.treatmentIncomingOrder_brut+20000*month.treatmentIncomingOrder_count)/month.treatmentIncomingOrder_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var addTreatmentGrossPrice=function addTreatmentGrossPrice(monthList){var result=[];result.push('Treatments - Gross Price');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(month.treatmentIncomingOrder_brut));},monthList);return result;};//
var addTreatmentNetIncludingMedicalPrice=function addTreatmentNetIncludingMedicalPrice(monthList){var result=[];result.push('Treatments ordered (incl medical fee, net)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.treatmentIncomingOrder_net+20000*month.treatmentIncomingOrder_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var addMedicalFees=function addMedicalFees(monthList){var result=[];result.push('Medical fees');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=20000*month.treatmentIncomingOrder_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};// =  (€)
var addMedicalNetTreatment=function addMedicalNetTreatment(monthList){var result=[];result.push('Net Aligner Value');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(month.treatmentIncomingOrder_net));},monthList);return result;};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compileTreatmentByPayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(280);
var compileTreatmentByPayment=function compileTreatmentByPayment(monthList){var table=[];table.push(addTreatmentOrders(monthList));table.push(addTreatmentAveragePrice(monthList));table.push(addTreatmentGrossPrice(monthList));table.push(addTreatmentNetIncludingMedicalPrice(monthList));table.push(addMedicalFees(monthList));table.push(addMedicalNetTreatment(monthList));return table;};var addTreatmentOrders=function addTreatmentOrders(monthList){var result=[];result.push('Treatments ordered (#)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(month.treatmentCashFlow_count);},monthList);return result;};//
var addTreatmentAveragePrice=function addTreatmentAveragePrice(monthList){var result=[];result.push('Treatment - Average Selling Price (gross, incl medical fee, €)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=(month.treatmentCashFlow_brut+20000*month.treatmentCashFlow_count)/month.treatmentCashFlow_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var addTreatmentGrossPrice=function addTreatmentGrossPrice(monthList){var result=[];result.push('Treatments - Gross Price');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(month.treatmentCashFlow_brut));},monthList);return result;};//
var addTreatmentNetIncludingMedicalPrice=function addTreatmentNetIncludingMedicalPrice(monthList){var result=[];result.push('Treatments ordered (incl medical fee, net)');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=month.treatmentCashFlow_net+20000*month.treatmentCashFlow_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};var addMedicalFees=function addMedicalFees(monthList){var result=[];result.push('Medical fees');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){var amount=20000*month.treatmentCashFlow_count;result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(amount));},monthList);return result;};// =  (€)
var addMedicalNetTreatment=function addMedicalNetTreatment(monthList){var result=[];result.push('Net Aligner Value');__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(month){result.push(Object(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* formatMoneyWithThousandSeparator */])(month.treatmentCashFlow_net));},monthList);return result;};

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_selector__ = __webpack_require__(182);
/* harmony default export */ __webpack_exports__["a"] = ({action:{},selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_detail_selector__["l" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_file_upload_selector__["a" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__state_search_selector__["a" /* selectIsFetching */])(state);}}});

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_manage_selector__ = __webpack_require__(284);
/* harmony default export */ __webpack_exports__["a"] = ({selector:{selectIsFetching:__WEBPACK_IMPORTED_MODULE_0__state_manage_selector__["e" /* selectIsFetching */]}});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(218);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_action__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_selector__ = __webpack_require__(457);
/* harmony default export */ __webpack_exports__["a"] = ({action:{findAllLeadIfNotLoaded:__WEBPACK_IMPORTED_MODULE_0__state_action__["a" /* findAllLeadIfNotLoaded */]},selector:{selectIsFetching:__WEBPACK_IMPORTED_MODULE_1__state_selector__["b" /* selectIsFetching */],selectLeadById:__WEBPACK_IMPORTED_MODULE_1__state_selector__["d" /* selectLeadById */]}});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeTableSetting */
/* unused harmony export findAllLeadRequest */
/* unused harmony export findAllLeadSuccess */
/* unused harmony export findAllLeadError */
/* unused harmony export findAllLead */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findAllLeadIfNotLoaded; });
/* unused harmony export findLeadRequest */
/* unused harmony export findLeadSuccess */
/* unused harmony export findLeadError */
/* unused harmony export findLead */
/* unused harmony export changeLead */
/* unused harmony export saveLeadRequest */
/* unused harmony export saveLeadSuccess */
/* unused harmony export saveLeadError */
/* unused harmony export saveLead */
/* unused harmony export addSentEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enrich_lead__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_state_table_state_helper__ = __webpack_require__(42);
var changeTableSetting=Object(__WEBPACK_IMPORTED_MODULE_4__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_TABLE_SETTING */]);var findAllLeadRequest=function findAllLeadRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_ALL_LEAD_REQUEST */],payload:{}};};var findAllLeadSuccess=function findAllLeadSuccess(leadList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_ALL_LEAD_SUCCESS */],payload:{leadList:leadList}};};var findAllLeadError=function findAllLeadError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_ALL_LEAD_ERROR */],payload:{error:error}};};var findAllLead=function findAllLead(){return function(dispatch,getState){dispatch(findAllLeadRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/lead/find-all-not-archived').then(function(leadList){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_lead__["b" /* enrichLeadList */])(getState(),leadList);dispatch(findAllLeadSuccess(leadList));}).catch(function(error){dispatch(findAllLeadError(error));});};};var findAllLeadIfNotLoaded=function findAllLeadIfNotLoaded(){return function(dispatch,getState){// return;
// let leadList = selector.selectLeadList(getState());
// if (leadList.length === 0) {
//     dispatch(findAllLead());
// }
};};var findLeadRequest=function findLeadRequest(leadId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_LEAD_REQUEST */],payload:{leadId:leadId}};};var findLeadSuccess=function findLeadSuccess(lead){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_LEAD_SUCCESS */],payload:{lead:lead}};};var findLeadError=function findLeadError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_LEAD_ERROR */],payload:{error:error}};};var findLead=function findLead(leadId){return function(dispatch,getState){dispatch(findLeadRequest(leadId));Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/lead/find-by-id?leadId='+leadId).then(function(lead){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_lead__["a" /* enrichLead */])(getState(),lead);dispatch(findLeadSuccess(lead));}).catch(function(error){dispatch(findLeadError(error));});};};var changeLead=function changeLead(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_LEAD */],payload:{name:name,value:value}};};var saveLeadRequest=function saveLeadRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_LEAD_REQUEST */]};};var saveLeadSuccess=function saveLeadSuccess(lead){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_LEAD_SUCCESS */],payload:{lead:lead}};};var saveLeadError=function saveLeadError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SAVE_LEAD_ERROR */],payload:{error:error}};};var saveLead=function saveLead(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectHasChanged */](state);if(!hasChanged){return;}var lead=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectLead */](state);dispatch(saveLeadRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/lead/save',lead).then(function(lead){Object(__WEBPACK_IMPORTED_MODULE_3__enrich_lead__["a" /* enrichLead */])(state,lead);dispatch(saveLeadSuccess(lead));}).catch(function(error){dispatch(saveLeadError(error));});};};var addSentEmail=function addSentEmail(sentEmail){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ADD_SENT_EMAIL */],payload:{sentEmail:sentEmail}};};

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enrichLeadList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enrichLead; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_datetime__ = __webpack_require__(26);
var enrichLeadList=function enrichLeadList(state,leadList){__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* forEach */](function(lead){enrichLead(state,lead);},leadList);};var enrichLead=function enrichLead(state,lead){lead.statusName=__WEBPACK_IMPORTED_MODULE_0__globals__["a" /* default */].selector.selectLeadStatusValueById(state,lead.status);lead.responsibleEmployeeName=__WEBPACK_IMPORTED_MODULE_0__globals__["a" /* default */].selector.selectEmployeeNameById(state,lead.responsibleEmployeeId);lead.lastStateTransition=Object(__WEBPACK_IMPORTED_MODULE_2__util_datetime__["b" /* formatDate */])(lead.lastStatusChange);__WEBPACK_IMPORTED_MODULE_1_ramda__["d" /* forEach */](function(statusHistory){statusHistory.statusName=__WEBPACK_IMPORTED_MODULE_0__globals__["a" /* default */].selector.selectLeadStatusValueById(state,statusHistory.newStatus);statusHistory.changedByEmployeeName=__WEBPACK_IMPORTED_MODULE_0__globals__["a" /* default */].selector.selectEmployeeNameById(state,statusHistory.changeByEmployeeId);},lead.statusHistory);lead.statusHistory.sort(Object(__WEBPACK_IMPORTED_MODULE_2__util_datetime__["a" /* dateComparator */])('changed'));};

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony default export */ __webpack_exports__["a"] = ({selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_search_selector__["h" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["d" /* selectIsFetching */])(state);}}});

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_barcode_selector__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_task_list_selector__ = __webpack_require__(183);
/* harmony default export */ __webpack_exports__["a"] = ({selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_barcode_selector__["b" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__["i" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["e" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_3__state_task_list_selector__["a" /* selectIsFetching */])(state);}}});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({payment_received:'btn-primary',cancel:'btn-danger',refunded:'btn-primary',label_printed:'btn-primary',refund:'btn-warning',ready_for_shipment:'btn-primary',delivery_failed:'btn-danger',imprint_received:'btn-primary',cancelled:'btn-danger',images_received:'btn-primary',images_ok:'btn-primary',images_not_ok:'btn-danger',at_least_one_imprint_visually_ok:'btn-primary',both_imprints_visually_not_ok:'btn-danger',cannot_be_treated:'btn-danger',set_returned:'btn-primary',imprints_scanned:'btn-primary',both_imprints_scan_ok:'btn-primary',at_least_one_imprint_scan_not_ok:'btn-danger',physician_assigned:'btn-primary',case_uploaded:'btn-primary',treatment_setup_done:'btn-primary',treatment_plan_done:'btn-primary',treatment_plan_ok_for_physician:'btn-primary',treatment_plan_not_ok_for_physician:'btn-danger',treatment_quotation_created:'btn-primary',park_treatment:'btn-warning',treatment_sold:'btn-primary',imprints_received:'btn-primary',treatment_parked:'btn-warning',send_reminder:'btn-primary',sepa_mandate_created:'btn-primary',payments_received:'btn-primary',put_payment_on_hold:'btn-warning',continue_reminder:'btn-primary',aligners_ordered:'btn-primary',aligners_received:'btn-primary',aligners_shipped:'btn-primary',aligners_returned:'btn-danger',aligners_delivered:'btn-primary',delivery_problem_solved:'btn-primary',follow_up_call_made:'btn-primary',send_email:'btn-primary',repeal:'btn-danger',stop:'btn-danger',in_delivery:'btn-primary',images_not_available:'btn-danger',solvency_check_passed:'btn-primary',solvency_check_failed:'btn-danger',invoice_uploaded_to_zab:'btn-primary',images_forwarded:'btn-primary',feedback_forwarded:'btn-primary',ok:'btn-primary',not_ok:'btn-danger',appointment_made:'btn-primary',setup_done:'btn-primary',refine_setup:'btn-danger',pretreatment_needed:'btn-primary',plan_done:'btn-primary',refine_plan:'btn-danger',production_files_uploaded:'btn-primary',models_printed:'btn-primary',thermo_formed:'btn-primary',aligners_produced:'btn-primary',produced:'btn-primary',aligner_shipped:'btn-primary',ipr_declined:'btn-danger',x_ray_needed:'btn-danger',request_medical_evaluation:'btn-danger'});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_detail_selector__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_search_selector__ = __webpack_require__(1025);
/* harmony default export */ __webpack_exports__["a"] = ({action:{},selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_detail_selector__["b" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_search_selector__["a" /* selectIsFetching */])(state);}}});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectProspectList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(460);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectProspectList=function selectProspectList(state){return selectOwnState(state).prospectList;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__ = __webpack_require__(288);
/* harmony default export */ __webpack_exports__["a"] = ({action:{},selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_plan_selector__["f" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_quotation_selector__["g" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1__state_quotation_selector__["g" /* selectIsFetching */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__["d" /* selectIsFetching */])(state);}}});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_search_selector__ = __webpack_require__(289);
/* harmony default export */ __webpack_exports__["a"] = ({action:{},selector:{selectIsFetching:function selectIsFetching(state){return Object(__WEBPACK_IMPORTED_MODULE_0__state_search_selector__["a" /* selectIsFetching */])(state);}}});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(237);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectLocation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectLocationPath; });
var selectOwnState=function selectOwnState(state){return state.router;};var selectLocation=function selectLocation(state){return selectOwnState(state).location;};var selectLocationPath=function selectLocationPath(state){return selectLocation(state).pathname;};

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleNavigation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(367);
var toggleNavigation=function toggleNavigation(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* TOGGLE_NAVIGATION */]};};

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollTop=function(_React$Component){_inherits(ScrollTop,_React$Component);function ScrollTop(){_classCallCheck(this,ScrollTop);return _possibleConstructorReturn(this,(ScrollTop.__proto__||Object.getPrototypeOf(ScrollTop)).apply(this,arguments));}_createClass(ScrollTop,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.location!==prevProps.location){window.scrollTo(0,0);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.children);}}]);return ScrollTop;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* withRouter */])(ScrollTop));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_basis_selector__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_basis_action__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BasisReport__ = __webpack_require__(1034);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({},__WEBPACK_IMPORTED_MODULE_1__state_basis_selector__["e" /* selectOwnState */](state),{setReport:__WEBPACK_IMPORTED_MODULE_1__state_basis_selector__["a" /* calculateSetReport */](state),treatmentByOrder:__WEBPACK_IMPORTED_MODULE_1__state_basis_selector__["b" /* calculateTreatmentByOrder */](state),treatmentByPayment:__WEBPACK_IMPORTED_MODULE_1__state_basis_selector__["c" /* calculateTreatmentByPayment */](state)});};var mapDispatchToProps={fetchBasisReport:__WEBPACK_IMPORTED_MODULE_2__state_basis_action__["a" /* fetchBasisReport */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__BasisReport__["a" /* default */]));

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchBasisReportRequest */
/* unused harmony export fetchBasisReportSuccess */
/* unused harmony export fetchBasisReportError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBasisReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(344);
var fetchBasisReportRequest=function fetchBasisReportRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FETCH_BASIS_REPORT_REQUEST */]};};var fetchBasisReportSuccess=function fetchBasisReportSuccess(monthList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FETCH_BASIS_REPORT_SUCCESS */],payload:{monthList:monthList}};};var fetchBasisReportError=function fetchBasisReportError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FETCH_BASIS_REPORT_ERROR */],payload:{error:error}};};var fetchBasisReport=function fetchBasisReport(){return function(dispatch,getState){dispatch(fetchBasisReportRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/sales-order/reporting/y2d-basis').then(function(monthList){dispatch(fetchBasisReportSuccess(monthList));}).catch(function(error){dispatch(fetchBasisReportError(error));});};};

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose__ = __webpack_require__(19);
var MONTH_LIST=['January','February','March','April','May','June','July','August','September','October','November','December'];var BasisReport=function BasisReport(_ref){var monthList=_ref.monthList,setReport=_ref.setReport,treatmentByOrder=_ref.treatmentByOrder,treatmentByPayment=_ref.treatmentByPayment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Y2D'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Kits (by payment date)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),monthList.map(function(month,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'align-right',key:index},MONTH_LIST[month.month-1]);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,setReport.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'spacer-bottom',key:index},row.map(function(cell,cellIndex){var className=cellIndex!==0?'align-right':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:className,key:cellIndex},cell);}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Treatments (by order date)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),monthList.map(function(month,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'align-right',key:index},MONTH_LIST[month.month-1]);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,treatmentByOrder.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'spacer-bottom',key:index},row.map(function(cell,cellIndex){var className=cellIndex!==0?'align-right':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:className,key:cellIndex},cell);}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Treatments (by payment) **reliable after june**'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),monthList.map(function(month,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'align-right',key:index},MONTH_LIST[month.month-1]);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,treatmentByPayment.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'spacer-bottom',key:index},row.map(function(cell,cellIndex){var className=cellIndex!==0?'align-right':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:className,key:cellIndex},cell);}));})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.fetchBasisReport();}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(BasisReport)));

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_funnel_builder_selector__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_funnel_builder_action__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FunnelBuilder__ = __webpack_require__(1040);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({processStateNameList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectProcessStateNameList(state),enrichedFunnelList:__WEBPACK_IMPORTED_MODULE_2__state_funnel_builder_selector__["b" /* selectEnrichedStepList */](state)},__WEBPACK_IMPORTED_MODULE_2__state_funnel_builder_selector__["h" /* selectOwnState */](state),{enrichedStateList:__WEBPACK_IMPORTED_MODULE_2__state_funnel_builder_selector__["a" /* selectEnrichedStateList */](state),filteredStateList:__WEBPACK_IMPORTED_MODULE_2__state_funnel_builder_selector__["c" /* selectFilteredStateList */](state)});};var mapDispatchToProps={changeFunnelStartTime:__WEBPACK_IMPORTED_MODULE_3__state_funnel_builder_action__["a" /* changeFunnelStartTime */],findCohort:__WEBPACK_IMPORTED_MODULE_3__state_funnel_builder_action__["e" /* findCohort */],changeFunnelStep:__WEBPACK_IMPORTED_MODULE_3__state_funnel_builder_action__["b" /* changeFunnelStep */],changeModeWeekly:__WEBPACK_IMPORTED_MODULE_3__state_funnel_builder_action__["d" /* changeModeWeekly */],changeModeMonthly:__WEBPACK_IMPORTED_MODULE_3__state_funnel_builder_action__["c" /* changeModeMonthly */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__FunnelBuilder__["a" /* default */]));

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeModeMonthly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeModeWeekly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFunnelStartTime; });
/* unused harmony export findCohortRequest */
/* unused harmony export findCohortSuccess */
/* unused harmony export findCohortError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return findCohort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeFunnelStep; });
/* unused harmony export findCurrentStateRequest */
/* unused harmony export findCurrentStateSuccess */
/* unused harmony export findCurrentStateError */
/* unused harmony export findCurrentState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selector__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__(113);
var changeModeMonthly=function changeModeMonthly(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* CHANGE_MODE */],payload:{mode:__WEBPACK_IMPORTED_MODULE_4__const__["a" /* MODE_MONTHLY */]}};};var changeModeWeekly=function changeModeWeekly(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* CHANGE_MODE */],payload:{mode:__WEBPACK_IMPORTED_MODULE_4__const__["b" /* MODE_WEEKLY */]}};};var changeFunnelStartTime=function changeFunnelStartTime(name,value){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_FUNNEL_START_DEFINITION */],payload:{name:name,value:value}});dispatch(findCohort());};};var findCohortRequest=function findCohortRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["e" /* FIND_COHORT_REQUEST */]};};var findCohortSuccess=function findCohortSuccess(firstCohort,cohortList){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["f" /* FIND_COHORT_SUCCESS */],payload:{firstCohort:firstCohort,cohortList:cohortList}};};var findCohortError=function findCohortError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["d" /* FIND_COHORT_ERROR */],payload:{error:error}};};var findCohort=function findCohort(){return function(dispatch,getState){var state=getState();var funnelStartTime=__WEBPACK_IMPORTED_MODULE_3__selector__["e" /* selectFunnelStartTime */](state);var firstFunnelStep=__WEBPACK_IMPORTED_MODULE_3__selector__["d" /* selectFirstFunnelStep */](state);var mode=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectMode */](state);var path=mode===__WEBPACK_IMPORTED_MODULE_4__const__["a" /* MODE_MONTHLY */]?'/api/process/analytics/state-cohort':'/api/process/analytics/state-cohort-weekly';dispatch(findCohortRequest());dispatch(findCurrentState());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])(path,Object.assign({},funnelStartTime,firstFunnelStep)).then(function(cohortList){var firstCohort=null;__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(cohort){if(cohort.processName===firstFunnelStep.processName&&cohort.stateName===firstFunnelStep.stateName){firstCohort=cohort;}},cohortList);dispatch(findCohortSuccess(firstCohort,cohortList));}).catch(function(error){dispatch(findCohortError(error));});};};var changeFunnelStep=function changeFunnelStep(funnelStepIndex,name,value){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__type__["b" /* CHANGE_FUNNEL_STEP */],payload:{name:name,value:value,funnelStepIndex:funnelStepIndex}});if(funnelStepIndex===0){dispatch(findCohort());}};};var findCurrentStateRequest=function findCurrentStateRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["h" /* FIND_CURRENT_STATE_REQUEST */]};};var findCurrentStateSuccess=function findCurrentStateSuccess(currentState){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["i" /* FIND_CURRENT_STATE_SUCCESS */],payload:{currentState:currentState}};};var findCurrentStateError=function findCurrentStateError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["g" /* FIND_CURRENT_STATE_ERROR */],payload:{error:error}};};var findCurrentState=function findCurrentState(){return function(dispatch,getState){var state=getState();var funnelStartTime=__WEBPACK_IMPORTED_MODULE_3__selector__["e" /* selectFunnelStartTime */](state);var firstFunnelStep=__WEBPACK_IMPORTED_MODULE_3__selector__["d" /* selectFirstFunnelStep */](state);var mode=__WEBPACK_IMPORTED_MODULE_3__selector__["g" /* selectMode */](state);var path=mode===__WEBPACK_IMPORTED_MODULE_4__const__["a" /* MODE_MONTHLY */]?'/api/process/analytics/state-cohort-current-state':'/api/process/analytics/state-cohort-weekly-current-state';dispatch(findCurrentStateRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])(path,Object.assign({},funnelStartTime,firstFunnelStep)).then(function(currentState){dispatch(findCurrentStateSuccess(currentState));}).catch(function(error){dispatch(findCohortError(error));});};};

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FunnelStartSelector__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FunnelStepList__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CurrentState__ = __webpack_require__(1043);
var FunnelBuilder=function FunnelBuilder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FunnelStartSelector__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FunnelStepList__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CurrentState__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findCohort();}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(FunnelBuilder)));

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_funnel_builder_const__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_const__ = __webpack_require__(31);
var monthList=[];for(var month=1;month<13;month++){monthList.push({id:''+month,value:''+month});}var weekList=[];for(var week=1;week<54;week++){weekList.push({id:''+week,value:''+week});}var yearList=[];var today=new Date();for(var year=2018;year<=today.getFullYear();year++){yearList.push({id:''+year,value:''+year});}var FunnelStartSelector=function FunnelStartSelector(_ref){var funnelStartTime=_ref.funnelStartTime,changeFunnelStartTime=_ref.changeFunnelStartTime,mode=_ref.mode,changeModeMonthly=_ref.changeModeMonthly,changeModeWeekly=_ref.changeModeWeekly;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Process Funnel Builder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],null,'Select Cohort')),mode===__WEBPACK_IMPORTED_MODULE_6__state_funnel_builder_const__["a" /* MODE_MONTHLY */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Month'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStartTime,name:'month',valueList:monthList,onChange:changeFunnelStartTime}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Year'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStartTime,name:'year',valueList:yearList,onChange:changeFunnelStartTime}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Company'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStartTime,name:'companyCode',valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["a" /* COMPANY_CODE_SELECT_VALUE_LIST */],onChange:changeFunnelStartTime}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Change Mode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:changeModeWeekly},'weekly'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4})),mode===__WEBPACK_IMPORTED_MODULE_6__state_funnel_builder_const__["b" /* MODE_WEEKLY */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Week'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStartTime,name:'week',valueList:weekList,onChange:changeFunnelStartTime}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Year'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStartTime,name:'year',valueList:yearList,onChange:changeFunnelStartTime}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Change Mode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:changeModeMonthly},'monthly'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6})));};/* harmony default export */ __webpack_exports__["a"] = (FunnelStartSelector);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_helper__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_util_names__ = __webpack_require__(25);
var FunnelStep=function FunnelStep(_ref){var funnelStep=_ref.funnelStep,processStateNameList=_ref.processStateNameList,funnelStepIndex=_ref.funnelStepIndex,changeFunnelStep=_ref.changeFunnelStep;var processNameSelectList=Object(__WEBPACK_IMPORTED_MODULE_7__state_helper__["a" /* getProcessSelectList */])(processStateNameList);var stateList=Object(__WEBPACK_IMPORTED_MODULE_7__state_helper__["b" /* getStateSelectList */])(processStateNameList,funnelStep.processName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStep,name:'processName',addEmpty:!funnelStep.processName,valueList:processNameSelectList,onChange:function onChange(name,value){changeFunnelStep(funnelStepIndex,name,value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'State'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{object:funnelStep,name:'stateName',addEmpty:!funnelStep.stateName,valueList:stateList,renderer:function renderer(stateName){return Object(__WEBPACK_IMPORTED_MODULE_8__process_util_names__["f" /* renderStateName */])(stateName.value);},onChange:function onChange(name,value){changeFunnelStep(funnelStepIndex,name,value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'funnel-builder-cohort-total'},funnelStep.total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},funnelStep.data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object.keys(funnelStep.data).map(function(value,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:key},value,' : ',funnelStep.data[value],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}))));};var FunnelStepList=function FunnelStepList(props){var enrichedFunnelList=props.enrichedFunnelList;var funnelStepLength=enrichedFunnelList.length;var outerLength=(funnelStepLength-funnelStepLength%6)/6+1;var rowColList=[];for(var rowIndex=0;rowIndex<outerLength;rowIndex++){var columnList=[];for(var columnIndex=0;columnIndex<6;columnIndex++){var index=rowIndex*6+columnIndex;var funnelStep=enrichedFunnelList[index];if(funnelStep){columnList.push(funnelStep);}}rowColList.push(columnList);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__["a" /* default */],{title:'Funnel Steps'},rowColList.map(function(columnList,outerIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M',key:outerIndex},columnList.map(function(funnelStep,innerIndex){var index=outerIndex*6+innerIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FunnelStep,Object.assign({key:innerIndex,funnelStepIndex:index,funnelStep:funnelStep},props));}));}));};FunnelStepList.propTypes={enrichedFunnelList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,processStateNameList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeFunnelStep:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FunnelStepList);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_util_names__ = __webpack_require__(25);
var COLOR_LIST=['rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)','rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)'];var compileDoughnutData=function compileDoughnutData(filteredStateList){return{labels:filteredStateList.map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_5__process_util_names__["f" /* renderStateName */])(entry.state)+' % ';}),datasets:[{data:filteredStateList.map(function(entry){return entry.percentage.toFixed(2);}),backgroundColor:COLOR_LIST,hoverBackgroundColor:COLOR_LIST}]};};var CurrentState=function CurrentState(_ref){var currentState=_ref.currentState,enrichedStateList=_ref.enrichedStateList,filteredStateList=_ref.filteredStateList;if(!currentState){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Current State'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__["b" /* Doughnut */],{data:compileDoughnutData(filteredStateList)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Absolute'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Percentage'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,enrichedStateList.map(function(state,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__process_util_names__["f" /* renderStateName */])(state.state)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},state.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},state.percentage.toFixed(2),' %'));}))))));};/* harmony default export */ __webpack_exports__["a"] = (CurrentState);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.3
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(38); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge({}, [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		return layout.horizontal ? newWidth !== chartArea.w : newHeight !== chartArea.h;
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || {};
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || {};

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(Math.max.apply(null, widths));
	highest = heights.indexOf(Math.max.apply(null, heights));

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(293);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(463),
    equalArrays = __webpack_require__(468),
    equalByTag = __webpack_require__(1080),
    equalObjects = __webpack_require__(1084),
    getTag = __webpack_require__(1102),
    isArray = __webpack_require__(85),
    isBuffer = __webpack_require__(470),
    isTypedArray = __webpack_require__(472);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(185);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(185);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(185);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(185);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(184);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(184),
    Map = __webpack_require__(294),
    MapCache = __webpack_require__(295);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(465),
    isMasked = __webpack_require__(1060),
    isObject = __webpack_require__(141),
    toSource = __webpack_require__(467);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1061);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(79);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1064),
    ListCache = __webpack_require__(184),
    Map = __webpack_require__(294);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1065),
    hashDelete = __webpack_require__(1066),
    hashGet = __webpack_require__(1067),
    hashHas = __webpack_require__(1068),
    hashSet = __webpack_require__(1069);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(187);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(187);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(187);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(187);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(188);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1071 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(188);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(188);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(188);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(295),
    setCacheAdd = __webpack_require__(1076),
    setCacheHas = __webpack_require__(1077);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1076 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1077 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1078 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186),
    Uint8Array = __webpack_require__(1081),
    eq = __webpack_require__(464),
    equalArrays = __webpack_require__(468),
    mapToArray = __webpack_require__(1082),
    setToArray = __webpack_require__(1083);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(79);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1085);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1086),
    getSymbols = __webpack_require__(1088),
    keys = __webpack_require__(296);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1087),
    isArray = __webpack_require__(85);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1089),
    stubArray = __webpack_require__(1090);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1092),
    isArguments = __webpack_require__(469),
    isArray = __webpack_require__(85),
    isBuffer = __webpack_require__(470),
    isIndex = __webpack_require__(471),
    isTypedArray = __webpack_require__(472);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(140),
    isObjectLike = __webpack_require__(142);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(140),
    isLength = __webpack_require__(297),
    isObjectLike = __webpack_require__(142);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1096 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(466);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(285)(module)))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1099),
    nativeKeys = __webpack_require__(1100);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1101);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1101 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1103),
    Map = __webpack_require__(294),
    Promise = __webpack_require__(1104),
    Set = __webpack_require__(1105),
    WeakMap = __webpack_require__(1106),
    baseGetTag = __webpack_require__(140),
    toSource = __webpack_require__(467);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104),
    root = __webpack_require__(79);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104),
    root = __webpack_require__(79);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104),
    root = __webpack_require__(79);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104),
    root = __webpack_require__(79);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1108),
    createAggregator = __webpack_require__(1110);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1109);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(104);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1111),
    baseAggregator = __webpack_require__(1112),
    baseIteratee = __webpack_require__(1118),
    isArray = __webpack_require__(85);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 1111 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1113);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1114),
    createBaseEach = __webpack_require__(1117);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1115),
    keys = __webpack_require__(296);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1116);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1116 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(473);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1119),
    baseMatchesProperty = __webpack_require__(1122),
    identity = __webpack_require__(1133),
    isArray = __webpack_require__(85),
    property = __webpack_require__(1134);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1120),
    getMatchData = __webpack_require__(1121),
    matchesStrictComparable = __webpack_require__(475);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(463),
    baseIsEqual = __webpack_require__(293);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(474),
    keys = __webpack_require__(296);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(293),
    get = __webpack_require__(1123),
    hasIn = __webpack_require__(1130),
    isKey = __webpack_require__(298),
    isStrictComparable = __webpack_require__(474),
    matchesStrictComparable = __webpack_require__(475),
    toKey = __webpack_require__(190);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(476);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1125);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1126);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(295);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1128);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186),
    arrayMap = __webpack_require__(1129),
    isArray = __webpack_require__(85),
    isSymbol = __webpack_require__(189);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1131),
    hasPath = __webpack_require__(1132);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1131 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(477),
    isArguments = __webpack_require__(469),
    isArray = __webpack_require__(85),
    isIndex = __webpack_require__(471),
    isLength = __webpack_require__(297),
    toKey = __webpack_require__(190);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1135),
    basePropertyDeep = __webpack_require__(1136),
    isKey = __webpack_require__(298),
    toKey = __webpack_require__(190);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(476);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_DatePicker__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoiceCSV=function(_React$Component){_inherits(InvoiceCSV,_React$Component);function InvoiceCSV(props){_classCallCheck(this,InvoiceCSV);var _this=_possibleConstructorReturn(this,(InvoiceCSV.__proto__||Object.getPrototypeOf(InvoiceCSV)).call(this,props));_this.changeSelect=_this.changeSelect.bind(_this);_this.maxDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(1,'days');_this.state={fromDate:_this.maxDate.format('YYYY-MM-DD'),toDate:_this.maxDate.format('YYYY-MM-DD')};return _this;}_createClass(InvoiceCSV,[{key:'changeSelect',value:function changeSelect(name,value){this.setState(Object.assign({},this.state,_defineProperty({},name,value)));}},{key:'render',value:function render(){var downloadLinkInvoice=__WEBPACK_IMPORTED_MODULE_7__util_api__["a" /* BACKEND_URL */]+'/api/invoice/generate-csv';var downloadLinkInvoiceForCompany=__WEBPACK_IMPORTED_MODULE_7__util_api__["a" /* BACKEND_URL */]+'/api/invoice/generate-csv-for-company';var dates='?fromDate='+this.state.fromDate+'&toDate='+this.state.toDate;var downloadLinkInvoiceFromToDate=downloadLinkInvoice+dates;var downloadLinkInvoiceDACH=downloadLinkInvoiceForCompany+dates+'&company_code='+__WEBPACK_IMPORTED_MODULE_8__internationalization_const__["b" /* COMPANY_CODE_SUNSHINE_SMILE_GERMANY */];var downloadLinkInvoiceUK=downloadLinkInvoiceForCompany+dates+'&company_code='+__WEBPACK_IMPORTED_MODULE_8__internationalization_const__["c" /* COMPANY_CODE_SUNSHINE_SMILE_UK */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Search Criteria'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'From'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_DatePicker__["a" /* default */],{object:this.state,name:'fromDate',dateFormat:'YYYY-MM-DD',maxDate:this.maxDate,minDate:null,placeholder:'Choose from date',onChange:this.changeSelect,onBlur:function onBlur(){},onKeyDown:function onKeyDown(e){e.preventDefault();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'To'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_DatePicker__["a" /* default */],{object:this.state,name:'toDate',dateFormat:'YYYY-MM-DD',maxDate:this.maxDate,minDate:null,placeholder:'Choose to date',onChange:this.changeSelect,onBlur:function onBlur(){},onKeyDown:function onKeyDown(e){e.preventDefault();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2,className:'status-download-link-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:downloadLinkInvoiceDACH,target:'_blank',rel:'noopener noreferrer'},'Download Invoice CSV (DACH+ES)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2,className:'status-download-link-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:downloadLinkInvoiceUK,target:'_blank',rel:'noopener noreferrer'},'Download Invoice CSV (UK)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4,className:'status-download-link-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:downloadLinkInvoiceFromToDate,target:'_blank',rel:'noopener noreferrer'},'Download Invoice Item CSV')))));}}]);return InvoiceCSV;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InvoiceCSV.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(InvoiceCSV));

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(490);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(480);
var isArguments = __webpack_require__(1145);
var is = __webpack_require__(1146);
var isRegex = __webpack_require__(1151);
var flags = __webpack_require__(1152);
var isDate = __webpack_require__(1154);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(481); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(144);
var callBind = __webpack_require__(482);

var implementation = __webpack_require__(485);
var getPolyfill = __webpack_require__(486);
var shim = __webpack_require__(1150);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(484)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(483);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(486);
var define = __webpack_require__(144);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(484)();
var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
var regexExec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	regexExec = Function.call.bind(RegExp.prototype.exec);
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		try {
			regexExec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return toStr.call(value) === regexClass;
	};


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(144);
var callBind = __webpack_require__(482);

var implementation = __webpack_require__(487);
var getPolyfill = __webpack_require__(488);
var shim = __webpack_require__(1153);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(144).supportsDescriptors;
var getPolyfill = __webpack_require__(488);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1157);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1158);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(489);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(490);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerSearch__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_state_selector__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["c" /* tableSelectorEmployee */](state),isTablet:Object(__WEBPACK_IMPORTED_MODULE_5__layout_state_selector__["c" /* selectIsTablet */])(state),isPartner:Object(__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["k" /* selectIsPartner */])(state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["e" /* initialTableQueryEmployee */],initialTableSettings:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["g" /* initialTableSettings */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["h" /* toggleColumnVisibility */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["a" /* changeFilterEmployee */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["k" /* toggleSortEmployee */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["i" /* toggleMultiSortEmployee */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["c" /* gotoPageEmployee */],navigateToCustomer:function navigateToCustomer(customerId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/customer/edit/'+customerId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerSearch__["a" /* default */]));

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(141),
    now = __webpack_require__(1162),
    toNumber = __webpack_require__(1163);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(79);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(141),
    isSymbol = __webpack_require__(189);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableSort__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableFilter__ = __webpack_require__(1167);
var TableHeader=function TableHeader(_ref){var filter=_ref.filter,filterSetting=_ref.filterSetting,orderBy=_ref.orderBy,columnList=_ref.columnList,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,changeFilter=_ref.changeFilter,hiddenColumns=_ref.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableSort__["a" /* default */],{orderBy:orderBy,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,columnList:columnList,hiddenColumns:hiddenColumns}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableFilter__["a" /* default */],{filter:filter,filterSetting:filterSetting,changeFilter:changeFilter,columnList:columnList,hiddenColumns:hiddenColumns}));};TableHeader.propTypes={columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,toggleSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleMultiSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,orderBy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,filterSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (TableHeader);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortIcon__ = __webpack_require__(1166);
var TableSort=function TableSort(_ref){var orderBy=_ref.orderBy,columnList=_ref.columnList,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,hiddenColumns=_ref.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,columnList.filter(function(column){return!hiddenColumns.includes(column.property);}).map(function(_ref2){var width=_ref2.width,property=_ref2.property,header=_ref2.header,columnName=_ref2.columnName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:property,width:width||'',onClick:function onClick(event){var isShiftKeyPressed=event.nativeEvent.shiftKey;if(isShiftKeyPressed){toggleMultiSort(columnName);}else{toggleSort(columnName);}}},header,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SortIcon__["a" /* default */],{orderBy:orderBy,columnName:columnName}));}));};TableSort.propTypes={columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,toggleSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleMultiSort:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,orderBy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TableSort);

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_reducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var SortIcon=function SortIcon(_ref){var orderBy=_ref.orderBy,columnName=_ref.columnName;var sortOrder=orderBy[columnName];if(!sortOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sort sortIcon'});}if(sortOrder===__WEBPACK_IMPORTED_MODULE_1__state_reducer__["a" /* ASC */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sort-amount-asc sortIcon'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sort-amount-desc sortIcon'});};SortIcon.propTypes={orderBy:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,columnName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SortIcon);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColumnFilter__ = __webpack_require__(1168);
var TableFilter=function TableFilter(_ref){var filter=_ref.filter,columnList=_ref.columnList,filterSetting=_ref.filterSetting,changeFilter=_ref.changeFilter,hiddenColumns=_ref.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-filter-row'},columnList.filter(function(column){return!hiddenColumns.includes(column.property);}).map(function(_ref2){var property=_ref2.property,columnName=_ref2.columnName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:property},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ColumnFilter__["a" /* default */],{changeFilter:changeFilter,filter:filter,property:property,columnName:columnName,filterSetting:filterSetting?filterSetting[property]:null}));}));};TableFilter.propTypes={columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,filterSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (TableFilter);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterInput__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilterSelect__ = __webpack_require__(1170);
var ColumnFilter=function ColumnFilter(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FilterInput__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilterSelect__["a" /* default */],props));};ColumnFilter.propTypes={changeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,columnName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,filterSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ColumnFilter);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var FilterInput=function FilterInput(_ref){var filterSetting=_ref.filterSetting,changeFilter=_ref.changeFilter,columnName=_ref.columnName,filter=_ref.filter;if(filterSetting&&filterSetting.type!=='input'){return null;}var _ref2=filterSetting||{},beforeQuery=_ref2.beforeQuery,beforeRender=_ref2.beforeRender;var changeInput=function changeInput(event){var value=beforeQuery?beforeQuery(event.currentTarget.value):event.currentTarget.value;changeFilter(columnName,value);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-addon left-addon right-addon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-filter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle',onClick:function onClick(){changeFilter(columnName,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',autoCorrect:'Off',className:'form-control',onChange:changeInput,value:beforeRender?beforeRender(filter[columnName]||''):filter[columnName]||''}));};FilterInput.propTypes={changeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,columnName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,filterSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (FilterInput);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var selectStyle={height:'34px',width:'100%',backgroundColor:'#fff',border:0,outline:'none',fontWeight:400};var FilterSelect=function FilterSelect(_ref){var filterSetting=_ref.filterSetting,changeFilter=_ref.changeFilter,columnName=_ref.columnName,filter=_ref.filter;if(!filterSetting||filterSetting.type!=='select'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{style:selectStyle,onChange:function onChange(event){changeFilter(columnName,event.currentTarget.value);},value:filter[columnName]||''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'All'),filterSetting.valueList.map(function(_ref2){var id=_ref2.id,value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:id,value:id},value);}));};FilterSelect.propTypes={changeFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,columnName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,filterSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (FilterSelect);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableRow__ = __webpack_require__(1172);
var TableBody=function TableBody(_ref){var columnList=_ref.columnList,objectList=_ref.objectList,idProperty=_ref.idProperty,onRowClick=_ref.onRowClick,onRowDoubleClick=_ref.onRowDoubleClick,hiddenColumns=_ref.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,objectList.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableRow__["a" /* default */],{columnList:columnList,row:row,key:row[idProperty],onRowClick:onRowClick,onRowDoubleClick:onRowDoubleClick,hiddenColumns:hiddenColumns});}));};TableBody.propTypes={columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,objectList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,idProperty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onRowClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRowDoubleClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TableBody);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var TableRow=function TableRow(_ref){var columnList=_ref.columnList,row=_ref.row,onRowClick=_ref.onRowClick,onRowDoubleClick=_ref.onRowDoubleClick,hiddenColumns=_ref.hiddenColumns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-row',onClick:function onClick(){if(onRowClick){onRowClick(row);}},onDoubleClick:function onDoubleClick(){if(onRowDoubleClick){onRowDoubleClick(row);}}},columnList.filter(function(column){return!hiddenColumns.includes(column.property);}).map(function(_ref2){var property=_ref2.property,renderer=_ref2.renderer;var value=renderer?renderer(row,property):row[property];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:property},value);}));};TableRow.propTypes={columnList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,row:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onRowClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onRowDoubleClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internationalization_renderLanguageFamily__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_util_names__ = __webpack_require__(80);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(isTablet,isPartner){var displayColumnList=isTablet?columnListTablet:columnListDesktop;if(!isPartner){return[].concat(_toConsumableArray(displayColumnList),[{property:'partnerPhysicianName',header:'Partner',columnName:'partnerPhysicianName'},{property:'treatingPhysicianName',header:'Treating',columnName:'treatingPhysicianName'}]);}return displayColumnList;});var columnListDesktop=[{property:'vip',header:'VIP',width:'45',renderer:function renderer(customer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__["a" /* default */],{active:!!customer.vip});},columnName:'customer_customer.vip'},{property:'referenceNumber',header:'Number',columnName:'customer_customer.referenceNumber'},{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'customer_customer.created'},{property:'firstName',header:'Firstname',columnName:'customer_customer.firstName'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'phone',header:'Phone',columnName:'customer_customer.phone'},{property:'zip',header:'ZIP',columnName:'customer_customer.zip'},{property:'city',header:'City',columnName:'customer_customer.city'},{property:'language',header:'Language',columnName:'customer_customer.language',renderer:__WEBPACK_IMPORTED_MODULE_3__internationalization_renderLanguageFamily__["a" /* default */]},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_4__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}];var columnListTablet=[{property:'firstName',header:'Firstname',columnName:'customer_customer.created'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'phone',header:'Phone',columnName:'customer_customer.phone'},{property:'zip',header:'ZIP',columnName:'customer_customer.zip'},{property:'city',header:'City',columnName:'customer_customer.city'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_4__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}];

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BLUR_DELAY=1000;var DEFAULT_TITLE='Select';var MultiSelect=function(_React$Component){_inherits(MultiSelect,_React$Component);function MultiSelect(props){_classCallCheck(this,MultiSelect);var _this=_possibleConstructorReturn(this,(MultiSelect.__proto__||Object.getPrototypeOf(MultiSelect)).call(this,props));_this.blurTimeout=null;var toggleColumnVisibility=props.toggleColumnVisibility;_this.toggleColumnVisibility=toggleColumnVisibility;_this.state={open:false};_this.toggleOpenClose=_this.toggleOpenClose.bind(_this);_this.handleBlur=_this.handleBlur.bind(_this);_this.handleClose=_this.handleClose.bind(_this);return _this;}_createClass(MultiSelect,[{key:'toggleOpenClose',value:function toggleOpenClose(event){this.setState({open:!this.state.open});}},{key:'handleClose',value:function handleClose(event){this.setState({open:false});}},{key:'getOptionClickHandler',value:function getOptionClickHandler(option){var _this2=this;return function(event){_this2.handleOptionClick(event,option);};}},{key:'getResetClickHandler',value:function getResetClickHandler(){var _this3=this;return function(event){_this3.handleResetClick(event);};}},{key:'handleOptionClick',value:function handleOptionClick(event,option){option.checked=!option.checked;this.toggleColumnVisibility(option.name);this.handleFocus();this.forceUpdate();}},{key:'handleResetClick',value:function handleResetClick(event){var _this4=this;this.props.options.forEach(function(option){if(!option.checked){option.checked=true;_this4.toggleColumnVisibility(option.name);}});this.handleFocus();this.forceUpdate();}},{key:'handleFocus',value:function handleFocus(){clearTimeout(this.blurTimeout);}},{key:'handleBlur',value:function handleBlur(){clearTimeout(this.blurTimeout);this.blurTimeout=setTimeout(this.handleClose,BLUR_DELAY);}},{key:'render',value:function render(){var _props$title=this.props.title,title=_props$title===undefined?DEFAULT_TITLE:_props$title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-selector-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'multi-selector-button',onClick:this.toggleOpenClose,onBlur:this.handleBlur},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-selector-label'},title)),this.renderOptions());}},{key:'renderOptions',value:function renderOptions(){var _this5=this;var options=this.props.options;var open=this.state.open;var optionsClassName='multi-selector-options';if(!open){optionsClassName+=' multi-selector-hidden';}var optionKey=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:optionsClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'multi-selector-off-screen'},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:"option_"+optionKey++,className:"multi-selector-option"+(option.checked?" multi-selector-option-selected":""),onClick:_this5.getOptionClickHandler(option)},option.title);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'multi-selector-reset',onClick:this.getResetClickHandler()},'Reset options'));}}]);return MultiSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MultiSelect.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (MultiSelect);

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_tab_comments_action__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_detail_tab_comments_selector__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Customer__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sipgate_state_action__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internationalization_const__ = __webpack_require__(31);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["c" /* selectCustomer */](state),accountFix:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["a" /* selectAccountFix */](state),imageFetching:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["j" /* selectImageFetching */](state),startProcessFetching:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["p" /* selectStartProcessFetching */](state),canReassignPhysician:Object(__WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__["b" /* selectCanReassignPhysician */])(state),showImages:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["o" /* selectShowImages */](state),customerId:props.computedMatch.params.customerId,changeEmailData:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["b" /* selectChangeEmailData */](state),salutationList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSalutationList(state),canSeeImages:Object(__WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__["d" /* selectCanSeeImages */])(state),physicianList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectPhysicianList(state),supplierList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSupplierList(state),isExternalTreatmentPlanerPossible:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["k" /* selectIsExternalTreatmentPlanerPossible */](state),treatmentPlanerList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectTreatmentPlanerList(state),userList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectUserList(state),readOnly:Object(__WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__["i" /* selectHasRole */])(state,__WEBPACK_IMPORTED_MODULE_9__security_state_auth_const__["B" /* ROLE_PARTNER_PHYSICIAN */]),processList:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["m" /* selectProcessList */](state),tab:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["q" /* selectTab */](state),countryCodeList:__WEBPACK_IMPORTED_MODULE_10__internationalization_const__["e" /* COUNTRY_CODE_LIST */],languageList:__WEBPACK_IMPORTED_MODULE_10__internationalization_const__["f" /* LANGUAGE_LIST */],responseFeedback:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["n" /* selectResponseFeedback */](state),deleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["h" /* selectDeleteConfirmationModal */](state),storeList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectStoreList(state),canReassignStore:Object(__WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__["c" /* selectCanReassignStore */])(state),contact:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["d" /* selectCustomerContact */](state),error:__WEBPACK_IMPORTED_MODULE_4__state_detail_selector__["f" /* selectCustomerError */](state),// comments tab
processInstanceList:__WEBPACK_IMPORTED_MODULE_5__state_detail_tab_comments_selector__["c" /* selectProcessInstanceList */](state),commentText:__WEBPACK_IMPORTED_MODULE_5__state_detail_tab_comments_selector__["a" /* selectCommentText */](state),isInternal:__WEBPACK_IMPORTED_MODULE_5__state_detail_tab_comments_selector__["b" /* selectIsInternal */](state),currentUser:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectUser(state)};};var mapDispatchToProps={findCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["l" /* findCustomer */],reassignPhysician:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["u" /* reassignPhysician */],reassignStore:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["v" /* reassignStore */],changeCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["c" /* changeCustomer */],saveCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["w" /* saveCustomer */],toggleImageView:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["H" /* toggleImageView */],uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["J" /* uploadCustomerImage */],fixAccountProblem:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["o" /* fixAccountProblem */],callNumber:__WEBPACK_IMPORTED_MODULE_8__sipgate_state_action__["a" /* callNumber */],openChangeEmailModal:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["s" /* openChangeEmailModal */],closeChangeEmailModal:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["h" /* closeChangeEmailModal */],changeNewEmail:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["g" /* changeNewEmail */],changeEmail:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["e" /* changeEmail */],startRefinementSetProcess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["E" /* startRefinementSetProcess */],startRefinementShopProcess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["F" /* startRefinementShopProcess */],startRetainerRefinementProcess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["G" /* startRetainerRefinementProcess */],startEscalationProcess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["C" /* startEscalationProcess */],findProcessComment:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["n" /* findProcessComment */],startAlignerReproductionProcess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["A" /* startAlignerReproductionProcess */],startPartialRefundProcess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["D" /* startPartialRefundProcess */],changeActiveTab:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["b" /* changeActiveTab */],startDownloadCustomerData:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["B" /* startDownloadCustomerData */],closeResponseFeedbackModal:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["j" /* closeResponseFeedbackModal */],openDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["t" /* openDeleteConfirmationModal */],closeDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["i" /* closeDeleteConfirmationModal */],handleDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["p" /* handleDeleteConfirmationModal */],deleteCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["k" /* deleteCustomer */],showError:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["z" /* showError */],updateWhatsappOtpIn:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["I" /* updateWhatsappOtpIn */],changeCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["d" /* changeCustomerContact */],saveCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["x" /* saveCustomerContact */],hydrateContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["q" /* hydrateCustomerContact */],changeIsTransferredToDrSmile:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["f" /* changeIsTransferredToDrSmile */],// comments tab
findProcessCommentList:__WEBPACK_IMPORTED_MODULE_3__state_detail_tab_comments_action__["d" /* findProcessComment */],changeProcessComment:__WEBPACK_IMPORTED_MODULE_3__state_detail_tab_comments_action__["b" /* changeProcessComment */],addProcessComment:__WEBPACK_IMPORTED_MODULE_3__state_detail_tab_comments_action__["c" /* commentProcessInstance */],changeIsCommentInternal:__WEBPACK_IMPORTED_MODULE_3__state_detail_tab_comments_action__["a" /* changeIsCommentInternal */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__Customer__["a" /* default */]));

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeIsCommentInternal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeProcessComment; });
/* unused harmony export commentProcessInstanceRequest */
/* unused harmony export commentProcessInstanceSuccess */
/* unused harmony export commentProcessInstanceError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return commentProcessInstance; });
/* unused harmony export findProcessCommentRequest */
/* unused harmony export findProcessCommentSuccess */
/* unused harmony export findProcessCommentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findProcessComment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_enrich_process_instance__ = __webpack_require__(303);
var changeIsCommentInternal=function changeIsCommentInternal(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CHANGE_IS_COMMENT_INTERNAL */],payload:{name:name,value:value}};};var changeProcessComment=function changeProcessComment(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CHANGE_PROCESS_COMMENT */],payload:{name:name,value:value}};};var commentProcessInstanceRequest=function commentProcessInstanceRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* COMMENT_PROCESS_INSTANCE_REQUEST */],payload:{}};};var commentProcessInstanceSuccess=function commentProcessInstanceSuccess(comment){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["e" /* COMMENT_PROCESS_INSTANCE_SUCCESS */],payload:{comment:comment}};};var commentProcessInstanceError=function commentProcessInstanceError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* COMMENT_PROCESS_INSTANCE_ERROR */],payload:{error:error}};};var commentProcessInstance=function commentProcessInstance(){return function(dispatch,getState){dispatch(commentProcessInstanceRequest());var state=getState();var processInstanceList=__WEBPACK_IMPORTED_MODULE_1__selector__["c" /* selectProcessInstanceList */](state);var isInternal=__WEBPACK_IMPORTED_MODULE_1__selector__["b" /* selectIsInternal */](state);var processInstanceId=processInstanceList[processInstanceList.length-1].id;var commentText=__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectCommentText */](state);Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["c" /* post */])('/api/process/instance/comment',{processInstanceId:processInstanceId,commentText:commentText,isInternal:isInternal}).then(function(comment){Object(__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_enrich_process_instance__["a" /* enrichComment */])(state,comment);dispatch(commentProcessInstanceSuccess(comment));}).catch(function(error){dispatch(commentProcessInstanceError(error));});};};var findProcessCommentRequest=function findProcessCommentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["g" /* FIND_PROCESS_COMMENT_REQUEST */]};};var findProcessCommentSuccess=function findProcessCommentSuccess(processList){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["h" /* FIND_PROCESS_COMMENT_SUCCESS */],payload:{processList:processList}};};var findProcessCommentError=function findProcessCommentError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["f" /* FIND_PROCESS_COMMENT_ERROR */],payload:{error:error}};};var findProcessComment=function findProcessComment(){return function(dispatch,getState){var state=getState();var customerId=__WEBPACK_IMPORTED_MODULE_2__selector__["g" /* selectCustomerId */](state);if(!customerId){return;}dispatch(findProcessCommentRequest());Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["b" /* get */])('/api/customer/find-process-comment?customerId='+customerId).then(function(processList){var state=getState();for(var index=0;index<processList.length;index++){var process=processList[index];Object(__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_enrich_process_instance__["b" /* enrichCommentList */])(state,process);}dispatch(findProcessCommentSuccess(processList));}).catch(function(error){dispatch(findProcessCommentError(error));});};};

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerHead__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabBasicData__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabMedical__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabPhotos__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabAccounting__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TabFiles__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabComments__ = __webpack_require__(1279);
var Customer=function Customer(props){var customer=props.customer,startProcessFetching=props.startProcessFetching;if(customer===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_block_ui__["a" /* default */],{blocking:startProcessFetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CustomerHead__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TabBasicData__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TabMedical__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TabPhotos__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabAccounting__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TabFiles__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TabComments__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findCustomer(this.props.customerId);}})(Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(Customer)));

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_EscalationIcon__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomerInfo__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomerToolbar__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CustomerTabHeader__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerFeedback__ = __webpack_require__(1216);
var getDeletedInfo=function getDeletedInfo(customer){if(customer.deleted&&customer.firstName!=='Deleted'){var email=customer.email;var emailSplit=email.split('deleted');var deleteTime=emailSplit[1].split('@sunshinesmile.de');return'(non-medical data deleted '+deleteTime[0]+')';}return'';};var CustomerHead=function CustomerHead(props){var customer=props.customer;var deletedInfo=getDeletedInfo(customer);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_EscalationIcon__["a" /* default */],{inEscalation:customer.inEscalation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_VipIcon__["a" /* default */],{onClick:function onClick(){},active:customer.vip}),'\xA0','Customer '+customer.firstName+' '+customer.lastName,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'customer-info-important'},deletedInfo,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CustomerToolbar__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomerFeedback__["a" /* default */],{feedbackList:customer.feedbackList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CustomerInfo__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CustomerTabHeader__["a" /* default */],props)));};/* harmony default export */ __webpack_exports__["a"] = (CustomerHead);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var VIP_STYLE={color:'#d9534f',fontSize:'24px'};var EscalationIcon=function EscalationIcon(_ref){var inEscalation=_ref.inEscalation;if(!inEscalation){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-exclamation-triangle',style:VIP_STYLE});};EscalationIcon.propTypes={inEscalation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (EscalationIcon);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_clean_phone_number__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_select__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PhysicianSelector__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StoreSelector__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhatsappConfirmationModal__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_component_Checkbox__ = __webpack_require__(47);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var FRESH_DESK_LINK='https://gosunshinesmile.freshdesk.com/a/contacts/';var FRESH_SALES_LINK='https://plus-dental.freshsales.io/deals/';var HUBSPOT_LINK='https://app.hubspot.com/contacts/8110222/contact/';var getSupplierName=function getSupplierName(supplierList,supplierId){var supplier=supplierList.find(function(_ref){var id=_ref.id;return id===supplierId;});return supplier?supplier.displayName:'';};var getPhysicianName=function getPhysicianName(physicianList,userList,_ref2){var treatingPhysicianId=_ref2.treatingPhysicianId,partnerPhysicianId=_ref2.partnerPhysicianId;if(treatingPhysicianId){var treatingPhysician=userList.find(function(_ref3){var id=_ref3.id;return id===treatingPhysicianId;});return treatingPhysician?treatingPhysician.firstName+' '+treatingPhysician.lastName:'';}var partnerPhysician=physicianList.find(function(_ref4){var id=_ref4.id;return id===partnerPhysicianId;});return partnerPhysician?partnerPhysician.displayName:'';};var getLanguageValue=function getLanguageValue(languageList,extraLanguages,language){var extraLanguagesArr=extraLanguages?Object.keys(extraLanguages):[];var filteredLanguageListItems=languageList.filter(function(item){return extraLanguagesArr.includes(item.id)||item.id===language;});if(filteredLanguageListItems[0].id==='en_GB'){filteredLanguageListItems.push(filteredLanguageListItems.shift());}var languagesToBeContacted=filteredLanguageListItems.map(function(item){return item.value;});return languagesToBeContacted.join(', ');};var WhatsappOptIn=function WhatsappOptIn(_ref5){var customer=_ref5.customer,currentUser=_ref5.currentUser,_updateWhatsappOtpIn=_ref5.updateWhatsappOtpIn;var whatsappOptInValueList=[{'id':'true','value':'true'},{'id':'false','value':'false'}];var readOnly=!currentUser.roleList.includes('customer_service_team_lead');var addEmpty=customer.isWhatsAppOptIn===null;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showConfirmationModal=_useState2[0],setShowConfirmationModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),whatsAppOptIn=_useState4[0],setWhatsAppOptIn=_useState4[1];var toggleModalVisibility=function toggleModalVisibility(){setShowConfirmationModal(!showConfirmationModal);};var handleWhatsappOptIn=function handleWhatsappOptIn(name,value){setWhatsAppOptIn(value);toggleModalVisibility();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'WhatsApp Opt-in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Select__["a" /* default */],{name:'isWhatsAppOptIn',object:customer,valueList:whatsappOptInValueList,onChange:handleWhatsappOptIn,readOnly:readOnly,addEmpty:addEmpty})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WhatsappConfirmationModal__["a" /* default */],{isOpen:showConfirmationModal,handleClose:toggleModalVisibility,updateWhatsappOtpIn:function updateWhatsappOtpIn(){_updateWhatsappOtpIn(whatsAppOptIn);}}));};var CustomerInfo=function CustomerInfo(_ref6){var customer=_ref6.customer,salutationList=_ref6.salutationList,countryCodeList=_ref6.countryCodeList,supplierList=_ref6.supplierList,physicianList=_ref6.physicianList,userList=_ref6.userList,canReassignPhysician=_ref6.canReassignPhysician,reassignPhysician=_ref6.reassignPhysician,updateWhatsappOtpIn=_ref6.updateWhatsappOtpIn,currentUser=_ref6.currentUser,storeList=_ref6.storeList,reassignStore=_ref6.reassignStore,canReassignStore=_ref6.canReassignStore,languageList=_ref6.languageList,changeIsTransferredToDrSmile=_ref6.changeIsTransferredToDrSmile;var phone=Object(__WEBPACK_IMPORTED_MODULE_5__util_clean_phone_number__["a" /* cleanPhoneNumber */])(customer.phone,customer.countryCode);var salutation=Object(__WEBPACK_IMPORTED_MODULE_6__util_select__["b" /* getSelectValue */])(salutationList,customer.gender);var physicianName=getPhysicianName(physicianList,userList,customer);var country=Object(__WEBPACK_IMPORTED_MODULE_6__util_select__["b" /* getSelectValue */])(countryCodeList,customer.countryCode);var supplierName=getSupplierName(supplierList,customer.partnerSupplierId);var freshSalesDealId=findFreshSalesDealId(customer);var onyxId=customer.onyxId;var onyxServer=customer.onyxServer;var extraLanguages=getLanguageValue(languageList,customer.extraLanguages,customer.language);var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(customer.drSmileTransfer),_useState6=_slicedToArray(_useState5,2),drSmileTransfer=_useState6[0],setDrSmileTransfer=_useState6[1];var handleIsTransferredToDrSmile=function handleIsTransferredToDrSmile(name,value){setDrSmileTransfer(value);changeIsTransferredToDrSmile(value);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salutation+' '+customer.firstName+' '+customer.lastName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,customer.zip||'',' ',customer.city||'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,country)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Languages to be contacted'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,extraLanguages))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+customer.email},customer.email))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Phone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'tel:'+phone},phone))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhatsappOptIn,{customer:customer,updateWhatsappOtpIn:updateWhatsappOtpIn,currentUser:currentUser}),customer.freshDeskId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Freshdesk'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:FRESH_DESK_LINK+customer.freshDeskId},'view ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))),freshSalesDealId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Freshsales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:FRESH_SALES_LINK+freshSalesDealId},'view ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))),customer.hubspotContactId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Hubspot'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:HUBSPOT_LINK+customer.hubspotContactId},'view ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Dr. SmileData transfer consent'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,customer.dataTransferDS?'Yes':'No')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Transferred to Dr. Smile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_Checkbox__["a" /* default */],{object:{drSmileTransfer:drSmileTransfer},name:'drSmileTransfer',onChange:handleIsTransferredToDrSmile})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,customer.voucher&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Voucher code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,customer.voucher.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Store'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,canReassignStore&&customer.store!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StoreSelector__["a" /* default */],{customer:customer,reassignStore:reassignStore}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'info-store'},Object(__WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__["b" /* renderStoreName */])(customer.store)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Physician'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,canReassignPhysician&&physicianName!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PhysicianSelector__["a" /* default */],{customer:customer,physicianList:physicianList,userList:userList,reassignPhysician:reassignPhysician}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'qa-physician-name'},physicianName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Supplier'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,supplierName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'OnyxId'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,onyxId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'OnyxServer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,onyxServer)))))));};var findFreshSalesDealId=function findFreshSalesDealId(customer){if(!customer.processList){return null;}var freshSalesDealId=findLatestProcessContextFreshSalesDealId(customer.processList);if('treatmentQuotationList'in customer){freshSalesDealId=freshSalesDealId||findLatestTreatmentQuotationFreshSalesDealId(customer.treatmentQuotationList);}return freshSalesDealId||null;};var findLatestProcessContextFreshSalesDealId=function findLatestProcessContextFreshSalesDealId(processList){var latestTimestamp=0;var latestDealId='';processList.forEach(function(pi){if(!pi.context['freshSalesDealId']){return'';}var processStartTimestamp=Date.parse(pi.started);if(processStartTimestamp>latestTimestamp){latestTimestamp=processStartTimestamp;latestDealId=pi.context.freshSalesDealId;}});return latestDealId;};var findLatestTreatmentQuotationFreshSalesDealId=function findLatestTreatmentQuotationFreshSalesDealId(treatmentQuotationList){var latestTimestamp=0;var latestDealId='';treatmentQuotationList.forEach(function(tq){if(!tq['freshSalesDealId']){return'';}var createdAtTimestamp=Date.parse(tq.created);if(createdAtTimestamp>latestTimestamp){latestTimestamp=createdAtTimestamp;latestDealId=tq.freshSalesDealId;}});return latestDealId;};CustomerInfo.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,salutationList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,countryCodeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,canReassignPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,reassignPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,reassignStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,languageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,changeIsTransferredToDrSmile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CustomerInfo);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanPhoneNumber; });
var cleanPhoneNumber=function cleanPhoneNumber(phone,countryCode){if(!phone){return'';}if(!countryCode){return phone;}phone=phone.trim();var startsWithZeroZero=phone.startsWith('00');var startsWithPlus=phone.startsWith('+');phone=phone.replace(/[^0-9]/g,'');phone=phone.replace(/\s/g,'');if(startsWithZeroZero){return'+'+phone.substring(2);}if(startsWithPlus){return'+'+phone;}return getCountryPrefix(countryCode)+phone;};var getCountryPrefix=function getCountryPrefix(countryCode){switch(countryCode){case'AT':return'+43';case'CH':return'+41';case'DE':return'+49';case'GB':return'+44';default:return'';}};

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_physician_list__ = __webpack_require__(1202);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var selectorStyle={minWidth:'200px'};var GetAvailablePhysicians=function GetAvailablePhysicians(userList,partnerPhysicians,customer){var internalPhysiciansList=__WEBPACK_IMPORTED_MODULE_3__util_physician_list__["a" /* default */].createInternalPhysiciansList(userList,customer.treatingPhysicianId);var externalPhysiciansList=__WEBPACK_IMPORTED_MODULE_3__util_physician_list__["a" /* default */].createExternalPhysiciansList(userList,customer.treatingPhysicianId);var partnerPhysiciansList=__WEBPACK_IMPORTED_MODULE_3__util_physician_list__["a" /* default */].createPartnerPhysiciansList(partnerPhysicians);var physicians=[{label:"internal",options:internalPhysiciansList},{label:"external",options:externalPhysiciansList},{label:"partner",options:partnerPhysiciansList}];var selectedObject=__WEBPACK_IMPORTED_MODULE_3__util_physician_list__["a" /* default */].findPhysician(internalPhysiciansList,customer.treatingPhysicianId)||__WEBPACK_IMPORTED_MODULE_3__util_physician_list__["a" /* default */].findPhysician(externalPhysiciansList,customer.treatingPhysicianId)||__WEBPACK_IMPORTED_MODULE_3__util_physician_list__["a" /* default */].findPhysician(partnerPhysiciansList,customer.partnerPhysicianId);return[physicians,selectedObject];};var PhysicianSelector=function PhysicianSelector(_ref){var customer=_ref.customer,physicianList=_ref.physicianList,userList=_ref.userList,reassignPhysician=_ref.reassignPhysician;var _GetAvailablePhysicia=GetAvailablePhysicians(userList,physicianList,customer),_GetAvailablePhysicia2=_slicedToArray(_GetAvailablePhysicia,2),options=_GetAvailablePhysicia2[0],selectedObject=_GetAvailablePhysicia2[1];var changeHandler=function changeHandler(data){reassignPhysician(data.value,data.physicianType);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qa-physician-selector',style:selectorStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:'basic-single',classNamePrefix:'select',defaultValue:selectedObject,isSearchable:true,options:options,onChange:changeHandler}));};PhysicianSelector.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,physicianList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,userList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,reassignPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PhysicianSelector);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(1185);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1192)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(462)))

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1195));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1200));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(499));

var _Transition = _interopRequireDefault(__webpack_require__(497));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _addClass = _interopRequireDefault(__webpack_require__(1196));

var _removeClass = _interopRequireDefault(__webpack_require__(1199));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(497));

var _PropTypes = __webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1197);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1198));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(98);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(499));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__security_state_auth_const__ = __webpack_require__(28);
var TYPE_INTERNAL='internal';var TYPE_EXTERNAL='external';var TYPE_PARTNER='partner';function createInternalPhysiciansList(userList,selectedUserId){var filteredList=filterInternalPhysicians(userList,selectedUserId);return buildReassignInternalPhysicianList(filteredList);}function createExternalPhysiciansList(userList,selectedUserId){var filteredList=filterExternalPhysicians(userList,selectedUserId);return buildReassignExternalPhysicianList(filteredList);}function findPhysician(physiciansList,physicianId){return physiciansList.find(function(physician){return physicianId===physician.value;});}function createPartnerPhysiciansList(partnerPhysicians){return partnerPhysicians.map(function(physician){return{value:physician.id,label:physician.displayName,physicianType:TYPE_PARTNER};});}function filterInternalPhysicians(userList,selectedUserId){return userList.filter(function(user){var roleList=user.roleList;if(user.blocked){return false;}return user.id===selectedUserId||roleList.includes(__WEBPACK_IMPORTED_MODULE_0__security_state_auth_const__["M" /* ROLE_TREATING_PHYSICIAN */])||roleList.includes(__WEBPACK_IMPORTED_MODULE_0__security_state_auth_const__["N" /* ROLE_TREATING_PHYSICIAN_REMOTE */]);});}function buildReassignInternalPhysicianList(userList){return userList.map(function(user){return{value:user.id,label:user.firstName+' '+user.lastName,physicianType:TYPE_INTERNAL};});}function buildReassignExternalPhysicianList(userList){return userList.map(function(user){return{value:user.id,label:user.firstName+' '+user.lastName,physicianType:TYPE_EXTERNAL};});}function filterExternalPhysicians(userList,selectedUserId){return userList.filter(function(user){var roleList=user.roleList;if(user.externalUserId===null||user.store===null||user.blocked){return false;}return user.id===selectedUserId||roleList.includes(__WEBPACK_IMPORTED_MODULE_0__security_state_auth_const__["C" /* ROLE_PARTNER_PHYSICIAN_REMOTE */])||roleList.includes(__WEBPACK_IMPORTED_MODULE_0__security_state_auth_const__["B" /* ROLE_PARTNER_PHYSICIAN */])||roleList.includes(__WEBPACK_IMPORTED_MODULE_0__security_state_auth_const__["D" /* ROLE_PARTNER_SCAN_PHYSICIAN */]);});}/* harmony default export */ __webpack_exports__["a"] = ({createInternalPhysiciansList:createInternalPhysiciansList,createPartnerPhysiciansList:createPartnerPhysiciansList,createExternalPhysiciansList:createExternalPhysiciansList,findPhysician:findPhysician});

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(43);
var selectorStyle={minWidth:'200px'};var getAvailableStores=function getAvailableStores(){var state=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();var storeList=__WEBPACK_IMPORTED_MODULE_4__globals__["a" /* default */].selector.selectStoreList(state);return storeList.map(function(store){return{value:store.id,label:''+store.displayName};});};var getCustomerStore=function getCustomerStore(options,customer){return options.filter(function(store){return store.value===customer.storeId;}).shift();};var StoreSelector=function StoreSelector(_ref){var reassignStore=_ref.reassignStore,customer=_ref.customer;var options=getAvailableStores();var changeHandler=function changeHandler(data){reassignStore(data.value,customer.id);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qa-clinics-selector',style:selectorStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:'basic-single',classNamePrefix:'select',defaultValue:getCustomerStore(options,customer),isSearchable:true,options:options,onChange:changeHandler}));};StoreSelector.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,reassignStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StoreSelector);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
var WhatsappConfirmationModal=function WhatsappConfirmationModal(_ref){var updateWhatsappOtpIn=_ref.updateWhatsappOtpIn,isOpen=_ref.isOpen,handleClose=_ref.handleClose;var handleConfirmBtn=function handleConfirmBtn(){updateWhatsappOtpIn();handleClose();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{className:'confirmation-modal',overlayClassName:'confirmation-modal-overlay',contentLabel:'Delete Confirmation',onRequestClose:handleClose,isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'close confirmation-modal-button',style:{'paddingRight':'10px'},onClick:handleClose},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-title'},'Change WhatsApp Opt-in')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-text'},'Are you sure you want to change the opt-in status for this patient?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',style:{'marginRight':'10px'},onClick:handleClose},'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',onClick:handleConfirmBtn},'Yes'))));};WhatsappConfirmationModal.propTypes={updateWhatsappOtpIn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (WhatsappConfirmationModal);

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(98);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1206);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(501);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(305);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(304);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1207);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1208);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(501);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(1211);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(305);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(500);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(500);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResponseFeedbackModal__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeleteConfirmationModal__ = __webpack_require__(1214);
var ACCOUNT_FIX={send_create_account_mail:'Create account mail sent.',password_reset:'Password reset mail sent.'};var BUTTON_STYLE={marginRight:'5px'};var CustomerToolbar=function CustomerToolbar(_ref){var startRefinementSetProcess=_ref.startRefinementSetProcess,startAlignerReproductionProcess=_ref.startAlignerReproductionProcess,startPartialRefundProcess=_ref.startPartialRefundProcess,startEscalationProcess=_ref.startEscalationProcess,startRefinementShopProcess=_ref.startRefinementShopProcess,startRetainerRefinementProcess=_ref.startRetainerRefinementProcess,accountFix=_ref.accountFix,fixAccountProblem=_ref.fixAccountProblem,startDownloadCustomerData=_ref.startDownloadCustomerData,closeResponseFeedbackModal=_ref.closeResponseFeedbackModal,responseFeedback=_ref.responseFeedback,openDeleteConfirmationModal=_ref.openDeleteConfirmationModal,closeDeleteConfirmationModal=_ref.closeDeleteConfirmationModal,handleDeleteConfirmationModal=_ref.handleDeleteConfirmationModal,deleteConfirmationModal=_ref.deleteConfirmationModal,deleteCustomer=_ref.deleteCustomer,showError=_ref.showError;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-primary btn-sm',onClick:fixAccountProblem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-wrench'}),'\xA0fix account problem'),ACCOUNT_FIX[accountFix],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-warning btn-sm',onClick:startRefinementShopProcess},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Start Refinement (Booking)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-warning btn-sm',onClick:startRetainerRefinementProcess},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Start Retainer Refinement (Shop)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-warning btn-sm',onClick:startEscalationProcess},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Start Escalation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["H" /* ROLE_PRODUCTION_ADMIN */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-warning btn-sm',onClick:startAlignerReproductionProcess},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Start Aligner Reproduction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["f" /* ROLE_ACCOUNTING */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-warning btn-sm',onClick:startPartialRefundProcess},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Partial Refund')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["Q" /* ROLE_USER_ADMIN */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["e" /* ROLE_2ND_LEVEL_LEGAL */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-primary btn-sm',onClick:startDownloadCustomerData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),'\xA0Download Patient Data')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:[__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */],__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["e" /* ROLE_2ND_LEVEL_LEGAL */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:BUTTON_STYLE,className:'btn btn-danger btn-sm',onClick:openDeleteConfirmationModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}),'\xA0Delete Patient'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ResponseFeedbackModal__["a" /* default */],{closeResponseFeedbackModal:closeResponseFeedbackModal,responseFeedback:responseFeedback}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DeleteConfirmationModal__["a" /* default */],{closeDeleteConfirmationModal:closeDeleteConfirmationModal,deleteConfirmationModal:deleteConfirmationModal,handleDeleteConfirmationModal:handleDeleteConfirmationModal,deleteCustomer:deleteCustomer,showError:showError}));};CustomerToolbar.propTypes={startRefinementSetProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,startAlignerReproductionProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,startPartialRefundProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,startEscalationProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,startRefinementShopProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,startRetainerRefinementProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fixAccountProblem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,accountFix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,startDownloadCustomerData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,closeResponseFeedbackModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,responseFeedback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,openDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,closeDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,deleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,deleteCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CustomerToolbar);

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
var ResponseFeedbackModal=function ResponseFeedbackModal(_ref){var closeResponseFeedbackModal=_ref.closeResponseFeedbackModal,responseFeedback=_ref.responseFeedback;var DEFAULT_STATUS=401;var MAP_RESPONSE_STATUS={100:'All information regarding this customer has been deleted.',101:'The request is being processed and the corresponding data will be sent to our legal team for review',200:'Our system already contains medical data on this patient. Only non-medical relevant information has been deleted.',201:'Our system already contains medical or business related data on this patient. Only non relevant information has been deleted.',300:'Patient was already deleted.',301:'No information about this patient could be deleted as it is either of a transactional or medical nature which we are required to keep by law.',400:'Patient could not be deleted. Please contact the engineering team.',401:'Something went wrong. Please contact the Engineering team.',600:'An error has occurred. Change could not be saved. Please try again later or contact the engineering team',601:'The Change has been successfully made',602:'The value -empty- is not allowed, please select true or false'};var resValue='response-modal-fail-mode';var iconClass='fa-times-circle';var text=MAP_RESPONSE_STATUS[responseFeedback.status!==null?responseFeedback.status:DEFAULT_STATUS];if(responseFeedback.responseValue===true){resValue='response-modal-success-mode';iconClass='fa-check-circle';}if(responseFeedback.status===301){resValue='response-modal-info-mode';iconClass='fa-exclamation-circle';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:responseFeedback.responseFeedbackModalOpen,className:'response-modal',overlayClassName:'confirmation-modal-overlay',onRequestClose:closeResponseFeedbackModal,contentLabel:'Response Feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'response-modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'response-modal-header '+resValue},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'close response-modal-button',onClick:closeResponseFeedbackModal},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa response-modal-icon fa-inverse '+iconClass}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'response-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'response-modal-text'},text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'response-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',onClick:closeResponseFeedbackModal},'Close'))));};ResponseFeedbackModal.propTypes={responseFeedback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,closeResponseFeedbackModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ResponseFeedbackModal);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
var DeleteConfirmationModal=function DeleteConfirmationModal(_ref){var closeDeleteConfirmationModal=_ref.closeDeleteConfirmationModal,deleteConfirmationModal=_ref.deleteConfirmationModal,handleDeleteConfirmationModal=_ref.handleDeleteConfirmationModal,deleteCustomer=_ref.deleteCustomer,showError=_ref.showError;var handleInput=function handleInput(){var value=!deleteConfirmationModal.checked;handleDeleteConfirmationModal(value);};var startDeleteCustomer=function startDeleteCustomer(){var value=deleteConfirmationModal.checked;if(value){deleteCustomer();}else{showError();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:deleteConfirmationModal.open,className:'confirmation-modal',overlayClassName:'confirmation-modal-overlay',onRequestClose:closeDeleteConfirmationModal,contentLabel:'Delete Confirmation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'close confirmation-modal-button',style:{'padding-right':'10px'},onClick:closeDeleteConfirmationModal},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-title'},'Delete Patient')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-text'},'Information about this patient will be deleted. Are you sure you want to proceed?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'confirmation-modal-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'confirm',type:'checkbox',style:{'margin-right':'10px'},checked:deleteConfirmationModal.checked,onClick:handleInput}),'I confirm that I want to delete this patient')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,deleteConfirmationModal.warning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-warning'},'Must be selected for the patient to be deleted'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',style:{'margin-right':'10px'},onClick:closeDeleteConfirmationModal},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',onClick:startDeleteCustomer},'Delete'))));};DeleteConfirmationModal.propTypes={closeDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,handleDeleteConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DeleteConfirmationModal);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_definition_customer_ui__ = __webpack_require__(94);
var TabHeaderItem=function TabHeaderItem(_ref){var tab=_ref.tab,changeActiveTab=_ref.changeActiveTab,children=_ref.children,name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:tab===name?'active':'',onClick:function onClick(){changeActiveTab(name);}},children);};var CustomerTabHeader=function CustomerTabHeader(_ref2){var customer=_ref2.customer,changeActiveTab=_ref2.changeActiveTab,tab=_ref2.tab;if(customer===null){return null;}var canSeeCommentsTab=Object(__WEBPACK_IMPORTED_MODULE_3__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__ui_definition_customer_ui__["b" /* CUSTOMER_COMMENT_LIST */])||Object(__WEBPACK_IMPORTED_MODULE_3__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__ui_definition_customer_ui__["a" /* CUSTOMER_ADD_COMMENT */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabHeaderItem,{tab:tab,changeActiveTab:changeActiveTab,name:__WEBPACK_IMPORTED_MODULE_2__state_detail_const__["i" /* TAB_BASIC_DATA */]},'Basic Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabHeaderItem,{tab:tab,changeActiveTab:changeActiveTab,name:'medical'},'Medical'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabHeaderItem,{tab:tab,changeActiveTab:changeActiveTab,name:'photos'},'Photos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabHeaderItem,{tab:tab,changeActiveTab:changeActiveTab,name:'accounting'},'Accounting'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabHeaderItem,{tab:tab,changeActiveTab:changeActiveTab,name:'files'},'Files'),canSeeCommentsTab&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabHeaderItem,{tab:tab,changeActiveTab:changeActiveTab,name:'comments'},'Comments')));};CustomerTabHeader.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeActiveTab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CustomerTabHeader);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_RatingComponent__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
var CustomerFeedback=function CustomerFeedback(_ref){var feedbackList=_ref.feedbackList;if(!feedbackList||feedbackList.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},'Rating')),feedbackList.map(function(_ref2){var id=_ref2.id,created=_ref2.created,score=_ref2.score,campaignName=_ref2.campaignName,comment=_ref2.comment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},campaignName.replace(/_/g,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_RatingComponent__["a" /* default */],{total:10,score:score})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},comment));}));};CustomerFeedback.propTypes={feedbackList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (CustomerFeedback);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var VIP_STYLE={color:'#f1c40f'};var RatingComponent=function RatingComponent(_ref){var total=_ref.total,score=_ref.score;var list=[];for(var index=1;index<=total;index++){list.push({className:score>=index?'fa fa-star':'fa fa-star-o'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,list.map(function(entry,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{key:index,className:entry.className,style:VIP_STYLE});}));};RatingComponent.propTypes={total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,score:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RatingComponent);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomerContact__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessInstanceList__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appointment_component_list_AppointmentList__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__treatment_component_quotation_TreatmentQuotationContainer__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sales_order_component_list_SalesOrderList__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logistic_component_list_ShipmentListContainer__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__treatment_component_task_widget_ImplantTreatmentQuotationWidgetContainer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__treatment_state_quotation_const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sales_component_SalesNotes__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sales_PricesContext__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
var mapStateToProps=function mapStateToProps(state,props){return{state:state,props:props};};var TabBasicData=function TabBasicData(_ref){var state=_ref.state,props=_ref.props;var tab=props.tab,customer=props.customer,findProcessComment=props.findProcessComment;if(tab!==__WEBPACK_IMPORTED_MODULE_10__state_detail_const__["i" /* TAB_BASIC_DATA */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_6__security_state_auth_const__["l" /* ROLE_EMPLOYEE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProcessInstanceList__["a" /* default */],{findProcessComment:findProcessComment,processInstanceList:customer.processList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__appointment_component_list_AppointmentList__["a" /* default */],{appointmentList:customer.appointmentList})),'treatmentQuotationList'in customer&&customer.treatmentQuotationList[0]&&customer.treatmentQuotationList[0].type===__WEBPACK_IMPORTED_MODULE_12__treatment_state_quotation_const__["i" /* PRODUCT_TYPE_IMPLANTS */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__treatment_component_task_widget_ImplantTreatmentQuotationWidgetContainer__["a" /* default */],{onlyDisplay:true,validationMessageList:[]}),'treatmentQuotationList'in customer&&customer.treatmentQuotationList[0]&&customer.treatmentQuotationList[0].type===__WEBPACK_IMPORTED_MODULE_12__treatment_state_quotation_const__["h" /* PRODUCT_TYPE_ALIGNERS */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__treatment_component_quotation_TreatmentQuotationContainer__["a" /* default */],{onlyDisplay:true,validationMessageList:[]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CustomerContact__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__sales_PricesContext__["a" /* PricesProvider */],{countryCode:customer.countryCode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__sales_component_SalesNotes__["a" /* default */],{customerId:customer.id,state:state})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_6__security_state_auth_const__["l" /* ROLE_EMPLOYEE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__logistic_component_list_ShipmentListContainer__["a" /* default */],{shipmentList:customer.shipmentList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__sales_order_component_list_SalesOrderList__["a" /* default */],{salesOrderList:customer.salesOrderList})));};TabBasicData.propTypes={tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,findProcessComment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(TabBasicData));

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datePartsState=function datePartsState(state){return dateParts(state.year,state.month,state.date);};var minLength=function minLength(value){if(!value){return'';}value+='';return value.length===1?'0'+value:value;};var isDateValid=function isDateValid(year,month,date){return year&&year>1900&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(year+'-'+minLength(month)+'-'+minLength(date)).isValid();};var dateParts=function dateParts(){var year=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var month=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var date=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return{year:year,month:month,date:date,valid:isDateValid(year,month,date)};};var formatDate=function formatDate(_ref){var date=_ref.date,month=_ref.month,year=_ref.year;return year+'-'+minLength(month)+'-'+minLength(date);};var DateOfBirth=function(_React$Component){_inherits(DateOfBirth,_React$Component);function DateOfBirth(props){_classCallCheck(this,DateOfBirth);var _this=_possibleConstructorReturn(this,(DateOfBirth.__proto__||Object.getPrototypeOf(DateOfBirth)).call(this,props));_this.state=_this.parseProps(props);_this.onChange=_this.onChange.bind(_this);_this.onBlur=_this.onBlur.bind(_this);return _this;}_createClass(DateOfBirth,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){this.setState(this.parseProps(props));}},{key:'parseProps',value:function parseProps(_ref2){var object=_ref2.object,name=_ref2.name;var date=object[name];if(!date){return dateParts();}var dob=__WEBPACK_IMPORTED_MODULE_1_moment___default()(date);return dateParts(dob.year(),dob.month()+1,dob.date());}},{key:'onBlur',value:function onBlur(){if(!this.state.valid){return;}this.props.onChange(this.props.name,formatDate(this.state));}},{key:'onChange',value:function onChange(name,value){this.setState(datePartsState(Object.assign({},this.state,_defineProperty({},name,value))));}},{key:'render',value:function render(){var readOnly=this.props.readOnly;var className=this.state.valid?'':'form-error-border';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dob-date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Input__["a" /* default */],{name:'date',type:'number',readOnly:readOnly,className:'form-control',object:this.state,onChange:this.onChange,onBlur:this.onBlur})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dob-month'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Input__["a" /* default */],{name:'month',type:'number',readOnly:readOnly,className:'form-control',object:this.state,onChange:this.onChange,onBlur:this.onBlur})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dob-year'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Input__["a" /* default */],{name:'year',type:'number',readOnly:readOnly,className:'form-control',object:this.state,onChange:this.onChange,onBlur:this.onBlur})));}}]);return DateOfBirth;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DateOfBirth);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({firstName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,lastName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string}));

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(230);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_DatePicker__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TreatmentPreview__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__state_const__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__state_quotation_const__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__prop_types_customer_obj_type__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__prop_types_treatment_quotation_obj_type__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__security_state_auth_const__ = __webpack_require__(28);
var moment=__webpack_require__(38);var getProlongValidDate=function getProlongValidDate(date){return moment(date).add(23,'hours').add(59,'minutes').add(59,'seconds').format('YYYY-MM-DDTHH:mm:ss');};/**
 * this checks if the customer has an @sunshinesmile.de email. If so the purchased state can be reset manually
 * (To allow multiple treatment checkouts for testing)
 * @param customer
 */var isSunshineSmileCustomer=function isSunshineSmileCustomer(customer){if(!customer){return false;}if(!customer.email){return false;}return customer.email.indexOf('@sunshinesmile.de')!==-1;};var getCommentText=function getCommentText(commentKey){var countryCode=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'DE';var getLocalizedText=__WEBPACK_IMPORTED_MODULE_15__state_quotation_const__["j" /* QUOTATION_COMMENT_TEXT */][commentKey];if(getLocalizedText){return getLocalizedText(countryCode);}else{return'';}};var getComment=function getComment(_ref){var treatmentQuotation=_ref.treatmentQuotation,changeTreatmentQuotation=_ref.changeTreatmentQuotation,saveImplantTreatmentQuotation=_ref.saveImplantTreatmentQuotation,customer=_ref.customer;var commentText=getCommentText(treatmentQuotation.commentKey,customer.countryCode);changeTreatmentQuotation('comment',commentText);saveImplantTreatmentQuotation();};var currentUserHasReadOnlyRole=function currentUserHasReadOnlyRole(){var canModifyTQRoles=[__WEBPACK_IMPORTED_MODULE_22__security_state_auth_const__["m" /* ROLE_EMPLOYEE_CUSTOMER_SERVICE */],__WEBPACK_IMPORTED_MODULE_22__security_state_auth_const__["O" /* ROLE_TREATMENT_PLANER */],__WEBPACK_IMPORTED_MODULE_22__security_state_auth_const__["I" /* ROLE_QM_TREATMENT_PLANNER */],__WEBPACK_IMPORTED_MODULE_22__security_state_auth_const__["P" /* ROLE_TREATMENT_QUOTATION_ADMIN */]];var state=__WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */].getState();return!Object(__WEBPACK_IMPORTED_MODULE_21__security_state_auth_selector__["u" /* userHasAnyOfRoles */])(state,canModifyTQRoles);};var ImplantTreatmentQuotation=function ImplantTreatmentQuotation(_ref2){var treatmentQuotation=_ref2.treatmentQuotation,isValid=_ref2.isValid,changeTreatmentQuotation=_ref2.changeTreatmentQuotation,saveImplantTreatmentQuotation=_ref2.saveImplantTreatmentQuotation,customer=_ref2.customer,isPreviewModalOpen=_ref2.isPreviewModalOpen,closePreviewModal=_ref2.closePreviewModal,validationMessageList=_ref2.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_18__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_19__process_ui_definition_process_ui__["z" /* IMPLANT_TREATMENT_QUOTATION_WIDGET */])){return null;}if(!customer){return null;}if(!customer.isImplantCustomer){return null;}var onChangeSelect=function onChangeSelect(name,value){changeTreatmentQuotation(name,value);if(name==='brutPrice'){changeTreatmentQuotation('physicianCost',__WEBPACK_IMPORTED_MODULE_13__state_const__["e" /* IMPLANT_TREATMENT_PHYSICIAN_COST */]);}saveImplantTreatmentQuotation();};if(treatmentQuotation===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__["a" /* default */],{title:'Implant Treatment Quotation'});}var commentExists=treatmentQuotation&&treatmentQuotation.commentKey&&!treatmentQuotation.comment;if(commentExists){getComment({treatmentQuotation:treatmentQuotation,changeTreatmentQuotation:changeTreatmentQuotation,saveImplantTreatmentQuotation:saveImplantTreatmentQuotation,customer:customer});}var currencyCodeSymbol=__WEBPACK_IMPORTED_MODULE_13__state_const__["d" /* CURRENCY_CODE_SYMBOL */][treatmentQuotation.currency];var isSunshineSmile=isSunshineSmileCustomer(customer);var hasPhysician=!!(customer.partnerPhysicianId||customer.treatingPhysicianId);var readonly=treatmentQuotation.purchased||currentUserHasReadOnlyRole();var title='Implant Treatment Quotation '+treatmentQuotation.customerName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TreatmentPreview__["a" /* default */],{treatmentQuotation:treatmentQuotation,isPreviewModalOpen:isPreviewModalOpen,closePreviewModal:closePreviewModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),isSunshineSmile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Checkbox__["a" /* default */],{object:treatmentQuotation,name:'purchased',onChange:onChangeSelect},'Purchased')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Checkbox__["a" /* default */],{object:treatmentQuotation,name:'approved',readOnly:!isValid||!hasPhysician||readonly,onChange:onChangeSelect},'Allow customer to purchase'),!hasPhysician&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-error'},'Please select a physician to activate this quotation. (in the status area of the Sales Order)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Checkbox__["a" /* default */],{object:treatmentQuotation,name:'ratePayAllowed',readOnly:readonly,onChange:onChangeSelect},'Rate pay allowed'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Valid Until'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_DatePicker__["a" /* default */],{object:treatmentQuotation,name:'validUntil',readOnly:readonly,onChange:function onChange(name,value){changeTreatmentQuotation(name,getProlongValidDate(value));},onBlur:saveImplantTreatmentQuotation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'BrutPrice',groupAddOnIcon:currencyCodeSymbol},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__form_component_Select__["a" /* default */],{name:'brutPrice',object:treatmentQuotation,valueList:__WEBPACK_IMPORTED_MODULE_13__state_const__["a" /* AVAILABLE_IMPLANT_TREATMENT_PRICE_LIST */],readOnly:readonly,type:'int',onChange:onChangeSelect}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Physician Cost',groupAddOnIcon:currencyCodeSymbol},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:treatmentQuotation,name:'physicianCost',readOnly:true,onChange:changeTreatmentQuotation,onBlur:saveImplantTreatmentQuotation,isMoney:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__form_component_Select__["a" /* default */],{name:'commentKey',object:treatmentQuotation,valueList:Object(__WEBPACK_IMPORTED_MODULE_15__state_quotation_const__["m" /* getQuotationCommentSelectValues */])(false),readOnly:readonly,addEmpty:true,onChange:function onChange(name,value){changeTreatmentQuotation(name,value);var commentText=getCommentText(value,customer.countryCode);changeTreatmentQuotation('comment',commentText);saveImplantTreatmentQuotation();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Currency'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__form_component_Select__["a" /* default */],{name:'currency',object:treatmentQuotation,valueList:__WEBPACK_IMPORTED_MODULE_13__state_const__["c" /* CURRENCY_CODE_LIST */],readOnly:readonly,addEmpty:false,onChange:onChangeSelect})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_TextArea__["a" /* default */],{name:'comment',readOnly:readonly,object:treatmentQuotation,onChange:changeTreatmentQuotation,onBlur:saveImplantTreatmentQuotation})))));};ImplantTreatmentQuotation.propTypes={treatmentQuotation:__WEBPACK_IMPORTED_MODULE_17__prop_types_treatment_quotation_obj_type__["a" /* default */],isPreviewModalOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,findOrCreateTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveImplantTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,openPreviewModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,closePreviewModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,customer:__WEBPACK_IMPORTED_MODULE_16__prop_types_customer_obj_type__["a" /* default */],productType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){if(this.props.onlyDisplay){return;}if(this.props.customer.isImplantCustomer){this.props.findOrCreateTreatmentQuotation(this.props.productType);}}})(ImplantTreatmentQuotation));

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1227);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOLLOW_UP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var FOLLOW_UP={IN_CLINIC:'In-Clinic-Follow-Up',EXPERT_CALL:'Expert-Call-Follow-Up',NO_FOLLOW_UP:'No-Follow-Up',NO_PITCH:'No-Pitch'};/* harmony default export */ __webpack_exports__["b"] = ({findNote:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(customerId){var note;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])("/api/sales/"+customerId+"/note");case 2:note=_context.sent;return _context.abrupt("return",{followUpType:note.followUpType,promisedPrice:note.promisedPrice||'',treatmentPlanDeadline:note.treatmentPlanDeadline?__WEBPACK_IMPORTED_MODULE_2_moment___default()(note.treatmentPlanDeadline):null});case 4:case"end":return _context.stop();}}},_callee,this);}));function findNote(_x){return _ref.apply(this,arguments);}return findNote;}(),saveNote:function saveNote(customerId,note){if(!Object.values(FOLLOW_UP).includes(note.followUpType)){throw new Error('Follow-up type is required');}if(!note.promisedPrice){throw new Error('Promised Price is required');}var hasAppointment=[FOLLOW_UP.IN_CLINIC,FOLLOW_UP.EXPERT_CALL].includes(note.followUpType);if(hasAppointment&&!note.treatmentPlanDeadline){throw new Error('Treatment Deadline is required for this follow up type');}return Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["c" /* post */])("/api/sales/"+customerId+"/note",{followUpType:note.followUpType,promisedPrice:note.promisedPrice?note.promisedPrice.toString():null,treatmentPlanDeadline:note.treatmentPlanDeadline?note.treatmentPlanDeadline.format('YYYY-MM-DD'):null});}});

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PhysicianAndSupplier__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TraySize__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__treatment_component_quotation_TreatmentQuotationContainer__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TreatmentExecution__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TreatmentFeedback__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__anamnesis_component_list_AnamnesisListContainer__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__treatment_component_plan_IPRInstructions__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__process_component_task_widget_PatientIPRWishesWidgetContainer__ = __webpack_require__(525);
var TabMedical=function TabMedical(props){var tab=props.tab,customer=props.customer;if(tab!==__WEBPACK_IMPORTED_MODULE_11__state_detail_const__["l" /* TAB_MEDICAL */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["l" /* ROLE_EMPLOYEE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PhysicianAndSupplier__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TraySize__["a" /* default */],Object.assign({},props,{readOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TreatmentFeedback__["a" /* default */],{customer:customer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TreatmentExecution__["a" /* default */],{customer:customer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__treatment_component_quotation_TreatmentQuotationContainer__["a" /* default */],{onlyDisplay:true,validationMessageList:[]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__anamnesis_component_list_AnamnesisListContainer__["a" /* default */],{customer:customer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__process_component_task_widget_PatientIPRWishesWidgetContainer__["a" /* default */],{readOnly:true,customer:customer}),customer.treatmentPlanList.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__treatment_component_plan_IPRInstructions__["a" /* default */],{readOnly:true,isWidget:false,changeIPRInstruction:function changeIPRInstruction(){},saveTreatmentPlan:function saveTreatmentPlan(){},context:{},treatmentPlan:customer.treatmentPlanList[0],isIPRProviderStore:true}));};TabMedical.propTypes={tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TabMedical);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_list_action__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_list_selector__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnamnesisList__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state,_ref){var customer=_ref.customer;return{customerId:customer.id,anamnesisList:__WEBPACK_IMPORTED_MODULE_3__state_list_selector__["a" /* selectAnamnesisList */](state),isIPRProviderStore:Object(__WEBPACK_IMPORTED_MODULE_5__globals_state_selector__["isIPRProviderStore"])(state,customer.store),isUserFromCustomerStore:Object(__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["s" /* selectUserStore */])(state)===customer.store,showAnamnesis:__WEBPACK_IMPORTED_MODULE_3__state_list_selector__["c" /* selectShowAnamnesis */](state),isInfoLegendShown:__WEBPACK_IMPORTED_MODULE_3__state_list_selector__["d" /* selectShowInfoLegendShown */](state)};};var mapDispatchToProps={findByCustomerId:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["a" /* findByCustomerId */],toggleAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["b" /* toggleAnamnesis */],toggleInfoLegend:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["c" /* toggleInfoLegend */],changeAnamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__["a" /* changeAnamnesis */],saveAnamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__["c" /* saveAnamnesis */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__AnamnesisList__["a" /* default */]));

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(anamnesis){if(!anamnesis.formData){anamnesis.formData={};}if(!anamnesis.formData.teethIndication){anamnesis.formData.teethIndication={};}if(!anamnesis.formData.additionalIndication){anamnesis.formData.additionalIndication=null;}if(!anamnesis.formData.treatmentExpectation){anamnesis.formData.treatmentExpectation=[];}return anamnesis;});

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_ToggleButton__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupData=function GroupData(_ref){var group=_ref.group,currentLanguage=_ref.currentLanguage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'customer-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Answer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,group.answerList.map(function(answer){var question=answer.question[currentLanguage];var answers=answer.answer.map(function(a){return a[currentLanguage]+' ';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:answer.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'key'},question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'value'},answers));})))));};var AlignerTreatmentCustomerAssessment=function(_React$Component){_inherits(AlignerTreatmentCustomerAssessment,_React$Component);function AlignerTreatmentCustomerAssessment(props){_classCallCheck(this,AlignerTreatmentCustomerAssessment);var _this=_possibleConstructorReturn(this,(AlignerTreatmentCustomerAssessment.__proto__||Object.getPrototypeOf(AlignerTreatmentCustomerAssessment)).call(this,props));var availableLanguages=Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["g" /* pathOr */])([],['anamnesis','availableLanguageList'],props);var defaultLanguage=availableLanguages.includes('de')?'de':availableLanguages[0];_this.state={currentLanguage:defaultLanguage};_this.changeState=_this.changeState.bind(_this);return _this;}_createClass(AlignerTreatmentCustomerAssessment,[{key:'changeState',value:function changeState(name,value){this.setState(Object.assign({},this.state,_defineProperty({},name,value)));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,anamnesis=_props.anamnesis,showAnamnesis=_props.showAnamnesis,toggleAnamnesis=_props.toggleAnamnesis;var languageSelectorValueList=anamnesis.availableLanguageList.map(function(language){return{id:language,value:language};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_ToggleButton__["a" /* default */],{toggle:toggleAnamnesis,active:showAnamnesis,activeIcon:'fa fa-search-minus',inactiveIcon:'fa fa-search-plus',className:'anamnesis-toggle-button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Language'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:this.state,name:'currentLanguage',addEmpty:false,onChange:this.changeState,valueList:languageSelectorValueList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Selected language by patient'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:this.state,name:'selectedUserLanguage',addEmpty:false,defaultValue:anamnesis.language,readOnly:true,valueList:languageSelectorValueList})))),showAnamnesis&&anamnesis.formData.map(function(group){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupData,{key:group.groupId,group:group,currentLanguage:_this2.state.currentLanguage});}));}}]);return AlignerTreatmentCustomerAssessment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AlignerTreatmentCustomerAssessment);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_SelectChip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_datetime__ = __webpack_require__(26);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var TOOTH_INDICATION=['C','I','V','M','B','x'].map(function(indication){return{id:indication,value:indication};});var ADDITIONAL_INDICATION=[{value:'clinic_opb',label:' No Findings'},{value:'CMD_Kurzbefund_lt2',label:' CMD (Yes)'},{value:'CMD_Kurzbefund_gt2',label:' CMD (No)'},{value:'parodontitis',label:'PSI >3 (Periodontitis)'},{value:'WKB_unabgeschlossen',label:'Root canal treatment needed or not finished'},{value:'other',label:'Other (write in general comments)'}];var ToothCell=function ToothCell(_ref){var position=_ref.position,_ref$teethIndication=_ref.teethIndication,teethIndication=_ref$teethIndication===undefined?{}:_ref$teethIndication,readOnly=_ref.readOnly,changeToothIndication=_ref.changeToothIndication;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'teeth-cell-'+position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{addEmpty:true,readOnly:readOnly,object:Object.assign({},teethIndication),onChange:changeToothIndication,valueList:TOOTH_INDICATION,name:position}));};var InfoLegend=function InfoLegend(_ref2){var isInfoLegendShown=_ref2.isInfoLegendShown,toggleInfoLegend=_ref2.toggleInfoLegend;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){toggleInfoLegend();},className:' btn-primary btn-md info-button'},'i'),isInfoLegendShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext teethLegend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'i = Implant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'v = Veneer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'c = Caries'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'b = Bridge or blocked crowns'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'m = Milk tooth'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' x = missing')));};var AlignerTreatmentPhysicianAssessment=function AlignerTreatmentPhysicianAssessment(_ref3){var anamnesis=_ref3.anamnesis,error=_ref3.error,readOnly=_ref3.readOnly,udpateAnamnesis=_ref3.udpateAnamnesis,saveAnamnesis=_ref3.saveAnamnesis,isInfoLegendShown=_ref3.isInfoLegendShown,toggleInfoLegend=_ref3.toggleInfoLegend;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object.assign({},anamnesis.formData)),_useState2=_slicedToArray(_useState,2),form=_useState2[0],setForm=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),editing=_useState4[0],setEditing=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),loading=_useState6[0],setLoading=_useState6[1];var saveChanges=function saveChanges(){setEditing(false);setLoading(true);udpateAnamnesis(form,anamnesis.templateKey);saveAnamnesis(anamnesis.templateKey);setLoading(false);};var cancelEditing=function cancelEditing(){setEditing(false);setForm(Object.assign({},anamnesis.formData));};var changeFormData=function changeFormData(name,value){setForm(Object.assign({},form,_defineProperty({},name,value)));};if(!form){return null;}var changeToothIndication=function changeToothIndication(name,value){setForm(Object.assign({},form,{teethIndication:Object.assign({},form.teethIndication,_defineProperty({},name,value))}));};var TeethRow=function TeethRow(_ref4){var upperTeeth=_ref4.upperTeeth,lowerTeeth=_ref4.lowerTeeth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,upperTeeth&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,upperTeeth.map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:position},position);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,(upperTeeth||lowerTeeth).map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToothCell,{key:position,changeToothIndication:changeToothIndication,readOnly:!editing||readOnly,teethIndication:form.teethIndication,position:position});})),lowerTeeth&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,lowerTeeth.map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:position},position);})));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger',role:'alert'},error.messgage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{layer:'md',size:8},anamnesis.createdByUser||'',' ',Object(__WEBPACK_IMPORTED_MODULE_9__util_datetime__["c" /* formatDateTime */])(anamnesis.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{layer:'md',size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},!editing&&!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return setEditing(true);},className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})),editing&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:cancelEditing,className:'btn',disabled:loading,style:{marginLeft:'5px'}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:saveChanges,className:'btn btn-primary',disabled:loading,type:'submit',style:{marginLeft:'5px'}},'Save'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{layer:'md',size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoLegend,{isInfoLegendShown:isInfoLegendShown,toggleInfoLegend:toggleInfoLegend}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M',className:'teeth-table-whole-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:6,layer:'lg',className:'no-padding teeth-table-right-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'teeth-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{upperTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["o" /* UPPER_TEETH_FIRST_HALF */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{lowerTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["j" /* LOWER_TEETH_FIRST_HALF */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'teeth-table-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-table-divider-horizontal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:6,layer:'lg',className:'no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'teeth-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{upperTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["q" /* UPPER_TEETH_SECOND_HALF */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{lowerTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["l" /* LOWER_TEETH_SECOND_HALF */]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Findings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_SelectChip__["a" /* default */],{object:form,name:'additionalIndication',readOnly:!editing||readOnly,addEmpty:true,valueList:ADDITIONAL_INDICATION,onChange:changeFormData})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Patients wishes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__["a" /* default */],{name:'treatmentExpectation',object:form,onChange:changeFormData,className:'textarea-treatment-expectation',readOnly:!editing||readOnly})))));};/* harmony default export */ __webpack_exports__["a"] = (AlignerTreatmentPhysicianAssessment);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Finding=function Finding(_ref){var options=_ref.options,anamnesis=_ref.anamnesis,saveAnamnesis=_ref.saveAnamnesis,changeAnamnesis=_ref.changeAnamnesis;var changeFormData=function changeFormData(name,value){changeAnamnesis('formData',Object.assign({},anamnesis.formData,_defineProperty({},name,value)),anamnesis.templateKey);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,options.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},option.subCategory,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{key:option.subCategory+i,top:'L'},option.findings.map(function(finding,index){var isFindingChecked=anamnesis.formData[finding.name]&&anamnesis.formData[finding.name]===true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{key:option.keyPrefix+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Checkbox__["a" /* default */],{key:option.keyPrefix+index,onChange:function onChange(){changeFormData(finding.name,!isFindingChecked);saveAnamnesis(anamnesis.templateKey);},name:'isFindingChecked',object:{isFindingChecked:isFindingChecked}},finding.label));})));}));};var ZAHNBEZOGEN=[{label:'Parodontitis',name:'zahnbezogenParodontitis'},{label:'Endodontisches Problem',name:'zahnbezogenEndodontischesProblem'},{label:'Trauma',name:'zahnbezogenTrauma'}];var AESTHETISCHE_ERWARTUNG=[{label:'hoch',name:'aesthetischeErwartungHoch'},{label:'mittel',name:'aesthetischeErwartungMittel'},{label:'niedrig',name:'aesthetischeErwartungNiedrig'}];var RESTAURATION=[{label:'Einzelzahnversorgung',name:'restaurationEinzelzahnversorgung'},{label:'Mehrfachversorgung',name:'restaurationMehrfachversorgung'},{label:'zementiert',name:'restaurationZementiert'},{label:'verschraubt',name:'restaurationVerschraubt'},{label:'PV gewünscht',name:'restaurationPVgewünscht'}];var DICKE_DES_ALVEOLARKAMMS=[{label:'dünn',name:'dickeDesAlveolarkammsDuenn'},{label:'breit',name:'dickeDesAlveolarkammsBreit'},{label:'c4',name:'dickeDesAlveolarkammsC4'}];var BEFESTIGTE_GINGIVA=[{label:'dünn',name:'befestigteGingivaDuenn'},{label:'dick',name:'befestigteGingivaDick'}];var PALPATION=[{label:'gut',name:'befestigteGingivaGut'},{label:'mittel',name:'befestigteGingivaMittel'},{label:'unzureichend',name:'befestigteGingivaUnzureichend'}];var PRAEIMPLANTARE_VORBEHANDLUNG=[{label:'Prämedikation (bitte ins Kommentarfeld schreiben)',name:'praeimplantaereVorbehandlungPraemedikation'},{label:'Weichgewebsmanagement',name:'praeimplantaereVorbehandlungWeichgewebsmanagement'}];var KNOCHENMANAGEMENT=[{label:'Augmentation',name:'knochenmanagementAugmentation'},{label:'Sinuslift',name:'knochenmanagementSinuslift'},{label:'Membran',name:'knochenmanagementMembran'},{label:'GBR',name:'knochenmanagementGBR'}];var MUNDOEFFNUNG=[{label:'<2 Finger',name:'mundoeffnungL2finger'},{label:'>2 Finger',name:'mundoeffnungM2finger'},{label:'>3 Finger',name:'mundoeffnungM3finger'}];var IMPLANTATSYSTEM=[{label:'MIS',name:'implantatsystemMIS'},{label:'Camlog',name:'implantatsystemCamlog'},{label:'Conelog',name:'implantatsystemConelog'},{label:'Straumann',name:'implantatsystemStraumann'},{label:'ICX',name:'implantatsystemICX'},{label:'other (bitte ins Kommentarfeld schreiben)',name:'implantatsystemOther'}];var FINDINGS=[{category:'Zahnbezogen',options:[{subCategory:"",keyPrefix:'zahnbezogen',findings:ZAHNBEZOGEN}]},{category:'Ästhetische Erwartung',options:[{subCategory:"",keyPrefix:'aesthetischeErwartung',findings:AESTHETISCHE_ERWARTUNG}]},{category:'Restauration',options:[{subCategory:"",keyPrefix:'restauration',findings:RESTAURATION}]},{category:'Knochenvolumen',options:[{subCategory:"Dicke des Alveolarkamms",keyPrefix:'dickeDesAlveolarkamms',findings:DICKE_DES_ALVEOLARKAMMS},{subCategory:"Befestigte Gingiva",keyPrefix:'befestigteGingiva',findings:BEFESTIGTE_GINGIVA},{subCategory:"Palpation",keyPrefix:'palpation',findings:PALPATION}]},{category:'Präimplantäre Vorbehandlung',options:[{subCategory:"",keyPrefix:'praeimplantaereVorbehandlung',findings:PRAEIMPLANTARE_VORBEHANDLUNG}]},{category:'Präimplantäre Vorbehandlung',options:[{subCategory:"Knochenmanagement",keyPrefix:'knochenmanagement',findings:KNOCHENMANAGEMENT}]},{category:'Mundöffnung',options:[{subCategory:"",keyPrefix:'mundoeffnung',findings:MUNDOEFFNUNG}]},{category:'Implantatsystem',options:[{subCategory:"",keyPrefix:'implantatsystem',findings:IMPLANTATSYSTEM}]}];var ImplantConsultationAndFindings=function ImplantConsultationAndFindings(_ref2){var props=_objectWithoutProperties(_ref2,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'findings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],null,FINDINGS.map(function(finding,i){var findingProps=Object.assign({},props,{options:finding.options});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:finding.category+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'L'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,finding.category)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Finding,Object.assign({key:finding.category+i},findingProps)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})));};/* harmony default export */ __webpack_exports__["a"] = (ImplantConsultationAndFindings);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
var AlignerTreatmentMedical=function AlignerTreatmentMedical(_ref){var anamnesis=_ref.anamnesis;if(!anamnesis.formData){return null;}var keyList=Object.getOwnPropertyNames(anamnesis.formData);var renderValue=function renderValue(key){var value=anamnesis.formData[key];if(value===undefined||value===null){return'';}if(value===false){return'no';}if(value===true){return'yes';}if(value.join){return value.map(function(answer,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},answer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));});}return value;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'customer-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Answer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,keyList.map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'key'},key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'value'},renderValue(key)));})))));};/* harmony default export */ __webpack_exports__["a"] = (AlignerTreatmentMedical);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export valueList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(191);
var valueList=[{value:'straighter_teeth',label:'Straighter teeth'},{value:'improve_esthetics',label:'Improve esthetics'},{value:'solve_anterior_crowding',label:'Solve anterior crowding'},{value:'solve_anterior_spacing',label:'Solve anterior spacing'},{value:'diastema_closure',label:'Diastema Closure'},{value:'gap_closure',label:'Gap closure'},{value:'midline_correction',label:'Midline correction'},{value:'overbite_correction',label:'Overbite correction'},{value:'openbite_correction',label:'Openbite correction'},{value:'anterior_crossbite_correction',label:'Anterior crossbite correction'}];var AlignerTreatmentExpectation=function AlignerTreatmentExpectation(_ref){var anamnesis=_ref.anamnesis;if(!anamnesis.formData){return null;}var keyList=Object.keys(anamnesis.formData);var renderValue=function renderValue(key){var value=anamnesis.formData[key];if(value===true){return'yes';}if(value===false){return'no';}return value;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'customer-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Answer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,keyList.map(function(key){return key==='medicalAssesment'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'key'},key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'value'},renderValue(key)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Medical Assessment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{isMulti:true,isDisabled:true,defaultValue:anamnesis.formData.medicalAssesment||[],onChange:function onChange(){},options:valueList,classNamePrefix:'sunshine-multi-select'})))))));};/* harmony default export */ __webpack_exports__["a"] = (AlignerTreatmentExpectation);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_SelectChip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__ = __webpack_require__(21);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var TOOTH_INDICATION=['b','f','i','ix','k','kw','sw','x',')(','S'].map(function(indication){return{id:indication,value:indication};});var ADDITIONAL_INDICATION=[{value:'clinic_opb',label:' No Findings'},{value:'CMD_Kurzbefund_lt2',label:' CMD (Yes)'},{value:'CMD_Kurzbefund_gt2',label:' CMD (No)'},{value:'parodontitis',label:'PSI >3 (Periodontitis)'},{value:'WKB_unabgeschlossen',label:'Root canal treatment needed or not finished'},{value:'other',label:'Other (write in general comments)'}];var EditTreatmentExpectationButton=function EditTreatmentExpectationButton(_ref){var toggleEditingTreatmentExpectation=_ref.toggleEditingTreatmentExpectation,isEditingTreatmentExpectation=_ref.isEditingTreatmentExpectation,readOnly=_ref.readOnly,saveAnamnesis=_ref.saveAnamnesis,anamnesis=_ref.anamnesis;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-md ',onClick:function onClick(){if(readOnly){return;}if(isEditingTreatmentExpectation){saveAnamnesis(anamnesis.templateKey);}toggleEditingTreatmentExpectation();}},isEditingTreatmentExpectation?'Save Comment':'Edit Comment');};var ToothCell=function ToothCell(_ref2){var position=_ref2.position,_ref2$teethIndication=_ref2.teethIndication,teethIndication=_ref2$teethIndication===undefined?{}:_ref2$teethIndication,readOnly=_ref2.readOnly,changeToothIndication=_ref2.changeToothIndication;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'teeth-cell-'+position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Select__["a" /* default */],{addEmpty:true,readOnly:readOnly,object:teethIndication,onChange:changeToothIndication,valueList:TOOTH_INDICATION,name:position}));};var InfoLegendDiv=function InfoLegendDiv(_ref3){var children=_ref3.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-legend-div'},children);};var InfoLegend=function InfoLegend(_ref4){var isInfoLegendShown=_ref4.isInfoLegendShown,toggleInfoLegend=_ref4.toggleInfoLegend;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){toggleInfoLegend();},className:' btn-primary btn-md info-button'},'i'),isInfoLegendShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext teethLegend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'b = Br\xFCckenglied'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'f = fehlender Zahn'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'i = Implantat mit intakter Suprakonstruktion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'ix = zu entfernendes Implantat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'k = klinisch intakte Krone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'kw = erneuerungsbed\xFCrftige Krone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'sw = erneuerungsbed\xFCrftige Suprakonstruktion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'x = nicht erhaltungsw\xFCrdiger Zahn'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,')( = L\xFCckenschluss'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'S = Implantatgetragene Suprakonstruktion geplant')));};var ImplantTreatmentPhysicianAssessment=function ImplantTreatmentPhysicianAssessment(_ref5){var anamnesis=_ref5.anamnesis,readOnly=_ref5.readOnly,changeAnamnesis=_ref5.changeAnamnesis,saveAnamnesis=_ref5.saveAnamnesis,toggleEditingTreatmentExpectation=_ref5.toggleEditingTreatmentExpectation,isEditingTreatmentExpectation=_ref5.isEditingTreatmentExpectation,isInfoLegendShown=_ref5.isInfoLegendShown,toggleInfoLegend=_ref5.toggleInfoLegend;var changeAndSaveFormData=function changeAndSaveFormData(formData){changeAnamnesis('formData',formData,anamnesis.templateKey);saveAnamnesis(anamnesis.templateKey);};var changeFormData=function changeFormData(name,value){changeAndSaveFormData(Object.assign({},anamnesis.formData,_defineProperty({},name,value)));};if(!anamnesis.formData){return null;}var changeToothIndication=function changeToothIndication(name,value){changeAndSaveFormData(Object.assign({},anamnesis.formData,{teethIndication:Object.assign({},anamnesis.formData.teethIndication,_defineProperty({},name,value))}));};var TeethRow=function TeethRow(_ref6){var upperTeeth=_ref6.upperTeeth,lowerTeeth=_ref6.lowerTeeth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,upperTeeth&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,upperTeeth.map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:position},position);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,(upperTeeth||lowerTeeth).map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToothCell,{key:position,changeToothIndication:changeToothIndication,readOnly:readOnly,teethIndication:anamnesis.formData.teethIndication,position:position});})),lowerTeeth&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,lowerTeeth.map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:position},position);})));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoLegendDiv,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoLegend,{isInfoLegendShown:isInfoLegendShown,toggleInfoLegend:toggleInfoLegend})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M',className:'teeth-table-whole-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:6,layer:'lg',className:'no-padding teeth-table-right-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'teeth-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{upperTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["o" /* UPPER_TEETH_FIRST_HALF */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{lowerTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["j" /* LOWER_TEETH_FIRST_HALF */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'teeth-table-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-table-divider-horizontal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:6,layer:'lg',className:'no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'teeth-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{upperTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["q" /* UPPER_TEETH_SECOND_HALF */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethRow,{lowerTeeth:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_const__["l" /* LOWER_TEETH_SECOND_HALF */]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Findings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_SelectChip__["a" /* default */],{object:anamnesis.formData,name:'additionalIndication',readOnly:readOnly,addEmpty:true,valueList:ADDITIONAL_INDICATION,onChange:changeFormData})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Patients wishes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__["a" /* default */],{name:'treatmentExpectation',object:anamnesis.formData,onChange:function onChange(name,value){changeAnamnesis('formData',Object.assign({},anamnesis.formData,_defineProperty({},name,value)),anamnesis.templateKey);},className:'textarea-treatment-expectation',readOnly:!isEditingTreatmentExpectation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditTreatmentExpectationButton,{toggleEditingTreatmentExpectation:toggleEditingTreatmentExpectation,isEditingTreatmentExpectation:isEditingTreatmentExpectation,readOnly:readOnly,saveAnamnesis:saveAnamnesis,anamnesis:anamnesis}))));};/* harmony default export */ __webpack_exports__["a"] = (ImplantTreatmentPhysicianAssessment);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_Radio__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBoxBody__ = __webpack_require__(84);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ANASTHESIE=[{label:'Infiltrationsanästhesie',name:'anasthesieInfiltrationsanaesthesie'},{label:'Leitungsanästhesie',name:'anasthesieLeitungsanaesthesie'}];var ANZAHL_DER_AMPULLEN=[{label:'1',name:'anzahlDerAmpullen'},{label:'2',name:'anzahlDerAmpullen'},{label:'3',name:'anzahlDerAmpullen'},{label:'4',name:'anzahlDerAmpullen'},{label:'5',name:'anzahlDerAmpullen'}];var VOLLNARKOSE=[{label:'ja',name:'vollnarkose'},{label:'nein',name:'vollnarkose'}];var INZISION=[{label:'Flapless',name:'inzisionFlapless'},{label:'Spaltlappen',name:'inzisionSpaltlappen'},{label:'Volllappen',name:'inzisionVolllappen'}];var CHIRURGISCHER_EINGRIFF=[{label:'Einzeitiges Verfahren',name:'chirurgischerEingriffEinzeitigesVerfahren'},{label:'Zweizeitiges Verfahren (bitte Datum ins Kommentarfeld angeben)',name:'chirurgischerEingriffZweizeitigesVerfahren'},{label:'Geführte Chirurgie',name:'chirurgischerEingriffGefuehrteChirurgie'},{label:'Sofortbelastung',name:'chirurgischerEingriffSofortbelastung'},{label:'Zeitversetzte Belastung',name:'chirurgischerEingriffZeitversetzteBelastung'}];var POSTOPERATIVES_ROENTGEN=[{label:'ja',name:'postoperativesRoentgen'},{label:'nein',name:'postoperativesRoentgen'}];var KONTROLLE=[{label:'7 Tage',name:'kontrolle7Tage'},{label:'14 Tage',name:'kontrolle14Tage'},{label:'3 Monate',name:'kontrolle3Monate'},{label:'6 Monate',name:'kontrolle6Monate'},{label:'1 Jahr',name:'kontrolle1Jahr'},{label:'2 Jahre',name:'kontrolle2Jahre'}];var ImplantSurgeryDocumentation=function ImplantSurgeryDocumentation(props){var anamnesis=props.anamnesis,changeAnamnesis=props.changeAnamnesis,saveAnamnesis=props.saveAnamnesis;var changeFormData=function changeFormData(name,value){changeAnamnesis('formData',Object.assign({},anamnesis.formData,_defineProperty({},name,value)),anamnesis.templateKey);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'surgeryDocumentation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBoxBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'An\xE4sthesie')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},ANASTHESIE.map(function(documentation,index){var isChecked=anamnesis.formData[documentation.name]&&anamnesis.formData[documentation.name]===true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,!isChecked);saveAnamnesis(anamnesis.templateKey);},name:'isChecked',object:{isChecked:isChecked}},documentation.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Anzahl der Ampullen',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},ANZAHL_DER_AMPULLEN.map(function(documentation,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Radio__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,documentation.label);saveAnamnesis(anamnesis.templateKey);},value:documentation.label,name:documentation.name,object:anamnesis.formData},documentation.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Vollnarkose',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},VOLLNARKOSE.map(function(documentation,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Radio__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,documentation.label);saveAnamnesis(anamnesis.templateKey);},value:documentation.label,name:documentation.name,object:anamnesis.formData},documentation.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Inzision')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},INZISION.map(function(documentation,index){var isChecked=anamnesis.formData[documentation.name]&&anamnesis.formData[documentation.name]===true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,!isChecked);saveAnamnesis(anamnesis.templateKey);},name:'isChecked',object:{isChecked:isChecked}},documentation.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Chirurgischer Eingriff')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},CHIRURGISCHER_EINGRIFF.map(function(documentation,index){var isChecked=anamnesis.formData[documentation.name]&&anamnesis.formData[documentation.name]===true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,!isChecked);saveAnamnesis(anamnesis.templateKey);},name:'isChecked',object:{isChecked:isChecked}},documentation.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Postoperatives R\xF6ntgen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},POSTOPERATIVES_ROENTGEN.map(function(documentation,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_Radio__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,documentation.label);saveAnamnesis(anamnesis.templateKey);},value:documentation.label,name:documentation.name,object:anamnesis.formData},documentation.label));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Kontrolle und Nachsorge der Implantatbehandlung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],{top:'S'},KONTROLLE.map(function(documentation,index){var isChecked=anamnesis.formData[documentation.name]&&anamnesis.formData[documentation.name]===true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{key:documentation.name+index,size:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:'field-'+documentation.name+index,onChange:function onChange(){changeFormData(documentation.name,!isChecked);saveAnamnesis(anamnesis.templateKey);},name:'isChecked',object:{isChecked:isChecked}},documentation.label));})))));};/* harmony default export */ __webpack_exports__["a"] = (ImplantSurgeryDocumentation);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Select__ = __webpack_require__(16);
var IPRInstruction=function IPRInstruction(_ref){var iprInstructionList=_ref.iprInstructionList,position=_ref.position,readOnly=_ref.readOnly,changeIPRInstruction=_ref.changeIPRInstruction;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-in-between-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Select__["a" /* default */],{object:iprInstructionList,readOnly:readOnly,onChange:function onChange(name,value){if(!readOnly){changeIPRInstruction(name,value);}},valueList:__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["f" /* IPR_VALUE_LIST */],name:position}));};var IPRInstructionList=function IPRInstructionList(_ref2){var iprInstructionList=_ref2.iprInstructionList,readOnly=_ref2.readOnly,changeIPRInstruction=_ref2.changeIPRInstruction;if(!iprInstructionList){iprInstructionList={};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["n" /* UPPER_TEETH */].map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:position,className:'teeth-label-item'},position);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-in-between-start-end'}),__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["p" /* UPPER_TEETH_IN_BETWEEN */].map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IPRInstruction,{key:position,position:position,readOnly:readOnly,iprInstructionList:iprInstructionList,changeIPRInstruction:changeIPRInstruction});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-in-between-start-end'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-in-between-start-end'}),__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["k" /* LOWER_TEETH_IN_BETWEEN */].map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IPRInstruction,{key:position,position:position,readOnly:readOnly,iprInstructionList:iprInstructionList,changeIPRInstruction:changeIPRInstruction});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teeth-in-between-start-end'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["i" /* LOWER_TEETH */].map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:position,className:'teeth-label-item'},position);})));};IPRInstructionList.propTypes={iprInstructionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeIPRInstruction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (IPRInstructionList);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader__);
var IPR_WANTED_VALUE=[{value:true,label:'Yes, patient agrees to IPR if needed'},{value:false,label:'No, patient does not agree to IPR if needed'}];var WIDGET_TITLE='IPR Patient Agreement';var PatientIPRWishesWidget=function PatientIPRWishesWidget(_ref){var readOnly=_ref.readOnly,isIPRProviderStore=_ref.isIPRProviderStore,anamnesis=_ref.anamnesis,fetching=_ref.fetching,taskName=_ref.taskName,changeAnamnesis=_ref.changeAnamnesis,saveAnamnesis=_ref.saveAnamnesis;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__["M" /* PATIENT_IPR_WISHES_WIDGET */])||!anamnesis){return null;}if(!isIPRProviderStore){if(taskName!=='medical_assessment'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Clinic does not offer IPR'));}return null;}var changeFormData=function changeFormData(value){var payload=Object.assign({},anamnesis.formData,{iprAgreed:value});changeAnamnesis('formData',payload,__WEBPACK_IMPORTED_MODULE_9__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]);saveAnamnesis(__WEBPACK_IMPORTED_MODULE_9__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]);};// prevent crash during data loading
if(fetching&&!readOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading... Please wait.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader___default.a,{loading:fetching}))));}// we use context as object because at the time the widget is used we do not have an anamnesis ready...
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__["a" /* default */],{object:anamnesis.formData,name:'iprAgreed',readOnly:readOnly||fetching,addEmpty:true,valueList:IPR_WANTED_VALUE,onChange:function onChange(name,value){changeFormData(value);}})))));};PatientIPRWishesWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,anamnesis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeAnamnesis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveAnamnesis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isIPRProviderStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,taskName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PatientIPRWishesWidget);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassNames", function() { return ClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Global", function() { return Global; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jsx", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_cache__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__ = __webpack_require__(527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CacheProvider", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeContext", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "__unsafe_useEmotionCache", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useTheme", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withEmotionCache", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_extends__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_weak_memoize__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isolated_hnrs_dist_emotion_react_isolated_hnrs_browser_esm_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_utils__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emotion_serialize__ = __webpack_require__(530);












var pkg = {
	name: "@emotion/react",
	version: "11.8.2",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/babel-plugin": "^11.7.1",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.2",
		"@emotion/utils": "^1.1.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.7.1",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.8.1",
		"@types/react": "^16.9.11",
		dtslint: "^4.2.1",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["i" /* h */].call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = __WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["b" /* E */];
  createElementArgArray[1] = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["g" /* c */])(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(null, createElementArgArray);
};

var useInsertionEffect = __WEBPACK_IMPORTED_MODULE_0_react__['useInsertion' + 'Effect'] ? __WEBPACK_IMPORTED_MODULE_0_react__['useInsertion' + 'Effect'] : __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"];
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["k" /* w */])(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = Object(__WEBPACK_IMPORTED_MODULE_8__emotion_serialize__["a" /* serializeStyles */])([styles], undefined, Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["c" /* T */]));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  useInsertionEffect(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["b" /* insertStyles */])(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {
  Global.displayName = 'EmotionGlobal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_8__emotion_serialize__["a" /* serializeStyles */])(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["j" /* u */])(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["b" /* insertStyles */])(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["k" /* w */])(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_8__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["c" /* registerStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__emotion_element_cbed451f_browser_esm_js__["c" /* T */])
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (false) {
  ClassNames.displayName = 'EmotionClassNames';
}

if (false) {
  var isBrowser = "object" !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';

  if (isBrowser && !isJest) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}




/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();




/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHARSET */
/* unused harmony export COMMENT */
/* unused harmony export COUNTER_STYLE */
/* unused harmony export DECLARATION */
/* unused harmony export DOCUMENT */
/* unused harmony export FONT_FACE */
/* unused harmony export FONT_FEATURE_VALUES */
/* unused harmony export IMPORT */
/* unused harmony export KEYFRAMES */
/* unused harmony export MEDIA */
/* unused harmony export MOZ */
/* unused harmony export MS */
/* unused harmony export NAMESPACE */
/* unused harmony export PAGE */
/* unused harmony export RULESET */
/* unused harmony export SUPPORTS */
/* unused harmony export VIEWPORT */
/* unused harmony export WEBKIT */
/* unused harmony export abs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return U; });
/* unused harmony export append */
/* unused harmony export assign */
/* unused harmony export caret */
/* unused harmony export char */
/* unused harmony export character */
/* unused harmony export characters */
/* unused harmony export charat */
/* unused harmony export column */
/* unused harmony export combine */
/* unused harmony export comment */
/* unused harmony export commenter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ce; });
/* unused harmony export copy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return V; });
/* unused harmony export declaration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return W; });
/* unused harmony export delimiter */
/* unused harmony export escaping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return d; });
/* unused harmony export hash */
/* unused harmony export identifier */
/* unused harmony export indexof */
/* unused harmony export length */
/* unused harmony export line */
/* unused harmony export match */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return le; });
/* unused harmony export namespace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return N; });
/* unused harmony export node */
/* unused harmony export parse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return P; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return F; });
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return he; });
/* unused harmony export prev */
/* unused harmony export replace */
/* unused harmony export ruleset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fe; });
/* unused harmony export sizeof */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return R; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return oe; });
/* unused harmony export strlen */
/* unused harmony export substr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return T; });
/* unused harmony export tokenize */
/* unused harmony export tokenizer */
/* unused harmony export trim */
/* unused harmony export whitespace */
var e="-ms-";var r="-moz-";var a="-webkit-";var c="comm";var n="rule";var t="decl";var s="@page";var u="@media";var i="@import";var f="@charset";var o="@viewport";var l="@supports";var v="@document";var h="@namespace";var p="@keyframes";var b="@font-face";var w="@counter-style";var $="@font-feature-values";var k=Math.abs;var d=String.fromCharCode;var g=Object.assign;function m(e,r){return(((r<<2^z(e,0))<<2^z(e,1))<<2^z(e,2))<<2^z(e,3)}function x(e){return e.trim()}function y(e,r){return(e=r.exec(e))?e[0]:e}function j(e,r,a){return e.replace(r,a)}function C(e,r){return e.indexOf(r)}function z(e,r){return e.charCodeAt(r)|0}function A(e,r,a){return e.slice(r,a)}function O(e){return e.length}function M(e){return e.length}function S(e,r){return r.push(e),e}function q(e,r){return e.map(r).join("")}var B=1;var D=1;var E=0;var F=0;var G=0;var H="";function I(e,r,a,c,n,t,s){return{value:e,root:r,parent:a,type:c,props:n,children:t,line:B,column:D,length:s,return:""}}function J(e,r){return g(I("",null,null,"",null,null,0),e,{length:-e.length},r)}function K(){return G}function L(){G=F>0?z(H,--F):0;if(D--,G===10)D=1,B--;return G}function N(){G=F<E?z(H,F++):0;if(D++,G===10)D=1,B++;return G}function P(){return z(H,F)}function Q(){return F}function R(e,r){return A(H,e,r)}function T(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function U(e){return B=D=1,E=O(H=e),F=0,[]}function V(e){return H="",e}function W(e){return x(R(F-1,ee(e===91?e+2:e===40?e+1:e)))}function X(e){return V(Z(U(e)))}function Y(e){while(G=P())if(G<33)N();else break;return T(e)>2||T(G)>3?"":" "}function Z(e){while(N())switch(T(G)){case 0:S(ae(F-1),e);break;case 2:S(W(G),e);break;default:S(d(G),e)}return e}function _(e,r){while(--r&&N())if(G<48||G>102||G>57&&G<65||G>70&&G<97)break;return R(e,Q()+(r<6&&P()==32&&N()==32))}function ee(e){while(N())switch(G){case e:return F;case 34:case 39:if(e!==34&&e!==39)ee(G);break;case 40:if(e===41)ee(e);break;case 92:N();break}return F}function re(e,r){while(N())if(e+G===47+10)break;else if(e+G===42+42&&P()===47)break;return"/*"+R(r,F-1)+"*"+d(e===47?e:N())}function ae(e){while(!T(P()))N();return R(e,F)}function ce(e){return V(ne("",null,null,null,[""],e=U(e),0,[0],e))}function ne(e,r,a,c,n,t,s,u,i){var f=0;var o=0;var l=s;var v=0;var h=0;var p=0;var b=1;var w=1;var $=1;var k=0;var g="";var m=n;var x=t;var y=c;var z=g;while(w)switch(p=k,k=N()){case 40:if(p!=108&&z.charCodeAt(l-1)==58){if(C(z+=j(W(k),"&","&\f"),"&\f")!=-1)$=-1;break}case 34:case 39:case 91:z+=W(k);break;case 9:case 10:case 13:case 32:z+=Y(p);break;case 92:z+=_(Q()-1,7);continue;case 47:switch(P()){case 42:case 47:S(se(re(N(),Q()),r,a),i);break;default:z+="/"}break;case 123*b:u[f++]=O(z)*$;case 125*b:case 59:case 0:switch(k){case 0:case 125:w=0;case 59+o:if(h>0&&O(z)-l)S(h>32?ue(z+";",c,a,l-1):ue(j(z," ","")+";",c,a,l-2),i);break;case 59:z+=";";default:S(y=te(z,r,a,f,o,n,u,g,m=[],x=[],l),t);if(k===123)if(o===0)ne(z,r,y,y,m,t,l,u,x);else switch(v){case 100:case 109:case 115:ne(e,y,y,c&&S(te(e,y,y,0,0,n,u,g,n,m=[],l),x),n,x,l,u,c?m:x);break;default:ne(z,y,y,y,[""],x,0,u,x)}}f=o=h=0,b=$=1,g=z="",l=s;break;case 58:l=1+O(z),h=p;default:if(b<1)if(k==123)--b;else if(k==125&&b++==0&&L()==125)continue;switch(z+=d(k),k*b){case 38:$=o>0?1:(z+="\f",-1);break;case 44:u[f++]=(O(z)-1)*$,$=1;break;case 64:if(P()===45)z+=W(N());v=P(),o=l=O(g=z+=ae(Q())),k++;break;case 45:if(p===45&&O(z)==2)b=0}}return t}function te(e,r,a,c,t,s,u,i,f,o,l){var v=t-1;var h=t===0?s:[""];var p=M(h);for(var b=0,w=0,$=0;b<c;++b)for(var d=0,g=A(e,v+1,v=k(w=u[b])),m=e;d<p;++d)if(m=x(w>0?h[d]+" "+g:j(g,/&\f/g,h[d])))f[$++]=m;return I(e,r,a,t===0?n:i,f,o,l)}function se(e,r,a){return I(e,r,a,c,d(K()),A(e,2,-2),0)}function ue(e,r,a,c){return I(e,r,a,t,A(e,0,c),A(e,c+1,-1),c)}function ie(c,n){switch(m(c,n)){case 5103:return a+"print-"+c+c;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return a+c+c;case 5349:case 4246:case 4810:case 6968:case 2756:return a+c+r+c+e+c+c;case 6828:case 4268:return a+c+e+c+c;case 6165:return a+c+e+"flex-"+c+c;case 5187:return a+c+j(c,/(\w+).+(:[^]+)/,a+"box-$1$2"+e+"flex-$1$2")+c;case 5443:return a+c+e+"flex-item-"+j(c,/flex-|-self/,"")+c;case 4675:return a+c+e+"flex-line-pack"+j(c,/align-content|flex-|-self/,"")+c;case 5548:return a+c+e+j(c,"shrink","negative")+c;case 5292:return a+c+e+j(c,"basis","preferred-size")+c;case 6060:return a+"box-"+j(c,"-grow","")+a+c+e+j(c,"grow","positive")+c;case 4554:return a+j(c,/([^-])(transform)/g,"$1"+a+"$2")+c;case 6187:return j(j(j(c,/(zoom-|grab)/,a+"$1"),/(image-set)/,a+"$1"),c,"")+c;case 5495:case 3959:return j(c,/(image-set\([^]*)/,a+"$1"+"$`$1");case 4968:return j(j(c,/(.+:)(flex-)?(.*)/,a+"box-pack:$3"+e+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+a+c+c;case 4095:case 3583:case 4068:case 2532:return j(c,/(.+)-inline(.+)/,a+"$1$2")+c;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(O(c)-1-n>6)switch(z(c,n+1)){case 109:if(z(c,n+4)!==45)break;case 102:return j(c,/(.+:)(.+)-([^]+)/,"$1"+a+"$2-$3"+"$1"+r+(z(c,n+3)==108?"$3":"$2-$3"))+c;case 115:return~C(c,"stretch")?ie(j(c,"stretch","fill-available"),n)+c:c}break;case 4949:if(z(c,n+1)!==115)break;case 6444:switch(z(c,O(c)-3-(~C(c,"!important")&&10))){case 107:return j(c,":",":"+a)+c;case 101:return j(c,/(.+:)([^;!]+)(;|!.+)?/,"$1"+a+(z(c,14)===45?"inline-":"")+"box$3"+"$1"+a+"$2$3"+"$1"+e+"$2box$3")+c}break;case 5936:switch(z(c,n+11)){case 114:return a+c+e+j(c,/[svh]\w+-[tblr]{2}/,"tb")+c;case 108:return a+c+e+j(c,/[svh]\w+-[tblr]{2}/,"tb-rl")+c;case 45:return a+c+e+j(c,/[svh]\w+-[tblr]{2}/,"lr")+c}return a+c+e+c+c}return c}function fe(e,r){var a="";var c=M(e);for(var n=0;n<c;n++)a+=r(e[n],n,e,r)||"";return a}function oe(e,r,a,s){switch(e.type){case i:case t:return e.return=e.return||e.value;case c:return"";case p:return e.return=e.value+"{"+fe(e.children,s)+"}";case n:e.value=e.props.join(",")}return O(a=fe(e.children,s))?e.return=e.value+"{"+a+"}":""}function le(e){var r=M(e);return function(a,c,n,t){var s="";for(var u=0;u<r;u++)s+=e[u](a,c,n,t)||"";return s}}function ve(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function he(c,s,u,i){if(c.length>-1)if(!c.return)switch(c.type){case t:c.return=ie(c.value,c.length);break;case p:return fe([J(c,{value:j(c.value,"@","@"+a)})],i);case n:if(c.length)return q(c.props,(function(n){switch(y(n,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return fe([J(c,{props:[j(n,/:(read-\w+)/,":"+r+"$1")]})],i);case"::placeholder":return fe([J(c,{props:[j(n,/:(plac\w+)/,":"+a+"input-$1")]}),J(c,{props:[j(n,/:(plac\w+)/,":"+r+"$1")]}),J(c,{props:[j(n,/:(plac\w+)/,e+"input-$1")]})],i)}return""}))}}function pe(e){switch(e.type){case n:e.props=e.props.map((function(r){return q(X(r),(function(r,a,c){switch(z(r,0)){case 12:return A(r,1,O(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(c[++a]==="global")c[a]="",c[++a]="\f"+A(c[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return M(c)>1?"":r;case a=M(c)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}
//# sourceMappingURL=stylis.mjs.map


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (memoize);


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(1251), exports);
__exportStar(__webpack_require__(1252), exports);
__exportStar(__webpack_require__(1253), exports);


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.heightWidthRadiusDefaults = exports.heightWidthDefaults = exports.sizeMarginDefaults = exports.sizeDefaults = void 0;
/*
 * DefaultProps object for different loaders
 */
var commonValues = {
    loading: true,
    color: "#000000",
    css: "",
    speedMultiplier: 1
};
function sizeDefaults(sizeValue) {
    return Object.assign({}, commonValues, { size: sizeValue });
}
exports.sizeDefaults = sizeDefaults;
function sizeMarginDefaults(sizeValue) {
    return Object.assign({}, sizeDefaults(sizeValue), {
        margin: 2
    });
}
exports.sizeMarginDefaults = sizeMarginDefaults;
function heightWidthDefaults(height, width) {
    return Object.assign({}, commonValues, {
        height: height,
        width: width
    });
}
exports.heightWidthDefaults = heightWidthDefaults;
function heightWidthRadiusDefaults(height, width, radius) {
    if (radius === void 0) { radius = 2; }
    return Object.assign({}, heightWidthDefaults(height, width), {
        radius: radius,
        margin: 2
    });
}
exports.heightWidthRadiusDefaults = heightWidthRadiusDefaults;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRgba = void 0;
var BasicColors;
(function (BasicColors) {
    BasicColors["maroon"] = "#800000";
    BasicColors["red"] = "#FF0000";
    BasicColors["orange"] = "#FFA500";
    BasicColors["yellow"] = "#FFFF00";
    BasicColors["olive"] = "#808000";
    BasicColors["green"] = "#008000";
    BasicColors["purple"] = "#800080";
    BasicColors["fuchsia"] = "#FF00FF";
    BasicColors["lime"] = "#00FF00";
    BasicColors["teal"] = "#008080";
    BasicColors["aqua"] = "#00FFFF";
    BasicColors["blue"] = "#0000FF";
    BasicColors["navy"] = "#000080";
    BasicColors["black"] = "#000000";
    BasicColors["gray"] = "#808080";
    BasicColors["silver"] = "#C0C0C0";
    BasicColors["white"] = "#FFFFFF";
})(BasicColors || (BasicColors = {}));
var calculateRgba = function (color, opacity) {
    if (Object.keys(BasicColors).includes(color)) {
        color = BasicColors[color];
    }
    if (color[0] === "#") {
        color = color.slice(1);
    }
    if (color.length === 3) {
        var res_1 = "";
        color.split("").forEach(function (c) {
            res_1 += c;
            res_1 += c;
        });
        color = res_1;
    }
    var rgbValues = (color.match(/.{2}/g) || [])
        .map(function (hex) { return parseInt(hex, 16); })
        .join(", ");
    return "rgba(" + rgbValues + ", " + opacity + ")";
};
exports.calculateRgba = calculateRgba;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.cssValue = exports.parseLengthAndUnit = void 0;
var cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */
function parseLengthAndUnit(size) {
    if (typeof size === "number") {
        return {
            value: size,
            unit: "px"
        };
    }
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) {
        value = parseFloat(valueString);
    }
    else {
        value = parseInt(valueString, 10);
    }
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if (cssUnit[unit]) {
        return {
            value: value,
            unit: unit
        };
    }
    console.warn("React Spinners: " + size + " is not a valid css value. Defaulting to " + value + "px.");
    return {
        value: value,
        unit: "px"
    };
}
exports.parseLengthAndUnit = parseLengthAndUnit;
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */
function cssValue(value) {
    var lengthWithunit = parseLengthAndUnit(value);
    return "" + lengthWithunit.value + lengthWithunit.unit;
}
exports.cssValue = cssValue;


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_VersionedImageListContainer__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_const__ = __webpack_require__(40);
var TabPhotos=function TabPhotos(props){var tab=props.tab,customer=props.customer;if(tab!==__WEBPACK_IMPORTED_MODULE_3__state_detail_const__["m" /* TAB_PHOTOS */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__image_VersionedImageListContainer__["a" /* default */],{customerId:customer.id}));};TabPhotos.propTypes={tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TabPhotos);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VersionedImageList__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state,props){return{canSeeImages:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["d" /* selectCanSeeImages */])(state),imageVersionList:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["c" /* selectOrderedImageVersionList */](state),showImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["f" /* selectShowImages */](state),showDeleteImage:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["j" /* selectIsCustomerServiceTeamLead */])(state)};};var mapDispatchToProps={findImageVersion:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["b" /* findImageVersion */],uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["m" /* uploadCustomerImage */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["g" /* rotateCustomerImage */],toggleImageView:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["l" /* toggleImageView */],setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["i" /* setImageTypeMetaData */],deleteCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["a" /* deleteCustomerImage */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__VersionedImageList__["a" /* default */]));

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Browser Image Compression
 * v1.0.14
 * by Donald <donaldcwl@gmail.com>
 * https://github.com/Donaldcwl/browser-image-compression
 */

function _defineProperty(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function ownKeys(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);r&&(a=a.filter((function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable}))),t.push.apply(t,a)}return t}function _objectSpread2(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys(Object(t),!0).forEach((function(r){_defineProperty(e,r,t[r])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys(Object(t)).forEach((function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r))}))}return e}function _slicedToArray(e,r){return _arrayWithHoles(e)||_iterableToArrayLimit(e,r)||_unsupportedIterableToArray(e,r)||_nonIterableRest()}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _iterableToArrayLimit(e,r){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var t=[],a=!0,i=!1,f=void 0;try{for(var c,s=e[Symbol.iterator]();!(a=(c=s.next()).done)&&(t.push(c.value),!r||t.length!==r);a=!0);}catch(e){i=!0,f=e}finally{try{a||null==s.return||s.return()}finally{if(i)throw f}}return t}}function _unsupportedIterableToArray(e,r){if(e){if("string"==typeof e)return _arrayLikeToArray(e,r);var t=Object.prototype.toString.call(e).slice(8,-1);return"Object"===t&&e.constructor&&(t=e.constructor.name),"Map"===t||"Set"===t?Array.from(e):"Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)?_arrayLikeToArray(e,r):void 0}}function _arrayLikeToArray(e,r){(null==r||r>e.length)&&(r=e.length);for(var t=0,a=new Array(r);t<r;t++)a[t]=e[t];return a}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function createCommonjsModule(e){var r={exports:{}};return e(r,r.exports),r.exports}var UZIP_1=createCommonjsModule((function(e){var r,t,UZIP={};e.exports=UZIP,UZIP.parse=function(e,r){for(var t=UZIP.bin.readUshort,a=UZIP.bin.readUint,i=0,f={},c=new Uint8Array(e),s=c.length-4;101010256!=a(c,s);)s--;i=s;i+=4;var l=t(c,i+=4),u=(t(c,i+=2),a(c,i+=2)),d=a(c,i+=4);i+=4,i=d;for(var h=0;h<l;h++){a(c,i);i+=4,i+=4,i+=4;a(c,i+=4),u=a(c,i+=4);var A=a(c,i+=4),v=t(c,i+=4),p=t(c,i+2),U=t(c,i+4);i+=6;var g=a(c,i+=8);i+=4,i+=v+p+U,UZIP._readLocal(c,g,f,u,A,r)}return f},UZIP._readLocal=function(e,r,t,a,i,f){var c=UZIP.bin.readUshort,s=UZIP.bin.readUint,l=(s(e,r),c(e,r+=4),c(e,r+=2),c(e,r+=2));s(e,r+=2),s(e,r+=4);r+=4;var u=c(e,r+=8),d=c(e,r+=2);r+=2;var h=UZIP.bin.readUTF8(e,r,u);if(r+=u,r+=d,f)t[h]={size:i,csize:a};else{var A=new Uint8Array(e.buffer,r);if(0==l)t[h]=new Uint8Array(A.buffer.slice(r,r+a));else{if(8!=l)throw"unknown compression method: "+l;var v=new Uint8Array(i);UZIP.inflateRaw(A,v),t[h]=v}}},UZIP.inflateRaw=function(e,r){return UZIP.F.inflate(e,r)},UZIP.inflate=function(e,r){e[0],e[1];return UZIP.inflateRaw(new Uint8Array(e.buffer,e.byteOffset+2,e.length-6),r)},UZIP.deflate=function(e,r){null==r&&(r={level:6});var t=0,a=new Uint8Array(50+Math.floor(1.1*e.length));a[t]=120,a[t+1]=156,t+=2,t=UZIP.F.deflateRaw(e,a,t,r.level);var i=UZIP.adler(e,0,e.length);return a[t+0]=i>>>24&255,a[t+1]=i>>>16&255,a[t+2]=i>>>8&255,a[t+3]=i>>>0&255,new Uint8Array(a.buffer,0,t+4)},UZIP.deflateRaw=function(e,r){null==r&&(r={level:6});var t=new Uint8Array(50+Math.floor(1.1*e.length)),a=UZIP.F.deflateRaw(e,t,a,r.level);return new Uint8Array(t.buffer,0,a)},UZIP.encode=function(e,r){null==r&&(r=!1);var t=0,a=UZIP.bin.writeUint,i=UZIP.bin.writeUshort,f={};for(var c in e){var s=!UZIP._noNeed(c)&&!r,l=e[c],u=UZIP.crc.crc(l,0,l.length);f[c]={cpr:s,usize:l.length,crc:u,file:s?UZIP.deflateRaw(l):l}}for(var c in f)t+=f[c].file.length+30+46+2*UZIP.bin.sizeUTF8(c);t+=22;var d=new Uint8Array(t),h=0,A=[];for(var c in f){var v=f[c];A.push(h),h=UZIP._writeHeader(d,h,c,v,0)}var p=0,U=h;for(var c in f){v=f[c];A.push(h),h=UZIP._writeHeader(d,h,c,v,1,A[p++])}var g=h-U;return a(d,h,101010256),h+=4,i(d,h+=4,p),i(d,h+=2,p),a(d,h+=2,g),a(d,h+=4,U),h+=4,h+=2,d.buffer},UZIP._noNeed=function(e){var r=e.split(".").pop().toLowerCase();return-1!="png,jpg,jpeg,zip".indexOf(r)},UZIP._writeHeader=function(e,r,t,a,i,f){var c=UZIP.bin.writeUint,s=UZIP.bin.writeUshort,l=a.file;return c(e,r,0==i?67324752:33639248),r+=4,1==i&&(r+=2),s(e,r,20),s(e,r+=2,0),s(e,r+=2,a.cpr?8:0),c(e,r+=2,0),c(e,r+=4,a.crc),c(e,r+=4,l.length),c(e,r+=4,a.usize),s(e,r+=4,UZIP.bin.sizeUTF8(t)),s(e,r+=2,0),r+=2,1==i&&(r+=2,r+=2,c(e,r+=6,f),r+=4),r+=UZIP.bin.writeUTF8(e,r,t),0==i&&(e.set(l,r),r+=l.length),r},UZIP.crc={table:function(){for(var e=new Uint32Array(256),r=0;r<256;r++){for(var t=r,a=0;a<8;a++)1&t?t=3988292384^t>>>1:t>>>=1;e[r]=t}return e}(),update:function(e,r,t,a){for(var i=0;i<a;i++)e=UZIP.crc.table[255&(e^r[t+i])]^e>>>8;return e},crc:function(e,r,t){return 4294967295^UZIP.crc.update(4294967295,e,r,t)}},UZIP.adler=function(e,r,t){for(var a=1,i=0,f=r,c=r+t;f<c;){for(var s=Math.min(f+5552,c);f<s;)i+=a+=e[f++];a%=65521,i%=65521}return i<<16|a},UZIP.bin={readUshort:function(e,r){return e[r]|e[r+1]<<8},writeUshort:function(e,r,t){e[r]=255&t,e[r+1]=t>>8&255},readUint:function(e,r){return 16777216*e[r+3]+(e[r+2]<<16|e[r+1]<<8|e[r])},writeUint:function(e,r,t){e[r]=255&t,e[r+1]=t>>8&255,e[r+2]=t>>16&255,e[r+3]=t>>24&255},readASCII:function(e,r,t){for(var a="",i=0;i<t;i++)a+=String.fromCharCode(e[r+i]);return a},writeASCII:function(e,r,t){for(var a=0;a<t.length;a++)e[r+a]=t.charCodeAt(a)},pad:function(e){return e.length<2?"0"+e:e},readUTF8:function(e,r,t){for(var a,i="",f=0;f<t;f++)i+="%"+UZIP.bin.pad(e[r+f].toString(16));try{a=decodeURIComponent(i)}catch(a){return UZIP.bin.readASCII(e,r,t)}return a},writeUTF8:function(e,r,t){for(var a=t.length,i=0,f=0;f<a;f++){var c=t.charCodeAt(f);if(0==(4294967168&c))e[r+i]=c,i++;else if(0==(4294965248&c))e[r+i]=192|c>>6,e[r+i+1]=128|c>>0&63,i+=2;else if(0==(4294901760&c))e[r+i]=224|c>>12,e[r+i+1]=128|c>>6&63,e[r+i+2]=128|c>>0&63,i+=3;else{if(0!=(4292870144&c))throw"e";e[r+i]=240|c>>18,e[r+i+1]=128|c>>12&63,e[r+i+2]=128|c>>6&63,e[r+i+3]=128|c>>0&63,i+=4}}return i},sizeUTF8:function(e){for(var r=e.length,t=0,a=0;a<r;a++){var i=e.charCodeAt(a);if(0==(4294967168&i))t++;else if(0==(4294965248&i))t+=2;else if(0==(4294901760&i))t+=3;else{if(0!=(4292870144&i))throw"e";t+=4}}return t}},UZIP.F={},UZIP.F.deflateRaw=function(e,r,t,a){var i=[[0,0,0,0,0],[4,4,8,4,0],[4,5,16,8,0],[4,6,16,16,0],[4,10,16,32,0],[8,16,32,32,0],[8,16,128,128,0],[8,32,128,256,0],[32,128,258,1024,1],[32,258,258,4096,1]][a],f=UZIP.F.U,c=UZIP.F._goodIndex,s=(UZIP.F._hash,UZIP.F._putsE),l=0,u=t<<3,d=0,h=e.length;if(0==a){for(;l<h;){s(r,u,l+(I=Math.min(65535,h-l))==h?1:0),u=UZIP.F._copyExact(e,l,I,r,u+8),l+=I}return u>>>3}var A=f.lits,v=f.strt,p=f.prev,U=0,g=0,m=0,w=0,P=0,b=0;for(h>2&&(v[b=UZIP.F._hash(e,0)]=0),l=0;l<h;l++){if(P=b,l+1<h-2){b=UZIP.F._hash(e,l+1);var _=l+1&32767;p[_]=v[b],v[b]=_}if(d<=l){(U>14e3||g>26697)&&h-l>100&&(d<l&&(A[U]=l-d,U+=2,d=l),u=UZIP.F._writeBlock(l==h-1||d==h?1:0,A,U,w,e,m,l-m,r,u),U=g=w=0,m=l);var y=0;l<h-2&&(y=UZIP.F._bestMatch(e,l,p,P,Math.min(i[2],h-l),i[3]));var I=y>>>16,F=65535&y;if(0!=y){F=65535&y;var G=c(I=y>>>16,f.of0);f.lhst[257+G]++;var C=c(F,f.df0);f.dhst[C]++,w+=f.exb[G]+f.dxb[C],A[U]=I<<23|l-d,A[U+1]=F<<16|G<<8|C,U+=2,d=l+I}else f.lhst[e[l]]++;g++}}for(m==l&&0!=e.length||(d<l&&(A[U]=l-d,U+=2,d=l),u=UZIP.F._writeBlock(1,A,U,w,e,m,l-m,r,u),U=0,g=0,U=g=w=0,m=l);0!=(7&u);)u++;return u>>>3},UZIP.F._bestMatch=function(e,r,t,a,i,f){var c=32767&r,s=t[c],l=c-s+32768&32767;if(s==c||a!=UZIP.F._hash(e,r-l))return 0;for(var u=0,d=0,h=Math.min(32767,r);l<=h&&0!=--f&&s!=c;){if(0==u||e[r+u]==e[r+u-l]){var A=UZIP.F._howLong(e,r,l);if(A>u){if(d=l,(u=A)>=i)break;l+2<A&&(A=l+2);for(var v=0,p=0;p<A-2;p++){var U=r-l+p+32768&32767,g=U-t[U]+32768&32767;g>v&&(v=g,s=U)}}}l+=(c=s)-(s=t[c])+32768&32767}return u<<16|d},UZIP.F._howLong=function(e,r,t){if(e[r]!=e[r-t]||e[r+1]!=e[r+1-t]||e[r+2]!=e[r+2-t])return 0;var a=r,i=Math.min(e.length,r+258);for(r+=3;r<i&&e[r]==e[r-t];)r++;return r-a},UZIP.F._hash=function(e,r){return(e[r]<<8|e[r+1])+(e[r+2]<<4)&65535},UZIP.saved=0,UZIP.F._writeBlock=function(e,r,t,a,i,f,c,s,l){var u,d,h,A,v,p,U,g,m,w=UZIP.F.U,P=UZIP.F._putsF,b=UZIP.F._putsE;w.lhst[256]++,d=(u=UZIP.F.getTrees())[0],h=u[1],A=u[2],v=u[3],p=u[4],U=u[5],g=u[6],m=u[7];var _=32+(0==(l+3&7)?0:8-(l+3&7))+(c<<3),y=a+UZIP.F.contSize(w.fltree,w.lhst)+UZIP.F.contSize(w.fdtree,w.dhst),I=a+UZIP.F.contSize(w.ltree,w.lhst)+UZIP.F.contSize(w.dtree,w.dhst);I+=14+3*U+UZIP.F.contSize(w.itree,w.ihst)+(2*w.ihst[16]+3*w.ihst[17]+7*w.ihst[18]);for(var F=0;F<286;F++)w.lhst[F]=0;for(F=0;F<30;F++)w.dhst[F]=0;for(F=0;F<19;F++)w.ihst[F]=0;var G=_<y&&_<I?0:y<I?1:2;if(P(s,l,e),P(s,l+1,G),l+=3,0==G){for(;0!=(7&l);)l++;l=UZIP.F._copyExact(i,f,c,s,l)}else{var C,E;if(1==G&&(C=w.fltree,E=w.fdtree),2==G){UZIP.F.makeCodes(w.ltree,d),UZIP.F.revCodes(w.ltree,d),UZIP.F.makeCodes(w.dtree,h),UZIP.F.revCodes(w.dtree,h),UZIP.F.makeCodes(w.itree,A),UZIP.F.revCodes(w.itree,A),C=w.ltree,E=w.dtree,b(s,l,v-257),b(s,l+=5,p-1),b(s,l+=5,U-4),l+=4;for(var B=0;B<U;B++)b(s,l+3*B,w.itree[1+(w.ordr[B]<<1)]);l+=3*U,l=UZIP.F._codeTiny(g,w.itree,s,l),l=UZIP.F._codeTiny(m,w.itree,s,l)}for(var Z=f,x=0;x<t;x+=2){for(var M=r[x],R=M>>>23,Q=Z+(8388607&M);Z<Q;)l=UZIP.F._writeLit(i[Z++],C,s,l);if(0!=R){var T=r[x+1],D=T>>16,O=T>>8&255,V=255&T;b(s,l=UZIP.F._writeLit(257+O,C,s,l),R-w.of0[O]),l+=w.exb[O],P(s,l=UZIP.F._writeLit(V,E,s,l),D-w.df0[V]),l+=w.dxb[V],Z+=R}}l=UZIP.F._writeLit(256,C,s,l)}return l},UZIP.F._copyExact=function(e,r,t,a,i){var f=i>>>3;return a[f]=t,a[f+1]=t>>>8,a[f+2]=255-a[f],a[f+3]=255-a[f+1],f+=4,a.set(new Uint8Array(e.buffer,r,t),f),i+(t+4<<3)},UZIP.F.getTrees=function(){for(var e=UZIP.F.U,r=UZIP.F._hufTree(e.lhst,e.ltree,15),t=UZIP.F._hufTree(e.dhst,e.dtree,15),a=[],i=UZIP.F._lenCodes(e.ltree,a),f=[],c=UZIP.F._lenCodes(e.dtree,f),s=0;s<a.length;s+=2)e.ihst[a[s]]++;for(s=0;s<f.length;s+=2)e.ihst[f[s]]++;for(var l=UZIP.F._hufTree(e.ihst,e.itree,7),u=19;u>4&&0==e.itree[1+(e.ordr[u-1]<<1)];)u--;return[r,t,l,i,c,u,a,f]},UZIP.F.getSecond=function(e){for(var r=[],t=0;t<e.length;t+=2)r.push(e[t+1]);return r},UZIP.F.nonZero=function(e){for(var r="",t=0;t<e.length;t+=2)0!=e[t+1]&&(r+=(t>>1)+",");return r},UZIP.F.contSize=function(e,r){for(var t=0,a=0;a<r.length;a++)t+=r[a]*e[1+(a<<1)];return t},UZIP.F._codeTiny=function(e,r,t,a){for(var i=0;i<e.length;i+=2){var f=e[i],c=e[i+1];a=UZIP.F._writeLit(f,r,t,a);var s=16==f?2:17==f?3:7;f>15&&(UZIP.F._putsE(t,a,c,s),a+=s)}return a},UZIP.F._lenCodes=function(e,r){for(var t=e.length;2!=t&&0==e[t-1];)t-=2;for(var a=0;a<t;a+=2){var i=e[a+1],f=a+3<t?e[a+3]:-1,c=a+5<t?e[a+5]:-1,s=0==a?-1:e[a-1];if(0==i&&f==i&&c==i){for(var l=a+5;l+2<t&&e[l+2]==i;)l+=2;(u=Math.min(l+1-a>>>1,138))<11?r.push(17,u-3):r.push(18,u-11),a+=2*u-2}else if(i==s&&f==i&&c==i){for(l=a+5;l+2<t&&e[l+2]==i;)l+=2;var u=Math.min(l+1-a>>>1,6);r.push(16,u-3),a+=2*u-2}else r.push(i,0)}return t>>>1},UZIP.F._hufTree=function(e,r,t){var a=[],i=e.length,f=r.length,c=0;for(c=0;c<f;c+=2)r[c]=0,r[c+1]=0;for(c=0;c<i;c++)0!=e[c]&&a.push({lit:c,f:e[c]});var s=a.length,l=a.slice(0);if(0==s)return 0;if(1==s){var u=a[0].lit;l=0==u?1:0;return r[1+(u<<1)]=1,r[1+(l<<1)]=1,1}a.sort((function(e,r){return e.f-r.f}));var d=a[0],h=a[1],A=0,v=1,p=2;for(a[0]={lit:-1,f:d.f+h.f,l:d,r:h,d:0};v!=s-1;)d=A!=v&&(p==s||a[A].f<a[p].f)?a[A++]:a[p++],h=A!=v&&(p==s||a[A].f<a[p].f)?a[A++]:a[p++],a[v++]={lit:-1,f:d.f+h.f,l:d,r:h};var U=UZIP.F.setDepth(a[v-1],0);for(U>t&&(UZIP.F.restrictDepth(l,t,U),U=t),c=0;c<s;c++)r[1+(l[c].lit<<1)]=l[c].d;return U},UZIP.F.setDepth=function(e,r){return-1!=e.lit?(e.d=r,r):Math.max(UZIP.F.setDepth(e.l,r+1),UZIP.F.setDepth(e.r,r+1))},UZIP.F.restrictDepth=function(e,r,t){var a=0,i=1<<t-r,f=0;for(e.sort((function(e,r){return r.d==e.d?e.f-r.f:r.d-e.d})),a=0;a<e.length&&e[a].d>r;a++){var c=e[a].d;e[a].d=r,f+=i-(1<<t-c)}for(f>>>=t-r;f>0;){(c=e[a].d)<r?(e[a].d++,f-=1<<r-c-1):a++}for(;a>=0;a--)e[a].d==r&&f<0&&(e[a].d--,f++);0!=f&&console.log("debt left")},UZIP.F._goodIndex=function(e,r){var t=0;return r[16|t]<=e&&(t|=16),r[8|t]<=e&&(t|=8),r[4|t]<=e&&(t|=4),r[2|t]<=e&&(t|=2),r[1|t]<=e&&(t|=1),t},UZIP.F._writeLit=function(e,r,t,a){return UZIP.F._putsF(t,a,r[e<<1]),a+r[1+(e<<1)]},UZIP.F.inflate=function(e,r){var t=Uint8Array;if(3==e[0]&&0==e[1])return r||new t(0);var a=UZIP.F,i=a._bitsF,f=a._bitsE,c=a._decodeTiny,s=a.makeCodes,l=a.codes2map,u=a._get17,d=a.U,h=null==r;h&&(r=new t(e.length>>>2<<3));for(var A,v,p=0,U=0,g=0,m=0,w=0,P=0,b=0,_=0,y=0;0==p;)if(p=i(e,y,1),U=i(e,y+1,2),y+=3,0!=U){if(h&&(r=UZIP.F._check(r,_+(1<<17))),1==U&&(A=d.flmap,v=d.fdmap,P=511,b=31),2==U){g=f(e,y,5)+257,m=f(e,y+5,5)+1,w=f(e,y+10,4)+4,y+=14;for(var I=0;I<38;I+=2)d.itree[I]=0,d.itree[I+1]=0;var F=1;for(I=0;I<w;I++){var G=f(e,y+3*I,3);d.itree[1+(d.ordr[I]<<1)]=G,G>F&&(F=G)}y+=3*w,s(d.itree,F),l(d.itree,F,d.imap),A=d.lmap,v=d.dmap,y=c(d.imap,(1<<F)-1,g+m,e,y,d.ttree);var C=a._copyOut(d.ttree,0,g,d.ltree);P=(1<<C)-1;var E=a._copyOut(d.ttree,g,m,d.dtree);b=(1<<E)-1,s(d.ltree,C),l(d.ltree,C,A),s(d.dtree,E),l(d.dtree,E,v)}for(;;){var B=A[u(e,y)&P];y+=15&B;var Z=B>>>4;if(Z>>>8==0)r[_++]=Z;else{if(256==Z)break;var x=_+Z-254;if(Z>264){var M=d.ldef[Z-257];x=_+(M>>>3)+f(e,y,7&M),y+=7&M}var R=v[u(e,y)&b];y+=15&R;var Q=R>>>4,T=d.ddef[Q],D=(T>>>4)+i(e,y,15&T);for(y+=15&T,h&&(r=UZIP.F._check(r,_+(1<<17)));_<x;)r[_]=r[_++-D],r[_]=r[_++-D],r[_]=r[_++-D],r[_]=r[_++-D];_=x}}}else{0!=(7&y)&&(y+=8-(7&y));var O=4+(y>>>3),V=e[O-4]|e[O-3]<<8;h&&(r=UZIP.F._check(r,_+V)),r.set(new t(e.buffer,e.byteOffset+O,V),_),y=O+V<<3,_+=V}return r.length==_?r:r.slice(0,_)},UZIP.F._check=function(e,r){var t=e.length;if(r<=t)return e;var a=new Uint8Array(Math.max(t<<1,r));return a.set(e,0),a},UZIP.F._decodeTiny=function(e,r,t,a,i,f){for(var c=UZIP.F._bitsE,s=UZIP.F._get17,l=0;l<t;){var u=e[s(a,i)&r];i+=15&u;var d=u>>>4;if(d<=15)f[l]=d,l++;else{var h=0,A=0;16==d?(A=3+c(a,i,2),i+=2,h=f[l-1]):17==d?(A=3+c(a,i,3),i+=3):18==d&&(A=11+c(a,i,7),i+=7);for(var v=l+A;l<v;)f[l]=h,l++}}return i},UZIP.F._copyOut=function(e,r,t,a){for(var i=0,f=0,c=a.length>>>1;f<t;){var s=e[f+r];a[f<<1]=0,a[1+(f<<1)]=s,s>i&&(i=s),f++}for(;f<c;)a[f<<1]=0,a[1+(f<<1)]=0,f++;return i},UZIP.F.makeCodes=function(e,r){for(var t,a,i,f,c=UZIP.F.U,s=e.length,l=c.bl_count,u=0;u<=r;u++)l[u]=0;for(u=1;u<s;u+=2)l[e[u]]++;var d=c.next_code;for(t=0,l[0]=0,a=1;a<=r;a++)t=t+l[a-1]<<1,d[a]=t;for(i=0;i<s;i+=2)0!=(f=e[i+1])&&(e[i]=d[f],d[f]++)},UZIP.F.codes2map=function(e,r,t){for(var a=e.length,i=UZIP.F.U.rev15,f=0;f<a;f+=2)if(0!=e[f+1])for(var c=f>>1,s=e[f+1],l=c<<4|s,u=r-s,d=e[f]<<u,h=d+(1<<u);d!=h;){t[i[d]>>>15-r]=l,d++}},UZIP.F.revCodes=function(e,r){for(var t=UZIP.F.U.rev15,a=15-r,i=0;i<e.length;i+=2){var f=e[i]<<r-e[i+1];e[i]=t[f]>>>a}},UZIP.F._putsE=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8},UZIP.F._putsF=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8,e[a+2]|=t>>>16},UZIP.F._bitsE=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8)>>>(7&r)&(1<<t)-1},UZIP.F._bitsF=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)&(1<<t)-1},UZIP.F._get17=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)},UZIP.F._get25=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16|e[3+(r>>>3)]<<24)>>>(7&r)},UZIP.F.U=(r=Uint16Array,t=Uint32Array,{next_code:new r(16),bl_count:new r(16),ordr:[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],of0:[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],exb:[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0],ldef:new r(32),df0:[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,65535,65535],dxb:[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0],ddef:new t(32),flmap:new r(512),fltree:[],fdmap:new r(32),fdtree:[],lmap:new r(32768),ltree:[],ttree:[],dmap:new r(32768),dtree:[],imap:new r(512),itree:[],rev15:new r(32768),lhst:new t(286),dhst:new t(30),ihst:new t(19),lits:new t(15e3),strt:new r(65536),prev:new r(32768)}),function(){for(var e=UZIP.F.U,r=0;r<32768;r++){var t=r;t=(4278255360&(t=(4042322160&(t=(3435973836&(t=(2863311530&t)>>>1|(1431655765&t)<<1))>>>2|(858993459&t)<<2))>>>4|(252645135&t)<<4))>>>8|(16711935&t)<<8,e.rev15[r]=(t>>>16|t<<16)>>>17}function pushV(e,r,t){for(;0!=r--;)e.push(0,t)}for(r=0;r<32;r++)e.ldef[r]=e.of0[r]<<3|e.exb[r],e.ddef[r]=e.df0[r]<<4|e.dxb[r];pushV(e.fltree,144,8),pushV(e.fltree,112,9),pushV(e.fltree,24,7),pushV(e.fltree,8,8),UZIP.F.makeCodes(e.fltree,9),UZIP.F.codes2map(e.fltree,9,e.flmap),UZIP.F.revCodes(e.fltree,9),pushV(e.fdtree,32,5),UZIP.F.makeCodes(e.fdtree,5),UZIP.F.codes2map(e.fdtree,5,e.fdmap),UZIP.F.revCodes(e.fdtree,5),pushV(e.itree,19,0),pushV(e.ltree,286,0),pushV(e.dtree,30,0),pushV(e.ttree,320,0)}()})),UZIP=Object.freeze(Object.assign(Object.create(null),UZIP_1,{default:UZIP_1})),UPNG={},N,W,H;UPNG.toRGBA8=function(e){var r=e.width,t=e.height;if(null==e.tabs.acTL)return[UPNG.toRGBA8.decodeImage(e.data,r,t,e).buffer];var a=[];null==e.frames[0].data&&(e.frames[0].data=e.data);for(var i=r*t*4,f=new Uint8Array(i),c=new Uint8Array(i),s=new Uint8Array(i),l=0;l<e.frames.length;l++){var u=e.frames[l],d=u.rect.x,h=u.rect.y,A=u.rect.width,v=u.rect.height,p=UPNG.toRGBA8.decodeImage(u.data,A,v,e);if(0!=l)for(var U=0;U<i;U++)s[U]=f[U];if(0==u.blend?UPNG._copyTile(p,A,v,f,r,t,d,h,0):1==u.blend&&UPNG._copyTile(p,A,v,f,r,t,d,h,1),a.push(f.buffer.slice(0)),0==u.dispose);else if(1==u.dispose)UPNG._copyTile(c,A,v,f,r,t,d,h,0);else if(2==u.dispose)for(U=0;U<i;U++)f[U]=s[U]}return a},UPNG.toRGBA8.decodeImage=function(e,r,t,a){var i=r*t,f=UPNG.decode._getBPP(a),c=Math.ceil(r*f/8),s=new Uint8Array(4*i),l=new Uint32Array(s.buffer),u=a.ctype,d=a.depth,h=UPNG._bin.readUshort;if(6==u){var A=i<<2;if(8==d)for(var v=0;v<A;v+=4)s[v]=e[v],s[v+1]=e[v+1],s[v+2]=e[v+2],s[v+3]=e[v+3];if(16==d)for(v=0;v<A;v++)s[v]=e[v<<1]}else if(2==u){var p=a.tabs.tRNS;if(null==p){if(8==d)for(v=0;v<i;v++){var U=3*v;l[v]=255<<24|e[U+2]<<16|e[U+1]<<8|e[U]}if(16==d)for(v=0;v<i;v++){U=6*v;l[v]=255<<24|e[U+4]<<16|e[U+2]<<8|e[U]}}else{var g=p[0],m=p[1],w=p[2];if(8==d)for(v=0;v<i;v++){var P=v<<2;U=3*v;l[v]=255<<24|e[U+2]<<16|e[U+1]<<8|e[U],e[U]==g&&e[U+1]==m&&e[U+2]==w&&(s[P+3]=0)}if(16==d)for(v=0;v<i;v++){P=v<<2,U=6*v;l[v]=255<<24|e[U+4]<<16|e[U+2]<<8|e[U],h(e,U)==g&&h(e,U+2)==m&&h(e,U+4)==w&&(s[P+3]=0)}}}else if(3==u){var b=a.tabs.PLTE,_=a.tabs.tRNS,y=_?_.length:0;if(1==d)for(var I=0;I<t;I++){var F=I*c,G=I*r;for(v=0;v<r;v++){P=G+v<<2;var C=3*(E=e[F+(v>>3)]>>7-((7&v)<<0)&1);s[P]=b[C],s[P+1]=b[C+1],s[P+2]=b[C+2],s[P+3]=E<y?_[E]:255}}if(2==d)for(I=0;I<t;I++)for(F=I*c,G=I*r,v=0;v<r;v++){P=G+v<<2,C=3*(E=e[F+(v>>2)]>>6-((3&v)<<1)&3);s[P]=b[C],s[P+1]=b[C+1],s[P+2]=b[C+2],s[P+3]=E<y?_[E]:255}if(4==d)for(I=0;I<t;I++)for(F=I*c,G=I*r,v=0;v<r;v++){P=G+v<<2,C=3*(E=e[F+(v>>1)]>>4-((1&v)<<2)&15);s[P]=b[C],s[P+1]=b[C+1],s[P+2]=b[C+2],s[P+3]=E<y?_[E]:255}if(8==d)for(v=0;v<i;v++){var E;P=v<<2,C=3*(E=e[v]);s[P]=b[C],s[P+1]=b[C+1],s[P+2]=b[C+2],s[P+3]=E<y?_[E]:255}}else if(4==u){if(8==d)for(v=0;v<i;v++){P=v<<2;var B=e[Z=v<<1];s[P]=B,s[P+1]=B,s[P+2]=B,s[P+3]=e[Z+1]}if(16==d)for(v=0;v<i;v++){var Z;P=v<<2,B=e[Z=v<<2];s[P]=B,s[P+1]=B,s[P+2]=B,s[P+3]=e[Z+2]}}else if(0==u)for(g=a.tabs.tRNS?a.tabs.tRNS:-1,I=0;I<t;I++){var x=I*c,M=I*r;if(1==d)for(var R=0;R<r;R++){var Q=(B=255*(e[x+(R>>>3)]>>>7-(7&R)&1))==255*g?0:255;l[M+R]=Q<<24|B<<16|B<<8|B}else if(2==d)for(R=0;R<r;R++){Q=(B=85*(e[x+(R>>>2)]>>>6-((3&R)<<1)&3))==85*g?0:255;l[M+R]=Q<<24|B<<16|B<<8|B}else if(4==d)for(R=0;R<r;R++){Q=(B=17*(e[x+(R>>>1)]>>>4-((1&R)<<2)&15))==17*g?0:255;l[M+R]=Q<<24|B<<16|B<<8|B}else if(8==d)for(R=0;R<r;R++){Q=(B=e[x+R])==g?0:255;l[M+R]=Q<<24|B<<16|B<<8|B}else if(16==d)for(R=0;R<r;R++){B=e[x+(R<<1)],Q=h(e,x+(R<<v))==g?0:255;l[M+R]=Q<<24|B<<16|B<<8|B}}return s},UPNG.decode=function(e){for(var r,t=new Uint8Array(e),a=8,i=UPNG._bin,f=i.readUshort,c=i.readUint,s={tabs:{},frames:[]},l=new Uint8Array(t.length),u=0,d=0,h=[137,80,78,71,13,10,26,10],A=0;A<8;A++)if(t[A]!=h[A])throw"The input is not a PNG file!";for(;a<t.length;){var v=i.readUint(t,a);a+=4;var p=i.readASCII(t,a,4);if(a+=4,"IHDR"==p)UPNG.decode._IHDR(t,a,s);else if("CgBI"==p)s.tabs[p]=t.slice(a,a+4);else if("IDAT"==p){for(A=0;A<v;A++)l[u+A]=t[a+A];u+=v}else if("acTL"==p)s.tabs[p]={num_frames:c(t,a),num_plays:c(t,a+4)},r=new Uint8Array(t.length);else if("fcTL"==p){var U;if(0!=d)(U=s.frames[s.frames.length-1]).data=UPNG.decode._decompress(s,r.slice(0,d),U.rect.width,U.rect.height),d=0;var g={x:c(t,a+12),y:c(t,a+16),width:c(t,a+4),height:c(t,a+8)},m=f(t,a+22);m=f(t,a+20)/(0==m?100:m);var w={rect:g,delay:Math.round(1e3*m),dispose:t[a+24],blend:t[a+25]};s.frames.push(w)}else if("fdAT"==p){for(A=0;A<v-4;A++)r[d+A]=t[a+A+4];d+=v-4}else if("pHYs"==p)s.tabs[p]=[i.readUint(t,a),i.readUint(t,a+4),t[a+8]];else if("cHRM"==p){s.tabs[p]=[];for(A=0;A<8;A++)s.tabs[p].push(i.readUint(t,a+4*A))}else if("tEXt"==p||"zTXt"==p){null==s.tabs[p]&&(s.tabs[p]={});var P=i.nextZero(t,a),b=i.readASCII(t,a,P-a),_=a+v-P-1;if("tEXt"==p)G=i.readASCII(t,P+1,_);else{var y=UPNG.decode._inflate(t.slice(P+2,P+2+_));G=i.readUTF8(y,0,y.length)}s.tabs[p][b]=G}else if("iTXt"==p){null==s.tabs[p]&&(s.tabs[p]={});P=0;var I=a;P=i.nextZero(t,I);b=i.readASCII(t,I,P-I);var F=t[I=P+1];I+=2,P=i.nextZero(t,I);i.readASCII(t,I,P-I);I=P+1,P=i.nextZero(t,I);var G;i.readUTF8(t,I,P-I),_=v-((I=P+1)-a);if(0==F)G=i.readUTF8(t,I,_);else{y=UPNG.decode._inflate(t.slice(I,I+_));G=i.readUTF8(y,0,y.length)}s.tabs[p][b]=G}else if("PLTE"==p)s.tabs[p]=i.readBytes(t,a,v);else if("hIST"==p){var C=s.tabs.PLTE.length/3;s.tabs[p]=[];for(A=0;A<C;A++)s.tabs[p].push(f(t,a+2*A))}else if("tRNS"==p)3==s.ctype?s.tabs[p]=i.readBytes(t,a,v):0==s.ctype?s.tabs[p]=f(t,a):2==s.ctype&&(s.tabs[p]=[f(t,a),f(t,a+2),f(t,a+4)]);else if("gAMA"==p)s.tabs[p]=i.readUint(t,a)/1e5;else if("sRGB"==p)s.tabs[p]=t[a];else if("bKGD"==p)0==s.ctype||4==s.ctype?s.tabs[p]=[f(t,a)]:2==s.ctype||6==s.ctype?s.tabs[p]=[f(t,a),f(t,a+2),f(t,a+4)]:3==s.ctype&&(s.tabs[p]=t[a]);else if("IEND"==p)break;a+=v;i.readUint(t,a);a+=4}0!=d&&((U=s.frames[s.frames.length-1]).data=UPNG.decode._decompress(s,r.slice(0,d),U.rect.width,U.rect.height),d=0);return s.data=UPNG.decode._decompress(s,l,s.width,s.height),delete s.compress,delete s.interlace,delete s.filter,s},UPNG.decode._decompress=function(e,r,t,a){var i=UPNG.decode._getBPP(e),f=Math.ceil(t*i/8),c=new Uint8Array((f+1+e.interlace)*a);return r=e.tabs.CgBI?UPNG.inflateRaw(r,c):UPNG.decode._inflate(r,c),0==e.interlace?r=UPNG.decode._filterZero(r,e,0,t,a):1==e.interlace&&(r=UPNG.decode._readInterlace(r,e)),r},UPNG.decode._inflate=function(e,r){return UPNG.inflateRaw(new Uint8Array(e.buffer,2,e.length-6),r)},UPNG.inflateRaw=(H={},H.H={},H.H.N=function(e,r){var t,a,i=Uint8Array,f=0,c=0,s=0,l=0,u=0,d=0,h=0,A=0,v=0;if(3==e[0]&&0==e[1])return r||new i(0);var p=H.H,U=p.b,g=p.e,m=p.R,w=p.n,P=p.A,b=p.Z,_=p.m,y=null==r;for(y&&(r=new i(e.length>>>2<<5));0==f;)if(f=U(e,v,1),c=U(e,v+1,2),v+=3,0!=c){if(y&&(r=H.H.W(r,A+(1<<17))),1==c&&(t=_.J,a=_.h,d=511,h=31),2==c){s=g(e,v,5)+257,l=g(e,v+5,5)+1,u=g(e,v+10,4)+4,v+=14;for(var I=1,F=0;F<38;F+=2)_.Q[F]=0,_.Q[F+1]=0;for(F=0;F<u;F++){var G=g(e,v+3*F,3);_.Q[1+(_.X[F]<<1)]=G,G>I&&(I=G)}v+=3*u,w(_.Q,I),P(_.Q,I,_.u),t=_.w,a=_.d,v=m(_.u,(1<<I)-1,s+l,e,v,_.v);var C=p.V(_.v,0,s,_.C);d=(1<<C)-1;var E=p.V(_.v,s,l,_.D);h=(1<<E)-1,w(_.C,C),P(_.C,C,t),w(_.D,E),P(_.D,E,a)}for(;;){var B=t[b(e,v)&d];v+=15&B;var Z=B>>>4;if(Z>>>8==0)r[A++]=Z;else{if(256==Z)break;var x=A+Z-254;if(Z>264){var M=_.q[Z-257];x=A+(M>>>3)+g(e,v,7&M),v+=7&M}var R=a[b(e,v)&h];v+=15&R;var Q=R>>>4,T=_.c[Q],D=(T>>>4)+U(e,v,15&T);for(v+=15&T;A<x;)r[A]=r[A++-D],r[A]=r[A++-D],r[A]=r[A++-D],r[A]=r[A++-D];A=x}}}else{0!=(7&v)&&(v+=8-(7&v));var O=4+(v>>>3),V=e[O-4]|e[O-3]<<8;y&&(r=H.H.W(r,A+V)),r.set(new i(e.buffer,e.byteOffset+O,V),A),v=O+V<<3,A+=V}return r.length==A?r:r.slice(0,A)},H.H.W=function(e,r){var t=e.length;if(r<=t)return e;var a=new Uint8Array(t<<1);return a.set(e,0),a},H.H.R=function(e,r,t,a,i,f){for(var c=H.H.e,s=H.H.Z,l=0;l<t;){var u=e[s(a,i)&r];i+=15&u;var d=u>>>4;if(d<=15)f[l]=d,l++;else{var h=0,A=0;16==d?(A=3+c(a,i,2),i+=2,h=f[l-1]):17==d?(A=3+c(a,i,3),i+=3):18==d&&(A=11+c(a,i,7),i+=7);for(var v=l+A;l<v;)f[l]=h,l++}}return i},H.H.V=function(e,r,t,a){for(var i=0,f=0,c=a.length>>>1;f<t;){var s=e[f+r];a[f<<1]=0,a[1+(f<<1)]=s,s>i&&(i=s),f++}for(;f<c;)a[f<<1]=0,a[1+(f<<1)]=0,f++;return i},H.H.n=function(e,r){for(var t,a,i,f,c=H.H.m,s=e.length,l=c.j,u=0;u<=r;u++)l[u]=0;for(u=1;u<s;u+=2)l[e[u]]++;var d=c.K;for(t=0,l[0]=0,a=1;a<=r;a++)t=t+l[a-1]<<1,d[a]=t;for(i=0;i<s;i+=2)0!=(f=e[i+1])&&(e[i]=d[f],d[f]++)},H.H.A=function(e,r,t){for(var a=e.length,i=H.H.m.r,f=0;f<a;f+=2)if(0!=e[f+1])for(var c=f>>1,s=e[f+1],l=c<<4|s,u=r-s,d=e[f]<<u,h=d+(1<<u);d!=h;)t[i[d]>>>15-r]=l,d++},H.H.l=function(e,r){for(var t=H.H.m.r,a=15-r,i=0;i<e.length;i+=2){var f=e[i]<<r-e[i+1];e[i]=t[f]>>>a}},H.H.M=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8},H.H.I=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8,e[a+2]|=t>>>16},H.H.e=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8)>>>(7&r)&(1<<t)-1},H.H.b=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)&(1<<t)-1},H.H.Z=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)},H.H.i=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16|e[3+(r>>>3)]<<24)>>>(7&r)},H.H.m=(N=Uint16Array,W=Uint32Array,{K:new N(16),j:new N(16),X:[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],S:[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],T:[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0],q:new N(32),p:[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,65535,65535],z:[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0],c:new W(32),J:new N(512),_:[],h:new N(32),$:[],w:new N(32768),C:[],v:[],d:new N(32768),D:[],u:new N(512),Q:[],r:new N(32768),s:new W(286),Y:new W(30),a:new W(19),t:new W(15e3),k:new N(65536),g:new N(32768)}),function(){for(var e=H.H.m,r=0;r<32768;r++){var t=r;t=(4278255360&(t=(4042322160&(t=(3435973836&(t=(2863311530&t)>>>1|(1431655765&t)<<1))>>>2|(858993459&t)<<2))>>>4|(252645135&t)<<4))>>>8|(16711935&t)<<8,e.r[r]=(t>>>16|t<<16)>>>17}function n(e,r,t){for(;0!=r--;)e.push(0,t)}for(r=0;r<32;r++)e.q[r]=e.S[r]<<3|e.T[r],e.c[r]=e.p[r]<<4|e.z[r];n(e._,144,8),n(e._,112,9),n(e._,24,7),n(e._,8,8),H.H.n(e._,9),H.H.A(e._,9,e.J),H.H.l(e._,9),n(e.$,32,5),H.H.n(e.$,5),H.H.A(e.$,5,e.h),H.H.l(e.$,5),n(e.Q,19,0),n(e.C,286,0),n(e.D,30,0),n(e.v,320,0)}(),H.H.N),UPNG.decode._readInterlace=function(e,r){for(var t=r.width,a=r.height,i=UPNG.decode._getBPP(r),f=i>>3,c=Math.ceil(t*i/8),s=new Uint8Array(a*c),l=0,u=[0,0,4,0,2,0,1],d=[0,4,0,2,0,1,0],h=[8,8,8,4,4,2,2],A=[8,8,4,4,2,2,1],v=0;v<7;){for(var p=h[v],U=A[v],g=0,m=0,w=u[v];w<a;)w+=p,m++;for(var P=d[v];P<t;)P+=U,g++;var b=Math.ceil(g*i/8);UPNG.decode._filterZero(e,r,l,g,m);for(var _=0,y=u[v];y<a;){for(var I=d[v],F=l+_*b<<3;I<t;){var G;if(1==i)G=(G=e[F>>3])>>7-(7&F)&1,s[y*c+(I>>3)]|=G<<7-((7&I)<<0);if(2==i)G=(G=e[F>>3])>>6-(7&F)&3,s[y*c+(I>>2)]|=G<<6-((3&I)<<1);if(4==i)G=(G=e[F>>3])>>4-(7&F)&15,s[y*c+(I>>1)]|=G<<4-((1&I)<<2);if(i>=8)for(var C=y*c+I*f,E=0;E<f;E++)s[C+E]=e[(F>>3)+E];F+=i,I+=U}_++,y+=p}g*m!=0&&(l+=m*(1+b)),v+=1}return s},UPNG.decode._getBPP=function(e){return[1,null,3,1,2,null,4][e.ctype]*e.depth},UPNG.decode._filterZero=function(e,r,t,a,i){var f=UPNG.decode._getBPP(r),c=Math.ceil(a*f/8),s=UPNG.decode._paeth;f=Math.ceil(f/8);var l=0,u=1,d=e[t],h=0;if(d>1&&(e[t]=[0,0,1][d-2]),3==d)for(h=f;h<c;h++)e[h+1]=e[h+1]+(e[h+1-f]>>>1)&255;for(var A=0;A<i;A++)if(h=0,0==(d=e[(u=(l=t+A*c)+A+1)-1]))for(;h<c;h++)e[l+h]=e[u+h];else if(1==d){for(;h<f;h++)e[l+h]=e[u+h];for(;h<c;h++)e[l+h]=e[u+h]+e[l+h-f]}else if(2==d)for(;h<c;h++)e[l+h]=e[u+h]+e[l+h-c];else if(3==d){for(;h<f;h++)e[l+h]=e[u+h]+(e[l+h-c]>>>1);for(;h<c;h++)e[l+h]=e[u+h]+(e[l+h-c]+e[l+h-f]>>>1)}else{for(;h<f;h++)e[l+h]=e[u+h]+s(0,e[l+h-c],0);for(;h<c;h++)e[l+h]=e[u+h]+s(e[l+h-f],e[l+h-c],e[l+h-f-c])}return e},UPNG.decode._paeth=function(e,r,t){var a=e+r-t,i=a-e,f=a-r,c=a-t;return i*i<=f*f&&i*i<=c*c?e:f*f<=c*c?r:t},UPNG.decode._IHDR=function(e,r,t){var a=UPNG._bin;t.width=a.readUint(e,r),r+=4,t.height=a.readUint(e,r),r+=4,t.depth=e[r],r++,t.ctype=e[r],r++,t.compress=e[r],r++,t.filter=e[r],r++,t.interlace=e[r],r++},UPNG._bin={nextZero:function nextZero(e,r){for(;0!=e[r];)r++;return r},readUshort:function readUshort(e,r){return e[r]<<8|e[r+1]},writeUshort:function writeUshort(e,r,t){e[r]=t>>8&255,e[r+1]=255&t},readUint:function readUint(e,r){return 16777216*e[r]+(e[r+1]<<16|e[r+2]<<8|e[r+3])},writeUint:function writeUint(e,r,t){e[r]=t>>24&255,e[r+1]=t>>16&255,e[r+2]=t>>8&255,e[r+3]=255&t},readASCII:function readASCII(e,r,t){for(var a="",i=0;i<t;i++)a+=String.fromCharCode(e[r+i]);return a},writeASCII:function writeASCII(e,r,t){for(var a=0;a<t.length;a++)e[r+a]=t.charCodeAt(a)},readBytes:function readBytes(e,r,t){for(var a=[],i=0;i<t;i++)a.push(e[r+i]);return a},pad:function pad(e){return e.length<2?"0"+e:e},readUTF8:function readUTF8(e,r,t){for(var a,i="",f=0;f<t;f++)i+="%"+UPNG._bin.pad(e[r+f].toString(16));try{a=decodeURIComponent(i)}catch(a){return UPNG._bin.readASCII(e,r,t)}return a}},UPNG._copyTile=function(e,r,t,a,i,f,c,s,l){for(var u=Math.min(r,i),d=Math.min(t,f),h=0,A=0,v=0;v<d;v++)for(var p=0;p<u;p++)if(c>=0&&s>=0?(h=v*r+p<<2,A=(s+v)*i+c+p<<2):(h=(-s+v)*r-c+p<<2,A=v*i+p<<2),0==l)a[A]=e[h],a[A+1]=e[h+1],a[A+2]=e[h+2],a[A+3]=e[h+3];else if(1==l){var U=e[h+3]*(1/255),g=e[h]*U,m=e[h+1]*U,w=e[h+2]*U,P=a[A+3]*(1/255),b=a[A]*P,_=a[A+1]*P,y=a[A+2]*P,I=1-U,F=U+P*I,G=0==F?0:1/F;a[A+3]=255*F,a[A+0]=(g+b*I)*G,a[A+1]=(m+_*I)*G,a[A+2]=(w+y*I)*G}else if(2==l){U=e[h+3],g=e[h],m=e[h+1],w=e[h+2],P=a[A+3],b=a[A],_=a[A+1],y=a[A+2];U==P&&g==b&&m==_&&w==y?(a[A]=0,a[A+1]=0,a[A+2]=0,a[A+3]=0):(a[A]=g,a[A+1]=m,a[A+2]=w,a[A+3]=U)}else if(3==l){U=e[h+3],g=e[h],m=e[h+1],w=e[h+2],P=a[A+3],b=a[A],_=a[A+1],y=a[A+2];if(U==P&&g==b&&m==_&&w==y)continue;if(U<220&&P>20)return!1}return!0},UPNG.encode=function(e,r,t,a,i,f,c){null==a&&(a=0),null==c&&(c=!1);var s=UPNG.encode.compress(e,r,t,a,[!1,!1,!1,0,c]);return UPNG.encode.compressPNG(s,-1),UPNG.encode._main(s,r,t,i,f)},UPNG.encodeLL=function(e,r,t,a,i,f,c,s){for(var l={ctype:0+(1==a?0:2)+(0==i?0:4),depth:f,frames:[]},u=(a+i)*f,d=u*r,h=0;h<e.length;h++)l.frames.push({rect:{x:0,y:0,width:r,height:t},img:new Uint8Array(e[h]),blend:0,dispose:1,bpp:Math.ceil(u/8),bpl:Math.ceil(d/8)});return UPNG.encode.compressPNG(l,0,!0),UPNG.encode._main(l,r,t,c,s)},UPNG.encode._main=function(e,r,t,a,i){null==i&&(i={});var f=UPNG.crc.crc,c=UPNG._bin.writeUint,s=UPNG._bin.writeUshort,l=UPNG._bin.writeASCII,u=8,d=e.frames.length>1,h=!1,A=33+(d?20:0);if(null!=i.sRGB&&(A+=13),null!=i.pHYs&&(A+=21),3==e.ctype){for(var v=e.plte.length,p=0;p<v;p++)e.plte[p]>>>24!=255&&(h=!0);A+=8+3*v+4+(h?8+1*v+4:0)}for(var U=0;U<e.frames.length;U++){d&&(A+=38),A+=(F=e.frames[U]).cimg.length+12,0!=U&&(A+=4)}A+=12;var g=new Uint8Array(A),m=[137,80,78,71,13,10,26,10];for(p=0;p<8;p++)g[p]=m[p];if(c(g,u,13),l(g,u+=4,"IHDR"),c(g,u+=4,r),c(g,u+=4,t),g[u+=4]=e.depth,g[++u]=e.ctype,g[++u]=0,g[++u]=0,g[++u]=0,c(g,++u,f(g,u-17,17)),u+=4,null!=i.sRGB&&(c(g,u,1),l(g,u+=4,"sRGB"),g[u+=4]=i.sRGB,c(g,++u,f(g,u-5,5)),u+=4),null!=i.pHYs&&(c(g,u,9),l(g,u+=4,"pHYs"),c(g,u+=4,i.pHYs[0]),c(g,u+=4,i.pHYs[1]),g[u+=4]=i.pHYs[2],c(g,++u,f(g,u-13,13)),u+=4),d&&(c(g,u,8),l(g,u+=4,"acTL"),c(g,u+=4,e.frames.length),c(g,u+=4,null!=i.loop?i.loop:0),c(g,u+=4,f(g,u-12,12)),u+=4),3==e.ctype){c(g,u,3*(v=e.plte.length)),l(g,u+=4,"PLTE"),u+=4;for(p=0;p<v;p++){var w=3*p,P=e.plte[p],b=255&P,_=P>>>8&255,y=P>>>16&255;g[u+w+0]=b,g[u+w+1]=_,g[u+w+2]=y}if(c(g,u+=3*v,f(g,u-3*v-4,3*v+4)),u+=4,h){c(g,u,v),l(g,u+=4,"tRNS"),u+=4;for(p=0;p<v;p++)g[u+p]=e.plte[p]>>>24&255;c(g,u+=v,f(g,u-v-4,v+4)),u+=4}}var I=0;for(U=0;U<e.frames.length;U++){var F=e.frames[U];d&&(c(g,u,26),l(g,u+=4,"fcTL"),c(g,u+=4,I++),c(g,u+=4,F.rect.width),c(g,u+=4,F.rect.height),c(g,u+=4,F.rect.x),c(g,u+=4,F.rect.y),s(g,u+=4,a[U]),s(g,u+=2,1e3),g[u+=2]=F.dispose,g[++u]=F.blend,c(g,++u,f(g,u-30,30)),u+=4);var G=F.cimg;c(g,u,(v=G.length)+(0==U?0:4));var C=u+=4;l(g,u,0==U?"IDAT":"fdAT"),u+=4,0!=U&&(c(g,u,I++),u+=4),g.set(G,u),c(g,u+=v,f(g,C,u-C)),u+=4}return c(g,u,0),l(g,u+=4,"IEND"),c(g,u+=4,f(g,u-4,4)),u+=4,g.buffer},UPNG.encode.compressPNG=function(e,r,t){for(var a=0;a<e.frames.length;a++){var i=e.frames[a],f=(i.rect.width,i.rect.height),c=new Uint8Array(f*i.bpl+f);i.cimg=UPNG.encode._filterZero(i.img,f,i.bpp,i.bpl,c,r,t)}},UPNG.encode.compress=function(e,r,t,a,i){for(var f=i[0],c=i[1],s=i[2],l=i[3],u=i[4],d=6,h=8,A=255,v=0;v<e.length;v++)for(var p=new Uint8Array(e[v]),U=p.length,g=0;g<U;g+=4)A&=p[g+3];var m=255!=A,w=UPNG.encode.framize(e,r,t,f,c,s),P={},b=[],_=[];if(0!=a){var y=[];for(g=0;g<w.length;g++)y.push(w[g].img.buffer);var I=UPNG.encode.concatRGBA(y),F=UPNG.quantize(I,a),G=0,C=new Uint8Array(F.abuf);for(g=0;g<w.length;g++){var E=(K=w[g].img).length;_.push(new Uint8Array(F.inds.buffer,G>>2,E>>2));for(v=0;v<E;v+=4)K[v]=C[G+v],K[v+1]=C[G+v+1],K[v+2]=C[G+v+2],K[v+3]=C[G+v+3];G+=E}for(g=0;g<F.plte.length;g++)b.push(F.plte[g].est.rgba)}else for(v=0;v<w.length;v++){var B=w[v],Z=new Uint32Array(B.img.buffer),x=B.rect.width,M=(U=Z.length,new Uint8Array(U));_.push(M);for(g=0;g<U;g++){var R=Z[g];if(0!=g&&R==Z[g-1])M[g]=M[g-1];else if(g>x&&R==Z[g-x])M[g]=M[g-x];else{var Q=P[R];if(null==Q&&(P[R]=Q=b.length,b.push(R),b.length>=300))break;M[g]=Q}}}var T=b.length;T<=256&&0==u&&(h=T<=2?1:T<=4?2:T<=16?4:8,h=Math.max(h,l));for(v=0;v<w.length;v++){(B=w[v]).rect.x,B.rect.y,x=B.rect.width;var D=B.rect.height,O=B.img,V=(new Uint32Array(O.buffer),4*x),z=4;if(T<=256&&0==u){V=Math.ceil(h*x/8);for(var k=new Uint8Array(V*D),L=_[v],S=0;S<D;S++){g=S*V;var q=S*x;if(8==h)for(var j=0;j<x;j++)k[g+j]=L[q+j];else if(4==h)for(j=0;j<x;j++)k[g+(j>>1)]|=L[q+j]<<4-4*(1&j);else if(2==h)for(j=0;j<x;j++)k[g+(j>>2)]|=L[q+j]<<6-2*(3&j);else if(1==h)for(j=0;j<x;j++)k[g+(j>>3)]|=L[q+j]<<7-1*(7&j)}O=k,d=3,z=1}else if(0==m&&1==w.length){k=new Uint8Array(x*D*3);var $=x*D;for(g=0;g<$;g++){var K,J=4*g;k[K=3*g]=O[J],k[K+1]=O[J+1],k[K+2]=O[J+2]}O=k,d=2,z=3,V=3*x}B.img=O,B.bpl=V,B.bpp=z}return{ctype:d,depth:h,plte:b,frames:w}},UPNG.encode.framize=function(e,r,t,a,i,f){for(var c=[],s=0;s<e.length;s++){var l,u=new Uint8Array(e[s]),d=new Uint32Array(u.buffer),h=0,A=0,v=r,p=t,U=a?1:0;if(0!=s){for(var g=f||a||1==s||0!=c[s-2].dispose?1:2,m=0,w=1e9,P=0;P<g;P++){for(var b=new Uint8Array(e[s-1-P]),_=new Uint32Array(e[s-1-P]),y=r,I=t,F=-1,G=-1,C=0;C<t;C++)for(var E=0;E<r;E++){d[T=C*r+E]!=_[T]&&(E<y&&(y=E),E>F&&(F=E),C<I&&(I=C),C>G&&(G=C))}-1==F&&(y=I=F=G=0),i&&(1==(1&y)&&y--,1==(1&I)&&I--);var B=(F-y+1)*(G-I+1);B<w&&(w=B,m=P,h=y,A=I,v=F-y+1,p=G-I+1)}b=new Uint8Array(e[s-1-m]);1==m&&(c[s-1].dispose=2),l=new Uint8Array(v*p*4),UPNG._copyTile(b,r,t,l,v,p,-h,-A,0),1==(U=UPNG._copyTile(u,r,t,l,v,p,-h,-A,3)?1:0)?UPNG.encode._prepareDiff(u,r,t,l,{x:h,y:A,width:v,height:p}):UPNG._copyTile(u,r,t,l,v,p,-h,-A,0)}else l=u.slice(0);c.push({rect:{x:h,y:A,width:v,height:p},img:l,blend:U,dispose:0})}if(a)for(s=0;s<c.length;s++){if(1!=(D=c[s]).blend){var Z=D.rect,x=c[s-1].rect,M=Math.min(Z.x,x.x),R=Math.min(Z.y,x.y),Q={x:M,y:R,width:Math.max(Z.x+Z.width,x.x+x.width)-M,height:Math.max(Z.y+Z.height,x.y+x.height)-R};c[s-1].dispose=1,s-1!=0&&UPNG.encode._updateFrame(e,r,t,c,s-1,Q,i),UPNG.encode._updateFrame(e,r,t,c,s,Q,i)}}if(1!=e.length)for(var T=0;T<c.length;T++){var D;(D=c[T]).rect.width*D.rect.height}return c},UPNG.encode._updateFrame=function(e,r,t,a,i,f,c){for(var s=Uint8Array,l=Uint32Array,u=new s(e[i-1]),d=new l(e[i-1]),h=i+1<e.length?new s(e[i+1]):null,A=new s(e[i]),v=new l(A.buffer),p=r,U=t,g=-1,m=-1,w=0;w<f.height;w++)for(var P=0;P<f.width;P++){var b=f.x+P,_=f.y+w,y=_*r+b,I=v[y];0==I||0==a[i-1].dispose&&d[y]==I&&(null==h||0!=h[4*y+3])||(b<p&&(p=b),b>g&&(g=b),_<U&&(U=_),_>m&&(m=_))}-1==g&&(p=U=g=m=0),c&&(1==(1&p)&&p--,1==(1&U)&&U--),f={x:p,y:U,width:g-p+1,height:m-U+1};var F=a[i];F.rect=f,F.blend=1,F.img=new Uint8Array(f.width*f.height*4),0==a[i-1].dispose?(UPNG._copyTile(u,r,t,F.img,f.width,f.height,-f.x,-f.y,0),UPNG.encode._prepareDiff(A,r,t,F.img,f)):UPNG._copyTile(A,r,t,F.img,f.width,f.height,-f.x,-f.y,0)},UPNG.encode._prepareDiff=function(e,r,t,a,i){UPNG._copyTile(e,r,t,a,i.width,i.height,-i.x,-i.y,2)},UPNG.encode._filterZero=function(e,r,t,a,i,f,c){var s,l=[],u=[0,1,2,3,4];-1!=f?u=[f]:(r*a>5e5||1==t)&&(u=[0]),c&&(s={level:0});for(var d=UZIP,h=0;h<u.length;h++){for(var A=0;A<r;A++)UPNG.encode._filterLine(i,e,A,a,t,u[h]);l.push(d.deflate(i,s))}var v,p=1e9;for(h=0;h<l.length;h++)l[h].length<p&&(v=h,p=l[h].length);return l[v]},UPNG.encode._filterLine=function(e,r,t,a,i,f){var c=t*a,s=c+t,l=UPNG.decode._paeth;if(e[s]=f,s++,0==f)if(a<500)for(var u=0;u<a;u++)e[s+u]=r[c+u];else e.set(new Uint8Array(r.buffer,c,a),s);else if(1==f){for(u=0;u<i;u++)e[s+u]=r[c+u];for(u=i;u<a;u++)e[s+u]=r[c+u]-r[c+u-i]+256&255}else if(0==t){for(u=0;u<i;u++)e[s+u]=r[c+u];if(2==f)for(u=i;u<a;u++)e[s+u]=r[c+u];if(3==f)for(u=i;u<a;u++)e[s+u]=r[c+u]-(r[c+u-i]>>1)+256&255;if(4==f)for(u=i;u<a;u++)e[s+u]=r[c+u]-l(r[c+u-i],0,0)+256&255}else{if(2==f)for(u=0;u<a;u++)e[s+u]=r[c+u]+256-r[c+u-a]&255;if(3==f){for(u=0;u<i;u++)e[s+u]=r[c+u]+256-(r[c+u-a]>>1)&255;for(u=i;u<a;u++)e[s+u]=r[c+u]+256-(r[c+u-a]+r[c+u-i]>>1)&255}if(4==f){for(u=0;u<i;u++)e[s+u]=r[c+u]+256-l(0,r[c+u-a],0)&255;for(u=i;u<a;u++)e[s+u]=r[c+u]+256-l(r[c+u-i],r[c+u-a],r[c+u-i-a])&255}}},UPNG.crc={table:function(){for(var e=new Uint32Array(256),r=0;r<256;r++){for(var t=r,a=0;a<8;a++)1&t?t=3988292384^t>>>1:t>>>=1;e[r]=t}return e}(),update:function update(e,r,t,a){for(var i=0;i<a;i++)e=UPNG.crc.table[255&(e^r[t+i])]^e>>>8;return e},crc:function crc(e,r,t){return 4294967295^UPNG.crc.update(4294967295,e,r,t)}},UPNG.quantize=function(e,r){var t,a=new Uint8Array(e),i=a.slice(0),f=new Uint32Array(i.buffer),c=UPNG.quantize.getKDtree(i,r),s=c[0],l=c[1],u=UPNG.quantize.planeDst,d=a,h=f,A=d.length,v=new Uint8Array(a.length>>2);if(a.length<2e7)for(var p=0;p<A;p+=4){var U=d[p]*(1/255),g=d[p+1]*(1/255),m=d[p+2]*(1/255),w=d[p+3]*(1/255);t=UPNG.quantize.getNearest(s,U,g,m,w),v[p>>2]=t.ind,h[p>>2]=t.est.rgba}else for(p=0;p<A;p+=4){U=d[p]*(1/255),g=d[p+1]*(1/255),m=d[p+2]*(1/255),w=d[p+3]*(1/255);for(t=s;t.left;)t=u(t.est,U,g,m,w)<=0?t.left:t.right;v[p>>2]=t.ind,h[p>>2]=t.est.rgba}return{abuf:i.buffer,inds:v,plte:l}},UPNG.quantize.getKDtree=function(e,r,t){null==t&&(t=1e-4);var a=new Uint32Array(e.buffer),i={i0:0,i1:e.length,bst:null,est:null,tdst:0,left:null,right:null};i.bst=UPNG.quantize.stats(e,i.i0,i.i1),i.est=UPNG.quantize.estats(i.bst);for(var f=[i];f.length<r;){for(var c=0,s=0,l=0;l<f.length;l++)f[l].est.L>c&&(c=f[l].est.L,s=l);if(c<t)break;var u=f[s],d=UPNG.quantize.splitPixels(e,a,u.i0,u.i1,u.est.e,u.est.eMq255);if(u.i0>=d||u.i1<=d)u.est.L=0;else{var h={i0:u.i0,i1:d,bst:null,est:null,tdst:0,left:null,right:null};h.bst=UPNG.quantize.stats(e,h.i0,h.i1),h.est=UPNG.quantize.estats(h.bst);var A={i0:d,i1:u.i1,bst:null,est:null,tdst:0,left:null,right:null};A.bst={R:[],m:[],N:u.bst.N-h.bst.N};for(l=0;l<16;l++)A.bst.R[l]=u.bst.R[l]-h.bst.R[l];for(l=0;l<4;l++)A.bst.m[l]=u.bst.m[l]-h.bst.m[l];A.est=UPNG.quantize.estats(A.bst),u.left=h,u.right=A,f[s]=h,f.push(A)}}f.sort((function(e,r){return r.bst.N-e.bst.N}));for(l=0;l<f.length;l++)f[l].ind=l;return[i,f]},UPNG.quantize.getNearest=function(e,r,t,a,i){if(null==e.left)return e.tdst=UPNG.quantize.dist(e.est.q,r,t,a,i),e;var f=UPNG.quantize.planeDst(e.est,r,t,a,i),c=e.left,s=e.right;f>0&&(c=e.right,s=e.left);var l=UPNG.quantize.getNearest(c,r,t,a,i);if(l.tdst<=f*f)return l;var u=UPNG.quantize.getNearest(s,r,t,a,i);return u.tdst<l.tdst?u:l},UPNG.quantize.planeDst=function(e,r,t,a,i){var f=e.e;return f[0]*r+f[1]*t+f[2]*a+f[3]*i-e.eMq},UPNG.quantize.dist=function(e,r,t,a,i){var f=r-e[0],c=t-e[1],s=a-e[2],l=i-e[3];return f*f+c*c+s*s+l*l},UPNG.quantize.splitPixels=function(e,r,t,a,i,f){var c=UPNG.quantize.vecDot;for(a-=4;t<a;){for(;c(e,t,i)<=f;)t+=4;for(;c(e,a,i)>f;)a-=4;if(t>=a)break;var s=r[t>>2];r[t>>2]=r[a>>2],r[a>>2]=s,t+=4,a-=4}for(;c(e,t,i)>f;)t-=4;return t+4},UPNG.quantize.vecDot=function(e,r,t){return e[r]*t[0]+e[r+1]*t[1]+e[r+2]*t[2]+e[r+3]*t[3]},UPNG.quantize.stats=function(e,r,t){for(var a=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],i=[0,0,0,0],f=t-r>>2,c=r;c<t;c+=4){var s=e[c]*(1/255),l=e[c+1]*(1/255),u=e[c+2]*(1/255),d=e[c+3]*(1/255);i[0]+=s,i[1]+=l,i[2]+=u,i[3]+=d,a[0]+=s*s,a[1]+=s*l,a[2]+=s*u,a[3]+=s*d,a[5]+=l*l,a[6]+=l*u,a[7]+=l*d,a[10]+=u*u,a[11]+=u*d,a[15]+=d*d}return a[4]=a[1],a[8]=a[2],a[9]=a[6],a[12]=a[3],a[13]=a[7],a[14]=a[11],{R:a,m:i,N:f}},UPNG.quantize.estats=function(e){var r=e.R,t=e.m,a=e.N,i=t[0],f=t[1],c=t[2],s=t[3],l=0==a?0:1/a,u=[r[0]-i*i*l,r[1]-i*f*l,r[2]-i*c*l,r[3]-i*s*l,r[4]-f*i*l,r[5]-f*f*l,r[6]-f*c*l,r[7]-f*s*l,r[8]-c*i*l,r[9]-c*f*l,r[10]-c*c*l,r[11]-c*s*l,r[12]-s*i*l,r[13]-s*f*l,r[14]-s*c*l,r[15]-s*s*l],d=u,h=UPNG.M4,A=[Math.random(),Math.random(),Math.random(),Math.random()],v=0,p=0;if(0!=a)for(var U=0;U<16&&(A=h.multVec(d,A),p=Math.sqrt(h.dot(A,A)),A=h.sml(1/p,A),!(0!=U&&Math.abs(p-v)<1e-9));U++)v=p;var g=[i*l,f*l,c*l,s*l];return{Cov:u,q:g,e:A,L:v,eMq255:h.dot(h.sml(255,g),A),eMq:h.dot(A,g),rgba:(Math.round(255*g[3])<<24|Math.round(255*g[2])<<16|Math.round(255*g[1])<<8|Math.round(255*g[0])<<0)>>>0}},UPNG.M4={multVec:function multVec(e,r){return[e[0]*r[0]+e[1]*r[1]+e[2]*r[2]+e[3]*r[3],e[4]*r[0]+e[5]*r[1]+e[6]*r[2]+e[7]*r[3],e[8]*r[0]+e[9]*r[1]+e[10]*r[2]+e[11]*r[3],e[12]*r[0]+e[13]*r[1]+e[14]*r[2]+e[15]*r[3]]},dot:function dot(e,r){return e[0]*r[0]+e[1]*r[1]+e[2]*r[2]+e[3]*r[3]},sml:function sml(e,r){return[e*r[0],e*r[1],e*r[2],e*r[3]]}},UPNG.encode.concatRGBA=function(e){for(var r=0,t=0;t<e.length;t++)r+=e[t].byteLength;var a=new Uint8Array(r),i=0;for(t=0;t<e.length;t++){for(var f=new Uint8Array(e[t]),c=f.length,s=0;s<c;s+=4){var l=f[s],u=f[s+1],d=f[s+2],h=f[s+3];0==h&&(l=u=d=0),a[i+s]=l,a[i+s+1]=u,a[i+s+2]=d,a[i+s+3]=h}i+=c}return a.buffer};var isBrowser="undefined"!=typeof window,moduleMapper=isBrowser&&window.cordova&&window.cordova.require&&window.cordova.require("cordova/modulemapper"),CustomFile=isBrowser&&(moduleMapper&&moduleMapper.getOriginalSymbol(window,"File")||File),CustomFileReader=isBrowser&&(moduleMapper&&moduleMapper.getOriginalSymbol(window,"FileReader")||FileReader);function isAutoOrientationInBrowser(){return new Promise((function(e,r){var t,a,i,f;return void 0!==isAutoOrientationInBrowser.result?e(isAutoOrientationInBrowser.result):("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==",getFilefromDataUrl("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==","test.jpg",Date.now()).then((function(c){try{return drawFileInCanvas(t=c).then((function(c){try{return canvasToFile(a=c[1],t.type,t.name,t.lastModified).then((function(t){try{return i=t,cleanupCanvasMemory(a),drawFileInCanvas(i).then((function(t){try{return f=t[0],isAutoOrientationInBrowser.result=1===f.width&&2===f.height,e(isAutoOrientationInBrowser.result)}catch(e){return r(e)}}),r)}catch(e){return r(e)}}),r)}catch(e){return r(e)}}),r)}catch(e){return r(e)}}),r))}))}function getDataUrlFromFile(e){return new Promise((function(r,t){var a=new CustomFileReader;a.onload=function(){return r(a.result)},a.onerror=function(e){return t(e)},a.readAsDataURL(e)}))}function getFilefromDataUrl(e,r){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Date.now();return new Promise((function(a){for(var i=e.split(","),f=i[0].match(/:(.*?);/)[1],c=globalThis.atob(i[1]),s=c.length,l=new Uint8Array(s);s--;)l[s]=c.charCodeAt(s);var u=new Blob([l],{type:f});u.name=r,u.lastModified=t,a(u)}))}function loadImage(e){return new Promise((function(r,t){var a=new Image;a.onload=function(){return r(a)},a.onerror=function(e){return t(e)},a.src=e}))}function drawImageInCanvas(e){var r=_slicedToArray(getNewCanvasAndCtx(e.width,e.height),2),t=r[0];return r[1].drawImage(e,0,0,t.width,t.height),t}function drawFileInCanvas(e){return new Promise((function(r,t){var a,i,f=function $Try_1_Post(){try{return i=drawImageInCanvas(a),r([a,i])}catch(e){return t(e)}},c=function $Try_1_Catch(r){try{return getDataUrlFromFile(e).then((function(e){try{return loadImage(e).then((function(e){try{return a=e,f()}catch(e){return t(e)}}),t)}catch(e){return t(e)}}),t)}catch(e){return t(e)}};try{return createImageBitmap(e).then((function(e){try{return a=e,f()}catch(e){return c()}}),c)}catch(e){c()}}))}function canvasToFile(e,r,t,a){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1;return new Promise((function(f,c){var s,l,u;if("image/png"===r)return l=e.getContext("2d").getImageData(0,0,e.width,e.height).data,u=UPNG.encode([l],e.width,e.height,256*i),(s=new Blob([u],{type:r})).name=t,s.lastModified=a,$If_4.call(this);{return"function"==typeof OffscreenCanvas&&e instanceof OffscreenCanvas?e.convertToBlob({type:r,quality:i}).then(function(e){try{return(s=e).name=t,s.lastModified=a,$If_5.call(this)}catch(e){return c(e)}}.bind(this),c):getFilefromDataUrl(e.toDataURL(r,i),t,a).then(function(e){try{return s=e,$If_5.call(this)}catch(e){return c(e)}}.bind(this),c);function $If_5(){return $If_4.call(this)}}function $If_4(){return f(s)}}))}function getExifOrientation(e){return new Promise((function(r,t){var a=new CustomFileReader;a.onload=function(e){var t=new DataView(e.target.result);if(65496!=t.getUint16(0,!1))return r(-2);for(var a=t.byteLength,i=2;i<a;){if(t.getUint16(i+2,!1)<=8)return r(-1);var f=t.getUint16(i,!1);if(i+=2,65505==f){if(1165519206!=t.getUint32(i+=2,!1))return r(-1);var c=18761==t.getUint16(i+=6,!1);i+=t.getUint32(i+4,c);var s=t.getUint16(i,c);i+=2;for(var l=0;l<s;l++)if(274==t.getUint16(i+12*l,c))return r(t.getUint16(i+12*l+8,c))}else{if(65280!=(65280&f))break;i+=t.getUint16(i,!1)}}return r(-1)},a.onerror=function(e){return t(e)},a.readAsArrayBuffer(e)}))}function handleMaxWidthOrHeight(e,r){var t,a=e.width,i=e.height,f=r.maxWidthOrHeight,c=e;if(isFinite(f)&&(a>f||i>f)){var s=_slicedToArray(getNewCanvasAndCtx(a,i),2);c=s[0],t=s[1],a>i?(c.width=f,c.height=i/a*f):(c.width=a/i*f,c.height=f),t.drawImage(e,0,0,c.width,c.height),cleanupCanvasMemory(e)}return c}function followExifOrientation(e,r){var t=e.width,a=e.height,i=_slicedToArray(getNewCanvasAndCtx(t,a),2),f=i[0],c=i[1];switch(4<r&&r<9?(f.width=a,f.height=t):(f.width=t,f.height=a),r){case 2:c.transform(-1,0,0,1,t,0);break;case 3:c.transform(-1,0,0,-1,t,a);break;case 4:c.transform(1,0,0,-1,0,a);break;case 5:c.transform(0,1,1,0,0,0);break;case 6:c.transform(0,1,-1,0,a,0);break;case 7:c.transform(0,-1,-1,0,a,t);break;case 8:c.transform(0,-1,1,0,0,t)}return c.drawImage(e,0,0,t,a),cleanupCanvasMemory(e),f}function getNewCanvasAndCtx(e,r){var t,a;try{if(null===(a=(t=new OffscreenCanvas(e,r)).getContext("2d")))throw new Error("getContext of OffscreenCanvas returns null")}catch(e){a=(t=document.createElement("canvas")).getContext("2d")}return t.width=e,t.height=r,[t,a]}function cleanupCanvasMemory(e){e.width=0,e.height=0}function compress(e,r){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return new Promise((function(a,i){var f,c,s,l,u,d,h,A,v,p,U,g,m,w,P,b,_,y;function incProgress(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:5;f+=e,r.onProgress(Math.min(f,100))}function setProgress(e){f=Math.min(Math.max(e,f),100),r.onProgress(f)}return f=t,c=r.maxIteration||10,s=1024*r.maxSizeMB*1024,incProgress(),drawFileInCanvas(e).then(function(t){try{var f=_slicedToArray(t,2);return f[0],l=f[1],incProgress(),u=handleMaxWidthOrHeight(l,r),incProgress(),new Promise((function(t,a){var i;if(!(i=r.exifOrientation))return getExifOrientation(e).then(function(e){try{return i=e,$If_2.call(this)}catch(e){return a(e)}}.bind(this),a);function $If_2(){return t(i)}return $If_2.call(this)})).then(function(t){try{return d=t,incProgress(),isAutoOrientationInBrowser().then(function(t){try{return h=t?u:followExifOrientation(u,d),incProgress(),A=r.initialQuality||1,v=r.fileType||e.type,canvasToFile(h,v,e.name,e.lastModified,A).then(function(r){try{{if(p=r,incProgress(),U=p.size>s,g=p.size>e.size,!U&&!g)return setProgress(100),a(p);var t;function $Loop_3(){if(c--&&(P>s||P>m)){var r,t,a=_slicedToArray(getNewCanvasAndCtx(r=U?.95*y.width:y.width,t=U?.95*y.height:y.height),2);return _=a[0],a[1].drawImage(y,0,0,r,t),A*=.95,canvasToFile(_,v,e.name,e.lastModified,A).then((function(e){try{return b=e,cleanupCanvasMemory(y),y=_,P=b.size,setProgress(Math.min(99,Math.floor((w-P)/(w-s)*100))),$Loop_3}catch(e){return i(e)}}),i)}return[1]}return m=e.size,w=p.size,P=w,y=h,(t=function(e){for(;e;){if(e.then)return void e.then(t,i);try{if(e.pop){if(e.length)return e.pop()?$Loop_3_exit.call(this):e;e=$Loop_3}else e=e.call(this)}catch(e){return i(e)}}}.bind(this))($Loop_3);function $Loop_3_exit(){return cleanupCanvasMemory(y),cleanupCanvasMemory(_),cleanupCanvasMemory(u),cleanupCanvasMemory(h),cleanupCanvasMemory(l),setProgress(100),a(b)}}}catch(e){return i(e)}}.bind(this),i)}catch(e){return i(e)}}.bind(this),i)}catch(e){return i(e)}}.bind(this),i)}catch(e){return i(e)}}.bind(this),i)}))}isBrowser&&(Number.isInteger=Number.isInteger||function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e});var cnt=0,imageCompressionLibUrl,worker;function createWorker(e){return"function"==typeof e&&(e="(".concat(f,")()")),new Worker(URL.createObjectURL(new Blob([e])))}function createSourceObject(e){return URL.createObjectURL(new Blob([e],{type:"application/javascript"}))}function stringify(e){return JSON.stringify(e,(function(e,r){return"function"==typeof r?"BIC_FN:::(() => ".concat(r.toString(),")()"):r}))}function parse(o){if("string"==typeof o)return o;var result={};return Object.entries(o).forEach((function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];if("string"==typeof value&&value.startsWith("BIC_FN:::"))try{result[key]=eval(value.replace(/^BIC_FN:::/,""))}catch(e){throw console.log(key,e),e}else result[key]=parse(value)})),result}function generateLib(){return createSourceObject("\n    // reconstruct library\n    function imageCompression (){return (".concat(imageCompression,").apply(null, arguments)}\n\n    imageCompression.getDataUrlFromFile = ").concat(imageCompression.getDataUrlFromFile,"\n    imageCompression.getFilefromDataUrl = ").concat(imageCompression.getFilefromDataUrl,"\n    imageCompression.loadImage = ").concat(imageCompression.loadImage,"\n    imageCompression.drawImageInCanvas = ").concat(imageCompression.drawImageInCanvas,"\n    imageCompression.drawFileInCanvas = ").concat(imageCompression.drawFileInCanvas,"\n    imageCompression.canvasToFile = ").concat(imageCompression.canvasToFile,"\n    imageCompression.getExifOrientation = ").concat(imageCompression.getExifOrientation,"\n    imageCompression.handleMaxWidthOrHeight = ").concat(imageCompression.handleMaxWidthOrHeight,"\n    imageCompression.followExifOrientation = ").concat(imageCompression.followExifOrientation,"\n    imageCompression.cleanupCanvasMemory = ").concat(imageCompression.cleanupCanvasMemory,"\n    imageCompression.isAutoOrientationInBrowser = ").concat(imageCompression.isAutoOrientationInBrowser,"\n\n    // functions / objects\n    getDataUrlFromFile = imageCompression.getDataUrlFromFile\n    getFilefromDataUrl = imageCompression.getFilefromDataUrl\n    loadImage = imageCompression.loadImage\n    drawImageInCanvas = imageCompression.drawImageInCanvas\n    drawFileInCanvas = imageCompression.drawFileInCanvas\n    canvasToFile = imageCompression.canvasToFile\n    getExifOrientation = imageCompression.getExifOrientation\n    handleMaxWidthOrHeight = imageCompression.handleMaxWidthOrHeight\n    followExifOrientation = imageCompression.followExifOrientation\n    cleanupCanvasMemory = imageCompression.cleanupCanvasMemory\n    isAutoOrientationInBrowser = imageCompression.isAutoOrientationInBrowser\n    \n    getNewCanvasAndCtx = ").concat(getNewCanvasAndCtx,"\n    CustomFileReader = FileReader\n    CustomFile = File\n    function _slicedToArray(arr, n) { return arr }\n    function _typeof(a) { return typeof a }\n    function compress (){return (").concat(compress,").apply(null, arguments)}\n\n    // Libraries\n    const parse = ").concat(parse,"\n    const UPNG = {}\n    UPNG.toRGBA8 = ").concat(UPNG.toRGBA8,"\n    UPNG.toRGBA8.decodeImage = ").concat(UPNG.toRGBA8.decodeImage,"\n    UPNG.decode = ").concat(UPNG.decode,"\n    UPNG.decode._decompress = ").concat(UPNG.decode._decompress,"\n    UPNG.decode._inflate = ").concat(UPNG.decode._inflate,"\n    UPNG.decode._readInterlace = ").concat(UPNG.decode._readInterlace,"\n    UPNG.decode._getBPP = ").concat(UPNG.decode._getBPP," \n    UPNG.decode._filterZero = ").concat(UPNG.decode._filterZero,"\n    UPNG.decode._paeth = ").concat(UPNG.decode._paeth,"\n    UPNG.decode._IHDR = ").concat(UPNG.decode._IHDR,"\n    UPNG._bin = parse(").concat(stringify(UPNG._bin),")\n    UPNG._copyTile = ").concat(UPNG._copyTile,"\n    UPNG.encode = ").concat(UPNG.encode,"\n    UPNG.encodeLL = ").concat(UPNG.encodeLL," \n    UPNG.encode._main = ").concat(UPNG.encode._main,"\n    UPNG.encode.compressPNG = ").concat(UPNG.encode.compressPNG," \n    UPNG.encode.compress = ").concat(UPNG.encode.compress,"\n    UPNG.encode.framize = ").concat(UPNG.encode.framize," \n    UPNG.encode._updateFrame = ").concat(UPNG.encode._updateFrame," \n    UPNG.encode._prepareDiff = ").concat(UPNG.encode._prepareDiff," \n    UPNG.encode._filterZero = ").concat(UPNG.encode._filterZero," \n    UPNG.encode._filterLine = ").concat(UPNG.encode._filterLine,"\n    UPNG.encode.concatRGBA = ").concat(UPNG.encode.concatRGBA,"\n    UPNG.crc = parse(").concat(stringify(UPNG.crc),")\n    UPNG.crc.table = ( function() {\n    var tab = new Uint32Array(256);\n    for (var n=0; n<256; n++) {\n      var c = n;\n      for (var k=0; k<8; k++) {\n        if (c & 1)  c = 0xedb88320 ^ (c >>> 1);\n        else        c = c >>> 1;\n      }\n      tab[n] = c;  }\n    return tab;  })()\n    UPNG.quantize = ").concat(UPNG.quantize," \n    UPNG.quantize.getKDtree = ").concat(UPNG.quantize.getKDtree," \n    UPNG.quantize.getNearest = ").concat(UPNG.quantize.getNearest," \n    UPNG.quantize.planeDst = ").concat(UPNG.quantize.planeDst," \n    UPNG.quantize.dist = ").concat(UPNG.quantize.dist,"     \n    UPNG.quantize.splitPixels = ").concat(UPNG.quantize.splitPixels," \n    UPNG.quantize.vecDot = ").concat(UPNG.quantize.vecDot," \n    UPNG.quantize.stats = ").concat(UPNG.quantize.stats," \n    UPNG.quantize.estats = ").concat(UPNG.quantize.estats,"\n    UPNG.M4 = parse(").concat(stringify(UPNG.M4),")\n    UPNG.encode.concatRGBA = ").concat(UPNG.encode.concatRGBA,'\n    UPNG.inflateRaw=function(){\n    var H={};H.H={};H.H.N=function(N,W){var R=Uint8Array,i=0,m=0,J=0,h=0,Q=0,X=0,u=0,w=0,d=0,v,C;\n      if(N[0]==3&&N[1]==0)return W?W:new R(0);var V=H.H,n=V.b,A=V.e,l=V.R,M=V.n,I=V.A,e=V.Z,b=V.m,Z=W==null;\n      if(Z)W=new R(N.length>>>2<<5);while(i==0){i=n(N,d,1);m=n(N,d+1,2);d+=3;if(m==0){if((d&7)!=0)d+=8-(d&7);\n        var D=(d>>>3)+4,q=N[D-4]|N[D-3]<<8;if(Z)W=H.H.W(W,w+q);W.set(new R(N.buffer,N.byteOffset+D,q),w);d=D+q<<3;\n        w+=q;continue}if(Z)W=H.H.W(W,w+(1<<17));if(m==1){v=b.J;C=b.h;X=(1<<9)-1;u=(1<<5)-1}if(m==2){J=A(N,d,5)+257;\n        h=A(N,d+5,5)+1;Q=A(N,d+10,4)+4;d+=14;var E=d,j=1;for(var c=0;c<38;c+=2){b.Q[c]=0;b.Q[c+1]=0}for(var c=0;\n                                                                                                        c<Q;c++){var K=A(N,d+c*3,3);b.Q[(b.X[c]<<1)+1]=K;if(K>j)j=K}d+=3*Q;M(b.Q,j);I(b.Q,j,b.u);v=b.w;C=b.d;\n        d=l(b.u,(1<<j)-1,J+h,N,d,b.v);var r=V.V(b.v,0,J,b.C);X=(1<<r)-1;var S=V.V(b.v,J,h,b.D);u=(1<<S)-1;M(b.C,r);\n        I(b.C,r,v);M(b.D,S);I(b.D,S,C)}while(!0){var T=v[e(N,d)&X];d+=T&15;var p=T>>>4;if(p>>>8==0){W[w++]=p}else if(p==256){break}else{var z=w+p-254;\n        if(p>264){var _=b.q[p-257];z=w+(_>>>3)+A(N,d,_&7);d+=_&7}var $=C[e(N,d)&u];d+=$&15;var s=$>>>4,Y=b.c[s],a=(Y>>>4)+n(N,d,Y&15);\n        d+=Y&15;while(w<z){W[w]=W[w++-a];W[w]=W[w++-a];W[w]=W[w++-a];W[w]=W[w++-a]}w=z}}}return W.length==w?W:W.slice(0,w)};\n      H.H.W=function(N,W){var R=N.length;if(W<=R)return N;var V=new Uint8Array(R<<1);V.set(N,0);return V};\n      H.H.R=function(N,W,R,V,n,A){var l=H.H.e,M=H.H.Z,I=0;while(I<R){var e=N[M(V,n)&W];n+=e&15;var b=e>>>4;\n        if(b<=15){A[I]=b;I++}else{var Z=0,m=0;if(b==16){m=3+l(V,n,2);n+=2;Z=A[I-1]}else if(b==17){m=3+l(V,n,3);\n          n+=3}else if(b==18){m=11+l(V,n,7);n+=7}var J=I+m;while(I<J){A[I]=Z;I++}}}return n};H.H.V=function(N,W,R,V){var n=0,A=0,l=V.length>>>1;\n        while(A<R){var M=N[A+W];V[A<<1]=0;V[(A<<1)+1]=M;if(M>n)n=M;A++}while(A<l){V[A<<1]=0;V[(A<<1)+1]=0;A++}return n};\n      H.H.n=function(N,W){var R=H.H.m,V=N.length,n,A,l,M,I,e=R.j;for(var M=0;M<=W;M++)e[M]=0;for(M=1;M<V;M+=2)e[N[M]]++;\n        var b=R.K;n=0;e[0]=0;for(A=1;A<=W;A++){n=n+e[A-1]<<1;b[A]=n}for(l=0;l<V;l+=2){I=N[l+1];if(I!=0){N[l]=b[I];\n          b[I]++}}};H.H.A=function(N,W,R){var V=N.length,n=H.H.m,A=n.r;for(var l=0;l<V;l+=2)if(N[l+1]!=0){var M=l>>1,I=N[l+1],e=M<<4|I,b=W-I,Z=N[l]<<b,m=Z+(1<<b);\n        while(Z!=m){var J=A[Z]>>>15-W;R[J]=e;Z++}}};H.H.l=function(N,W){var R=H.H.m.r,V=15-W;for(var n=0;n<N.length;\n                                                                                                 n+=2){var A=N[n]<<W-N[n+1];N[n]=R[A]>>>V}};H.H.M=function(N,W,R){R=R<<(W&7);var V=W>>>3;N[V]|=R;N[V+1]|=R>>>8};\n      H.H.I=function(N,W,R){R=R<<(W&7);var V=W>>>3;N[V]|=R;N[V+1]|=R>>>8;N[V+2]|=R>>>16};H.H.e=function(N,W,R){return(N[W>>>3]|N[(W>>>3)+1]<<8)>>>(W&7)&(1<<R)-1};\n      H.H.b=function(N,W,R){return(N[W>>>3]|N[(W>>>3)+1]<<8|N[(W>>>3)+2]<<16)>>>(W&7)&(1<<R)-1};H.H.Z=function(N,W){return(N[W>>>3]|N[(W>>>3)+1]<<8|N[(W>>>3)+2]<<16)>>>(W&7)};\n      H.H.i=function(N,W){return(N[W>>>3]|N[(W>>>3)+1]<<8|N[(W>>>3)+2]<<16|N[(W>>>3)+3]<<24)>>>(W&7)};H.H.m=function(){var N=Uint16Array,W=Uint32Array;\n        return{K:new N(16),j:new N(16),X:[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],S:[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],T:[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0],q:new N(32),p:[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,65535,65535],z:[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0],c:new W(32),J:new N(512),_:[],h:new N(32),$:[],w:new N(32768),C:[],v:[],d:new N(32768),D:[],u:new N(512),Q:[],r:new N(1<<15),s:new W(286),Y:new W(30),a:new W(19),t:new W(15e3),k:new N(1<<16),g:new N(1<<15)}}();\n      (function(){var N=H.H.m,W=1<<15;for(var R=0;R<W;R++){var V=R;V=(V&2863311530)>>>1|(V&1431655765)<<1;\n        V=(V&3435973836)>>>2|(V&858993459)<<2;V=(V&4042322160)>>>4|(V&252645135)<<4;V=(V&4278255360)>>>8|(V&16711935)<<8;\n        N.r[R]=(V>>>16|V<<16)>>>17}function n(A,l,M){while(l--!=0)A.push(0,M)}for(var R=0;R<32;R++){N.q[R]=N.S[R]<<3|N.T[R];\n        N.c[R]=N.p[R]<<4|N.z[R]}n(N._,144,8);n(N._,255-143,9);n(N._,279-255,7);n(N._,287-279,8);H.H.n(N._,9);\n        H.H.A(N._,9,N.J);H.H.l(N._,9);n(N.$,32,5);H.H.n(N.$,5);H.H.A(N.$,5,N.h);H.H.l(N.$,5);n(N.Q,19,0);n(N.C,286,0);\n        n(N.D,30,0);n(N.v,320,0)}());return H.H.N}()\n    \n    const UZIP = {}\n    UZIP["parse"] = ').concat(UZIP_1.parse,"\n    UZIP._readLocal = ").concat(UZIP_1._readLocal,"\n    UZIP.inflateRaw = ").concat(UZIP_1.inflateRaw,"\n    UZIP.inflate = ").concat(UZIP_1.inflate,"\n    UZIP.deflate = ").concat(UZIP_1.deflate,"\n    UZIP.deflateRaw = ").concat(UZIP_1.deflateRaw,"\n    UZIP.encode = ").concat(UZIP_1.encode,"\n    UZIP._noNeed = ").concat(UZIP_1._noNeed,"\n    UZIP._writeHeader = ").concat(UZIP_1._writeHeader,"\n    UZIP.crc = parse(").concat(stringify(UZIP_1.crc),")\n    UZIP.crc.table = ( function() {\n      var tab = new Uint32Array(256);\n      for (var n=0; n<256; n++) {\n        var c = n;\n        for (var k=0; k<8; k++) {\n          if (c & 1)  c = 0xedb88320 ^ (c >>> 1);\n          else        c = c >>> 1;\n        }\n        tab[n] = c;  }\n      return tab;  })()\n    \n    UZIP.adler = ").concat(UZIP_1.adler,"\n    UZIP.bin = parse(").concat(stringify(UZIP_1.bin),")\n    UZIP.F = {}\n    UZIP.F.deflateRaw = ").concat(UZIP_1.F.deflateRaw,"\n    UZIP.F._bestMatch = ").concat(UZIP_1.F._bestMatch,"\n    UZIP.F._howLong = ").concat(UZIP_1.F._howLong,"\n    UZIP.F._hash = ").concat(UZIP_1.F._hash,"\n    UZIP.saved = ").concat(UZIP_1.saved,"\n    UZIP.F._writeBlock = ").concat(UZIP_1.F._writeBlock,"\n    UZIP.F._copyExact = ").concat(UZIP_1.F._copyExact,"\n    UZIP.F.getTrees = ").concat(UZIP_1.F.getTrees,"\n    UZIP.F.getSecond = ").concat(UZIP_1.F.getSecond,"\n    UZIP.F.nonZero = ").concat(UZIP_1.F.nonZero,"\n    UZIP.F.contSize = ").concat(UZIP_1.F.contSize,"\n    UZIP.F._codeTiny = ").concat(UZIP_1.F._codeTiny," \n    UZIP.F._lenCodes = ").concat(UZIP_1.F._lenCodes," \n    UZIP.F._hufTree = ").concat(UZIP_1.F._hufTree," \n    UZIP.F.setDepth = ").concat(UZIP_1.F.setDepth," \n    UZIP.F.restrictDepth = ").concat(UZIP_1.F.restrictDepth,"\n    UZIP.F._goodIndex = ").concat(UZIP_1.F._goodIndex," \n    UZIP.F._writeLit = ").concat(UZIP_1.F._writeLit," \n    UZIP.F.inflate = ").concat(UZIP_1.F.inflate," \n    UZIP.F._check = ").concat(UZIP_1.F._check," \n    UZIP.F._decodeTiny = ").concat(UZIP_1.F._decodeTiny," \n    UZIP.F._copyOut = ").concat(UZIP_1.F._copyOut," \n    UZIP.F.makeCodes = ").concat(UZIP_1.F.makeCodes," \n    UZIP.F.codes2map = ").concat(UZIP_1.F.codes2map," \n    UZIP.F.revCodes = ").concat(UZIP_1.F.revCodes," \n\n    // used only in deflate\n    UZIP.F._putsE = ").concat(UZIP_1.F._putsE,"\n    UZIP.F._putsF = ").concat(UZIP_1.F._putsF,"\n  \n    UZIP.F._bitsE = ").concat(UZIP_1.F._bitsE,"\n    UZIP.F._bitsF = ").concat(UZIP_1.F._bitsF,"\n\n    UZIP.F._get17 = ").concat(UZIP_1.F._get17,"\n    UZIP.F._get25 = ").concat(UZIP_1.F._get25,"\n    UZIP.F.U = function(){\n      var u16=Uint16Array, u32=Uint32Array;\n      return {\n        next_code : new u16(16),\n        bl_count  : new u16(16),\n        ordr : [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ],\n        of0  : [3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],\n        exb  : [0,0,0,0,0,0,0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4,  4,  5,  5,  5,  5,  0,  0,  0,  0],\n        ldef : new u16(32),\n        df0  : [1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577, 65535, 65535],\n        dxb  : [0,0,0,0,1,1,2, 2, 3, 3, 4, 4, 5, 5,  6,  6,  7,  7,  8,  8,   9,   9,  10,  10,  11,  11,  12,   12,   13,   13,     0,     0],\n        ddef : new u32(32),\n        flmap: new u16(  512),  fltree: [],\n        fdmap: new u16(   32),  fdtree: [],\n        lmap : new u16(32768),  ltree : [],  ttree:[],\n        dmap : new u16(32768),  dtree : [],\n        imap : new u16(  512),  itree : [],\n        //rev9 : new u16(  512)\n        rev15: new u16(1<<15),\n        lhst : new u32(286), dhst : new u32( 30), ihst : new u32(19),\n        lits : new u32(15000),\n        strt : new u16(1<<16),\n        prev : new u16(1<<15)\n      };\n    } ();\n\n    (function(){\n      var U = UZIP.F.U;\n      var len = 1<<15;\n      for(var i=0; i<len; i++) {\n        var x = i;\n        x = (((x & 0xaaaaaaaa) >>> 1) | ((x & 0x55555555) << 1));\n        x = (((x & 0xcccccccc) >>> 2) | ((x & 0x33333333) << 2));\n        x = (((x & 0xf0f0f0f0) >>> 4) | ((x & 0x0f0f0f0f) << 4));\n        x = (((x & 0xff00ff00) >>> 8) | ((x & 0x00ff00ff) << 8));\n        U.rev15[i] = (((x >>> 16) | (x << 16)))>>>17;\n      }\n  \n      function pushV(tgt, n, sv) {  while(n--!=0) tgt.push(0,sv);  }\n  \n      for(var i=0; i<32; i++) {  U.ldef[i]=(U.of0[i]<<3)|U.exb[i];  U.ddef[i]=(U.df0[i]<<4)|U.dxb[i];  }\n  \n      pushV(U.fltree, 144, 8);  pushV(U.fltree, 255-143, 9);  pushV(U.fltree, 279-255, 7);  pushV(U.fltree,287-279,8);\n      /*\n        var i = 0;\n        for(; i<=143; i++) U.fltree.push(0,8);\n        for(; i<=255; i++) U.fltree.push(0,9);\n        for(; i<=279; i++) U.fltree.push(0,7);\n        for(; i<=287; i++) U.fltree.push(0,8);\n        */\n      UZIP.F.makeCodes(U.fltree, 9);\n      UZIP.F.codes2map(U.fltree, 9, U.flmap);\n      UZIP.F.revCodes (U.fltree, 9)\n  \n      pushV(U.fdtree,32,5);\n      //for(i=0;i<32; i++) U.fdtree.push(0,5);\n      UZIP.F.makeCodes(U.fdtree, 5);\n      UZIP.F.codes2map(U.fdtree, 5, U.fdmap);\n      UZIP.F.revCodes (U.fdtree, 5)\n  \n      pushV(U.itree,19,0);  pushV(U.ltree,286,0);  pushV(U.dtree,30,0);  pushV(U.ttree,320,0);\n      /*\n        for(var i=0; i< 19; i++) U.itree.push(0,0);\n        for(var i=0; i<286; i++) U.ltree.push(0,0);\n        for(var i=0; i< 30; i++) U.dtree.push(0,0);\n        for(var i=0; i<320; i++) U.ttree.push(0,0);\n        */\n    })()\n    "))}function generateWorkerScript(){return createWorker("\n    let scriptImported = false\n    self.addEventListener('message', async (e) => {\n      const { file, id, imageCompressionLibUrl, options } = e.data\n      options.onProgress = (progress) => self.postMessage({ progress, id })\n      try {\n        if (!scriptImported) {\n          // console.log('[worker] importScripts', imageCompressionLibUrl)\n          self.importScripts(imageCompressionLibUrl)\n          scriptImported = true\n        }\n        // console.log('[worker] self', self)\n        const compressedFile = await imageCompression(file, options)\n        self.postMessage({ file: compressedFile, id })\n      } catch (e) {\n        // console.error('[worker] error', e)\n        self.postMessage({ error: e.message + '\\n' + e.stack, id })\n      }\n    })\n  ")}function compressOnWebWorker(e,r){return new Promise((function(t,a){return new Promise((function(i,f){var c=cnt++;return imageCompressionLibUrl||(imageCompressionLibUrl=generateLib()),worker||(worker=generateWorkerScript()),worker.addEventListener("message",(function handler(e){if(e.data.id===c){if(void 0!==e.data.progress)return void r.onProgress(e.data.progress);worker.removeEventListener("message",handler),e.data.error&&a(new Error(e.data.error)),t(e.data.file)}})),worker.addEventListener("error",a),worker.postMessage({file:e,id:c,imageCompressionLibUrl:imageCompressionLibUrl,options:_objectSpread2(_objectSpread2({},r),{},{onProgress:void 0})}),i()}))}))}function imageCompression(e,r){return new Promise((function(t,a){var i,f,c,s,l;if(f=0,r.maxSizeMB=r.maxSizeMB||Number.POSITIVE_INFINITY,s="boolean"!=typeof r.useWebWorker||r.useWebWorker,delete r.useWebWorker,c=r.onProgress,r.onProgress=function(e){f=e,"function"==typeof c&&c(f)},!(e instanceof Blob||e instanceof CustomFile))return a(new Error("The file given is not an instance of Blob or File"));if(!/^image/.test(e.type))return a(new Error("The file given is not an image"));if(l="undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope,!s||"function"!=typeof Worker||l)return compress(e,r).then(function(e){try{return i=e,$If_3.call(this)}catch(e){return a(e)}}.bind(this),a);var u=function(){try{return $If_3.call(this)}catch(e){return a(e)}}.bind(this),d=function $Try_1_Catch(t){try{return compress(e,r).then((function(e){try{return i=e,u()}catch(e){return a(e)}}),a)}catch(e){return a(e)}};try{return compressOnWebWorker(e,r).then((function(e){try{return i=e,u()}catch(e){return d()}}),d)}catch(e){d()}function $If_3(){try{i.name=e.name,i.lastModified=e.lastModified}catch(e){}return t(i)}}))}imageCompression.getDataUrlFromFile=getDataUrlFromFile,imageCompression.getFilefromDataUrl=getFilefromDataUrl,imageCompression.loadImage=loadImage,imageCompression.drawImageInCanvas=drawImageInCanvas,imageCompression.drawFileInCanvas=drawFileInCanvas,imageCompression.canvasToFile=canvasToFile,imageCompression.getExifOrientation=getExifOrientation,imageCompression.handleMaxWidthOrHeight=handleMaxWidthOrHeight,imageCompression.followExifOrientation=followExifOrientation,imageCompression.cleanupCanvasMemory=cleanupCanvasMemory,imageCompression.isAutoOrientationInBrowser=isAutoOrientationInBrowser,imageCompression.version="1.0.14";/* harmony default export */ __webpack_exports__["a"] = (imageCompression);
//# sourceMappingURL=browser-image-compression.mjs.map


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWN", function() { return DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEFT", function() { return LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RIGHT", function() { return RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swipeable", function() { return Swipeable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UP", function() { return UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSwipeable", function() { return useSwipeable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var defaultProps = {
  preventDefaultTouchmoveEvent: false,
  delta: 10,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState = {
  xy: [0, 0],
  swiping: false,
  eventData: undefined,
  start: undefined
};
var LEFT = 'Left';
var RIGHT = 'Right';
var UP = 'Up';
var DOWN = 'Down';
var touchStart = 'touchstart';
var touchMove = 'touchmove';
var touchEnd = 'touchend';
var mouseMove = 'mousemove';
var mouseUp = 'mouseup';

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return LEFT;
    }

    return RIGHT;
  } else if (deltaY > 0) {
    return UP;
  }

  return DOWN;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event.touches && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends({}, state, initialState, {
        eventData: {
          initial: [].concat(xy),
          first: true
        },
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
        return state;
      }

      var _ref2 = event.touches ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = state.xy[0] - x;
      var deltaY = state.xy[1] - y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);

      var eventData = _extends({}, state.eventData, {
        event: event,
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        velocity: velocity,
        dir: dir
      });

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault(); // first is now always false

      return _extends({}, state, {
        eventData: _extends({}, eventData, {
          first: false
        }),
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping) {
        eventData = _extends({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
      }

      return _extends({}, state, initialState, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };

  var attachTouch = function attachTouch(el) {
    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h);
      }); // return properly scoped cleanup method for removing listeners

      return function () {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = null;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef // if track mouse attach mouse down listener

  };

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = null;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el);
    }
  }

  return _extends({}, state, addState);
}

function useSwipeable(props) {
  var trackMouse = props.trackMouse;
  var transientState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(_extends({}, initialState, {
    type: 'hook'
  }));
  var transientProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();
  transientProps.current = _extends({}, defaultProps, props);

  var _React$useMemo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    return getHandlers(function (cb) {
      return transientState.current = cb(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      handlers = _React$useMemo[0],
      attachTouch = _React$useMemo[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
  return handlers;
}
var Swipeable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Swipeable, _React$PureComponent);

  function Swipeable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _this._set = function (cb) {
      _this.transientState = cb(_this.transientState, _this.props);
    };

    _this.transientState = _extends({}, initialState, {
      type: 'class'
    });
    return _this;
  }

  var _proto = Swipeable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        _this$props$nodeName = _this$props.nodeName,
        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
        innerRef = _this$props.innerRef,
        children = _this$props.children,
        trackMouse = _this$props.trackMouse;

    var _getHandlers = getHandlers(this._set, {
      trackMouse: trackMouse
    }),
        handlers = _getHandlers[0],
        attachTouch = _getHandlers[1];

    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
    var ref = innerRef ? function (el) {
      return innerRef(el), handlers.ref(el);
    } : handlers.ref;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(nodeName, _extends({}, handlers, {
      className: className,
      style: style,
      ref: ref
    }), children);
  };

  return Swipeable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);
Swipeable.propTypes = {
  onSwiped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwiping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  preventDefaultTouchmoveEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nodeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  trackMouse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  trackTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  rotationAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Swipeable.defaultProps = defaultProps;




/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
var DeleteModal=function DeleteModal(_ref){var processDelete=_ref.processDelete,isOpen=_ref.isOpen,handleClose=_ref.handleClose;var handleDelete=function handleDelete(){processDelete();handleClose();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{className:'confirmation-modal',overlayClassName:'confirmation-modal-overlay',contentLabel:'Delete Confirmation',onRequestClose:handleClose,isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'close confirmation-modal-button',style:{'paddingRight':'10px'},onClick:handleClose},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-title'},'Delete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-text'},'Are you sure you want to proceed?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmation-modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default',style:{'marginRight':'10px'},onClick:handleClose},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',onClick:handleDelete},'Delete'))));};DeleteModal.propTypes={processDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DeleteModal);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sales_order_component_list_SalesOrderList__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__invoice_component_list_InvoiceListContainer__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_component_list_PaymentList__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logistic_component_list_ShipmentListContainer__ = __webpack_require__(308);
var TabAccounting=function TabAccounting(props){var tab=props.tab,customer=props.customer;if(tab!==__WEBPACK_IMPORTED_MODULE_7__state_detail_const__["h" /* TAB_ACCOUNTING */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["l" /* ROLE_EMPLOYEE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__sales_order_component_list_SalesOrderList__["a" /* default */],{salesOrderList:customer.salesOrderList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__logistic_component_list_ShipmentListContainer__["a" /* default */],{shipmentList:customer.shipmentList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__invoice_component_list_InvoiceListContainer__["a" /* default */],{invoiceList:customer.invoiceList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__payment_component_list_PaymentList__["a" /* default */],{paymentList:customer.paymentList})));};TabAccounting.propTypes={tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TabAccounting);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_display_action__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_display_selector__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceList__ = __webpack_require__(316);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_display_selector__["b" /* selectOwnState */](state));};var mapDispatchToProps={createCorrection:__WEBPACK_IMPORTED_MODULE_1__state_display_action__["b" /* createCorrection */],showConfirmationModal:__WEBPACK_IMPORTED_MODULE_1__state_display_action__["c" /* showConfirmationModal */],closeConfirmationModal:__WEBPACK_IMPORTED_MODULE_1__state_display_action__["a" /* closeConfirmationModal */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__InvoiceList__["a" /* default */]));

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createCorrectionRequest */
/* unused harmony export createCorrectionSuccess */
/* unused harmony export createCorrectionError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createCorrection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeConfirmationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(533);
var createCorrectionRequest=function createCorrectionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CREATE_CORRECTION_REQUEST */],payload:{}};};var createCorrectionSuccess=function createCorrectionSuccess(invoice){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CREATE_CORRECTION_SUCCESS */],payload:{invoice:invoice}};};var createCorrectionError=function createCorrectionError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CREATE_CORRECTION_ERROR */],payload:{error:error}};};var createCorrection=function createCorrection(callback){return function(dispatch,getState){var state=getState();var invoice=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectInvoice */](state);if(!invoice){return null;}dispatch(createCorrectionRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/invoice/create-correction?invoiceId='+invoice.id).then(function(invoiceCorrection){dispatch(createCorrectionSuccess());callback(invoiceCorrection);}).catch(function(error){dispatch(createCorrectionError(error));});};};var showConfirmationModal=function showConfirmationModal(invoice){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SHOW_CONFIRMATION_MODAL */],payload:{invoice:invoice}};};var closeConfirmationModal=function closeConfirmationModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CLOSE_CONFIRMATION_MODAL */]};};

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INVOICE_TYPE_INVOICE; });
/* unused harmony export INVOICE_TYPE_CREDIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INVOICE_TYPE_INVOICE_CORRECTION; });
/* unused harmony export INVOICE_TYPE_PREPAYMENT */
/* unused harmony export TYPE_SET */
/* unused harmony export TYPE_TREATMENT */
/* unused harmony export PAYMENT_METHOD_CREDIT_CARD */
/* unused harmony export PAYMENT_METHOD_PREPAYMENT */
/* unused harmony export PAYMENT_METHOD_SEPA */
var INVOICE_TYPE_INVOICE='invoice';var INVOICE_TYPE_CREDIT='credit';var INVOICE_TYPE_INVOICE_CORRECTION='invoice_correction';var INVOICE_TYPE_PREPAYMENT='prepayment';var TYPE_SET='type_set';var TYPE_TREATMENT='type_treatment';var PAYMENT_METHOD_CREDIT_CARD='credit_card';var PAYMENT_METHOD_PREPAYMENT='prepayment';var PAYMENT_METHOD_SEPA='sepa';

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scan_file_upload_TreatmentPlanFileUploadContainer__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scan_file_upload_TreatmentPlanExternalFileUploadContainer__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scan_file_upload_ProductionFileUploadContainer__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scan_file_upload_ScanFileUploadContainer__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scan_file_upload_OtherFileUploadContainer__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scan_file_upload_ImplantScanFileUploadContainer__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scan_file_upload_XRayFileUploadContainer__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__task_widget_ConformityWidgetContainer__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cbct_file_upload_CbctFileUploadContainer__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sales_order_component_task_widget_CustomsInvoiceListWidgetContainer__ = __webpack_require__(538);
var TabFiles=function TabFiles(props){var tab=props.tab,customer=props.customer;if(tab!==__WEBPACK_IMPORTED_MODULE_11__state_detail_const__["k" /* TAB_FILES */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__scan_file_upload_ScanFileUploadContainer__["a" /* default */],{customer:customer,readOnly:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["j" /* ROLE_CUSTOMER_SERVICE_TEAM_LEAD */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__scan_file_upload_OtherFileUploadContainer__["a" /* default */],{customer:customer,readOnly:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__scan_file_upload_XRayFileUploadContainer__["a" /* default */],{customer:customer,readOnly:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__scan_file_upload_ImplantScanFileUploadContainer__["a" /* default */],{customer:customer,readOnly:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__cbct_file_upload_CbctFileUploadContainer__["a" /* default */],{customer:customer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_3__security_state_auth_const__["l" /* ROLE_EMPLOYEE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__scan_file_upload_TreatmentPlanFileUploadContainer__["a" /* default */],{customer:customer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__scan_file_upload_TreatmentPlanExternalFileUploadContainer__["a" /* default */],{customer:customer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__scan_file_upload_ProductionFileUploadContainer__["a" /* default */],{customer:customer})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__task_widget_ConformityWidgetContainer__["a" /* default */],{customer:customer,readOnly:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__sales_order_component_task_widget_CustomsInvoiceListWidgetContainer__["a" /* default */],{customer:customer,readOnly:true}));};TabFiles.propTypes={tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TabFiles);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["j" /* FILE_TYPE_TREATMENT_PLAN */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["j" /* FILE_TYPE_TREATMENT_PLAN */],visualizationRequested:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["c" /* selectVisualizationRequested */](state),widgetId:__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],taskName:props.taskName});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */],triggerVisualization:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["b" /* triggerVisualization */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */],widgetId:__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_16" /* TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["h" /* FILE_TYPE_PRODUCTION */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["h" /* FILE_TYPE_PRODUCTION */],widgetId:__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["i" /* FILE_TYPE_SCAN_FILE */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["i" /* FILE_TYPE_SCAN_FILE */],widgetId:__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["g" /* FILE_TYPE_OTHER_FILES */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["g" /* FILE_TYPE_OTHER_FILES */],widgetId:__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["e" /* FILE_TYPE_IMPLANT_SCAN_FILE */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["e" /* FILE_TYPE_IMPLANT_SCAN_FILE */],widgetId:__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_definition_customer_ui__ = __webpack_require__(94);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["l" /* FILE_TYPE_X_RAY */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["l" /* FILE_TYPE_X_RAY */],widgetId:__WEBPACK_IMPORTED_MODULE_6__ui_definition_customer_ui__["e" /* CUSTOMER_XRAY_FILE_UPLOAD */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_detail_action__ = __webpack_require__(32);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["c" /* selectCustomer */](state),readOnly:!__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["i" /* selectHasRole */](state,__WEBPACK_IMPORTED_MODULE_5__security_state_auth_const__["Q" /* ROLE_USER_ADMIN */]),fetching:__WEBPACK_IMPORTED_MODULE_2__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_3__state_const__["b" /* FILE_TYPE_CONFORMITY_DECLARATION */]),widgetId:__WEBPACK_IMPORTED_MODULE_4__process_ui_definition_process_ui__["m" /* CONFORMITY_DECLARATION_LIST_WIDGET */],fileType:__WEBPACK_IMPORTED_MODULE_3__state_const__["b" /* FILE_TYPE_CONFORMITY_DECLARATION */]});};var mapDispatchToProps={setDeleteFlag:__WEBPACK_IMPORTED_MODULE_8__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_9__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_9__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_7__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTableSetting; });
/* unused harmony export uploadCustomerFileRequest */
/* unused harmony export uploadCustomerFileSuccess */
/* unused harmony export uploadCustomerFileError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uploadCustomerFile; });
/* unused harmony export setDeleteFlagRequest */
/* unused harmony export setDeleteFlagSuccess */
/* unused harmony export setDeleteFlagError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setDeleteFlag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_cbct_file_upload_helper__ = __webpack_require__(1276);
var changeTableSetting=Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TABLE_SETTING */]);var uploadCustomerFileRequest=function uploadCustomerFileRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* UPLOAD_CUSTOMER_FILE_REQUEST */],payload:{}};};var uploadCustomerFileSuccess=function uploadCustomerFileSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* UPLOAD_CUSTOMER_FILE_SUCCESS */],payload:{}};};var uploadCustomerFileError=function uploadCustomerFileError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* UPLOAD_CUSTOMER_FILE_ERROR */],payload:{error:error}};};var uploadCustomerFile=function uploadCustomerFile(fileList,customerId,fileType,onUploadSuccess){return function(dispatch,getState){var state=getState();dispatch(uploadCustomerFileRequest());Object(__WEBPACK_IMPORTED_MODULE_4__util_cbct_file_upload_helper__["a" /* default */])(customerId,fileList,fileType,onUploadSuccess,state).then(function(isNoError){if(isNoError){dispatch(uploadCustomerFileSuccess());}else{dispatch(uploadCustomerFileError('Something went wrong'));}});};};var setDeleteFlagRequest=function setDeleteFlagRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* SET_DELETE_FLAG_REQUEST */],payload:{}};};var setDeleteFlagSuccess=function setDeleteFlagSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* SET_DELETE_FLAG_SUCCESS */],payload:{}};};var setDeleteFlagError=function setDeleteFlagError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* SET_DELETE_FLAG_ERROR */],payload:{error:error}};};var setDeleteFlag=function setDeleteFlag(fileId,onDeleteFlagSuccess){return function(dispatch,getState){dispatch(setDeleteFlagRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/file-system/set-delete-flag?fileId='+fileId).then(function(){dispatch(setDeleteFlagSuccess());onDeleteFlagSuccess(__WEBPACK_IMPORTED_MODULE_2__const__["a" /* FILE_TYPE_CBCT_FILE */],fileId);}).catch(function(error){dispatch(setDeleteFlagError(error));});};};

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(43);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getEndpoint=function getEndpoint(customerId){return __WEBPACK_IMPORTED_MODULE_1__util_api__["a" /* BACKEND_URL */]+'/api/customer/add-cbct-file?customerId='+customerId||'';};function uploadChunk(fileListChunk,endpoint){var chunkPromises=[];var _loop=function _loop(index){var file=fileListChunk[index];var data=new FormData();data.append('file',file);var filePromise=new Promise(function(resolve,reject){fetch(endpoint,{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){try{resolve(response.json());}catch(e){reject('Invalid json response');}}).catch(function(error){reject(error);});});chunkPromises.push(filePromise);};for(var index=0;index<fileListChunk.length;index++){_loop(index);}return chunkPromises;}/* harmony default export */ __webpack_exports__["a"] = ((function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(customerId,fileList,fileType,onUploadSuccess,state){var endpoint,chunkSize,fileListLength,i,fileListChunk,chunkPromises,isSuccess;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:endpoint=getEndpoint(customerId);chunkSize=5;fileListLength=fileList.length;i=0;case 4:if(!(i<fileListLength)){_context.next=15;break;}fileListChunk=fileList.slice(i,i+chunkSize);chunkPromises=uploadChunk(fileListChunk,endpoint);_context.next=9;return Promise.all(chunkPromises).then(function(fileMetadataList){fileMetadataList.forEach(function(fileMetadata){fileMetadata.createdByUser=__WEBPACK_IMPORTED_MODULE_2__globals__["a" /* default */].selector.selectUserDisplayNameById(state,fileMetadata.createdByUserId);onUploadSuccess(fileType,fileMetadata);});return true;}).catch(function(){alert('Something went wrong. Please refresh the page and try to upload once again or contact a system administrator');return false;});case 9:isSuccess=_context.sent;if(isSuccess){_context.next=12;break;}return _context.abrupt('return',false);case 12:i+=chunkSize;_context.next=4;break;case 15:return _context.abrupt('return',true);case 16:case'end':return _context.stop();}}},_callee,this);}));function uploadByChunks(_x,_x2,_x3,_x4,_x5){return _ref.apply(this,arguments);}return uploadByChunks;})());

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectTableSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__ = __webpack_require__(42);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectTableSetting=Object(__WEBPACK_IMPORTED_MODULE_2__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_file_upload_const__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_upload_helper__ = __webpack_require__(536);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var style={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'32px'};var VIEW_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/view-file?fileId=';var DOWNLOAD_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/download-file?fileId=';var DOWNLOAD_ALL_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/download-cbct-files?customerId=';var getColumnList=function getColumnList(fileType,setDeleteFlag,onFileDeleteFlagSuccess){return[{property:'fileName',header:'File name'},{property:'uploaded',header:'Uploaded',renderer:function renderer(file){return Object(__WEBPACK_IMPORTED_MODULE_7__util_datetime__["c" /* formatDateTime */])(file.created);}},{property:'download',header:'Download',renderer:function renderer(file){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:DOWNLOAD_URL+file.id},'download');}},{property:'view',header:'View',renderer:function renderer(file){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:VIEW_URL+file.id,target:'_blank',rel:'noopener noreferrer'},'view');}},{property:'createdByUser',header:'Uploaded By'},{property:'delete',header:'Delete',renderer:function renderer(file){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){setDeleteFlag(file.id,onFileDeleteFlagSuccess);},className:'btn btn-primary btn-sm'},'delete');}}];};var UploadedFileTable=function UploadedFileTable(_ref){var fileList=_ref.fileList,fileType=_ref.fileType,readOnly=_ref.readOnly,setDeleteFlag=_ref.setDeleteFlag,onFileDeleteFlagSuccess=_ref.onFileDeleteFlagSuccess,tableSetting=_ref.tableSetting,changeTableSetting=_ref.changeTableSetting;if(!fileList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__form_component_Table__["a" /* default */],{columnList:getColumnList(fileType,setDeleteFlag,onFileDeleteFlagSuccess),changeTableSetting:changeTableSetting,tableSetting:tableSetting,rowList:fileList,idProperty:'id'});};var CbctFileUpload=function CbctFileUpload(_ref2){var customer=_ref2.customer,fileType=_ref2.fileType,uploadCustomerFile=_ref2.uploadCustomerFile,onUploadSuccess=_ref2.onUploadSuccess,setDeleteFlag=_ref2.setDeleteFlag,onFileDeleteFlagSuccess=_ref2.onFileDeleteFlagSuccess,fetching=_ref2.fetching,tableSetting=_ref2.tableSetting,changeTableSetting=_ref2.changeTableSetting;if(!Object(__WEBPACK_IMPORTED_MODULE_10__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */])||!customer){return null;}var fileList=customer[fileType].filter(function(file){return!file.deleted;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'CBCT Files'},fileList.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{bottom:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:DOWNLOAD_ALL_URL+customer.id,className:'btn btn-primary btn-sm',target:'_blank',rel:'noopener noreferrer'},'Download all ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-cloud-download'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UploadedFileTable,{onFileDeleteFlagSuccess:onFileDeleteFlagSuccess,setDeleteFlag:setDeleteFlag,fileType:fileType,fileList:fileList,tableSetting:tableSetting,changeTableSetting:changeTableSetting}))),uploadCustomerFile!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__["a" /* default */],{multiple:true,maxSize:__WEBPACK_IMPORTED_MODULE_6__state_file_upload_const__["a" /* MAX_SCAN_FILE_SIZE */],style:style,disablePreview:true,getDataTransferItems:function getDataTransferItems(evt){return Object(__WEBPACK_IMPORTED_MODULE_13__util_upload_helper__["a" /* getDroppedOrSelectedFiles */])(evt).then(function(list){return list.map(function(_ref3){var fileObject=_ref3.fileObject,rest=_objectWithoutProperties(_ref3,['fileObject']);return fileObject;});});},onDrop:function onDrop(fileList){uploadCustomerFile(fileList,customer.id,fileType,onUploadSuccess);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload a file'))))));};CbctFileUpload.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fileType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CbctFileUpload);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tab_comments_NewProcessComment__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tab_comments_ProcessCommentList__ = __webpack_require__(1281);
var TabComments=function TabComments(props){var tab=props.tab;if(tab!==__WEBPACK_IMPORTED_MODULE_2__state_detail_const__["j" /* TAB_COMMENTS */]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tab_comments_ProcessCommentList__["a" /* default */],{findProcessCommentList:props.findProcessCommentList,processInstanceList:props.processInstanceList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tab_comments_NewProcessComment__["a" /* default */],props));};TabComments.propTypes={tab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,findProcessCommentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,processInstanceList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (TabComments);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_customer_ui__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose__ = __webpack_require__(19);
var infoStyle={marginBottom:'20px',color:'#727272'};var checkboxStyle={display:'inline-flex',marginLeft:'25px',verticalAlign:'bottom',marginBottom:'8px'};var iconStyle={marginLeft:'8px',marginBottom:'14px',verticalAlign:'bottom'};var NewProcessComment=function NewProcessComment(_ref){var changeProcessComment=_ref.changeProcessComment,commentText=_ref.commentText,addProcessComment=_ref.addProcessComment,isInternal=_ref.isInternal,changeIsCommentInternal=_ref.changeIsCommentInternal,currentUser=_ref.currentUser;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ui_definition_customer_ui__["a" /* CUSTOMER_ADD_COMMENT */])){return null;}var isEmployee=currentUser.roleList.includes('employee');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Add New Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-post'},isEmployee&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:infoStyle},'* Please be aware that your comment will be visible to everyone who uses our backend. If you want to make it visible to PlusDental employees only, please mark it as "internal comment". *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_TextArea__["a" /* default */],{className:'form-control comment-post-textarea',object:{commentText:commentText},name:'commentText',onChange:changeProcessComment,placeholder:'Enter comment. Click button below to submit.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!commentText,onClick:addProcessComment},'Save Comment'),isEmployee&&[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Checkbox__["a" /* default */],{style:checkboxStyle,onChange:changeIsCommentInternal,name:'isInternal',object:{isInternal:isInternal}},'Internal comment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:iconStyle,className:'fa fa-lock fa-lg'})])));};NewProcessComment.propTypes={changeProcessComment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,addProcessComment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,commentText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isInternal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,changeIsCommentInternal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){var _props=this.props,currentUser=_props.currentUser,changeIsCommentInternal=_props.changeIsCommentInternal;var isInternal=currentUser.roleList.includes('employee');changeIsCommentInternal(null,isInternal);}})(NewProcessComment));

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_component_instance_detail_CommentList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_definition_customer_ui__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose__ = __webpack_require__(19);
var ProcessCommentList=function ProcessCommentList(_ref){var processCommentList=_ref.processCommentList;if(processCommentList.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5',style:{border:'1px solid #eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,processCommentList.map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__process_component_instance_detail_CommentList__["a" /* Comment */],{key:comment.id,comment:comment});}))));};var ProcessInstance=function ProcessInstance(_ref2){var processInstance=_ref2.processInstance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__process_util_names__["d" /* renderProcessName */])(processInstance.processName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(processInstance.started)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(processInstance.lastStatusChange)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__process_util_names__["f" /* renderStateName */])(processInstance.currentStateName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__process_util_names__["g" /* renderTaskName */])(processInstance.currentTaskName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessCommentList,{processCommentList:processInstance.processCommentList}));};var ProcessInstanceList=function ProcessInstanceList(_ref3){var processInstanceList=_ref3.processInstanceList;if(!Object(__WEBPACK_IMPORTED_MODULE_9__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__ui_definition_customer_ui__["b" /* CUSTOMER_COMMENT_LIST */])){return null;}if(!processInstanceList||processInstanceList.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'View Comments'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Process'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Started'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Status Change'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Current State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Current Task'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processInstanceList.map(function(processInstance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessInstance,{key:processInstance.id,processInstance:processInstance});}))))));};ProcessInstanceList.propTypes={processInstanceList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,findProcessCommentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){var findProcessCommentList=this.props.findProcessCommentList;findProcessCommentList();}})(ProcessInstanceList));

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_manage_action__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_manage_selector__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManageEmailTemplate__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_const__ = __webpack_require__(28);
var mapStateToProps=function mapStateToProps(state,props){return{userSelection:__WEBPACK_IMPORTED_MODULE_2__state_manage_selector__["i" /* selectUserSelection */](state),processList:__WEBPACK_IMPORTED_MODULE_2__state_manage_selector__["f" /* selectProcessList */](state),templateList:__WEBPACK_IMPORTED_MODULE_2__state_manage_selector__["h" /* selectTemplateListForProcess */](state),emailTemplate:__WEBPACK_IMPORTED_MODULE_2__state_manage_selector__["a" /* selectEmailTemplate */](state),emailTemplateVariantList:__WEBPACK_IMPORTED_MODULE_2__state_manage_selector__["d" /* selectEmailTemplateVariantList */](state),isEmailAdmin:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["i" /* selectHasRole */])(state,__WEBPACK_IMPORTED_MODULE_5__security_state_auth_const__["k" /* ROLE_EMAIL_ADMIN */]),processMacroList:__WEBPACK_IMPORTED_MODULE_2__state_manage_selector__["g" /* selectProcessMacroListForCurrentProcess */](state)};};var mapDispatchToProps={findEmailTemplateList:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["g" /* findEmailTemplateList */],changeProcess:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["c" /* changeProcess */],findEmailTemplateById:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["f" /* findEmailTemplateById */],changeLocale:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["b" /* changeLocale */],changeEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["a" /* changeEmailTemplateVariant */],saveEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["i" /* saveEmailTemplateVariant */],createEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["d" /* createEmailTemplateVariant */],testEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["j" /* testEmailTemplateVariant */],deleteEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["e" /* deleteEmailTemplateVariant */],getProcessMacroList:__WEBPACK_IMPORTED_MODULE_1__state_manage_action__["h" /* getProcessMacroList */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ManageEmailTemplate__["a" /* default */]));

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findEmailTemplateListRequest */
/* unused harmony export findTemplateListSuccess */
/* unused harmony export findEmailTemplateListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return findEmailTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeLocale; });
/* unused harmony export findEmailTemplateByIdRequest */
/* unused harmony export findEmailTemplateByIdSuccess */
/* unused harmony export findEmailTemplateByIdError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return findEmailTemplateById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeEmailTemplateVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createEmailTemplateVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return testEmailTemplateVariant; });
/* unused harmony export saveEmailTemplateVariantRequest */
/* unused harmony export saveEmailTemplateVariantSuccess */
/* unused harmony export saveEmailTemplateVariantError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return saveEmailTemplateVariant; });
/* unused harmony export deleteEmailTemplateVariantRequest */
/* unused harmony export deleteEmailTemplateVariantSuccess */
/* unused harmony export deleteEmailTemplateVariantError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteEmailTemplateVariant; });
/* unused harmony export getProcessMacroListRequest */
/* unused harmony export getProcessMacroListSuccess */
/* unused harmony export getProcessMacroListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProcessMacroList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_create_uuid__ = __webpack_require__(360);
var findEmailTemplateListRequest=function findEmailTemplateListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* FIND_EMAIL_TEMPLATE_LIST_REQUEST */]};};var findTemplateListSuccess=function findTemplateListSuccess(emailTemplateList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_EMAIL_TEMPLATE_LIST_SUCCESS */],payload:{emailTemplateList:emailTemplateList}};};var findEmailTemplateListError=function findEmailTemplateListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* FIND_EMAIL_TEMPLATE_LIST_ERROR */],payload:{error:error}};};var findEmailTemplateList=function findEmailTemplateList(){return function(dispatch,getState){dispatch(findEmailTemplateListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/email/template/find-all').then(function(emailTemplateList){dispatch(findTemplateListSuccess(emailTemplateList));}).catch(function(error){dispatch(findEmailTemplateListError(error));});};};var changeProcess=function changeProcess(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_PROCESS */],payload:{name:name,value:value}};};var changeLocale=function changeLocale(name,locale){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_LOCALE */],payload:{locale:locale}};};var findEmailTemplateByIdRequest=function findEmailTemplateByIdRequest(emailTemplateId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_EMAIL_TEMPLATE_BY_ID_REQUEST */],payload:{emailTemplateId:emailTemplateId}};};var findEmailTemplateByIdSuccess=function findEmailTemplateByIdSuccess(emailTemplate){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS */],payload:{emailTemplate:emailTemplate}};};var findEmailTemplateByIdError=function findEmailTemplateByIdError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_EMAIL_TEMPLATE_BY_ID_ERROR */],payload:{error:error}};};var findEmailTemplateById=function findEmailTemplateById(name,emailTemplateId){return function(dispatch,getState){dispatch(findEmailTemplateByIdRequest(emailTemplateId));if(!emailTemplateId){return;}Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/email/template/find-by-id?emailTemplateId='+emailTemplateId).then(function(emailTemplate){emailTemplate.templateVariantList.forEach(function(emailTemplateVariant){emailTemplateVariant.localId=Object(__WEBPACK_IMPORTED_MODULE_3__util_create_uuid__["a" /* default */])();});dispatch(findEmailTemplateByIdSuccess(emailTemplate));}).catch(function(error){dispatch(findEmailTemplateByIdError(error));});};};var changeEmailTemplateVariant=function changeEmailTemplateVariant(localId,name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_EMAIL_TEMPLATE_VARIANT */],payload:{localId:localId,name:name,value:value}};};var createEmailTemplateVariant=function createEmailTemplateVariant(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CREATE_EMAIL_TEMPLATE_VARIANT */]};};var testEmailTemplateVariant=function testEmailTemplateVariant(localId){return function(dispatch,getState){var state=getState();var emailTemplateVariantId=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectEmailTemplateVariantIdByLocalId */](state,localId);if(!emailTemplateVariantId){return;}Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/email/template-variant/test?emailTemplateVariantId='+emailTemplateVariantId);};};var saveEmailTemplateVariantRequest=function saveEmailTemplateVariantRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["r" /* SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST */]};};var saveEmailTemplateVariantSuccess=function saveEmailTemplateVariantSuccess(localId,emailTemplateVariant){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["s" /* SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS */],payload:{localId:localId,emailTemplateVariant:emailTemplateVariant}};};var saveEmailTemplateVariantError=function saveEmailTemplateVariantError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["q" /* SAVE_EMAIL_TEMPLATE_VARIANT_ERROR */],payload:{error:error}};};var saveEmailTemplateVariant=function saveEmailTemplateVariant(localId){return function(dispatch,getState){var state=getState();var variant=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectEmailTemplateVariantByLocalId */](state,localId);if(variant===null){return;}dispatch(saveEmailTemplateVariantRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/email/template-variant/save',variant).then(function(emailTemplateVariant){emailTemplateVariant.localId=localId;dispatch(saveEmailTemplateVariantSuccess(localId,emailTemplateVariant));}).catch(function(error){dispatch(saveEmailTemplateVariantError(error));});};};var deleteEmailTemplateVariantRequest=function deleteEmailTemplateVariantRequest(localId){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST */],payload:{localId:localId}};};var deleteEmailTemplateVariantSuccess=function deleteEmailTemplateVariantSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS */]};};var deleteEmailTemplateVariantError=function deleteEmailTemplateVariantError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* DELETE_EMAIL_TEMPLATE_VARIANT_ERROR */],payload:{error:error}};};var deleteEmailTemplateVariant=function deleteEmailTemplateVariant(localId){return function(dispatch,getState){var state=getState();var variant=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectEmailTemplateVariantByLocalId */](state,localId);dispatch(deleteEmailTemplateVariantRequest(localId));if(!variant||!variant.id){return;}Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/email/template-variant/delete?emailTemplateVariantId='+variant.id).then(function(){dispatch(deleteEmailTemplateVariantSuccess());}).catch(function(error){dispatch(deleteEmailTemplateVariantError(error));});};};var getProcessMacroListRequest=function getProcessMacroListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["o" /* GET_PROCESS_MACRO_LIST_REQUEST */]};};var getProcessMacroListSuccess=function getProcessMacroListSuccess(processName,emailMacroList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["p" /* GET_PROCESS_MACRO_LIST_SUCCESS */],payload:{processName:processName,emailMacroList:emailMacroList}};};var getProcessMacroListError=function getProcessMacroListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["n" /* GET_PROCESS_MACRO_LIST_ERROR */],payload:{error:error}};};var getProcessMacroList=function getProcessMacroList(){return function(dispatch,getState){var state=getState();var processMacroList=__WEBPACK_IMPORTED_MODULE_2__selector__["g" /* selectProcessMacroListForCurrentProcess */](state);if(processMacroList){return;}var currentProcessName=__WEBPACK_IMPORTED_MODULE_2__selector__["j" /* selectUserSelectionProcess */](state);if(!currentProcessName){return;}dispatch(getProcessMacroListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/sales-order/get-salesorder-macro-list?processName='+currentProcessName).then(function(emailMacroList){dispatch(getProcessMacroListSuccess(currentProcessName,emailMacroList));}).catch(function(error){dispatch(getProcessMacroListError(error));});};};

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmailTemplateVariantSelection__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailTemplateVariantList__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmailMacro__ = __webpack_require__(1288);
var ManageEmailTemplates=function ManageEmailTemplates(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EmailTemplateVariantSelection__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EmailTemplateVariantList__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EmailMacro__["a" /* default */],props));};ManageEmailTemplates.propTypes={userSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,processList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,templateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,emailTemplateVariantList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,isEmailAdmin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,processMacroList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,findEmailTemplateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,findEmailTemplateById:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeLocale:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,testEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getProcessMacroList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findEmailTemplateList();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(ManageEmailTemplates)));

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_const__ = __webpack_require__(31);
var EmailTemplateVariantSelection=function EmailTemplateVariantSelection(_ref){var userSelection=_ref.userSelection,processList=_ref.processList,templateList=_ref.templateList,isEmailAdmin=_ref.isEmailAdmin,changeProcess=_ref.changeProcess,findEmailTemplateById=_ref.findEmailTemplateById,changeLocale=_ref.changeLocale,createEmailTemplateVariant=_ref.createEmailTemplateVariant,getProcessMacroList=_ref.getProcessMacroList;var showCreateButton=isEmailAdmin&&userSelection.emailTemplateId&&userSelection.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__["a" /* default */],{title:'Manage Email Templates'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,style:{height:'30px'},name:'processName',addEmpty:true,valueList:processList,onChange:function onChange(name,value){changeProcess(name,value);getProcessMacroList();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Template'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,style:{height:'30px'},name:'emailTemplateId',addEmpty:true,valueList:templateList,renderer:function renderer(_ref2){var technicalName=_ref2.technicalName,subject=_ref2.subject,text=_ref2.text;return technicalName;},onChange:findEmailTemplateById}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Language'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,style:{height:'30px'},name:'locale',addEmpty:false,valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["f" /* LANGUAGE_LIST */],onChange:changeLocale})))),showCreateButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-warning btn-sm',onClick:createEmailTemplateVariant},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-square'}),'\xA0new variant')))));};EmailTemplateVariantSelection.propTypes={userSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,processList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,templateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,findEmailTemplateById:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeLocale:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getProcessMacroList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EmailTemplateVariantSelection);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailTemplateVariant__ = __webpack_require__(1287);
var EmailTemplateVariantList=function EmailTemplateVariantList(_ref){var emailTemplateVariantList=_ref.emailTemplateVariantList,isEmailAdmin=_ref.isEmailAdmin,changeEmailTemplateVariant=_ref.changeEmailTemplateVariant,saveEmailTemplateVariant=_ref.saveEmailTemplateVariant,testEmailTemplateVariant=_ref.testEmailTemplateVariant,deleteEmailTemplateVariant=_ref.deleteEmailTemplateVariant;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,emailTemplateVariantList.map(function(emailTemplateVariant){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EmailTemplateVariant__["a" /* default */],{key:emailTemplateVariant.localId,isEmailAdmin:isEmailAdmin,emailTemplateVariant:emailTemplateVariant,changeEmailTemplateVariant:changeEmailTemplateVariant,saveEmailTemplateVariant:saveEmailTemplateVariant,testEmailTemplateVariant:testEmailTemplateVariant,deleteEmailTemplateVariant:deleteEmailTemplateVariant});}));};EmailTemplateVariantList.propTypes={emailTemplateVariantList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,isEmailAdmin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,testEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EmailTemplateVariantList);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_manage_const__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_component_Checkbox__ = __webpack_require__(47);
var EmailTemplateVariant=function EmailTemplateVariant(_ref){var emailTemplateVariant=_ref.emailTemplateVariant,isEmailAdmin=_ref.isEmailAdmin,changeEmailTemplateVariant=_ref.changeEmailTemplateVariant,saveEmailTemplateVariant=_ref.saveEmailTemplateVariant,testEmailTemplateVariant=_ref.testEmailTemplateVariant,deleteEmailTemplateVariant=_ref.deleteEmailTemplateVariant;var localId=emailTemplateVariant.localId;var _changeEmailTemplateVariant=isEmailAdmin?function(name,value){changeEmailTemplateVariant(localId,name,value);}:function(){};var _saveEmailTemplateVariant=isEmailAdmin?function(){saveEmailTemplateVariant(localId);}:function(){};var _changeAndSaveEmailVariant=isEmailAdmin?function(name,value){changeEmailTemplateVariant(localId,name,value);saveEmailTemplateVariant(localId);}:function(){};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__layout_component_ContentBox__["a" /* default */],{title:'Email Template Variant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){testEmailTemplateVariant(localId);},className:'btn btn-primary btn-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-send'}),'\xA0test email'),'\xA0',isEmailAdmin&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){deleteEmailTemplateVariant(localId);},className:'btn btn-danger btn-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash-o'}),'\xA0delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Variant Name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:emailTemplateVariant,readOnly:!isEmailAdmin,name:'variant',onChange:_changeEmailTemplateVariant,onBlur:_saveEmailTemplateVariant}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Probability'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:emailTemplateVariant,readOnly:!isEmailAdmin,name:'probability',type:'number',onChange:_changeEmailTemplateVariant,onBlur:_saveEmailTemplateVariant}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_Checkbox__["a" /* default */],{object:emailTemplateVariant,name:'active',readOnly:!isEmailAdmin,onChange:_changeAndSaveEmailVariant},'Active'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Subject'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:emailTemplateVariant,readOnly:!isEmailAdmin,name:'subject',onChange:_changeEmailTemplateVariant,onBlur:_saveEmailTemplateVariant}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Design Template'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:emailTemplateVariant,readOnly:!isEmailAdmin,name:'designTemplateId',onChange:_changeAndSaveEmailVariant,valueList:__WEBPACK_IMPORTED_MODULE_2__state_manage_const__["c" /* DESIGN_TEMPLATE_LIST */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Brand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:emailTemplateVariant,readOnly:!isEmailAdmin,name:'brand',onChange:_changeAndSaveEmailVariant,valueList:__WEBPACK_IMPORTED_MODULE_2__state_manage_const__["a" /* BRAND_LIST */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Email Text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_TextArea__["a" /* default */],{name:'emailText',className:'email-text-edit',object:emailTemplateVariant,readOnly:!isEmailAdmin,onChange:_changeEmailTemplateVariant,onBlur:_saveEmailTemplateVariant})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'SMS Text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_TextArea__["a" /* default */],{name:'smsText',className:'sms-text-edit',object:emailTemplateVariant,readOnly:!isEmailAdmin,onChange:_changeEmailTemplateVariant,onBlur:_saveEmailTemplateVariant})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:' '+(emailTemplateVariant.smsText?emailTemplateVariant.smsText.length:0)+' character. Max length after macro expansion 765'}))));};EmailTemplateVariant.propTypes={emailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isEmailAdmin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,testEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deleteEmailTemplateVariant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EmailTemplateVariant);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
var EmailMacro=function EmailMacro(_ref){var emailTemplate=_ref.emailTemplate,processMacroList=_ref.processMacroList;if(!emailTemplate||!processMacroList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Available Macros'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Macro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Explanation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Example'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processMacroList.map(function(processMacro){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:processMacro.macro},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'{'+processMacro.macro+'}'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,processMacro.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,processMacro.example));}))));};EmailMacro.propTypes={emailTemplate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,processMacroList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (EmailMacro);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_action__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_selector__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmployeeSettings__ = __webpack_require__(1291);
var mapStateToProps=function mapStateToProps(state){return{employee:__WEBPACK_IMPORTED_MODULE_3__state_selector__["a" /* selectEmployee */](state),sipGateDeviceList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectDeviceList(state)};};var mapDispatchToProps={changeEmployee:__WEBPACK_IMPORTED_MODULE_2__state_action__["a" /* changeEmployee */],setSipGateDeviceId:__WEBPACK_IMPORTED_MODULE_2__state_action__["b" /* setSipGateDeviceId */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__EmployeeSettings__["a" /* default */]));

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeEmployee; });
/* unused harmony export setSipGateDeviceIdRequest */
/* unused harmony export setSipGateDeviceIdSuccess */
/* unused harmony export setSipGateDeviceIdError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setSipGateDeviceId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(361);
var changeEmployee=function changeEmployee(name,value){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_EMPLOYEE */],payload:{name:name,value:value}};};var setSipGateDeviceIdRequest=function setSipGateDeviceIdRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* SET_SIPGATE_DEVICE_ID_REQUEST */]};};var setSipGateDeviceIdSuccess=function setSipGateDeviceIdSuccess(sipGateDeviceId){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["d" /* SET_SIPGATE_DEVICE_ID_SUCCESS */]};};var setSipGateDeviceIdError=function setSipGateDeviceIdError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["b" /* SET_SIPGATE_DEVICE_ID_ERROR */],payload:{error:error}};};var setSipGateDeviceId=function setSipGateDeviceId(){return function(dispatch,getState){var state=getState();var sipGateDeviceId=__WEBPACK_IMPORTED_MODULE_1__selector__["b" /* selectSipGateDeviceId */](state);dispatch(setSipGateDeviceIdRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/employeee/set-sipgate-device-id',{sipGateDeviceId:sipGateDeviceId}).then(function(empty){dispatch(setSipGateDeviceIdSuccess());}).catch(function(error){dispatch(setSipGateDeviceIdError(error));});};};

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
var EmployeeSettings=function EmployeeSettings(_ref){var employee=_ref.employee,sipGateDeviceList=_ref.sipGateDeviceList,setSipGateDeviceId=_ref.setSipGateDeviceId,changeEmployee=_ref.changeEmployee;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'My Settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'SipGate Device'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{addEmpty:true,object:employee,name:'sipGateDeviceId',onChange:function onChange(name,value){changeEmployee(name,value);setSipGateDeviceId();},valueList:sipGateDeviceList,renderer:function renderer(sipGateDevice){return sipGateDevice.alias;}})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(EmployeeSettings));

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_associate_payment_selector__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssociatePayment__ = __webpack_require__(1294);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_associate_payment_selector__["b" /* selectOwnState */](state));};var mapDispatchToProps={findUnassignedPaymentList:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["g" /* findUnassignedPaymentList */],editUnassignedPayment:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["f" /* editUnassignedPayment */],changeTableSetting:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["d" /* changeTableSetting */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["h" /* initialColumnsVisibility */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["i" /* toggleColumnVisibility */],changeCustomer:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["b" /* changeCustomer */],changeSalesOrder:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["c" /* changeSalesOrder */],associatePayment:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["a" /* associatePayment */],deletePayment:__WEBPACK_IMPORTED_MODULE_1__state_associate_payment_action__["e" /* deletePayment */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AssociatePayment__["a" /* default */]));

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTableSetting; });
/* unused harmony export findUnassignedPaymentListRequest */
/* unused harmony export findUnassignedPaymentListSuccess */
/* unused harmony export findUnassignedPaymentListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return findUnassignedPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return editUnassignedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSalesOrder; });
/* unused harmony export associatePaymentRequest */
/* unused harmony export associatePaymentSuccess */
/* unused harmony export associatePaymentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return associatePayment; });
/* unused harmony export deletePaymentRequest */
/* unused harmony export deletePaymentSuccess */
/* unused harmony export deletePaymentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return initialColumnsVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleColumnVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deletePayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table_state_action__ = __webpack_require__(92);
var changeTableSetting=Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_TABLE_SETTINGS */]);var findUnassignedPaymentListRequest=function findUnassignedPaymentListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* FIND_UNASSIGNED_PAYMENT_LIST_REQUEST */]};};var findUnassignedPaymentListSuccess=function findUnassignedPaymentListSuccess(paymentList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["m" /* FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS */],payload:{paymentList:paymentList}};};var findUnassignedPaymentListError=function findUnassignedPaymentListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* FIND_UNASSIGNED_PAYMENT_LIST_ERROR */],payload:{error:error}};};var findUnassignedPaymentList=function findUnassignedPaymentList(){return function(dispatch,getState){dispatch(findUnassignedPaymentListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/payment/get-unassigned-payments').then(function(paymentList){dispatch(findUnassignedPaymentListSuccess(paymentList));}).catch(function(error){dispatch(findUnassignedPaymentListError(error));});};};var editUnassignedPayment=function editUnassignedPayment(payment){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* EDIT_UNASSIGNED_PAYMENT */],payload:{payment:payment}};};var changeCustomer=function changeCustomer(customer){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* CHANGE_CUSTOMER */],payload:{customer:customer}};};var changeSalesOrder=function changeSalesOrder(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* CHANGE_SALES_ORDER */],payload:{name:name,value:value}};};var associatePaymentRequest=function associatePaymentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* ASSOCIATE_PAYMENT_REQUEST */]};};var associatePaymentSuccess=function associatePaymentSuccess(paymentList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* ASSOCIATE_PAYMENT_SUCCESS */],payload:{paymentList:paymentList}};};var associatePaymentError=function associatePaymentError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ASSOCIATE_PAYMENT_ERROR */],payload:{error:error}};};var associatePayment=function associatePayment(){return function(dispatch,getState){var state=getState();var payment=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectCurrentPayment */](state);if(!payment.customerId||!payment.salesOrderId){return;}dispatch(associatePaymentRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/payment/associate-payment',payment).then(function(paymentList){window.scrollTo(0,0);dispatch(associatePaymentSuccess(paymentList));}).catch(function(error){dispatch(associatePaymentError(error));});};};var deletePaymentRequest=function deletePaymentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* DELETE_PAYMENT_REQUEST */]};};var deletePaymentSuccess=function deletePaymentSuccess(paymentList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* DELETE_PAYMENT_SUCCESS */],payload:{paymentList:paymentList}};};var deletePaymentError=function deletePaymentError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* DELETE_PAYMENT_ERROR */],payload:{error:error}};};var initialColumnsVisibility=__WEBPACK_IMPORTED_MODULE_4__table_state_action__["c" /* createInitialColumnsVisibilityFormHandler */](__WEBPACK_IMPORTED_MODULE_1__type__["n" /* TABLE_ASSOCIATE_PAYMENTS */],__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_TABLE_SETTINGS */]);var toggleColumnVisibility=__WEBPACK_IMPORTED_MODULE_4__table_state_action__["f" /* createToggleColumnVisibilityFormHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_1__type__["f" /* CHANGE_TABLE_SETTINGS */],__WEBPACK_IMPORTED_MODULE_1__type__["n" /* TABLE_ASSOCIATE_PAYMENTS */]);var deletePayment=function deletePayment(){return function(dispatch,getState){var state=getState();var payment=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectCurrentPayment */](state);dispatch(deletePaymentRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/payment/delete?paymentId='+payment.id).then(function(paymentList){window.scrollTo(0,0);dispatch(deletePaymentSuccess(paymentList));}).catch(function(error){dispatch(deletePaymentError(error));});};};

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_money__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__column_list__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__customer_component_CustomerSuggest__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_block_ui__ = __webpack_require__(69);
var PaymentList=function PaymentList(_ref){var paymentList=_ref.paymentList,editUnassignedPayment=_ref.editUnassignedPayment,tableSetting=_ref.tableSetting,changeTableSetting=_ref.changeTableSetting,toggleColumnVisibility=_ref.toggleColumnVisibility;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Unassigned Payments'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Table__["a" /* default */],{changeTableSetting:changeTableSetting,tableSetting:tableSetting,columnList:__WEBPACK_IMPORTED_MODULE_7__column_list__["a" /* columnList */],rowList:paymentList,idProperty:'id',onRowClick:function onRowClick(payment){editUnassignedPayment(payment);},toggleColumnVisibility:toggleColumnVisibility}));};PaymentList.propTypes={paymentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,editUnassignedPayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeTableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var PaymentDetail=function PaymentDetail(_ref2){var payment=_ref2.payment,changeCustomer=_ref2.changeCustomer,changeSalesOrder=_ref2.changeSalesOrder,associatePayment=_ref2.associatePayment,deletePayment=_ref2.deletePayment;if(payment===null){return null;}var salesOrderList=payment.customer?payment.customer.salesOrderList:[];var salesOrderRenderer=function salesOrderRenderer(salesOrder){return salesOrder.referenceNumber+' - '+Object(__WEBPACK_IMPORTED_MODULE_12__util_datetime__["b" /* formatDate */])(salesOrder.created)+' - '+Object(__WEBPACK_IMPORTED_MODULE_6__util_money__["b" /* formatMoney */])(salesOrder.brutPrice,salesOrder.currency);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Payment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_12__util_datetime__["b" /* formatDate */])(payment.date)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Amount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_6__util_money__["b" /* formatMoney */])(payment.amount,payment.currency)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Reference'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,payment.bankPayment.reference))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Customer Reference'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,payment.bankPayment.customerReference))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Account Owner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,payment.bankPayment.otherParty)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Customer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__customer_component_CustomerSuggest__["a" /* default */],{currentCustomer:payment.customer,onChangeCustomer:changeCustomer}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_LabelInput__["a" /* default */],{label:'Sales Order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_Select__["a" /* default */],{object:payment,name:'salesOrderId',renderer:salesOrderRenderer,addEmpty:payment.salesOrderId===null,valueList:salesOrderList,onChange:changeSalesOrder})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__bootstrap_component_Column__["a" /* default */],{size:6,className:'align-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger btn-sm',onClick:deletePayment},'Not relevant'),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:associatePayment},'Assign'))));};PaymentDetail.propTypes={payment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeSalesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,associatePayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,deletePayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var AssociatePayment=function AssociatePayment(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_block_ui__["a" /* default */],{tag:'div',blocking:props.fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PaymentList,props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PaymentDetail,props));};AssociatePayment.propTypes={paymentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,editUnassignedPayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeTableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,payment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeSalesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,associatePayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,deletePayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findUnassignedPaymentList();this.props.initialColumnsVisibility();}})(Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(AssociatePayment)));

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return columnList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_money__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_const__ = __webpack_require__(115);
var columnList=[{property:'date',header:'Created',comparator:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateComparator('date'),renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateRenderer('date')},{property:'amount',header:'Amount',renderer:function renderer(payment){return Object(__WEBPACK_IMPORTED_MODULE_1__util_money__["b" /* formatMoney */])(payment.amount,payment.currency);}},{property:'type',header:'Type',renderer:function renderer(payment){if(!payment.bankPayment){return'';}return __WEBPACK_IMPORTED_MODULE_2__state_const__["a" /* BANK_PAYMENT_TEXT */][payment.bankPayment.type];}},{property:'reference',header:'Reference',renderer:function renderer(payment){if(!payment.bankPayment){return'';}return payment.bankPayment.reference;}},{property:'customer_reference',header:'Customer Reference',renderer:function renderer(payment){if(!payment.bankPayment){return'';}return payment.bankPayment.customerReference;}},{property:'sender',header:'Sender',renderer:function renderer(payment){if(!payment.bankPayment){return'';}return payment.bankPayment.otherParty;}},{property:'note',header:'Note',renderer:function renderer(payment){if(!payment.bankPayment){return'';}return payment.bankPayment.note;}}];

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autosuggest__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_api__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var theme={container:{position:'relative'},input:{},inputFocused:{outline:'none'},inputOpen:{borderBottomLeftRadius:0,borderBottomRightRadius:0},suggestionsContainer:{display:'none'},suggestionsContainerOpen:{display:'block',position:'relative',top:0,width:'100%',border:'1px solid rgb(231, 235, 238)',backgroundColor:'#fff',fontFamily:'"Open Sans", sans-serif',fontSize:'13px',borderBottomLeftRadius:3,borderBottomRightRadius:3,zIndex:1000},suggestionsList:{margin:0,padding:0,listStyleType:'none'},suggestion:{cursor:'pointer',padding:'5px 10px'},suggestionHighlighted:{backgroundColor:'rgb(231, 235, 238)'}};var getSuggestionValue=function getSuggestionValue(suggestion){return suggestion.firstName+' '+suggestion.lastName;};var renderSuggestion=function renderSuggestion(suggestion){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,suggestion.firstName+' '+suggestion.lastName+' '+suggestion.zip+' '+suggestion.city);};var CustomerSuggest=function(_React$Component){_inherits(CustomerSuggest,_React$Component);function CustomerSuggest(props){_classCallCheck(this,CustomerSuggest);var _this=_possibleConstructorReturn(this,(CustomerSuggest.__proto__||Object.getPrototypeOf(CustomerSuggest)).call(this,props));_this.onChange=function(event,_ref){var newValue=_ref.newValue;_this.setState({value:newValue});};_this.onSuggestionsFetchRequested=function(_ref2){var value=_ref2.value;if(!value){_this.setState({suggestions:[]});return;}Object(__WEBPACK_IMPORTED_MODULE_2__util_api__["b" /* get */])('/api/customer/find-by-name-pattern?pattern='+value).then(function(resultList){_this.setState({suggestions:resultList});}).catch(function(error){_this.setState({suggestions:[]});});};_this.onSuggestionsClearRequested=function(){_this.setState({suggestions:[]});};_this.state={value:props.currentCustomer?getSuggestionValue(props.currentCustomer):'',suggestions:[]};_this.onChange=_this.onChange.bind(_this);_this.onSuggestionsFetchRequested=_this.onSuggestionsFetchRequested.bind(_this);_this.onSuggestionsClearRequested=_this.onSuggestionsClearRequested.bind(_this);_this.onSuggestionSelected=_this.onSuggestionSelected.bind(_this);return _this;}_createClass(CustomerSuggest,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){this.setState({value:newProps.currentCustomer?getSuggestionValue(newProps.currentCustomer):''});}},{key:'onSuggestionSelected',value:function onSuggestionSelected(event,data){this.props.onChangeCustomer(data.suggestion);}},{key:'render',value:function render(){var _state=this.state,value=_state.value,suggestions=_state.suggestions;var inputProps={placeholder:'Choose Customer',value:value,onChange:this.onChange,className:'form-control',// onBlur: this.props.onBlur,
style:{zIndex:10}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_autosuggest___default.a,{suggestions:suggestions,onSuggestionsFetchRequested:this.onSuggestionsFetchRequested,onSuggestionsClearRequested:this.onSuggestionsClearRequested,getSuggestionValue:getSuggestionValue,renderSuggestion:renderSuggestion,onSuggestionSelected:this.onSuggestionSelected,theme:theme,inputProps:inputProps});}}]);return CustomerSuggest;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CustomerSuggest);

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1298).default;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__(1299);

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__(1300);

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__(1308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;

    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    if (event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = true;
    }

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onDocumentMouseUp = function () {
    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
      _this4.input.focus();
    }
    _this4.pressedSuggestion = null;
  };

  this.onSuggestionMouseDown = function (event) {
    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
    if (!_this4.justSelectedSuggestion) {
      _this4.justSelectedSuggestion = true;
      _this4.pressedSuggestion = event.target;
    }
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.onSuggestionMouseLeave = function (event) {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = false;
    }
  };

  this.onSuggestionTouchStart = function () {
    _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
  };

  this.onSuggestionTouchMove = function () {
    _this4.justSelectedSuggestion = false;
    _this4.pressedSuggestion = null;
    _this4.input.focus();
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.onSuggestionMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionTouchStart,
      onTouchMove: _this4.onSuggestionTouchMove,
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualArrays;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1301).default;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__(1302);

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__(1303);

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__(1305);

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__(1306);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }

    // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes2.default.object, // Arbitrary container props
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(1304);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(317);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1307);

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__(317);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(317);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_upload_action__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_upload_selector__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CSVUpload__ = __webpack_require__(1312);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_upload_selector__["a" /* selectOwnState */](state));};var mapDispatchToProps={uploadDBCSV:__WEBPACK_IMPORTED_MODULE_1__state_upload_action__["a" /* uploadDBCSV */],uploadPostFinanceCSV:__WEBPACK_IMPORTED_MODULE_1__state_upload_action__["b" /* uploadPostFinanceCSV */],uploadZABCSV:__WEBPACK_IMPORTED_MODULE_1__state_upload_action__["e" /* uploadZABCSV */],uploadTabeoCSV:__WEBPACK_IMPORTED_MODULE_1__state_upload_action__["d" /* uploadTabeoCSV */],uploadSplitItCSV:__WEBPACK_IMPORTED_MODULE_1__state_upload_action__["c" /* uploadSplitItCSV */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__CSVUpload__["a" /* default */]));

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uploadCSVRequest */
/* unused harmony export uploadCSVError */
/* unused harmony export uploadCSVSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uploadDBCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uploadPostFinanceCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return uploadZABCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uploadTabeoCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uploadSplitItCSV; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(372);
var uploadCSVRequest=function uploadCSVRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* UPLOAD_CSV_REQUEST */]};};var uploadCSVError=function uploadCSVError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* UPLOAD_CSV_ERROR */],payload:{error:error}};};var uploadCSVSuccess=function uploadCSVSuccess(paymentList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* UPLOAD_CSV_SUCCESS */],payload:{paymentList:paymentList}};};var uploadDBCSV=function uploadDBCSV(file){return function(dispatch){dispatch(uploadCSVRequest());var data=new FormData();data.append('file',file);fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/payment/upload-db-csv',{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(paymentList){dispatch(uploadCSVSuccess(paymentList));}).catch(function(error){dispatch(uploadCSVError(error));});};};var uploadPostFinanceCSV=function uploadPostFinanceCSV(file){return function(dispatch){dispatch(uploadCSVRequest());var data=new FormData();data.append('file',file);fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/payment/upload-pf-csv',{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(paymentList){dispatch(uploadCSVSuccess(paymentList));}).catch(function(error){dispatch(uploadCSVError(error));});};};var uploadZABCSV=function uploadZABCSV(file){return function(dispatch,getState){dispatch(uploadCSVRequest());var data=new FormData();data.append('file',file);fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/payment/upload-zab-csv',{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(paymentList){dispatch(uploadCSVSuccess(paymentList));}).catch(function(error){dispatch(uploadCSVError(error));});};};var uploadTabeoCSV=function uploadTabeoCSV(file){return function(dispatch){dispatch(uploadCSVRequest());var data=new FormData();data.append('file',file);fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/payment/upload-tabeo-csv',{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(paymentList){dispatch(uploadCSVSuccess(paymentList));}).catch(function(error){dispatch(uploadCSVError(error));});};};var uploadSplitItCSV=function uploadSplitItCSV(file){return function(dispatch){dispatch(uploadCSVRequest());var data=new FormData();data.append('file',file);fetch(__WEBPACK_IMPORTED_MODULE_0__util_api__["a" /* BACKEND_URL */]+'/api/payment/upload-splitit-csv',{method:'post',body:data,headers:{Accept:'application/json'},credentials:'include'}).then(function(response){return response.json();}).then(function(paymentList){dispatch(uploadCSVSuccess(paymentList));}).catch(function(error){dispatch(uploadCSVError(error));});};};

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* unused harmony export selectPaymentList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(541);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectPaymentList=function selectPaymentList(state){return selectOwnState(state).paymentList;};

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__list_PaymentList__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_withLayout__ = __webpack_require__(24);
var style={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'32px'};var CSVUpload=function CSVUpload(_ref){var uploadDBCSV=_ref.uploadDBCSV,uploadPostFinanceCSV=_ref.uploadPostFinanceCSV,uploadZABCSV=_ref.uploadZABCSV,uploadTabeoCSV=_ref.uploadTabeoCSV,uploadSplitItCSV=_ref.uploadSplitItCSV,paymentList=_ref.paymentList,fetching=_ref.fetching;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Upload Deutsche Bank CSV'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadDBCSV(fileList[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload CSV'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Upload PostFinance AG Bank CSV (CH)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadPostFinanceCSV(fileList[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload CSV'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Upload ZAB CSV'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadZABCSV(fileList[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload CSV'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Upload Tabeo CSV'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadTabeoCSV(fileList[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload CSV'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Upload SplitIt CSV'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadSplitItCSV(fileList[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload CSV'))))),paymentList.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__list_PaymentList__["a" /* default */],{skipAuthorization:true,paymentList:paymentList}));};CSVUpload.propTypes={uploadDBCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,uploadPostFinanceCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,uploadZABCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,uploadTabeoCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,uploadSplitItCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,paymentList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__layout_withLayout__["a" /* default */])(CSVUpload));

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["p" /* selectSetTable */](state),type:'set'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["T" /* initialTableQuerySet */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["n" /* changeFilterSet */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_55" /* toggleSortSet */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_39" /* toggleMultiSortSet */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["D" /* gotoPageSet */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_8" /* initialTableSettingsSet */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_23" /* toggleColumnVisibilitySet */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_const__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = ([{property:'vip',header:'VIP',width:'45',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_VipIcon__["a" /* default */],{active:!!salesOrder.vip});},columnName:'salesorder_salesorder.vip'},{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'salesorder_salesorder.created'},{property:'referenceNumber',header:'No.',columnName:'salesorder_salesorder.referenceNumber'},{property:'firstName',header:'Firstname',columnName:'customer_customer.firstName'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'status',header:'Status',renderer:function renderer(salesOrder){return Object(__WEBPACK_IMPORTED_MODULE_4__process_util_names__["f" /* renderStateName */])(salesOrder.status);},columnName:'salesorder_salesorder.status'},{property:'lastStateTransition',header:'Last Status Change',renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateRenderer('lastStateTransition'),columnName:'salesorder_salesorder.lastStateTransition'},{property:'numberOfSetsSent',header:'# Sets sent',renderer:function renderer(salesOrder){return salesOrder.numberOfSetsSent===null?0:salesOrder.numberOfSetsSent;},columnName:'salesorder_salesorder.numberOfSetsSent'},{header:'gender',property:'gender',columnName:'customer_customer.gender'},{property:'paymentMethod',header:'P. Method',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_1__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod];},columnName:'salesorder_salesorder.paymentMethod'},{property:'paymentReceived',header:'P. Received',renderer:function renderer(value){return value.paymentReceived==='1'?'yes':'no';},columnName:'salesorder_salesorder.paymentReceived'},{property:'voucherCode',header:'Voucher',columnName:'salesorder_salesorder.voucherCode'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_5__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}]);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = ([{property:'vip',header:'VIP',width:'45',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__["a" /* default */],{active:!!salesOrder.vip});},columnName:'salesorder_salesorder.vip'},{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'salesorder_salesorder.created'},{property:'referenceNumber',header:'No.',columnName:'salesorder_salesorder.referenceNumber'},{property:'firstName',header:'Firstname',columnName:'customer_customer.firstName'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'status',header:'Status',renderer:function renderer(salesOrder){return Object(__WEBPACK_IMPORTED_MODULE_3__process_util_names__["f" /* renderStateName */])(salesOrder.status);},columnName:'salesorder_salesorder.status'},{property:'lastStateTransition',header:'Last Status Change',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateRenderer('lastStateTransition'),columnName:'salesorder_salesorder.lastStateTransition'},{header:'gender',property:'gender',columnName:'customer_customer.gender'},{property:'store',header:'Store',renderer:function renderer(appointment){return Object(__WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__["c" /* renderStoreNameById */])(appointment.storeId);},columnName:'customer_customer.store'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_5__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}]);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = ([{property:'vip',header:'VIP',width:'45',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__["a" /* default */],{active:!!salesOrder.vip});},columnName:'salesorder_salesorder.vip'},{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'salesorder_salesorder.created'},{property:'referenceNumber',header:'No.',columnName:'salesorder_salesorder.referenceNumber'},{property:'firstName',header:'Firstname',columnName:'customer_customer.firstName'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'status',header:'Status',renderer:function renderer(salesOrder){return Object(__WEBPACK_IMPORTED_MODULE_3__process_util_names__["f" /* renderStateName */])(salesOrder.status);},columnName:'salesorder_salesorder.status'},{property:'lastStateTransition',header:'Last Status Change',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateRenderer('lastStateTransition'),columnName:'salesorder_salesorder.lastStateTransition'},{property:'store',header:'Store',renderer:function renderer(appointment){return Object(__WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__["c" /* renderStoreNameById */])(appointment.storeId);},columnName:'customer_customer.store'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_5__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}]);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_const__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = ([{property:'vip',header:'VIP',width:'45',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_VipIcon__["a" /* default */],{active:!!salesOrder.vip});},columnName:'salesorder_salesorder.vip'},{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'salesorder_salesorder.created'},{property:'referenceNumber',header:'No.',columnName:'salesorder_salesorder.referenceNumber'},{property:'firstName',header:'Firstname',columnName:'customer_customer.firstName'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'status',header:'Status',renderer:function renderer(salesOrder){return Object(__WEBPACK_IMPORTED_MODULE_4__process_util_names__["f" /* renderStateName */])(salesOrder.status);},columnName:'salesorder_salesorder.status'},{property:'lastStateTransition',header:'Last Status Change',renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateRenderer('lastStateTransition'),columnName:'salesorder_salesorder.lastStateTransition'},{header:'gender',property:'gender',columnName:'customer_customer.gender'},{property:'paymentMethod',header:'P. Method',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_1__state_const__["b" /* PAYMENT_METHOD_TEXT */][salesOrder.paymentMethod];},columnName:'salesorder_salesorder.paymentMethod'},{property:'paymentReceived',header:'P. Received',renderer:function renderer(value){return value.paymentReceived==='1'?'yes':'no';},columnName:'salesorder_salesorder.paymentReceived'},{property:'voucherCode',header:'Voucher',columnName:'salesorder_salesorder.voucherCode'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_5__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}]);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = ([{property:'vip',header:'VIP',width:'45',renderer:function renderer(salesOrder){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_VipIcon__["a" /* default */],{active:!!salesOrder.vip});},columnName:'salesorder_salesorder.vip'},{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'salesorder_salesorder.created'},{property:'referenceNumber',header:'No.',columnName:'salesorder_salesorder.referenceNumber'},{property:'firstName',header:'Firstname',columnName:'customer_customer.firstName'},{property:'lastName',header:'Lastname',columnName:'customer_customer.lastName'},{property:'email',header:'Email',columnName:'customer_customer.email'},{property:'status',header:'Status',renderer:function renderer(salesOrder){return Object(__WEBPACK_IMPORTED_MODULE_3__process_util_names__["f" /* renderStateName */])(salesOrder.status);},columnName:'salesorder_salesorder.status'},{property:'lastStateTransition',header:'Last Status Change',renderer:__WEBPACK_IMPORTED_MODULE_1__form_component_Table__["a" /* default */].dateRenderer('lastStateTransition'),columnName:'salesorder_salesorder.lastStateTransition'},{header:'gender',property:'gender',columnName:'customer_customer.gender'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_4__customer_util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'customer_customer.countryCode'}]);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["q" /* selectShopScanTable */](state),type:'shop-scan'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["U" /* initialTableQueryShopScan */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["o" /* changeFilterShopScan */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_56" /* toggleSortShopScan */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_40" /* toggleMultiSortShopScan */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["E" /* gotoPageShopScan */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_9" /* initialTableSettingsShopScan */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_24" /* toggleColumnVisibilityShopScan */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["r" /* selectTreatmentTable */](state),type:'treatment'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["V" /* initialTableQueryTreatment */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["p" /* changeFilterTreatment */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_57" /* toggleSortTreatment */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_41" /* toggleMultiSortTreatment */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["F" /* gotoPageTreatment */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_10" /* initialTableSettingsTreatment */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_25" /* toggleColumnVisibilityTreatment */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderDetail__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sipgate_state_action__ = __webpack_require__(195);
var mapStateToProps=function mapStateToProps(state,props){return{salesOrderId:props.computedMatch.params.salesOrderId,salesOrder:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["f" /* selectSalesOrder */](state),salutationList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSalutationList(state),salesOrderStatusList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSalesOrderStatusList(state),salesOrderTreatmentStatusList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSalesOrderTreatmentStatusList(state),contact:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["h" /* selectSalesOrderCustomerContact */](state),error:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["a" /* selectAPIError */](state)};};var mapDispatchToProps={findSalesOrder:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["g" /* findSalesOrder */],changeSalesOrder:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["d" /* changeSalesOrder */],saveSalesOrder:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["j" /* saveSalesOrder */],changeSalesOrderCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["e" /* changeSalesOrderCustomer */],saveSalesOrderCustomer:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["k" /* saveSalesOrderCustomer */],addSentEmail:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["b" /* addSentEmail */],addInvoice:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addInvoice */],addShipment:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["c" /* addShipment */],callNumber:__WEBPACK_IMPORTED_MODULE_5__sipgate_state_action__["a" /* callNumber */],changeCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["f" /* changeSalesOrderCustomerContact */],saveCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["l" /* saveSalesOrderCustomerContact */],hydrateContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["i" /* hydrateSalesOrderCustomerContact */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderDetail__["a" /* default */]));

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enrichSalesOrderList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enrichSalesOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_util_names__ = __webpack_require__(25);
var enrichSalesOrderList=function enrichSalesOrderList(state,salesOrderList){__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(salesOrder){enrichSalesOrder(state,salesOrder);},salesOrderList);};var enrichSalesOrder=function enrichSalesOrder(state,salesOrder){salesOrder.isSet=salesOrder.type==='set';var statusResolver=salesOrder.isSet?__WEBPACK_IMPORTED_MODULE_1__globals_index__["a" /* default */].selector.selectSalesOrderStatusValueById:__WEBPACK_IMPORTED_MODULE_1__globals_index__["a" /* default */].selector.selectSalesOrderTreatmentStatusValueById;//
salesOrder.statusName=statusResolver(state,salesOrder.status)||Object(__WEBPACK_IMPORTED_MODULE_3__process_util_names__["f" /* renderStateName */])(salesOrder.status);salesOrder.responsibleEmployeeName=__WEBPACK_IMPORTED_MODULE_1__globals_index__["a" /* default */].selector.selectEmployeeNameById(state,salesOrder.responsibleEmployeeId);__WEBPACK_IMPORTED_MODULE_0_ramda__["d" /* forEach */](function(statusHistory){statusHistory.statusName=statusResolver(state,statusHistory.newStatus);statusHistory.changedByEmployeeName=__WEBPACK_IMPORTED_MODULE_1__globals_index__["a" /* default */].selector.selectEmployeeNameById(state,statusHistory.changeByEmployeeId);},salesOrder.statusHistory);salesOrder.statusHistory.sort(Object(__WEBPACK_IMPORTED_MODULE_2__util_datetime__["a" /* dateComparator */])('changed'));};

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesOrderOverview__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderCustomer__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__email_component_sent_SentEmailList__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__invoice_component_list_InvoiceList__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payment_component_list_PaymentList__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatusHistory__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logistic_component_list_ShipmentListContainer__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__invoice_component_list_CustomsInvoiceList__ = __webpack_require__(1327);
var SalesOrderDetail=function SalesOrderDetail(props){var salesOrder=props.salesOrder,addShipment=props.addShipment;if(!salesOrder){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SalesOrderOverview__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SalesOrderCustomer__["a" /* default */],Object.assign({},props,{salesOrderCustomer:salesOrder.salesOrderCustomer})),!salesOrder.hasProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StatusHistory__["a" /* default */],{statusHistory:salesOrder.statusHistory}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__email_component_sent_SentEmailList__["a" /* default */],{sentEmailList:salesOrder.sentEmailList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__invoice_component_list_InvoiceList__["a" /* default */],{invoiceList:salesOrder.invoiceList,confirmationModalOpen:false,closeConfirmationModal:function closeConfirmationModal(){}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__invoice_component_list_CustomsInvoiceList__["a" /* default */],{customsInvoiceList:salesOrder.customer.customsInvoiceList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__payment_component_list_PaymentList__["a" /* default */],{paymentList:salesOrder.paymentList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__logistic_component_list_ShipmentListContainer__["a" /* default */],{shipmentList:salesOrder.shipmentList,salesOrder:salesOrder,addShipment:addShipment}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findSalesOrder(this.props.salesOrderId);}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(SalesOrderDetail)));

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detail_SalesOrderInfoTable__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detail_SalesOrderPriceTable__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__detail_SalesOrderPaymentDetails__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_definition_sales_order_ui__ = __webpack_require__(318);
var TITLE={'set':'Set','treatment':'Treatment','treatment-new':'Treatment New','shop-scan':'Shop Scan','shop-scan-new':'Shop Scan New','retainer':'Retainer','retainer-new':'Retainer New','refinement-set':'Refinement (Set)','refinement-shop':'Refinement (Shop)','refinement-shop-new':'Refinement (Shop New)','refinement-production':'Refinement Production','in-shop-scan':'Clinic 3D-Scan','in-shop-scan-new':'Clinic 3D-Scan New','escalation':'Escalation','check-in':'Clinic Check-In','check-in-New':'Clinic Check-In New','aligner-reproduction':'Aligner Reproduction','implant-3d-scan':'Implant Clinic 3D-Scan','implant-plan':'Implant Plan','implant-treatment':'Implant Treatment','retainer-refinement':'Retainer Refinement','retainer-refinement-new':'Retainer Refinement New','partial-refund':'Partial Refund'};var SalesOrderComment=function SalesOrderComment(_ref){var salesOrder=_ref.salesOrder,changeSalesOrder=_ref.changeSalesOrder,saveSalesOrder=_ref.saveSalesOrder;if(salesOrder.hasProcess){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__["a" /* default */],{label:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_TextArea__["a" /* default */],{name:'comment',object:salesOrder,onChange:changeSalesOrder,onBlur:saveSalesOrder}))));};var SalesOrderOverview=function SalesOrderOverview(props){if(!Object(__WEBPACK_IMPORTED_MODULE_10__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__ui_definition_sales_order_ui__["a" /* SALES_ORDER_OVERVIEW */])){return null;}var salesOrder=props.salesOrder;var customer=salesOrder.customer;var title=TITLE[salesOrder.type]+' '+customer.firstName+' '+customer.lastName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__detail_SalesOrderInfoTable__["a" /* default */],props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__detail_SalesOrderPaymentDetails__["a" /* default */],{salesOrder:salesOrder})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__detail_SalesOrderPriceTable__["a" /* default */],{salesOrder:salesOrder}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesOrderComment,props));};SalesOrderOverview.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderOverview);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_component_CustomerLink__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
var SalesOrderStatus=function SalesOrderStatus(_ref){var salesOrder=_ref.salesOrder,salesOrderStatusList=_ref.salesOrderStatusList,salesOrderTreatmentStatusList=_ref.salesOrderTreatmentStatusList,changeSalesOrder=_ref.changeSalesOrder,saveSalesOrder=_ref.saveSalesOrder;if(salesOrder.hasProcess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5__process_util_names__["f" /* renderStateName */])(salesOrder.status));}var valueList=salesOrder.type==='set'?salesOrderStatusList:salesOrderTreatmentStatusList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:salesOrder,name:'status',valueList:valueList,onChange:function onChange(name,value){changeSalesOrder(name,value);saveSalesOrder();}});};var SalesOrderInfoTable=function SalesOrderInfoTable(props){var salesOrder=props.salesOrder;var hasProcess=salesOrder.hasProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Customer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__customer_component_CustomerLink__["a" /* default */],{customer:salesOrder.customer}))),hasProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Process'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/process/instance/view-by-master-id/salesorder_salesorder/'+salesOrder.id},'view'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesOrderStatus,props))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__util_datetime__["c" /* formatDateTime */])(salesOrder.created))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Reference Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.referenceNumber))));};SalesOrderInfoTable.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderInfoTable);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_sales_order_ui__ = __webpack_require__(318);
var StatusRow=function StatusRow(_ref){var statusHistoryItem=_ref.statusHistoryItem;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:statusHistoryItem.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_datetime__["c" /* formatDateTime */])(statusHistoryItem.changed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,statusHistoryItem.statusName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,statusHistoryItem.changedByEmployeeName));};StatusRow.propTypes={statusHistory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,employeeName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,statusName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var StatusHistory=function StatusHistory(_ref2){var statusHistory=_ref2.statusHistory;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ui_definition_sales_order_ui__["b" /* SALES_ORDER_STATUS_HISTORY */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Status history'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'changed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'new status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'changed by'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,statusHistory.map(function(statusHistoryItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatusRow,{key:statusHistoryItem.id,statusHistoryItem:statusHistoryItem});}))));};StatusHistory.propTypes={statusHistory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StatusHistory);

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_api__ = __webpack_require__(12);
var NAME_TREATMENT='Treatment';var CustomsInvoice=function CustomsInvoice(_ref){var customsInvoice=_ref.customsInvoice;var downloadUrl=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/download-file?fileId='+customsInvoice.id;var viewUrl=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/api/file-system/view-file?fileId='+customsInvoice.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,NAME_TREATMENT),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["b" /* formatDate */])(customsInvoice.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:downloadUrl,download:true},'download')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:viewUrl,target:'_blank',rel:'noopener noreferrer'},'view')));};var CustomsInvoiceList=function CustomsInvoiceList(_ref2){var customsInvoiceList=_ref2.customsInvoiceList;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["w" /* CUSTOMS_INVOICE_LIST_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Customs Invoices '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Download'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,customsInvoiceList.map(function(customsInvoice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomsInvoice,{customsInvoice:customsInvoice,key:'customs-invoice-'+customsInvoice.id});}))))));};CustomsInvoiceList.propTypes={customsInvoiceList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CustomsInvoiceList);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_barcode_action__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_barcode_selector__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Barcode__ = __webpack_require__(1330);
var mapStateToProps=function mapStateToProps(state,props){return{barcode:__WEBPACK_IMPORTED_MODULE_2__state_barcode_selector__["a" /* selectBarCode */](state)};};var mapDispatchToProps={changeBarCode:__WEBPACK_IMPORTED_MODULE_1__state_barcode_action__["a" /* changeBarCode */],onBarCodeEnter:__WEBPACK_IMPORTED_MODULE_1__state_barcode_action__["b" /* onBarCodeEnter */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Barcode__["a" /* default */]));

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeBarCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onBarCodeEnter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(286);
var changeBarCode=function changeBarCode(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_BAR_CODE */],payload:{name:name,value:value}};};var onBarCodeEnter=function onBarCodeEnter(){return function(dispatch,getState){var state=getState();var barcode=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectBarCode */](state);if(!barcode||!barcode.value){return;}var partList=barcode.value.split('.');if(partList.length!==2){return;}var instanceId=partList[1];instanceId=instanceId.replace(/ß/g,'-');dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["d" /* push */])('/task/detail-by-process-instance-id/'+instanceId));dispatch(changeBarCode('value',''));};};

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
var Barcode=function Barcode(_ref){var barcode=_ref.barcode,changeBarCode=_ref.changeBarCode,onBarCodeEnter=_ref.onBarCodeEnter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Barcode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{name:'value',object:barcode,placeholder:'Scanner',onEnter:onBarCodeEnter,onChange:changeBarCode})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:8})));};Barcode.propTypes={barcode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeBarCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onBarCodeEnter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(Barcode));

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskList__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_task_list_action__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_task_list_selector__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_state_selector__ = __webpack_require__(88);
var mapStateToProps=function mapStateToProps(state,props){return{taskList:__WEBPACK_IMPORTED_MODULE_4__state_task_list_selector__["e" /* selectUserTaskList */](state),tableSetting:__WEBPACK_IMPORTED_MODULE_4__state_task_list_selector__["d" /* selectTableSetting */](state),canSeeCustomerNames:Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["a" /* canSeeCustomerNames */])(state),isTablet:Object(__WEBPACK_IMPORTED_MODULE_6__layout_state_selector__["c" /* selectIsTablet */])(state),currentUserId:Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["q" /* selectUserId */])(state)};};var mapDispatchToProps={findTaskList:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["c" /* findTaskList */],changeTableSetting:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["b" /* changeTableSetting */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["e" /* initialColumnsVisibility */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["h" /* toggleColumnVisibility */],navigateToTaskDetail:function navigateToTaskDetail(taskId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/task/detail/'+taskId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__TaskList__["a" /* default */]));

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tasklist_column_list__ = __webpack_require__(547);
var TaskList=function TaskList(_ref){var taskList=_ref.taskList,tableSetting=_ref.tableSetting,changeTableSetting=_ref.changeTableSetting,navigateToTaskDetail=_ref.navigateToTaskDetail,canSeeCustomerNames=_ref.canSeeCustomerNames,isTablet=_ref.isTablet,currentUserId=_ref.currentUserId,toggleColumnVisibility=_ref.toggleColumnVisibility;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Worklist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Table__["a" /* default */],{columnList:Object(__WEBPACK_IMPORTED_MODULE_8__tasklist_column_list__["a" /* default */])(canSeeCustomerNames,isTablet,currentUserId),rowList:taskList,changeTableSetting:changeTableSetting,tableSetting:tableSetting,idProperty:'id',onRowClick:function onRowClick(task){navigateToTaskDetail(task.id);},toggleColumnVisibility:toggleColumnVisibility}))));};TaskList.propTypes={taskList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,tableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeTableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,navigateToTaskDetail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,canSeeCustomerNames:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,currentUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialColumnsVisibility();this.props.findTaskList();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(TaskList)));

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskDetail__ = __webpack_require__(1472);
var mapStateToProps=function mapStateToProps(state,props){return{taskId:props.computedMatch.params.taskId,processInstanceId:props.computedMatch.params.processInstanceId,task:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["m" /* selectTask */](state),taskName:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["o" /* selectTaskName */](state),fetching:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["e" /* selectIsFetching */](state),noFollowUp:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["c" /* selectHasNoFollowUpTask */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["p" /* selectValidationMessageList */](state),taskReadOnly:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["f" /* selectIsTaskReadOnly */](state),hasPreviousRetainerRefinementProcess:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["d" /* selectHasPreviousRetainerRefinementProcess */](state)};};var mapDispatchToProps={findTaskDetail:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["e" /* findTaskDetail */],findTaskDetailByProcessInstanceId:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["f" /* findTaskDetailByProcessInstanceId */],validateAndTriggerEvent:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["j" /* validateAndTriggerEvent */],toggleProcessFlowVisibility:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["g" /* toggleProcessFlowVisibility */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__TaskDetail__["a" /* default */]));

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* ASSIGN_PHYSICIAN */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer){if(eventName!=='physician_assigned'){return null;}var messageList=[];// make sure at least one is true
if(!customer.partnerPhysicianId&&!customer.treatingPhysicianId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a physician.','validateAssignPhysician.physicianId'));}// make sure at least one is true
if(!customer.partnerSupplierId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a supplier','validateAssignPhysician.supplier'));}return messageList;}}));

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* CHECK_CUSTOMER_IMAGES */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var lowerJawVisuallyOK=context.lowerJawVisuallyOK;var upperJawVisuallyOK=context.upperJawVisuallyOK;// make sure at least one is true
if(eventName==='at_least_one_imprint_visually_ok'&&!lowerJawVisuallyOK&&!upperJawVisuallyOK){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action at least one imprint has to be visually ok.','validateCheckImprintVisually.at_least_one_imprint_visually_ok'));}// both have to be false
if(eventName==='both_imprints_visually_not_ok'&&(lowerJawVisuallyOK||upperJawVisuallyOK)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action both imprints must not be visually ok.','validateCheckImprintVisually.both_imprints_visually_not_ok'));}return messageList;}}));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* CHECK_IMAGES */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var lowerJawVisuallyOK=context.lowerJawVisuallyOK;var upperJawVisuallyOK=context.upperJawVisuallyOK;// make sure at least one is true
if(eventName==='at_least_one_imprint_visually_ok'&&!lowerJawVisuallyOK&&!upperJawVisuallyOK){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action at least one imprint has to be visually ok.','validateCheckImprintVisually.at_least_one_imprint_visually_ok'));}// both have to be false
if(eventName==='both_imprints_visually_not_ok'&&(lowerJawVisuallyOK||upperJawVisuallyOK)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action both imprints must not be visually ok.','validateCheckImprintVisually.both_imprints_visually_not_ok'));}var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason&&eventName==='cannot_be_treated'){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}}));

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["e" /* CHECK_IMAGES_AND_SCANS */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Z" /* REQUEST_MEDICAL_EVALUATION */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["v" /* CUSTOMER_XRAY_FILE_UPLOAD */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__["a" /* default */]}));

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["f" /* CHECK_IMAGES_AND_SCANS_REFINEMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]]}));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["g" /* CHECK_IMAGES_POST */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var lowerJawVisuallyOK=context.lowerJawVisuallyOK;var upperJawVisuallyOK=context.upperJawVisuallyOK;// make sure at least one is true
if(eventName==='at_least_one_imprint_visually_ok'&&!lowerJawVisuallyOK&&!upperJawVisuallyOK){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action at least one imprint has to be visually ok.','validateCheckImprintVisually.at_least_one_imprint_visually_ok'));}// both have to be false
if(eventName==='both_imprints_visually_not_ok'&&(lowerJawVisuallyOK||upperJawVisuallyOK)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action both imprints must not be visually ok.','validateCheckImprintVisually.both_imprints_visually_not_ok'));}var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason&&eventName==='cannot_be_treated'){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}}));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["h" /* CHECK_IMPRINTS_VISUALLY */],overwriteWidget:true,stateNameList:[],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_10" /* TRAY_SIZE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var lowerJawVisuallyOK=context.lowerJawVisuallyOK;var upperJawVisuallyOK=context.upperJawVisuallyOK;// make sure at least one is true
if(eventName==='at_least_one_imprint_visually_ok'&&!lowerJawVisuallyOK&&!upperJawVisuallyOK){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action at least one imprint has to be visually ok.','validateCheckImprintVisually.at_least_one_imprint_visually_ok'));}// both have to be false
if(eventName==='both_imprints_visually_not_ok'&&(lowerJawVisuallyOK||upperJawVisuallyOK)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('For this action both imprints must not be visually ok.','validateCheckImprintVisually.both_imprints_visually_not_ok'));}var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason&&eventName==='cannot_be_treated'){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}}));

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_3__task_name__["i" /* CHECK_SCANS */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_10" /* TRAY_SIZE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var upperJawScanOk=context.upperJawScanOk;var lowerJawScanOK=context.lowerJawScanOK;// // make sure at least one is true
if(eventName==='both_imprints_scan_ok'&&(!upperJawScanOk||!lowerJawScanOK)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])('For this action both scans have to be ok.','validateCheckScans.both_imprints_scan_ok'));}// both have to be false
if(eventName==='at_least_one_imprint_scan_not_ok'&&upperJawScanOk&&lowerJawScanOK){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])('For this action at least one scan has to be not ok.','validateCheckScans.at_least_one_imprint_scan_not_ok'));}return messageList;}}));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["n" /* CONFIRM_TREATMENT_PLAN_DONE */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}]}));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["l" /* CLARIFY_REMARKS */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */],__WEBPACK_IMPORTED_MODULE_5__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer,context){var messageList=[];var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason&&eventName==='cannot_be_treated'){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));return messageList;}// make sure at least one is true
if(!customer.partnerPhysicianId&&!customer.treatingPhysicianId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a physician.','validateAssignPhysician.physicianId'));}// make sure at least one is true
if(!customer.partnerSupplierId&&processInstance.processName!=='process-implant-plan'){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a supplier','validateAssignPhysician.supplier'));}return messageList;},actionList:[{action:__WEBPACK_IMPORTED_MODULE_6__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_6__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_6__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_6__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]}));

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["s" /* CREATE_TREATMENT_PLAN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{isIprReadOnly:false}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["M" /* PATIENT_IPR_WISHES_WIDGET */],widgetProps:{readOnly:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["h" /* ATTACHMENT_NEEDED_WIDGET */],readOnly:false},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["g" /* ATTACHMENT_AGREEMENT_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_11" /* TREATMENT_CLASSIFICATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__["g" /* selectTreatmentPlan */],__WEBPACK_IMPORTED_MODULE_7__globals_state_selector__["selectStoreList"],__WEBPACK_IMPORTED_MODULE_8__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan,stores,customer){var messageList=[];var treatmentType=treatmentPlan.treatmentType,treatmentReason=treatmentPlan.treatmentReason,attachmentNeeded=treatmentPlan.attachmentNeeded;if(treatmentType===null){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment Type is mandatory field for Medical/Non Medical Treatment Classification.','treatmentPlan.treatmentType'));}if(treatmentType==='medical'&&treatmentReason===null){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment Reason is mandatory field for Medical Treatment.','treatmentPlan.treatmentReason'));}if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}if(eventName==='plan_done'){var numberOfAlignerLowerJaw=treatmentPlan.numberOfAlignerLowerJaw,numberOfAlignerUpperJaw=treatmentPlan.numberOfAlignerUpperJaw,treatmentDuration=treatmentPlan.treatmentDuration,iprInstructionList=treatmentPlan.iprInstructionList;var isZeroOrEmpty=function isZeroOrEmpty(value){return!Number(value);};var iprAdjustmentValues=Object.values(iprInstructionList||{});var IPRInstructionsMissing=iprAdjustmentValues.every(isZeroOrEmpty);var IPRDecided=context[__WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__["e" /* IPR_NOT_REQUIRED */]]!==undefined;var IPRNotNeeded=context[__WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__["e" /* IPR_NOT_REQUIRED */]];var store=stores.find(function(s){return s.technicalName===customer.store;});var isIPRProviderStore=store.iprProvider;var isAttachmentProviderStore=store.attachmentAvailable;if(attachmentNeeded===null&&isAttachmentProviderStore){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select if attachment is needed','treatmentPlan.attachmentNeeded'));}if(!numberOfAlignerLowerJaw&&numberOfAlignerLowerJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner lower jaw.','treatmentplan.numberOfAlignerLowerJaw'));}if(!numberOfAlignerUpperJaw&&numberOfAlignerUpperJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner upper jaw.','treatmentplan.numberOfAlignerUpperJaw'));}if(!treatmentDuration){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment duration has not been calculated','treatmentplan.treatmentDuration'));}// fixme: this validation rules should be composed on a higher level
if(isIPRProviderStore){if(!IPRDecided){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please decide whether IPR is needed.','treatmentplan.iprInstructions'));}else if(!IPRNotNeeded&&IPRInstructionsMissing||!context.hasOwnProperty(__WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__["g" /* IS_IPR_INSTRUCTIONS_LIST_SAVED */])){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please fill in the IPR requirements.','treatmentplan.iprInstructions'));}}}return messageList;}});

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["t" /* CREATE_TREATMENT_PLAN_EXTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan){var messageList=[];if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}if(eventName==='plan_done'){var numberOfAlignerLowerJaw=treatmentPlan.numberOfAlignerLowerJaw,numberOfAlignerUpperJaw=treatmentPlan.numberOfAlignerUpperJaw,treatmentDuration=treatmentPlan.treatmentDuration;if(!numberOfAlignerLowerJaw&&numberOfAlignerLowerJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner lower jaw.','treatmentplan.numberOfAlignerLowerJaw'));}if(!numberOfAlignerUpperJaw&&numberOfAlignerUpperJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner upper jaw.','treatmentplan.numberOfAlignerUpperJaw'));}if(!treatmentDuration){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment duration has not been calculated','treatmentplan.treatmentDuration'));}return messageList;}return messageList;}});

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["u" /* CREATE_TREATMENT_PLAN_EXTERNAL_PLANER */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_16" /* TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan){var messageList=[];if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}if(eventName==='plan_done'){var numberOfAlignerLowerJaw=treatmentPlan.numberOfAlignerLowerJaw,numberOfAlignerUpperJaw=treatmentPlan.numberOfAlignerUpperJaw,treatmentDuration=treatmentPlan.treatmentDuration;if(!numberOfAlignerLowerJaw&&numberOfAlignerLowerJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner lower jaw.','treatmentplan.numberOfAlignerLowerJaw'));}if(!numberOfAlignerUpperJaw&&numberOfAlignerUpperJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner upper jaw.','treatmentplan.numberOfAlignerUpperJaw'));}if(!treatmentDuration){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment duration has not been calculated','treatmentplan.treatmentDuration'));}return messageList;}return messageList;}});

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["o" /* CREATE_EXTERNAL_TREATMENT_PLAN_VISUALIZATION */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_16" /* TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__check_treatability_validator__ = __webpack_require__(1349);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["j" /* CHECK_TREATABILITY_AFTER_CLINIC */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Z" /* REQUEST_MEDICAL_EVALUATION */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["v" /* CUSTOMER_XRAY_FILE_UPLOAD */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_4__check_treatability_validator__["a" /* default */]}));

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = (function(task,processInstance,taskName,eventName,context){var messageList=[];var ReasonMedicalEval=context.ReasonMedicalEval;if(ReasonMedicalEval){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])("The reason for 'Medical Evaluation Reason' should be empty.",'checkMedicalEvaluationTracking.checkMedicalEvaluationTracking'));}if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}}return messageList;});

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treatment_state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["v" /* CREATE_TREATMENT_QUOTATION */],actionList:[{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']}],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_0" /* SALES_NOTE_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */],readOnly:true,widgetProps:{}}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__treatment_state_quotation_selector__["n" /* selectTreatmentQuotation */],__WEBPACK_IMPORTED_MODULE_2__treatment_state_quotation_selector__["k" /* selectIsTreatmentQuotationReadyForPurchase */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,treatmentQuotation,readyForPurchase){if(eventName!=='treatment_quotation_created'){return null;}var messageList=[];if(!treatmentQuotation){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('No treatment quotation created','validateTreatmentQuotation.object'));return messageList;}if(!readyForPurchase){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment Quotation not valid','validateTreatmentQuotation.valid'));}return messageList;}}));

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["p" /* CREATE_REFINEMENT_PLAN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["S" /* PROCESS_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__["g" /* selectTreatmentPlan */],__WEBPACK_IMPORTED_MODULE_7__globals_state_selector__["selectStoreList"],__WEBPACK_IMPORTED_MODULE_8__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan,stores,customer){var messageList=[];if(eventName==='plan_done'){var numberOfAlignerLowerJaw=treatmentPlan.numberOfAlignerLowerJaw,numberOfAlignerUpperJaw=treatmentPlan.numberOfAlignerUpperJaw,treatmentDuration=treatmentPlan.treatmentDuration,iprInstructionList=treatmentPlan.iprInstructionList;var isZeroOrEmpty=function isZeroOrEmpty(value){return!Number(value);};var iprAdjustmentValues=Object.values(iprInstructionList||{});var IPRInstructionsMissing=iprAdjustmentValues.every(isZeroOrEmpty);var IPRDecided=context[__WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__["e" /* IPR_NOT_REQUIRED */]]!==undefined;var IPRNotNeeded=context[__WEBPACK_IMPORTED_MODULE_6__treatment_state_plan_const__["e" /* IPR_NOT_REQUIRED */]];var isIPRProviderStore=stores.find(function(s){return s.technicalName===customer.store;}).iprProvider;if(!numberOfAlignerLowerJaw&&numberOfAlignerLowerJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner lower jaw.','treatmentplan.numberOfAlignerLowerJaw'));}if(!numberOfAlignerUpperJaw&&numberOfAlignerUpperJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner upper jaw.','treatmentplan.numberOfAlignerUpperJaw'));}if(!treatmentDuration){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment duration has not been calculated','treatmentplan.treatmentDuration'));}if(isIPRProviderStore){if(!IPRDecided){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please decide whether IPR is needed.','treatmentplan.iprInstructions'));}else if(!IPRNotNeeded&&IPRInstructionsMissing){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please fill in the IPR requirements.','treatmentplan.iprInstructions'));}}return messageList;}return messageList;}});

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["q" /* CREATE_REFINEMENT_PLAN_EXTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan){var messageList=[];if(eventName==='plan_done'){var numberOfAlignerLowerJaw=treatmentPlan.numberOfAlignerLowerJaw,numberOfAlignerUpperJaw=treatmentPlan.numberOfAlignerUpperJaw,treatmentDuration=treatmentPlan.treatmentDuration;if(!numberOfAlignerLowerJaw&&numberOfAlignerLowerJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner lower jaw.','treatmentplan.numberOfAlignerLowerJaw'));}if(!numberOfAlignerUpperJaw&&numberOfAlignerUpperJaw!==0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please add number of aligner upper jaw.','treatmentplan.numberOfAlignerUpperJaw'));}if(!treatmentDuration){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment duration has not been calculated','treatmentplan.treatmentDuration'));}return messageList;}return messageList;}});

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treatment_state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["r" /* CREATE_REFINEMENT_QUOTATION */],actionList:[{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']}],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */],readOnly:true,widgetProps:{}}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__treatment_state_quotation_selector__["n" /* selectTreatmentQuotation */],__WEBPACK_IMPORTED_MODULE_2__treatment_state_quotation_selector__["k" /* selectIsTreatmentQuotationReadyForPurchase */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,treatmentQuotation,readyForPurchase){if(eventName!=='treatment_quotation_created'){return null;}var messageList=[];if(!treatmentQuotation){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('No treatment quotation created','validateTreatmentQuotation.object'));return messageList;}if(!readyForPurchase){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment Quotation not valid','validateTreatmentQuotation.valid'));}return messageList;}}));

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["w" /* DO_SEPA_PAYMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_15" /* TREATMENT_PAYMENT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}]}));

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["x" /* ENTER_PHYSICIAN_FEEDBACK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_5__cannot_be_treated_validator__["a" /* default */]}));

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["A" /* MANUALLY_CHECK_IMAGE_AVAILABILITY */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]}]}));

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["B" /* ORDER_ALIGNER */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}]}));

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["G" /* REFUND */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Y" /* REFUND_SEPA_TRANSFER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}]}));

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["F" /* PROVIDE_TREATMENT_SETUP */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__["a" /* default */]});

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["E" /* PROVIDE_REFINEMENT_SETUP */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["X" /* REFINEMENT_REASON_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]]});

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["I" /* REVIEW_TREATMENT_PLAN */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["h" /* ATTACHMENT_NEEDED_WIDGET */],readOnly:false},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_11" /* TREATMENT_CLASSIFICATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["v" /* CUSTOMER_XRAY_FILE_UPLOAD */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan){var messageList=[];var treatmentType=treatmentPlan.treatmentType,treatmentReason=treatmentPlan.treatmentReason;if(treatmentType===null){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Treatment Type is mandatory field for Medical/Non Medical Treatment Classification.","treatmentPlan.treatmentType"));}if(treatmentType==='medical'&&treatmentReason===null){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Treatment Reason is mandatory field for Medical Treatment.","treatmentPlan.treatmentReason"));}if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}return messageList;}});

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["H" /* REVIEW_REFINEMENT_PLAN */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]]});

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["J" /* REVIEW_TREATMENT_PLAN_INTERNAL */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__["a" /* default */]});

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["K" /* SCAN_IMPRINTS */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}]}));

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["L" /* SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_1 */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_23" /* WHATS_APP_TEXT_WIDGET_CONTAINER */],widgetProps:{textId:'treatmentQuotationReminder1'}},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]}));

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["M" /* SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_2 */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_23" /* WHATS_APP_TEXT_WIDGET_CONTAINER */],widgetProps:{textId:'treatmentQuotationReminder2'}},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]}));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["N" /* SHIP_SET */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_10" /* TRAY_SIZE_WIDGET */],readOnly:false},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */],readOnly:false},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]}]}));

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_name__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:null,stateNameList:[__WEBPACK_IMPORTED_MODULE_2__state_name__["a" /* TREATMENT_QUOTATION_CREATED */]],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["z" /* IMPLANT_TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]}));

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TREATMENT_QUOTATION_CREATED; });
var TREATMENT_QUOTATION_CREATED='treatment_quotation_created';

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["O" /* TREATMENT_QUOTATION_CREATED_WHATS_APP */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_23" /* WHATS_APP_TEXT_WIDGET_CONTAINER */],widgetProps:{textId:'treatmentQuotationCreated'}},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]}));

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["P" /* TREATMENT_QUOTATION_FOLLOW_UP_CALL_1 */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]}));

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["Q" /* TREATMENT_QUOTATION_FOLLOW_UP_CALL_2 */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]}));

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["S" /* UPLOAD_TREATMENT_PLAN_FILES */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']}]}));

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["U" /* VISUALIZATION_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']}]}));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["R" /* UPLOAD_CASE */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}]}));

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["T" /* VALIDATE_CANNOT_BE_TREATED */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */],__WEBPACK_IMPORTED_MODULE_5__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer,context){var messageList=[];var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason&&eventName==='cannot_be_treated'){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));return messageList;}if(eventName!=='physician_assigned'){return null;}// make sure at least one is true
if(!customer.partnerPhysicianId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a physician.','validateAssignPhysician.physicianId'));}// make sure at least one is true
if(!customer.partnerSupplierId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_2__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a supplier','validateAssignPhysician.supplier'));}return messageList;}}));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["k" /* CLARIFY_PRE_TREATMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__["a" /* default */]}));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["D" /* PRE_TREATMENT_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_4__cannot_be_treated_validator__["a" /* default */]}));// //

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_and_shop_scan_task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__set_and_shop_scan_task_name__["b" /* BAD_IMPRINT_PATIENT_CALL */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[]}));

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["y" /* MAKE_CUSTOMER_APPOINTMENT */],widgetList:[]}));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["z" /* MAKE_NEW_CUSTOMER_APPOINTMENT */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["n" /* CREATE_3DSCAN_APPOINTMENT */]}]}));

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_and_shop_scan_task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__set_and_shop_scan_task_name__["C" /* PREPARE_TREATMENT_FILES */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}]}));

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* APPOINTMENT_REMINDER_CALL */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["f" /* APPOINTMENT_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],overwriteWidget:true}));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* CHECK_ID */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]}],overwriteWidget:true,taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer){if(eventName!=='id_checked'){return null;}var messageList=[];if(!customer.dob){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter date of birth.','validateDateOfBirth.physicianId'));}if(!customer.firstName){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter first name.','validateDateOfBirth.firstName'));}if(!customer.lastName){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter last name.','validateDateOfBirth.lastName'));}if(!customer.streetAddress){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter streetAddress.','validateDateOfBirth.streetAddress'));}if(!customer.zip){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter zip code.','validateDateOfBirth.zip'));}if(!customer.city){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter city.','validateDateOfBirth.city'));}if(!customer.countryCode){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter Country.','validateDateOfBirth.Country'));}return messageList;}}));

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* COMPLETE_ANAMNESIS */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_22" /* WHATSAPP_MESSAGES_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],overwriteWidget:true}));

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["f" /* VALIDATE_APPOINTMENT */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["f" /* APPOINTMENT_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],overwriteWidget:true}));

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["e" /* MAKE_CUSTOMER_SCAN_APPOINTMENT */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["n" /* CREATE_3DSCAN_APPOINTMENT */]}]}));

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* MAKE_CUSTOMER_IPR_APPOINTMENT */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["o" /* CREATE_IPR_APPOINTMENT */]}]}));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* CHECK_PHOTO_CHECKIN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["P" /* PHOTO_CHECKIN_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var gotoAlignerNumberUpper=context.gotoAlignerNumberUpper;var gotoAlignerNumberLower=context.gotoAlignerNumberLower;if(eventName==='goto_aligner_step'&&(!gotoAlignerNumberUpper||!gotoAlignerNumberLower)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter to which aligner the customer should change.','checkPhotoCheckin.goto_aligner_step'));}if(eventName==='return_to_precheck'&&processInstance.processCommentList.length===0){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter comment why you are returning to state precheck photo checkin.','checkPhotoCheckin.commentList'));}return messageList;}});

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["e" /* FINAL_CHECK_PHOTO_CHECKIN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["P" /* PHOTO_CHECKIN_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var gotoAlignerNumberUpper=context.gotoAlignerNumberUpper;var gotoAlignerNumberLower=context.gotoAlignerNumberLower;if(eventName==='go_back_to_aligner'&&(!gotoAlignerNumberUpper||!gotoAlignerNumberLower)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter to which aligner the customer should change.','checkPhotoCheckin.goto_aligner_step'));}return messageList;}});

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["r" /* PROVIDE_CUSTOMER_COMMUNICATION_REASON */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["a" /* ALIGNER_CUSTOMER_COMMUNICATION_COMMENT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer){var messageList=[];var treatmentExecutionList=customer.treatmentExecutionList;var alignerCheckins=treatmentExecutionList[treatmentExecutionList.length-1].alignerCheckInList;var clarificationComment=alignerCheckins[alignerCheckins.length-1].clarificationComment;if(clarificationComment===null){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please choose reason.','checkPhotoCheckin.reason'));}return messageList;}});

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* CLARIFY_REFINEMENT */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["P" /* PHOTO_CHECKIN_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["t" /* PROVIDE_PHYSICIAN_RECOMMENDATION */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["c" /* ALIGNER_SEND_RECOMMENDATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer){var messageList=[];var treatmentExecutionList=customer.treatmentExecutionList;var alignerCheckins=treatmentExecutionList[treatmentExecutionList.length-1].alignerCheckInList;var clarificationComment=alignerCheckins[alignerCheckins.length-1].clarificationComment;if(clarificationComment===null){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please choose reason.','checkPhotoCheckin.reason'));}return messageList;}});

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_name__ = __webpack_require__(1395);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:null,stateNameList:[__WEBPACK_IMPORTED_MODULE_4__state_name__["b" /* WAITING_FOR_BOTH_PAYMENTS */],__WEBPACK_IMPORTED_MODULE_4__state_name__["a" /* PAYMENT_REMINDER_SENT */]],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_15" /* TREATMENT_PAYMENT_WIDGET */]}],overwriteWidget:true,taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(processInstance,eventName,context){if(eventName!=='payments_received'){return null;}var messageList=[];var physicianPaymentReceived=context.physicianPaymentReceived;var sunshinePaymentReceived=context.sunshinePaymentReceived;// // make sure at least one is true
if(eventName==='payments_received'&&(!physicianPaymentReceived||!sunshinePaymentReceived)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])('Both payments need to be received.','checkTreatmentPayments.payments_received'));}return messageList;}}));

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WAITING_FOR_BOTH_PAYMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAYMENT_REMINDER_SENT; });
var WAITING_FOR_BOTH_PAYMENTS='waiting_for_both_payments';var PAYMENT_REMINDER_SENT='payment_reminder_sent';

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["f" /* FOLLOW_UP_CALL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["v" /* REFINEMENT_CLARIFICATION_CALL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["o" /* PRINT_MODELS */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["n" /* PRINT_MISSING_MODELS */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["I" /* MODEL_SELECTION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__new_photos_needed_validator__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_image_selector__ = __webpack_require__(48);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["l" /* PRE_CHECK_PHOTO_CHECKIN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["t" /* CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__customer_state_image_selector__["b" /* selectImageVersionList */]],taskValidator:__WEBPACK_IMPORTED_MODULE_3__new_photos_needed_validator__["a" /* default */]});

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__ = __webpack_require__(17);
var isReasonSelected=function isReasonSelected(lastImageVersion){if(!lastImageVersion.meta){return false;}if(!lastImageVersion.meta.reason){return false;}return true;};/* harmony default export */ __webpack_exports__["a"] = (function(task,processInstance,taskName,eventName,imageVersionList){if(eventName!=='new_photos_needed'){return null;}var messageList=[];var reasonSelected=false;for(var key in imageVersionList){var imageVersionGallery=imageVersionList[key];var lastImageVersion=imageVersionGallery[imageVersionGallery.length-1];if(isReasonSelected(lastImageVersion)){reasonSelected=true;break;}}if(!reasonSelected){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_0__validation_create_validation_message__["a" /* createValidationMessage */])("At least one reason must be provided.","newPhotosNeededReasonNotSelected.newPhotosNeededReasonNotSelected"));}return messageList;});

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["p" /* PRODUCE_ALIGNER */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["q" /* PRODUCE_ALIGNER_EXTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["s" /* PROVIDE_MOVEMENT_CERTIFICATE_NUMBER */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["J" /* MOVEMENT_CERTIFICATE_NUMBER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){if(eventName!=='movement_certificate_number_provided'){return null;}var messageList=[];var movementCertificateNumber=context.movementCertificateNumber;if(!movementCertificateNumber){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter a movement certificate number.','empty-movement-certificate'));}return messageList;}}));

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["w" /* SHIP_ALIGNER */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["x" /* DELIVERY_TRACKING_WIDGET */],widgetProps:{showAlignerNumberCounted:true}},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["w" /* CUSTOMS_INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_5__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){if(eventName!=='aligners_shipped'){return null;}var messageList=[];var alignerNumberCounted=context.alignerNumberCounted;if(!alignerNumberCounted){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('Please confirm number of aligner is counted.'));}return messageList;}}));

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["x" /* SHIP_ALIGNER_EXTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_7" /* SUPPLIER_TRACKING_NUMBER_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var trackingNumber=context.supplierTrackingNumber;if(!trackingNumber){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please add the tracking number before proceeding.','checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}});

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["A" /* THERMO_FORM */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["B" /* UPLOAD_PRODUCT_FILES */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["g" /* FORWARD_IMAGES_TO_PHYSICIAN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["i" /* MARKING_MODELS */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true,widgetProps:{showInitialProcess:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["h" /* MAKE_CUSTOMER_IPR_APPOINTMENT */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["o" /* CREATE_IPR_APPOINTMENT */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["j" /* NESTING */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["k" /* NEST_MISSING_MODELS */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["I" /* MODEL_SELECTION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* CREATE_INVOICE_CORRECTION */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["C" /* INVOICE_CORRECTION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Y" /* REFUND_SEPA_TRANSFER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_3__process_action__["b" /* INVOICE_CORRECTION */],taskPath:['processInstance','context','invoiceId']}]}));

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["m" /* PRINT_CASE_CARD */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["V" /* PRODUCTION_CASE_CARD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["u" /* REDUCER_ENAMEL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["M" /* PATIENT_IPR_WISHES_WIDGET */],widgetProps:{readOnly:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["c" /* ALIGNER_TREATMENT_MEDICAL_INFORMATION */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["b" /* ALIGNER_TREATMENT_EXPECTATION */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["g" /* IMPLANT_TREATMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["a" /* ALIGNER_TREATMENT */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["c" /* ALIGNER_TREATMENT_MEDICAL_INFORMATION */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["b" /* ALIGNER_TREATMENT_EXPECTATION */],__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_const__["g" /* IMPLANT_TREATMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var gotoAlignerNumberUpper=context.gotoAlignerNumberUpper;var gotoAlignerNumberLower=context.gotoAlignerNumberLower;if(eventName==='goto_aligner_step'&&(!gotoAlignerNumberUpper||!gotoAlignerNumberLower)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter to which aligner the customer should change.','checkPhotoCheckin.goto_aligner_step'));}return messageList;}});

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["z" /* START_SORTING */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["I" /* MODEL_SELECTION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["y" /* SORTING_MODELS */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["I" /* MODEL_SELECTION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* CHOOSE_ALIGNER */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["I" /* MODEL_SELECTION_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* PRODUCE_MISSING_ALIGNER_EXTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["I" /* MODEL_SELECTION_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* PRODUCE_RETAINER */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* PRODUCE_RETAINER_EXTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["e" /* SHIP_RETAINER_EXTERNAL */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_4__process_ui__["_7" /* SUPPLIER_TRACKING_NUMBER_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_5__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];var trackingNumber=context.supplierTrackingNumber;if(!trackingNumber){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_1__validation_create_validation_message__["a" /* createValidationMessage */])('Please add the tracking number before proceeding.','checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}}));

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* SHIP_RETAINER */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["x" /* DELIVERY_TRACKING_WIDGET */]}],actionList:[],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){if(eventName!=='retainer_shipped'){return null;}var messageList=[];var trackingNumber=context.trackingNumber;if(!trackingNumber){// messageList.push(createValidationMessage('Please add the tracking number before proceeding.', 'checkDeliveryTracking.checkDeliveryTracking'));
}return messageList;}}));

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* ORDER_RETAINER */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true}]}));

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["e" /* CONSULT_CUSTOMER */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],overwriteWidget:true}));

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["f" /* ENTER_DOB */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],overwriteWidget:true,taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer){if(eventName!=='done'){return null;}var messageList=[];if(!customer.dob){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter date of birth.','validateDateOfBirth.physicianId'));}if(!customer.firstName){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter first name.','validateDateOfBirth.firstName'));}if(!customer.lastName){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter last name.','validateDateOfBirth.lastName'));}if(!customer.streetAddress){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter streetAddress.','validateDateOfBirth.streetAddress'));}if(!customer.zip){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter zip code.','validateDateOfBirth.zip'));}if(!customer.city){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please enter city.','validateDateOfBirth.city'));}return messageList;}}));

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["l" /* MEDICAL_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["c" /* selectOrderedImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["b" /* selectAnamnesisList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList,_ref){var alignerTreatmentPhysicianAssessment=_ref.alignerTreatmentPhysicianAssessment;var messageList=[];var isIPRRequired=alignerTreatmentPhysicianAssessment.formData.iprPossible;var isPretreatmentNeeded=eventName==='pretreatment_needed';var canNotBeTreated=eventName==='cannot_be_treated';var isMedicalCheckDone=eventName==='medical_check_done';var isImageNotComplete=!!imageVersionList.other&&Object.keys(imageVersionList).length<9||Object.keys(imageVersionList).length<8;if(canNotBeTreated&&!context.cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'cannot_be_treated'));}if(isPretreatmentNeeded&&!context.preTreatmentReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'pretreatment' before proceeding.",'preTreatmentReason'));}if(context.patientScanned===undefined){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if you have scanned the customer.','patientScanned'));}if(context.patientScanned===false&&isMedicalCheckDone){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('With patient scanned "No", process can only proceed with "pretreatment needed" or "cannot be treated"','patientScanned'));}if(isImageNotComplete&&isMedicalCheckDone){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateAllPhotosUploaded'));}// isIPRRequired: if null, it means the field is required by not done. if the field is not required (the corresponding shop does not provide IPR), isIPRRequired will be undefined, and need not to be validated
if(isIPRRequired===null&&isMedicalCheckDone){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if patient needs IPR','validateIPRRequired'));}if(isMedicalCheckDone&&(context.preTreatmentReason||context.cannotBeTreatedReason)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please remove the reason for \'pretreatment\' before proceeding.','validateMedicalCheckDone'));}return messageList;}}));

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["o" /* RESCAN */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */],hideIPR:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_8__process_action__["f" /* RESCAN_APPOINTMENT_TOGGLE_IMAGE_VIEW */],taskPath:[]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["b" /* selectImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["b" /* selectAnamnesisList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList){var messageList=[];var isImageNotComplete=!!imageVersionList.other&&Object.keys(imageVersionList).length<9||Object.keys(imageVersionList).length<8;if(isImageNotComplete){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateAllPhotosUploaded'));}return messageList;}}));

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["n" /* REFINEMENT_MEDICAL_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["X" /* REFINEMENT_REASON_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */],hideIPR:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["q" /* CUSTOMER_IMAGE_REUPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_8__process_action__["f" /* RESCAN_APPOINTMENT_TOGGLE_IMAGE_VIEW */],taskPath:[]},{action:__WEBPACK_IMPORTED_MODULE_8__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_8__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["b" /* selectImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["b" /* selectAnamnesisList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList){var messageList=[];var isImageNotComplete=!!imageVersionList.other&&Object.keys(imageVersionList).length<9||Object.keys(imageVersionList).length<8;if(context.patientScanned===undefined){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if you have scanned the customer.','patientScanned'));}if(isImageNotComplete){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateAllPhotosUploaded'));}return messageList;}}));

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["m" /* MEDICAL_CHECK_WITH_PRETREATMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["c" /* selectOrderedImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["b" /* selectAnamnesisList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList,_ref){var alignerTreatmentPhysicianAssessment=_ref.alignerTreatmentPhysicianAssessment;var messageList=[];var isIPRRequired=alignerTreatmentPhysicianAssessment.formData.iprPossible;var isPretreatmentNeeded=eventName==='pretreatment_needed';var canNotBeTreated=eventName==='cannot_be_treated';var isMedicalCheckDone=eventName==='medical_check_done';var isImageNotComplete=!!imageVersionList.other&&Object.keys(imageVersionList).length<9||Object.keys(imageVersionList).length<8;if(canNotBeTreated&&!context.cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'cannot_be_treated'));}if(isPretreatmentNeeded&&!context.preTreatmentReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'pretreatment' before proceeding.",'preTreatmentReason'));}if(context.patientScanned===undefined){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if you have scanned the customer.','patientScanned'));}if(context.patientScanned===false&&!canNotBeTreated){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('With patient scanned No , process can only proceed with "cannot be treated"','patientScanned'));}if(isImageNotComplete&&!canNotBeTreated){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateAllPhotosUploaded'));}// isIPRRequired: if null, it means the field is required by not done. if the field is not required, isIPRRequired will be undefined, and need not to be validated
if(isIPRRequired===null&&!canNotBeTreated){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if patient needs IPR','validateIPRRequired'));}if(isMedicalCheckDone&&(context.preTreatmentReason||context.cannotBeTreatedReason)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please remove the reason for \'pretreatment\' before proceeding.','validateMedicalCheckDone'));}return messageList;}}));

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_state_selector__ = __webpack_require__(37);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["k" /* MEDICAL_ASSESSMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["M" /* PATIENT_IPR_WISHES_WIDGET */],widgetProps:{readOnly:false,templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */],taskName:'medical_assessment'}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["g" /* ATTACHMENT_AGREEMENT_WIDGET */],readOnly:false},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["c" /* selectOrderedImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["d" /* selectMedicalAssessment */],__WEBPACK_IMPORTED_MODULE_8__globals_state_selector__["selectStoreList"]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList,medAssessment,stores){var messageList=[];var isPretreatmentNeeded=eventName==='pretreatment_needed';var canNotBeTreated=eventName==='cannot_be_treated';var isMedicalCheckDone=eventName==='medical_check_done';var isImageNotComplete=!!imageVersionList.other&&Object.keys(imageVersionList).length<9||Object.keys(imageVersionList).length<8;var store=stores.find(function(s){return s.technicalName===context.store;});var isIPRProviderStore=store.iprProvider;var isAttachmentProviderStore=store.attachmentAvailable;var iprAgreementMade=typeof medAssessment.formData.iprAgreed==="boolean";var attachmentDecisionMade=typeof medAssessment.formData.attachmentAgreed==="boolean";if(isIPRProviderStore&&!iprAgreementMade){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add the patient agreement for IPR before proceeding.','iprAgreed'));}if(isAttachmentProviderStore&&!attachmentDecisionMade){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add the patient agreement for Attachment before proceeding.','attachmentAgreed'));}if(canNotBeTreated&&!context.cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'cannot_be_treated'));}if(isPretreatmentNeeded&&!context.preTreatmentReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'pretreatment' before proceeding.",'preTreatmentReason'));}if(context.patientScanned===undefined){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if you have scanned the customer.','patientScanned'));}if(context.patientScanned===false&&!canNotBeTreated){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('With patient scanned No , process can only proceed with "cannot be treated"','patientScanned'));}if(isImageNotComplete&&!canNotBeTreated){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateAllPhotosUploaded'));}if(isMedicalCheckDone&&(context.preTreatmentReason||context.cannotBeTreatedReason)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please remove the reason for \'pretreatment\' before proceeding.','validateMedicalCheckDone'));}return messageList;}}));

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* CONFIRM_MEDICAL_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["c" /* selectOrderedImageVersionList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList){var messageList=[];var isPretreatmentNeeded=eventName==='pretreatment_needed';var canNotBeTreated=eventName==='cannot_be_treated';var isDone=eventName==='done';if(canNotBeTreated&&!context.cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'cannot_be_treated'));}if(isPretreatmentNeeded&&!context.preTreatmentReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'pretreatment' before proceeding.",'preTreatmentReason'));}if(!imageVersionList||Object.keys(imageVersionList).length<8){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateThreeShapeCase'));}if(isDone&&(context.preTreatmentReason||context.cannotBeTreatedReason)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please remove the reason for \'pretreatment\' before proceeding.','validateMedicalCheckDone'));}return messageList;}}));

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* CONFIRM_REFINEMENT_MEDICAL_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["X" /* REFINEMENT_REASON_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */],hideIPR:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}]}));

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["c" /* selectOrderedImageVersionList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList){var messageList=[];var isPretreatmentNeeded=eventName==='pretreatment_needed';var canNotBeTreated=eventName==='cannot_be_treated';var isDone=eventName==='done';if(canNotBeTreated&&!context.cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'cannot_be_treated'));}if(isPretreatmentNeeded&&!context.preTreatmentReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'pretreatment' before proceeding.",'preTreatmentReason'));}if(!imageVersionList||Object.keys(imageVersionList).length<8){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateThreeShapeCase'));}if(isDone&&(context.preTreatmentReason||context.cannotBeTreatedReason)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please remove the reason for \'pretreatment\' before proceeding.','validateMedicalCheckDone'));}return messageList;}}));

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* CONFIRM_MEDICAL_ASSESSMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["g" /* ATTACHMENT_AGREEMENT_WIDGET */],readOnly:false},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["c" /* selectOrderedImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__globals_state_selector__["isAttachmentProviderStore"],__WEBPACK_IMPORTED_MODULE_8__anamnesis_state_anamnesis_selector__["d" /* selectMedicalAssessment */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList,isAttachmentProviderStore,medAssessment){var messageList=[];var isPretreatmentNeeded=eventName==='pretreatment_needed';var canNotBeTreated=eventName==='cannot_be_treated';var isDone=eventName==='done';var attachmentAgreed=typeof medAssessment.formData.attachmentAgreed==="boolean";if(canNotBeTreated&&!context.cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'cannot_be_treated'));}if(isPretreatmentNeeded&&!context.preTreatmentReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'pretreatment' before proceeding.",'preTreatmentReason'));}if(!imageVersionList||Object.keys(imageVersionList).length<8){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateThreeShapeCase'));}if(isDone&&(context.preTreatmentReason||context.cannotBeTreatedReason)){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please remove the reason for \'pretreatment\' before proceeding.','validateMedicalCheckDone'));}if(isAttachmentProviderStore&&!attachmentAgreed){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please add the patient agreement for Attachment before proceeding.','attachmentAgreed'));}return messageList;}}));

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["q" /* SELECT_REFINEMENT_TYPE */],taskOverviewProps:{},overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["X" /* REFINEMENT_REASON_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}]}));

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["p" /* SCAN_CUSTOMER */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]}],overwriteWidget:true}));

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_image_selector__ = __webpack_require__(48);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["r" /* TAKE_PICTURES */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__customer_state_image_selector__["b" /* selectImageVersionList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,imageVersionList){var messageList=[];if(!imageVersionList||Object.keys(imageVersionList).length<8){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please take all pictures first.','validateThreeShapeCase'));}return messageList;}}));

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["s" /* UPLOAD_SCANS */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["u" /* CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}]}));

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_name__ = __webpack_require__(319);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_2__task_name__["c" /* UPLOAD_CBCT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_0__process_ui__["k" /* COMMENT_LIST */]}]}));

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["t" /* UPLOAD_SCAN_FILES_MANUALLY */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,customer){if(!customer.scanFileList||customer.scanFileList.length<2){return[Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please upload at least 2 scan files.','scan_file_upload_length')];}return[];}}));

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["j" /* MATCH_3SHAPE */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["G" /* MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]}],overwriteWidget:true,taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var threeShapeCaseId=context.threeShapeCaseId;var messageList=[];if(eventName==='done'&&!threeShapeCaseId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please select a case','validateThreeShapeCase'));}if(eventName==='not_scanned'&&threeShapeCaseId){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please deselect the case','validateThreeShapeCase'));}return messageList;}}));

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__set_and_shop_scan_cannot_be_treated_validator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["u" /* VALIDATE_PRETREATMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:__WEBPACK_IMPORTED_MODULE_3__set_and_shop_scan_cannot_be_treated_validator__["a" /* default */]}));

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["g" /* IPR_CLEARING_UP */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]}],overwriteWidget:true}));

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["h" /* IPR_EXPLANATION */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]}],overwriteWidget:true}));

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["i" /* MANUAL_ADDRESS_CHECK */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]}],overwriteWidget:true}));

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_and_shop_scan_task_name__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__set_and_shop_scan_task_name__["m" /* COMPLEXITY_TREATMENT */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["l" /* COMPLEXITY_TREATMENT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_5__treatment_state_plan_selector__["g" /* selectTreatmentPlan */],__WEBPACK_IMPORTED_MODULE_6__state_instance_detail_selector__["k" /* selectProcessContext */]],actionList:[{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}],taskValidator:function taskValidator(task,processInstance,taskName,eventName,treatmentPlan,processContext){var messageList=[];if(treatmentPlan===undefined&&processContext.complexity===''){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please choose a treatment complexity.','validateTreatmentPlanComplexity'));}if(treatmentPlan&&!treatmentPlan.complexity){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_3__validation_create_validation_message__["a" /* createValidationMessage */])('Please choose a treatment complexity.','validateTreatmentPlanComplexity'));}return messageList;}}));

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* IMPLANT_MEDICAL_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */],widgetProps:{isSaveNeeded:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["b" /* selectImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["b" /* selectAnamnesisList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList){var messageList=[];if(context.patientScanned===undefined){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if you have scanned the customer.','patientScanned'));}return messageList;}}));

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* CONFIRM_IMPLANT_MEDICAL_CHECK */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],widgetProps:{skipImages:['lower-row-of-teeth','upper-row-with-aligner','lower-row-with-aligner']}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["N" /* PATIENT_SCANNED_WIDGET */],widgetProps:{isSaveNeeded:true}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_4__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_6__customer_state_image_selector__["b" /* selectImageVersionList */],__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_anamnesis_selector__["b" /* selectAnamnesisList */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,imageVersionList){var messageList=[];if(context.patientScanned===undefined){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])('Please select, if you have scanned the customer.','patientScanned'));}return messageList;}}));

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* IMPLANT_CREATE_TREATMENT_PLAN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){var messageList=[];if(eventName==='clarify_cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}if(eventName==='plan_done'){return messageList;}return messageList;}});

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* IMPLANT_REVIEW_TREATMENT_PLAN */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan){var messageList=[];if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}return messageList;}});

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treatment_state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* IMPLANT_CREATE_TREATMENT_QUOTATION */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["z" /* IMPLANT_TREATMENT_QUOTATION_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */],readOnly:true,widgetProps:{}}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_5__treatment_state_quotation_selector__["n" /* selectTreatmentQuotation */],__WEBPACK_IMPORTED_MODULE_5__treatment_state_quotation_selector__["h" /* selectIsImplantTreatmentQuotationReadyForPurchase */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,treatmentQuotation,readyForPurchase){if(eventName!=='treatment_quotation_created'){return null;}var messageList=[];if(!treatmentQuotation){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('No treatment quotation created','validateTreatmentQuotation.object'));return messageList;}if(!readyForPurchase){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_4__validation_create_validation_message__["a" /* createValidationMessage */])('Treatment Quotation not valid','validateTreatmentQuotation.valid'));}return messageList;}}));

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* QM_REVIEW_TREATMENT_PLAN_INTERNAL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],widgetProps:{excludeTemplateKeyList:[__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_6__anamnesis_state_anamnesis_const__["e" /* IMPLANT_CONSULTATION_AND_FINDINGS */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_selector__["k" /* selectProcessContext */],__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_selector__["g" /* selectTreatmentPlan */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context,treatmentPlan){var messageList=[];if(eventName==='cannot_be_treated'){var cannotBeTreatedReason=context.cannotBeTreatedReason;if(!cannotBeTreatedReason){messageList.push(Object(__WEBPACK_IMPORTED_MODULE_5__validation_create_validation_message__["a" /* createValidationMessage */])("Please add the reason for 'cannot be treated' before proceeding.",'checkDeliveryTracking.checkDeliveryTracking'));}return messageList;}return messageList;}});

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["d" /* NESTING_SURGICAL_GUIDE */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["e" /* PACK_SURGICAL_GUIDE */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["f" /* PRINT_SURGICAL_GUIDE */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["g" /* SHIP_SURGICAL_GUIDE */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["x" /* DELIVERY_TRACKING_WIDGET */],widgetProps:{showAlignerNumberCounted:true}},{component:__WEBPACK_IMPORTED_MODULE_3__process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_4__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]}],taskValidatorSelector:[__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */]],taskValidator:function taskValidator(task,processInstance,taskName,eventName,context){if(eventName!=='surgical_guide_shipped'){return null;}return[];}}));

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* FIT_GUIDE */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["c" /* MARKING_AND_EXPORT */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']}]});

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* IMPLANT_SURGERY */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["h" /* IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],widgetProps:{templateKey:__WEBPACK_IMPORTED_MODULE_3__anamnesis_state_anamnesis_const__["f" /* IMPLANT_SURGERY_DOCUMENTATION */]}},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */],readOnly:true}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["e" /* QUOTATION_CUSTOMER_LOADED */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retainer_refinement_task_name__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__retainer_refinement_task_name__["a" /* PREPARE_RETAINER_FILES */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_4" /* SENT_EMAIL_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */]}]}));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PREPARE_RETAINER_FILES; });
var PREPARE_RETAINER_FILES='prepare_retainer_files';

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* CALL_CUSTOMER */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["F" /* LOW_NPS_REASON_WIDGET_CONTAINER */]}]}));

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_CUSTOMER; });
var CALL_CUSTOMER='call_customer';

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_action__ = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["a"] = ({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["a" /* END_OF_TREATMENT_CALL */],taskOverviewProps:{},widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["k" /* COMMENT_LIST */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],readOnly:true},{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */]}],actionList:[{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["c" /* PROCESS_INSTANCE */],taskPath:['processInstance']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["h" /* TREATMENT_PLAN */],taskPath:['objectDetail','customer','treatmentPlanList',0]},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["g" /* SALES_ORDER */],taskPath:['objectDetail']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["a" /* CUSTOMER */],taskPath:['objectDetail','customer']},{action:__WEBPACK_IMPORTED_MODULE_2__process_action__["i" /* TREATMENT_QUOTATION */],taskPath:['objectDetail']}]});

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_OF_TREATMENT_CALL; });
var END_OF_TREATMENT_CALL='end_of_treatment_call';

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["b" /* INPUT_REFUND_DATA */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["L" /* PARTIAL_INVOICE_CORRECTION_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]}]}));

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_task_definition__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_name__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_1__task_name__["a" /* CONFIRM_REFUND */],overwriteWidget:true,widgetList:[{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["K" /* OVERVIEW */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["L" /* PARTIAL_INVOICE_CORRECTION_CONTAINER */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["k" /* COMMENT_LIST */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["D" /* INVOICE_LIST_WIDGET */]},{component:__WEBPACK_IMPORTED_MODULE_2__process_ui__["O" /* PAYMENT_LIST_WIDGET */]}]}));

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task_name__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_task_definition__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__default_task_definition__["a" /* createUIDefinition */])({taskName:__WEBPACK_IMPORTED_MODULE_0__task_name__["b" /* CLARIFY_ALIGNER_CHECKIN_COMMENT */],widgetList:[{component:__WEBPACK_IMPORTED_MODULE_1__process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */]}]}));

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enrichFinishedBy */
/* unused harmony export enrichCreatedBy */
/* unused harmony export enrichTransitionList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enrichTaskDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals_index__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__security_state_auth_selector__ = __webpack_require__(23);
var enrichFinishedBy=function enrichFinishedBy(state,task){if(!task.finishedByUserId){return;}task.finishedByUserName=__WEBPACK_IMPORTED_MODULE_0__globals_index__["a" /* default */].selector.selectUserDisplayNameById(state,task.finishedByUserId);};var enrichCreatedBy=function enrichCreatedBy(state,task){task.objectDetail.customer.cbctFileList.forEach(function(file){file.createdByUser=__WEBPACK_IMPORTED_MODULE_0__globals_index__["a" /* default */].selector.selectUserDisplayNameById(state,file.createdByUserId);});};var enrichTransitionList=function enrichTransitionList(state,task){var transitionList=task.processInstance.currentState.transitionList;for(var index=0;index<transitionList.length;index++){var transition=transitionList[index];transition.isAllowedForUser=transition.requiredRoleList?Object(__WEBPACK_IMPORTED_MODULE_1__security_state_auth_selector__["i" /* selectHasRole */])(state,transition.requiredRoleList):true;}};var enrichTaskDetail=function enrichTaskDetail(state,task){enrichFinishedBy(state,task);enrichTransitionList(state,task);enrichCreatedBy(state,task);};

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_ui_definition__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__name_component_mapping__ = __webpack_require__(1473);
var componentNotDefined=function componentNotDefined(componentName){return function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__["a" /* default */],{title:componentName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Not defined'));};};var getComponentForName=function getComponentForName(componentName){var component=__WEBPACK_IMPORTED_MODULE_7__name_component_mapping__["a" /* NAME_COMPONENT_MAPPING */][componentName];return component||componentNotDefined(componentName);};var TaskDetail=function TaskDetail(props){var task=props.task,taskName=props.taskName,taskReadOnly=props.taskReadOnly,noFollowUp=props.noFollowUp,fetching=props.fetching;if(noFollowUp){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__["a" /* default */],{title:'No follow up task'});}if(!task){return null;}var _getUIDefinitionByTas=Object(__WEBPACK_IMPORTED_MODULE_5__ui_definition_ui_definition__["b" /* getUIDefinitionByTaskName */])(taskName),widgetList=_getUIDefinitionByTas.widgetList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},widgetList.map(function(widget,index){var component=widget.component,readOnly=widget.readOnly,_widget$widgetProps=widget.widgetProps,widgetProps=_widget$widgetProps===undefined?{}:_widget$widgetProps;var Component=getComponentForName(component);readOnly=readOnly||taskReadOnly;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({key:index,readOnly:!!readOnly,taskReadOnly:taskReadOnly},widgetProps,props));}));};TaskDetail.propTypes={task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,taskName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidUpdate:function componentDidUpdate(prevProps){if(!!prevProps&&prevProps.taskName!==this.props.taskName){window.scrollTo({top:0,left:0});}},componentDidMount:function componentDidMount(){if(this.props.taskId){this.props.findTaskDetail(this.props.taskId);}if(this.props.processInstanceId){this.props.findTaskDetailByProcessInstanceId(this.props.processInstanceId);}}})(Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(TaskDetail)));

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME_COMPONENT_MAPPING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_component_task_widget_PhysicianAndSupplierWidgetContainer__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_component_task_widget_CustomerImageWidgetContainer__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_component_task_widget_CustomerImageUploadWidgetContainer__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_component_task_widget_CustomerImageReuploadWidgetContainer__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_component_task_widget_ScanFileUploadWidgetContainer__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__task_widget_TaskOverviewWidgetContainer__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__task_widget_TransitionListWidgetContainer__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__task_widget_CommentListWidgetContainer__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__task_widget_CreateIprAppointmentContainer__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__task_widget_Create3DScanAppointmentContainer__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__task_widget_TechnicalLogContainer__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__task_widget_StateTransitionLogContainer__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sales_order_component_task_widget_SalesOrderOverviewWidgetContainer__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__customer_component_task_widget_TraySizeWidgetContainer__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sales_order_component_task_widget_ImprintScanStatusWidgetContainer__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sales_order_component_task_widget_SalesOrderCustomerWidgetContainer__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sales_order_component_task_widget_SentEmailWidgetContainer__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sales_order_component_task_widget_InvoiceListWidgetContainer__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sales_order_component_task_widget_PaymentListWidgetContainer__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__treatment_component_task_widget_TreatmentPlanWidgetContainer__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__treatment_component_task_widget_TreatmentQuotationWidgetContainer__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__treatment_component_task_widget_ImplantTreatmentQuotationWidgetContainer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sales_order_component_task_widget_TreatmentPaymentWidgetContainer__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sales_order_component_task_widget_DeliveryTrackingNumberWidgetContainer__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sales_order_component_task_widget_RefundSepaTransferWidgetContainer__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__customer_component_task_widget_ProductionFileUploadWidgetContainer__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__customer_component_task_widget_TreatmentPlanFileUploadWidgetContainer__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__sales_order_component_task_widget_SupplierTrackingNumberWidgetContainer__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__treatment_component_task_widget_AlignerLabelWidgetContainer__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sales_order_component_task_widget_CannotBeTreatedReasonWidgetContainer__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sales_order_component_task_widget_WhatsAppTextWidgetContainer__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__treatment_component_task_widget_TreatmentDurationWidgetContainer__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sales_order_component_task_widget_PhotoCheckinWidgetContainer__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__treatment_component_task_widget_MedicalPhotoCheckWidgetContainer__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__treatment_component_task_widget_TreatmentVisualizationWidgetContainer__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__invoice_component_task_widget_MovementCertificateNumberWidgetContainer__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__logistic_component_task_widget_ShipmentListWidgetContainer__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__customer_component_task_widget_TransferDriveFilesContainer__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__customer_component_task_widget_CustomerContactWidgetContainer__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__customer_component_task_widget_TreatmentExecutionWidgetContainer__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__customer_component_task_widget_TreatmentFeedbackWidgetContainer__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__threeshape_component_task_widget_Match3ShapeCustomerWidgetContainer__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__sales_order_component_task_widget_InitialHesitationWidgetContainer__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__anamnesis_component_task_widget_AnamnesisEditWidgetContainer__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__anamnesis_component_task_widget_AnamnesisListWidgetContainer__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__task_widget_PatientScannedWidgetContainer__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__appointment_component_task_widget_AppointmentListWidgetContainer__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__customer_component_task_widget_TreatmentPlanExternalFileUploadWidgetContainer__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__invoice_component_task_widget_InvoiceCorrectionWidgetContainer__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__sales_order_component_task_widget_PreTreatmentReasonWidgetContainer__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__sales_order_component_task_widget_ProductionCaseCardWidgetContainer__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__treatment_component_task_widget_IPRInstructionsWidgetContainer__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__treatment_component_task_widget_ModelSelectionWidgetContainer__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__sales_order_component_task_widget_VoucherWidgetContainer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__task_widget_ComplexityTreatmentWidgetContainer__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__customer_component_task_widget_customerPreCheckinImageWidget_CustomerPreCheckinImageWidgetContainer__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__customer_component_cbct_file_upload_CbctFileUploadContainer__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__customer_component_task_widget_ImplantTreatmentPlanUploadWidgetContainer__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__customer_component_task_widget_AlignerCustomerCommunicationCommentWidgetContainer__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__customer_component_task_widget_AlignerSendRecommendationWidgetContainer__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__refinement_component_RefinementReasonWidgetContainer__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__feedback_component_LowNpsReasonWidgetContainer__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__sales_order_component_task_widget_CustomsInvoiceListWidgetContainer__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__partial_refund_component_PartialInvoiceCorrectionWidgetContainer__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__treatment_component_task_widget_TreatmentClassificationWidgetContainer__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__customer_component_task_widget_XRayFileUploadWidgetContainer__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__whatsapp_messages_component_WhatsappMessagesWidgetContainer__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__task_widget_RequestMedicalEvalWidgetContainer__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__customer_component_task_widget_ProcessListCommentWidgetContainer__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__task_widget_PatientIPRWishesWidgetContainer__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__sales_SalesNoteWidgetContainer_js__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__task_widget_AttachmentNeededWidgetContainer__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__task_widget_AttachmentAgreementWidgetContainer__ = __webpack_require__(1608);
var _NAME_COMPONENT_MAPPI;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NAME_COMPONENT_MAPPING=(_NAME_COMPONENT_MAPPI={},_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["K" /* OVERVIEW */],__WEBPACK_IMPORTED_MODULE_6__task_widget_TaskOverviewWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["o" /* CREATE_IPR_APPOINTMENT */],__WEBPACK_IMPORTED_MODULE_9__task_widget_CreateIprAppointmentContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["n" /* CREATE_3DSCAN_APPOINTMENT */],__WEBPACK_IMPORTED_MODULE_10__task_widget_Create3DScanAppointmentContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_7__task_widget_TransitionListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["k" /* COMMENT_LIST */],__WEBPACK_IMPORTED_MODULE_8__task_widget_CommentListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_8" /* TECHNICAL_LOG_CONTAINER */],__WEBPACK_IMPORTED_MODULE_11__task_widget_TechnicalLogContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_6" /* STATE_TRANSITION_LOG_CONTAINER */],__WEBPACK_IMPORTED_MODULE_12__task_widget_StateTransitionLogContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */],__WEBPACK_IMPORTED_MODULE_13__sales_order_component_task_widget_SalesOrderOverviewWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_1" /* SALES_ORDER_CUSTOMER_WIDGET */],__WEBPACK_IMPORTED_MODULE_16__sales_order_component_task_widget_SalesOrderCustomerWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_4" /* SENT_EMAIL_WIDGET */],__WEBPACK_IMPORTED_MODULE_17__sales_order_component_task_widget_SentEmailWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_22" /* WHATSAPP_MESSAGES_WIDGET */],__WEBPACK_IMPORTED_MODULE_67__whatsapp_messages_component_WhatsappMessagesWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["D" /* INVOICE_LIST_WIDGET */],__WEBPACK_IMPORTED_MODULE_18__sales_order_component_task_widget_InvoiceListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["O" /* PAYMENT_LIST_WIDGET */],__WEBPACK_IMPORTED_MODULE_19__sales_order_component_task_widget_PaymentListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_10" /* TRAY_SIZE_WIDGET */],__WEBPACK_IMPORTED_MODULE_14__customer_component_task_widget_TraySizeWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["A" /* IMPRINT_SCAN_STATUS_WIDGET */],__WEBPACK_IMPORTED_MODULE_15__sales_order_component_task_widget_ImprintScanStatusWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],__WEBPACK_IMPORTED_MODULE_1__customer_component_task_widget_PhysicianAndSupplierWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["s" /* CUSTOMER_IMAGE_WIDGET */],__WEBPACK_IMPORTED_MODULE_2__customer_component_task_widget_CustomerImageWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["t" /* CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET */],__WEBPACK_IMPORTED_MODULE_56__customer_component_task_widget_customerPreCheckinImageWidget_CustomerPreCheckinImageWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_3__customer_component_task_widget_CustomerImageUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["q" /* CUSTOMER_IMAGE_REUPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_4__customer_component_task_widget_CustomerImageReuploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_18" /* TREATMENT_PLAN_WIDGET */],__WEBPACK_IMPORTED_MODULE_20__treatment_component_task_widget_TreatmentPlanWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_5__customer_component_task_widget_ScanFileUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_27__customer_component_task_widget_TreatmentPlanFileUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_26__customer_component_task_widget_ProductionFileUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],__WEBPACK_IMPORTED_MODULE_21__treatment_component_task_widget_TreatmentQuotationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_15" /* TREATMENT_PAYMENT_WIDGET */],__WEBPACK_IMPORTED_MODULE_23__sales_order_component_task_widget_TreatmentPaymentWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["x" /* DELIVERY_TRACKING_WIDGET */],__WEBPACK_IMPORTED_MODULE_24__sales_order_component_task_widget_DeliveryTrackingNumberWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["Y" /* REFUND_SEPA_TRANSFER_WIDGET */],__WEBPACK_IMPORTED_MODULE_25__sales_order_component_task_widget_RefundSepaTransferWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_7" /* SUPPLIER_TRACKING_NUMBER_WIDGET */],__WEBPACK_IMPORTED_MODULE_28__sales_order_component_task_widget_SupplierTrackingNumberWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_29__treatment_component_task_widget_AlignerLabelWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["i" /* CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_30__sales_order_component_task_widget_CannotBeTreatedReasonWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_50__sales_order_component_task_widget_PreTreatmentReasonWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_23" /* WHATS_APP_TEXT_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_31__sales_order_component_task_widget_WhatsAppTextWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_32__treatment_component_task_widget_TreatmentDurationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_11" /* TREATMENT_CLASSIFICATION_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_65__treatment_component_task_widget_TreatmentClassificationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["w" /* CUSTOMS_INVOICE_LIST_WIDGET */],__WEBPACK_IMPORTED_MODULE_63__sales_order_component_task_widget_CustomsInvoiceListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["P" /* PHOTO_CHECKIN_WIDGET */],__WEBPACK_IMPORTED_MODULE_33__sales_order_component_task_widget_PhotoCheckinWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */],__WEBPACK_IMPORTED_MODULE_34__treatment_component_task_widget_MedicalPhotoCheckWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_35__treatment_component_task_widget_TreatmentVisualizationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["p" /* CUSTOMER_CONTACT_WIDGET */],__WEBPACK_IMPORTED_MODULE_39__customer_component_task_widget_CustomerContactWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["u" /* CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET */],__WEBPACK_IMPORTED_MODULE_38__customer_component_task_widget_TransferDriveFilesContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["J" /* MOVEMENT_CERTIFICATE_NUMBER_WIDGET */],__WEBPACK_IMPORTED_MODULE_36__invoice_component_task_widget_MovementCertificateNumberWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_5" /* SHIPMENT_LIST_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_37__logistic_component_task_widget_ShipmentListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_13" /* TREATMENT_EXECUTION_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_40__customer_component_task_widget_TreatmentExecutionWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_14" /* TREATMENT_FEEDBACK_WIDGET */],__WEBPACK_IMPORTED_MODULE_41__customer_component_task_widget_TreatmentFeedbackWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["G" /* MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_42__threeshape_component_task_widget_Match3ShapeCustomerWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_43__sales_order_component_task_widget_InitialHesitationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["d" /* ANAMNESIS_EDIT_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_44__anamnesis_component_task_widget_AnamnesisEditWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["e" /* ANAMNESIS_LIST_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_45__anamnesis_component_task_widget_AnamnesisListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_16" /* TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_48__customer_component_task_widget_TreatmentPlanExternalFileUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["f" /* APPOINTMENT_LIST_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_47__appointment_component_task_widget_AppointmentListWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["C" /* INVOICE_CORRECTION_WIDGET */],__WEBPACK_IMPORTED_MODULE_49__invoice_component_task_widget_InvoiceCorrectionWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["V" /* PRODUCTION_CASE_CARD_WIDGET */],__WEBPACK_IMPORTED_MODULE_51__sales_order_component_task_widget_ProductionCaseCardWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["E" /* IPR_INSTRUCTIONS_WIDGET */],__WEBPACK_IMPORTED_MODULE_52__treatment_component_task_widget_IPRInstructionsWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["M" /* PATIENT_IPR_WISHES_WIDGET */],__WEBPACK_IMPORTED_MODULE_70__task_widget_PatientIPRWishesWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["I" /* MODEL_SELECTION_WIDGET */],__WEBPACK_IMPORTED_MODULE_53__treatment_component_task_widget_ModelSelectionWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["N" /* PATIENT_SCANNED_WIDGET */],__WEBPACK_IMPORTED_MODULE_46__task_widget_PatientScannedWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_21" /* VOUCHER_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_54__sales_order_component_task_widget_VoucherWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["l" /* COMPLEXITY_TREATMENT_WIDGET */],__WEBPACK_IMPORTED_MODULE_55__task_widget_ComplexityTreatmentWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["j" /* CBCT_FILE_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_57__customer_component_cbct_file_upload_CbctFileUploadContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */],__WEBPACK_IMPORTED_MODULE_58__customer_component_task_widget_ImplantTreatmentPlanUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["z" /* IMPLANT_TREATMENT_QUOTATION_WIDGET */],__WEBPACK_IMPORTED_MODULE_22__treatment_component_task_widget_ImplantTreatmentQuotationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["a" /* ALIGNER_CUSTOMER_COMMUNICATION_COMMENT_WIDGET */],__WEBPACK_IMPORTED_MODULE_59__customer_component_task_widget_AlignerCustomerCommunicationCommentWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["c" /* ALIGNER_SEND_RECOMMENDATION_WIDGET */],__WEBPACK_IMPORTED_MODULE_60__customer_component_task_widget_AlignerSendRecommendationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["X" /* REFINEMENT_REASON_WIDGET */],__WEBPACK_IMPORTED_MODULE_61__refinement_component_RefinementReasonWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["F" /* LOW_NPS_REASON_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_62__feedback_component_LowNpsReasonWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["L" /* PARTIAL_INVOICE_CORRECTION_CONTAINER */],__WEBPACK_IMPORTED_MODULE_64__partial_refund_component_PartialInvoiceCorrectionWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["v" /* CUSTOMER_XRAY_FILE_UPLOAD */],__WEBPACK_IMPORTED_MODULE_66__customer_component_task_widget_XRayFileUploadWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["Z" /* REQUEST_MEDICAL_EVALUATION */],__WEBPACK_IMPORTED_MODULE_68__task_widget_RequestMedicalEvalWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["S" /* PROCESS_LIST */],__WEBPACK_IMPORTED_MODULE_69__customer_component_task_widget_ProcessListCommentWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_0" /* SALES_NOTE_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_71__sales_SalesNoteWidgetContainer_js__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["h" /* ATTACHMENT_NEEDED_WIDGET */],__WEBPACK_IMPORTED_MODULE_72__task_widget_AttachmentNeededWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["g" /* ATTACHMENT_AGREEMENT_WIDGET */],__WEBPACK_IMPORTED_MODULE_73__task_widget_AttachmentAgreementWidgetContainer__["a" /* default */]),_NAME_COMPONENT_MAPPI);

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_VersionedImageList__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state,props){return{customerId:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["g" /* selectCustomerId */](state),canSeeImages:Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["d" /* selectCanSeeImages */])(state),imageVersionList:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["c" /* selectOrderedImageVersionList */](state),showImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["f" /* selectShowImages */](state)};};var mapDispatchToProps={findImageVersion:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["b" /* findImageVersion */],uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["m" /* uploadCustomerImage */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["g" /* rotateCustomerImage */],toggleImageView:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["l" /* toggleImageView */],setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["i" /* setImageTypeMetaData */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__image_VersionedImageList__["a" /* default */]));

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imageUpload_ImageUpload__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var canSeeImages=function canSeeImages(state){if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */])){return false;}return Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["d" /* selectCanSeeImages */])(state);};var mapStateToProps=function mapStateToProps(state){return{customerId:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["g" /* selectCustomerId */](state),canSeeImages:canSeeImages(state),imageVersionList:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["c" /* selectOrderedImageVersionList */](state),showImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["f" /* selectShowImages */](state),uploadingImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["h" /* selectUploadingImages */](state),retryImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["d" /* selectRetryImages */](state)};};var mapDispatchToProps={findImageVersion:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["b" /* findImageVersion */],uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["m" /* uploadCustomerImage */],retryUploadFromLocalStorage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["e" /* retryUploadFromLocalStorage */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["g" /* rotateCustomerImage */],toggleImageView:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["l" /* toggleImageView */],setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["i" /* setImageTypeMetaData */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__imageUpload_ImageUpload__["a" /* default */]));

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imageUpload_ImageUpload__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var canSeeImages=function canSeeImages(state){if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["r" /* CUSTOMER_IMAGE_UPLOAD_WIDGET */])){return false;}return Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["d" /* selectCanSeeImages */])(state);};var mapStateToProps=function mapStateToProps(state){return{customerId:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["g" /* selectCustomerId */](state),canSeeImages:canSeeImages(state),imageVersionList:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["c" /* selectOrderedImageVersionList */](state),showImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["f" /* selectShowImages */](state),uploadingImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["h" /* selectUploadingImages */](state),retryImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["d" /* selectRetryImages */](state)};};var mapDispatchToProps={findImageVersion:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["d" /* findRecentImageVersion */],uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["f" /* reuploadCustomerImage */],retryUploadFromLocalStorage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["e" /* retryUploadFromLocalStorage */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["g" /* rotateCustomerImage */],toggleImageView:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["l" /* toggleImageView */],setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["i" /* setImageTypeMetaData */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__imageUpload_ImageUpload__["a" /* default */]));

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectCustomer */](state),fetching:__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_6__state_const__["i" /* FILE_TYPE_SCAN_FILE */]),fileType:__WEBPACK_IMPORTED_MODULE_6__state_const__["i" /* FILE_TYPE_SCAN_FILE */],widgetId:__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_3" /* SCAN_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskOverviewWidget__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treatment_state_plan_selector__ = __webpack_require__(33);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_8__treatment_state_plan_selector__["g" /* selectTreatmentPlan */](state),processInstance:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["j" /* selectProcessInstance */](state),processInstanceId:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["k" /* selectProcessInstanceId */](state),currentState:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["b" /* selectCurrentState */](state),role:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["l" /* selectRole */](state),isTaskAdmin:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["i" /* selectHasRole */])(state,__WEBPACK_IMPORTED_MODULE_6__security_state_auth_const__["L" /* ROLE_TASK_ADMIN */]),userId:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["q" /* selectUserId */])(state),assignedToUser:__WEBPACK_IMPORTED_MODULE_5__globals__["a" /* default */].selector.selectUserDisplayNameById(state,props.task.assignedToUserId),userWithRoleForTask:Object(__WEBPACK_IMPORTED_MODULE_7__globals_state_selector__["selectUserWithRoleList"])(state,props.task.role),availableTransitionList:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["a" /* selectAvailableTransitionList */](state),processFlowVisible:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["i" /* selectProcessFlowVisible */](state),isPartner:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["k" /* selectIsPartner */])(state),onyxId:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["g" /* selectOnyxId */](state),onyxServer:__WEBPACK_IMPORTED_MODULE_2__state_task_detail_selector__["h" /* selectOnyxServer */](state)};};var mapDispatchToProps={changeTaskDueDate:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["b" /* changeTaskDueDate */],changeTaskStatus:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["c" /* changeTaskStatus */],claimTask:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["d" /* claimTask */],unClaimTask:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["h" /* unClaimTask */],changeAssignedTo:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["a" /* changeAssignedTo */],updateAssignedToUserId:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_action__["i" /* updateAssignedToUserId */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__TaskOverviewWidget__["a" /* default */]));

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__form_component_DatePicker__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__security_component_auth_HasNotAuthorizationContainer__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TaskResponsible__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ProcessFlow__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ToggleProcessFlowButton__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TransitionList__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ChangeTaskResponsible__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__appointment_state_const__ = __webpack_require__(129);
var STATUS_LIST=[{id:'open',value:'open'},{id:'pending',value:'pending'},{id:'finished',value:'finished'}];var TaskOverviewWidget=function TaskOverviewWidget(_ref){var treatmentPlan=_ref.treatmentPlan,isPartner=_ref.isPartner,claimTask=_ref.claimTask,userWithRoleForTask=_ref.userWithRoleForTask,updateAssignedToUserId=_ref.updateAssignedToUserId,changeAssignedTo=_ref.changeAssignedTo,unClaimTask=_ref.unClaimTask,isTaskAdmin=_ref.isTaskAdmin,taskReadOnly=_ref.taskReadOnly,processFlowVisible=_ref.processFlowVisible,changeTaskDueDate=_ref.changeTaskDueDate,changeTaskStatus=_ref.changeTaskStatus,toggleProcessFlowVisibility=_ref.toggleProcessFlowVisibility,validateAndTriggerEvent=_ref.validateAndTriggerEvent,currentState=_ref.currentState,task=_ref.task,taskName=_ref.taskName,role=_ref.role,userId=_ref.userId,assignedToUser=_ref.assignedToUser,availableTransitionList=_ref.availableTransitionList,validationMessageList=_ref.validationMessageList,onyxId=_ref.onyxId,onyxServer=_ref.onyxServer;if(!Object(__WEBPACK_IMPORTED_MODULE_23__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_24__ui_definition_process_ui__["K" /* OVERVIEW */])){return null;}var title=isPartner?'Task '+Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["g" /* renderTaskName */])(taskName):'Task '+task.processDisplayName+' '+Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["g" /* renderTaskName */])(taskName)+' ';var complexity=treatmentPlan?'Complexity '+(treatmentPlan.complexity?treatmentPlan.complexity:''):'';var activeAppointment=getLatestAppointment(task.objectDetail.customer.appointmentList);var isAppointmentInfoVisible=__WEBPACK_IMPORTED_MODULE_25__appointment_state_const__["a" /* ALLOWED_TASKS_FOR_APPOINTMENT_INFO */].includes(taskName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__form_component_VipIcon__["a" /* default */],{onClick:function onClick(){},active:task.vip}),'\xA0',title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__layout_component_ContentBoxBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ToggleProcessFlowButton__["a" /* default */],{isPartner:isPartner,toggleProcessFlowVisibility:toggleProcessFlowVisibility,processFlowVisible:processFlowVisible}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TransitionList__["a" /* default */],{task:task,taskReadOnly:taskReadOnly,availableTransitionList:availableTransitionList,validateAndTriggerEvent:validateAndTriggerEvent}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ProcessFlow__["a" /* default */],{processFlowVisible:processFlowVisible,processInstanceId:task.processInstanceId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_13__security_state_auth_const__["L" /* ROLE_TASK_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__form_component_Select__["a" /* default */],{object:task,name:'status',valueList:STATUS_LIST,onChange:changeTaskStatus})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__security_component_auth_HasNotAuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_13__security_state_auth_const__["L" /* ROLE_TASK_ADMIN */]},task.status))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_13__security_state_auth_const__["l" /* ROLE_EMPLOYEE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Process'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* Link */],{to:'/process/instance/view/'+task.processInstanceId},Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["d" /* renderProcessName */])(task.processName))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["g" /* renderTaskName */])(taskName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["f" /* renderStateName */])(currentState.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Responsible'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,assignedToUser||Object(__WEBPACK_IMPORTED_MODULE_2__util_names__["e" /* renderRoleName */])(role),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TaskResponsible__["a" /* default */],{taskReadOnly:taskReadOnly,task:task,userId:userId,isTaskAdmin:isTaskAdmin,claimTask:claimTask,unClaimTask:unClaimTask}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ChangeTaskResponsible__["a" /* default */],{userWithRoleForTask:userWithRoleForTask,task:task,isTaskAdmin:isTaskAdmin,changeAssignedTo:changeAssignedTo,updateAssignedToUserId:updateAssignedToUserId,taskReadOnly:taskReadOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Customer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,task.customerReference)),isAppointmentInfoVisible&&activeAppointment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderAppointmentType,{activeAppointment:activeAppointment}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Priority'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,task.priority)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Task Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(task.created))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Task Due'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_13__security_state_auth_const__["L" /* ROLE_TASK_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__form_component_DatePicker__["a" /* default */],{object:task,name:'due',showTimeSelect:true,dateFormat:'DD.MM.YYYY HH:mm',placeholder:'Due Date',onChange:changeTaskDueDate,onBlur:function onBlur(){}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__security_component_auth_HasNotAuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_13__security_state_auth_const__["L" /* ROLE_TASK_ADMIN */]},Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(task.due)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Task Finished'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(task.finished))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Finished by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,task.finishedByUserName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Store'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_17__store_util_renderStoreName__["b" /* renderStoreName */])(task.store))),isAppointmentInfoVisible&&activeAppointment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderAppointmentReason,{activeAppointment:activeAppointment}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,complexity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'OnyxId'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,onyxId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'OnyxServer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,onyxServer))))))));};var getLatestAppointment=function getLatestAppointment(appointmentList){return appointmentList.slice(-1)[0];};var RenderAppointmentType=function RenderAppointmentType(_ref2){var activeAppointment=_ref2.activeAppointment;var mappedAppointmentType=__WEBPACK_IMPORTED_MODULE_25__appointment_state_const__["c" /* APPOINTMENT_TYPE_LIST */].find(function(appointment){return appointment.id===activeAppointment.appointmentType;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Appointment Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mappedAppointmentType?mappedAppointmentType.value:''));};var RenderAppointmentReason=function RenderAppointmentReason(_ref3){var activeAppointment=_ref3.activeAppointment;var mappedAppointmentReason=__WEBPACK_IMPORTED_MODULE_25__appointment_state_const__["b" /* APPOINTMENT_REASON_LIST */].find(function(appointment){return appointment.id===activeAppointment.appointmentReason;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Appointment Reason'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mappedAppointmentReason?mappedAppointmentReason.value:''));};TaskOverviewWidget.propTypes={treatmentPLan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isPartner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,validateAndTriggerEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,availableTransitionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,processFlowVisible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,toggleProcessFlowVisibility:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,role:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,changeAssignedTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,updateAssignedToUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userWithRoleForTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TaskOverviewWidget);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HasNotAuthorization__ = __webpack_require__(1481);
var mapStateToProps=function mapStateToProps(state,props){return{hasRole:__WEBPACK_IMPORTED_MODULE_1__state_auth_selector__["i" /* selectHasRole */](state,props.requiredRole)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__HasNotAuthorization__["a" /* default */]));

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var HasNotAuthorization=function HasNotAuthorization(_ref){var children=_ref.children,hasRole=_ref.hasRole;return hasRole?null:children;};HasNotAuthorization.propTypes={requiredRole:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array]),hasRole:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (HasNotAuthorization);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var TaskResponsible=function TaskResponsible(_ref){var taskReadOnly=_ref.taskReadOnly,userId=_ref.userId,claimTask=_ref.claimTask,unClaimTask=_ref.unClaimTask,task=_ref.task,isTaskAdmin=_ref.isTaskAdmin;if(taskReadOnly){return null;}if(!task.assignedToUserId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lock lock-icon',onClick:claimTask});}if(task.assignedToUserId===userId||!isTaskAdmin){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-unlock lock-icon',onClick:unClaimTask});}return null;};TaskResponsible.propTypes={taskReadOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isTaskAdmin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,claimTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,unClaimTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TaskResponsible);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_api__ = __webpack_require__(12);
var PROCESS_FLOW_URL=__WEBPACK_IMPORTED_MODULE_4__util_api__["a" /* BACKEND_URL */]+'/process/instance/view-flow?processInstanceId=';var FRAME_STYLE={border:0,width:'100%',height:'600px'};var ProcessFlow=function ProcessFlow(_ref){var processFlowVisible=_ref.processFlowVisible,processInstanceId=_ref.processInstanceId;if(!processFlowVisible){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{style:FRAME_STYLE,src:PROCESS_FLOW_URL+processInstanceId,title:'Process Flow'})));};ProcessFlow.propTypes={processFlowVisible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,processInstanceId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProcessFlow);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_ToggleButton__ = __webpack_require__(107);
var ToggleProcessFlowButton=function ToggleProcessFlowButton(_ref){var isPartner=_ref.isPartner,toggleProcessFlowVisibility=_ref.toggleProcessFlowVisibility,processFlowVisible=_ref.processFlowVisible;if(isPartner){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_ToggleButton__["a" /* default */],{toggle:toggleProcessFlowVisibility,active:processFlowVisible,activeIcon:'fa fa-search-minus',inactiveIcon:'fa fa-search-plus'}),'\xA0');};ToggleProcessFlowButton.propTypes={isPartner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,toggleProcessFlowVisibility:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,processFlowVisible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ToggleProcessFlowButton);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Select__ = __webpack_require__(16);
var ChangeTaskResponsible=function ChangeTaskResponsible(_ref){var changeAssignedTo=_ref.changeAssignedTo,taskReadOnly=_ref.taskReadOnly,task=_ref.task,updateAssignedToUserId=_ref.updateAssignedToUserId,userWithRoleForTask=_ref.userWithRoleForTask,isTaskAdmin=_ref.isTaskAdmin;// only task admin are allowed to change
// only show if the task is currently assigned to a user (as opposed to a role)
// tasks assigned to partners cannot be changed
// task can't be in status skipped or finished
if(!isTaskAdmin||!task.assignedToUserId||task.partner||task.status==='skipped'||task.status==='finished'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'New Responsible'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Select__["a" /* default */],{object:task,name:'assignedToUserId',onChange:function onChange(name,value){changeAssignedTo(name,value);updateAssignedToUserId();},valueList:userWithRoleForTask,renderer:function renderer(_ref2){var firstName=_ref2.firstName,lastName=_ref2.lastName;return firstName+' '+lastName;}})));};ChangeTaskResponsible.propTypes={changeAssignedTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,updateAssignedToUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userWithRoleForTask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,isTaskAdmin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,taskReadOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ChangeTaskResponsible);

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionListWidget__ = __webpack_require__(1487);
var mapStateToProps=function mapStateToProps(state){return{availableTransitionList:__WEBPACK_IMPORTED_MODULE_1__state_task_detail_selector__["a" /* selectAvailableTransitionList */](state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__TransitionListWidget__["a" /* default */]));

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionList__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_definition_process_ui__ = __webpack_require__(2);
var STYLE={padding:'15px',textAlign:'left'};var STYLE_VALIDATION={paddingTop:'15px'};var TransitionListWidget=function TransitionListWidget(_ref){var taskReadOnly=_ref.taskReadOnly,task=_ref.task,availableTransitionList=_ref.availableTransitionList,validateAndTriggerEvent=_ref.validateAndTriggerEvent,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__ui_definition_process_ui__["_9" /* TRANSITION_LIST_WIDGET_CONTAINER */])){return null;}if(taskReadOnly||task.status==='skipped'||task.status==='finished'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TransitionList__["a" /* default */],{taskReadOnly:taskReadOnly,task:task,availableTransitionList:availableTransitionList,validateAndTriggerEvent:validateAndTriggerEvent})),!!validationMessageList.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLE_VALIDATION},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))));};TransitionListWidget.propTypes={taskReadOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,task:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,availableTransitionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,validateAndTriggerEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TransitionListWidget);

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instance_detail_CommentList__ = __webpack_require__(192);
var mapStateToProps=function mapStateToProps(state,props){return{commentText:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["e" /* selectCommentText */](state),commentList:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["d" /* selectCommentList */](state)};};var mapDispatchToProps={changeProcessComment:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["c" /* changeProcessComment */],commentProcessInstance:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["f" /* commentProcessInstance */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__instance_detail_CommentList__["b" /* default */]));

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_detail_CreateIprAppointment__ = __webpack_require__(1490);
var mapStateToProps=function mapStateToProps(state){return{customer:__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */](state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__task_detail_CreateIprAppointment__["a" /* default */]));

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_process_ui__ = __webpack_require__(2);
var CreateIprAppointment=function CreateIprAppointment(_ref){var customer=_ref.customer;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ui_definition_process_ui__["o" /* CREATE_IPR_APPOINTMENT */])||!customer){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Create IPR Appointment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},customer.storeIprBookingUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:customer.storeIprBookingUrl,className:'btn btn-danger btn-sm',target:'_blank',rel:'noopener noreferrer'},'Create IPR Appointment\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))));};/* harmony default export */ __webpack_exports__["a"] = (CreateIprAppointment);

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_detail_Create3DScanAppointment__ = __webpack_require__(1492);
var mapStateToProps=function mapStateToProps(state){return{customer:__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */](state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__task_detail_Create3DScanAppointment__["a" /* default */]));

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_process_ui__ = __webpack_require__(2);
var Create3DScanAppointment=function Create3DScanAppointment(_ref){var customer=_ref.customer;if(!customer||!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ui_definition_process_ui__["n" /* CREATE_3DSCAN_APPOINTMENT */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Create 3D Scan Appointment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},customer.rescanBookingUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:customer.rescanBookingUrl,className:'btn btn-danger btn-sm',target:'_blank',rel:'noopener noreferrer'},'Create 3D-Scan Appointment\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-external-link'})))));};/* harmony default export */ __webpack_exports__["a"] = (Create3DScanAppointment);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance_detail_TechnicalLog__ = __webpack_require__(558);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__["k" /* selectProcessContext */](state),processLogList:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__["o" /* selectProcessLogList */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__instance_detail_TechnicalLog__["a" /* default */]));

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance_detail_StateTransitionLog__ = __webpack_require__(559);
var mapStateToProps=function mapStateToProps(state,props){return{processStateHistoryList:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_selector__["p" /* selectProcessStateHistoryList */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__instance_detail_StateTransitionLog__["a" /* default */]));

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SalesOrderProcessInfoTable__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detail_SalesOrderPriceTable__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__detail_SalesOrderPaymentDetails__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FreshSalesInfoTable__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__ = __webpack_require__(2);
/* this is used within the process */var SalesOrderOverviewWidget=function SalesOrderOverviewWidget(_ref){var salesOrder=_ref.salesOrder,dealOwner=_ref.dealOwner,calendlyLink=_ref.calendlyLink,showInitialProcess=_ref.showInitialProcess,hasPreviousRetainerRefinementProcess=_ref.hasPreviousRetainerRefinementProcess;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_process_ui__["_2" /* SALES_ORDER_OVERVIEW_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Overview '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SalesOrderProcessInfoTable__["a" /* default */],{salesOrder:salesOrder,showInitialProcess:showInitialProcess,hasPreviousRetainerRefinementProcess:hasPreviousRetainerRefinementProcess})),dealOwner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FreshSalesInfoTable__["a" /* default */],{dealOwner:dealOwner,calendlyLink:calendlyLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__detail_SalesOrderPaymentDetails__["a" /* default */],{salesOrder:salesOrder})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__detail_SalesOrderPriceTable__["a" /* default */],{salesOrder:salesOrder}))));};SalesOrderOverviewWidget.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,dealOwner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showInitialProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasPreviousRetainerRefinementProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderOverviewWidget);

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_component_CustomerLink__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_api__ = __webpack_require__(12);
var LABEL_URL=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/sales-order/view-set-label?salesOrderId=';var LABEL_REFINEMENT_URL=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/sales-order/view-refinement-set-label?salesOrderId=';var ALIGNER_LABEL_URL=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/production/render-aligner-label-pdf?salesOrderId=';var REPRODUCTION_ALIGNER_LABEL_URL=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/production/render-reproduction-aligner-label-pdf?salesOrderId=';var RETAINER_LABEL_URL=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/production/render-retainer-label-pdf?salesOrderId=';var SalesOrderProcessInfoTable=function SalesOrderProcessInfoTable(_ref){var salesOrder=_ref.salesOrder,showInitialProcess=_ref.showInitialProcess,hasPreviousRetainerRefinementProcess=_ref.hasPreviousRetainerRefinementProcess;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'sales-order-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Customer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__customer_component_CustomerLink__["a" /* default */],{customer:salesOrder.customer}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Sales Order'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/sales-order/edit/'+salesOrder.id},salesOrder.referenceNumber))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__util_datetime__["c" /* formatDateTime */])(salesOrder.created))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Reference Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,salesOrder.referenceNumber)),salesOrder.type==='set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Set Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:LABEL_URL+salesOrder.id,target:'_blank',rel:'noopener noreferrer'},'open'))),salesOrder.type==='refinement-set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Refinement Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:LABEL_REFINEMENT_URL+salesOrder.id,target:'_blank',rel:'noopener noreferrer'},'open'))),(salesOrder.type==='treatment'||salesOrder.type==='treatment-new'||salesOrder.type==='refinement-production')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Aligner Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:ALIGNER_LABEL_URL+salesOrder.id,target:'_blank',rel:'noopener noreferrer'},'open'))),salesOrder.type==='aligner-reproduction'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Aligner Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:REPRODUCTION_ALIGNER_LABEL_URL+salesOrder.id,target:'_blank',rel:'noopener noreferrer'},'open'))),(salesOrder.type==='retainer'||salesOrder.type==='retainer-new'||salesOrder.type==='retainer-refinement'||salesOrder.type==='retainer-refinement-new')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Retainer Label'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:RETAINER_LABEL_URL+salesOrder.id,target:'_blank',rel:'noopener noreferrer'},'open'))),showInitialProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Retainer model info'),(salesOrder.type==='retainer'||salesOrder.type==='retainer-new')&&hasPreviousRetainerRefinementProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Retainer refinement'),(salesOrder.type==='retainer'||salesOrder.type==='retainer-new')&&!hasPreviousRetainerRefinementProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Standart Retainer'),(salesOrder.type==='retainer-refinement'||salesOrder.type==='retainer-refinement-new')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Retainer refinement'))));};SalesOrderProcessInfoTable.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,showInitialProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasPreviousRetainerRefinementProcess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SalesOrderProcessInfoTable);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var LINK_STYLE={'padding-left':'8px'};var FreshSalesInfoTable=function FreshSalesInfoTable(_ref){var dealOwner=_ref.dealOwner,calendlyLink=_ref.calendlyLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fresh-sales-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'column'},'Freshsales Deal Owner'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'column'},dealOwner)),calendlyLink&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'column'},'Freshsales Calendly Link'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:calendlyLink,style:LINK_STYLE},'View')))));};FreshSalesInfoTable.propTypes={dealOwner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FreshSalesInfoTable);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detail_TraySize__ = __webpack_require__(514);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectCustomer */](state)};};var mapDispatchToProps={changeCustomer:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["c" /* changeCustomer */],saveCustomer:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["w" /* saveCustomer */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__detail_TraySize__["a" /* default */]));

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImprintScanStatusWidget__ = __webpack_require__(561);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["k" /* selectProcessContext */](state),salesOrder:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["f" /* selectSalesOrder */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__ImprintScanStatusWidget__["a" /* default */]));

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plan_TreatmentPlan__ = __webpack_require__(1501);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_2__state_plan_selector__["g" /* selectTreatmentPlan */](state)};};var mapDispatchToProps={changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["f" /* changeTreatmentPlan */],changeExistingCondition:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["b" /* changeExistingCondition */],changeInstruction:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["d" /* changeInstruction */],changeDoNotMove:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["a" /* changeDoNotMove */],changeLeaveSpaceOpen:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["e" /* changeLeaveSpaceOpen */],saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["g" /* saveTreatmentPlan */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__plan_TreatmentPlan__["a" /* default */]));

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExistingCondition__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdditionalInstruction__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InstructionList__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var TreatmentPlan=function TreatmentPlan(_ref){var treatmentPlan=_ref.treatmentPlan,readOnly=_ref.readOnly,changeTreatmentPlan=_ref.changeTreatmentPlan,changeInstruction=_ref.changeInstruction,changeExistingCondition=_ref.changeExistingCondition,changeDoNotMove=_ref.changeDoNotMove,changeLeaveSpaceOpen=_ref.changeLeaveSpaceOpen,saveTreatmentPlan=_ref.saveTreatmentPlan;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_18" /* TREATMENT_PLAN_WIDGET */])){return null;}if(!treatmentPlan){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ExistingCondition__["a" /* default */],{saveTreatmentPlan:saveTreatmentPlan,changeExistingCondition:changeExistingCondition,existingCondition:treatmentPlan.existingCondition,readOnly:readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InstructionList__["a" /* default */],{saveTreatmentPlan:saveTreatmentPlan,changeTreatmentPlan:changeTreatmentPlan,treatmentPlan:treatmentPlan,readOnly:readOnly,changeInstruction:changeInstruction}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AdditionalInstruction__["a" /* default */],{saveTreatmentPlan:saveTreatmentPlan,changeDoNotMove:changeDoNotMove,changeLeaveSpaceOpen:changeLeaveSpaceOpen,treatmentPlan:treatmentPlan,changeTreatmentPlan:changeTreatmentPlan,readOnly:readOnly}));};TreatmentPlan.propTypes={treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeExistingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeInstruction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeDoNotMove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeLeaveSpaceOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TreatmentPlan);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RelationShip__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Midline__ = __webpack_require__(1504);
var ExistingCondition=function ExistingCondition(_ref){var existingCondition=_ref.existingCondition,changeExistingCondition=_ref.changeExistingCondition,readOnly=_ref.readOnly,saveTreatmentPlan=_ref.saveTreatmentPlan;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'existing-condition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Existing Condition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Chief complaint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__["a" /* default */],{name:'chiefComplaint',object:existingCondition,readOnly:readOnly,onChange:changeExistingCondition,onBlur:saveTreatmentPlan})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Midline__["a" /* default */],{existingCondition:existingCondition,changeExistingCondition:changeExistingCondition,valuePrefix:'upper',readOnly:readOnly,saveTreatmentPlan:saveTreatmentPlan,title:'Upper midline'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Midline__["a" /* default */],{existingCondition:existingCondition,changeExistingCondition:changeExistingCondition,valuePrefix:'lower',readOnly:readOnly,saveTreatmentPlan:saveTreatmentPlan,title:'Lower midline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RelationShip__["a" /* default */],{title:'Canine relationship',changeExistingCondition:changeExistingCondition,existingCondition:existingCondition,leftValue:'canineRelationshipLeft',rightValue:'canineRelationshipRight',saveTreatmentPlan:saveTreatmentPlan,readOnly:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RelationShip__["a" /* default */],{title:'Molar relationship',changeExistingCondition:changeExistingCondition,existingCondition:existingCondition,leftValue:'molarRelationshipLeft',rightValue:'molarRelationshipRight',saveTreatmentPlan:saveTreatmentPlan,readOnly:readOnly})))));};ExistingCondition.propTypes={existingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeExistingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ExistingCondition);

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Select__ = __webpack_require__(16);
var RELATION_SHIP=[{id:'I',value:'I'},{id:'II',value:'II'},{id:'III',value:'III'}];var RelationShip=function RelationShip(_ref){var existingCondition=_ref.existingCondition,title=_ref.title,changeExistingCondition=_ref.changeExistingCondition,leftValue=_ref.leftValue,rightValue=_ref.rightValue,readOnly=_ref.readOnly,saveTreatmentPlan=_ref.saveTreatmentPlan;var onChange=function onChange(name,value){changeExistingCondition(name,value);saveTreatmentPlan();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relation-ship-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relation-ship-text'},'right class'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relation-ship-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Select__["a" /* default */],{object:existingCondition,name:rightValue,onChange:onChange,readOnly:readOnly,valueList:RELATION_SHIP}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relation-ship-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relation-ship-text'},'left class'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relation-ship-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Select__["a" /* default */],{object:existingCondition,name:leftValue,onChange:onChange,readOnly:readOnly,valueList:RELATION_SHIP}))));};RelationShip.propTypes={existingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,changeExistingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,leftValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,rightValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RelationShip);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Radio__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Input__ = __webpack_require__(36);
var Midline=function Midline(_ref){var existingCondition=_ref.existingCondition,changeExistingCondition=_ref.changeExistingCondition,valuePrefix=_ref.valuePrefix,title=_ref.title,readOnly=_ref.readOnly,saveTreatmentPlan=_ref.saveTreatmentPlan;var onChange=function onChange(name,value){changeExistingCondition(name,value);saveTreatmentPlan();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line-radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Radio__["a" /* default */],{name:valuePrefix+'MidlineValue',value:'centered',object:existingCondition,onChange:onChange,readOnly:readOnly},'\xA0centered'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line-radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Radio__["a" /* default */],{name:valuePrefix+'MidlineValue',value:'shifted_right',object:existingCondition,onChange:onChange,readOnly:readOnly},'\xA0shifted right')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Input__["a" /* default */],{type:'number',name:valuePrefix+'MidlineShiftedRight',object:existingCondition,placeholder:'mm',readOnly:readOnly,onChange:changeExistingCondition,onBlur:saveTreatmentPlan}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line-radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Radio__["a" /* default */],{name:valuePrefix+'MidlineValue',value:'shifted_left',object:existingCondition,onChange:onChange,readOnly:readOnly},'\xA0shifted left')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mid-line-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Input__["a" /* default */],{type:'number',name:valuePrefix+'MidlineShiftedLeft',object:existingCondition,placeholder:'mm',readOnly:readOnly,onChange:changeExistingCondition,onBlur:saveTreatmentPlan}))));};Midline.propTypes={existingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeExistingCondition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,valuePrefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Midline);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TeethSelect__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_TextArea__ = __webpack_require__(63);
var AdditionalInstructions=function AdditionalInstructions(_ref){var saveTreatmentPlan=_ref.saveTreatmentPlan,treatmentPlan=_ref.treatmentPlan,readOnly=_ref.readOnly,changeTreatmentPlan=_ref.changeTreatmentPlan,changeDoNotMove=_ref.changeDoNotMove,changeLeaveSpaceOpen=_ref.changeLeaveSpaceOpen;var doNotMove=treatmentPlan.doNotMove,leaveSpacesOpen=treatmentPlan.leaveSpacesOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'additional-instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Additional Instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Do not move these teeth'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TeethSelect__["a" /* default */],{isDoNotMove:true,teeth:doNotMove,readOnly:readOnly,onChange:changeDoNotMove,save:saveTreatmentPlan}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Leave these spaces open'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TeethSelect__["a" /* default */],{isDoNotMove:false,teeth:leaveSpacesOpen,readOnly:readOnly,onChange:changeLeaveSpaceOpen,save:saveTreatmentPlan}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Additional Instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_TextArea__["a" /* default */],{name:'additionalInstructions',object:treatmentPlan,readOnly:readOnly,onBlur:saveTreatmentPlan,onChange:changeTreatmentPlan}))))));};AdditionalInstructions.propTypes={treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeDoNotMove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeLeaveSpaceOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AdditionalInstructions);

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_plan_const__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_selector__ = __webpack_require__(9);
var TeethCell=function TeethCell(_ref){var teeth=_ref.teeth,position=_ref.position,readOnly=_ref.readOnly,_onChange=_ref.onChange,save=_ref.save,_ref$checked=_ref.checked,checked=_ref$checked===undefined?false:_ref$checked;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'teeth-cell-'+position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:teeth[position]||checked,readOnly:readOnly,disabled:readOnly,onChange:function onChange(event){if(readOnly){return;}_onChange(position,event.currentTarget.checked);save();}}));};TeethCell.propTypes={teeth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,position:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var TeethSelect=function TeethSelect(_ref2){var teeth=_ref2.teeth,readOnly=_ref2.readOnly,onChange=_ref2.onChange,save=_ref2.save,isDoNotMove=_ref2.isDoNotMove;var state=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();var processInstance=Object(__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_selector__["m" /* selectProcessInstance */])(state);var isSetProcess=processInstance&&processInstance.processName==='salesorder-set';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'teeth-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["n" /* UPPER_TEETH */].map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:position,className:'teeth-cell-'+position},position);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["n" /* UPPER_TEETH */].map(function(position){var additionalSetReadOnly=isSetProcess&&isDoNotMove&&(position==='14'||position==='15'||position==='24'||position==='25');var _readonly=readOnly||additionalSetReadOnly||position==='16'||position==='17'||position==='18'||position==='26'||position==='27'||position==='28';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethCell,{key:position,teeth:teeth,position:position,onChange:onChange,save:save,readOnly:_readonly,checked:additionalSetReadOnly});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'separator'},__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["i" /* LOWER_TEETH */].map(function(position){var additionalSetReadOnly=isSetProcess&&isDoNotMove&&(position==='44'||position==='45'||position==='34'||position==='35');var _readonly=readOnly||additionalSetReadOnly||position==='46'||position==='47'||position==='48'||position==='36'||position==='37'||position==='38';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeethCell,{key:position,teeth:teeth,position:position,onChange:onChange,save:save,readOnly:_readonly,checked:additionalSetReadOnly});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2__state_plan_const__["i" /* LOWER_TEETH */].map(function(position){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:position,className:'teeth-cell-'+position},position);}))));};TeethSelect.propTypes={teeth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,save:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isDoNotMove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TeethSelect);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Radio__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_state_instance_detail_selector__ = __webpack_require__(9);
var Instruction=function Instruction(_ref){var title=_ref.title,changeInstruction=_ref.changeInstruction,instructionList=_ref.instructionList,name=_ref.name,valueList=_ref.valueList,readOnly=_ref.readOnly,labelList=_ref.labelList,saveTreatmentPlan=_ref.saveTreatmentPlan;var onChange=function onChange(name,value){changeInstruction(name,value);saveTreatmentPlan();};var state=__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getState();var processInstance=Object(__WEBPACK_IMPORTED_MODULE_7__process_state_instance_detail_selector__["m" /* selectProcessInstance */])(state);var _readOnly=readOnly||processInstance.processName==='salesorder-set'&&name==='ipr';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:3},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Radio__["a" /* default */],{onChange:onChange,value:valueList[0],name:name,readOnly:_readOnly,object:instructionList},'\xA0',labelList[0])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Radio__["a" /* default */],{onChange:onChange,name:name,readOnly:_readOnly,value:valueList[1],object:instructionList},'\xA0',labelList[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Radio__["a" /* default */],{onChange:onChange,name:name,readOnly:_readOnly,value:valueList[2],object:instructionList},'\xA0',labelList[2])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:2}));};var MAINTAIN_LIST=['maintain','improve','idealize'];var YES_NO_LIST=['yes','no','only_if_needed'];var YES_NO_LABEL_LIST=['yes','no','only if needed'];var INSTRUCTION_FIELD_LIST=[{title:'Upper midline',name:'upperMidline',valueList:MAINTAIN_LIST,labelList:MAINTAIN_LIST},{title:'Lower midline',name:'lowerMidline',valueList:MAINTAIN_LIST,labelList:MAINTAIN_LIST},{title:'Overjet',name:'overjet',valueList:MAINTAIN_LIST,labelList:MAINTAIN_LIST},{title:'Overbite',name:'overbite',valueList:MAINTAIN_LIST,labelList:MAINTAIN_LIST},{title:'Arch form',name:'archForm',valueList:MAINTAIN_LIST,labelList:MAINTAIN_LIST},{title:'Canine relationship',name:'canineRelationship',valueList:MAINTAIN_LIST,labelList:MAINTAIN_LIST},{title:'Procline',name:'procline',valueList:YES_NO_LIST,labelList:YES_NO_LABEL_LIST},{title:'Expand',name:'expand',valueList:YES_NO_LIST,labelList:YES_NO_LABEL_LIST},{title:'Distalize',name:'distalize',valueList:YES_NO_LIST,labelList:YES_NO_LABEL_LIST},{title:'IPR',name:'ipr',valueList:YES_NO_LIST,labelList:YES_NO_LABEL_LIST}];var InstructionList=function InstructionList(_ref2){var treatmentPlan=_ref2.treatmentPlan,changeTreatmentPlan=_ref2.changeTreatmentPlan,readOnly=_ref2.readOnly,changeInstruction=_ref2.changeInstruction,saveTreatmentPlan=_ref2.saveTreatmentPlan;var instructionList=treatmentPlan.instructionList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Instructions'},INSTRUCTION_FIELD_LIST.map(function(instruction){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Instruction,Object.assign({changeInstruction:changeInstruction,instructionList:instructionList},instruction,{readOnly:readOnly,key:instruction.name,saveTreatmentPlan:saveTreatmentPlan}));})));};InstructionList.propTypes={treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeInstruction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InstructionList);

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__ = __webpack_require__(2);
var TreatmentPaymentWidget=function TreatmentPaymentWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList,salesOrder=_ref.salesOrder;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__["_15" /* TREATMENT_PAYMENT_WIDGET */])){return null;}if(salesOrder.type!=='treatment'&&salesOrder.type!=='treatment-new'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Treatment Payments'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Checkbox__["a" /* default */],{object:context,name:'physicianPaymentReceived',readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Physician Payment Received'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Checkbox__["a" /* default */],{object:context,name:'sunshinePaymentReceived',readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}},'Sunshine Payment Received'))));};TreatmentPaymentWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TreatmentPaymentWidget);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeliveryTrackingNumberWidget__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logistic_state_list_action_js__ = __webpack_require__(309);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */],getProviderUrl:__WEBPACK_IMPORTED_MODULE_4__logistic_state_list_action_js__["b" /* getProviderUrl */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__DeliveryTrackingNumberWidget__["a" /* default */]));

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__ = __webpack_require__(1511);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var DeliveryTrackingNumber=function DeliveryTrackingNumber(_ref){var showAlignerNumberCounted=_ref.showAlignerNumberCounted,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList,getProviderUrl=_ref.getProviderUrl;if(!Object(__WEBPACK_IMPORTED_MODULE_11__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__process_ui_definition_process_ui__["x" /* DELIVERY_TRACKING_WIDGET */])){return null;}var onShipmentProviderChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(key,shipmentProvider){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return setShipmentProvider(shipmentProvider);case 2:setTrackingUrl();saveProcessContext();case 4:case'end':return _context.stop();}}},_callee,_this);}));return function onShipmentProviderChange(_x,_x2){return _ref2.apply(this,arguments);};}();var onTrackingNumberChange=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(context.shipmentProviderUrl){_context2.next=3;break;}_context2.next=3;return setShipmentProvider(__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["a" /* DEFAULT_SHIPMENT_PROVIDER */]);case 3:setTrackingUrl();saveProcessContext();case 5:case'end':return _context2.stop();}}},_callee2,_this);}));return function onTrackingNumberChange(){return _ref3.apply(this,arguments);};}();var setShipmentProvider=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(shipmentProvider){var provider,providerUrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:changeProcessContext(__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["b" /* SHIPMENT_PROVIDER_CONTEXT_KEY */],shipmentProvider);provider=__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["c" /* SHIPMENT_PROVIDER_LIST */].find(function(el){return el.id===shipmentProvider;});_context3.next=4;return getProviderUrl(provider.key);case 4:providerUrl=_context3.sent;changeProcessContext(__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["d" /* SHIPMENT_PROVIDER_URL_CONTEXT_KEY */],providerUrl);context.shipmentProviderUrl=providerUrl;case 7:case'end':return _context3.stop();}}},_callee3,_this);}));return function setShipmentProvider(_x3){return _ref4.apply(this,arguments);};}();var setTrackingUrl=function setTrackingUrl(){var trackingUrl=context.shipmentProviderUrl.replace('%tracking_number%',context.trackingNumber);changeProcessContext(__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["f" /* TRACKING_URL_CONTEXT_KEY */],trackingUrl);saveProcessContext();};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Shipping Tracking Number'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__["a" /* default */],{label:'Tracking Number'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Input__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["e" /* TRACKING_NUMBER_CONTEXT_KEY */],object:context,onChange:changeProcessContext,onBlur:onTrackingNumberChange}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__["a" /* default */],{label:'Shipment Provider'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{name:__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["b" /* SHIPMENT_PROVIDER_CONTEXT_KEY */],object:context,defaultValue:__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["a" /* DEFAULT_SHIPMENT_PROVIDER */],valueList:__WEBPACK_IMPORTED_MODULE_13__logistic_util_ShipmentProviderUtil__["c" /* SHIPMENT_PROVIDER_LIST */],onChange:onShipmentProviderChange}))),showAlignerNumberCounted&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_Checkbox__["a" /* default */],{onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();},object:context,name:'alignerNumberCounted'},'Aligner counted'))));};DeliveryTrackingNumber.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DeliveryTrackingNumber);

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SHIPMENT_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHIPMENT_PROVIDER_URL_CONTEXT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHIPMENT_PROVIDER_CONTEXT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRACKING_URL_CONTEXT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRACKING_NUMBER_CONTEXT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHIPMENT_PROVIDER_LIST; });
var DEFAULT_SHIPMENT_PROVIDER="DHL";var SHIPMENT_PROVIDER_URL_CONTEXT_KEY="shipmentProviderUrl";var SHIPMENT_PROVIDER_CONTEXT_KEY="shipmentProvider";var TRACKING_URL_CONTEXT_KEY="trackingUrl";var TRACKING_NUMBER_CONTEXT_KEY="trackingNumber";var SHIPMENT_PROVIDER_LIST=[{id:"DHL",value:"DHL",key:"dhl"},{id:"DHL Express",value:"DHL Express",key:"dhl_express"},{id:"Swiss Post",value:"Swiss Post",key:"swiss_post"},{id:"Fedex",value:"Fedex",key:"fedex"}];

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RefundSepaTransferWidget__ = __webpack_require__(1513);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RefundSepaTransferWidget__["a" /* default */]));

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var DOWNLOAD_SEPA_TRANSFER=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/sepa/download-sepa-transfer-xml?sepaTransferId=';var RefundSepaTransferWidget=function RefundSepaTransferWidget(_ref){var context=_ref.context;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["Y" /* REFUND_SEPA_TRANSFER_WIDGET */])){return null;}if(!context.sepaTransferId){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Refund with Sepa Transfer File'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:DOWNLOAD_SEPA_TRANSFER+context.sepaTransferId},'Download SEPA File'))));};RefundSepaTransferWidget.propTypes={context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RefundSepaTransferWidget);

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["b" /* selectOwnState */](state),{fileType:__WEBPACK_IMPORTED_MODULE_6__state_const__["h" /* FILE_TYPE_PRODUCTION */],customer:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectCustomer */](state),fetching:__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_6__state_const__["h" /* FILE_TYPE_PRODUCTION */]),widgetId:__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["W" /* PRODUCTION_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectCustomer */](state),fileType:__WEBPACK_IMPORTED_MODULE_6__state_const__["j" /* FILE_TYPE_TREATMENT_PLAN */],fetching:__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_6__state_const__["j" /* FILE_TYPE_TREATMENT_PLAN */]),visualizationRequested:__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["c" /* selectVisualizationRequested */](state),widgetId:__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_17" /* TREATMENT_PLAN_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["r" /* onFileDeleteFlagSuccess */],triggerVisualization:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["b" /* triggerVisualization */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupplierTrackingNumberWidget__ = __webpack_require__(1517);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SupplierTrackingNumberWidget__["a" /* default */]));

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
var SupplierTrackingNumber=function SupplierTrackingNumber(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["_7" /* SUPPLIER_TRACKING_NUMBER_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Supplier Tracking Number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'TrackingNumber'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{name:'supplierTrackingNumber',object:context,onChange:changeProcessContext,onBlur:saveProcessContext}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};SupplierTrackingNumber.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SupplierTrackingNumber);

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan_AlignerLabel__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state,props){var salesOrder=Object(__WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__["f" /* selectSalesOrder */])(state);return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["g" /* selectTreatmentPlan */](state),alignerLabelList:__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["a" /* selectAlignerLabelList */](state,salesOrder),salesOrder:salesOrder};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__plan_AlignerLabel__["a" /* default */]));

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_copy_to_clipboard__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__ = __webpack_require__(2);
var AlignerLabelInput=function AlignerLabelInput(_ref){var text=_ref.text;if(!text){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{readOnly:true,className:'form-control',value:text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3__util_copy_to_clipboard__["a" /* copyToClipboard */])(text);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-copy'}))));};var AlignerLabel=function AlignerLabel(_ref2){var salesOrder=_ref2.salesOrder,alignerLabelList=_ref2.alignerLabelList,readOnly=_ref2.readOnly;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__["b" /* ALIGNER_LABEL_WIDGET_CONTAINER */])){return null;}var referenceNumberPartList=salesOrder.referenceNumber.split('-');var renderAlignerLabel=function renderAlignerLabel(label){return label?referenceNumberPartList[2]+label:'';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Aligner Label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Upper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Lower'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,alignerLabelList.map(function(label,index){var upperText=renderAlignerLabel(label.upper);var lowerText=renderAlignerLabel(label.lower);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AlignerLabelInput,{text:upperText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AlignerLabelInput,{text:lowerText})));}))));};AlignerLabel.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AlignerLabel);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CannotBeTreatedReasonWidget__ = __webpack_require__(569);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state),taskName:props.taskName};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__CannotBeTreatedReasonWidget__["a" /* default */]));

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WhatsAppTextWidget__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */](state),context:__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__WhatsAppTextWidget__["a" /* default */]));

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internationalization_phone_util__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_copy_to_clipboard__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_localized_text_with_replacements__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_localized_urls__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__ = __webpack_require__(2);
var TEXTS={treatmentQuotationCreated:Object(__WEBPACK_IMPORTED_MODULE_7__util_localized_text_with_replacements__["a" /* default */])({DE:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["b" /* TREATMENT_QUOTATION_CREATED_DE */],GB:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["c" /* TREATMENT_QUOTATION_CREATED_GB */],CH:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["a" /* TREATMENT_QUOTATION_CREATED_CH */]}),treatmentQuotationReminder1:Object(__WEBPACK_IMPORTED_MODULE_7__util_localized_text_with_replacements__["a" /* default */])({DE:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["g" /* TREATMENT_QUOTATION_REMINDER_DE */],GB:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["h" /* TREATMENT_QUOTATION_REMINDER_GB */]}),treatmentQuotationReminder2:Object(__WEBPACK_IMPORTED_MODULE_7__util_localized_text_with_replacements__["a" /* default */])({DE:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["e" /* TREATMENT_QUOTATION_REMINDER2_DE */],GB:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["f" /* TREATMENT_QUOTATION_REMINDER2_GB */],CH:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["d" /* TREATMENT_QUOTATION_REMINDER2_CH */]}),treatmentQuotationReminder2Voucher:Object(__WEBPACK_IMPORTED_MODULE_7__util_localized_text_with_replacements__["a" /* default */])({DE:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["j" /* TREATMENT_QUOTATION_REMINDER_VOUCHER_DE */],GB:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["k" /* TREATMENT_QUOTATION_REMINDER_VOUCHER_GB */],CH:__WEBPACK_IMPORTED_MODULE_9__resources_whatsAppMacros__["i" /* TREATMENT_QUOTATION_REMINDER_VOUCHER_CH */]})};var createWhatsAppUrl=function createWhatsAppUrl(text,phone,countryCode){var transformedNumber=Object(__WEBPACK_IMPORTED_MODULE_5__internationalization_phone_util__["a" /* transformPhoneNumber */])(phone,countryCode);var transformedText=encodeURIComponent(text);return'https://wa.me/'+transformedNumber+'?text='+transformedText;};var getText=function getText(_ref){var textId=_ref.textId,customer=_ref.customer,context=_ref.context;var textTemplate=TEXTS[textId];return textTemplate(customer.countryCode,{firstName:customer.firstName,lastName:customer.lastName,salutation:customer.gender,websiteUrl:Object(__WEBPACK_IMPORTED_MODULE_8__util_localized_urls__["b" /* getTreatmentCheckoutForCountryCode */])(customer.countryCode),emailAddress:Object(__WEBPACK_IMPORTED_MODULE_8__util_localized_urls__["a" /* getEmailForCountryCode */])(customer.countryCode),voucherCode:context.voucherCode});};var WhatsAppMacroContainer=function WhatsAppMacroContainer(_ref2){var label=_ref2.label,whatsAppUrl=_ref2.whatsAppUrl,text=_ref2.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'whatsapp-message'},label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{display:'block'},className:'control-label'},'With voucher'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:whatsAppUrl,target:'_blank',rel:'noopener noreferrer'},'Quick Link'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{readOnly:true,className:'form-control text-area-default form-control whatsapp-message-textarea',value:text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_6__util_copy_to_clipboard__["a" /* copyToClipboard */])(text);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-copy'})))))));};var WhatsAppTextWidget=function WhatsAppTextWidget(_ref3){var readOnly=_ref3.readOnly,customer=_ref3.customer,textId=_ref3.textId,_ref3$context=_ref3.context,context=_ref3$context===undefined?{}:_ref3$context;if(!Object(__WEBPACK_IMPORTED_MODULE_10__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__["_23" /* WHATS_APP_TEXT_WIDGET_CONTAINER */])){return null;}var text=getText({textId:textId,customer:customer,context:context});var whatsAppUrl=createWhatsAppUrl(text,customer.phone,customer.countryCode);var voucherText=null;var whatsAppVoucherUrl=null;if(textId==='treatmentQuotationReminder2'){voucherText=getText({textId:'treatmentQuotationReminder2Voucher',customer:customer,context:context});whatsAppVoucherUrl=createWhatsAppUrl(voucherText,customer.phone,customer.countryCode);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'WhatsApp Text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhatsAppMacroContainer,{label:'',text:text,whatsAppUrl:whatsAppUrl}),voucherText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhatsAppMacroContainer,{label:'With voucher',text:voucherText,whatsAppUrl:whatsAppVoucherUrl}));};WhatsAppTextWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,textId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (WhatsAppTextWidget);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPhonePrefixForCountryCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transformPhoneNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(31);
var getPhonePrefixForCountryCode=function getPhonePrefixForCountryCode(countryCode){switch(countryCode){case __WEBPACK_IMPORTED_MODULE_0__const__["d" /* COUNTRY_CODE */].AT:return'43';case __WEBPACK_IMPORTED_MODULE_0__const__["d" /* COUNTRY_CODE */].CH:return'41';case __WEBPACK_IMPORTED_MODULE_0__const__["d" /* COUNTRY_CODE */].DE:return'49';case __WEBPACK_IMPORTED_MODULE_0__const__["d" /* COUNTRY_CODE */].ES:return'34';case __WEBPACK_IMPORTED_MODULE_0__const__["d" /* COUNTRY_CODE */].GB:return'44';default:return'49';}};var transformPhoneNumber=function transformPhoneNumber(phone,countryCode){if(!phone){return null;}var startsWithPlus=phone.startsWith('+');var startsWithDoubleZero=phone.startsWith('00');var transformedNumber=phone.replace(/[^0-9]/g,'');transformedNumber=transformedNumber.replace(/\s/g,'');if(startsWithPlus){return transformedNumber;}if(startsWithDoubleZero){return transformedNumber.substring(2);}return getPhonePrefixForCountryCode(countryCode)+transformedNumber.substring(1);};

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEmailForCountryCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTreatmentCheckoutForCountryCode; });
var getEmailForCountryCode=function getEmailForCountryCode(){var countryCode=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'DE';switch(countryCode.toUpperCase()){case'DE':return'info@plusdental.de';case'AT':return'info@plusdental.at';case'CH':return'info@plusdental.ch';case'GB':return'info@plusdent.co.uk';default:return'info@plusdental.de';}};var getTreatmentCheckoutForCountryCode=function getTreatmentCheckoutForCountryCode(){var countryCode=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'DE';switch(countryCode.toUpperCase()){case'DE':return'https://www.plusdental.de/account/checkout-treatment';case'AT':return'https://www.plusdental.at/account/checkout-treatment';case'CH':return'https://www.plusdental.ch/account/checkout-treatment';case'GB':return'https://www.plusdent.co.uk/account/checkout-treatment';default:return'https://www.plusdental.de/account/checkout-treatment';}};

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TREATMENT_QUOTATION_CREATED_DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TREATMENT_QUOTATION_CREATED_GB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TREATMENT_QUOTATION_CREATED_CH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TREATMENT_QUOTATION_REMINDER_DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TREATMENT_QUOTATION_REMINDER_GB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TREATMENT_QUOTATION_REMINDER2_DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TREATMENT_QUOTATION_REMINDER2_CH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TREATMENT_QUOTATION_REMINDER2_GB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TREATMENT_QUOTATION_REMINDER_VOUCHER_DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TREATMENT_QUOTATION_REMINDER_VOUCHER_CH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TREATMENT_QUOTATION_REMINDER_VOUCHER_GB; });
var TREATMENT_QUOTATION_CREATED_DE="\nHallo $salutation $lastName,\n\nIhr individueller Behandlungsplan ist fertig. Dieser wurde f\xFCr Sie in ihrem pers\xF6nlichen Account auf unserer Website $websiteUrl hinterlegt und per E-Mail an Sie gesendet.\nDer Behandlungsplan enth\xE4lt eine 3D-Simulation, die Ihnen zeigt, wie Ihre Z\xE4hne am Ende der Behandlung aussehen werden. Sollten Sie Fragen dazu haben, antworten Sie gerne auf diese Whatsapp oder rufen uns unter +49 (0) 30 255 585 825 an.\n\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_CREATED_GB="\nHello $salutation $lastName,\n\nYour individual treatment plan is ready. This is available for you to see in your account at our website $websiteUrl and we have also sent it to you by e-mail.\n\nThe treatment plan includes a 3D simulation that shows you how your teeth will look at the end of the treatment. If you have any questions, please feel free to contact our customer service. Via e-mail: $emailAddress or via phone +44 20 3499 8279 (Mon-Fri 8am-7pm, Sat 9am-5pm).\n\nBest regards\nYour PlusDent Team\n";var TREATMENT_QUOTATION_CREATED_CH="\nHallo $salutation $lastName,\n\neventuell hatten Sie die Gelegenheit Ihren Behandlungsplan einzusehen und sind von dem geplanten Behandlungsergebnis begeistert?\n\nDann m\xF6chten wir Ihnen gerne einen Gutschein-Code zur Verf\xFCgung stellen, mit dem Sie bei der Bestellung der Zahnschienen 300CHF sparen. Geben Sie hierf\xFCr einfach den Gutschein-Code undefined bei der Bestellung der Zahnschienen ein.\n\nIhren individuellen Behandlungsplan finden Sie in Ihrem pers\xF6nlichen Account auf unserer Website https://www.plusdental.ch/account/checkout-treatment\n\nLassen Sie uns gerne wissen, wenn Sie noch Fragen zu Ihrer Behandlung haben. Sie erreichen uns telefonisch unter +41 44 505 12 36 oder per E-Mail an info@plusdental.ch\n\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_REMINDER_DE="\nHallo $salutation $lastName,\n\nvor einiger Zeit haben Sie Ihren individuellen Behandlungsplan per E-Mail erhalten. Sollten Sie diesen mit unseren Experten besprechen wollen, k\xF6nnen Sie einen kostenlosen Termin f\xFCr ein Telefongespr\xE4ch vereinbaren, um alle offenen Fragen zu beantworten. Zur Terminvereinbarung: https://calendly.com/medical-team-plusdental/30min. \n\nIhren Behandlungsplan finden Sie auch in Ihrem pers\xF6nlichen Account auf unserer Website $websiteUrl/account/checkout-treatment\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_REMINDER_GB="\nHello $salutation $lastName,\n\nA short while ago, you received your individual treatment plan by e-mail. Should you wish to discuss this with our experts, you can arrange a free appointment for a telephone conversation to discuss details with us (+44 20 3499 8279 Mon-Fri 8am-7pm, Sat 9am-5pm).\n\nYour treatment plan can also be found in your account on our website $websiteUrl\n\nBest regards\nYour PlusDent Team\n";var TREATMENT_QUOTATION_REMINDER2_DE="\nHallo $salutation $lastName,\n\ngerne m\xF6chten wir Sie noch einmal an Ihren individuellen Behandlungsplan erinnern, den wir Ihnen per E-Mail zugeschickt haben. Diesen finden Sie auch in Ihrem pers\xF6nlichen Account auf $websiteUrl. Dort sehen Sie, anhand einer 3D-Simulation, wie sich Ihre Z\xE4hne in die gew\xFCnschte Position verschieben werden.\n\nSollten Sie weitere Informationen ben\xF6tigen oder Fragen zu Ihrer Behandlung haben, lassen Sie es uns gerne wissen. Sie erreichen uns unter +49 (0) 30 255 585 825 oder per E-Mail an $emailAddress\n\n\n\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_REMINDER2_CH="\nHallo $salutation $lastName,\n\ngerne m\xF6chten wir Sie noch einmal an Ihren individuellen Behandlungsplan erinnern, den wir Ihnen per E-Mail zugeschickt haben. Diesen finden Sie auch in Ihrem pers\xF6nlichen Account auf $websiteUrl. Dort sehen Sie, anhand einer 3D-Simulation, wie sich Ihre Z\xE4hne in die gew\xFCnschte Position verschieben werden.\n\nSollten Sie weitere Informationen ben\xF6tigen oder Fragen zu Ihrer Behandlung haben, lassen Sie es uns gerne wissen. Sie erreichen uns unter +41 44 505 12 36 oder per E-Mail an $emailAddress\n\n\n\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_REMINDER2_GB="\nHello $salutation $lastName,\n\nWe would like to remind you about your individual treatment plan that we have sent to you by email. You can find it in your account on $websiteUrl. There you see how your teeth will shift to the desired position using a 3D simulation.\n\nIf you have any questions, please feel free to contact our customer service. Via e-mail: $emailAddress or via phone +44 20 3499 8279 (Mon-Fri 8am-7pm, Sat 9am-5pm).\n\nBest regards\nYour PlusDent-Team\n";var TREATMENT_QUOTATION_REMINDER_VOUCHER_DE="\nHallo $salutation $lastName,\n\neventuell hatten Sie die Gelegenheit Ihren Behandlungsplan einzusehen und sind von dem geplanten Behandlungsergebnis begeistert?\n\nDann m\xF6chten wir Ihnen gerne einen Gutschein-Code zur Verf\xFCgung stellen, mit dem Sie bei der Bestellung der Zahnschienen 300\u20AC sparen. Geben Sie hierf\xFCr einfach den Gutschein-Code $voucherCode bei der Bestellung der Zahnschienen ein.\n\nIhren individuellen Behandlungsplan finden Sie in Ihrem pers\xF6nlichen Account auf unserer Website $websiteUrl\n\nLassen Sie uns gerne wissen, wenn Sie noch Fragen zu Ihrer Behandlung haben. Sie erreichen uns telefonisch unter +49 (0) 30 255 585 825 oder per E-Mail an $emailAddress\n\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_REMINDER_VOUCHER_CH="\nHallo $salutation $lastName,\n\neventuell hatten Sie die Gelegenheit Ihren Behandlungsplan einzusehen und sind von dem geplanten Behandlungsergebnis begeistert?\n\nDann m\xF6chten wir Ihnen gerne einen Gutschein-Code zur Verf\xFCgung stellen, mit dem Sie bei der Bestellung der Zahnschienen 300\u20AC sparen. Geben Sie hierf\xFCr einfach den Gutschein-Code $voucherCode bei der Bestellung der Zahnschienen ein.\n\nIhren individuellen Behandlungsplan finden Sie in Ihrem pers\xF6nlichen Account auf unserer Website $websiteUrl\n\nLassen Sie uns gerne wissen, wenn Sie noch Fragen zu Ihrer Behandlung haben. Sie erreichen uns telefonisch unter +41 44 505 12 36 oder per E-Mail an $emailAddress\n\nViele Gr\xFC\xDFe\nIhr PlusDental-Team\n";var TREATMENT_QUOTATION_REMINDER_VOUCHER_GB="\nHello $salutation $lastName,\n\nPerhaps you have had the opportunity to review your treatment plan and are enthusiastic about the planned treatment result?\n\nThen we would like to provide you with a voucher code that will save you 300 GBP when ordering your PlusDent Treatment. Simply enter the voucher code $voucherCode when ordering. You will find your individual treatment plan in your personal account on our website $websiteUrl.\n\nIf you have any questions, please do not hesitate to contact our customer service.Via e-mail: $emailAddress or via phone +44 20 3499 8279 (Mon-Fri 8am-7pm, Sat 9am-5pm).\n\nBest regards\nYour PlusDent-Team\n";

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plan_TreatmentDuration__ = __webpack_require__(1527);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["g" /* selectTreatmentPlan */](state),alignerSystemList:__WEBPACK_IMPORTED_MODULE_2__customer_state_detail_selector__["r" /* selectTreatmentAlignerSystemList */](state),alignersPerStepList:__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["d" /* selectAlignersPerStepList */]()};};var mapDispatchToProps={changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_3__state_plan_action__["f" /* changeTreatmentPlan */],saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_3__state_plan_action__["g" /* saveTreatmentPlan */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__plan_TreatmentDuration__["a" /* default */]));

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_quotation_const__ = __webpack_require__(59);
var TreatmentDuration=function TreatmentDuration(_ref){var treatmentPlan=_ref.treatmentPlan,alignerSystemList=_ref.alignerSystemList,alignersPerStepList=_ref.alignersPerStepList,changeTreatmentPlan=_ref.changeTreatmentPlan,saveTreatmentPlan=_ref.saveTreatmentPlan,readOnly=_ref.readOnly;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__process_ui_definition_process_ui__["_12" /* TREATMENT_DURATION_WIDGET_CONTAINER */])){return null;}if(!treatmentPlan){return null;}if(!treatmentPlan.system){changeTreatmentPlan('system',__WEBPACK_IMPORTED_MODULE_10__state_quotation_const__["b" /* ALIGNER_SYSTEM_DEFAULT_VALUE */]);}var updateNumberOfAligner=function updateNumberOfAligner(name,numberOfSteps,system){var numberOfAlignerPerStep=alignersPerStepList[system];changeTreatmentPlan(name,numberOfSteps*numberOfAlignerPerStep);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instructions w-treatment-duration'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Number of aligners'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{className:'w-td-panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{className:'w-td-column w-td-inputs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-td-input-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'System'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Select__["a" /* default */],{name:'system',valueList:alignerSystemList,onChange:function onChange(name,value){changeTreatmentPlan(name,value);updateNumberOfAligner('numberOfAlignerUpperJaw',treatmentPlan.numberOfStepsUpperJaw,value);updateNumberOfAligner('numberOfAlignerLowerJaw',treatmentPlan.numberOfStepsLowerJaw,value);saveTreatmentPlan();},readOnly:readOnly,object:treatmentPlan,defaultValue:__WEBPACK_IMPORTED_MODULE_10__state_quotation_const__["b" /* ALIGNER_SYSTEM_DEFAULT_VALUE */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Steps upper jaw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{name:'numberOfStepsUpperJaw',onChange:function onChange(name,value){changeTreatmentPlan(name,value);updateNumberOfAligner('numberOfAlignerUpperJaw',value,treatmentPlan.system);},onBlur:saveTreatmentPlan,type:'number',readOnly:readOnly,object:treatmentPlan})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Number of aligner upper jaw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{name:'numberOfAlignerUpperJaw',type:'number',readOnly:true,object:treatmentPlan}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-td-input-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Steps lower jaw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{name:'numberOfStepsLowerJaw',onChange:function onChange(name,value){changeTreatmentPlan(name,value);updateNumberOfAligner('numberOfAlignerLowerJaw',value,treatmentPlan.system);},onBlur:saveTreatmentPlan,type:'number',readOnly:readOnly,object:treatmentPlan})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Number of aligner lower jaw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{name:'numberOfAlignerLowerJaw',type:'number',readOnly:true,object:treatmentPlan})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{className:'w-td-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/asset/image/teeth-universal-numbering-system.png',alt:'teeth-universal-numbering-system'})))));};TreatmentDuration.propTypes={treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,alignerSystemList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,alignersPerStepList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TreatmentDuration);

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PhotoCheckinWidget__ = __webpack_require__(1529);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__PhotoCheckinWidget__["a" /* default */]));

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
var PhotoCheckinWidget=function PhotoCheckinWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["P" /* PHOTO_CHECKIN_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Photo Checkin Result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Go to aligner number upper jaw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{name:'gotoAlignerNumberUpper',object:context,type:'number',onChange:changeProcessContext,onBlur:saveProcessContext}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Go to aligner number lower jaw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{name:'gotoAlignerNumberLower',type:'number',object:context,onChange:changeProcessContext,onBlur:saveProcessContext})))));};PhotoCheckinWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PhotoCheckinWidget);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_quotation_action__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MedicalPhotoCheckWidget__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_quotation_const__ = __webpack_require__(59);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentQuotation:__WEBPACK_IMPORTED_MODULE_2__state_quotation_selector__["n" /* selectTreatmentQuotation */](state),customerId:__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["g" /* selectCustomerId */](state),customer:__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */](state),imageVersionList:__WEBPACK_IMPORTED_MODULE_5__customer_state_image_selector__["c" /* selectOrderedImageVersionList */](state),selectedImageType:__WEBPACK_IMPORTED_MODULE_5__customer_state_image_selector__["e" /* selectSelectedImageType */](state),currentStep:__WEBPACK_IMPORTED_MODULE_5__customer_state_image_selector__["a" /* selectCurrentStep */](state),slideIndex:__WEBPACK_IMPORTED_MODULE_5__customer_state_image_selector__["g" /* selectSlideIndex */](state),productType:__WEBPACK_IMPORTED_MODULE_7__state_quotation_const__["h" /* PRODUCT_TYPE_ALIGNERS */]};};var mapDispatchToProps={findImageVersion:__WEBPACK_IMPORTED_MODULE_6__customer_state_image_action__["b" /* findImageVersion */],findOrCreateTreatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_action__["d" /* findOrCreateTreatmentQuotation */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_6__customer_state_image_action__["g" /* rotateCustomerImage */],setSelectedImageType:__WEBPACK_IMPORTED_MODULE_6__customer_state_image_action__["j" /* setSelectedImageType */],setCurrentStep:__WEBPACK_IMPORTED_MODULE_6__customer_state_image_action__["h" /* setCurrentStep */],setSlideIndex:__WEBPACK_IMPORTED_MODULE_6__customer_state_image_action__["k" /* setSlideIndex */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__MedicalPhotoCheckWidget__["a" /* default */]));

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__customer_state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__process_ui_definition_process_ui__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MedicalPhotoCheckWidget=function(_React$Component){_inherits(MedicalPhotoCheckWidget,_React$Component);function MedicalPhotoCheckWidget(props){_classCallCheck(this,MedicalPhotoCheckWidget);var _this=_possibleConstructorReturn(this,(MedicalPhotoCheckWidget.__proto__||Object.getPrototypeOf(MedicalPhotoCheckWidget)).call(this,props));_this.getTreatmentSteps=function(){var alignerSystem=Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["g" /* pathOr */])('1-1-2',['customer','treatmentPlanList','0','system'],_this.props);var numberOfAlignerUpperJaw=Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["g" /* pathOr */])(0,['customer','treatmentPlanList','0','numberOfAlignerUpperJaw'],_this.props);var numberOfAlignerLowerJaw=Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["g" /* pathOr */])(0,['customer','treatmentPlanList','0','numberOfAlignerLowerJaw'],_this.props);var maxAligners=Math.max(numberOfAlignerUpperJaw,numberOfAlignerLowerJaw);var STEPS_FREQUENCY=alignerSystem.split('-').length;var TREATMENT_STEPS=[];for(var i=0;i<=maxAligners;i++){if(i%STEPS_FREQUENCY===0){TREATMENT_STEPS.push(i+1);}}return TREATMENT_STEPS;};_this.sendStepToVisualization=function(step){if(_this.state.visualizationLoaded){var TREATMENT_STEPS=_this.getTreatmentSteps();var visualizationStep=TREATMENT_STEPS.find(function(s){return s>=step;});var visualizationSliderValue=TREATMENT_STEPS.indexOf(visualizationStep);var iframe=document.getElementById('visualizationIframe');iframe.contentWindow.postMessage({step:visualizationSliderValue},'*');}};_this.imageGalleryRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={visualizationLoaded:false};_this.handleVisualizationLoaded=_this.handleVisualizationLoaded.bind(_this);return _this;}_createClass(MedicalPhotoCheckWidget,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('message',this.handleVisualizationLoaded);this.props.findImageVersion(this.props.customerId);this.props.findOrCreateTreatmentQuotation(this.props.productType);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('message',this.handleVisualizationLoaded);}},{key:'handleVisualizationLoaded',value:function handleVisualizationLoaded(e){if(e.data&&e.data.visualizationLoaded){this.setState({visualizationLoaded:true});this.sendStepToVisualization(this.props.currentStep);}}},{key:'renderVersionedImageGallery',value:function renderVersionedImageGallery(){var _this2=this;var _props=this.props,currentStep=_props.currentStep,setCurrentStep=_props.setCurrentStep,imageVersionList=_props.imageVersionList,selectedImageType=_props.selectedImageType,rotateCustomerImage=_props.rotateCustomerImage,setImageTypeMetaData=_props.setImageTypeMetaData,customerId=_props.customerId,slideIndex=_props.slideIndex;if(!imageVersionList||!imageVersionList[selectedImageType.name]){return null;}var versionImageList=imageVersionList[selectedImageType.name];var image=__WEBPACK_IMPORTED_MODULE_11__customer_state_detail_const__["a" /* DEFINED_IMAGE_LIST */].find(function(item){return item.name===selectedImageType.name;});versionImageList.sort(function(a,b){a=a.lastModified;b=b.lastModified;if(!a&&!b){return 0;}if(!a&&b){return-1;}if(a&&!b){return 1;}return __WEBPACK_IMPORTED_MODULE_4_moment___default()(a).unix()-__WEBPACK_IMPORTED_MODULE_4_moment___default()(b).unix();});var imageList=versionImageList.map(function(version){return{path:version.path,original:__WEBPACK_IMPORTED_MODULE_10__util_api__["a" /* BACKEND_URL */]+version.link,lastModified:Object(__WEBPACK_IMPORTED_MODULE_9__util_datetime__["c" /* formatDateTime */])(version.lastModified),fileName:image.name,versionId:version.versionId,rotate:version.meta&&version.meta.rotate?version.meta.rotate:0,originalImageType:version.originalImageType,image:image,rotateCustomerImage:rotateCustomerImage,setImageTypeMetaData:setImageTypeMetaData,customerId:customerId,imageStep:_this2.calculateImageStep(version.lastModified)};});var startIndex=Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["f" /* isNil */])(slideIndex)?versionImageList.length-1:slideIndex;if(currentStep<0){// set step on the first load
setCurrentStep(imageList[startIndex].imageStep);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery___default.a,{ref:function ref(i){return _this2.imageGalleryRef=i;},startIndex:startIndex,renderItem:this.renderImage,infinite:false,items:imageList,showThumbnails:false,showPlayButton:false,showBullets:false,showFullscreenButton:false,onSlide:function onSlide(index){return _this2.onImageSlide(index);},onClick:function onClick(){return _this2.onImageClick();}});}},{key:'renderImage',value:function renderImage(props){var lastModified=props.lastModified,original=props.original,rotate=props.rotate,originalImageType=props.originalImageType,rotateCustomerImage=props.rotateCustomerImage,versionId=props.versionId,imageStep=props.imageStep;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'medical-photo-checkin-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photo-checkin-image-container '+ROTATE_CSS[rotate]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:original,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rotate-icon-container',onClick:function onClick(event){event.stopPropagation();event.preventDefault();rotateCustomerImage(originalImageType,versionId,90);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RotateIcon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'rotate-label'},'rotate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,lastModified),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'step-number'},'Step: ',imageStep)));}},{key:'calculateImageStep',value:function calculateImageStep(formattedImageDate){var alignerCheckInList=this.props.customer.treatmentExecutionList.reduce(function(previous,current){return previous.concat(current.alignerCheckInList);},[]);var checkInDates=alignerCheckInList.map(function(checkIn){var useOldAppValues=checkIn.newAlignerNumberUpper===null&&checkIn.newAlignerNumberLower===null;var alignerNumber=useOldAppValues?Math.max(checkIn.alignerNumberUpper,checkIn.alignerNumberLower):Math.max(checkIn.newAlignerNumberUpper,checkIn.newAlignerNumberLower);var alignerChangeDate=Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["g" /* pathOr */])(__WEBPACK_IMPORTED_MODULE_4_moment___default.a.now(),['metaData','alignerChangeDate'],checkIn);var checkInDate=useOldAppValues?__WEBPACK_IMPORTED_MODULE_4_moment___default()(alignerChangeDate,'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss.SSS'):alignerChangeDate;return{checkInDate:checkInDate,alignerNumber:alignerNumber};});var imageDate=new Date(formattedImageDate);var imageStep=Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["j" /* reverse */])(checkInDates).find(function(item){return new Date(item.checkInDate)<imageDate;});return imageStep?imageStep.alignerNumber:0;}},{key:'onSelectImageType',value:function onSelectImageType(value){var _props2=this.props,currentStep=_props2.currentStep,imageVersionList=_props2.imageVersionList,setSelectedImageType=_props2.setSelectedImageType,setSlideIndex=_props2.setSlideIndex;setSelectedImageType(value);var versionImageList=imageVersionList[value];// we keep the current step status after selecting a new image type on the dropdown
// if no photo is found for that specific step, we show the last one available
var preselectedImageIndex=versionImageList.length-1;for(var i=0;i<versionImageList.length;i++){var image=versionImageList[i];var imgStep=this.calculateImageStep(image.lastModified);if(imgStep===currentStep){preselectedImageIndex=i;}}var slideIndex=preselectedImageIndex;setSlideIndex(slideIndex);this.setCurrentImageStep(versionImageList,slideIndex);}},{key:'onImageSlide',value:function onImageSlide(index){var _props3=this.props,imageVersionList=_props3.imageVersionList,selectedImageType=_props3.selectedImageType,setSlideIndex=_props3.setSlideIndex;var versionImageList=imageVersionList[selectedImageType.name];setSlideIndex(index);this.setCurrentImageStep(versionImageList,index);}},{key:'setCurrentImageStep',value:function setCurrentImageStep(versionImageList,index){var setCurrentStep=this.props.setCurrentStep;var currentImage=versionImageList[index];var step=this.calculateImageStep(currentImage.lastModified);setCurrentStep(step);this.sendStepToVisualization(step);}},{key:'onImageClick',value:function onImageClick(){this.imageGalleryRef._toggleFullScreen();}},{key:'render',value:function render(){var _this3=this;if(!Object(__WEBPACK_IMPORTED_MODULE_12__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__process_ui_definition_process_ui__["H" /* MEDICAL_PHOTO_CHECK_WIDGET */])){return null;}var _props4=this.props,currentStep=_props4.currentStep,treatmentQuotation=_props4.treatmentQuotation,selectedImageType=_props4.selectedImageType,imageVersionList=_props4.imageVersionList;if(!treatmentQuotation){return null;}// disable options with no pictures on the dropdown
var valueList=__WEBPACK_IMPORTED_MODULE_11__customer_state_detail_const__["c" /* IMAGE_TYPE_SELECT */].map(function(item){return Object.assign({},item,{disabled:!imageVersionList[item.id]});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__["a" /* default */],{title:'Medical Photo Check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'default-text'},'You can choose the view from dropdown menu and see the steps on this view by using arrows',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-address-card'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inline-block vertical-align-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Select__["a" /* default */],{object:selectedImageType,name:'name',style:selectStyle,valueList:valueList,onChange:function onChange(id,value){_this3.onSelectImageType(value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imagesContainerStyle},this.renderVersionedImageGallery())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'visualizationIframe',style:visualizationStyle,src:treatmentQuotation.treatmentLink+'&quality=medium',title:'preview',onLoad:function onLoad(){return _this3.sendStepToVisualization(currentStep);}}))));}}]);return MedicalPhotoCheckWidget;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MedicalPhotoCheckWidget.propTypes={treatmentQuotation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,selectedImageType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,setSelectedImageType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,setCurrentStep:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,imageVersionList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,customer:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,customerId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,currentStep:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,setSlideIndex:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,slideIndex:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (MedicalPhotoCheckWidget);var selectStyle={height:31,fontSize:11,marginBottom:10};var imagesContainerStyle={height:664,overflow:'hidden'};var visualizationStyle={width:'100%',height:600,border:'0'};var ROTATE_CSS={0:'grid-rotate-0',90:'grid-rotate-90',180:'grid-rotate-180',270:'grid-rotate-270'};var RotateIcon=function RotateIcon(_ref){var _ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?function(){}:_ref$onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{onClick:onClick,width:'24px',height:'25px',viewBox:'0 0 24 25'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('filter',{x:'-32.5%',y:'-31.0%',width:'165.0%',height:'161.9%',filterUnits:'objectBoundingBox',id:'filter-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feOffset',{dx:'0',dy:'1','in':'SourceAlpha',result:'shadowOffsetOuter1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feGaussianBlur',{stdDeviation:'1','in':'shadowOffsetOuter1',result:'shadowBlurOuter1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feColorMatrix',{values:'0 0 0 0 0.290221632   0 0 0 0 0.290175289   0 0 0 0 0.290237457  0 0 0 0.5 0',type:'matrix','in':'shadowBlurOuter1',result:'shadowMatrixOuter1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feMerge',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feMergeNode',{'in':'shadowMatrixOuter1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feMergeNode',{'in':'SourceGraphic'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Photo-check-in',stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Medical-Photo-Check-PDF',transform:'translate(-408.000000, -692.000000)',fill:'#FFFFFF',fillRule:'nonzero'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'875100-copy',filter:'url(#filter-1)',transform:'translate(410.000000, 693.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M17.6846847,0 C17.2600901,0 16.9159009,0.335692469 16.9159009,0.749805439 L16.9159009,3.48876778 C12.957973,-0.248485356 6.64315315,-0.148757322 2.81130631,3.7114205 C1.00545045,5.53064435 -0.00198198198,7.96493096 0.00299949504,10.4970565 C0.00299949504,10.9111695 0.347207207,11.2468619 0.771801802,11.2468619 C1.1963964,11.2468619 1.54054054,10.9111695 1.54054054,10.4970565 C1.54148649,5.94198954 5.32828829,2.25007531 9.99869369,2.25099791 C12.3706306,2.25143724 14.6332883,3.22345607 16.2348198,4.92985983 L12.8291892,6.03728033 C12.4258559,6.1681569 12.2076126,6.59312134 12.3418018,6.98649791 C12.475991,7.37987448 12.9117117,7.59273013 13.315045,7.46185356 L17.9276577,5.96228661 C18.2425225,5.86001046 18.4545495,5.57216109 18.4535173,5.24850628 L18.4535173,0.749761506 C18.4535173,0.335692469 18.1092793,0 17.6846847,0 Z',id:'Path'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M19.2222072,9.74729498 C18.7976126,9.74729498 18.4534234,10.0829874 18.4534234,10.4971004 C18.4524775,15.0521674 14.6656757,18.7440816 9.99527027,18.743159 C7.62333333,18.7427197 5.36067568,17.7707008 3.75914414,16.0642971 L7.16477477,14.9568766 C7.56810811,14.826 7.78635135,14.4010356 7.65216216,14.007659 C7.51797297,13.6142824 7.08225225,13.4014268 6.67891892,13.5323033 L2.06630631,15.0318703 C1.75144144,15.1341464 1.53941441,15.4219958 1.54044667,15.7456506 L1.54044667,20.2443954 C1.54044667,20.6585084 1.88463964,20.9942008 2.30923423,20.9942008 C2.73382883,20.9942008 3.07801802,20.6585084 3.07801802,20.2443954 L3.07801802,17.5053891 C7.03594595,21.2426423 13.3508108,21.1429582 17.1826126,17.2827364 C18.9884685,15.4635126 19.9959009,13.0292259 19.9909194,10.4971004 C19.9909194,10.0829874 19.6468018,9.74729498 19.2222072,9.74729498 Z',id:'Path'})))));};RotateIcon.propTypes={active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_quotation_selector__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TreatmentVisualizationWidget__ = __webpack_require__(1533);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentQuotation:__WEBPACK_IMPORTED_MODULE_1__state_quotation_selector__["n" /* selectTreatmentQuotation */](state),treatmentPlan:__WEBPACK_IMPORTED_MODULE_2__state_plan_selector__["g" /* selectTreatmentPlan */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__TreatmentVisualizationWidget__["a" /* default */]));

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
var VISUALIZATION_LINK='https://sunshinesmile.de/visualization/?quality=medium&showGridButton=true&id=';var style={width:'100%',height:'600px',border:'0'};var TreatmentVisualizationWidget=function TreatmentVisualizationWidget(_ref){var treatmentQuotation=_ref.treatmentQuotation,treatmentPlan=_ref.treatmentPlan,readOnly=_ref.readOnly;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__["_20" /* TREATMENT_VISUALIZATION_WIDGET_CONTAINER */])){return null;}if(!treatmentQuotation||!treatmentPlan){return null;}var alignerSystem=treatmentPlan.system;var link=treatmentQuotation.visualizationId?VISUALIZATION_LINK+treatmentQuotation.visualizationId+'&system='+alignerSystem:treatmentQuotation.treatmentLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Treatment Visualization'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link,target:'_blank',rel:'noopener noreferrer'},'Open in new Window'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{style:style,src:link,title:'preview'}))));};TreatmentVisualizationWidget.propTypes={treatmentQuotation:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,treatmentPlan:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (TreatmentVisualizationWidget);

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__manage_MovementCertificateNumberWidget__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_action__ = __webpack_require__(51);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__manage_MovementCertificateNumberWidget__["a" /* default */]));

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validation_component_ValidationMessageList__ = __webpack_require__(34);
var MovementCertificateNumberWidget=function MovementCertificateNumberWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["J" /* MOVEMENT_CERTIFICATE_NUMBER_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Movement Certificate Number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Input__["a" /* default */],{readOnly:readOnly,name:'movementCertificateNumber',object:context,onChange:changeProcessContext,onBlur:saveProcessContext}))));};MovementCertificateNumberWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (MovementCertificateNumberWidget);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_list_action__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_list_selector__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_ShipmentList__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sales_order_state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sales_order_state_detail_action__ = __webpack_require__(147);
var mapStateToProps=function mapStateToProps(state,props){return{fetching:__WEBPACK_IMPORTED_MODULE_2__state_list_selector__["a" /* selectIsFetching */](state),shipmentList:Object(__WEBPACK_IMPORTED_MODULE_4__sales_order_state_detail_selector__["j" /* selectShipmentList */])(state),salesOrder:Object(__WEBPACK_IMPORTED_MODULE_4__sales_order_state_detail_selector__["f" /* selectSalesOrder */])(state),shipmentDetailOpen:__WEBPACK_IMPORTED_MODULE_2__state_list_selector__["c" /* selectShipmentDetailOpen */](state)};};var mapDispatchToProps={createShipment:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["a" /* createShipment */],addShipment:__WEBPACK_IMPORTED_MODULE_5__sales_order_state_detail_action__["c" /* addShipment */],toggleShipmentTracking:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["c" /* toggleShipmentTracking */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__list_ShipmentList__["a" /* default */]));

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_transfer_drive_files_selector__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_transfer_drive_files_action__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransferDriveFiles__ = __webpack_require__(1540);
var mapStateToProps=function mapStateToProps(state,props){return{fileList:__WEBPACK_IMPORTED_MODULE_1__state_transfer_drive_files_selector__["a" /* selectFileList */](state)};};var mapDispatchToProps={getScanFolderContent:__WEBPACK_IMPORTED_MODULE_2__state_transfer_drive_files_action__["a" /* getScanFolderContent */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__TransferDriveFiles__["a" /* default */]));

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectFileList; });
/* unused harmony export selectIsFetching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(102);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectFileList=function selectFileList(state){return selectOwnState(state).fileList;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getScanFolderContentRequest */
/* unused harmony export getScanFolderContentSuccess */
/* unused harmony export getScanFolderContentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getScanFolderContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(356);
var getScanFolderContentRequest=function getScanFolderContentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_SCAN_FOLDER_CONTENT_REQUEST */]};};var getScanFolderContentSuccess=function getScanFolderContentSuccess(fileList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* GET_SCAN_FOLDER_CONTENT_SUCCESS */],payload:{fileList:fileList}};};var getScanFolderContentError=function getScanFolderContentError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* GET_SCAN_FOLDER_CONTENT_ERROR */],payload:{error:error}};};var getScanFolderContent=function getScanFolderContent(folderId){return function(dispatch,getState){dispatch(getScanFolderContentRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/store/get-scan-folder-content?folderId='+folderId).then(function(fileList){dispatch(getScanFolderContentSuccess(fileList));}).catch(function(error){dispatch(getScanFolderContentError(error));});};};

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var TransferDriveFiles=function TransferDriveFiles(_ref){var task=_ref.task,fileList=_ref.fileList,getScanFolderContent=_ref.getScanFolderContent;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["u" /* CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET */])){return null;}var processInstance=task.processInstance;var context=processInstance.context;var driveFolderId=context.driveFolderId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Drive Files'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:function onClick(){getScanFolderContent(driveFolderId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-refresh'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'customer-form-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'File')),fileList.map(function(file){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:file.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,file.name));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null)))));};TransferDriveFiles.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){var processInstance=this.props.task.processInstance;var context=processInstance.context;var driveFolderId=context.driveFolderId;this.props.getScanFolderContent(driveFolderId);}})(TransferDriveFiles));

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detail_CustomerContact__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sipgate_state_action__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_const__ = __webpack_require__(31);
var mapStateToProps=function mapStateToProps(state,props){return{contact:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["d" /* selectCustomerContact */](state),error:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["f" /* selectCustomerError */](state),salutationList:__WEBPACK_IMPORTED_MODULE_1__globals__["a" /* default */].selector.selectSalutationList(state),canSeeImages:Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["d" /* selectCanSeeImages */])(state),countryCodeList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["e" /* COUNTRY_CODE_LIST */],languageList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["f" /* LANGUAGE_LIST */]};};var mapDispatchToProps={callNumber:__WEBPACK_IMPORTED_MODULE_6__sipgate_state_action__["a" /* callNumber */],changeCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["d" /* changeCustomerContact */],saveCustomerContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["x" /* saveCustomerContact */],hydrateContact:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["q" /* hydrateCustomerContact */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__detail_CustomerContact__["a" /* default */]));

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail_TreatmentExecution__ = __webpack_require__(515);
var mapStateToProps=function mapStateToProps(state){return{customer:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["c" /* selectCustomer */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__detail_TreatmentExecution__["a" /* default */]));

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail_TreatmentFeedback__ = __webpack_require__(516);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["c" /* selectCustomer */](state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__detail_TreatmentFeedback__["a" /* default */]));

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_match_action__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_match_selector__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__match_Match3ShapeCustomer__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_state_instance_detail_action__ = __webpack_require__(51);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */](state),caseList:__WEBPACK_IMPORTED_MODULE_3__state_match_selector__["a" /* selectCaseList */](state),context:__WEBPACK_IMPORTED_MODULE_5__process_state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={findUnassignedCaseList:__WEBPACK_IMPORTED_MODULE_2__state_match_action__["a" /* findUnassignedCaseList */],changeProcessContext:__WEBPACK_IMPORTED_MODULE_6__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_6__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__match_Match3ShapeCustomer__["a" /* default */]));

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findUnassignedCaseListRequest */
/* unused harmony export findUnassignedCaseListSuccess */
/* unused harmony export findUnassignedCaseListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findUnassignedCaseList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_state_detail_selector__ = __webpack_require__(13);
var findUnassignedCaseListRequest=function findUnassignedCaseListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_UNASSIGNED_CASE_LIST_REQUEST */],payload:{}};};var findUnassignedCaseListSuccess=function findUnassignedCaseListSuccess(caseList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_UNASSIGNED_CASE_LIST_SUCCESS */],payload:{caseList:caseList}};};var findUnassignedCaseListError=function findUnassignedCaseListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FIND_UNASSIGNED_CASE_LIST_ERROR */],payload:{error:error}};};var findUnassignedCaseList=function findUnassignedCaseList(){return function(dispatch,getState){var state=getState();var customerId=Object(__WEBPACK_IMPORTED_MODULE_2__customer_state_detail_selector__["g" /* selectCustomerId */])(state);dispatch(findUnassignedCaseListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/3shape/find-unassigned-case-list?customerId='+customerId).then(function(caseList){dispatch(findUnassignedCaseListSuccess(caseList));}).catch(function(error){dispatch(findUnassignedCaseListError(error));});};};

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectCaseList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(1547);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectCaseList=function selectCaseList(state){return selectOwnState(state).caseList;};

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(390);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__ = __webpack_require__(2);
var Match3Shape=function Match3Shape(_ref){var customer=_ref.customer,caseList=_ref.caseList,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,readOnly=_ref.readOnly,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_10__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__["G" /* MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__["a" /* default */],{title:'Match 3Shape'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'3Shape Case'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Select__["a" /* default */],{object:context,name:'threeShapeCaseId',valueList:caseList,addEmpty:true,renderer:function renderer(threeShapeCase){return threeShapeCase.firstName+' '+threeShapeCase.lastName+' ('+Object(__WEBPACK_IMPORTED_MODULE_9__util_datetime__["b" /* formatDate */])(threeShapeCase.original.UpdatedOn)+')';},readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};Match3Shape.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,caseList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,findUnassignedCaseList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findUnassignedCaseList();}})(Match3Shape));

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
var HESITATION_REASON_LIST=[{id:'financial',value:'Financial'},{id:'competition_financial',value:'Konkurrenz finanziell'},{id:'competition_treatment_plan',value:'Konkurrenz Behandlungsergebnis'},{id:'bite_correction',value:'Bisskorrektur'},{id:'molar',value:'Backenzähne'},{id:'asr_not_available',value:'ASR (bei uns noch nicht vefügbar)'},{id:'digital_treatment_too_lose',value:'Digitale Behandlung zu lose'},{id:'bad_shop_experience',value:'Negative Shoperfahrung'},{id:'treatment_plan',value:'Treatment Plan'},{id:'needs_dental_treatment',value:'Needs dental treatment'},{id:'new_pricing',value:'new pricing'},{id:'other',value:'Other'}];var InitialHesitationWidget=function InitialHesitationWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Initial Hesitation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{name:'initialHesitation',object:context,valueList:HESITATION_REASON_LIST,addEmpty:!context.initialHesitation,readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};InitialHesitationWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InitialHesitationWidget);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__anamnesis_Anamnesis__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state,_ref){var templateKey=_ref.templateKey;var customer=Object(__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */])(state);return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_selector__["e" /* selectOwnState */](state),{anamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_selector__["a" /* selectAnamnesisByTemplateKey */](state,templateKey),templateKey:templateKey,customerId:customer.id,isUserFromCustomerStore:Object(__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["s" /* selectUserStore */])(state)===customer.store,isIPRProviderStore:Object(__WEBPACK_IMPORTED_MODULE_5__globals_state_selector__["isIPRProviderStore"])(state,customer.store),showAnamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_selector__["f" /* selectShowAnamnesis */](state),isInfoLegendShown:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_selector__["g" /* selectShowInfoLegendShown */](state)});};var mapDispatchToProps={findOrCreateAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["b" /* findOrCreateAnamnesis */],changeAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["a" /* changeAnamnesis */],udpateAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["g" /* udpateAnamnesis */],saveAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["c" /* saveAnamnesis */],toggleAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["d" /* toggleAnamnesis */],toggleEditingTreatmentExpectation:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["e" /* toggleEditingTreatmentExpectation */],toggleInfoLegend:__WEBPACK_IMPORTED_MODULE_1__state_anamnesis_action__["f" /* toggleInfoLegend */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__anamnesis_Anamnesis__["a" /* default */]));

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_list_action__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_AnamnesisList__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_list_selector__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state,props){var customer=Object(__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["c" /* selectCustomer */])(state);return{customerId:customer.id,isIprReadOnly:props.isIprReadOnly,store:customer.store,anamnesisList:__WEBPACK_IMPORTED_MODULE_5__state_list_selector__["a" /* selectAnamnesisList */](state),isUserFromCustomerStore:Object(__WEBPACK_IMPORTED_MODULE_7__security_state_auth_selector__["s" /* selectUserStore */])(state)===customer.store,isIPRProviderStore:Object(__WEBPACK_IMPORTED_MODULE_6__globals_state_selector__["isIPRProviderStore"])(state,customer.store),showAnamnesis:__WEBPACK_IMPORTED_MODULE_5__state_list_selector__["c" /* selectShowAnamnesis */](state),isInfoLegendShown:__WEBPACK_IMPORTED_MODULE_5__state_list_selector__["d" /* selectShowInfoLegendShown */](state)};};var mapDispatchToProps={findOrCreateAnamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__["b" /* findOrCreateAnamnesis */],findByCustomerId:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["a" /* findByCustomerId */],toggleAnamnesis:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["b" /* toggleAnamnesis */],toggleInfoLegend:__WEBPACK_IMPORTED_MODULE_1__state_list_action__["c" /* toggleInfoLegend */],changeAnamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__["a" /* changeAnamnesis */],saveAnamnesis:__WEBPACK_IMPORTED_MODULE_2__state_anamnesis_action__["c" /* saveAnamnesis */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__list_AnamnesisList__["a" /* default */]));

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PatientScannedWidget__ = __webpack_require__(1553);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__PatientScannedWidget__["a" /* default */]));

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Input__ = __webpack_require__(36);
var PATIENT_SCANNED_VALUE=[{value:true,label:'Yes'},{value:false,label:'No'}];var PatientScannedWidget=function PatientScannedWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList,_ref$isSaveNeeded=_ref.isSaveNeeded,isSaveNeeded=_ref$isSaveNeeded===undefined?false:_ref$isSaveNeeded;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__["N" /* PATIENT_SCANNED_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:' Patient Scanned'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__["a" /* default */],{object:context,name:'patientScanned',readOnly:readOnly,addEmpty:true,valueList:PATIENT_SCANNED_VALUE,onChange:function onChange(name,value){changeProcessContext('patientScanned',value);if(isSaveNeeded){saveProcessContext();}}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Scanned by'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Input__["a" /* default */],{name:'scannedBy',object:context,readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext('scannedBy',value);saveProcessContext();}})))));};PatientScannedWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,isSaveNeeded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (PatientScannedWidget);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list_AppointmentList__ = __webpack_require__(504);
var mapStateToProps=function mapStateToProps(state,props){var _selector$selectCusto=__WEBPACK_IMPORTED_MODULE_1__customer_state_detail_selector__["c" /* selectCustomer */](state),appointmentList=_selector$selectCusto.appointmentList;return{appointmentList:appointmentList};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__list_AppointmentList__["a" /* default */]));

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectCustomer */](state),fileType:__WEBPACK_IMPORTED_MODULE_6__state_const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */],fetching:__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_6__state_const__["k" /* FILE_TYPE_TREATMENT_PLAN_EXTERNAL */]),widgetId:__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_16" /* TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_correction_action__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_correction_selector__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__correction_InvoiceCorrection__ = __webpack_require__(1557);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_correction_selector__["b" /* selectOwnState */](state));};var mapDispatchToProps={showConfirmationModal:__WEBPACK_IMPORTED_MODULE_1__state_correction_action__["f" /* showConfirmationModal */],closeConfirmationModal:__WEBPACK_IMPORTED_MODULE_1__state_correction_action__["c" /* closeConfirmationModal */],changeInvoiceCorrectionItem:__WEBPACK_IMPORTED_MODULE_1__state_correction_action__["b" /* changeInvoiceCorrectionItem */],createInvoiceCorrection:__WEBPACK_IMPORTED_MODULE_1__state_correction_action__["d" /* createInvoiceCorrection */],changeInvoiceCorrectionData:__WEBPACK_IMPORTED_MODULE_1__state_correction_action__["a" /* changeInvoiceCorrectionData */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__correction_InvoiceCorrection__["a" /* default */]));

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvoiceCorrectionForm__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceCorrectionResult__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__ = __webpack_require__(2);
var InvoiceCorrection=function InvoiceCorrection(props){if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__["C" /* INVOICE_CORRECTION_WIDGET */])){return null;}var invoice=props.invoice,invoiceCorrection=props.invoiceCorrection;if(!invoice){return null;}return invoiceCorrection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InvoiceCorrectionResult__["a" /* default */],props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InvoiceCorrectionForm__["a" /* default */],props);};InvoiceCorrection.propTypes={invoice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,invoiceCorrection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,invoiceCorrectionData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,confirmationModalOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeInvoiceCorrectionItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,closeConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createInvoiceCorrection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeInvoiceCorrectionData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InvoiceCorrection);

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_ConfirmationModal__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoiceItemCorrectionForm__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_TextArea__ = __webpack_require__(63);
var InvoiceCorrectionForm=function InvoiceCorrectionForm(_ref){var invoice=_ref.invoice,fetching=_ref.fetching,invoiceCorrectionData=_ref.invoiceCorrectionData,confirmationModalOpen=_ref.confirmationModalOpen,changeInvoiceCorrectionData=_ref.changeInvoiceCorrectionData,changeInvoiceCorrectionItem=_ref.changeInvoiceCorrectionItem,createInvoiceCorrection=_ref.createInvoiceCorrection,showConfirmationModal=_ref.showConfirmationModal,closeConfirmationModal=_ref.closeConfirmationModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBox__["a" /* default */],{title:'Create Invoice Correction '+invoice.referenceNumber},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_ConfirmationModal__["a" /* default */],{showModal:confirmationModalOpen,confirmClicked:createInvoiceCorrection,cancelClicked:closeConfirmationModal},'Please confirm the creation of invoice correction for invoice ',invoice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,invoice.referenceNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger btn-sm',onClick:showConfirmationModal},'create correction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Position'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Original Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Refund amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,invoice.invoiceItemList.map(function(invoiceItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InvoiceItemCorrectionForm__["a" /* default */],{key:invoiceItem.id,changeInvoiceCorrectionItem:changeInvoiceCorrectionItem,invoiceItem:invoiceItem});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__["a" /* default */],{label:'Comment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_TextArea__["a" /* default */],{name:'customText',object:invoiceCorrectionData,onChange:changeInvoiceCorrectionData}))))));};InvoiceCorrectionForm.propTypes={invoice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,invoiceCorrectionData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,confirmationModalOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeInvoiceCorrectionItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,closeConfirmationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createInvoiceCorrection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeInvoiceCorrectionData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InvoiceCorrectionForm);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_money__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Input__ = __webpack_require__(36);
var InvoiceItemCorrectionForm=function InvoiceItemCorrectionForm(_ref){var invoiceItem=_ref.invoiceItem,changeInvoiceCorrectionItem=_ref.changeInvoiceCorrectionItem;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,invoiceItem.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_2__util_money__["b" /* formatMoney */])(invoiceItem.brutPrice,invoiceItem.currency)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Input__["a" /* default */],{name:'correctionAmount',object:invoiceItem,type:'number',max:invoiceItem.brutPrice/100,onChange:function onChange(name,value){changeInvoiceCorrectionItem(invoiceItem.id,name,value);}})));};InvoiceItemCorrectionForm.propTypes={invoiceItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeInvoiceCorrectionItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InvoiceItemCorrectionForm);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_api__ = __webpack_require__(12);
var iframeStyle={width:'100%',height:'1000px'};var InvoiceCorrectionResult=function InvoiceCorrectionResult(_ref){var invoiceCorrection=_ref.invoiceCorrection;var viewLink=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/invoice/pdf/view?fileId='+invoiceCorrection.fileId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Invoice Correction '+invoiceCorrection.referenceNumber},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:viewLink,title:'Invoice Correction',style:iframeStyle}))));};InvoiceCorrectionResult.propTypes={invoiceCorrection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InvoiceCorrectionResult);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PreTreatmentReasonWidget__ = __webpack_require__(1562);
var mapStateToProps=function mapStateToProps(state,props){return{context:__WEBPACK_IMPORTED_MODULE_2__process_state_instance_detail_selector__["k" /* selectProcessContext */](state),taskName:props.taskName};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__PreTreatmentReasonWidget__["a" /* default */]));

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CannotBeTreatedReasonWidget__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__ = __webpack_require__(35);
var PRE_TREATMENT_REASON_LIST_WITHOUT_PRETREATMENT=[{id:'caries',value:'Caries'},{id:'defective_filling',value:'defective filling'},{id:'gingivitis_prophylaxis',value:'massive dental calculus'},{id:'parodontosis',value:'Periodontitis'},{id:'tmj',value:'TMJ disorder (CMD)'}];var PRE_TREATMENT_REASON_LIST_WITH_PRETREATMENT=[{id:'caries',value:'Caries'},{id:'defective_filling',value:'defective filling'},{id:'gingivitis_prophylaxis',value:'massive dental calculus'}];var getPretreatmentReasonsList=function getPretreatmentReasonsList(taskName){var taskList=[__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["c" /* CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT */],__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["m" /* MEDICAL_CHECK_WITH_PRETREATMENT */],__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["k" /* MEDICAL_ASSESSMENT */],__WEBPACK_IMPORTED_MODULE_10__process_ui_definition_sales_order_in_shop_scan_task_name__["a" /* CONFIRM_MEDICAL_ASSESSMENT */]];var found=taskList.includes(taskName);return found?PRE_TREATMENT_REASON_LIST_WITH_PRETREATMENT:PRE_TREATMENT_REASON_LIST_WITHOUT_PRETREATMENT;};var customSelectStyle={border:'1px solid rgb(52, 152, 219)',height:'50px'};var PreTreatmentReasonWidget=function PreTreatmentReasonWidget(_ref){var readOnly=_ref.readOnly,context=_ref.context,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,taskName=_ref.taskName;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["R" /* PRE_TREATMENT_REASON_WIDGET_CONTAINER */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Pre Treatment / Cannot be treated reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Pre Treatment reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{style:customSelectStyle,name:'preTreatmentReason',object:context,valueList:getPretreatmentReasonsList(taskName),addEmpty:true,readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Cannot be treated reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{style:customSelectStyle,name:'cannotBeTreatedReason',object:context,valueList:Object(__WEBPACK_IMPORTED_MODULE_7__CannotBeTreatedReasonWidget__["b" /* getCannotBeTreatedReasonsList */])(taskName),addEmpty:true,readOnly:readOnly,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}})))));};PreTreatmentReasonWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,context:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,taskName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PreTreatmentReasonWidget);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductionCaseCardWidget__ = __webpack_require__(1564);
var mapStateToProps=function mapStateToProps(state,props){return{salesOrder:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["f" /* selectSalesOrder */](state)};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ProductionCaseCardWidget__["a" /* default */]));

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var iframeStyle={width:'100%',height:'700px'};var ProductionCaseCardWidget=function ProductionCaseCardWidget(_ref){var salesOrder=_ref.salesOrder;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["V" /* PRODUCTION_CASE_CARD_WIDGET */])){return null;}if(!salesOrder){return null;}var viewLink=__WEBPACK_IMPORTED_MODULE_5__util_api__["a" /* BACKEND_URL */]+'/api/production/render-production-case-card?salesOrderId='+salesOrder.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Production Case Card'+salesOrder.referenceNumber},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:viewLink,title:'Production Case Card',style:iframeStyle}))));};ProductionCaseCardWidget.propTypes={salesOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ProductionCaseCardWidget);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plan_IPRInstructions__ = __webpack_require__(524);
var mapStateToProps=function mapStateToProps(state,props){var customer=Object(__WEBPACK_IMPORTED_MODULE_6__customer_state_detail_selector__["c" /* selectCustomer */])(state);return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_2__state_plan_selector__["g" /* selectTreatmentPlan */](state),context:__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["k" /* selectProcessContext */](state),isWidget:true,isIPRProviderStore:Object(__WEBPACK_IMPORTED_MODULE_5__globals_state_selector__["isIPRProviderStore"])(state,customer.store)};};var mapDispatchToProps={saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["g" /* saveTreatmentPlan */],changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["f" /* changeTreatmentPlan */],changeIPRInstruction:__WEBPACK_IMPORTED_MODULE_1__state_plan_action__["c" /* changeIPRInstruction */],changeProcessContext:__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_7__plan_IPRInstructions__["a" /* default */]));

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan_ModelSelection__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sales_order_state_detail_selector__ = __webpack_require__(54);
var mapStateToProps=function mapStateToProps(state,props){var salesOrder=Object(__WEBPACK_IMPORTED_MODULE_5__sales_order_state_detail_selector__["f" /* selectSalesOrder */])(state);var alignerLabelList=salesOrder.type==='treatment'||salesOrder.type==='treatment-new'?__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["b" /* selectAlignerLabelListProduction */](state,salesOrder):__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["c" /* selectAlignerLabelListReproduction */](state);return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["g" /* selectTreatmentPlan */](state),alignerLabelList:alignerLabelList,processContext:Object(__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["k" /* selectProcessContext */])(state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__plan_ModelSelection__["a" /* default */]));

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_state_instance_detail_selector__ = __webpack_require__(9);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var MODEL_SELECTION_PROPERTY='modelSelection';var MODEL_SELECTION_PROPERTY_RE_PRODUCTION='modelSelectionReproduction';function getAlignerSelectionObject(processContext,modelSelectionProcessContextKey){if(!processContext){return{};}return processContext[modelSelectionProcessContextKey]||{};}var alignerTypeSelectionsReadOnly={};function setReadOnlyStatusForAlignerTypeSections(selectedAlignerList,alignerLabelList){clearReadOnlyStatusForAlignerTypeSections(alignerLabelList);Object.keys(selectedAlignerList).forEach(function(selectedAlignerName){alignerLabelList.forEach(function(_ref,alignerLabelKey){var labelList=_ref.labelList,salesOrderReference=_ref.salesOrderReference;labelList.forEach(function(_ref2){var lower=_ref2.lower,upper=_ref2.upper;var lowerLabelName=generateLowerAlignerName(lower,salesOrderReference);var upperLabelName=generateUpperAlignerName(upper,salesOrderReference);if([upperLabelName,lowerLabelName].includes(selectedAlignerName)){Object.keys(alignerTypeSelectionsReadOnly).forEach(function(key){if(parseInt(key,10)!==alignerLabelKey&&selectedAlignerList[selectedAlignerName]===true){alignerTypeSelectionsReadOnly[key]=true;}});}});});});}function clearReadOnlyStatusForAlignerTypeSections(alignerLabelList){Object.keys(alignerLabelList).forEach(function(key){alignerTypeSelectionsReadOnly[key]=false;});}function generateLowerAlignerName(lower,salesOrderReference){return getSalesOrderReferenceShort(salesOrderReference)+lower;}function generateUpperAlignerName(upper,salesOrderReference){return getSalesOrderReferenceShort(salesOrderReference)+upper;}function getSalesOrderReferenceShort(salesOrderReference){var referenceNumberPartList=salesOrderReference.split('-');return referenceNumberPartList[2];}var ModelSelection=function ModelSelection(_ref3){var treatmentPlan=_ref3.treatmentPlan,alignerLabelList=_ref3.alignerLabelList,readOnly=_ref3.readOnly,processContext=_ref3.processContext,changeProcessContext=_ref3.changeProcessContext,saveProcessContext=_ref3.saveProcessContext;var modelSelectionProcessContextKey=MODEL_SELECTION_PROPERTY;if(!Object(__WEBPACK_IMPORTED_MODULE_4__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__process_ui_definition_process_ui__["I" /* MODEL_SELECTION_WIDGET */])){return null;}if(!treatmentPlan){return null;}var state=__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getState();var processInstance=Object(__WEBPACK_IMPORTED_MODULE_7__process_state_instance_detail_selector__["m" /* selectProcessInstance */])(state);var isAlignerReproductionProcess=processInstance&&processInstance.processName==='salesorder-aligner-reproduction';if(isAlignerReproductionProcess){modelSelectionProcessContextKey=MODEL_SELECTION_PROPERTY_RE_PRODUCTION;}// change selection
var alignerSelectionObject=getAlignerSelectionObject(processContext,modelSelectionProcessContextKey);var toggleAlignerSelection=function toggleAlignerSelection(name,salesOrderReference){changeProcessContext(modelSelectionProcessContextKey,Object.assign({},alignerSelectionObject,_defineProperty({},name,!alignerSelectionObject[name])));changeProcessContext('SalesOrderReference',salesOrderReference);saveProcessContext();};// select all aligner/models
var selectAll=function selectAll(selected){var selection={};var lastAlignerLabel=alignerLabelList[alignerLabelList.length-1];var referenceNumberPartList=lastAlignerLabel.salesOrderReference.split('-');//take the last Part of SalesOrderReferenceNumber e.g: A-2020-f543 --> f543
var salesOrderReferenceShort=referenceNumberPartList[2];lastAlignerLabel.labelList.map(function(label){if(label.upper){selection[salesOrderReferenceShort+label.upper]=selected;}if(label.lower){selection[salesOrderReferenceShort+label.lower]=selected;}return selection;});changeProcessContext(modelSelectionProcessContextKey,selection);saveProcessContext();};if(alignerSelectionObject&&alignerLabelList){setReadOnlyStatusForAlignerTypeSections(alignerSelectionObject,alignerLabelList);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Model Selection'},!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-warning btn-sm',onClick:function onClick(){selectAll(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Select all'),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-warning btn-sm',onClick:function onClick(){selectAll(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'\xA0Deselect all')),alignerLabelList.map(function(alignerLabel,index1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px'},key:index1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,alignerLabel.salesOrderType.charAt(0).toUpperCase()+alignerLabel.salesOrderType.slice(1)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Upper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Lower'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,alignerLabel.labelList.map(function(label,index2){// prepare for aligner rendering
var referenceNumberPartList=alignerLabel.salesOrderReference.split('-');var salesOrderReferenceShort=referenceNumberPartList[2];var renderAlignerLabel=function renderAlignerLabel(label){return label?salesOrderReferenceShort+label:'';};var upperText=renderAlignerLabel(label.upper);var lowerText=renderAlignerLabel(label.lower);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,upperText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Checkbox__["a" /* default */],{readOnly:readOnly||alignerTypeSelectionsReadOnly[index1],name:upperText,object:alignerSelectionObject,onChange:function onChange(name,value){if(!readOnly){toggleAlignerSelection(name,alignerLabel.salesOrderReference);}}},upperText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,lowerText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Checkbox__["a" /* default */],{readOnly:readOnly||alignerTypeSelectionsReadOnly[index1],name:lowerText,object:alignerSelectionObject,onChange:function onChange(name,value){if(!readOnly){toggleAlignerSelection(name,alignerLabel.salesOrderReference);}}},lowerText)));}))));}));};ModelSelection.propTypes={treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ModelSelection);

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var moment=__webpack_require__(38);var isDateStillValid=function isDateStillValid(date){return moment().utc().diff(date)<0;};var VoucherWidget=function VoucherWidget(_ref){var _ref$voucherList=_ref.voucherList,voucherList=_ref$voucherList===undefined?[]:_ref$voucherList;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["_21" /* VOUCHER_WIDGET_CONTAINER */])){return null;}if(!Array.isArray(voucherList)||voucherList.length<1){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Voucher Info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'still Available?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Voucher Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'UsageCount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valid Until'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,voucherList.map(function(voucher,index){var usageCount=voucher.usageCount,validUntil=voucher.validUntil,value=voucher.value,productLogicalId=voucher.productLogicalId,code=voucher.code;var isVoucherAvailable=usageCount===0&&isDateStillValid(validUntil);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:voucher.code+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,isVoucherAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:iconStyleGreen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2714')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:iconStyleRed},'\u292B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,productLogicalId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,usageCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,validUntil));}))))));};VoucherWidget.propTypes={voucherList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};var iconStyleRed={display:'inline-flex',justifyContent:'center',alignContent:'center',backgroundColor:'red',color:'white',borderRadius:'4px',width:'24px',height:'24px',fontSize:'14px',fontWeight:'900'};var iconStyleGreen={display:'inline-flex',justifyContent:'center',alignContent:'center',backgroundColor:'green',color:'white',paddding:'4px',borderRadius:'4px',width:'24px',height:'24px',fontSize:'18px',fontWeight:'900'};/* harmony default export */ __webpack_exports__["a"] = (VoucherWidget);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComplexityTreatmentWidget__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treatment_state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_instance_detail_selector__ = __webpack_require__(9);
var mapStateToProps=function mapStateToProps(state,props){var treatmentPlan=__WEBPACK_IMPORTED_MODULE_2__treatment_state_plan_selector__["g" /* selectTreatmentPlan */](state);var treatmentPlanExists=typeof treatmentPlan!=='undefined';return{treatmentPlanObject:treatmentPlanExists?__WEBPACK_IMPORTED_MODULE_2__treatment_state_plan_selector__["g" /* selectTreatmentPlan */](state):__WEBPACK_IMPORTED_MODULE_5__state_instance_detail_selector__["k" /* selectProcessContext */](state),treatmentPlanExists:treatmentPlanExists};};var mapDispatchToProps={changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_action__["f" /* changeTreatmentPlan */],saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_3__treatment_state_plan_action__["g" /* saveTreatmentPlan */],changeProcessContext:__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_4__process_state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ComplexityTreatmentWidget__["a" /* default */]));

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__ = __webpack_require__(2);
var COMPLEXITY_LIST=[{id:'simple',value:'Simple'},{id:'medium',value:'Medium'},{id:'complex',value:'Complex'},{id:'joker',value:'Joker'}];var ComplexityTreatmentWidget=function ComplexityTreatmentWidget(_ref){var validationMessageList=_ref.validationMessageList,treatmentPlanObject=_ref.treatmentPlanObject,treatmentPlanExists=_ref.treatmentPlanExists,changeTreatmentPlan=_ref.changeTreatmentPlan,saveTreatmentPlan=_ref.saveTreatmentPlan,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__process_ui_definition_process_ui__["l" /* COMPLEXITY_TREATMENT_WIDGET */])){return null;}var complexityName='complexity';if(treatmentPlanExists&&treatmentPlanObject.complexity===null&&treatmentPlanObject.iprPossible===true){changeTreatmentPlan(complexityName,'medium');saveTreatmentPlan();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Treatment plan complexity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Complexity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{name:complexityName,object:treatmentPlanObject,valueList:COMPLEXITY_LIST,addEmpty:true,readOnly:false,onChange:function onChange(name,value){if(treatmentPlanExists){changeTreatmentPlan(name,value);saveTreatmentPlan();}else{changeProcessContext(name,value);saveProcessContext();}}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};ComplexityTreatmentWidget.propTypes={treatmentPlanObject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,treatmentPlanExists:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ComplexityTreatmentWidget);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_image_selector__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomerPreCheckinImageWidget__ = __webpack_require__(1572);
var mapStateToProps=function mapStateToProps(state,props){return{customerId:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["g" /* selectCustomerId */](state),canSeeImages:Object(__WEBPACK_IMPORTED_MODULE_4__security_state_auth_selector__["d" /* selectCanSeeImages */])(state),imageVersionList:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["c" /* selectOrderedImageVersionList */](state),showImages:__WEBPACK_IMPORTED_MODULE_2__state_image_selector__["f" /* selectShowImages */](state)};};var mapDispatchToProps={uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["m" /* uploadCustomerImage */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["g" /* rotateCustomerImage */],toggleImageView:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["l" /* toggleImageView */],setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["i" /* setImageTypeMetaData */],findImageVersion:__WEBPACK_IMPORTED_MODULE_1__state_image_action__["b" /* findImageVersion */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__CustomerPreCheckinImageWidget__["a" /* default */]));

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_ToggleButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DownloadImages__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_PreCheckinPhotoList__ = __webpack_require__(1574);
var CustomerPreCheckinImageWidget=function CustomerPreCheckinImageWidget(_ref){var canSeeImages=_ref.canSeeImages,setImageTypeMetaData=_ref.setImageTypeMetaData,imageVersionList=_ref.imageVersionList,uploadCustomerImage=_ref.uploadCustomerImage,rotateCustomerImage=_ref.rotateCustomerImage,customerId=_ref.customerId,showImages=_ref.showImages,toggleImageView=_ref.toggleImageView,findImageVersion=_ref.findImageVersion;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__process_ui_definition_process_ui__["t" /* CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET */])||!canSeeImages){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Column__["a" /* default */],{size:8},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h1",null,"Photo precheck")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bootstrap_component_Column__["a" /* default */],{size:4,className:"align-right"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_ToggleButton__["a" /* default */],{toggle:toggleImageView,active:showImages,activeIcon:"fa fa-search-minus",inactiveIcon:"fa fa-search-plus"})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout_component_ContentBoxBody__["a" /* default */],null,imageVersionList!==undefined||Object.keys(imageVersionList).length!==0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_DownloadImages__["a" /* default */],{imageVersionList:imageVersionList,customerId:customerId}):"",showImages&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_PreCheckinPhotoList__["a" /* default */],{customerId:customerId,setImageTypeMetaData:setImageTypeMetaData,imageVersionList:imageVersionList,uploadCustomerImage:uploadCustomerImage,rotateCustomerImage:rotateCustomerImage,findImageVersion:findImageVersion})));};CustomerPreCheckinImageWidget.propTypes={customerId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,showImages:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,toggleImageView:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,canSeeImages:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,imageVersionList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]),findImageVersion:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* lifecycle */])({})(CustomerPreCheckinImageWidget));

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(12);
var DOWNLOAD_URL=__WEBPACK_IMPORTED_MODULE_3__util_api__["a" /* BACKEND_URL */]+'/api/customer/download-images?customerId=';var getDownloadUrlWith=function getDownloadUrlWith(customerId){return DOWNLOAD_URL+customerId;};var DownloadImages=function DownloadImages(_ref){var customerId=_ref.customerId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:getDownloadUrlWith(customerId)},"download")));};/* harmony default export */ __webpack_exports__["a"] = (DownloadImages);

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PreCheckinPhoto_PreCheckinPhotoContainer__ = __webpack_require__(1575);
var PreCheckinPhotoList=function PreCheckinPhotoList(_ref){var setImageTypeMetaData=_ref.setImageTypeMetaData,imageVersionList=_ref.imageVersionList,uploadCustomerImage=_ref.uploadCustomerImage,rotateCustomerImage=_ref.rotateCustomerImage,customerId=_ref.customerId,_ref$skipImages=_ref.skipImages,skipImages=_ref$skipImages===undefined?[]:_ref$skipImages;return __WEBPACK_IMPORTED_MODULE_4__state_detail_const__["b" /* DEFINED_PRE_CHECKIN_IMAGE_LIST */].filter(function(image){return!skipImages.includes(image.name);}).map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PreCheckinPhoto_PreCheckinPhotoContainer__["a" /* default */],{key:index,preCheckinPhotoIndex:index,image:image,customerId:customerId,setImageTypeMetaData:setImageTypeMetaData,rotateCustomerImage:rotateCustomerImage,uploadCustomerImage:uploadCustomerImage,imageVersionList:imageVersionList[image.name]});});};PreCheckinPhotoList.propTypes={customerId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,findImageVersion:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,skipImages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_4__state_detail_const__["b" /* DEFINED_PRE_CHECKIN_IMAGE_LIST */].map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["h" /* prop */])('name'))))};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findImageVersion(this.props.customerId);}})(PreCheckinPhotoList));

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_task_widget_selector__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_image_action__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_task_widget_action__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PreCheckinPhoto__ = __webpack_require__(1576);
var mapStateToProps=function mapStateToProps(state,props){return{customerId:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["g" /* selectCustomerId */](state),selectedImageVersions:__WEBPACK_IMPORTED_MODULE_2__state_task_widget_selector__["a" /* selectSelectedImageVersions */](state)};};var mapDispatchToProps={uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_3__state_image_action__["m" /* uploadCustomerImage */],rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_3__state_image_action__["g" /* rotateCustomerImage */],setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_3__state_image_action__["i" /* setImageTypeMetaData */],setSelectedImageVersions:__WEBPACK_IMPORTED_MODULE_4__state_task_widget_action__["b" /* setSelectedImageVersions */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__PreCheckinPhoto__["a" /* default */]));

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_const__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageVersionGallery__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown_DropdownContainer__ = __webpack_require__(1580);
var style={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'60px'};var findStartIndex=function findStartIndex(imageVersionList,selectedImageVersions,preCheckinPhotoIndex){var startIndex=imageVersionList!==undefined?imageVersionList.length-1:null;if(selectedImageVersions!==null){selectedImageVersions.find(function(selectedImageVersion){if(selectedImageVersion.preCheckinPhotoIndex===preCheckinPhotoIndex){startIndex=selectedImageVersion.imageVersionIndexInGallery;return true;}return false;});}return startIndex;};var PreCheckinPhoto=function PreCheckinPhoto(_ref){var image=_ref.image,imageVersionList=_ref.imageVersionList,customerId=_ref.customerId,uploadCustomerImage=_ref.uploadCustomerImage,rotateCustomerImage=_ref.rotateCustomerImage,setImageTypeMetaData=_ref.setImageTypeMetaData,setSelectedImageVersions=_ref.setSelectedImageVersions,selectedImageVersions=_ref.selectedImageVersions,preCheckinPhotoIndex=_ref.preCheckinPhotoIndex;var handleOnSlide=function handleOnSlide(index){setSelectedImageVersions(preCheckinPhotoIndex,index);};var startIndex=findStartIndex(imageVersionList,selectedImageVersions,preCheckinPhotoIndex);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],{top:"M",className:"pre-checkin-photo-row"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:8},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h2",null,image.title),imageVersionList?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ImageVersionGallery__["a" /* default */],{image:image,imageVersionList:imageVersionList,customerId:customerId,setImageTypeMetaData:setImageTypeMetaData,rotateCustomerImage:rotateCustomerImage,handleOnSlide:handleOnSlide,startIndex:startIndex}):""),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_dropzone__["a" /* default */],{multiple:false,accept:"image/*",maxSize:__WEBPACK_IMPORTED_MODULE_3__state_detail_const__["d" /* MAX_IMAGE_SIZE */],style:style,disablePreview:true,onDrop:function onDrop(fileList){uploadCustomerImage(fileList,image.name,customerId);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",null,"Click to upload a picture")),imageVersionList!==undefined&&imageVersionList!==null?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Dropdown_DropdownContainer__["a" /* default */],{preCheckinPhotoIndex:preCheckinPhotoIndex,startIndex:startIndex,imageVersionList:imageVersionList}):""));};PreCheckinPhoto.propTypes={image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,imageVersionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),customerId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uploadCustomerImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setSelectedImageVersions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selectedImageVersions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,preCheckinPhotoIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (PreCheckinPhoto);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery_styles_css_image_gallery_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery_styles_css_image_gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery_styles_css_image_gallery_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_gallery__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__renderer_renderImageArea__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__renderer_renderThumbnail__ = __webpack_require__(1579);
var _this=this;var moment=__webpack_require__(38);var compareImageVersion=function compareImageVersion(a,b){a=a.lastModified;b=b.lastModified;if(!a&&!b){return 0;}if(!a&&b){return-1;}if(a&&!b){return 1;}return moment(a).unix()-moment(b).unix();};var ImageVersionGallery=function ImageVersionGallery(_ref){var imageVersionList=_ref.imageVersionList,rotateCustomerImage=_ref.rotateCustomerImage,image=_ref.image,setImageTypeMetaData=_ref.setImageTypeMetaData,customerId=_ref.customerId,handleOnSlide=_ref.handleOnSlide,startIndex=_ref.startIndex;imageVersionList.sort(compareImageVersion);var imageList=imageVersionList.map(function(version){return{path:version.path,original:__WEBPACK_IMPORTED_MODULE_4__util_api__["a" /* BACKEND_URL */]+version.link,thumbnail:__WEBPACK_IMPORTED_MODULE_4__util_api__["a" /* BACKEND_URL */]+version.link,lastModified:Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(version.lastModified),fileName:image.name,versionId:version.versionId,rotate:version.meta&&version.meta.rotate?version.meta.rotate:0,originalImageType:version.originalImageType,image:image,rotateCustomerImage:rotateCustomerImage,setImageTypeMetaData:setImageTypeMetaData,customerId:customerId};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_gallery___default.a,{startIndex:startIndex,renderItem:__WEBPACK_IMPORTED_MODULE_6__renderer_renderImageArea__["a" /* default */],infinite:false,items:imageList,renderThumbInner:__WEBPACK_IMPORTED_MODULE_7__renderer_renderThumbnail__["a" /* default */],onSlide:handleOnSlide.bind(_this)});};ImageVersionGallery.propTypes={imageVersionList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),rotateCustomerImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,setImageTypeMetaData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,customerId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,handleOnSlide:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,startIndex:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ImageVersionGallery);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_const__ = __webpack_require__(40);
var ROTATE_CSS_CLASS_NAMES={0:'rotate-0',90:'rotate-90',180:'rotate-180',270:'rotate-270'};var IMAGE_STYLE={maxHeight:'600px',maxWidth:'100%',position:'absolute',width:'auto',margin:'auto',top:'0',bottom:'0',right:'0',left:'0'};var IMAGE_DIV_STYLE={display:'flex',flexDirection:'column',justifyContent:'center',position:'relative',overflow:'hidden',textAlign:'center',height:'600px'};var TYPE_SELECT_STYLE={height:'18px'};var renderLastModified=function renderLastModified(lastModified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-block vertical-align-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"badge"},lastModified));};var renderChangePreCheckinPhotoSelect=function renderChangePreCheckinPhotoSelect(customerId,setImageTypeMetaData,fileName,image,path,originalImageType,versionId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-block vertical-align-top image-slide-select"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__form_component_Select__["a" /* default */],{object:{},name:"name",addEmpty:true,style:TYPE_SELECT_STYLE,valueList:__WEBPACK_IMPORTED_MODULE_2__state_detail_const__["e" /* PRE_CHECKIN_IMAGE_TYPE_SELECT */],onChange:function onChange(name,newImageType){if(!newImageType||newImageType===image.name){return;}setImageTypeMetaData(customerId,originalImageType,versionId,path,newImageType);}}));};var renderRotateButtons=function renderRotateButtons(rotateCustomerImage,originalImageType,versionId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inline-block vertical-align-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"customer-image-rotate-icon fa fa-rotate-left",onClick:function onClick(event){event.stopPropagation();event.preventDefault();rotateCustomerImage(originalImageType,versionId,-90);}}),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"customer-image-rotate-icon fa fa-rotate-right",onClick:function onClick(event){event.stopPropagation();event.preventDefault();rotateCustomerImage(originalImageType,versionId,90);}}));};var renderImageToolbox=function renderImageToolbox(rotateCustomerImage,customerId,setImageTypeMetaData,lastModified,fileName,versionId,originalImageType,original,rotate,image,path){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"image-slider-header"},renderLastModified(lastModified),renderChangePreCheckinPhotoSelect(customerId,setImageTypeMetaData,fileName,image,path,originalImageType,versionId),renderRotateButtons(rotateCustomerImage,originalImageType,versionId));};var renderImage=function renderImage(rotate,original){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:IMAGE_DIV_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:IMAGE_STYLE,className:ROTATE_CSS_CLASS_NAMES[rotate],src:original,alt:""}));};var renderImageArea=function renderImageArea(_ref){var rotateCustomerImage=_ref.rotateCustomerImage,customerId=_ref.customerId,setImageTypeMetaData=_ref.setImageTypeMetaData,lastModified=_ref.lastModified,fileName=_ref.fileName,versionId=_ref.versionId,originalImageType=_ref.originalImageType,original=_ref.original,rotate=_ref.rotate,image=_ref.image,path=_ref.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,renderImageToolbox(rotateCustomerImage,customerId,setImageTypeMetaData,lastModified,fileName,versionId,originalImageType,original,rotate,image,path),renderImage(rotate,original));};/* harmony default export */ __webpack_exports__["a"] = (renderImageArea);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ROTATE_CSS={0:'rotate-0',90:'rotate-90',180:'rotate-180',270:'rotate-270'};var renderThumbnail=function renderThumbnail(_ref){var original=_ref.original,rotate=_ref.rotate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflow:'hidden',display:'flex',justifyContent:'center',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:ROTATE_CSS[rotate],src:original,alt:''}));};/* harmony default export */ __webpack_exports__["a"] = (renderThumbnail);

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_task_widget_selector__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_task_widget_action__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(1581);
var mapStateToProps=function mapStateToProps(state,props){return{selectedImageVersions:__WEBPACK_IMPORTED_MODULE_1__state_task_widget_selector__["a" /* selectSelectedImageVersions */](state,props.preCheckinPhotoIndex)};};var mapDispatchToProps={setPhotoRejectionReason:__WEBPACK_IMPORTED_MODULE_2__state_task_widget_action__["a" /* setPhotoRejectionReason */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */]));

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_task_widget_const__ = __webpack_require__(156);
var reasonsDropdownStyle={height:"28px"};var getLatestImageVersion=function getLatestImageVersion(imageVersionList){return imageVersionList.length!==0?imageVersionList[imageVersionList.length-1]:null;};var getValues=function getValues(){return __WEBPACK_IMPORTED_MODULE_3__state_task_widget_const__["a" /* PHOTO_REJECTION_REASONS */].map(function(image){return{id:image.name,value:image.title};});};var findSelectedImageVersion=function findSelectedImageVersion(selectedImageVersions,preCheckinPhotoIndex,imageVersionList){var result=null;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=selectedImageVersions[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var selectedImageVersion=_step.value;if(selectedImageVersion.preCheckinPhotoIndex===preCheckinPhotoIndex&&imageVersionList!==undefined){result={enabled:imageVersionList.length-1===selectedImageVersion.imageVersionIndexInGallery,imageVersion:imageVersionList[selectedImageVersion.imageVersionIndexInGallery]};break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(result===null){result={enabled:true,imageVersion:getLatestImageVersion(imageVersionList)};}return result;};var Dropdown=function Dropdown(_ref){var setPhotoRejectionReason=_ref.setPhotoRejectionReason,selectedImageVersions=_ref.selectedImageVersions,preCheckinPhotoIndex=_ref.preCheckinPhotoIndex,imageVersionList=_ref.imageVersionList;var _findSelectedImageVer=findSelectedImageVersion(selectedImageVersions,preCheckinPhotoIndex,imageVersionList),enabled=_findSelectedImageVer.enabled,imageVersion=_findSelectedImageVer.imageVersion;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Photo issue"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Select__["a" /* default */],{readOnly:!enabled,style:reasonsDropdownStyle,object:{},name:"name",addEmpty:true,valueList:getValues(),defaultValue:imageVersion&&imageVersion.meta!==null?imageVersion.meta.reason:"",onChange:function onChange(name,newPhotoNeededReason){setPhotoRejectionReason(imageVersion,newPhotoNeededReason);}}));};Dropdown.propTypes={setPhotoRejectionReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selectedImageVersions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,preCheckinPhotoIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,imageVersionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])};/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectCustomer */](state),fetching:__WEBPACK_IMPORTED_MODULE_4__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_6__state_const__["f" /* FILE_TYPE_IMPLANT_TREATMENT_PLAN */]),fileType:__WEBPACK_IMPORTED_MODULE_6__state_const__["f" /* FILE_TYPE_IMPLANT_TREATMENT_PLAN */],widgetId:__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["y" /* IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlignerCustomerCommunicationCommentWidget__ = __webpack_require__(1584);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["c" /* selectCustomer */](state)};};var mapDispatchToProps={saveTreatmentExecutionClarificationComment:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["y" /* saveTreatmentExecutionClarificationComment */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AlignerCustomerCommunicationCommentWidget__["a" /* default */]));

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Select__ = __webpack_require__(16);
var CC_REASONS=[{id:'notGoOnBJ',value:'NOT GO ON & REFINEMENT both jaws - Not tracking well, customer service will call you'},{id:'notGoOnUJ',value:'NOT GO ON & REFINEMENT UJ - Not tracking well, customer service will call you'},{id:'notGoOnLJ',value:'NOT GO ON & REFINEMENT LJ - Not tracking well, customer service will call you'},{id:'notGoOnGeneral',value:'NOT GO ON & General Problem (no refinement, don\'t change aligners, please SPECIFY IN COMMENT)'},{id:'badFeedbackScore',value:'Bad Feedback Score - Contact patient'}];var AlignerCustomerCommunicationCommentWidget=function AlignerCustomerCommunicationCommentWidget(_ref){var customer=_ref.customer,saveTreatmentExecutionClarificationComment=_ref.saveTreatmentExecutionClarificationComment,changeTreatmentExecutionList=_ref.changeTreatmentExecutionList;var treatmentExecutionList=customer.treatmentExecutionList;if(treatmentExecutionList.length===0){return null;}var alignerCheckins=treatmentExecutionList[treatmentExecutionList.length-1].alignerCheckInList;var clarificationComment=alignerCheckins[alignerCheckins.length-1].clarificationComment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Choose reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Select__["a" /* default */],{object:{clarificationComment:clarificationComment},name:'clarificationComment',valueList:CC_REASONS,addEmpty:true,onChange:function onChange(name,value){saveTreatmentExecutionClarificationComment(value);}}));};AlignerCustomerCommunicationCommentWidget.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,saveTreatmentExecutionClarificationComment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AlignerCustomerCommunicationCommentWidget);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlignerSendRecommendationWidget__ = __webpack_require__(1586);
var mapStateToProps=function mapStateToProps(state,props){return{customer:__WEBPACK_IMPORTED_MODULE_1__state_detail_selector__["c" /* selectCustomer */](state)};};var mapDispatchToProps={saveTreatmentExecutionClarificationComment:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["y" /* saveTreatmentExecutionClarificationComment */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AlignerSendRecommendationWidget__["a" /* default */]));

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_Select__ = __webpack_require__(16);
var RECOMMENDATIONS=[{id:'goOnNextAligners',value:'GO ON - Next aligners despite slight displacement'},{id:'goOnUseChewies',value:'GO ON & RECOMMENDATION - Use Chewies'},{id:'goOnUseChewiesOnTeeth',value:'GO ON & RECOMMENDATION - Use Chewies on teeth with displacement'},{id:'goOnIncreaseAndUseChewies',value:'GO ON & RECOMMENDATION - Increase wearing duration per day and use Chewies'},{id:'goOnIncrease',value:'GO ON & RECOMMENDATION - Increase wearing duration per day'},{id:'goOnPZR',value:'GO ON & RECOMMENDATION - PZR needed'}];var AlignerSendRecommendationWidget=function AlignerSendRecommendationWidget(_ref){var customer=_ref.customer,saveTreatmentExecutionClarificationComment=_ref.saveTreatmentExecutionClarificationComment;var treatmentExecutionList=customer.treatmentExecutionList;if(treatmentExecutionList.length===0){return null;}var alignerCheckins=treatmentExecutionList[treatmentExecutionList.length-1].alignerCheckInList;alignerCheckins.sort(function(a,b){return new Date(a.checkinDate)-new Date(b.checkinDate);});var clarificationComment=alignerCheckins[alignerCheckins.length-1].clarificationComment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Choose recommendation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_Select__["a" /* default */],{object:{clarificationComment:clarificationComment},name:'clarificationComment',valueList:RECOMMENDATIONS,addEmpty:true,onChange:function onChange(name,value){saveTreatmentExecutionClarificationComment(value);}}));};AlignerSendRecommendationWidget.propTypes={customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,saveTreatmentExecutionClarificationComment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AlignerSendRecommendationWidget);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_action__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_selector__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RefinementReasonWidget__ = __webpack_require__(1589);
var mapStateToProps=function mapStateToProps(state){return{refinementReason:__WEBPACK_IMPORTED_MODULE_2__state_selector__["b" /* selectRefinementReason */](state)};};var mapDispatchToProps={changeRefinementReason:__WEBPACK_IMPORTED_MODULE_1__state_action__["a" /* changeRefinementReason */],saveRefinementReason:__WEBPACK_IMPORTED_MODULE_1__state_action__["c" /* saveRefinementReason */],getRefinementReason:__WEBPACK_IMPORTED_MODULE_1__state_action__["b" /* getRefinementReason */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__RefinementReasonWidget__["a" /* default */]));

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeRefinementReason; });
/* unused harmony export getRefinementReasonRequest */
/* unused harmony export getRefinementReasonSuccess */
/* unused harmony export getRefinementReasonError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRefinementReason; });
/* unused harmony export saveRefinementReasonRequest */
/* unused harmony export saveRefinementReasonSuccess */
/* unused harmony export saveRefinementReasonError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveRefinementReason; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_ui_definition_sales_order_in_shop_scan_task_name__ = __webpack_require__(35);
var changeRefinementReason=function changeRefinementReason(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_REFINEMENT_REASON */],payload:{refinementReason:value}};};var getRefinementReasonRequest=function getRefinementReasonRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* GET_REFINEMENT_REASON_REQUEST */]};};var getRefinementReasonSuccess=function getRefinementReasonSuccess(refinementReason){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_REFINEMENT_REASON_SUCCESS */],payload:{refinementReason:refinementReason}};};var getRefinementReasonError=function getRefinementReasonError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_REFINEMENT_REASON_ERROR */],payload:{error:error}};};var getRefinementReason=function getRefinementReason(task){return function(dispatch,getState){dispatch(getRefinementReasonRequest());var state=getState();var salesOrder=__WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__["f" /* selectSalesOrder */](state);var customerId=__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["g" /* selectCustomerId */](state);var url='';var body={};if(task===__WEBPACK_IMPORTED_MODULE_5__process_ui_definition_sales_order_in_shop_scan_task_name__["q" /* SELECT_REFINEMENT_TYPE */]){url='/api/refinement/get-reason-by-sales-order-id';body={salesOrderId:salesOrder.id};}else{url='/api/refinement/get-reason-by-customer-id';body={customerId:customerId};}Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])(url,body).then(function(_ref){var refinementReason=_ref.refinementReason;dispatch(getRefinementReasonSuccess(refinementReason));}).catch(function(error){dispatch(getRefinementReasonError(error));});};};var saveRefinementReasonRequest=function saveRefinementReasonRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_REFINEMENT_REASON_REQUEST */]};};var saveRefinementReasonSuccess=function saveRefinementReasonSuccess(refinementReason){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_REFINEMENT_REASON_SUCCESS */],payload:{refinementReason:refinementReason}};};var saveRefinementReasonError=function saveRefinementReasonError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_REFINEMENT_REASON_ERROR */],payload:{error:error}};};var saveRefinementReason=function saveRefinementReason(){return function(dispatch,getState){var state=getState();var hasChanged=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectHasChanged */](state);if(!hasChanged){return;}var salesOrder=__WEBPACK_IMPORTED_MODULE_3__sales_order_state_detail_selector__["f" /* selectSalesOrder */](state);var customerId=__WEBPACK_IMPORTED_MODULE_4__customer_state_detail_selector__["g" /* selectCustomerId */](state);var refinementReason=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectRefinementReason */](state);dispatch(saveRefinementReasonRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/refinement/save',{customerId:customerId,refinementReason:refinementReason,salesOrderId:salesOrder.id}).then(function(refinementReason){dispatch(saveRefinementReasonSuccess(refinementReason));}).catch(function(error){dispatch(saveRefinementReasonError(error));});};};

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
var RefinementReason=function RefinementReason(_ref){var refinementReason=_ref.refinementReason,changeRefinementReason=_ref.changeRefinementReason,saveRefinementReason=_ref.saveRefinementReason,readOnly=_ref.readOnly;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["X" /* REFINEMENT_REASON_WIDGET */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Refinement Reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_component_TextArea__["a" /* default */],{name:'refinementReason',object:{refinementReason:refinementReason},onChange:changeRefinementReason,placeholder:'Enter reason. Click button below to submit.',readOnly:readOnly}),!readOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!refinementReason,onClick:saveRefinementReason,hidden:readOnly},'Save Reason')));};RefinementReason.propTypes={changeRefinementReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getRefinementReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,refinementReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,saveRefinementReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.getRefinementReason(this.props.taskName);}})(RefinementReason));

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_action__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_selector__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LowNpsReasonWidget__ = __webpack_require__(1592);
var mapStateToProps=function mapStateToProps(state,props){return{lowNpsReasonList:__WEBPACK_IMPORTED_MODULE_2__state_selector__["b" /* selectLowNpsReasonList */](state),taskName:props.taskName,feedbackCreated:__WEBPACK_IMPORTED_MODULE_2__state_selector__["a" /* selectCreated */](state),feedbackScore:__WEBPACK_IMPORTED_MODULE_2__state_selector__["c" /* selectScore */](state)};};var mapDispatchToProps={toggleLowNpsReason:__WEBPACK_IMPORTED_MODULE_1__state_action__["c" /* toggleLowNpsReason */],saveLowNpsReason:__WEBPACK_IMPORTED_MODULE_1__state_action__["b" /* saveLowNpsReason */],getFeedback:__WEBPACK_IMPORTED_MODULE_1__state_action__["a" /* getFeedback */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__LowNpsReasonWidget__["a" /* default */]));

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFeedbackRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleLowNpsReason; });
/* unused harmony export saveLowNpsReasonRequest */
/* unused harmony export saveLowNpsReasonSuccess */
/* unused harmony export saveLowNpsReasonError */
/* unused harmony export getFeedbackDetailsSuccess */
/* unused harmony export getFeedbackDetailsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveLowNpsReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFeedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__ = __webpack_require__(9);
var getFeedbackRequest=function getFeedbackRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* GET_FEEDBACK_REQUEST */]};};var toggleLowNpsReason=function toggleLowNpsReason(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* TOGGLE_LOW_NPS_REASON */],payload:{name:name,value:value}};};var saveLowNpsReasonRequest=function saveLowNpsReasonRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_LOW_NPS_REASON_REQUEST */]};};var saveLowNpsReasonSuccess=function saveLowNpsReasonSuccess(feedback){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_LOW_NPS_REASON_SUCCESS */],payload:{feedback:feedback}};};var saveLowNpsReasonError=function saveLowNpsReasonError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* SAVE_LOW_NPS_REASON_ERROR */],payload:{error:error}};};var getFeedbackDetailsSuccess=function getFeedbackDetailsSuccess(feedback){var created=feedback.created,lowScoreReason=feedback.lowScoreReason,score=feedback.score;return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* GET_FEEDBACK_DETAILS_SUCCESS */],payload:{feedbackCreated:created,lowScoreReason:lowScoreReason,feedbackScore:score}};};var getFeedbackDetailsError=function getFeedbackDetailsError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* GET_FEEDBACK_DETAILS_ERROR */],payload:{error:error}};};var saveLowNpsReason=function saveLowNpsReason(){return function(dispatch,getState){var state=getState();var feedbackId=__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["k" /* selectProcessContext */](state).feedbackId;dispatch(saveLowNpsReasonRequest());var request={feedbackId:feedbackId,lowNpsReasonList:__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectLowNpsReasonList */](state)};Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/promoter/feedback/reason',request).then(function(feedback){dispatch(saveLowNpsReasonSuccess(feedback));}).catch(function(error){dispatch(saveLowNpsReasonError(error));});};};var getFeedback=function getFeedback(){return function(dispatch,getState){var state=getState();var feedbackId=__WEBPACK_IMPORTED_MODULE_3__process_state_instance_detail_selector__["k" /* selectProcessContext */](state).feedbackId;dispatch(getFeedbackRequest());return Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/promoter/feedback/find-by-id',{feedbackId:feedbackId}).then(function(feedback){dispatch(getFeedbackDetailsSuccess(feedback));}).catch(function(error){dispatch(getFeedbackDetailsError(error));});};};

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var LOW_NPS_REASON_LIST=[{id:'aligner_fit',value:'Aligner fit'},{id:'aligner_quality',value:'Aligner quality'},{id:'photo_check_up',value:'Photo check up'},{id:'treatment_progress_in_general',value:'Treatment progress in general'},{id:'treatment_result',value:'Treatment result'},{id:'refinement_not_granted',value:'Refinement not granted'},{id:'response_time',value:'Response time'},{id:'response_quality',value:'Response quality'},{id:'app_usability',value:'APP Usability'},{id:'general_support',value:'General support (e.g. no physical contact)'},{id:'other_medical_issues',value:'Other medical issues'},{id:'delivery_issues',value:'Delivery issues'},{id:'unknown',value:'unknown'},{id:'others',value:'others'}];var LowNpsReasonWidget=function LowNpsReasonWidget(_ref){var lowNpsReasonList=_ref.lowNpsReasonList,toggleLowNpsReason=_ref.toggleLowNpsReason,saveLowNpsReason=_ref.saveLowNpsReason,feedbackCreated=_ref.feedbackCreated,feedbackScore=_ref.feedbackScore;if(!Object(__WEBPACK_IMPORTED_MODULE_5__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__process_ui_definition_process_ui__["F" /* LOW_NPS_REASON_WIDGET_CONTAINER */])){return null;}if(!feedbackCreated){return null;}var createdParsed=feedbackCreated?__WEBPACK_IMPORTED_MODULE_9_moment___default()(feedbackCreated).format('DD.MM.YYYY, HH:mm'):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Low NPS reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Feedback created:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,createdParsed))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Feedback score:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedbackScore)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LOW_NPS_REASON_LIST.map(function(reason){var isLowNpsReason=reason.id?lowNpsReasonList.includes(reason.id):false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Checkbox__["a" /* default */],{key:reason.id,object:{lowNpsReason:isLowNpsReason},onChange:function onChange(){toggleLowNpsReason(reason.id,!isLowNpsReason);saveLowNpsReason();},name:'lowNpsReason'},reason.value);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};LowNpsReasonWidget.propTypes={lowNpsReasonList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,toggleLowNpsReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveLowNpsReason:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getFeedback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.getFeedback();}})(LowNpsReasonWidget));

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_action__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_selector__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PartialInvoiceCorrectionWidget__ = __webpack_require__(1595);
var mapStateToProps=function mapStateToProps(state,props){return{taskName:props.taskName,salesOrderList:__WEBPACK_IMPORTED_MODULE_2__state_selector__["d" /* selectSalesOrderPartialRefundList */](state),partialRefundData:__WEBPACK_IMPORTED_MODULE_2__state_selector__["c" /* selectPartialRefund */](state),fetching:__WEBPACK_IMPORTED_MODULE_2__state_selector__["a" /* selectFetching */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_2__state_selector__["e" /* selectValidationMessageList */](state)};};var mapDispatchToProps={getRefundableSalesOrderList:__WEBPACK_IMPORTED_MODULE_1__state_action__["c" /* getRefundableSalesOrderList */],getPartialRefundData:__WEBPACK_IMPORTED_MODULE_1__state_action__["b" /* getPartialRefundData */],changePartialRefundData:__WEBPACK_IMPORTED_MODULE_1__state_action__["a" /* changePartialRefundData */],savePartialRefundData:__WEBPACK_IMPORTED_MODULE_1__state_action__["d" /* savePartialRefundData */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__PartialInvoiceCorrectionWidget__["a" /* default */]));

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPartialRefundRequest */
/* unused harmony export getPartialRefundSuccess */
/* unused harmony export getPartialRefundError */
/* unused harmony export savePartialRefundRequest */
/* unused harmony export savePartialRefundSuccess */
/* unused harmony export savePartialRefundError */
/* unused harmony export getRefundableSalesOrderListRequest */
/* unused harmony export getRefundableSalesOrderListSuccess */
/* unused harmony export getRefundableSalesOrderListError */
/* unused harmony export addValidationMessage */
/* unused harmony export clearValidationMessageList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return savePartialRefundData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPartialRefundData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRefundableSalesOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePartialRefundData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__process_state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_money__ = __webpack_require__(86);
var getPartialRefundRequest=function getPartialRefundRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* GET_PARTIAL_REFUND_DATA_REQUEST */]};};var getPartialRefundSuccess=function getPartialRefundSuccess(partialRefundData){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* GET_PARTIAL_REFUND_DATA_SUCCESS */],payload:{partialRefundData:partialRefundData}};};var getPartialRefundError=function getPartialRefundError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* GET_PARTIAL_REFUND_DATA_ERROR */],payload:{error:error}};};var savePartialRefundRequest=function savePartialRefundRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* SAVE_PARTIAL_REFUND_DATA_REQUEST */]};};var savePartialRefundSuccess=function savePartialRefundSuccess(refund){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* SAVE_PARTIAL_REFUND_DATA_SUCCESS */],payload:{refund:refund}};};var savePartialRefundError=function savePartialRefundError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* SAVE_PARTIAL_REFUND_DATA_ERROR */],payload:{error:error}};};var getRefundableSalesOrderListRequest=function getRefundableSalesOrderListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST */]};};var getRefundableSalesOrderListSuccess=function getRefundableSalesOrderListSuccess(salesOrderList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS */],payload:{salesOrderList:salesOrderList}};};var getRefundableSalesOrderListError=function getRefundableSalesOrderListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* GET_REFUNDABLE_SALES_ORDER_LIST_ERROR */],payload:{error:error}};};var addValidationMessage=function addValidationMessage(message){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* ADD_VALIDATION_MESSAGE */],payload:{message:message}};};var clearValidationMessageList=function clearValidationMessageList(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CLEAR_VALIDATION_MESSAGE_LIST */]};};var savePartialRefundData=function savePartialRefundData(){return function(dispatch,getState){var state=getState();var params=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */](state).partialRefundData;var hasErrors=false;dispatch(clearValidationMessageList());//validation
if(params.salesOrderId===''||params.amount===''||params.reason===''){dispatch(addValidationMessage({messageId:1,message:'All fields are required.'}));hasErrors=true;}var salesOrderList=__WEBPACK_IMPORTED_MODULE_2__selector__["d" /* selectSalesOrderPartialRefundList */](state);var selectedSalesOrder=salesOrderList.find(function(salesOrder){return salesOrder.id===params.salesOrderId;});var salesOrderBrutPriceEur=(selectedSalesOrder.brutPrice/100).toFixed(2);var amountInCents=Object(__WEBPACK_IMPORTED_MODULE_5__util_money__["a" /* convertToCents */])(params.amount);if(selectedSalesOrder&&amountInCents>selectedSalesOrder.brutPrice){dispatch(addValidationMessage({messageId:2,message:'Correction Invoice Amount cannot be greater than the Sales Order brut price: '+salesOrderBrutPriceEur}));hasErrors=true;}else if(selectedSalesOrder&&amountInCents<0.01){dispatch(addValidationMessage({messageId:2,message:'Correction Invoice Amount cannot be less than 0.01'}));hasErrors=true;}if(hasErrors){return;}dispatch(savePartialRefundRequest());var processInstanceId=__WEBPACK_IMPORTED_MODULE_4__process_state_task_detail_selector__["k" /* selectProcessInstanceId */](state);Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/partial-refund/save',Object.assign({},params,{amount:amountInCents,processInstanceId:processInstanceId})).then(function(refund){dispatch(savePartialRefundSuccess(refund));}).catch(function(error){dispatch(savePartialRefundError(error));});};};var getPartialRefundData=function getPartialRefundData(){return function(dispatch,getState){var processInstanceId=__WEBPACK_IMPORTED_MODULE_4__process_state_task_detail_selector__["k" /* selectProcessInstanceId */](getState());dispatch(getPartialRefundRequest());return Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/partial-refund/find-by-process-instance-id?processInstanceId='+processInstanceId).then(function(partialRefundData){dispatch(getPartialRefundSuccess(Object.assign({},partialRefundData,{amount:partialRefundData.amount.toFixed(2)/100})));}).catch(function(error){dispatch(getPartialRefundError(error));});};};var getRefundableSalesOrderList=function getRefundableSalesOrderList(){return function(dispatch,getState){var customerId=Object(__WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__["g" /* selectCustomerId */])(getState());dispatch(getRefundableSalesOrderListRequest());return Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/partial-refund/find-refundable-by-customer-id?customerId='+customerId).then(function(salesOrderList){dispatch(getRefundableSalesOrderListSuccess(salesOrderList));}).catch(function(error){dispatch(getRefundableSalesOrderListError(error));});};};var changePartialRefundData=function changePartialRefundData(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_PARTIAL_REFUND_DATA */],payload:{name:name,value:value}};};

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validation_component_ValidationMessageList__ = __webpack_require__(34);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var PartialInvoiceCorrectionWidget=function PartialInvoiceCorrectionWidget(_ref){var salesOrderList=_ref.salesOrderList,changePartialRefundData=_ref.changePartialRefundData,partialRefundData=_ref.partialRefundData,savePartialRefundData=_ref.savePartialRefundData,fetching=_ref.fetching,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_12__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__process_ui_definition_process_ui__["L" /* PARTIAL_INVOICE_CORRECTION_CONTAINER */])){return null;}var selectedSalesOrder=salesOrderList.find(function(salesOrder){return salesOrder.id===partialRefundData.salesOrderId;});var salesOrderType=selectedSalesOrder?selectedSalesOrder.type:'';var salesOrderDropdown=[{id:'',value:'Select'}].concat(salesOrderList.map(function(salesOrder){return{id:salesOrder.id,value:salesOrder.referenceNumber};}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Partial Refund Information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Sales order reference'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:partialRefundData,name:'salesOrderId',valueList:salesOrderDropdown,onChange:changePartialRefundData}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{textTransform:"capitalize",margin:"20px 0 0 5px"}},salesOrderType))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Correction Invoice Amount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Input__["a" /* default */],{name:'amount',type:'number',object:partialRefundData,onChange:changePartialRefundData,pattern:'^(\\d+)(,\\d{1,2}|.\\d{1,2})?$',max:selectedSalesOrder?selectedSalesOrder.brutPrice.toFixed(2)/100:null}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{textTransform:"capitalize",margin:"20px 0 0 5px"}},selectedSalesOrder?selectedSalesOrder.currency:''))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Number of products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:partialRefundData,name:'numberOfProducts',valueList:[].concat(_toConsumableArray(Array(20).keys())).map(function(i){return{id:i+1,value:i+1};}),onChange:changePartialRefundData})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Reason for correction invoice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_TextArea__["a" /* default */],{name:'reason',object:partialRefundData,onChange:changePartialRefundData})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:savePartialRefundData},'Save information'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList})))));};PartialInvoiceCorrectionWidget.propTypes={salesOrderList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,partialRefundData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,changePartialRefundData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,savePartialRefundData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.getRefundableSalesOrderList();this.props.getPartialRefundData();}})(PartialInvoiceCorrectionWidget));

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_plan_selector__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan_TreatmentClassification__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_plan_action__ = __webpack_require__(97);
var mapStateToProps=function mapStateToProps(state,props){return{treatmentPlan:__WEBPACK_IMPORTED_MODULE_1__state_plan_selector__["g" /* selectTreatmentPlan */](state)};};var mapDispatchToProps={changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_3__state_plan_action__["f" /* changeTreatmentPlan */],saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_3__state_plan_action__["g" /* saveTreatmentPlan */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__plan_TreatmentClassification__["a" /* default */]));

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__process_ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__ = __webpack_require__(21);
var TREATMENT_TYPES=[{id:'noclassification',value:'No classification'},{id:'medical',value:'Medical'},{id:'nonmedical',value:'Non-Medical'}];var TREATMENT_REASONS=[{id:'',value:''},{id:'Anterior Crossbite',value:'Anterior Crossbite'},{id:'Crowding / > KIG 2',value:'Crowding / > KIG 2'},{id:'Increased overjet due to protruded anterior teeth',value:'Increased overjet due to protruded anterior teeth'},{id:'Crowding in combination with rotation',value:'Crowding in combination with rotation'},{id:'Labial or palatal tilting of teeth',value:'Labial or palatal tilting of teeth'},{id:'Premature contacts',value:'Premature contacts'},{id:'Diastema',value:'Diastema'},{id:'Pre-prosthetic orthodontic treatment',value:'Pre-prosthetic orthodontic treatment'}];var TreatmentClassification=function TreatmentClassification(_ref){var treatmentPlan=_ref.treatmentPlan,saveTreatmentPlan=_ref.saveTreatmentPlan,changeTreatmentPlan=_ref.changeTreatmentPlan,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_1__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__process_ui_definition_process_ui__["_11" /* TREATMENT_CLASSIFICATION_WIDGET_CONTAINER */])){return null;}var treatmentType=treatmentPlan.treatmentType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instructions w-treatment-duration"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:"Medical/Non Medical Treatment Classification"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],{className:"w-td-panel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__["a" /* default */],{label:"Treatment type"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:treatmentPlan,name:"treatmentType",valueList:TREATMENT_TYPES,onChange:function onChange(name,value){changeTreatmentPlan(name,value);saveTreatmentPlan();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:6},treatmentType==="medical"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_LabelInput__["a" /* default */],{label:"Treatment reason"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:treatmentPlan,name:"treatmentReason",valueList:TREATMENT_REASONS,onChange:function onChange(name,value){changeTreatmentPlan(name,value);saveTreatmentPlan();}})):""))));};TreatmentClassification.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (TreatmentClassification);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scan_file_upload_CustomerFileUpload__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_const__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_definition_customer_ui__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_detail_selector__ = __webpack_require__(13);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["b" /* selectOwnState */](state),{customer:__WEBPACK_IMPORTED_MODULE_7__state_detail_selector__["c" /* selectCustomer */](state),fetching:__WEBPACK_IMPORTED_MODULE_3__state_file_upload_selector__["a" /* selectIsFetching */](state,__WEBPACK_IMPORTED_MODULE_5__state_const__["l" /* FILE_TYPE_X_RAY */]),fileType:__WEBPACK_IMPORTED_MODULE_5__state_const__["l" /* FILE_TYPE_X_RAY */],widgetId:__WEBPACK_IMPORTED_MODULE_6__ui_definition_customer_ui__["e" /* CUSTOMER_XRAY_FILE_UPLOAD */]});};var mapDispatchToProps={uploadCustomerFile:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["c" /* uploadCustomerFile */],setDeleteFlag:__WEBPACK_IMPORTED_MODULE_1__state_file_upload_action__["a" /* setDeleteFlag */],onUploadSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* addCustomerFile */],onFileDeleteFlagSuccess:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["r" /* onFileDeleteFlagSuccess */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__scan_file_upload_CustomerFileUpload__["a" /* default */]));

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findWhatsappMessageList; });
/* unused harmony export findWhatsappDeliveredMessageListRequest */
/* unused harmony export findWhatsappDeliveredMessageListSuccess */
/* unused harmony export findWhatsappDeliveredMessageListError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(398);
var findWhatsappMessageList=function findWhatsappMessageList(processInstanceId){return function(dispatch){dispatch(findWhatsappDeliveredMessageListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/freshchat/get-whatsapp-delivered-messages?processInstanceId='+processInstanceId).then(function(whatsappMessageList){dispatch(findWhatsappDeliveredMessageListSuccess(whatsappMessageList));}).catch(function(error){dispatch(findWhatsappDeliveredMessageListError(error));});};};var findWhatsappDeliveredMessageListRequest=function findWhatsappDeliveredMessageListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST */]};};var findWhatsappDeliveredMessageListSuccess=function findWhatsappDeliveredMessageListSuccess(whatsappMessageList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS */],payload:{whatsappMessageList:whatsappMessageList}};};var findWhatsappDeliveredMessageListError=function findWhatsappDeliveredMessageListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR */],payload:{error:error}};};

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
var WhatsappMessages=function WhatsappMessages(_ref){var whatsappMessageList=_ref.whatsappMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_6__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_22" /* WHATSAPP_MESSAGES_WIDGET */])){return null;}var templateUrl="https://docs.google.com/spreadsheets/d/1EjBmFiai9LXxFILgMabRGa44Ht7fbt70kDJJIpi2be0/edit#gid=2128352820";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'WhatsApp Messages'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'40%'},'Template name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10%'},'Sent Date'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,whatsappMessageList.map(function(whatsappMessage,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,whatsappMessage.templateName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_datetime__["c" /* formatDateTime */])(whatsappMessage.sentAt)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:templateUrl},'Template content'))))))));};WhatsappMessages.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableQuery(this.props.processInstanceId);}})(WhatsappMessages));

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* unused harmony export selectIsFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectWhatsappMessageList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(257);
var selectOwnState=function selectOwnState(state){return state[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};var selectWhatsappMessageList=function selectWhatsappMessageList(state){return selectOwnState(state).whatsappMessageList;};

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestMedicalEvalWidget__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_instance_detail_action__ = __webpack_require__(51);
var mapStateToProps=function mapStateToProps(state,props){return{reasonMedicalEvalObject:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */](state)};};var mapDispatchToProps={changeProcessContext:__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_3__state_instance_detail_action__["j" /* saveProcessContext */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RequestMedicalEvalWidget__["a" /* default */]));

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validation_component_ValidationMessageList__ = __webpack_require__(34);
var MEDICAL_EVAL_REASON=[{id:'pa_needed',value:'PA treatment needed?'},{id:'caries',value:'Caries?'},{id:'xray_needed',value:'Xray/OPG needed?'},{id:'orthodontic',value:'Evaluate orthodontic treatability'},{id:'recessions',value:'Recessions?'},{id:'other',value:'Other'}];var reasonName='ReasonMedicalEval';var RequestMedicalEvalWidget=function RequestMedicalEvalWidget(_ref){var reasonMedicalEvalObject=_ref.reasonMedicalEvalObject,changeProcessContext=_ref.changeProcessContext,saveProcessContext=_ref.saveProcessContext,validationMessageList=_ref.validationMessageList;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ui_definition_process_ui__["Z" /* REQUEST_MEDICAL_EVALUATION */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Medical Evaluation Reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_LabelInput__["a" /* default */],{label:'Reason'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{name:reasonName,object:reasonMedicalEvalObject,valueList:MEDICAL_EVAL_REASON,addEmpty:true,readOnly:false,onChange:function onChange(name,value){changeProcessContext(name,value);saveProcessContext();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})));};RequestMedicalEvalWidget.propTypes={changeProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveProcessContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,reasonMedicalEvalObject:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RequestMedicalEvalWidget);

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_component_detail_ProcessInstanceList__ = __webpack_require__(503);
var mapStateToProps=function mapStateToProps(state,props){return{processInstanceList:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["m" /* selectProcessList */](state),customerId:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["g" /* selectCustomerId */](state)};};var mapDispatchToProps={findProcessComment:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["n" /* findProcessComment */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__customer_component_detail_ProcessInstanceList__["a" /* default */]));

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_SalesNotes__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PricesContext__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__ = __webpack_require__(2);
// import * as selector from "../treatment/state/quotation/selector";
// this container is for BC with Redux, to be removed later
var mapStateToProps=function mapStateToProps(state,props){var customer=__WEBPACK_IMPORTED_MODULE_6__customer_state_detail_selector__["c" /* selectCustomer */](state)||{};return{isReadOnly:props.readOnly,countryCode:customer.countryCode,customerId:customer.id,state:state};};var mapDispatchToProps={};var SalesNoteWidgetContainer=function SalesNoteWidgetContainer(_ref){var countryCode=_ref.countryCode,customerId=_ref.customerId,isReadOnly=_ref.isReadOnly,state=_ref.state;if(!customerId){return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_4__security_state_auth_const__["i" /* ROLE_CLINIC_SALES */],widgetName:__WEBPACK_IMPORTED_MODULE_7__process_ui_definition_process_ui__["_0" /* SALES_NOTE_WIDGET_CONTAINER */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PricesContext__["a" /* PricesProvider */],{countryCode:countryCode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_SalesNotes__["a" /* default */],{customerId:customerId,isReadOnly:isReadOnly,state:state})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(SalesNoteWidgetContainer));

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttachmentNeededWidget__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_action__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__treatment_state_plan_selector__ = __webpack_require__(33);
var mapStateToProps=function mapStateToProps(state,props){var customer=Object(__WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__["c" /* selectCustomer */])(state);return{readOnly:typeof props.readOnly==="boolean"?props.readOnly:Object(__WEBPACK_IMPORTED_MODULE_6__state_task_detail_selector__["f" /* selectIsTaskReadOnly */])(state),fetching:Object(__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__["c" /* selectIsFetching */])(state),isAttachmentProviderStore:Object(__WEBPACK_IMPORTED_MODULE_2__globals_state_selector__["isAttachmentProviderStore"])(state,customer.store),treatmentPlan:__WEBPACK_IMPORTED_MODULE_7__treatment_state_plan_selector__["g" /* selectTreatmentPlan */](state)};};var mapDispatchToProps={saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_action__["g" /* saveTreatmentPlan */],changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_4__treatment_state_plan_action__["f" /* changeTreatmentPlan */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AttachmentNeededWidget__["a" /* default */]));

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_spinners_BeatLoader__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_spinners_BeatLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_spinners_BeatLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_definition_process_ui__ = __webpack_require__(2);
var ATTACHMENT_VALUES=[{value:true,label:'Attachment Needed'},{value:false,label:'Attachment Not Needed'}];var WIDGET_TITLE='Attachment';var AttachmentNeededWidget=function AttachmentNeededWidget(_ref){var readOnly=_ref.readOnly,isAttachmentProviderStore=_ref.isAttachmentProviderStore,treatmentPlan=_ref.treatmentPlan,fetching=_ref.fetching,changeTreatmentPlan=_ref.changeTreatmentPlan,saveTreatmentPlan=_ref.saveTreatmentPlan;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__ui_definition_process_ui__["h" /* ATTACHMENT_NEEDED_WIDGET */])){return null;}// force readOnly to be true if clinic do not offer attachment
var internalReadOnly=isAttachmentProviderStore?readOnly:true;var changeFormData=function changeFormData(name,value){changeTreatmentPlan(name,value);saveTreatmentPlan();};// prevent crash during data loading
if(fetching&&!internalReadOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading... Please wait.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_spinners_BeatLoader___default.a,{loading:fetching}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},!isAttachmentProviderStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Clinic does not offer Attachment')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__["a" /* default */],{object:treatmentPlan,name:'attachmentNeeded',readOnly:internalReadOnly,addEmpty:true,valueList:ATTACHMENT_VALUES,onChange:changeFormData})))));};AttachmentNeededWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,treatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTreatmentPlan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isAttachmentProviderStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (AttachmentNeededWidget);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttachmentAgreementWidget__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__anamnesis_state_anamnesis_action__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_task_detail_selector__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__anamnesis_state_list_selector__ = __webpack_require__(193);
var mapStateToProps=function mapStateToProps(state,props){var customer=Object(__WEBPACK_IMPORTED_MODULE_3__customer_state_detail_selector__["c" /* selectCustomer */])(state);var readOnly=typeof props.readOnly==="boolean"?props.readOnly:Object(__WEBPACK_IMPORTED_MODULE_6__state_task_detail_selector__["f" /* selectIsTaskReadOnly */])(state);var anamnesis=readOnly?Object(__WEBPACK_IMPORTED_MODULE_7__anamnesis_state_list_selector__["b" /* selectLastMedicalAssessment */])(state):Object(__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__["d" /* selectMedicalAssessment */])(state);return{anamnesis:anamnesis,readOnly:readOnly,fetching:Object(__WEBPACK_IMPORTED_MODULE_5__anamnesis_state_anamnesis_selector__["c" /* selectIsFetching */])(state),isAttachmentProviderStore:Object(__WEBPACK_IMPORTED_MODULE_2__globals_state_selector__["isAttachmentProviderStore"])(state,customer.store)};};var mapDispatchToProps={changeAnamnesis:__WEBPACK_IMPORTED_MODULE_4__anamnesis_state_anamnesis_action__["a" /* changeAnamnesis */],saveAnamnesis:__WEBPACK_IMPORTED_MODULE_4__anamnesis_state_anamnesis_action__["c" /* saveAnamnesis */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AttachmentAgreementWidget__["a" /* default */]));

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__anamnesis_state_anamnesis_const__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader__);
var AGREEMENT_VALUES=[{value:true,label:'Yes, patient agrees to Attachment if needed'},{value:false,label:'No, patient does not agree to Attachment if needed'}];var WIDGET_TITLE='Attachment Patient Agreement';var AttachmentAgreementWidget=function AttachmentAgreementWidget(_ref){var readOnly=_ref.readOnly,isAttachmentProviderStore=_ref.isAttachmentProviderStore,anamnesis=_ref.anamnesis,fetching=_ref.fetching,changeAnamnesis=_ref.changeAnamnesis,saveAnamnesis=_ref.saveAnamnesis;if(!Object(__WEBPACK_IMPORTED_MODULE_7__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__ui_definition_process_ui__["g" /* ATTACHMENT_AGREEMENT_WIDGET */])||!anamnesis){return null;}// force readOnly to be true if clinic do not offer attachment
var internalReadOnly=isAttachmentProviderStore?readOnly:true;var changeFormData=function changeFormData(name,value){var payload=Object.assign({},anamnesis.formData,{attachmentAgreed:value});changeAnamnesis('formData',payload,__WEBPACK_IMPORTED_MODULE_9__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]);saveAnamnesis(__WEBPACK_IMPORTED_MODULE_9__anamnesis_state_anamnesis_const__["d" /* ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT */]);};// prevent crash during data loading
if(fetching&&!internalReadOnly){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading... Please wait.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_spinners_BeatLoader___default.a,{loading:fetching}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,anamnesis&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:WIDGET_TITLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},!isAttachmentProviderStore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Clinic does not offer Attachment')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_SelectChip__["a" /* default */],{object:anamnesis.formData,name:'attachmentAgreed',readOnly:internalReadOnly,addEmpty:true,valueList:AGREEMENT_VALUES,onChange:changeFormData}))))));};AttachmentAgreementWidget.propTypes={readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,anamnesis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeAnamnesis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveAnamnesis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isAttachmentProviderStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AttachmentAgreementWidget);

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_state_auth_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstanceDetail__ = __webpack_require__(1611);
var mapStateToProps=function mapStateToProps(state,props){return{processInstanceId:props.computedMatch.params.processInstanceId,masterId:props.computedMatch.params.masterId,masterObject:props.computedMatch.params.masterObject,processInstance:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["m" /* selectProcessInstance */](state),fetching:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["i" /* selectIsFetching */](state),processFlowVisible:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["l" /* selectProcessFlowVisible */](state),availableTransitionList:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["b" /* selectAvailableTransitionList */](state),processLogList:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["o" /* selectProcessLogList */](state),commentText:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["e" /* selectCommentText */](state),commentList:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["d" /* selectCommentList */](state),taskName:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["f" /* selectCurrentTaskName */](state),context:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["k" /* selectProcessContext */](state),availableStateList:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["a" /* selectAvailableStateList */](state),beamProcessState:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["c" /* selectBeamProcessState */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["t" /* selectValidationMessageList */](state),openTask:__WEBPACK_IMPORTED_MODULE_2__state_instance_detail_selector__["j" /* selectOpenTask */](state),isProductionAdmin:Object(__WEBPACK_IMPORTED_MODULE_3__security_state_auth_selector__["i" /* selectHasRole */])(state,__WEBPACK_IMPORTED_MODULE_4__security_state_auth_const__["H" /* ROLE_PRODUCTION_ADMIN */])};};var mapDispatchToProps={findProcessInstance:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["g" /* findProcessInstance */],findProcessInstanceByMasterId:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["h" /* findProcessInstanceByMasterId */],toggleProcessFlowVisibility:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["k" /* toggleProcessFlowVisibility */],toggleVIPStatus:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["m" /* toggleVIPStatus */],toggleRushStatus:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["l" /* toggleRushStatus */],changeProcessComment:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["c" /* changeProcessComment */],commentProcessInstance:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["f" /* commentProcessInstance */],changeProcessContext:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["d" /* changeProcessContext */],saveProcessContext:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["j" /* saveProcessContext */],changeBeamProcessState:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["b" /* changeBeamProcessState */],beamProcessInstance:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["a" /* beamProcessInstance */],changeTime:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["e" /* changeTime */],validateAndTriggerEvent:__WEBPACK_IMPORTED_MODULE_1__state_instance_detail_action__["n" /* validateAndTriggerEvent */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__InstanceDetail__["a" /* default */]));

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TaskList__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Overview__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommentList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StateTransitionLog__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TechnicalLog__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sales_order_component_task_widget_SalesOrderCustomerWidgetContainer__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sales_order_component_task_widget_SentEmailWidgetContainer__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sales_order_component_task_widget_InvoiceListWidgetContainer__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sales_order_component_task_widget_PaymentListWidgetContainer__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sales_order_component_task_widget_SalesOrderOverviewWidgetContainer__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sales_order_component_task_widget_InitialHesitationWidgetContainer__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_definition_ui_definition__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__name_component_mapping__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sales_order_component_task_widget_ImprintScanStatusWidget__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sales_order_component_task_widget_VoucherWidgetContainer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__whatsapp_messages_component_WhatsappMessagesWidgetContainer__ = __webpack_require__(576);
var ComponentWidgetList=function ComponentWidgetList(props){var definition=props.definition;var widgetList=definition.widgetList;if(!widgetList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,widgetList.map(function(widget,index){var component=widget.component,_widget$widgetProps=widget.widgetProps,widgetProps=_widget$widgetProps===undefined?{}:_widget$widgetProps;var Component=__WEBPACK_IMPORTED_MODULE_16__name_component_mapping__["a" /* NAME_COMPONENT_MAPPING */][component];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({key:index,readOnly:false},widgetProps,props));}));};var SalesOrderProcess=function SalesOrderProcess(props){var processNames=['salesorder-shop-scan','salesorder-shop-scan-new','salesorder-treatment','salesorder-refinement-production','salesorder-check-in'];var processInstance=props.processInstance,fetching=props.fetching;var definition=Object(__WEBPACK_IMPORTED_MODULE_15__ui_definition_ui_definition__["a" /* getUIDefinitionByStateName */])(processInstance.currentStateName);var isSetOrShopScanProcess=processInstance.processName==='salesorder-shop-scan'||processInstance.processName==='salesorder-shop-scan-new'||processInstance.processName==='salesorder-set';var isWhatsappWidgetVisible=processNames.includes(processInstance.processName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Overview__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__sales_order_component_task_widget_SalesOrderOverviewWidgetContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentWidgetList,Object.assign({definition:definition},props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CommentList__["b" /* default */],props),isSetOrShopScanProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__sales_order_component_task_widget_InitialHesitationWidgetContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__sales_order_component_task_widget_SalesOrderCustomerWidgetContainer__["a" /* default */],null),isSetOrShopScanProcess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__sales_order_component_task_widget_VoucherWidgetContainer__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__sales_order_component_task_widget_SentEmailWidgetContainer__["a" /* default */],null),isWhatsappWidgetVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__whatsapp_messages_component_WhatsappMessagesWidgetContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__sales_order_component_task_widget_InvoiceListWidgetContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__sales_order_component_task_widget_PaymentListWidgetContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaskList__["a" /* default */],{processTaskList:processInstance.processTaskList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StateTransitionLog__["a" /* default */],Object.assign({},props,{processStateHistoryList:processInstance.processStateHistoryList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__sales_order_component_task_widget_ImprintScanStatusWidget__["a" /* default */],{context:processInstance.context,readOnly:true,changeProcessContext:function changeProcessContext(){},saveProcessContext:function saveProcessContext(){},salesOrder:processInstance.objectDetail,validationMessageList:[]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TechnicalLog__["a" /* default */],Object.assign({},props,{processLogList:processInstance.processLogList})));};var InstanceDetail=function InstanceDetail(props){var processInstance=props.processInstance;if(!processInstance){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesOrderProcess,props);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){if(this.props.processInstanceId){this.props.findProcessInstance(this.props.processInstanceId);}if(this.props.masterObject&&this.props.masterId){this.props.findProcessInstanceByMasterId(this.props.masterObject,this.props.masterId);}}})(Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(InstanceDetail)));

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_definition_process_ui__ = __webpack_require__(2);
var TaskList=function TaskList(_ref){var processTaskList=_ref.processTaskList;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__ui_definition_process_ui__["U" /* PROCESS_TASK_LIST */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Task list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Due'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Closed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Role'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Finished by'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processTaskList.map(function(task){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:task.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/task/detail/'+task.id},Object(__WEBPACK_IMPORTED_MODULE_7__util_names__["g" /* renderTaskName */])(task.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__util_datetime__["c" /* formatDateTime */])(task.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__util_datetime__["c" /* formatDateTime */])(task.due)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__util_datetime__["c" /* formatDateTime */])(task.finished)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,task.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__util_names__["e" /* renderRoleName */])(task.role)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,task.finishedByUserName));}))))));};TaskList.propTypes={processTaskList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TaskList);

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBoxWithoutHeader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_RushIcon__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_ToggleButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_component_DatePicker__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BeamProcessInstance__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_component_ContentBoxHeader__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_component_ContentBoxBody__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_widget_helper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_definition_process_ui__ = __webpack_require__(2);
var PROCESS_FLOW_URL=__WEBPACK_IMPORTED_MODULE_4__util_api__["a" /* BACKEND_URL */]+'/process/instance/view-flow?processInstanceId=';var FRAME_STYLE={border:0,width:'100%',height:'600px'};var ToggleProcessFlowButton=function ToggleProcessFlowButton(_ref){var toggleProcessFlowVisibility=_ref.toggleProcessFlowVisibility,processFlowVisible=_ref.processFlowVisible;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_ToggleButton__["a" /* default */],{toggle:toggleProcessFlowVisibility,active:processFlowVisible,activeIcon:'fa fa-search-minus',inactiveIcon:'fa fa-search-plus'}),'\xA0');};var TransitionList=function TransitionList(_ref2){var openTask=_ref2.openTask,availableTransitionList=_ref2.availableTransitionList,validateAndTriggerEvent=_ref2.validateAndTriggerEvent,processInstance=_ref2.processInstance;if(openTask){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,availableTransitionList.map(function(transition){var eventName=transition.eventName,technicalEvent=transition.technicalEvent,hide=transition.hide;if(technicalEvent||hide){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:eventName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){validateAndTriggerEvent(processInstance.id,processInstance.currentStateName,eventName);},className:'btn-primary btn btn-sm'},Object(__WEBPACK_IMPORTED_MODULE_11__util_names__["c" /* renderEventName */])(eventName)),'\xA0');}));};var ProcessFlow=function ProcessFlow(_ref3){var processFlowVisible=_ref3.processFlowVisible,processInstanceId=_ref3.processInstanceId;if(!processFlowVisible){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{style:FRAME_STYLE,src:PROCESS_FLOW_URL+processInstanceId,title:'Process Flow'})));};var Overview=function Overview(_ref4){var openTask=_ref4.openTask,toggleVIPStatus=_ref4.toggleVIPStatus,toggleRushStatus=_ref4.toggleRushStatus,changeTime=_ref4.changeTime,processInstance=_ref4.processInstance,validateAndTriggerEvent=_ref4.validateAndTriggerEvent,processFlowVisible=_ref4.processFlowVisible,availableStateList=_ref4.availableStateList,toggleProcessFlowVisibility=_ref4.toggleProcessFlowVisibility,availableTransitionList=_ref4.availableTransitionList,changeBeamProcessState=_ref4.changeBeamProcessState,beamProcessState=_ref4.beamProcessState,beamProcessInstance=_ref4.beamProcessInstance,validationMessageList=_ref4.validationMessageList,isProductionAdmin=_ref4.isProductionAdmin;if(!Object(__WEBPACK_IMPORTED_MODULE_16__util_widget_helper__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_17__ui_definition_process_ui__["T" /* PROCESS_OVERVIEW */])){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBoxWithoutHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__layout_component_ContentBoxHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_VipIcon__["a" /* default */],{onClick:function onClick(){toggleVIPStatus();},active:processInstance.vip}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_RushIcon__["a" /* default */],{onClick:function onClick(){if(isProductionAdmin){toggleRushStatus();}},active:processInstance.rush}),'\xA0','Process '+Object(__WEBPACK_IMPORTED_MODULE_11__util_names__["d" /* renderProcessName */])(processInstance.processName)+' '+processInstance.displayName,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__layout_component_ContentBoxBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleProcessFlowButton,{toggleProcessFlowVisibility:toggleProcessFlowVisibility,processFlowVisible:processFlowVisible}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransitionList,{openTask:openTask,processInstance:processInstance,availableTransitionList:availableTransitionList,validateAndTriggerEvent:validateAndTriggerEvent})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:4,className:'align-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__BeamProcessInstance__["a" /* default */],{availableStateList:availableStateList,changeBeamProcessState:changeBeamProcessState,beamProcessState:beamProcessState,beamProcessInstance:beamProcessInstance}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessFlow,{processFlowVisible:processFlowVisible,processInstanceId:processInstance.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'process-info-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,openTask&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/task/detail/'+openTask.id},Object(__WEBPACK_IMPORTED_MODULE_11__util_names__["g" /* renderTaskName */])(openTask.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Responsible'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,openTask&&Object(__WEBPACK_IMPORTED_MODULE_11__util_names__["e" /* renderRoleName */])(openTask.role))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_11__util_names__["f" /* renderStateName */])(processInstance.currentStateName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Wakeup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!processInstance.emailActionWakeup&&!processInstance.timeoutWakeup&&'none',processInstance.emailActionWakeup&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_DatePicker__["a" /* default */],{object:processInstance,name:'emailActionWakeup',showTimeSelect:true,dateFormat:'DD.MM.YYYY HH:mm',placeholder:'Next Activity',onChange:changeTime,onBlur:function onBlur(){}}),processInstance.timeoutWakeup&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__form_component_DatePicker__["a" /* default */],{object:processInstance,name:'timeoutWakeup',showTimeSelect:true,dateFormat:'DD.MM.YYYY HH:mm',placeholder:'Next Activity',onChange:changeTime,onBlur:function onBlur(){}})))))))));};Overview.propTypes={processInstance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,processFlowVisible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,validateAndTriggerEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,eventList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Overview);

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var RushIcon=function RushIcon(_ref){var active=_ref.active,_ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?function(){}:_ref$onClick;if(active){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{onClick:onClick,xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',width:'24',height:'24',viewBox:'0 0 172 172'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(8.944,8.944) scale(0.896,0.896)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'none',fillRule:'nonzero',stroke:'none',strokeWidth:'none',strokeLinecap:'butt',strokeLinejoin:'none',strokeMiterlimit:'10',strokeDasharray:'',strokeDashoffset:'0',fontFamily:'none',fontWeight:'none',fontSize:'none',textAnchor:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'#e74c3c',stroke:'#e74c3c',strokeWidth:'20',strokeLinejoin:'round'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M103.2,11.46667c3.16643,0 5.73333,2.5669 5.73333,5.73333c0.00017,0.81066 -0.17158,1.61215 -0.50391,2.35156l-19.56276,54.98177h31.53333c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,1.24874 -0.48596,2.33906 -1.16458,3.28099l0.05599,0.10078l-39.68542,73.82786h-0.0112c-0.99102,1.87753 -2.93843,3.05373 -5.06146,3.05703c-3.16643,0 -5.73333,-2.5669 -5.73333,-5.73333c-0.00097,-0.38352 0.03654,-0.76616 0.11198,-1.14219l8.48802,-56.19114h-31.53333c-3.16643,0 -5.73333,-2.5669 -5.73333,-5.73333c0.00221,-0.51489 0.07378,-1.02713 0.21276,-1.52292l-0.0112,-0.0112l17.08802,-73.99583c0.48343,-2.73875 2.86266,-4.7356 5.64375,-4.73672z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M0,172v-172h172v172z',fill:'none',stroke:'none',strokeWidth:'1',strokeLinejoin:'miter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'#e74c3c',stroke:'none',strokeWidth:'1',strokeLinejoin:'miter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M68.8,11.46667c-2.78109,0.00112 -5.16032,1.99797 -5.64375,4.73672l-17.08802,73.99583l0.0112,0.0112c-0.13898,0.49578 -0.21055,1.00803 -0.21276,1.52292c0,3.16643 2.5669,5.73333 5.73333,5.73333h31.53333l-8.48802,56.19114c-0.07543,0.37603 -0.11295,0.75867 -0.11198,1.14219c0,3.16643 2.5669,5.73333 5.73333,5.73333c2.12303,-0.0033 4.07043,-1.1795 5.06146,-3.05703h0.0112l39.68542,-73.82786l-0.05599,-0.10078c0.67862,-0.94193 1.16458,-2.03225 1.16458,-3.28099c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333h-31.53333l19.56276,-54.98177c0.33233,-0.73941 0.50408,-1.5409 0.50391,-2.35156c0,-3.16643 -2.5669,-5.73333 -5.73333,-5.73333z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',fill:'none',stroke:'none',strokeWidth:'1',strokeLinejoin:'miter'}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{onClick:onClick,xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',width:'24',height:'24',viewBox:'0 0 172 172'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'#ffffff',stroke:'#e74c3c',strokeWidth:'10',strokeLinejoin:'round'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{strokeWidth:'25',d:'M103.2,11.46667c3.16643,0 5.73333,2.5669 5.73333,5.73333c0.00017,0.81066 -0.17158,1.61215 -0.50391,2.35156l-19.56276,54.98177h31.53333c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,1.24874 -0.48596,2.33906 -1.16458,3.28099l0.05599,0.10078l-39.68542,73.82786h-0.0112c-0.99102,1.87753 -2.93843,3.05373 -5.06146,3.05703c-3.16643,0 -5.73333,-2.5669 -5.73333,-5.73333c-0.00097,-0.38352 0.03654,-0.76616 0.11198,-1.14219l8.48802,-56.19114h-31.53333c-3.16643,0 -5.73333,-2.5669 -5.73333,-5.73333c0.00221,-0.51489 0.07378,-1.02713 0.21276,-1.52292l-0.0112,-0.0112l17.08802,-73.99583c0.48343,-2.73875 2.86266,-4.7356 5.64375,-4.73672z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M0,172v-172h172v172z',fill:'none',stroke:'none',strokeWidth:'10',strokeLinejoin:'miter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'',fill:'none',stroke:'none',strokeWidth:'10',strokeLinejoin:'miter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'#ffffff',stroke:'none',strokeWidth:'10',strokeLinejoin:'miter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M68.8,11.46667c-2.78109,0.00112 -5.16032,1.99797 -5.64375,4.73672l-17.08802,73.99583l0.0112,0.0112c-0.13898,0.49578 -0.21055,1.00803 -0.21276,1.52292c0,3.16643 2.5669,5.73333 5.73333,5.73333h31.53333l-8.48802,56.19114c-0.07543,0.37603 -0.11295,0.75867 -0.11198,1.14219c0,3.16643 2.5669,5.73333 5.73333,5.73333c2.12303,-0.0033 4.07043,-1.1795 5.06146,-3.05703h0.0112l39.68542,-73.82786l-0.05599,-0.10078c0.67862,-0.94193 1.16458,-2.03225 1.16458,-3.28099c0,-3.1648 -2.56853,-5.73333 -5.73333,-5.73333h-31.53333l19.56276,-54.98177c0.33233,-0.73941 0.50408,-1.5409 0.50391,-2.35156c0,-3.16643 -2.5669,-5.73333 -5.73333,-5.73333z'})));};RushIcon.propTypes={active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RushIcon);

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__security_component_auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_const__ = __webpack_require__(28);
var BeamProcessInstance=function BeamProcessInstance(_ref){var beamProcessState=_ref.beamProcessState,availableStateList=_ref.availableStateList,changeBeamProcessState=_ref.changeBeamProcessState,beamProcessInstance=_ref.beamProcessInstance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__security_component_auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_5__security_state_auth_const__["F" /* ROLE_PROCESS_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'beam-process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'beam-process-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Select__["a" /* default */],{object:beamProcessState,name:'beamProcessState',valueList:availableStateList,addEmpty:true,renderer:function renderer(state){var stateName=Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["f" /* renderStateName */])(state.name);return state.taskName===null?stateName:stateName+' <'+Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["g" /* renderTaskName */])(state.taskName)+'>';},onChange:changeBeamProcessState})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'beam-process-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger btn-sm',onClick:beamProcessInstance},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-magic'}),' beam'))));};BeamProcessInstance.propTypes={beamProcessState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,availableStateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeBeamProcessState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,beamProcessInstance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (BeamProcessInstance);

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME_COMPONENT_MAPPING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sales_order_component_task_widget_TreatmentPaymentWidgetContainer__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_component_task_widget_PhysicianAndSupplierWidgetContainer__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treatment_component_task_widget_TreatmentQuotationWidgetContainer__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treatment_component_task_widget_ImplantTreatmentQuotationWidgetContainer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sales_order_component_task_widget_InitialHesitationWidgetContainer__ = __webpack_require__(320);
var _NAME_COMPONENT_MAPPI;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NAME_COMPONENT_MAPPING=(_NAME_COMPONENT_MAPPI={},_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_15" /* TREATMENT_PAYMENT_WIDGET */],__WEBPACK_IMPORTED_MODULE_1__sales_order_component_task_widget_TreatmentPaymentWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["Q" /* PHYSICIAN_AND_SUPPLIER_WIDGET */],__WEBPACK_IMPORTED_MODULE_2__customer_component_task_widget_PhysicianAndSupplierWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["_19" /* TREATMENT_QUOTATION_WIDGET */],__WEBPACK_IMPORTED_MODULE_3__treatment_component_task_widget_TreatmentQuotationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["z" /* IMPLANT_TREATMENT_QUOTATION_WIDGET */],__WEBPACK_IMPORTED_MODULE_4__treatment_component_task_widget_ImplantTreatmentQuotationWidgetContainer__["a" /* default */]),_defineProperty(_NAME_COMPONENT_MAPPI,__WEBPACK_IMPORTED_MODULE_0__ui_definition_process_ui__["B" /* INITIAL_HESITATION_WIDGET_CONTAINER */],__WEBPACK_IMPORTED_MODULE_5__sales_order_component_task_widget_InitialHesitationWidgetContainer__["a" /* default */]),_NAME_COMPONENT_MAPPI);

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AllOpenTaskList__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_task_list_action__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_task_list_selector__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_state_selector__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state,props){return{tableData:__WEBPACK_IMPORTED_MODULE_4__state_task_list_selector__["c" /* selectTable */](state),partnerList:Object(__WEBPACK_IMPORTED_MODULE_5__globals_state_selector__["selectPartnerList"])(state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["f" /* initialTableQuery */],changeFilter:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["a" /* changeFilter */],toggleSort:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["k" /* toggleSort */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["j" /* toggleMultiSort */],gotoPage:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["d" /* gotoPage */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["g" /* initialTableSettingsAllOpenTask */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_3__state_task_list_action__["i" /* toggleColumnVisibilityAllOpenTask */],navigateToTaskDetail:function navigateToTaskDetail(taskId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/task/detail/'+taskId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__AllOpenTaskList__["a" /* default */]));

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__table_component_Table__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__all_open_tasklist_column_list__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__security_state_auth_const__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__table_component_TableColumnSelector__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internationalization_const__ = __webpack_require__(31);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AllOpenTaskList=function AllOpenTaskList(_ref){var tableData=_ref.tableData,changeFilter=_ref.changeFilter,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,gotoPage=_ref.gotoPage,navigateToTaskDetail=_ref.navigateToTaskDetail,partnerList=_ref.partnerList,toggleColumnVisibility=_ref.toggleColumnVisibility;var columnList=Object(__WEBPACK_IMPORTED_MODULE_8__all_open_tasklist_column_list__["a" /* default */])(partnerList);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'All open task'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__table_component_TableColumnSelector__["a" /* default */],{resultsNumber:tableData.objectList.length,hiddenColumns:tableData.hiddenColumns,columnList:columnList,toggleColumnVisibility:toggleColumnVisibility}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__table_component_Table__["a" /* default */],Object.assign({},tableData,{changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,gotoPage:gotoPage,columnList:columnList,idProperty:'id',onRowClick:function onRowClick(task){navigateToTaskDetail(task.id);},filterSetting:{vip:{type:'select',valueList:[{id:'0',value:'no influencer'},{id:'1',value:'influencer'}]},partnerId:{type:'select',valueList:partnerList.map(function(partner){return{id:partner.id,value:partner.displayName};})},store:{type:'select',valueList:Object(__WEBPACK_IMPORTED_MODULE_9__store_util_renderStoreName__["a" /* getStoreDropDown */])()},countryCode:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_13__internationalization_const__["e" /* COUNTRY_CODE_LIST */]},processName:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_10__util_names__["b" /* PROCESS_NAME_SELECT */]},role:{type:'select',valueList:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__security_state_auth_const__["w" /* ROLE_LIST_EMPLOYEE_SELECT */]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__security_state_auth_const__["y" /* ROLE_LIST_PARTNER_SELECT */]))},status:{type:'input',beforeQuery:function beforeQuery(value){if(!value){return value;}return value.replace(/ /g,'_');},beforeRender:function beforeRender(value){if(!value){return value;}return value.replace(/_/g,' ');}},name:{type:'input',beforeQuery:function beforeQuery(value){if(!value){return value;}return value.replace(/ /g,'_');},beforeRender:function beforeRender(value){if(!value){return value;}return value.replace(/_/g,' ');}}}})))));};AllOpenTaskList.propTypes={navigateToTaskDetail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableQuery();this.props.initialColumnsVisibility();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(AllOpenTaskList)));

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = (function(partnerList){var partnersById=partnerList.reduce(function(partnersById,partner){partnersById[partner.id]=partner.displayName;return partnersById;},{});return[{property:'vip',header:'VIP',width:'45',renderer:function renderer(processInstance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__form_component_VipIcon__["a" /* default */],{active:processInstance.vip===1||processInstance.vip==='1'});},columnName:'process_task.vip'},{property:'created',header:'Created',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('created'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'process_task.created'},{property:'due',header:'Due',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('due'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('due'),columnName:'process_task.due'},{property:'priority',header:'Priority',columnName:'process_task.priority'},{property:'processName',header:'process Name',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["d" /* renderProcessName */])(processInstance.processName);},columnName:'process_task.processName'},{property:'name',header:'taskname',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__util_names__["g" /* renderTaskName */])(processInstance.name);},columnName:'process_task.name'},{property:'role',header:'Role',renderer:function renderer(processInstance){if(!processInstance.role){return'';}var list=JSON.parse(processInstance.role);return list.join(',');},columnName:'process_task.role'},{property:'processDisplayName',header:'Name',columnName:'process_task.processDisplayName'},{property:'partnerId',header:'Partner',columnName:'process_task.partnerId',renderer:function renderer(task){if(!task.partnerId){return'';}return partnersById[task.partnerId];}},{property:'assignedToName',header:'Assigned',columnName:'assignedToName'},{property:'store',header:'Store',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_4__store_util_renderStoreName__["b" /* renderStoreName */])(processInstance.store);},columnName:'process_task.storeId'},{property:'dealOwner',header:'DealOwner',columnName:'dealOwner'},{property:'countryCode',header:'Country',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_5__customer_util_names__["a" /* renderCountryName */])(processInstance.countryCode);},columnName:'store_store.countryCode'}];});

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["o" /* selectRetainerTable */](state),type:'retainer'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["R" /* initialTableQueryRetainer */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["l" /* changeFilterRetainer */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_53" /* toggleSortRetainer */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_37" /* toggleMultiSortRetainer */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["B" /* gotoPageRetainer */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_6" /* initialTableSettingsRetainer */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_21" /* toggleColumnVisibilityRetainer */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["n" /* selectRetainerRefinementTable */](state),type:'retainer-refinement'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["S" /* initialTableQueryRetainerRefinement */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["m" /* changeFilterRetainerRefinement */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_54" /* toggleSortRetainerRefinement */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_38" /* toggleMultiSortRetainerRefinement */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["C" /* gotoPageRetainerRefinement */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_7" /* initialTableSettingsRetainerRefinement */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_22" /* toggleColumnVisibilityRetainerRefinement */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_transition_selector__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_transition_action__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(43);
var mapStateToProps=function mapStateToProps(state,props){return{processStateNameList:__WEBPACK_IMPORTED_MODULE_4__globals__["a" /* default */].selector.selectProcessStateNameList(state),processState:__WEBPACK_IMPORTED_MODULE_1__state_transition_selector__["c" /* selectProcessState */](state),yearWeekList:__WEBPACK_IMPORTED_MODULE_1__state_transition_selector__["e" /* selectYearWeekList */](state),transitionList:__WEBPACK_IMPORTED_MODULE_1__state_transition_selector__["d" /* selectTransitionList */](state),mode:__WEBPACK_IMPORTED_MODULE_1__state_transition_selector__["b" /* selectMode */](state)};};var mapDispatchToProps={changeProcessState:__WEBPACK_IMPORTED_MODULE_2__state_transition_action__["a" /* changeProcessState */],changeYearWeek:__WEBPACK_IMPORTED_MODULE_2__state_transition_action__["b" /* changeYearWeek */],deleteYearWeek:__WEBPACK_IMPORTED_MODULE_2__state_transition_action__["c" /* deleteYearWeek */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* default */]));

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeProcessState; });
/* unused harmony export changeMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeYearWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteYearWeek; });
/* unused harmony export findTransitionRequest */
/* unused harmony export findTransitionSuccess */
/* unused harmony export findTransitionError */
/* unused harmony export findTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(283);
var changeProcessState=function changeProcessState(name,value){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_PROCESS_STATE */],payload:{name:name,value:value}});dispatch(findTransition());};};var changeMode=function changeMode(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_MODE */],payload:{mode:value}};};var changeYearWeek=function changeYearWeek(index,name,value){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_YEAR_WEEK */],payload:{index:index,name:name,value:parseInt(value,10)}});dispatch(findTransition());};};var deleteYearWeek=function deleteYearWeek(index){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* DELETE_YEAR_WEEK */],payload:{index:index}});dispatch(findTransition());};};var findTransitionRequest=function findTransitionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_TRANSITION_REQUEST */]};};var findTransitionSuccess=function findTransitionSuccess(transitionList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_TRANSITION_SUCCESS */],payload:{transitionList:transitionList}};};var findTransitionError=function findTransitionError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_TRANSITION_ERROR */],payload:{error:error}};};var findTransition=function findTransition(){return function(dispatch,getState){var state=getState();var processState=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectProcessState */](state);var yearWeekList=__WEBPACK_IMPORTED_MODULE_2__selector__["e" /* selectYearWeekList */](state);yearWeekList=yearWeekList.filter(function(yearWeek){return yearWeek.year&&yearWeek.week;});if(yearWeekList.length===0||!processState.startProcessName||!processState.startStatus||!processState.endProcessName||!processState.endStatus){return;}dispatch(findTransitionRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/analytics/get-transition-over-time',Object.assign({},processState,{yearWeekList:yearWeekList})).then(function(transitionList){dispatch(findTransitionSuccess(transitionList));}).catch(function(error){dispatch(findTransitionError(error));});};};

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_helper__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_transition_const__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internationalization_const__ = __webpack_require__(31);
var COLOR_LIST=['0,145,231','255,193,44','255,138,0','255,63,107','18,178,178','133,70,255','186,188,193'];var compileGraphData=function compileGraphData(transitionList,mode){var max=0;var maxIndex=0;for(var index=0;index<transitionList.length;index++){var item=transitionList[index];var transitionCount=item.transition.length;if(transitionCount>max){max=transitionCount;maxIndex=index;}}var result={labels:transitionList[maxIndex].transition.map(function(item){return item.offset;}),datasets:[]};for(var _index=0;_index<transitionList.length;_index++){var color=COLOR_LIST[_index%7];var _item=transitionList[_index];result.datasets.push({label:' Week '+_item.week,fill:false,lineTension:0.1,backgroundColor:'rgba('+color+',0.4)',borderColor:'rgba('+color+',1)',borderCapStyle:'butt',borderDash:[],borderDashOffset:0.0,borderJoinStyle:'miter',pointBorderColor:'rgba('+color+',1)',pointBackgroundColor:'#fff',pointBorderWidth:1,pointHoverRadius:5,pointHoverBackgroundColor:'rgba('+color+',1)',pointHoverBorderColor:'rgba(220,220,220,1)',pointHoverBorderWidth:2,pointRadius:1,pointHitRadius:10,data:_item.transition.map(function(transition){return Math.round(transition[mode]);})});}return result;};var weekList=[];for(var week=1;week<54;week++){weekList.push({id:''+week,value:''+week});}var yearList=[];var today=new Date();var currentYear=today.getFullYear();for(var year=2018;year<=currentYear;year++){yearList.push({id:''+year,value:''+year});}var Transition=function Transition(_ref){var processState=_ref.processState,changeProcessState=_ref.changeProcessState,processStateNameList=_ref.processStateNameList,yearWeekList=_ref.yearWeekList,changeYearWeek=_ref.changeYearWeek,deleteYearWeek=_ref.deleteYearWeek,transitionList=_ref.transitionList,mode=_ref.mode;var processNameSelectList=Object(__WEBPACK_IMPORTED_MODULE_8__state_helper__["a" /* getProcessSelectList */])(processStateNameList);var startStateList=Object(__WEBPACK_IMPORTED_MODULE_8__state_helper__["b" /* getStateSelectList */])(processStateNameList,processState.startProcessName);var endStateList=Object(__WEBPACK_IMPORTED_MODULE_8__state_helper__["b" /* getStateSelectList */])(processStateNameList,processState.endProcessName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'State Transition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Start Process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:processState,name:'startProcessName',addEmpty:!processState.startProcessName,valueList:processNameSelectList,onChange:changeProcessState})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Start State'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:processState,name:'startStatus',addEmpty:!processState.startStatus,valueList:startStateList,renderer:function renderer(stateName){return Object(__WEBPACK_IMPORTED_MODULE_10__process_util_names__["f" /* renderStateName */])(stateName.value);},onChange:changeProcessState})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Mode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:processState,name:'mode',addEmpty:false,valueList:__WEBPACK_IMPORTED_MODULE_11__state_transition_const__["b" /* MODE_LIST */],onChange:changeProcessState}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Target Process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:processState,name:'endProcessName',addEmpty:!processState.endProcessName,valueList:processNameSelectList,onChange:changeProcessState})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Target State'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:processState,name:'endStatus',addEmpty:!processState.endStatus,valueList:endStateList,renderer:function renderer(stateName){return Object(__WEBPACK_IMPORTED_MODULE_10__process_util_names__["f" /* renderStateName */])(stateName.value);},onChange:changeProcessState}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:3},yearWeekList.map(function(yearWeek,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearWeekRow,{key:index,changeYearWeek:changeYearWeek,yearWeek:yearWeek,index:index,deleteYearWeek:deleteYearWeek});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearWeekRow,{changeYearWeek:changeYearWeek,yearWeek:{year:currentYear},index:yearWeekList.length})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Company'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:processState,name:'companyCode',valueList:__WEBPACK_IMPORTED_MODULE_12__internationalization_const__["a" /* COMPANY_CODE_SELECT_VALUE_LIST */],onChange:changeProcessState}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:2}))),transitionList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartjs_2__["c" /* Line */],{data:compileGraphData(transitionList,mode)})));};var YearWeekRow=function YearWeekRow(_ref2){var changeYearWeek=_ref2.changeYearWeek,yearWeek=_ref2.yearWeek,index=_ref2.index,deleteYearWeek=_ref2.deleteYearWeek;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-builder-cw-year-week'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Year'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:yearWeek,name:'year',addEmpty:!yearWeek.year,valueList:yearList,onChange:function onChange(name,value){changeYearWeek(index,name,value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-builder-cw-year-week'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_LabelInput__["a" /* default */],{label:'Week'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Select__["a" /* default */],{object:yearWeek,name:'week',addEmpty:!yearWeek.week,valueList:weekList,onChange:function onChange(name,value){changeYearWeek(index,name,value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transition-builder-cw-year-delete'},deleteYearWeek&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-minus-circle transition-builder-delete-cw',onClick:function onClick(){deleteYearWeek(index);}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(Transition)));

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["l" /* selectRefinementSetTable */](state),type:'refinement-set'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["P" /* initialTableQueryRefinementSet */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["j" /* changeFilterRefinementSet */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_51" /* toggleSortRefinementSet */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_35" /* toggleMultiSortRefinementSet */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["z" /* gotoPageRefinementSet */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_4" /* initialTableSettingsRefinementSet */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_19" /* toggleColumnVisibilityRefinementSet */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["j" /* selectRefinementBookingTable */](state),type:'refinement-booking'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["N" /* initialTableQueryRefinementBooking */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["h" /* changeFilterRefinementBooking */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_49" /* toggleSortRefinementBooking */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_33" /* toggleMultiSortRefinementBooking */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["x" /* gotoPageRefinementBooking */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["m" /* selectRefinementShopTable */](state),type:'refinement-shop'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["Q" /* initialTableQueryRefinementShop */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["k" /* changeFilterRefinementShop */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_52" /* toggleSortRefinementShop */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_36" /* toggleMultiSortRefinementShop */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["A" /* gotoPageRefinementShop */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_5" /* initialTableSettingsRefinementShop */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_20" /* toggleColumnVisibilityRefinementShop */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_manage_selector__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_manage_action__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManageUser__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_state_selector__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state,props){return{currentUser:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["c" /* selectCurrentUser */](state),userList:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["i" /* selectUserList */](state),currentUserId:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["d" /* selectCurrentUserId */](state),salutationList:__WEBPACK_IMPORTED_MODULE_4__globals__["a" /* default */].selector.selectSalutationList(state),partnerList:Object(__WEBPACK_IMPORTED_MODULE_5__globals_state_selector__["selectPartnerList"])(state),passwordStatus:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["g" /* selectPasswordStatus */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["j" /* selectValidationMessageList */](state),isUniqueConstraintViolation:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["f" /* selectIsUniqueConstraintViolation */](state),storeList:Object(__WEBPACK_IMPORTED_MODULE_5__globals_state_selector__["selectStoreList"])(state)};};var mapDispatchToProps={findAllUser:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["i" /* findAllUser */],changeCurrentUserId:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["b" /* changeCurrentUserId */],changeUser:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["d" /* changeUser */],toggleRole:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["m" /* toggleRole */],toggleWidgetAccess:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["o" /* toggleWidgetAccess */],createEmployee:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["e" /* createEmployee */],generateNewPassword:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["j" /* generateNewPassword */],createExternalUser:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["f" /* createExternalUser */],changeExternalUser:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["c" /* changeExternalUser */],saveUser:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["l" /* saveUser */],createUser:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["g" /* createUser */],findAllRole:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["h" /* findAllRole */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ManageUser__["a" /* default */]));

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserAdmin__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserSelection__ = __webpack_require__(1634);
var ManageUser=function ManageUser(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UserSelection__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserAdmin__["a" /* default */],props));};ManageUser.propTypes={isUniqueConstraintViolation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,createUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,userList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,partnerList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,storeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,findAllUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,generateNewPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeCurrentUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createEmployee:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeExternalUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createExternalUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleWidgetAccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,salutationList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,passwordStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,saveUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,findAllRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findAllUser();this.props.findAllRole();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(ManageUser)));

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Input__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__renderUserName__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RoleAdmin__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WidgetAdmin__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__auth_AuthorizationContainer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__state_auth_const__ = __webpack_require__(28);
var getStoreValueList=function getStoreValueList(storeList){var storeValueList=storeList.map(function(store){return{id:store.technicalName,value:store.displayName};});storeValueList.sort(function(aStore,bStore){if(aStore.value<bStore.value){return-1;}if(aStore.value>bStore.value){return 1;}return 0;});return storeValueList;};var UserAdmin=function UserAdmin(_ref){var passwordStatus=_ref.passwordStatus,createUser=_ref.createUser,isUniqueConstraintViolation=_ref.isUniqueConstraintViolation,validationMessageList=_ref.validationMessageList,currentUser=_ref.currentUser,saveUser=_ref.saveUser,changeUser=_ref.changeUser,toggleRole=_ref.toggleRole,toggleWidgetAccess=_ref.toggleWidgetAccess,salutationList=_ref.salutationList,partnerList=_ref.partnerList,storeList=_ref.storeList,changeExternalUser=_ref.changeExternalUser,generateNewPassword=_ref.generateNewPassword;if(!currentUser){return null;}var changeAndSave=function changeAndSave(name,value){changeUser(name,value);saveUser();};var storeValueList=getStoreValueList(storeList);var isEmployee=!!currentUser.employee;var title=Object(__WEBPACK_IMPORTED_MODULE_10__renderUserName__["a" /* default */])(currentUser);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},currentUser.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:passwordStatus==='processing',className:'btn btn-warning btn-sm',onClick:generateNewPassword},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-send'}),'\xA0generate new password'),!currentUser.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger btn-sm',onClick:createUser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'}),'\xA0create'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:validationMessageList}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Salutation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:currentUser,name:'gender',addEmpty:!currentUser.gender,valueList:salutationList,onChange:changeAndSave}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__form_component_Checkbox__["a" /* default */],{name:'blocked',object:currentUser,onChange:changeAndSave},'blocked'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Firstname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:currentUser,name:'firstName',onChange:changeUser,onBlur:saveUser}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Lastname',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:currentUser,name:'lastName',onChange:changeUser,onBlur:saveUser})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Email',groupAddOnIcon:'fa fa-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Input__["a" /* default */],{object:currentUser,name:'email',onChange:changeUser,onBlur:saveUser})),isUniqueConstraintViolation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'form-error'},'Email is already in use')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Store'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:currentUser,name:'store',addEmpty:true,valueList:storeValueList,onChange:function onChange(name,value){changeUser(name,value);saveUser();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RoleAdmin__["a" /* default */],{saveUser:saveUser,currentUser:currentUser,toggleRole:toggleRole}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__auth_AuthorizationContainer__["a" /* default */],{requiredRole:__WEBPACK_IMPORTED_MODULE_15__state_auth_const__["R" /* ROLE_WIDGET_ADMIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__WidgetAdmin__["a" /* default */],{saveUser:saveUser,currentUser:currentUser,toggleWidgetAccess:toggleWidgetAccess}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},!isEmployee&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Partner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{valueList:partnerList,renderer:function renderer(partner){var suffix=' (Partner Clinic '+Object(__WEBPACK_IMPORTED_MODULE_13__store_util_renderStoreName__["b" /* renderStoreName */])(partner.store)+')';if(partner.isPhysician){suffix=' (Physician)';}if(partner.isSupplier){suffix=' (Supplier)';}if(partner.isTreatmentPlaner){suffix=' (Treatment Planer)';}return partner.displayName+suffix;},onChange:function onChange(name,value){changeExternalUser(name,value);saveUser();},object:currentUser.externalUser,addEmpty:!currentUser.externalUser.partnerId,name:'partnerId'})))));};UserAdmin.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,passwordStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,salutationList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,partnerList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,changeUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeExternalUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,generateNewPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleWidgetAccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,storeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserAdmin);

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_auth_const__ = __webpack_require__(28);
var RoleAdmin=function RoleAdmin(_ref){var currentUser=_ref.currentUser,toggleRole=_ref.toggleRole,saveUser=_ref.saveUser;var roleList=currentUser.employee?__WEBPACK_IMPORTED_MODULE_3__state_auth_const__["v" /* ROLE_LIST_EMPLOYEE */]:__WEBPACK_IMPORTED_MODULE_3__state_auth_const__["x" /* ROLE_LIST_PARTNER */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Assigned roles',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),roleList.map(function(role){var hasRole=currentUser.roleList.indexOf(role)!==-1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:role,object:{hasRole:hasRole},onChange:function onChange(){toggleRole(role,!hasRole);saveUser();},name:'hasRole'},role);}));};RoleAdmin.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,toggleRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RoleAdmin);

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_widgets__ = __webpack_require__(579);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var WidgetAdmin=function WidgetAdmin(_ref){var currentUser=_ref.currentUser,toggleWidgetAccess=_ref.toggleWidgetAccess,saveUser=_ref.saveUser;var widgetList=__WEBPACK_IMPORTED_MODULE_3__constant_widgets__["a" /* WIDGET_LIST */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Widget access',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object.entries(widgetList).map(function(_ref2){var _ref3=_slicedToArray(_ref2,2),widgetId=_ref3[0],widgetName=_ref3[1];var hasWidgetAccess=currentUser.visibleWidgetList.indexOf(widgetId)!==-1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:widgetId,object:{hasWidgetAccess:hasWidgetAccess},onChange:function onChange(){toggleWidgetAccess(widgetId,!hasWidgetAccess);saveUser();},name:'hasWidgetAccess'},widgetName);}));};WidgetAdmin.propTypes={currentUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,toggleWidgetAccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (WidgetAdmin);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__renderUserName__ = __webpack_require__(578);
var UserSelection=function UserSelection(_ref){var userList=_ref.userList,createUser=_ref.createUser,currentUserId=_ref.currentUserId,changeCurrentUserId=_ref.changeCurrentUserId,createEmployee=_ref.createEmployee,createExternalUser=_ref.createExternalUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layout_component_ContentBox__["a" /* default */],{title:'Manage User'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Choose User'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{style:{height:'30px'},object:{currentUserId:currentUserId},name:'currentUserId',renderer:__WEBPACK_IMPORTED_MODULE_7__renderUserName__["a" /* default */],valueList:userList,addEmpty:true,onChange:changeCurrentUserId}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'24px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-warning btn-sm',onClick:createEmployee},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-square'}),'\xA0new employee'),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-warning btn-sm',onClick:createExternalUser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-square'}),'\xA0new external user')))));};UserSelection.propTypes={userList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,currentUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,createUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeCurrentUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createEmployee:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeExternalUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserSelection);

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_search_action__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_selector__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppointmentSearch__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_state_selector__ = __webpack_require__(88);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_2__state_search_selector__["c" /* selectTable */](state),isTablet:Object(__WEBPACK_IMPORTED_MODULE_5__layout_state_selector__["c" /* selectIsTablet */])(state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["c" /* initialTableQuery */],changeFilter:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["a" /* changeFilter */],toggleSort:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["g" /* toggleSort */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["f" /* toggleMultiSort */],gotoPage:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["b" /* gotoPage */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["d" /* initialTableSettings */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["e" /* toggleColumnVisibility */],navigateToAppointment:function navigateToAppointment(appointmentId){return Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["d" /* push */])('/appointment/edit/'+appointmentId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AppointmentSearch__["a" /* default */]));

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialTableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleMultiSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gotoPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialTableSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleColumnVisibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(292);
var initialTableQuery=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);var changeFilter=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);var toggleSort=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);var toggleMultiSort=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);var gotoPage=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);var initialTableSettings=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);var toggleColumnVisibility=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectTable */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* APPOINTMENT_TABLE */]);

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appointment_column_list__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_component_Table__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__detail_AppointmentDetail__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_search_const__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__table_component_TableColumnSelector__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internationalization_const__ = __webpack_require__(31);
var AppointmentSearch=function AppointmentSearch(_ref){var tableData=_ref.tableData,changeFilter=_ref.changeFilter,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,gotoPage=_ref.gotoPage,isTablet=_ref.isTablet,navigateToAppointment=_ref.navigateToAppointment,toggleColumnVisibility=_ref.toggleColumnVisibility;var columnList=Object(__WEBPACK_IMPORTED_MODULE_5__appointment_column_list__["a" /* default */])(isTablet);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Appointment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__table_component_TableColumnSelector__["a" /* default */],{resultsNumber:tableData.objectList.length,hiddenColumns:tableData.hiddenColumns,columnList:columnList,toggleColumnVisibility:toggleColumnVisibility}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_component_Table__["a" /* default */],Object.assign({},tableData,{changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,gotoPage:gotoPage,idProperty:'id',columnList:columnList,onRowClick:function onRowClick(appointment){navigateToAppointment(appointment.id);},filterSetting:{cancelCategory:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_8__detail_AppointmentDetail__["a" /* CANCEL_CATEGORY */]},storeId:{type:'select',valueList:Object(__WEBPACK_IMPORTED_MODULE_7__store_util_renderStoreName__["a" /* getStoreDropDown */])()},countryCode:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_11__internationalization_const__["e" /* COUNTRY_CODE_LIST */]},status:{type:'input',beforeQuery:function beforeQuery(value){if(!value){return value;}return value.replace(/ /g,'_');},beforeRender:function beforeRender(value){if(!value){return value;}return value.replace(/_/g,' ');}},appointmentType:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_9__state_search_const__["a" /* APPOINTMENT_TYPE */]}}})));};AppointmentSearch.propTypes={isTablet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableQuery();this.props.initialColumnsVisibility();}})(Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(AppointmentSearch)));

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_util_names__ = __webpack_require__(80);
/* harmony default export */ __webpack_exports__["a"] = (function(isTablet){return isTablet?columnListStore:columnList;});var columnListStore=[{property:'firstName',header:'Firstname',columnName:'firstName'},{property:'lastName',header:'Lastname',columnName:'lastName'},{property:'email',header:'Email',columnName:'email'},{property:'phone',header:'Phone',columnName:'phone'},{property:'startTime',header:'Starttime',renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('startTime'),columnName:'startTime'},{property:'appointmentType',header:'Appointment Type',columnName:'appointmentType'},{property:'status',header:'Status',columnName:'status'},{property:'cancelCategory',header:'Cancel Category',columnName:'cancelCategory'}];var columnList=[{property:'created',header:'Created',renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('created'),columnName:'created'},{property:'updated',header:'Updated',renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('updated'),columnName:'updated'},{property:'firstName',header:'Firstname',columnName:'firstName'},{property:'lastName',header:'Lastname',columnName:'lastName'},{property:'email',header:'Email',columnName:'appointment_appointment.email'},{property:'storeId',header:'Store',renderer:function renderer(appointment){return Object(__WEBPACK_IMPORTED_MODULE_1__store_util_renderStoreName__["c" /* renderStoreNameById */])(appointment.storeId);},columnName:'storeId'},{property:'phone',header:'Phone',columnName:'phone'},{property:'startTime',header:'Starttime',renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('startTime'),columnName:'startTime'},{property:'endTime',header:'Endtime',renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('endTime'),columnName:'endTime'},{property:'appointmentType',header:'Appointment Type',columnName:'appointmentType'},{property:'status',header:'Status',columnName:'status'},{property:'cancelCategory',header:'Cancel Category',columnName:'cancelCategory'},{property:'countryCode',header:'Country',renderer:function renderer(appointment){return Object(__WEBPACK_IMPORTED_MODULE_2__customer_util_names__["a" /* renderCountryName */])(appointment.countryCode);},columnName:'appointment_appointment.countryCode'}];

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["g" /* selectInShopScanTable */](state),type:'in-shop-scan'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["M" /* initialTableQueryInShopScan */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["g" /* changeFilterInShopScan */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_48" /* toggleSortInShopScan */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_32" /* toggleMultiSortInShopScan */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["w" /* gotoPageInShopScan */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_2" /* initialTableSettingsInShopScan */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_17" /* toggleColumnVisibilityInShopScan */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerSearch__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_state_selector__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["d" /* tableSelectorPartner */](state),isTablet:Object(__WEBPACK_IMPORTED_MODULE_5__layout_state_selector__["c" /* selectIsTablet */])(state),isPartner:Object(__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["k" /* selectIsPartner */])(state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["f" /* initialTableQueryPartner */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["b" /* changeFilterPartner */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["l" /* toggleSortPartner */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["j" /* toggleMultiSortPartner */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["d" /* gotoPagePartner */],navigateToCustomer:function navigateToCustomer(customerId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/customer/edit/'+customerId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__CustomerSearch__["a" /* default */]));

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppointmentDetail__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(43);
var mapStateToProps=function mapStateToProps(state,props){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectOwnState */](state),{appointmentId:props.computedMatch.params.appointmentId,salutationList:__WEBPACK_IMPORTED_MODULE_4__globals__["a" /* default */].selector.selectSalutationList(state)});};var mapDispatchToProps={findAppointment:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["b" /* findAppointment */],changeAppointment:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* changeAppointment */],setAppointmentCancelCategory:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["c" /* setAppointmentCancelCategory */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__AppointmentDetail__["b" /* default */]));

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findAppointmentRequest */
/* unused harmony export findAppointmentSuccess */
/* unused harmony export findAppointmentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findAppointment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeAppointment; });
/* unused harmony export setAppointmentCancelCategoryRequest */
/* unused harmony export setAppointmentCancelCategorySuccess */
/* unused harmony export setAppointmentCancelCategoryError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setAppointmentCancelCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(291);
var findAppointmentRequest=function findAppointmentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_APPOINTMENT_REQUEST */],payload:{}};};var findAppointmentSuccess=function findAppointmentSuccess(appointment){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_APPOINTMENT_SUCCESS */],payload:{appointment:appointment}};};var findAppointmentError=function findAppointmentError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_APPOINTMENT_ERROR */],payload:{error:error}};};var findAppointment=function findAppointment(appointmentId){return function(dispatch,getState){dispatch(findAppointmentRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/appointment/find-appointment-by-id?appointmentId='+appointmentId).then(function(appointment){dispatch(findAppointmentSuccess(appointment));}).catch(function(error){dispatch(findAppointmentError(error));});};};var changeAppointment=function changeAppointment(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_APPOINTMENT */],payload:{name:name,value:value}};};var setAppointmentCancelCategoryRequest=function setAppointmentCancelCategoryRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_APPOINTMENT_REQUEST */],payload:{}};};var setAppointmentCancelCategorySuccess=function setAppointmentCancelCategorySuccess(appointment){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_APPOINTMENT_SUCCESS */],payload:{appointment:appointment}};};var setAppointmentCancelCategoryError=function setAppointmentCancelCategoryError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_APPOINTMENT_ERROR */],payload:{error:error}};};var setAppointmentCancelCategory=function setAppointmentCancelCategory(){return function(dispatch,getState){var state=getState();var appointment=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectAppointment */](state);dispatch(setAppointmentCancelCategoryRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/appointment/set-cancel-category',{appointmentId:appointment.id,cancelCategory:appointment.cancelCategory}).then(function(appointment){dispatch(setAppointmentCancelCategorySuccess(appointment));}).catch(function(error){dispatch(setAppointmentCancelCategoryError(error));});};};

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["k" /* selectRefinementProductionTable */](state),type:'refinement-production'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["O" /* initialTableQueryRefinementProduction */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["i" /* changeFilterRefinementProduction */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_50" /* toggleSortRefinementProduction */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_34" /* toggleMultiSortRefinementProduction */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["y" /* gotoPageRefinementProduction */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_3" /* initialTableSettingsRefinementProduction */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_18" /* toggleColumnVisibilityRefinementProduction */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_version_summary_action__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_version_summary_selector__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VersionSummary__ = __webpack_require__(1647);
var mapStateToProps=function mapStateToProps(state,props){return{versionSummary:__WEBPACK_IMPORTED_MODULE_2__state_version_summary_selector__["a" /* selectVersionSummary */](state),versionSummaryGrouped:__WEBPACK_IMPORTED_MODULE_2__state_version_summary_selector__["b" /* selectVersionSummaryGrouped */](state)};};var mapDispatchToProps={getVersionSummary:__WEBPACK_IMPORTED_MODULE_1__state_version_summary_action__["a" /* getVersionSummary */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__VersionSummary__["a" /* default */]));

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVersionSummaryRequest */
/* unused harmony export getVersionSummarySuccess */
/* unused harmony export getVersionSummaryError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVersionSummary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_api__ = __webpack_require__(12);
var getVersionSummaryRequest=function getVersionSummaryRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* GET_VERSION_SUMMARY_REQUEST */],payload:{}};};var getVersionSummarySuccess=function getVersionSummarySuccess(versionSummary){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* GET_VERSION_SUMMARY_SUCCESS */],payload:{versionSummary:versionSummary}};};var getVersionSummaryError=function getVersionSummaryError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* GET_VERSION_SUMMARY_ERROR */],payload:{error:error}};};var getVersionSummary=function getVersionSummary(){return function(dispatch,getState){dispatch(getVersionSummaryRequest());Object(__WEBPACK_IMPORTED_MODULE_1__util_api__["b" /* get */])('/process/version/summary').then(function(versionSummary){dispatch(getVersionSummarySuccess(versionSummary));}).catch(function(error){dispatch(getVersionSummaryError(error));});};};

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOwnState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectVersionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectVersionSummaryGrouped; });
/* unused harmony export selectIsFetching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(103);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectVersionSummary=function selectVersionSummary(state){return selectOwnState(state).versionSummary;};var selectVersionSummaryGrouped=function selectVersionSummaryGrouped(state){var versionSummary=selectVersionSummary(state);var versionSummaryGrouped={};for(var index=0;index<versionSummary.length;index++){var version=versionSummary[index];var name=version.name;if(!versionSummaryGrouped[name]){versionSummaryGrouped[name]=[];}versionSummaryGrouped[name].push(version);}return versionSummaryGrouped;};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_datetime__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_names__ = __webpack_require__(25);
var PROCESS_VERSION_URL=__WEBPACK_IMPORTED_MODULE_8__util_api__["a" /* BACKEND_URL */]+'/process/version/view-version?processVersionId=';var ProcessVersionSummary=function ProcessVersionSummary(_ref){var name=_ref.name,processVersionList=_ref.processVersionList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_9__util_names__["d" /* renderProcessName */])(name)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Activated'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Deactivated'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Number of instances'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,processVersionList.map(function(version){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:version.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_7__util_datetime__["c" /* formatDateTime */])(version.activated)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,version.deactivated?Object(__WEBPACK_IMPORTED_MODULE_7__util_datetime__["c" /* formatDateTime */])(version.deactivated):'active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,version.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:PROCESS_VERSION_URL+version.id,target:'_blank',rel:'noopener noreferrer'},'view')));}))))));};var VersionSummary=function VersionSummary(_ref2){var versionSummary=_ref2.versionSummary,versionSummaryGrouped=_ref2.versionSummaryGrouped;if(!versionSummaryGrouped||Object.keys(versionSummaryGrouped).length===0){return null;}var processVersionNameList=Object.keys(versionSummaryGrouped);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,processVersionNameList.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessVersionSummary,{key:name,name:name,processVersionList:versionSummaryGrouped[name]});}));};VersionSummary.propTypes={versionSummary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,getVersionSummary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.getVersionSummary();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(VersionSummary)));

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["c" /* selectEscalationTable */](state),type:'escalation'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["I" /* initialTableQueryEscalation */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["c" /* changeFilterEscalation */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_44" /* toggleSortEscalation */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_28" /* toggleMultiSortEscalation */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["s" /* gotoPageEscalation */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["Y" /* initialTableSettingsEscalation */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_13" /* toggleColumnVisibilityEscalation */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["a" /* selectCheckInTable */](state),type:'check-in'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["G" /* initialTableQueryCheckIn */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["a" /* changeFilterCheckIn */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_42" /* toggleSortCheckIn */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_26" /* toggleMultiSortCheckIn */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["q" /* gotoPageCheckIn */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["W" /* initialTableSettingsCheckIn */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_11" /* toggleColumnVisibilityCheckIn */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_state_responsible_action__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_state_responsible_selector__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StateResponsibleConfiguration__ = __webpack_require__(1652);
var mapStateToProps=function mapStateToProps(state){return{stateResponsibleList:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_selector__["b" /* selectStateResponsibleList */](state)};};var mapDispatchToProps={findResponsibleStateList:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_action__["b" /* findResponsibleStateList */],changeStateResponsible:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_action__["a" /* changeStateResponsible */],saveStateResponsible:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_action__["c" /* saveStateResponsible */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__StateResponsibleConfiguration__["a" /* default */]));

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findResponsibleStateListRequest */
/* unused harmony export findResponsibleStateListSuccess */
/* unused harmony export findResponsibleStateListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findResponsibleStateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeStateResponsible; });
/* unused harmony export saveStateResponsibleRequest */
/* unused harmony export saveStateResponsibleSuccess */
/* unused harmony export saveStateResponsibleError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveStateResponsible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(581);
var findResponsibleStateListRequest=function findResponsibleStateListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_STATE_RESPONSIBLE_LIST_REQUEST */]};};var findResponsibleStateListSuccess=function findResponsibleStateListSuccess(stateResponsibleList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_STATE_RESPONSIBLE_LIST_SUCCESS */],payload:{stateResponsibleList:stateResponsibleList}};};var findResponsibleStateListError=function findResponsibleStateListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_STATE_RESPONSIBLE_LIST_ERROR */],payload:{error:error}};};var findResponsibleStateList=function findResponsibleStateList(){return function(dispatch,getState){dispatch(findResponsibleStateListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/state-responsible/find-all').then(function(processInstance){dispatch(findResponsibleStateListSuccess(processInstance));}).catch(function(error){dispatch(findResponsibleStateListError(error));});};};var changeStateResponsible=function changeStateResponsible(stateResponsibleId,name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_STATE_RESPONSIBLE */],payload:{stateResponsibleId:stateResponsibleId,name:name,value:value}};};var saveStateResponsibleRequest=function saveStateResponsibleRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_STATE_RESPONSIBLE_REQUEST */]};};var saveStateResponsibleSuccess=function saveStateResponsibleSuccess(stateResponsible){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_STATE_RESPONSIBLE_SUCCESS */],payload:{stateResponsible:stateResponsible}};};var saveStateResponsibleError=function saveStateResponsibleError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_STATE_RESPONSIBLE_ERROR */],payload:{error:error}};};var saveStateResponsible=function saveStateResponsible(stateResponsibleId){return function(dispatch,getState){var state=getState();var stateResponsible=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectStateResponsibleById */](state,stateResponsibleId);if(!stateResponsible){return;}dispatch(saveStateResponsibleRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/state-responsible/save',stateResponsible).then(function(stateResponsible){dispatch(saveStateResponsibleSuccess(stateResponsible));}).catch(function(error){dispatch(saveStateResponsibleError(error));});};};

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_state_responsible_const__ = __webpack_require__(131);
var StateResponsible=function StateResponsible(_ref){var stateResponsible=_ref.stateResponsible,changeStateResponsible=_ref.changeStateResponsible,saveStateResponsible=_ref.saveStateResponsible;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_names__["d" /* renderProcessName */])(stateResponsible.processName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_names__["f" /* renderStateName */])(stateResponsible.stateName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:stateResponsible,name:'responsible',valueList:__WEBPACK_IMPORTED_MODULE_7__state_state_responsible_const__["b" /* STATE_RESPONSIBLE_SELECT */],onChange:function onChange(name,value){changeStateResponsible(stateResponsible.id,name,value);saveStateResponsible(stateResponsible.id);}})));};var StateResponsibleConfiguration=function StateResponsibleConfiguration(_ref2){var stateResponsibleList=_ref2.stateResponsibleList,changeStateResponsible=_ref2.changeStateResponsible,saveStateResponsible=_ref2.saveStateResponsible;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'State Responsible'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Process name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'State name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Responsible'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,stateResponsibleList.map(function(stateResponsible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StateResponsible,{key:stateResponsible.id,stateResponsible:stateResponsible,changeStateResponsible:changeStateResponsible,saveStateResponsible:saveStateResponsible});}))));};StateResponsibleConfiguration.propTypes={stateResponsibleList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,findResponsibleStateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeStateResponsible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveStateResponsible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findResponsibleStateList();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(StateResponsibleConfiguration)));

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StateResponsible__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(22);
var mapStateToProps=function mapStateToProps(state,props){return{stateAnalytics:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["e" /* selectStateAnalytics */](state),userSelection:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["m" /* selectUserSelection */](state),processNameList:Object(__WEBPACK_IMPORTED_MODULE_4__globals_state_selector__["selectProcessNameList"])(state),// task level
currentTaskName:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["b" /* selectCurrentTaskName */](state),taskByDueDateList:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["i" /* selectTaskByDueDateList */](state),taskList:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["j" /* selectTaskList */](state),taskTableSetting:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["k" /* selectTaskTableSetting */](state),// state level
currentStateName:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["a" /* selectCurrentStateName */](state),stateByLastChangedList:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["f" /* selectStateByLastChangedList */](state),processInstanceList:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["d" /* selectProcessInstanceList */](state),stateTableSetting:__WEBPACK_IMPORTED_MODULE_1__state_state_responsible_selector__["g" /* selectStateTableSetting */](state)};};var mapDispatchToProps={getStateAnalytics:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["f" /* getStateAnalytics */],getStateLastChanged:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["g" /* getStateLastChanged */],getTaskByDueDate:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["h" /* getTaskByDueDate */],changeUserSelection:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["c" /* changeUserSelection */],findTaskByWeekDiff:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["e" /* findTaskByWeekDiff */],findProcessInstanceByWeekDiff:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["d" /* findProcessInstanceByWeekDiff */],changeTaskTableSetting:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["b" /* changeTaskTableSetting */],changeStateTableSetting:__WEBPACK_IMPORTED_MODULE_2__state_state_responsible_action__["a" /* changeStateTableSetting */],navigateToTaskDetail:function navigateToTaskDetail(taskId){return Object(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["d" /* push */])('/task/detail/'+taskId);},navigateToProcessInstanceDetail:function navigateToProcessInstanceDetail(processInstanceId){return Object(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["d" /* push */])('/process/instance/view/'+processInstanceId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__StateResponsible__["a" /* default */]));

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeTaskTableSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeStateTableSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeUserSelection; });
/* unused harmony export getStateAnalyticsRequest */
/* unused harmony export getStateAnalyticsSuccess */
/* unused harmony export getStateAnalyticsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStateAnalytics; });
/* unused harmony export getStateLastChangedRequest */
/* unused harmony export getStateLastChangedSuccess */
/* unused harmony export getStateLastChangedError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStateLastChanged; });
/* unused harmony export getTaskByDueDateRequest */
/* unused harmony export getTaskByDueDateSuccess */
/* unused harmony export getTaskByDueDateError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTaskByDueDate; });
/* unused harmony export findTaskByWeekDiffRequest */
/* unused harmony export findTaskByWeekDiffSuccess */
/* unused harmony export findTaskByWeekDiffError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return findTaskByWeekDiff; });
/* unused harmony export findProcessInstanceByWeekDiffRequest */
/* unused harmony export findProcessInstanceByWeekDiffSuccess */
/* unused harmony export findProcessInstanceByWeekDiffError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findProcessInstanceByWeekDiff; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__ = __webpack_require__(42);
var changeTaskTableSetting=Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_1__type__["b" /* CHANGE_TASK_TABLE_SETTINGS */]);var changeStateTableSetting=Object(__WEBPACK_IMPORTED_MODULE_3__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_STATE_TABLE_SETTINGS */]);var changeUserSelection=function changeUserSelection(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* CHANGE_USER_SELECTION */],payload:{name:name,value:value}};};var getStateAnalyticsRequest=function getStateAnalyticsRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["k" /* GET_STATE_ANALYTICS_REQUEST */]};};var getStateAnalyticsSuccess=function getStateAnalyticsSuccess(stateAnalytics){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["l" /* GET_STATE_ANALYTICS_SUCCESS */],payload:{stateAnalytics:stateAnalytics}};};var getStateAnalyticsError=function getStateAnalyticsError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["j" /* GET_STATE_ANALYTICS_ERROR */],payload:{error:error}};};var getStateAnalytics=function getStateAnalytics(){return function(dispatch,getState){var state=getState();var userSelection=__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectUserSelection */](state);if(!userSelection.responsible){return;}dispatch(getStateAnalyticsRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/analytics/state-responsible',userSelection).then(function(stateAnalytics){dispatch(getStateAnalyticsSuccess(stateAnalytics));}).catch(function(error){dispatch(getStateAnalyticsError(error));});};};var getStateLastChangedRequest=function getStateLastChangedRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["n" /* GET_STATE_LAST_CHANGED_REQUEST */]};};var getStateLastChangedSuccess=function getStateLastChangedSuccess(stateByLastChangedList,stateName){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["o" /* GET_STATE_LAST_CHANGED_SUCCESS */],payload:{stateByLastChangedList:stateByLastChangedList,stateName:stateName}};};var getStateLastChangedError=function getStateLastChangedError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["m" /* GET_STATE_LAST_CHANGED_ERROR */],payload:{error:error}};};var getStateLastChanged=function getStateLastChanged(stateName){return function(dispatch,getState){var state=getState();var userSelection=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectUserSelection */](state),{stateName:stateName});dispatch(getStateLastChangedRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/analytics/state-last-changed',userSelection).then(function(stateByLastChangedList){dispatch(getStateLastChangedSuccess(stateByLastChangedList,stateName));}).catch(function(error){dispatch(getStateLastChangedError(error));});};};var getTaskByDueDateRequest=function getTaskByDueDateRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["q" /* GET_TASK_BY_DUE_DATE_REQUEST */]};};var getTaskByDueDateSuccess=function getTaskByDueDateSuccess(taskByDueDateList,taskName){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["r" /* GET_TASK_BY_DUE_DATE_SUCCESS */],payload:{taskByDueDateList:taskByDueDateList,taskName:taskName}};};var getTaskByDueDateError=function getTaskByDueDateError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["p" /* GET_TASK_BY_DUE_DATE_ERROR */],payload:{error:error}};};var getTaskByDueDate=function getTaskByDueDate(taskName){return function(dispatch,getState){var state=getState();var userSelection=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectUserSelection */](state),{taskName:taskName});dispatch(getTaskByDueDateRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/analytics/task-by-due-date',userSelection).then(function(taskByDueDateList){dispatch(getTaskByDueDateSuccess(taskByDueDateList,taskName));}).catch(function(error){dispatch(getTaskByDueDateError(error));});};};var findTaskByWeekDiffRequest=function findTaskByWeekDiffRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["h" /* FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST */]};};var findTaskByWeekDiffSuccess=function findTaskByWeekDiffSuccess(taskList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["i" /* FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS */],payload:{taskList:taskList}};};var findTaskByWeekDiffError=function findTaskByWeekDiffError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* FIND_TASK_BY_WEEK_DIFF_DATE_ERROR */],payload:{error:error}};};var findTaskByWeekDiff=function findTaskByWeekDiff(taskByDueDateListIndex){return function(dispatch,getState){var state=getState();var userSelection=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectUserSelection */](state),{taskName:__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectCurrentTaskName */](state),weekDiff:__WEBPACK_IMPORTED_MODULE_2__selector__["l" /* selectTaskWeekDiffByIndex */](state,taskByDueDateListIndex)});dispatch(findTaskByWeekDiffRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/analytics/task-by-week-diff',userSelection).then(function(taskList){dispatch(findTaskByWeekDiffSuccess(taskList));}).catch(function(error){dispatch(findTaskByWeekDiffError(error));});};};var findProcessInstanceByWeekDiffRequest=function findProcessInstanceByWeekDiffRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST */]};};var findProcessInstanceByWeekDiffSuccess=function findProcessInstanceByWeekDiffSuccess(processInstanceList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS */],payload:{processInstanceList:processInstanceList}};};var findProcessInstanceByWeekDiffError=function findProcessInstanceByWeekDiffError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR */],payload:{error:error}};};var findProcessInstanceByWeekDiff=function findProcessInstanceByWeekDiff(stateByDueDateListIndex){return function(dispatch,getState){var state=getState();var userSelection=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__selector__["m" /* selectUserSelection */](state),{stateName:__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectCurrentStateName */](state),weekDiff:__WEBPACK_IMPORTED_MODULE_2__selector__["h" /* selectStatekDiffByIndex */](state,stateByDueDateListIndex)});dispatch(findProcessInstanceByWeekDiffRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/analytics/process-instance-by-week-diff',userSelection).then(function(processInstanceList){dispatch(findProcessInstanceByWeekDiffSuccess(processInstanceList));}).catch(function(error){dispatch(findProcessInstanceByWeekDiffError(error));});};};

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StateResponsibleSelector__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CurrentStateAndTask__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StateLastChanged__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TaskByDueDate__ = __webpack_require__(1660);
var StateResponsible=function StateResponsible(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StateResponsibleSelector__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CurrentStateAndTask__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StateLastChanged__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TaskByDueDate__["a" /* default */],props));};StateResponsible.propTypes={stateAnalytics:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,stateByLastChangedList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,taskByDueDateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,taskList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,userSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,getStateAnalytics:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getStateLastChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getTaskByDueDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,findTaskByWeekDiff:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeUserSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,processNameList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(StateResponsible));

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_state_state_responsible_const__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__process_util_names__ = __webpack_require__(25);
var StateResponsibleSelector=function StateResponsibleSelector(_ref){var userSelection=_ref.userSelection,processNameList=_ref.processNameList,changeUserSelection=_ref.changeUserSelection,getStateAnalytics=_ref.getStateAnalytics;var processNameSelect=processNameList.map(function(name){return{id:name,value:Object(__WEBPACK_IMPORTED_MODULE_9__process_util_names__["d" /* renderProcessName */])(name)};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Process Dashboard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Responsible'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,name:'responsible',addEmpty:true,valueList:__WEBPACK_IMPORTED_MODULE_8__process_state_state_responsible_const__["b" /* STATE_RESPONSIBLE_SELECT */],onChange:function onChange(name,value){changeUserSelection(name,value);getStateAnalytics();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Process'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,name:'processName',addEmpty:true,valueList:processNameSelect,onChange:function onChange(name,value){value=value||null;changeUserSelection(name,value);getStateAnalytics();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Company'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,name:'companyCode',addEmpty:true,valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["a" /* COMPANY_CODE_SELECT_VALUE_LIST */],onChange:function onChange(name,value){value=value||null;changeUserSelection(name,value);getStateAnalytics();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_LabelInput__["a" /* default */],{label:'Country'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{object:userSelection,name:'countryCode',addEmpty:true,valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_const__["e" /* COUNTRY_CODE_LIST */],onChange:function onChange(name,value){value=value||null;changeUserSelection(name,value);getStateAnalytics();}})))));};StateResponsibleSelector.propTypes={userSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,getStateAnalytics:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeUserSelection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,processNameList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StateResponsibleSelector);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_util_names__ = __webpack_require__(25);
var DOUGHNUT_OPTIONS={legend:{display:false}};var COLOR_LIST=['rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)','rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)'];var compileDoughnutData=function compileDoughnutData(stateList,property){return{labels:stateList.map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_5__process_util_names__["f" /* renderStateName */])(entry[property]);}),datasets:[{data:stateList.map(function(entry){return entry.count;}),backgroundColor:COLOR_LIST,hoverBackgroundColor:COLOR_LIST}]};};var CurrentStateAndTask=function CurrentStateAndTask(_ref){var stateAnalytics=_ref.stateAnalytics,getStateLastChanged=_ref.getStateLastChanged,getTaskByDueDate=_ref.getTaskByDueDate;if(!stateAnalytics||!stateAnalytics.state){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Current States & Tasks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Current States'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__["b" /* Doughnut */],{options:DOUGHNUT_OPTIONS,data:compileDoughnutData(stateAnalytics.state,'currentStateName')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Current Tasks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__["b" /* Doughnut */],{options:DOUGHNUT_OPTIONS,data:compileDoughnutData(stateAnalytics.task,'name')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Overdue Tasks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__["b" /* Doughnut */],{options:DOUGHNUT_OPTIONS,data:compileDoughnutData(stateAnalytics.taskOverdue,'name')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StateTable,{stateList:stateAnalytics.state,getStateLastChanged:getStateLastChanged})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TaskTable,{taskList:stateAnalytics.task,getTaskByDueDate:getTaskByDueDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TaskTable,{taskList:stateAnalytics.taskOverdue,getTaskByDueDate:getTaskByDueDate}))));};var StateTable=function StateTable(_ref2){var stateList=_ref2.stateList,getStateLastChanged=_ref2.getStateLastChanged;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'State'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'align-right',style:{width:'15%'}},'#'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,stateList.map(function(state,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:'pointer'},onClick:function onClick(){getStateLastChanged(state.currentStateName);}},Object(__WEBPACK_IMPORTED_MODULE_5__process_util_names__["f" /* renderStateName */])(state.currentStateName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},state.count));})));};var TaskTable=function TaskTable(_ref3){var taskList=_ref3.taskList,getTaskByDueDate=_ref3.getTaskByDueDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'align-right',style:{width:'15%'}},'#'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,taskList.map(function(task,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:'pointer'},onClick:function onClick(){getTaskByDueDate(task.name);}},' ',Object(__WEBPACK_IMPORTED_MODULE_5__process_util_names__["g" /* renderTaskName */])(task.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-right'},task.count));})));};/* harmony default export */ __webpack_exports__["a"] = (CurrentStateAndTask);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__process_instance_column_list__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process_util_names__ = __webpack_require__(25);
var COLOR_LIST=['rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)','rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)'];var compileBarData=function compileBarData(stateByLastChangedList){return{labels:stateByLastChangedList.map(function(entry){return entry.weekDiff;}),datasets:[{data:stateByLastChangedList.map(function(entry){return entry.count;}),backgroundColor:COLOR_LIST,hoverBackgroundColor:COLOR_LIST}]};};var ProcessInstanceList=function ProcessInstanceList(_ref){var processInstanceList=_ref.processInstanceList,changeStateTableSetting=_ref.changeStateTableSetting,stateTableSetting=_ref.stateTableSetting,navigateToProcessInstanceDetail=_ref.navigateToProcessInstanceDetail;if(!processInstanceList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:'Process Instances'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Table__["a" /* default */],{rowsPerPage:0,columnList:__WEBPACK_IMPORTED_MODULE_5__process_instance_column_list__["a" /* default */],rowList:processInstanceList,changeTableSetting:changeStateTableSetting,tableSetting:stateTableSetting,idProperty:'id',onRowClick:function onRowClick(processInstance){navigateToProcessInstanceDetail(processInstance.id);}}))));};var StateLastChanged=function StateLastChanged(_ref2){var stateByLastChangedList=_ref2.stateByLastChangedList,currentStateName=_ref2.currentStateName,findProcessInstanceByWeekDiff=_ref2.findProcessInstanceByWeekDiff,navigateToProcessInstanceDetail=_ref2.navigateToProcessInstanceDetail,stateTableSetting=_ref2.stateTableSetting,changeStateTableSetting=_ref2.changeStateTableSetting,processInstanceList=_ref2.processInstanceList;if(!stateByLastChangedList||!stateByLastChangedList.length){return null;}var title='State Last Changed : '+Object(__WEBPACK_IMPORTED_MODULE_7__process_util_names__["f" /* renderStateName */])(currentStateName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Calendar Weeks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_chartjs_2__["a" /* Bar */],{getElementAtEvent:function getElementAtEvent(dataset){findProcessInstanceByWeekDiff(dataset[0]._index);},options:{legend:{display:false},scales:{yAxes:[{ticks:{beginAtZero:true}}]}},data:compileBarData(stateByLastChangedList)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProcessInstanceList,{processInstanceList:processInstanceList,changeStateTableSetting:changeStateTableSetting,navigateToProcessInstanceDetail:navigateToProcessInstanceDetail,stateTableSetting:stateTableSetting}));};/* harmony default export */ __webpack_exports__["a"] = (StateLastChanged);

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_component_VipIcon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__process_util_names__ = __webpack_require__(25);
/* harmony default export */ __webpack_exports__["a"] = ([{property:'vip',header:'VIP',width:'45',renderer:function renderer(processInstance){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__form_component_VipIcon__["a" /* default */],{active:processInstance.vip});}},{property:'started',header:'Started',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('started'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('started')},{property:'lastStatusChange',header:'Last Status Change',comparator:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateComparator('lastStatusChange'),renderer:__WEBPACK_IMPORTED_MODULE_2__form_component_Table__["a" /* default */].dateTimeRenderer('lastStatusChange')},{property:'processName',header:'process Name',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__process_util_names__["d" /* renderProcessName */])(processInstance.processName);},sortValue:function sortValue(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__process_util_names__["d" /* renderProcessName */])(processInstance.processName);}},{property:'displayName',header:'display Name'}]);

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__process_component_task_list_tasklist_column_list__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__process_util_names__ = __webpack_require__(25);
var COLOR_LIST=['rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)','rgb(0,145,231)','rgb(255,193,44)','rgb(255,138,0)','rgb(255,63,107)','rgb(18,178,178)','rgb(133,70,255)','rgb(186,188,193)'];var compileBarData=function compileBarData(taskByDueDateList){return{labels:taskByDueDateList.map(function(entry){return entry.weekDiff;}),datasets:[{data:taskByDueDateList.map(function(entry){return entry.count;}),backgroundColor:COLOR_LIST,hoverBackgroundColor:COLOR_LIST}]};};var TaskList=function TaskList(_ref){var taskList=_ref.taskList,changeTaskTableSetting=_ref.changeTaskTableSetting,taskTableSetting=_ref.taskTableSetting,navigateToTaskDetail=_ref.navigateToTaskDetail;if(!taskList){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Tasklist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Table__["a" /* default */],{rowsPerPage:0,columnList:Object(__WEBPACK_IMPORTED_MODULE_6__process_component_task_list_tasklist_column_list__["a" /* default */])(true,false),rowList:taskList,changeTableSetting:changeTaskTableSetting,tableSetting:taskTableSetting,idProperty:'id',onRowClick:function onRowClick(task){navigateToTaskDetail(task.id);}}))));};var TaskByDueDate=function TaskByDueDate(_ref2){var taskByDueDateList=_ref2.taskByDueDateList,currentTaskName=_ref2.currentTaskName,findTaskByWeekDiff=_ref2.findTaskByWeekDiff,taskList=_ref2.taskList,changeTaskTableSetting=_ref2.changeTaskTableSetting,taskTableSetting=_ref2.taskTableSetting,navigateToTaskDetail=_ref2.navigateToTaskDetail;if(!taskByDueDateList||!taskByDueDateList.length){return null;}var title='Task Due : '+Object(__WEBPACK_IMPORTED_MODULE_8__process_util_names__["f" /* renderStateName */])(currentTaskName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Calendar Weeks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_chartjs_2__["a" /* Bar */],{getElementAtEvent:function getElementAtEvent(dataset){findTaskByWeekDiff(dataset[0]._index);},options:{legend:{display:false},scales:{yAxes:[{ticks:{beginAtZero:true}}]}},data:compileBarData(taskByDueDateList)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TaskList,{taskList:taskList,changeTaskTableSetting:changeTaskTableSetting,navigateToTaskDetail:navigateToTaskDetail,taskTableSetting:taskTableSetting}));};TaskByDueDate.propTypes={taskByDueDateList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,findTaskByWeekDiff:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,taskList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (TaskByDueDate);

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_task_definition_action__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_task_definition_selector__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskDefinition__ = __webpack_require__(1663);
var mapStateToProps=function mapStateToProps(state){return{taskDefinitionList:__WEBPACK_IMPORTED_MODULE_2__state_task_definition_selector__["b" /* selectTaskDefinitionList */](state)};};var mapDispatchToProps={findTaskDefinitionList:__WEBPACK_IMPORTED_MODULE_1__state_task_definition_action__["b" /* findTaskDefinitionList */],changeTaskDefinition:__WEBPACK_IMPORTED_MODULE_1__state_task_definition_action__["a" /* changeTaskDefinition */],saveTaskDefinition:__WEBPACK_IMPORTED_MODULE_1__state_task_definition_action__["c" /* saveTaskDefinition */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__TaskDefinition__["a" /* default */]));

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findTaskDefinitionListRequest */
/* unused harmony export findTaskDefinitionListSuccess */
/* unused harmony export findTaskDefinitionListError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findTaskDefinitionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTaskDefinition; });
/* unused harmony export saveTaskDefinitionRequest */
/* unused harmony export saveTaskDefinitionSuccess */
/* unused harmony export saveTaskDefinitionError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveTaskDefinition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(582);
var findTaskDefinitionListRequest=function findTaskDefinitionListRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* FIND_TASK_DEFINITION_LIST_REQUEST */]};};var findTaskDefinitionListSuccess=function findTaskDefinitionListSuccess(taskDefinitionList){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* FIND_TASK_DEFINITION_LIST_SUCCESS */],payload:{taskDefinitionList:taskDefinitionList}};};var findTaskDefinitionListError=function findTaskDefinitionListError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* FIND_TASK_DEFINITION_LIST_ERROR */],payload:{error:error}};};var findTaskDefinitionList=function findTaskDefinitionList(){return function(dispatch,getState){dispatch(findTaskDefinitionListRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/task-definition/find-all').then(function(taskDefinitionList){dispatch(findTaskDefinitionListSuccess(taskDefinitionList));}).catch(function(error){dispatch(findTaskDefinitionListError(error));});};};var changeTaskDefinition=function changeTaskDefinition(taskDefinitionId,name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_TASK_DEFINITION */],payload:{taskDefinitionId:taskDefinitionId,name:name,value:value}};};var saveTaskDefinitionRequest=function saveTaskDefinitionRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* SAVE_TASK_DEFINITION_REQUEST */]};};var saveTaskDefinitionSuccess=function saveTaskDefinitionSuccess(stateResponsible){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* SAVE_TASK_DEFINITION_SUCCESS */],payload:{stateResponsible:stateResponsible}};};var saveTaskDefinitionError=function saveTaskDefinitionError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* SAVE_TASK_DEFINITION_ERROR */],payload:{error:error}};};var saveTaskDefinition=function saveTaskDefinition(taskDefinitionId){return function(dispatch,getState){var state=getState();var taskDefinition=__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectTaskDefinitionById */](state,taskDefinitionId);if(!taskDefinition){return;}dispatch(saveTaskDefinitionRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/process/task-definition/save',taskDefinition).then(function(taskDefinition){dispatch(saveTaskDefinitionSuccess(taskDefinition));}).catch(function(error){dispatch(saveTaskDefinitionError(error));});};};

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_task_definition_const__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__security_state_auth_const__ = __webpack_require__(28);
var formatMultiSelect=function formatMultiSelect(itemList){return itemList.map(function(item){return{value:item,label:item};});};var ROLE_LIST_INTERNAL_SELECT=formatMultiSelect(__WEBPACK_IMPORTED_MODULE_9__security_state_auth_const__["v" /* ROLE_LIST_EMPLOYEE */]);var ROLE_LIST_PARTNER_SELECT=formatMultiSelect(__WEBPACK_IMPORTED_MODULE_9__security_state_auth_const__["x" /* ROLE_LIST_PARTNER */]);var TaskDefinition=function TaskDefinition(_ref){var taskDefinition=_ref.taskDefinition,changeTaskDefinition=_ref.changeTaskDefinition,saveTaskDefinition=_ref.saveTaskDefinition;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_names__["d" /* renderProcessName */])(taskDefinition.processName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_5__util_names__["g" /* renderTaskName */])(taskDefinition.taskName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:taskDefinition,name:'external',addEmpty:true,valueList:__WEBPACK_IMPORTED_MODULE_7__state_task_definition_const__["a" /* EXTERNAL_VALUE_LIST */],onChange:function onChange(name,value){changeTaskDefinition(taskDefinition.id,name,value);saveTaskDefinition(taskDefinition.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:taskDefinition,name:'sla',valueList:__WEBPACK_IMPORTED_MODULE_7__state_task_definition_const__["d" /* SLA_VALUE_LIST */],type:'int',onChange:function onChange(name,value){changeTaskDefinition(taskDefinition.id,name,value);saveTaskDefinition(taskDefinition.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:taskDefinition,name:'priority',valueList:__WEBPACK_IMPORTED_MODULE_7__state_task_definition_const__["b" /* PRIORITY_VALUE_LIST */],type:'int',onChange:function onChange(name,value){changeTaskDefinition(taskDefinition.id,name,value);saveTaskDefinition(taskDefinition.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'400'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{isMulti:true,defaultValue:formatMultiSelect(taskDefinition.roleList),onChange:function onChange(data){var roleList=data.map(function(item){return item.value;});changeTaskDefinition(taskDefinition.id,'roleList',roleList);saveTaskDefinition(taskDefinition.id);},options:taskDefinition.external?ROLE_LIST_PARTNER_SELECT:ROLE_LIST_INTERNAL_SELECT,classNamePrefix:'sunshine-multi-select'})));};var TaskDefinitionList=function TaskDefinitionList(_ref2){var taskDefinitionList=_ref2.taskDefinitionList,changeTaskDefinition=_ref2.changeTaskDefinition,saveTaskDefinition=_ref2.saveTaskDefinition;if(taskDefinitionList.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Task Definition'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table-no-overflow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Process name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Task name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'External'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SLA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Priority'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'RoleList'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,taskDefinitionList.map(function(taskDefinition){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TaskDefinition,{key:taskDefinition.id,taskDefinition:taskDefinition,changeTaskDefinition:changeTaskDefinition,saveTaskDefinition:saveTaskDefinition});}))));};TaskDefinitionList.propTypes={taskDefinitionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,findTaskDefinitionList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeTaskDefinition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveTaskDefinition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findTaskDefinitionList();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(TaskDefinitionList)));

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_reassign_action__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Reassign__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_state_selector__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state){return{reassignment:__WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__["i" /* selectReassignment */](state),isReassignmentTreatingPhysician:__WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__["f" /* selectIsReassignmentTreatingPhysician */](state),isReassignmentPartnerPhysician:__WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__["e" /* selectIsReassignmentPartnerPhysician */](state),partnerPhysicianList:Object(__WEBPACK_IMPORTED_MODULE_4__globals_state_selector__["selectPhysicianList"])(state),treatingPhysicianList:Object(__WEBPACK_IMPORTED_MODULE_4__globals_state_selector__["selectTreatingPhysicianList"])(state),canProceed:__WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__["a" /* selectCanProceed */](state),fetching:__WEBPACK_IMPORTED_MODULE_2__state_reassign_selector__["d" /* selectIsFetching */](state)};};var mapDispatchToProps={changeReassignment:__WEBPACK_IMPORTED_MODULE_1__state_reassign_action__["a" /* changeReassignment */],reassignToPartnerPhysician:__WEBPACK_IMPORTED_MODULE_1__state_reassign_action__["b" /* reassignToPartnerPhysician */],reassignTreatingPhysician:__WEBPACK_IMPORTED_MODULE_1__state_reassign_action__["c" /* reassignTreatingPhysician */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Reassign__["a" /* default */]));

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeReassignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reassignTreatingPhysician; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reassignToPartnerPhysician; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(288);
var changeReassignment=function changeReassignment(name,value){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["a" /* CHANGE_REASSIGNMENT */],payload:{name:name,value:value}};};var reassignTreatingPhysicianRequest=function reassignTreatingPhysicianRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["f" /* REASSIGN_TREATING_PHYSICIAN_REQUEST */]};};var reassignTreatingPhysicianSuccess=function reassignTreatingPhysicianSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["g" /* REASSIGN_TREATING_PHYSICIAN_SUCCESS */]};};var reassignTreatingPhysicianError=function reassignTreatingPhysicianError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["e" /* REASSIGN_TREATING_PHYSICIAN_ERROR */],payload:{error:error}};};var reassignTreatingPhysician=function reassignTreatingPhysician(){return function(dispatch,getState){var state=getState();var confirmation=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectConfirmationLegalRequirementsMet */](state);var currentTreatingPhysicianId=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectCurrentTreatingPhysicianId */](state);var newTreatingPhysicianId=__WEBPACK_IMPORTED_MODULE_2__selector__["g" /* selectNewTreatingPhysicianId */](state);if(!confirmation||!currentTreatingPhysicianId||!newTreatingPhysicianId){return;}dispatch(reassignTreatingPhysicianRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/customer/reassign-treating-physician',{currentTreatingPhysicianId:currentTreatingPhysicianId,newTreatingPhysicianId:newTreatingPhysicianId}).then(function(){dispatch(reassignTreatingPhysicianSuccess());}).catch(function(error){dispatch(reassignTreatingPhysicianError(error));});};};var reassignToPartnerPhysicianRequest=function reassignToPartnerPhysicianRequest(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["c" /* REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST */]};};var reassignToPartnerPhysicianSuccess=function reassignToPartnerPhysicianSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["d" /* REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS */]};};var reassignToPartnerPhysicianError=function reassignToPartnerPhysicianError(error){return{type:__WEBPACK_IMPORTED_MODULE_1__type__["b" /* REASSIGN_TO_PARTNER_PHYSICIAN_ERROR */],payload:{error:error}};};var reassignToPartnerPhysician=function reassignToPartnerPhysician(){return function(dispatch,getState){var state=getState();var confirmation=__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* selectConfirmationLegalRequirementsMet */](state);var currentTreatingPhysicianId=__WEBPACK_IMPORTED_MODULE_2__selector__["c" /* selectCurrentTreatingPhysicianId */](state);var partnerPhysicianId=__WEBPACK_IMPORTED_MODULE_2__selector__["h" /* selectPartnerPhysicianId */](state);if(!confirmation||!currentTreatingPhysicianId||!partnerPhysicianId){return;}dispatch(reassignToPartnerPhysicianRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["c" /* post */])('/api/customer/reassign-to-partner-physician',{currentTreatingPhysicianId:currentTreatingPhysicianId,partnerPhysicianId:partnerPhysicianId}).then(function(){dispatch(reassignToPartnerPhysicianSuccess());}).catch(function(error){dispatch(reassignToPartnerPhysicianError(error));});};};

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_component_Select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_reassign_const__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_block_ui__ = __webpack_require__(69);
var Reassign=function Reassign(_ref){var fetching=_ref.fetching,reassignment=_ref.reassignment,changeReassignment=_ref.changeReassignment,reassignTreatingPhysician=_ref.reassignTreatingPhysician,reassignToPartnerPhysician=_ref.reassignToPartnerPhysician,isReassignmentTreatingPhysician=_ref.isReassignmentTreatingPhysician,isReassignmentPartnerPhysician=_ref.isReassignmentPartnerPhysician,partnerPhysicianList=_ref.partnerPhysicianList,treatingPhysicianList=_ref.treatingPhysicianList,canProceed=_ref.canProceed;var proceed=isReassignmentTreatingPhysician?reassignTreatingPhysician:reassignToPartnerPhysician;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Reassign to'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Reassign to'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:reassignment,name:'reassignTo',valueList:__WEBPACK_IMPORTED_MODULE_8__state_reassign_const__["c" /* REASSIGNMENT_VALUE_LIST */],addEmpty:true,onChange:changeReassignment}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Current Treating Physician'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:reassignment,name:'currentTreatingPhysicianId',valueList:treatingPhysicianList,renderer:function renderer(_ref2){var firstName=_ref2.firstName,lastName=_ref2.lastName;return firstName+' '+lastName;},addEmpty:true,onChange:changeReassignment}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:6},isReassignmentTreatingPhysician&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'New Treating Physician'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:reassignment,name:'newTreatingPhysicianId',valueList:treatingPhysicianList,renderer:function renderer(_ref3){var firstName=_ref3.firstName,lastName=_ref3.lastName;return firstName+' '+lastName;},addEmpty:true,onChange:changeReassignment})),isReassignmentPartnerPhysician&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_LabelInput__["a" /* default */],{label:'Partner Physician'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__form_component_Select__["a" /* default */],{object:reassignment,name:'partnerPhysicianId',valueList:partnerPhysicianList,renderer:function renderer(_ref4){var displayName=_ref4.displayName;return displayName;},addEmpty:true,onChange:changeReassignment})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__form_component_Checkbox__["a" /* default */],{object:reassignment,name:'confirmationLegalRequirementsMet',onChange:changeReassignment},'I confirm, that 1.) the change of physician meets all legal requirements. 2.) I am stored as the person who initiated the physician change.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!canProceed,className:'btn btn-danger btn-sm',onClick:proceed},'reassign physician')))));};Reassign.propTypes={reassignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isReassignmentTreatingPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isReassignmentPartnerPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changeReassignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,reassignToPartnerPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,reassignTreatingPhysician:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,partnerPhysicianList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,treatingPhysicianList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,canProceed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(Reassign));

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_manage_selector__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_manage_action__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManageRoleWidgets__ = __webpack_require__(1668);
var mapStateToProps=function mapStateToProps(state,props){return{currentRole:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["a" /* selectCurrentRole */](state),currentRoleId:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["b" /* selectCurrentRoleId */](state),roleList:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["h" /* selectRoleList */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_1__state_manage_selector__["j" /* selectValidationMessageList */](state)};};var mapDispatchToProps={changeCurrentRoleId:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["a" /* changeCurrentRoleId */],findAllRole:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["h" /* findAllRole */],toggleRoleWidgetAccess:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["n" /* toggleRoleWidgetAccess */],saveRole:__WEBPACK_IMPORTED_MODULE_2__state_manage_action__["k" /* saveRole */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ManageRoleWidgets__["a" /* default */]));

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RoleSelection__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RoleWidget__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__ = __webpack_require__(7);
var ManageRoleWidgets=function ManageRoleWidgets(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layout_component_ContentBox__["a" /* default */],{title:'Manage role widgets'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RoleSelection__["a" /* default */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__bootstrap_component_Row__["a" /* default */],{top:'M'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RoleWidget__["a" /* default */],props)))));};ManageRoleWidgets.propTypes={roleList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,findAllRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeCurrentRoleId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,toggleRoleWidgetAccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,changeRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.findAllRole();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(ManageRoleWidgets)));

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Select__ = __webpack_require__(16);
var RoleSelection=function RoleSelection(_ref){var roleList=_ref.roleList,currentRoleId=_ref.currentRoleId,changeCurrentRoleId=_ref.changeCurrentRoleId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Column__["a" /* default */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__form_component_LabelInput__["a" /* default */],{label:'Choose Role'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Select__["a" /* default */],{style:{height:'30px'},object:{currentRoleId:currentRoleId},name:'currentRoleId',renderer:function renderer(role){return role.role;},valueList:roleList,addEmpty:true,onChange:changeCurrentRoleId}))));};RoleSelection.propTypes={roleList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,currentRoleId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,changeCurrentRoleId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RoleSelection);

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_widgets__ = __webpack_require__(579);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var RoleWidget=function RoleWidget(_ref){var currentRole=_ref.currentRole,toggleRoleWidgetAccess=_ref.toggleRoleWidgetAccess,saveRole=_ref.saveRole;if(!currentRole){return null;}var widgetList=__WEBPACK_IMPORTED_MODULE_3__constant_widgets__["a" /* WIDGET_LIST */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Widget access',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object.entries(widgetList).map(function(_ref2){var _ref3=_slicedToArray(_ref2,2),widgetId=_ref3[0],widgetName=_ref3[1];var hasWidgetAccess=currentRole.widgetList.indexOf(widgetId)!==-1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_component_Checkbox__["a" /* default */],{key:widgetId,object:{hasWidgetAccess:hasWidgetAccess},onChange:function onChange(){toggleRoleWidgetAccess(widgetId,!hasWidgetAccess);saveRole();},name:'hasWidgetAccess'},widgetName);}));};RoleWidget.propTypes={currentRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,toggleRoleWidgetAccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveRole:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RoleWidget);

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FoilOverview__ = __webpack_require__(1672);
var mapStateToProps=function mapStateToProps(){return{};};var mapDispatchToProps={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FoilOverview__["a" /* default */]));

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__csv_upload_FoilMetadataUploadContainer__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_table_FoilInfoTableContainer__ = __webpack_require__(1678);
var FoilOverview=function FoilOverview(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__csv_upload_FoilMetadataUploadContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__info_table_FoilInfoTableContainer__["a" /* default */],null));};FoilOverview.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(FoilOverview));

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_overview_csv_upload_action__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_overview_csv_upload_selector__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FoilMetadataUpload__ = __webpack_require__(1676);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_overview_csv_upload_selector__["b" /* selectOwnState */](state),{fetching:__WEBPACK_IMPORTED_MODULE_2__state_overview_csv_upload_selector__["a" /* selectIsFetching */](state)});};var mapDispatchToProps={uploadFoilCSV:__WEBPACK_IMPORTED_MODULE_1__state_overview_csv_upload_action__["a" /* uploadFoilCSV */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__FoilMetadataUpload__["a" /* default */]));

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uploadCSVRequest */
/* unused harmony export uploadCSVError */
/* unused harmony export uploadCSVSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uploadFoilCSV; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_table_action__ = __webpack_require__(584);
var uploadCSVRequest=function uploadCSVRequest(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* UPLOAD_CSV_REQUEST */]};};var uploadCSVError=function uploadCSVError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* UPLOAD_CSV_ERROR */],payload:{error:error}};};var uploadCSVSuccess=function uploadCSVSuccess(){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* UPLOAD_CSV_SUCCESS */]};};var uploadFoilCSV=function uploadFoilCSV(file){return function(dispatch){dispatch(uploadCSVRequest());var data=new FormData();data.append('file',file);Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* uploadCSV */])(data).then(function(response){return response.json().then(function(data){if(response.ok){dispatch(uploadCSVSuccess());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__info_table_action__["b" /* getFoilList */])());}else{dispatch(uploadCSVError(data));}});}).catch(function(){dispatch(uploadCSVError({error:'Server error'}));});};};

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectIsFetching; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(585);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_0__const__["a" /* REDUCER_NAME */]];};var selectIsFetching=function selectIsFetching(state){return selectOwnState(state).fetching;};

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_block_ui__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UploadValidation__ = __webpack_require__(1677);
var dropzoneStyle={width:'100%',height:'200px',borderWidth:'2px',borderColor:'rgb(102, 102, 102)',borderStyle:'dashed',borderRadius:'5px',padding:'35px',textAlign:'center',cursor:'pointer',marginTop:'32px'};var FoilMetadataUpload=function FoilMetadataUpload(_ref){var uploadFoilCSV=_ref.uploadFoilCSV,fetching=_ref.fetching,error=_ref.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_block_ui__["a" /* default */],{tag:'div',blocking:fetching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Foil Metadata Upload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UploadValidation__["a" /* default */],{error:error}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{multiple:false,style:dropzoneStyle,disablePreview:true,onDrop:function onDrop(fileList){uploadFoilCSV(fileList[0]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click to upload CSV'))))));};FoilMetadataUpload.propTypes={uploadFoilCSV:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FoilMetadataUpload);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_component_ValidationMessageList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var getCustomErrorValidationObject=function getCustomErrorValidationObject(text){return{messageId:text,message:text};};var getMissingColumnsValidationObject=function getMissingColumnsValidationObject(missingColumnsText){return{messageId:'missing_columns',message:'Columns are missing: '+missingColumnsText};};var getMissingValuesText=function getMissingValuesText(missingValues){return'Missing values ('+missingValues+')';};var getUnknownValuesText=function getUnknownValuesText(unknownValues){return'Not valid data ('+unknownValues+')';};var getMissingAndUnknownValuesValidationObject=function getMissingAndUnknownValuesValidationObject(key,error){var rowNumber=key.replace('entry_num','');var rowText='Row #'+rowNumber+': ';var errorText=[];if(error[key]['missingValues']){var missingValues=error[key]['missingValues'].join(', ');errorText.push(getMissingValuesText(missingValues));}if(error[key]['unknownValues']){var unknownValues=error[key]['unknownValues'].join(', ');errorText.push(getUnknownValuesText(unknownValues));}return{messageId:key,message:rowText+errorText.join(', ')};};var getUnknownCombinationValidationObject=function getUnknownCombinationValidationObject(key){var rowNumber=key.replace('entry_num','');return{messageId:key,message:'Row #'+rowNumber+': Unknown combination of manufacturer, thickness and type'};};var buildValidationMessageList=function buildValidationMessageList(error){var validationMessageList=[];if(error.error){validationMessageList.push(getCustomErrorValidationObject(error.error));return validationMessageList;}if(error.missing_columns){validationMessageList.push(getMissingColumnsValidationObject(error.missing_columns.join(', ')));return validationMessageList;}if(error.duplicates){error.duplicates.forEach(function(entry){validationMessageList.push(getCustomErrorValidationObject(entry));});return validationMessageList;}Object.keys(error).forEach(function(key){if(error[key]['missingValues']||error[key]['unknownValues']){var validationObject=getMissingAndUnknownValuesValidationObject(key,error);validationMessageList.push(validationObject);}});if(validationMessageList.length>0){return validationMessageList;}Object.keys(error).forEach(function(key){if(error[key]['unknownCombination']){var validationObject=getUnknownCombinationValidationObject(key);validationMessageList.push(validationObject);}});return validationMessageList;};var Validation=function Validation(_ref){var error=_ref.error;if(!error)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__validation_component_ValidationMessageList__["a" /* default */],{validationMessageList:buildValidationMessageList(error)});};/* harmony default export */ __webpack_exports__["a"] = (Validation);

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_overview_info_table_action__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_overview_info_table_selector__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FoilInfoTable__ = __webpack_require__(1680);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},__WEBPACK_IMPORTED_MODULE_2__state_overview_info_table_selector__["a" /* selectOwnState */](state),{tableSetting:__WEBPACK_IMPORTED_MODULE_2__state_overview_info_table_selector__["b" /* selectTableSetting */](state)});};var mapDispatchToProps={getFoilList:__WEBPACK_IMPORTED_MODULE_1__state_overview_info_table_action__["b" /* getFoilList */],changeTableSetting:__WEBPACK_IMPORTED_MODULE_1__state_overview_info_table_action__["a" /* changeTableSetting */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__FoilInfoTable__["a" /* default */]));

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectOwnState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectTableSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(222);
var selectOwnState=function selectOwnState(state){return Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* selectOwnState */])(state)[__WEBPACK_IMPORTED_MODULE_2__const__["a" /* REDUCER_NAME */]];};var selectTableSetting=Object(__WEBPACK_IMPORTED_MODULE_0__form_state_table_state_helper__["d" /* createTableSettingSelector */])(selectOwnState);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(19);
var getColumnList=function getColumnList(){var columnList=[];columnList.push({property:'manufacturer',header:'Manufaturer',renderer:function renderer(foilSupply){return foilSupply.foilName.manufacturer;},sortValue:function sortValue(foilSupply){return foilSupply.foilName.manufacturer;}});columnList.push({property:'thickness',header:'Thickness',renderer:function renderer(foilSupply){return foilSupply.foilName.thickness;},sortValue:function sortValue(foilSupply){return foilSupply.foilName.thickness;}});columnList.push({property:'type',header:'Type',renderer:function renderer(foilSupply){return foilSupply.foilName.type;},sortValue:function sortValue(foilSupply){return foilSupply.foilName.type;}});columnList.push({property:'lot',header:'Lot'});columnList.push({property:'dateSetToActive',header:'Date set to Active',comparator:__WEBPACK_IMPORTED_MODULE_5__form_component_Table__["a" /* default */].dateComparator('dateSetToActive'),renderer:__WEBPACK_IMPORTED_MODULE_5__form_component_Table__["a" /* default */].dateTimeRenderer('dateSetToActive')});columnList.push({property:'dateSetToInactive',header:'Date set to Inactive',comparator:__WEBPACK_IMPORTED_MODULE_5__form_component_Table__["a" /* default */].dateComparator('dateSetToInactive'),renderer:__WEBPACK_IMPORTED_MODULE_5__form_component_Table__["a" /* default */].dateTimeRenderer('dateSetToInactive')});columnList.push({property:'status',header:'Status'});return columnList;};var FoilInfoTable=function FoilInfoTable(_ref){var foilList=_ref.foilList,tableSetting=_ref.tableSetting,changeTableSetting=_ref.changeTableSetting;var columnList=getColumnList();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layout_component_ContentBox__["a" /* default */],{title:'Foil Information'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__form_component_Table__["a" /* default */],{columnList:columnList,rowList:foilList,changeTableSetting:changeTableSetting,tableSetting:tableSetting,idProperty:'id'}))));};FoilInfoTable.propTypes={foilList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,tableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeTableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,getFoilList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.getFoilList();}})(FoilInfoTable));

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["d" /* selectImplant3dScanTable */](state),type:'implant-3d-scan'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["J" /* initialTableQueryImplant3dScan */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["d" /* changeFilterImplant3dScan */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_45" /* toggleSortImplant3dScan */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_29" /* toggleMultiSortImplant3dScan */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["t" /* gotoPageImplant3dScan */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["Z" /* initialTableSettingsImplant3dScan */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_14" /* toggleColumnVisibilityImplant3dScan */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["e" /* selectImplantPlanTable */](state),type:'implant-plan'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["K" /* initialTableQueryImplantPlan */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["e" /* changeFilterImplantPlan */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_46" /* toggleSortImplantPlan */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_30" /* toggleMultiSortImplantPlan */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["u" /* gotoPageImplantPlan */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_0" /* initialTableSettingsImplantPlan */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_15" /* toggleColumnVisibilityImplantPlan */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["f" /* selectImplantTreatmentTable */](state),type:'implant-treatment'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["L" /* initialTableQueryImplantTreatment */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["f" /* changeFilterImplantTreatment */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_47" /* toggleSortImplantTreatment */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_31" /* toggleMultiSortImplantTreatment */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["v" /* gotoPageImplantTreatment */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_1" /* initialTableSettingsImplantTreatment */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_16" /* toggleColumnVisibilityImplantTreatment */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PartnerSearch__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_state_selector__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["b" /* tableSelectorPartner */](state),isTablet:Object(__WEBPACK_IMPORTED_MODULE_5__layout_state_selector__["c" /* selectIsTablet */])(state),isPartner:Object(__WEBPACK_IMPORTED_MODULE_6__security_state_auth_selector__["k" /* selectIsPartner */])(state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["c" /* initialTableQueryPartner */],initialTableSettings:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["d" /* initialTableSettings */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["e" /* toggleColumnVisibility */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["a" /* changeFilterPartner */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["g" /* toggleSortPartner */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["f" /* toggleMultiSortPartner */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["b" /* gotoPagePartner */],navigateToPartner:function navigateToPartner(partnerId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/partner/edit/'+partnerId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__PartnerSearch__["a" /* default */]));

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialTableQueryPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFilterPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleSortPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleMultiSortPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gotoPagePartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialTableSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleColumnVisibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(586);
var initialTableQueryPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);var changeFilterPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);var toggleSortPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);var toggleMultiSortPartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);var gotoPagePartner=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);var initialTableSettings=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);var toggleColumnVisibility=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* tableSelectorPartner */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* PARTNER_TABLE */]);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_component_Table__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partner_column_list__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_languageConstants__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__table_component_TableColumnSelector__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(49);
var PartnerSearch=function PartnerSearch(_ref){var tableData=_ref.tableData,changeFilter=_ref.changeFilter,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,gotoPage=_ref.gotoPage,navigateToPartner=_ref.navigateToPartner,toggleColumnVisibility=_ref.toggleColumnVisibility;var columnList=Object(__WEBPACK_IMPORTED_MODULE_6__partner_column_list__["a" /* default */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Partners - Store / Clinics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__bootstrap_component_Row__["a" /* default */],{bottom:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__bootstrap_component_Column__["a" /* default */],{size:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["a" /* Link */],{to:'/partner/add/','class':'btn btn-primary'},'Add Partner'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_component_TableColumnSelector__["a" /* default */],{resultsNumber:tableData.objectList.length,hiddenColumns:tableData.hiddenColumns,columnList:columnList,toggleColumnVisibility:toggleColumnVisibility}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__table_component_Table__["a" /* default */],Object.assign({},tableData,{filterSetting:{language:languageSimplifierFilterSetting,countryCode:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_8__internationalization_const__["e" /* COUNTRY_CODE_LIST */]}},changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,gotoPage:gotoPage,idProperty:'id',columnList:columnList,onRowClick:function onRowClick(partner){navigateToPartner(partner.id);}})));};PartnerSearch.propTypes={tableData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,navigateToPartner:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,changeFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,toggleSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,gotoPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func/*
 * Filtering happens on the server, so we need to feed in server-stored values
 * To achieve filtering by locale string snippets, we need a `select` type table filter,
 *  where we display language families (English) and do filtering by the corresponding locale snippet
 */};var languageSimplifierFilterSetting={type:'select',valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_languageConstants__["b" /* SUPPORTED_LANGUAGES */].map(function(lang){return{id:__WEBPACK_IMPORTED_MODULE_7__internationalization_languageConstants__["a" /* LANGUAGE_FAMILY_PREFIXES */][lang],value:lang};})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableSettings();this.props.initialTableQuery();}})(PartnerSearch)));

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_names__ = __webpack_require__(1688);
/* harmony default export */ __webpack_exports__["a"] = (function(){return[{property:'firstName',header:'Firstname',columnName:'partner_partner.firstName'},{property:'lastName',header:'Lastname',columnName:'partner_partner.lastName'},{property:'active',header:'Active',columnName:'partner_partner.active'},{property:'store',header:'Associated Clinic',columnName:'partner_partner.store'},{property:'countryCode',header:'Country',renderer:function renderer(customer){return Object(__WEBPACK_IMPORTED_MODULE_0__util_names__["a" /* renderCountryName */])(customer.countryCode);},columnName:'partner_partner.countryCode'},{property:'isTreatingPhysician',header:'Is TreatingPhysician',columnName:'partner_partner.isTreatingPhysician'}];});

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderCountryName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internationalization_const__ = __webpack_require__(31);
var renderCountryName=function renderCountryName(countryCode){var country=__WEBPACK_IMPORTED_MODULE_0__internationalization_const__["e" /* COUNTRY_CODE_LIST */].find(function(item){return item.id===countryCode;});return country?country.value:'';};

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_search_action__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_selector__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VoucherSearch__ = __webpack_require__(1691);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_2__state_search_selector__["c" /* tableSelectorVoucher */](state),voucherCode:__WEBPACK_IMPORTED_MODULE_2__state_search_selector__["b" /* selectVoucherCode */](state)};};var mapDispatchToProps={onChangeVoucherCode:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["a" /* onVoucherCodeChange */],onEnterVoucherCode:__WEBPACK_IMPORTED_MODULE_1__state_search_action__["b" /* onVoucherCodeEnter */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__VoucherSearch__["a" /* default */]));

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onVoucherCodeChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onVoucherCodeEnter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_api__ = __webpack_require__(12);
var onVoucherCodeChange=function onVoucherCodeChange(name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__type__["a" /* CHANGE_VOUCHER_CODE */],payload:{name:name,value:value}};};var onVoucherCodeEnter=function onVoucherCodeEnter(){return function(dispatch,getState){var state=getState();var voucherCode=__WEBPACK_IMPORTED_MODULE_1__selector__["b" /* selectVoucherCode */](state);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__type__["d" /* REQUEST_VOUCHER_TABLE_DATA */]});Object(__WEBPACK_IMPORTED_MODULE_2__util_api__["c" /* post */])('/api/voucher/find-voucher-by-code',{'voucherCode':voucherCode.value}).then(function(objectList){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__type__["b" /* CHANGE_VOUCHER_TABLE_DATA */],payload:{objectList:objectList}});}).catch(function(error){alert('an error occured, please try later');dispatch({type:__WEBPACK_IMPORTED_MODULE_0__type__["c" /* ERROR_VOUCHER_TABLE_DATA */],payload:{error:error}});});};};

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__voucher_column_list__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Input__ = __webpack_require__(36);
var TABLE_STYLE={tableLayout:'auto'};var VoucherSearch=function VoucherSearch(_ref){var tableData=_ref.tableData,onChangeVoucherCode=_ref.onChangeVoucherCode,onEnterVoucherCode=_ref.onEnterVoucherCode,voucherCode=_ref.voucherCode;var columnList=Object(__WEBPACK_IMPORTED_MODULE_4__voucher_column_list__["a" /* default */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Search voucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],{bottom:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Input__["a" /* default */],{type:'text',name:'value',object:voucherCode,onChange:onChangeVoucherCode,onEnter:onEnterVoucherCode,placeholder:'voucher code'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Vouchers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'default-table',style:TABLE_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,columnList.map(function(_ref2){var property=_ref2.property,header=_ref2.header;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:property},header);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tableData.objectList.map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:row['id'],className:'table-row'},columnList.map(function(_ref3){var property=_ref3.property,renderer=_ref3.renderer;var value=renderer?renderer(row,property):row[property];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:property},value);}));}),tableData.objectList.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-center',colSpan:columnList.length},'No vouchers found'))))));};VoucherSearch.propTypes={tableData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,onChangeVoucherCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onEnterVoucherCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,voucherCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(VoucherSearch));

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){return[{property:'code',header:'Code',columnName:'voucher_voucher.code'},{property:'bookingValidUntil',header:'Booking Valid Until',columnName:'voucher_voucher.bookingValidUntil'},{property:'validUntil',header:'Checkout Valid Until',columnName:'voucher_voucher.validUntil'},{property:'value',header:'Value',columnName:'voucher_voucher.value'},{property:'category',header:'Category',columnName:'voucher_voucher.category'},{property:'description',header:'Description',columnName:'voucher_voucher.description'},{property:'maximumUsage',header:'Max Usage',columnName:'voucher_voucher.maximumUsage'},{property:'usageCount',header:'Usage Count',columnName:'voucher_voucher.usageCount'},{property:'mode',header:'Mode',columnName:'voucher_voucher.mode'},{property:'productLogicalId',header:'Type',columnName:'voucher_voucher.productLogicalId'},{property:'countryCode',header:'Country Validity',columnName:'voucher_voucher.country'}];});

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__ = __webpack_require__(56);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["b" /* selectEndOfTreatmentTable */](state),type:'end-of-treatment'};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["H" /* initialTableQueryEndOfTreatment */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["b" /* changeFilterEndOfTreatment */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_43" /* toggleSortEndOfTreatment */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_27" /* toggleMultiSortEndOfTreatment */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["r" /* gotoPageEndOfTreatment */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["X" /* initialTableSettingsEndOfTreatment */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["_12" /* toggleColumnVisibilityEndOfTreatment */],navigateToSalesOrder:function navigateToSalesOrder(salesOrderId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/sales-order/edit/'+salesOrderId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesOrderSearch__["a" /* default */]));

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_search_action__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_search_selector__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreSearch__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_state_selector__ = __webpack_require__(88);
var mapStateToProps=function mapStateToProps(state){return{tableData:__WEBPACK_IMPORTED_MODULE_3__state_search_selector__["b" /* tableSelectorStore */](state),isTablet:Object(__WEBPACK_IMPORTED_MODULE_5__layout_state_selector__["c" /* selectIsTablet */])(state)};};var mapDispatchToProps={initialTableQuery:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["c" /* initialTableQueryStore */],initialTableSettings:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["d" /* initialTableSettings */],toggleColumnVisibility:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["e" /* toggleColumnVisibility */],changeFilter:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["a" /* changeFilterStore */],toggleSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["g" /* toggleSortStore */],toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["f" /* toggleMultiSortStore */],gotoPage:__WEBPACK_IMPORTED_MODULE_2__state_search_action__["b" /* gotoPageStore */],navigateToStore:function navigateToStore(storeId){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["d" /* push */])('/store/edit/'+storeId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__StoreSearch__["a" /* default */]));

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialTableQueryStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFilterStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleSortStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleMultiSortStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gotoPageStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialTableSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleColumnVisibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selector__ = __webpack_require__(589);
var initialTableQueryStore=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);var changeFilterStore=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);var toggleSortStore=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);var toggleMultiSortStore=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_2__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);var gotoPageStore=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);var initialTableSettings=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);var toggleColumnVisibility=__WEBPACK_IMPORTED_MODULE_1__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__selector__["b" /* tableSelectorStore */],__WEBPACK_IMPORTED_MODULE_0__type__["a" /* STORE_TABLE */]);

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_component_Table__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_column_list__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internationalization_languageConstants__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internationalization_const__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__table_component_TableColumnSelector__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bootstrap_component_Row__ = __webpack_require__(5);
var StoreSearch=function StoreSearch(_ref){var tableData=_ref.tableData,changeFilter=_ref.changeFilter,toggleSort=_ref.toggleSort,toggleMultiSort=_ref.toggleMultiSort,gotoPage=_ref.gotoPage,navigateToStore=_ref.navigateToStore,isTablet=_ref.isTablet,toggleColumnVisibility=_ref.toggleColumnVisibility;var columnList=Object(__WEBPACK_IMPORTED_MODULE_6__store_column_list__["a" /* default */])(isTablet);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout_component_ContentBox__["a" /* default */],{title:'Clinics / Stores'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__bootstrap_component_Row__["a" /* default */],{bottom:'S'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__bootstrap_component_Column__["a" /* default */],{size:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Link */],{to:'/store/add/','class':'btn btn-primary'},'Add Clinic'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_component_TableColumnSelector__["a" /* default */],{resultsNumber:tableData.objectList.length,hiddenColumns:tableData.hiddenColumns,columnList:columnList,toggleColumnVisibility:toggleColumnVisibility}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__table_component_Table__["a" /* default */],Object.assign({},tableData,{filterSetting:{language:languageSimplifierFilterSetting,countryCode:{type:'select',valueList:__WEBPACK_IMPORTED_MODULE_8__internationalization_const__["e" /* COUNTRY_CODE_LIST */]}},changeFilter:changeFilter,toggleSort:toggleSort,toggleMultiSort:toggleMultiSort,gotoPage:gotoPage,idProperty:'id',columnList:columnList,onRowClick:function onRowClick(store){navigateToStore(store.id);}})));};StoreSearch.propTypes={tableData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,navigateToStore:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,changeFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,toggleSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,toggleMultiSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,gotoPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func/*
 * Filtering happens on the server, so we need to feed in server-stored values
 * To achieve filtering by locale string snippets, we need a `select` type table filter,
 *  where we display language families (English) and do filtering by the corresponding locale snippet
 */};var languageSimplifierFilterSetting={type:'select',valueList:__WEBPACK_IMPORTED_MODULE_7__internationalization_languageConstants__["b" /* SUPPORTED_LANGUAGES */].map(function(lang){return{id:__WEBPACK_IMPORTED_MODULE_7__internationalization_languageConstants__["a" /* LANGUAGE_FAMILY_PREFIXES */][lang],value:lang};})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialTableSettings();this.props.initialTableQuery();}})(StoreSearch)));

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_names__ = __webpack_require__(1698);
/* harmony default export */ __webpack_exports__["a"] = (function(isTablet){return isTablet?columnListTablet:columnListDesktop;});var columnListDesktop=[{property:'clinicName',header:'Clinic Name',columnName:'store_store.clinicName'},{property:'technicalName',header:'Technical Name',columnName:'store_store.technicalName'},{property:'email',header:'Email',columnName:'store_store.email'},{property:'isActive',header:'Active',width:'80',columnName:'store_store.isActive'},{property:'city',header:'City',columnName:'store_store.city'},{property:'countryCode',header:'Country',renderer:function renderer(store){return Object(__WEBPACK_IMPORTED_MODULE_0__util_names__["a" /* renderCountryName */])(store.countryCode);},columnName:'store_store.countryCode'},{property:'isPartner',header:'Partner',width:'100',columnName:'store_store.isPartner'},{property:'iprProvider',header:'IPR',width:'50',columnName:'store_store.iprProvider'},{property:'scanFileUploadMechanism',header:'Upload Mechanism',width:'120',columnName:'store_store.scanFileUploadMechanism'},{property:'partnerMgmtCategory',header:'Partner Mgmt Cat',width:'120',columnName:'store_store.partnerMgmtCategory'},{property:'treatingPhysicians',header:'TreatingPhysicianList',renderer:function renderer(store){return Object(__WEBPACK_IMPORTED_MODULE_0__util_names__["b" /* renderTreatingPhysicianList */])(store.treatingPhysicians);},columnName:'treatingPhysicians'}];var columnListTablet=[{property:'clinicName',header:'Clinic Name',columnName:'store_store.clinicName'},{property:'technicalName',header:'Technical Name',columnName:'store_store.technicalName'},{property:'email',header:'Email',columnName:'store_store.email'},{property:'active',header:'Active',width:'80',columnName:'store_store.isActive'},{property:'streetAddress',header:'Address',columnName:'store_store.streetAddress'},{property:'city',header:'City',columnName:'store_store.city'},{property:'zip',header:'ZIP',width:'80',columnName:'store_store.zip'},{property:'countryCode',header:'Country',renderer:function renderer(store){return Object(__WEBPACK_IMPORTED_MODULE_0__util_names__["a" /* renderCountryName */])(store.countryCode);},columnName:'store_store.countryCode'},{property:'isPartner',header:'Partner',width:'100',columnName:'store_store.isPartner'},{property:'iprProvider',header:'IPR',width:'50',columnName:'store_store.iprProvider'},{property:'scanFileUploadMechanism',header:'Upload Type',width:'120',columnName:'store_store.scanFileUploadMechanism'},{property:'partnerMgmtCategory',header:'Partner Mgmt',width:'120',columnName:'store_store.partnerMgmtCategory'}];

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderCountryName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderTreatingPhysicianList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internationalization_const__ = __webpack_require__(31);
var renderCountryName=function renderCountryName(countryCode){var country=__WEBPACK_IMPORTED_MODULE_1__internationalization_const__["e" /* COUNTRY_CODE_LIST */].find(function(item){return item.id===countryCode;});return country?country.value:'';};var renderTreatingPhysicianList=function renderTreatingPhysicianList(treatingPhysicianList){var treatingPhysicianArray=treatingPhysicianList.split(",");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,treatingPhysicianArray.map(function(treatingPhysician){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:treatingPhysician},treatingPhysician);}));};

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddStore__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(322);
var mapStateToProps=function mapStateToProps(state){return{title:'Add Clinic',store:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["d" /* selectStore */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["e" /* selectValidationMessageList */](state),redirect:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["c" /* selectRedirect */](state),isFetching:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["b" /* selectIsFetching */](state)};};var mapDispatchToProps={editStore:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["c" /* editFormValue */],saveStore:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["b" /* createOrUpdateStore */],pushValidationList:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["e" /* pushValidationList */],clearState:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* clearState */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__AddStore__["a" /* default */]));

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_StoreForm__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
var AddStore=function AddStore(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__form_StoreForm__["a" /* default */],props);};AddStore.propTypes={clearState:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.clearState();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(AddStore)));

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRegionList;
function getRegionList(country){return REGION_LIST_PER_COUNTRY.hasOwnProperty(country)?REGION_LIST_PER_COUNTRY[country]:[];}var REGION_LIST_PER_COUNTRY={"AT":[{"id":"Burgenland","value":"Burgenland"},{"id":"Kärnten","value":"Kärnten"},{"id":"Niederösterreich","value":"Niederösterreich"},{"id":"Oberösterreich","value":"Oberösterreich"},{"id":"Salzburg","value":"Salzburg"},{"id":"Steiermark","value":"Steiermark"},{"id":"Tirol","value":"Tirol"},{"id":"Vorarlberg","value":"Vorarlberg"},{"id":"Wien","value":"Wien"}],"FR":[{"id":"Auvergne-Rhône-Alpes","value":"Auvergne-Rhône-Alpes"},{"id":"Bourgogne-Franche-Comté","value":"Bourgogne-Franche-Comté"},{"id":"Bretagne","value":"Bretagne"},{"id":"Centre-Val de Loire","value":"Centre-Val de Loire"},{"id":"Corse","value":"Corse"},{"id":"Grand Est","value":"Grand Est"},{"id":"Hauts-de-France","value":"Hauts-de-France"},{"id":"Île-de-France","value":"Île-de-France"},{"id":"Normandie","value":"Normandie"},{"id":"Nouvelle-Aquitaine","value":"Nouvelle-Aquitaine"},{"id":"Occitanie","value":"Occitanie"},{"id":"Pays de la Loire","value":"Pays de la Loire"},{"id":"Provence-Alpes-Cote d'Azur","value":"Provence-Alpes-Cote d'Azur"},{"id":"Clipperton","value":"Clipperton"},{"id":"Guadeloupe","value":"Guadeloupe"},{"id":"Guyane","value":"Guyane"},{"id":"Martinique","value":"Martinique"},{"id":"Mayotte","value":"Mayotte"},{"id":"Novelle-Calédonie","value":"Novelle-Calédonie"},{"id":"Polynésie","value":"Polynésie"},{"id":"Saint-Pierre-et-Miquelon","value":"Saint-Pierre-et-Miquelon"},{"id":"Saint Barthélemy","value":"Saint Barthélemy"},{"id":"Saint Martin","value":"Saint Martin"},{"id":"Réunion","value":"Réunion"},{"id":"Terres Australes Françaises","value":"Terres Australes Françaises"},{"id":"Wallis-et-Futuna","value":"Wallis-et-Futuna"}],"DE":[{"id":"Baden-Württemberg","value":"Baden-Württemberg"},{"id":"Bayern","value":"Bayern"},{"id":"Berlin","value":"Berlin"},{"id":"Brandenburg","value":"Brandenburg"},{"id":"Bremen","value":"Bremen"},{"id":"Hamburg","value":"Hamburg"},{"id":"Hessen","value":"Hessen"},{"id":"Mecklenburg-Vorpommern","value":"Mecklenburg-Vorpommern"},{"id":"Niedersachsen","value":"Niedersachsen"},{"id":"Nordrhein-Westfalen","value":"Nordrhein-Westfalen"},{"id":"Rheinland-Pfalz","value":"Rheinland-Pfalz"},{"id":"Saarland","value":"Saarland"},{"id":"Sachsen","value":"Sachsen"},{"id":"Sachsen-Anhalt","value":"Sachsen-Anhalt"},{"id":"Schleswig-Holstein","value":"Schleswig-Holstein"},{"id":"Thüringen","value":"Thüringen"}],"NL":[{"id":"Drenthe","value":"Drenthe"},{"id":"Flevoland","value":"Flevoland"},{"id":"Friesland","value":"Friesland"},{"id":"Gelderland","value":"Gelderland"},{"id":"Groningen","value":"Groningen"},{"id":"Limburg","value":"Limburg"},{"id":"Noord-Brabant","value":"Noord-Brabant"},{"id":"Noord-Holland","value":"Noord-Holland"},{"id":"Overijssel","value":"Overijssel"},{"id":"Utrecht","value":"Utrecht"},{"id":"Zeeland","value":"Zeeland"},{"id":"Zuid-Holland","value":"Zuid-Holland"}],"ES":[{"id":"Albacete","value":"Albacete"},{"id":"Alicante","value":"Alicante"},{"id":"Almería","value":"Almería"},{"id":"Araba/Álava","value":"Araba/Álava"},{"id":"Asturias","value":"Asturias"},{"id":"Ávila","value":"Ávila"},{"id":"Badajoz","value":"Badajoz"},{"id":"Barcelona","value":"Barcelona"},{"id":"Bizkaia","value":"Bizkaia"},{"id":"Burgos","value":"Burgos"},{"id":"Cáceres","value":"Cáceres"},{"id":"Cádiz","value":"Cádiz"},{"id":"Cantabria","value":"Cantabria"},{"id":"Castellón/Castelló","value":"Castellón/Castelló"},{"id":"Ceuta","value":"Ceuta"},{"id":"Ciudad Real","value":"Ciudad Real"},{"id":"Córdoba","value":"Córdoba"},{"id":"A Coruña","value":"A Coruña"},{"id":"Cuenca","value":"Cuenca"},{"id":"Gipuzkoa","value":"Gipuzkoa"},{"id":"Girona","value":"Girona"},{"id":"Granada","value":"Granada"},{"id":"Guadalajara","value":"Guadalajara"},{"id":"Huelva","value":"Huelva"},{"id":"Huesca","value":"Huesca"},{"id":"Illes Balears","value":"Illes Balears"},{"id":"Jaén","value":"Jaén"},{"id":"León","value":"León"},{"id":"Lleida","value":"Lleida"},{"id":"Lugo","value":"Lugo"},{"id":"Madrid","value":"Madrid"},{"id":"Málaga","value":"Málaga"},{"id":"Melilla","value":"Melilla"},{"id":"Murcia","value":"Murcia"},{"id":"Navarra/Nafarroa","value":"Navarra/Nafarroa"},{"id":"Ourense","value":"Ourense"},{"id":"Palencia","value":"Palencia"},{"id":"Las Palmas","value":"Las Palmas"},{"id":"Pontevedra","value":"Pontevedra"},{"id":"La Rioja","value":"La Rioja"},{"id":"Salamanca","value":"Salamanca"},{"id":"Santa Cruz de Tenerife","value":"Santa Cruz de Tenerife"},{"id":"Segovia","value":"Segovia"},{"id":"Sevilla","value":"Sevilla"},{"id":"Soria","value":"Soria"},{"id":"Tarragona","value":"Tarragona"},{"id":"Teruel","value":"Teruel"},{"id":"Toledo","value":"Toledo"},{"id":"Valencia/València","value":"Valencia/València"},{"id":"Valladolid","value":"Valladolid"},{"id":"Zamora","value":"Zamora"},{"id":"Zaragoza","value":"Zaragoza"}],"SE":[{"id":"Blekinge","value":"Blekinge"},{"id":"Dalarna","value":"Dalarna"},{"id":"Gävleborg","value":"Gävleborg"},{"id":"Gotland","value":"Gotland"},{"id":"Halland","value":"Halland"},{"id":"Jämtland","value":"Jämtland"},{"id":"Jönköping","value":"Jönköping"},{"id":"Kalmar","value":"Kalmar"},{"id":"Kronoberg","value":"Kronoberg"},{"id":"Norrbotten","value":"Norrbotten"},{"id":"Örebro","value":"Örebro"},{"id":"Östergötland","value":"Östergötland"},{"id":"Skåne","value":"Skåne"},{"id":"Södermanland","value":"Södermanland"},{"id":"Stockholm","value":"Stockholm"},{"id":"Uppsala","value":"Uppsala"},{"id":"Värmland","value":"Värmland"},{"id":"Västerbotten","value":"Västerbotten"},{"id":"Västernorrland","value":"Västernorrland"},{"id":"Västmanland","value":"Västmanland"},{"id":"Västra Götaland","value":"Västra Götaland"}],"CH":[{"id":"Aargau","value":"Aargau"},{"id":"Appenzell Ausserrhoden","value":"Appenzell Ausserrhoden"},{"id":"Appenzell Innerhoden","value":"Appenzell Innerhoden"},{"id":"Basel-Landschaft","value":"Basel-Landschaft"},{"id":"Basel-Stadt","value":"Basel-Stadt"},{"id":"Bern","value":"Bern"},{"id":"Fribourg","value":"Fribourg"},{"id":"Genève","value":"Genève"},{"id":"Glarus","value":"Glarus"},{"id":"Graubünden","value":"Graubünden"},{"id":"Jura","value":"Jura"},{"id":"Luzern","value":"Luzern"},{"id":"Neuchâtel","value":"Neuchâtel"},{"id":"Nidwalden","value":"Nidwalden"},{"id":"Obwalden","value":"Obwalden"},{"id":"Sankt Gallen","value":"Sankt Gallen"},{"id":"Schaffhausen","value":"Schaffhausen"},{"id":"Schwyz","value":"Schwyz"},{"id":"Solothurn","value":"Solothurn"},{"id":"Thurgau","value":"Thurgau"},{"id":"Ticino","value":"Ticino"},{"id":"Uri","value":"Uri"},{"id":"Valais","value":"Valais"},{"id":"Vaud","value":"Vaud"},{"id":"Zug","value":"Zug"},{"id":"Zürich","value":"Zürich"}],"GB":[{"id":"Aberdeen City","value":"Aberdeen City"},{"id":"Aberdeenshire","value":"Aberdeenshire"},{"id":"Angus","value":"Angus"},{"id":"Antrim and Newtownabbey","value":"Antrim and Newtownabbey"},{"id":"Ards and North Down","value":"Ards and North Down"},{"id":"Argyll and Bute","value":"Argyll and Bute"},{"id":"Armagh, Banbridge and Craigavon","value":"Armagh, Banbridge and Craigavon"},{"id":"Barking and Dagenham","value":"Barking and Dagenham"},{"id":"Barnet","value":"Barnet"},{"id":"Barnsley","value":"Barnsley"},{"id":"Bath and North East Somerset","value":"Bath and North East Somerset"},{"id":"Bedford","value":"Bedford"},{"id":"Belfast","value":"Belfast"},{"id":"Bexley","value":"Bexley"},{"id":"Birmingham","value":"Birmingham"},{"id":"Blackburn with Darwen","value":"Blackburn with Darwen"},{"id":"Blackpool","value":"Blackpool"},{"id":"Blaenau Gwent","value":"Blaenau Gwent"},{"id":"Bolton","value":"Bolton"},{"id":"Bournemouth","value":"Bournemouth"},{"id":"Bracknell Forest","value":"Bracknell Forest"},{"id":"Bradford","value":"Bradford"},{"id":"Brent","value":"Brent"},{"id":"Bridgend","value":"Bridgend"},{"id":"Brighton and Hove","value":"Brighton and Hove"},{"id":"Bristol, City of","value":"Bristol, City of"},{"id":"Bromley","value":"Bromley"},{"id":"Buckinghamshire","value":"Buckinghamshire"},{"id":"Bury","value":"Bury"},{"id":"Caerphilly","value":"Caerphilly"},{"id":"Calderdale","value":"Calderdale"},{"id":"Cambridgeshire","value":"Cambridgeshire"},{"id":"Camden","value":"Camden"},{"id":"Cardiff","value":"Cardiff"},{"id":"Carmarthenshire","value":"Carmarthenshire"},{"id":"Causeway Coast and Glens","value":"Causeway Coast and Glens"},{"id":"Central Bedfordshire","value":"Central Bedfordshire"},{"id":"Ceredigion","value":"Ceredigion"},{"id":"Cheshire East","value":"Cheshire East"},{"id":"Cheshire West and Chester","value":"Cheshire West and Chester"},{"id":"Clackmannanshire","value":"Clackmannanshire"},{"id":"Conwy","value":"Conwy"},{"id":"Cornwall","value":"Cornwall"},{"id":"Coventry","value":"Coventry"},{"id":"Croydon","value":"Croydon"},{"id":"Cumbria","value":"Cumbria"},{"id":"Darlington","value":"Darlington"},{"id":"Denbighshire","value":"Denbighshire"},{"id":"Derby","value":"Derby"},{"id":"Derbyshire","value":"Derbyshire"},{"id":"Derry and Strabane","value":"Derry and Strabane"},{"id":"Devon","value":"Devon"},{"id":"Doncaster","value":"Doncaster"},{"id":"Dorset","value":"Dorset"},{"id":"Dudley","value":"Dudley"},{"id":"Dumfries and Galloway","value":"Dumfries and Galloway"},{"id":"Dundee City","value":"Dundee City"},{"id":"Durham County","value":"Durham County"},{"id":"Ealing","value":"Ealing"},{"id":"East Ayrshire","value":"East Ayrshire"},{"id":"East Dunbartonshire","value":"East Dunbartonshire"},{"id":"East Lothian","value":"East Lothian"},{"id":"East Renfrewshire","value":"East Renfrewshire"},{"id":"East Riding of Yorkshire","value":"East Riding of Yorkshire"},{"id":"East Sussex","value":"East Sussex"},{"id":"Edinburgh, City of","value":"Edinburgh, City of"},{"id":"Eilean Siar","value":"Eilean Siar"},{"id":"Enfield","value":"Enfield"},{"id":"Essex","value":"Essex"},{"id":"Falkirk","value":"Falkirk"},{"id":"Fermanagh and Omagh","value":"Fermanagh and Omagh"},{"id":"Fife","value":"Fife"},{"id":"Flintshire","value":"Flintshire"},{"id":"Gateshead","value":"Gateshead"},{"id":"Glasgow City","value":"Glasgow City"},{"id":"Gloucestershire","value":"Gloucestershire"},{"id":"Greenwich","value":"Greenwich"},{"id":"Gwynedd","value":"Gwynedd"},{"id":"Hackney","value":"Hackney"},{"id":"Halton","value":"Halton"},{"id":"Hammersmith and Fulham","value":"Hammersmith and Fulham"},{"id":"Hampshire","value":"Hampshire"},{"id":"Haringey","value":"Haringey"},{"id":"Harrow","value":"Harrow"},{"id":"Hartlepool","value":"Hartlepool"},{"id":"Havering","value":"Havering"},{"id":"Herefordshire","value":"Herefordshire"},{"id":"Hertfordshire","value":"Hertfordshire"},{"id":"Highland","value":"Highland"},{"id":"Hillingdon","value":"Hillingdon"},{"id":"Hounslow","value":"Hounslow"},{"id":"Inverclyde","value":"Inverclyde"},{"id":"Isle of Anglesey","value":"Isle of Anglesey"},{"id":"Isle of Wight","value":"Isle of Wight"},{"id":"Isles of Scilly","value":"Isles of Scilly"},{"id":"Islington","value":"Islington"},{"id":"Kensington and Chelsea","value":"Kensington and Chelsea"},{"id":"Kent","value":"Kent"},{"id":"Kingston upon Hull","value":"Kingston upon Hull"},{"id":"Kingston upon Thames","value":"Kingston upon Thames"},{"id":"Kirklees","value":"Kirklees"},{"id":"Knowsley","value":"Knowsley"},{"id":"Lambeth","value":"Lambeth"},{"id":"Lancashire","value":"Lancashire"},{"id":"Leeds","value":"Leeds"},{"id":"Leicester","value":"Leicester"},{"id":"Leicestershire","value":"Leicestershire"},{"id":"Lewisham","value":"Lewisham"},{"id":"Lincolnshire","value":"Lincolnshire"},{"id":"Lisburn and Castlereagh","value":"Lisburn and Castlereagh"},{"id":"Liverpool","value":"Liverpool"},{"id":"London, City of","value":"London, City of"},{"id":"Luton","value":"Luton"},{"id":"Manchester","value":"Manchester"},{"id":"Medway","value":"Medway"},{"id":"Merthyr Tydfil","value":"Merthyr Tydfil"},{"id":"Merton","value":"Merton"},{"id":"Mid and East Antrim","value":"Mid and East Antrim"},{"id":"Mid Ulster","value":"Mid Ulster"},{"id":"Middlesbrough","value":"Middlesbrough"},{"id":"Midlothian","value":"Midlothian"},{"id":"Milton Keynes","value":"Milton Keynes"},{"id":"Monmouthshire","value":"Monmouthshire"},{"id":"Moray","value":"Moray"},{"id":"Neath Port Talbot","value":"Neath Port Talbot"},{"id":"Newcastle upon Tyne","value":"Newcastle upon Tyne"},{"id":"Newham","value":"Newham"},{"id":"Newport","value":"Newport"},{"id":"Newry, Mourne and Down","value":"Newry, Mourne and Down"},{"id":"Norfolk","value":"Norfolk"},{"id":"North Ayrshire","value":"North Ayrshire"},{"id":"North East Lincolnshire","value":"North East Lincolnshire"},{"id":"North Lanarkshire","value":"North Lanarkshire"},{"id":"North Lincolnshire","value":"North Lincolnshire"},{"id":"North Somerset","value":"North Somerset"},{"id":"North Tyneside","value":"North Tyneside"},{"id":"North Yorkshire","value":"North Yorkshire"},{"id":"Northamptonshire","value":"Northamptonshire"},{"id":"Northumberland","value":"Northumberland"},{"id":"Nottingham","value":"Nottingham"},{"id":"Nottinghamshire","value":"Nottinghamshire"},{"id":"Oldham","value":"Oldham"},{"id":"Orkney Islands","value":"Orkney Islands"},{"id":"Oxfordshire","value":"Oxfordshire"},{"id":"Pembrokeshire","value":"Pembrokeshire"},{"id":"Perth and Kinross","value":"Perth and Kinross"},{"id":"Peterborough","value":"Peterborough"},{"id":"Plymouth","value":"Plymouth"},{"id":"Poole","value":"Poole"},{"id":"Portsmouth","value":"Portsmouth"},{"id":"Powys","value":"Powys"},{"id":"Reading","value":"Reading"},{"id":"Redbridge","value":"Redbridge"},{"id":"Redcar and Cleveland","value":"Redcar and Cleveland"},{"id":"Renfrewshire","value":"Renfrewshire"},{"id":"Rhondda, Cynon, Taff","value":"Rhondda, Cynon, Taff"},{"id":"Richmond upon Thames","value":"Richmond upon Thames"},{"id":"Rochdale","value":"Rochdale"},{"id":"Rotherham","value":"Rotherham"},{"id":"Rutland","value":"Rutland"},{"id":"St. Helens","value":"St. Helens"},{"id":"Salford","value":"Salford"},{"id":"Sandwell","value":"Sandwell"},{"id":"Scottish Borders, The","value":"Scottish Borders, The"},{"id":"Sefton","value":"Sefton"},{"id":"Sheffield","value":"Sheffield"},{"id":"Shetland Islands","value":"Shetland Islands"},{"id":"Shropshire","value":"Shropshire"},{"id":"Slough","value":"Slough"},{"id":"Solihull","value":"Solihull"},{"id":"Somerset","value":"Somerset"},{"id":"South Ayrshire","value":"South Ayrshire"},{"id":"South Gloucestershire","value":"South Gloucestershire"},{"id":"South Lanarkshire","value":"South Lanarkshire"},{"id":"South Tyneside","value":"South Tyneside"},{"id":"Southampton","value":"Southampton"},{"id":"Southend-on-Sea","value":"Southend-on-Sea"},{"id":"Southwark","value":"Southwark"},{"id":"Staffordshire","value":"Staffordshire"},{"id":"Stirling","value":"Stirling"},{"id":"Stockport","value":"Stockport"},{"id":"Stockton-on-Tees","value":"Stockton-on-Tees"},{"id":"Stoke-on-Trent","value":"Stoke-on-Trent"},{"id":"Suffolk","value":"Suffolk"},{"id":"Sunderland","value":"Sunderland"},{"id":"Surrey","value":"Surrey"},{"id":"Sutton","value":"Sutton"},{"id":"Swansea","value":"Swansea"},{"id":"Swindon","value":"Swindon"},{"id":"Tameside","value":"Tameside"},{"id":"Telford and Wrekin","value":"Telford and Wrekin"},{"id":"Thurrock","value":"Thurrock"},{"id":"Torbay","value":"Torbay"},{"id":"Torfaen","value":"Torfaen"},{"id":"Tower Hamlets","value":"Tower Hamlets"},{"id":"Trafford","value":"Trafford"},{"id":"Vale of Glamorgan, The","value":"Vale of Glamorgan, The"},{"id":"Wakefield","value":"Wakefield"},{"id":"Walsall","value":"Walsall"},{"id":"Waltham Forest","value":"Waltham Forest"},{"id":"Wandsworth","value":"Wandsworth"},{"id":"Warrington","value":"Warrington"},{"id":"Warwickshire","value":"Warwickshire"},{"id":"West Berkshire","value":"West Berkshire"},{"id":"West Dunbartonshire","value":"West Dunbartonshire"},{"id":"West Lothian","value":"West Lothian"},{"id":"West Sussex","value":"West Sussex"},{"id":"Westminster","value":"Westminster"},{"id":"Wigan","value":"Wigan"},{"id":"Wiltshire","value":"Wiltshire"},{"id":"Windsor and Maidenhead","value":"Windsor and Maidenhead"},{"id":"Wirral","value":"Wirral"},{"id":"Wokingham","value":"Wokingham"},{"id":"Wolverhampton","value":"Wolverhampton"},{"id":"Worcestershire","value":"Worcestershire"},{"id":"Wrexham","value":"Wrexham"},{"id":"York","value":"York"}]};

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MessageBox */
/* unused harmony export ContentBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_component_ValidationMessageList__ = __webpack_require__(34);
var MessageBox=function MessageBox(_ref){var messageList=_ref.messageList;if(Array.isArray(messageList)&&messageList.length===0){return null;}var classNameLabel="alert alert-danger";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNameLabel,role:'alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentBox,{validationMessageList:messageList}));};var ContentBox=function ContentBox(_ref2){var validationMessageList=_ref2.validationMessageList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Array.isArray(validationMessageList)&&validationMessageList.map(function(message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Message,{key:message.messageId,message:message});}));};var Message=function Message(_ref3){var message=_ref3.message;var msg=message.message.replace(__WEBPACK_IMPORTED_MODULE_2__const__["d" /* MESSAGE_PLACEHOLDER */],function(){var field=__WEBPACK_IMPORTED_MODULE_2__const__["c" /* MANDATORY_FIELDS */].find(function(el){return el.id===message.messageId;});return field?field.value:message.messageId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,msg);};__WEBPACK_IMPORTED_MODULE_3__validation_component_ValidationMessageList__["a" /* default */].propTypes={validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (MessageBox);

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditStore__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(322);
var mapStateToProps=function mapStateToProps(state,props){return{title:'Edit Clinic',store:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["d" /* selectStore */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["e" /* selectValidationMessageList */](state),storeId:props.computedMatch.params.storeId,redirect:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["c" /* selectRedirect */](state),isFetching:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["b" /* selectIsFetching */](state)};};var mapDispatchToProps={findStore:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["d" /* findStore */],editStore:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["c" /* editFormValue */],saveStore:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["b" /* createOrUpdateStore */],pushValidationList:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["e" /* pushValidationList */],clearState:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* clearState */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__EditStore__["a" /* default */]));

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_StoreForm__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
var EditStore=function EditStore(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_StoreForm__["a" /* default */],props);};EditStore.propTypes={storeId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,findStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,clearState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.clearState();this.props.findStore(this.props.storeId);}})(Object(__WEBPACK_IMPORTED_MODULE_3__layout_withLayout__["a" /* default */])(EditStore)));

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddPartner__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_action__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_detail_selector__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_state_selector__ = __webpack_require__(37);
var mapStateToProps=function mapStateToProps(state){return{title:'Add Partner',partner:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["c" /* selectPartner */](state),storeList:Object(__WEBPACK_IMPORTED_MODULE_4__globals_state_selector__["selectStoreList"])(state),error:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["a" /* selectError */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["e" /* selectValidationMessageList */](state),redirect:__WEBPACK_IMPORTED_MODULE_3__state_detail_selector__["d" /* selectRedirect */](state)};};var mapDispatchToProps={editPartner:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["b" /* editPartnerFormValue */],savePartner:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["e" /* savePartner */],pushValidationList:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["d" /* pushValidationList */],clearState:__WEBPACK_IMPORTED_MODULE_2__state_detail_action__["a" /* clearState */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__AddPartner__["a" /* default */]));

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_PartnerForm__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
var AddPartner=function AddPartner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__form_PartnerForm__["a" /* default */],props);};AddPartner.propTypes={clearState:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.clearState();}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(AddPartner)));

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MessageBox */
/* unused harmony export ContentBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_component_ValidationMessageList__ = __webpack_require__(34);
var MessageBox=function MessageBox(_ref){var messageList=_ref.messageList;if(Array.isArray(messageList)&&messageList.length===0){return null;}var classNameLabel="alert alert-danger";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNameLabel,role:'alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentBox,{validationMessageList:messageList}));};var ContentBox=function ContentBox(_ref2){var validationMessageList=_ref2.validationMessageList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,validationMessageList.map(function(message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Message,{message:message});}));};var Message=function Message(_ref3){var message=_ref3.message;var msg=message.message.replace(__WEBPACK_IMPORTED_MODULE_2__const__["b" /* MESSAGE_PLACEHOLDER */],function(){var field=__WEBPACK_IMPORTED_MODULE_2__const__["a" /* MANDATORY_FIELDS */].find(function(el){return el.id===message.messageId;});return field?field.value:message.messageId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,msg);};__WEBPACK_IMPORTED_MODULE_3__validation_component_ValidationMessageList__["a" /* default */].propTypes={validationMessageList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (MessageBox);

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_detail_action__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_detail_selector__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_state_selector__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditPartner__ = __webpack_require__(1709);
var mapStateToProps=function mapStateToProps(state,props){return{title:'Edit Partner',partner:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["c" /* selectPartner */](state),storeList:Object(__WEBPACK_IMPORTED_MODULE_3__globals_state_selector__["selectStoreList"])(state),error:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["a" /* selectError */](state),validationMessageList:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["e" /* selectValidationMessageList */](state),partnerId:props.computedMatch.params.partnerId,redirect:__WEBPACK_IMPORTED_MODULE_2__state_detail_selector__["d" /* selectRedirect */](state)};};var mapDispatchToProps={findPartner:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["c" /* findPartner */],editPartner:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["b" /* editPartnerFormValue */],savePartner:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["e" /* savePartner */],pushValidationList:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["d" /* pushValidationList */],clearState:__WEBPACK_IMPORTED_MODULE_1__state_detail_action__["a" /* clearState */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__EditPartner__["a" /* default */]));

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_PartnerForm__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var EditPartner=function EditPartner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__form_PartnerForm__["a" /* default */],props);};EditPartner.propTypes={partnerId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,findPartner:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,clearState:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.clearState();this.props.findPartner(this.props.partnerId);}})(Object(__WEBPACK_IMPORTED_MODULE_1__layout_withLayout__["a" /* default */])(EditPartner)));

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorklistAttachment__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_selector__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_action__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__ = __webpack_require__(23);
var mapStateToProps=function mapStateToProps(state,props){return{taskListWithAttachment:__WEBPACK_IMPORTED_MODULE_2__state_selector__["d" /* selectTaskListWithAttachment */](state),tableSetting:__WEBPACK_IMPORTED_MODULE_2__state_selector__["c" /* selectTableSetting */](state),currentUserId:Object(__WEBPACK_IMPORTED_MODULE_5__security_state_auth_selector__["q" /* selectUserId */])(state)};};var mapDispatchToProps={findTaskListWithAttachment:__WEBPACK_IMPORTED_MODULE_3__state_action__["b" /* findTaskWithAttachmentList */],changeTableSetting:__WEBPACK_IMPORTED_MODULE_3__state_action__["a" /* changeTableSetting */],initialColumnsVisibility:__WEBPACK_IMPORTED_MODULE_3__state_action__["c" /* initialColumnsVisibility */],navigateToTaskDetail:function navigateToTaskDetail(taskId){return Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["d" /* push */])('/task/detail/'+taskId);}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__WorklistAttachment__["a" /* default */]));

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_withLayout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__worklist_attachment_column_list__ = __webpack_require__(1712);
var WorklistAttachment=function WorklistAttachment(_ref){var taskListWithAttachment=_ref.taskListWithAttachment,tableSetting=_ref.tableSetting,changeTableSetting=_ref.changeTableSetting,navigateToTaskDetail=_ref.navigateToTaskDetail,currentUserId=_ref.currentUserId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layout_component_ContentBox__["a" /* default */],{title:'Worklist Attachment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bootstrap_component_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__bootstrap_component_Column__["a" /* default */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__form_component_Table__["a" /* default */],{columnList:Object(__WEBPACK_IMPORTED_MODULE_8__worklist_attachment_column_list__["a" /* default */])(currentUserId),rowList:taskListWithAttachment,changeTableSetting:changeTableSetting,tableSetting:tableSetting,idProperty:'id',onRowClick:function onRowClick(task){navigateToTaskDetail(task.id);}}))));};WorklistAttachment.propTypes={taskListWithAttachment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,tableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,changeTableSetting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,navigateToTaskDetail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentUserId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* lifecycle */])({componentDidMount:function componentDidMount(){this.props.initialColumnsVisibility();this.props.findTaskListWithAttachment();}})(Object(__WEBPACK_IMPORTED_MODULE_2__layout_withLayout__["a" /* default */])(WorklistAttachment)));

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_component_Table__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process_util_names__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_util_renderStoreName__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customer_util_names__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internationalization_const__ = __webpack_require__(31);
/* harmony default export */ __webpack_exports__["a"] = (function(currentUserId){var columnList=[];columnList.push({property:'created',header:'Created',comparator:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateComparator('created'),renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('created')});columnList.push({property:'due',header:'Due',comparator:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateComparator('due'),renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('due')});columnList.push({property:'processName',header:'process Name',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_1__process_util_names__["d" /* renderProcessName */])(processInstance.processName);},sortValue:function sortValue(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_1__process_util_names__["d" /* renderProcessName */])(processInstance.processName);}});columnList.push({property:'name',header:'taskname',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_1__process_util_names__["g" /* renderTaskName */])(processInstance.name);},sortValue:function sortValue(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_1__process_util_names__["g" /* renderTaskName */])(processInstance.name);}});columnList.push({property:'processDisplayName',header:'Name'});columnList.push({property:'complexity',header:'Complexity'});columnList.push({property:'priority',header:'Priority'});columnList.push({property:'reference',header:'Reference'});columnList.push({property:'status',header:'Status',renderer:function renderer(task){if(task.assignedToUserId===currentUserId){return'my task '+task.status;}if(task.assignedToUserId!==null){return'assigned '+task.status;}return task.status;}});columnList.push({property:'store',header:'Store',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_2__store_util_renderStoreName__["b" /* renderStoreName */])(processInstance.store);}});columnList.push({property:'countryCode',header:'Country',renderer:function renderer(processInstance){return Object(__WEBPACK_IMPORTED_MODULE_3__customer_util_names__["a" /* renderCountryName */])(processInstance.countryCode);},filterType:'select',filterOptions:__WEBPACK_IMPORTED_MODULE_4__internationalization_const__["e" /* COUNTRY_CODE_LIST */].map(function(country){return{id:country.value,value:country.value};})});columnList.push({property:'attachmentAgreed',header:'ATT AGREE'});columnList.push({property:'attachmentNeeded',header:'ATT NEED'});columnList.push({property:'treatmentPlanDeadline',header:'TP Deadline',comparator:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateComparator('treatmentPlanDeadline'),renderer:__WEBPACK_IMPORTED_MODULE_0__form_component_Table__["a" /* default */].dateTimeRenderer('treatmentPlanDeadline')});return columnList;});

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialTableQuery */
/* unused harmony export changeFilter */
/* unused harmony export toggleSort */
/* unused harmony export toggleMultiSort */
/* unused harmony export gotoPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialColumnsVisibility; });
/* unused harmony export initialTableSettingsAllOpenTask */
/* unused harmony export toggleColumnVisibilityAllOpenTask */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTableSetting; });
/* unused harmony export findTaskListWithAttachmentRequest */
/* unused harmony export findTaskListWithAttachmentSuccess */
/* unused harmony export findTaskListWithAttachmentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findTaskWithAttachmentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_state_action__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selector__ = __webpack_require__(597);
var initialTableQuery=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["e" /* createInitialTableQueryAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var changeFilter=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["a" /* createChangeFilterAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var toggleSort=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["i" /* createToggleSortAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var toggleMultiSort=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["h" /* createToggleMultiSortAction */](__WEBPACK_IMPORTED_MODULE_4__selector__["a" /* selectOwnState */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var gotoPage=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["b" /* createGotoPageAction */](__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var initialColumnsVisibility=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["c" /* createInitialColumnsVisibilityFormHandler */](__WEBPACK_IMPORTED_MODULE_2__type__["f" /* TABLE_PROCESS_WORKLIST */],__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_TABLE_SETTING */]);var initialTableSettingsAllOpenTask=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["d" /* createInitialColumnsVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var toggleColumnVisibilityAllOpenTask=__WEBPACK_IMPORTED_MODULE_3__table_state_action__["g" /* createToggleColumnVisibilityTableHandler */](__WEBPACK_IMPORTED_MODULE_4__selector__["b" /* selectTable */],__WEBPACK_IMPORTED_MODULE_2__type__["e" /* TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT */]);var changeTableSetting=Object(__WEBPACK_IMPORTED_MODULE_1__form_state_table_state_helper__["b" /* createChangeTableSettingAction */])(__WEBPACK_IMPORTED_MODULE_2__type__["a" /* CHANGE_TABLE_SETTING */]);var findTaskListWithAttachmentRequest=function findTaskListWithAttachmentRequest(){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["c" /* FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST */],payload:{}};};var findTaskListWithAttachmentSuccess=function findTaskListWithAttachmentSuccess(taskListWithAttachment){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["d" /* FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS */],payload:{taskListWithAttachment:taskListWithAttachment}};};var findTaskListWithAttachmentError=function findTaskListWithAttachmentError(error){return{type:__WEBPACK_IMPORTED_MODULE_2__type__["b" /* FIND_TASK_LIST_WITH_ATTACHMENT_ERROR */],payload:{error:error}};};var findTaskWithAttachmentList=function findTaskWithAttachmentList(){return function(dispatch,getState){dispatch(findTaskListWithAttachmentRequest());Object(__WEBPACK_IMPORTED_MODULE_0__util_api__["b" /* get */])('/api/process/task/find-open-with-attachment').then(function(taskList){dispatch(findTaskListWithAttachmentSuccess(taskList));}).catch(function(error){dispatch(findTaskListWithAttachmentError(error));});};};

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(38)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.39081a67.js